import { typographyClasses as lS, colors as bj, Button as Dr, Badge as wj, useTheme as Da, useMediaQuery as hc, SvgIcon as FA, Breadcrumbs as xj, Chip as fl, Dialog as hl, paperClasses as Sj, DialogTitle as BA, dialogTitleClasses as Ej, Stack as Ke, Typography as ne, IconButton as xc, DialogContent as Ei, dialogContentClasses as Mj, DialogActions as Nc, Box as F1, LinearProgress as uS, styled as H1, Link as Tj, Backdrop as Lj, CircularProgress as ji, useForkRef as Rj, Popper as cS, Skeleton as Fh, PaginationItem as Oj, Pagination as mb, TextField as Ef, Popover as HA, debounce as Dj, InputAdornment as Bh, ButtonBase as Hh, Checkbox as AA, Stepper as kj, stepIconClasses as Kg, stepClasses as jj, stepConnectorClasses as Up, stepLabelClasses as Wp, stepButtonClasses as zj, Step as Nj, StepButton as Pj, StepLabel as Fj, FormHelperText as Bj, FormLabel as Hj, FormControl as Uj, FormControlLabel as Uh, Autocomplete as Wj, Accordion as Vj, AccordionSummary as _j, AccordionDetails as Jj, ListItemButton as Kj, ListItem as gS, ListItemIcon as Yj, MenuItem as Ma, ListItemText as fS, Menu as P7, Avatar as dS, Tab as CS, Tabs as AS, alpha as Mf, Radio as Qj, List as Xj, Tooltip as Gj, TableCell as qj, TableContainer as Zj, TableRow as $j, Drawer as ez, SwipeableDrawer as tz, Alert as dl, DialogContentText as IS, Divider as IA, MenuList as pS, ListSubheader as nz, Paper as hS, Switch as rz, Container as iz } from "@mui/material";
import { Alert as jt1, AlertTitle as zt1, Select as Nt1, Box as Pt1, Card as Ft1, CardActionArea as Bt1, CardActions as Ht1, CardContent as Ut1, CardHeader as Wt1, CardMedia as Vt1, Checkbox as _t1, CircularProgress as Jt1, Container as Kt1, Divider as Yt1, Drawer as Qt1, Grid as Xt1, InputAdornment as Gt1, InputLabel as qt1, List as Zt1, ListItem as $t1, ListItemAvatar as en1, ListItemIcon as tn1, ListItemSecondaryAction as nn1, ListItemText as rn1, Stepper as in1, Menu as an1, MenuList as on1, Paper as sn1, Skeleton as ln1, Slider as un1, Stack as cn1, Step as gn1, StepConnector as fn1, StepLabel as dn1, SwipeableDrawer as Cn1, Table as An1, TableBody as In1, TableContainer as pn1, TableHead as hn1, TableRow as mn1, ThemeProvider as vn1, Typography as yn1, stepButtonClasses as bn1, stepClasses as wn1, stepConnectorClasses as xn1, stepIconClasses as Sn1, stepLabelClasses as En1, stepperClasses as Mn1, styled as Tn1, useTheme as Ln1 } from "@mui/material";
import * as n1 from "react";
import Gt, { useMemo as V2, Children as az, isValidElement as tA, cloneElement as nA, useCallback as h2, useLayoutEffect as If, useState as qt, useEffect as vn, forwardRef as ka, createElement as mS, useRef as yn, useImperativeHandle as vb, Fragment as oz, useId as vS } from "react";
import { useMatch as sz, Link as Wh, useLocation as yS, useSearchParams as lz } from "react-router-dom";
import uz from "@emotion/styled";
import { CacheProvider as cz, Global as gz, ThemeContext as bS, css as fz, keyframes as UA } from "@emotion/react";
import { DataGrid as On1, gridClasses as Dn1, useGridApiContext as kn1, useGridApiEventHandler as jn1, useGridApiRef as zn1 } from "@mui/x-data-grid";
import { DatePicker as yb } from "@mui/x-date-pickers";
import { DatePicker as Pn1, LocalizationProvider as Fn1 } from "@mui/x-date-pickers";
import { preventBubbling as rA, readableBytes as dz, defaultErrorParser as wS, DEFAULT_ERROR_MESSAGE as F7 } from "@liscio/utils";
import { useController as Vh, useFormContext as Tf, Controller as Cz } from "react-hook-form";
import { AnimatePresence as Az, motion as Iz } from "framer-motion";
const Q11 = "data:image/png;base64,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", X11 = "data:image/png;base64,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", pz = "data:image/png;base64,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", bb = "data:image/svg+xml,%3csvg%20width='43'%20height='28'%20viewBox='0%200%20828%20539'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7716_239579)'%3e%3cpath%20d='M539.534%20269.5C539.534%20418.349%20418.749%20539%20269.776%20539H0V269.5C0%20120.669%20120.785%200%20269.758%200C418.731%200%20539.516%20120.669%20539.516%20269.5H539.534Z'%20fill='%2300AFCC'/%3e%3cpath%20d='M288.48%20269.501C288.48%20120.67%20409.247%200.000976562%20558.239%200.000976562H827.997V269.501C827.997%20418.35%20707.212%20539.001%20558.239%20539.001C409.265%20539.001%20288.48%20418.332%20288.48%20269.501Z'%20fill='%23EC2AAC'/%3e%3cpath%20d='M288.48%20269.498C288.48%20365.338%20338.567%20449.479%20413.997%20497.272C489.444%20449.497%20539.513%20365.338%20539.513%20269.498C539.513%20173.658%20489.426%2089.5178%20413.997%2041.7246C338.549%2089.4997%20288.48%20173.658%20288.48%20269.498Z'%20fill='%230061A0'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7716_239579'%3e%3crect%20width='828'%20height='539'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
function Cl(e) {
  let n = "https://mui.com/production-error/?code=" + e;
  for (let i = 1; i < arguments.length; i += 1)
    n += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + e + "; visit " + n + " for the full message.";
}
const hz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cl
}, Symbol.toStringTag, { value: "Module" })), xS = "$$material";
function m1() {
  return m1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var a in i) ({}).hasOwnProperty.call(i, a) && (e[a] = i[a]);
    }
    return e;
  }, m1.apply(null, arguments);
}
function Tt(e, n) {
  if (e == null) return {};
  var i = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (n.includes(a)) continue;
    i[a] = e[a];
  }
  return i;
}
function _h(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function qo(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var i = function a() {
      return this instanceof a ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    i.prototype = n.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(i, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), i;
}
var B7 = { exports: {} }, NC = { exports: {} }, Jt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wb;
function mz() {
  if (wb) return Jt;
  wb = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, g = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, I = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, S = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, K = e ? Symbol.for("react.scope") : 60119;
  function V(H) {
    if (typeof H == "object" && H !== null) {
      var Z = H.$$typeof;
      switch (Z) {
        case n:
          switch (H = H.type, H) {
            case h:
            case m:
            case a:
            case g:
            case s:
            case S:
              return H;
            default:
              switch (H = H && H.$$typeof, H) {
                case I:
                case w:
                case k:
                case D:
                case c:
                  return H;
                default:
                  return Z;
              }
          }
        case i:
          return Z;
      }
    }
  }
  function Y(H) {
    return V(H) === m;
  }
  return Jt.AsyncMode = h, Jt.ConcurrentMode = m, Jt.ContextConsumer = I, Jt.ContextProvider = c, Jt.Element = n, Jt.ForwardRef = w, Jt.Fragment = a, Jt.Lazy = k, Jt.Memo = D, Jt.Portal = i, Jt.Profiler = g, Jt.StrictMode = s, Jt.Suspense = S, Jt.isAsyncMode = function(H) {
    return Y(H) || V(H) === h;
  }, Jt.isConcurrentMode = Y, Jt.isContextConsumer = function(H) {
    return V(H) === I;
  }, Jt.isContextProvider = function(H) {
    return V(H) === c;
  }, Jt.isElement = function(H) {
    return typeof H == "object" && H !== null && H.$$typeof === n;
  }, Jt.isForwardRef = function(H) {
    return V(H) === w;
  }, Jt.isFragment = function(H) {
    return V(H) === a;
  }, Jt.isLazy = function(H) {
    return V(H) === k;
  }, Jt.isMemo = function(H) {
    return V(H) === D;
  }, Jt.isPortal = function(H) {
    return V(H) === i;
  }, Jt.isProfiler = function(H) {
    return V(H) === g;
  }, Jt.isStrictMode = function(H) {
    return V(H) === s;
  }, Jt.isSuspense = function(H) {
    return V(H) === S;
  }, Jt.isValidElementType = function(H) {
    return typeof H == "string" || typeof H == "function" || H === a || H === m || H === g || H === s || H === S || H === T || typeof H == "object" && H !== null && (H.$$typeof === k || H.$$typeof === D || H.$$typeof === c || H.$$typeof === I || H.$$typeof === w || H.$$typeof === N || H.$$typeof === W || H.$$typeof === K || H.$$typeof === z);
  }, Jt.typeOf = V, Jt;
}
var Kt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xb;
function vz() {
  return xb || (xb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, g = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, I = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, S = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, K = e ? Symbol.for("react.scope") : 60119;
    function V(D1) {
      return typeof D1 == "string" || typeof D1 == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D1 === a || D1 === m || D1 === g || D1 === s || D1 === S || D1 === T || typeof D1 == "object" && D1 !== null && (D1.$$typeof === k || D1.$$typeof === D || D1.$$typeof === c || D1.$$typeof === I || D1.$$typeof === w || D1.$$typeof === N || D1.$$typeof === W || D1.$$typeof === K || D1.$$typeof === z);
    }
    function Y(D1) {
      if (typeof D1 == "object" && D1 !== null) {
        var ue = D1.$$typeof;
        switch (ue) {
          case n:
            var b1 = D1.type;
            switch (b1) {
              case h:
              case m:
              case a:
              case g:
              case s:
              case S:
                return b1;
              default:
                var Pe = b1 && b1.$$typeof;
                switch (Pe) {
                  case I:
                  case w:
                  case k:
                  case D:
                  case c:
                    return Pe;
                  default:
                    return ue;
                }
            }
          case i:
            return ue;
        }
      }
    }
    var H = h, Z = m, Q = I, P1 = c, Y1 = n, O1 = w, T1 = a, J1 = k, s1 = D, d1 = i, h1 = g, C1 = s, L1 = S, f1 = !1;
    function B1(D1) {
      return f1 || (f1 = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), t1(D1) || Y(D1) === h;
    }
    function t1(D1) {
      return Y(D1) === m;
    }
    function y1(D1) {
      return Y(D1) === I;
    }
    function k1(D1) {
      return Y(D1) === c;
    }
    function se(D1) {
      return typeof D1 == "object" && D1 !== null && D1.$$typeof === n;
    }
    function K1(D1) {
      return Y(D1) === w;
    }
    function le(D1) {
      return Y(D1) === a;
    }
    function G1(D1) {
      return Y(D1) === k;
    }
    function $1(D1) {
      return Y(D1) === D;
    }
    function V1(D1) {
      return Y(D1) === i;
    }
    function z1(D1) {
      return Y(D1) === g;
    }
    function ae(D1) {
      return Y(D1) === s;
    }
    function We(D1) {
      return Y(D1) === S;
    }
    Kt.AsyncMode = H, Kt.ConcurrentMode = Z, Kt.ContextConsumer = Q, Kt.ContextProvider = P1, Kt.Element = Y1, Kt.ForwardRef = O1, Kt.Fragment = T1, Kt.Lazy = J1, Kt.Memo = s1, Kt.Portal = d1, Kt.Profiler = h1, Kt.StrictMode = C1, Kt.Suspense = L1, Kt.isAsyncMode = B1, Kt.isConcurrentMode = t1, Kt.isContextConsumer = y1, Kt.isContextProvider = k1, Kt.isElement = se, Kt.isForwardRef = K1, Kt.isFragment = le, Kt.isLazy = G1, Kt.isMemo = $1, Kt.isPortal = V1, Kt.isProfiler = z1, Kt.isStrictMode = ae, Kt.isSuspense = We, Kt.isValidElementType = V, Kt.typeOf = Y;
  }()), Kt;
}
var Sb;
function SS() {
  return Sb || (Sb = 1, process.env.NODE_ENV === "production" ? NC.exports = mz() : NC.exports = vz()), NC.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Vp, Eb;
function yz() {
  if (Eb) return Vp;
  Eb = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function a(g) {
    if (g == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(g);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var g = new String("abc");
      if (g[5] = "de", Object.getOwnPropertyNames(g)[0] === "5")
        return !1;
      for (var c = {}, I = 0; I < 10; I++)
        c["_" + String.fromCharCode(I)] = I;
      var h = Object.getOwnPropertyNames(c).map(function(w) {
        return c[w];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(w) {
        m[w] = w;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Vp = s() ? Object.assign : function(g, c) {
    for (var I, h = a(g), m, w = 1; w < arguments.length; w++) {
      I = Object(arguments[w]);
      for (var S in I)
        n.call(I, S) && (h[S] = I[S]);
      if (e) {
        m = e(I);
        for (var T = 0; T < m.length; T++)
          i.call(I, m[T]) && (h[m[T]] = I[m[T]]);
      }
    }
    return h;
  }, Vp;
}
var _p, Mb;
function Jh() {
  if (Mb) return _p;
  Mb = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _p = e, _p;
}
var Jp, Tb;
function ES() {
  return Tb || (Tb = 1, Jp = Function.call.bind(Object.prototype.hasOwnProperty)), Jp;
}
var Kp, Lb;
function bz() {
  if (Lb) return Kp;
  Lb = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Jh(), i = {}, a = ES();
    e = function(g) {
      var c = "Warning: " + g;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function s(g, c, I, h, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var w in g)
        if (a(g, w)) {
          var S;
          try {
            if (typeof g[w] != "function") {
              var T = Error(
                (h || "React class") + ": " + I + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw T.name = "Invariant Violation", T;
            }
            S = g[w](c, w, h, I, null, n);
          } catch (k) {
            S = k;
          }
          if (S && !(S instanceof Error) && e(
            (h || "React class") + ": type specification of " + I + " `" + w + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof S + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), S instanceof Error && !(S.message in i)) {
            i[S.message] = !0;
            var D = m ? m() : "";
            e(
              "Failed " + I + " type: " + S.message + (D ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, Kp = s, Kp;
}
var Yp, Rb;
function wz() {
  if (Rb) return Yp;
  Rb = 1;
  var e = SS(), n = yz(), i = Jh(), a = ES(), s = bz(), g = function() {
  };
  process.env.NODE_ENV !== "production" && (g = function(I) {
    var h = "Warning: " + I;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return Yp = function(I, h) {
    var m = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
    function S(t1) {
      var y1 = t1 && (m && t1[m] || t1[w]);
      if (typeof y1 == "function")
        return y1;
    }
    var T = "<<anonymous>>", D = {
      array: W("array"),
      bigint: W("bigint"),
      bool: W("boolean"),
      func: W("function"),
      number: W("number"),
      object: W("object"),
      string: W("string"),
      symbol: W("symbol"),
      any: K(),
      arrayOf: V,
      element: Y(),
      elementType: H(),
      instanceOf: Z,
      node: O1(),
      objectOf: P1,
      oneOf: Q,
      oneOfType: Y1,
      shape: J1,
      exact: s1
    };
    function k(t1, y1) {
      return t1 === y1 ? t1 !== 0 || 1 / t1 === 1 / y1 : t1 !== t1 && y1 !== y1;
    }
    function z(t1, y1) {
      this.message = t1, this.data = y1 && typeof y1 == "object" ? y1 : {}, this.stack = "";
    }
    z.prototype = Error.prototype;
    function N(t1) {
      if (process.env.NODE_ENV !== "production")
        var y1 = {}, k1 = 0;
      function se(le, G1, $1, V1, z1, ae, We) {
        if (V1 = V1 || T, ae = ae || $1, We !== i) {
          if (h) {
            var D1 = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D1.name = "Invariant Violation", D1;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ue = V1 + ":" + $1;
            !y1[ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            k1 < 3 && (g(
              "You are manually calling a React.PropTypes validation function for the `" + ae + "` prop on `" + V1 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), y1[ue] = !0, k1++);
          }
        }
        return G1[$1] == null ? le ? G1[$1] === null ? new z("The " + z1 + " `" + ae + "` is marked as required " + ("in `" + V1 + "`, but its value is `null`.")) : new z("The " + z1 + " `" + ae + "` is marked as required in " + ("`" + V1 + "`, but its value is `undefined`.")) : null : t1(G1, $1, V1, z1, ae);
      }
      var K1 = se.bind(null, !1);
      return K1.isRequired = se.bind(null, !0), K1;
    }
    function W(t1) {
      function y1(k1, se, K1, le, G1, $1) {
        var V1 = k1[se], z1 = C1(V1);
        if (z1 !== t1) {
          var ae = L1(V1);
          return new z(
            "Invalid " + le + " `" + G1 + "` of type " + ("`" + ae + "` supplied to `" + K1 + "`, expected ") + ("`" + t1 + "`."),
            { expectedType: t1 }
          );
        }
        return null;
      }
      return N(y1);
    }
    function K() {
      return N(c);
    }
    function V(t1) {
      function y1(k1, se, K1, le, G1) {
        if (typeof t1 != "function")
          return new z("Property `" + G1 + "` of component `" + K1 + "` has invalid PropType notation inside arrayOf.");
        var $1 = k1[se];
        if (!Array.isArray($1)) {
          var V1 = C1($1);
          return new z("Invalid " + le + " `" + G1 + "` of type " + ("`" + V1 + "` supplied to `" + K1 + "`, expected an array."));
        }
        for (var z1 = 0; z1 < $1.length; z1++) {
          var ae = t1($1, z1, K1, le, G1 + "[" + z1 + "]", i);
          if (ae instanceof Error)
            return ae;
        }
        return null;
      }
      return N(y1);
    }
    function Y() {
      function t1(y1, k1, se, K1, le) {
        var G1 = y1[k1];
        if (!I(G1)) {
          var $1 = C1(G1);
          return new z("Invalid " + K1 + " `" + le + "` of type " + ("`" + $1 + "` supplied to `" + se + "`, expected a single ReactElement."));
        }
        return null;
      }
      return N(t1);
    }
    function H() {
      function t1(y1, k1, se, K1, le) {
        var G1 = y1[k1];
        if (!e.isValidElementType(G1)) {
          var $1 = C1(G1);
          return new z("Invalid " + K1 + " `" + le + "` of type " + ("`" + $1 + "` supplied to `" + se + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return N(t1);
    }
    function Z(t1) {
      function y1(k1, se, K1, le, G1) {
        if (!(k1[se] instanceof t1)) {
          var $1 = t1.name || T, V1 = B1(k1[se]);
          return new z("Invalid " + le + " `" + G1 + "` of type " + ("`" + V1 + "` supplied to `" + K1 + "`, expected ") + ("instance of `" + $1 + "`."));
        }
        return null;
      }
      return N(y1);
    }
    function Q(t1) {
      if (!Array.isArray(t1))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? g(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : g("Invalid argument supplied to oneOf, expected an array.")), c;
      function y1(k1, se, K1, le, G1) {
        for (var $1 = k1[se], V1 = 0; V1 < t1.length; V1++)
          if (k($1, t1[V1]))
            return null;
        var z1 = JSON.stringify(t1, function(We, D1) {
          var ue = L1(D1);
          return ue === "symbol" ? String(D1) : D1;
        });
        return new z("Invalid " + le + " `" + G1 + "` of value `" + String($1) + "` " + ("supplied to `" + K1 + "`, expected one of " + z1 + "."));
      }
      return N(y1);
    }
    function P1(t1) {
      function y1(k1, se, K1, le, G1) {
        if (typeof t1 != "function")
          return new z("Property `" + G1 + "` of component `" + K1 + "` has invalid PropType notation inside objectOf.");
        var $1 = k1[se], V1 = C1($1);
        if (V1 !== "object")
          return new z("Invalid " + le + " `" + G1 + "` of type " + ("`" + V1 + "` supplied to `" + K1 + "`, expected an object."));
        for (var z1 in $1)
          if (a($1, z1)) {
            var ae = t1($1, z1, K1, le, G1 + "." + z1, i);
            if (ae instanceof Error)
              return ae;
          }
        return null;
      }
      return N(y1);
    }
    function Y1(t1) {
      if (!Array.isArray(t1))
        return process.env.NODE_ENV !== "production" && g("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var y1 = 0; y1 < t1.length; y1++) {
        var k1 = t1[y1];
        if (typeof k1 != "function")
          return g(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f1(k1) + " at index " + y1 + "."
          ), c;
      }
      function se(K1, le, G1, $1, V1) {
        for (var z1 = [], ae = 0; ae < t1.length; ae++) {
          var We = t1[ae], D1 = We(K1, le, G1, $1, V1, i);
          if (D1 == null)
            return null;
          D1.data && a(D1.data, "expectedType") && z1.push(D1.data.expectedType);
        }
        var ue = z1.length > 0 ? ", expected one of type [" + z1.join(", ") + "]" : "";
        return new z("Invalid " + $1 + " `" + V1 + "` supplied to " + ("`" + G1 + "`" + ue + "."));
      }
      return N(se);
    }
    function O1() {
      function t1(y1, k1, se, K1, le) {
        return d1(y1[k1]) ? null : new z("Invalid " + K1 + " `" + le + "` supplied to " + ("`" + se + "`, expected a ReactNode."));
      }
      return N(t1);
    }
    function T1(t1, y1, k1, se, K1) {
      return new z(
        (t1 || "React class") + ": " + y1 + " type `" + k1 + "." + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K1 + "`."
      );
    }
    function J1(t1) {
      function y1(k1, se, K1, le, G1) {
        var $1 = k1[se], V1 = C1($1);
        if (V1 !== "object")
          return new z("Invalid " + le + " `" + G1 + "` of type `" + V1 + "` " + ("supplied to `" + K1 + "`, expected `object`."));
        for (var z1 in t1) {
          var ae = t1[z1];
          if (typeof ae != "function")
            return T1(K1, le, G1, z1, L1(ae));
          var We = ae($1, z1, K1, le, G1 + "." + z1, i);
          if (We)
            return We;
        }
        return null;
      }
      return N(y1);
    }
    function s1(t1) {
      function y1(k1, se, K1, le, G1) {
        var $1 = k1[se], V1 = C1($1);
        if (V1 !== "object")
          return new z("Invalid " + le + " `" + G1 + "` of type `" + V1 + "` " + ("supplied to `" + K1 + "`, expected `object`."));
        var z1 = n({}, k1[se], t1);
        for (var ae in z1) {
          var We = t1[ae];
          if (a(t1, ae) && typeof We != "function")
            return T1(K1, le, G1, ae, L1(We));
          if (!We)
            return new z(
              "Invalid " + le + " `" + G1 + "` key `" + ae + "` supplied to `" + K1 + "`.\nBad object: " + JSON.stringify(k1[se], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(t1), null, "  ")
            );
          var D1 = We($1, ae, K1, le, G1 + "." + ae, i);
          if (D1)
            return D1;
        }
        return null;
      }
      return N(y1);
    }
    function d1(t1) {
      switch (typeof t1) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t1;
        case "object":
          if (Array.isArray(t1))
            return t1.every(d1);
          if (t1 === null || I(t1))
            return !0;
          var y1 = S(t1);
          if (y1) {
            var k1 = y1.call(t1), se;
            if (y1 !== t1.entries) {
              for (; !(se = k1.next()).done; )
                if (!d1(se.value))
                  return !1;
            } else
              for (; !(se = k1.next()).done; ) {
                var K1 = se.value;
                if (K1 && !d1(K1[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function h1(t1, y1) {
      return t1 === "symbol" ? !0 : y1 ? y1["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && y1 instanceof Symbol : !1;
    }
    function C1(t1) {
      var y1 = typeof t1;
      return Array.isArray(t1) ? "array" : t1 instanceof RegExp ? "object" : h1(y1, t1) ? "symbol" : y1;
    }
    function L1(t1) {
      if (typeof t1 > "u" || t1 === null)
        return "" + t1;
      var y1 = C1(t1);
      if (y1 === "object") {
        if (t1 instanceof Date)
          return "date";
        if (t1 instanceof RegExp)
          return "regexp";
      }
      return y1;
    }
    function f1(t1) {
      var y1 = L1(t1);
      switch (y1) {
        case "array":
        case "object":
          return "an " + y1;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + y1;
        default:
          return y1;
      }
    }
    function B1(t1) {
      return !t1.constructor || !t1.constructor.name ? T : t1.constructor.name;
    }
    return D.checkPropTypes = s, D.resetWarningCache = s.resetWarningCache, D.PropTypes = D, D;
  }, Yp;
}
var Qp, Ob;
function xz() {
  if (Ob) return Qp;
  Ob = 1;
  var e = Jh();
  function n() {
  }
  function i() {
  }
  return i.resetWarningCache = n, Qp = function() {
    function a(c, I, h, m, w, S) {
      if (S !== e) {
        var T = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw T.name = "Invariant Violation", T;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var g = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: i,
      resetWarningCache: n
    };
    return g.PropTypes = g, g;
  }, Qp;
}
if (process.env.NODE_ENV !== "production") {
  var Sz = SS(), Ez = !0;
  B7.exports = wz()(Sz.isElement, Ez);
} else
  B7.exports = xz()();
var E1 = B7.exports;
const E = /* @__PURE__ */ _h(E1);
var Mz = !1;
function Tz(e) {
  if (e.sheet)
    return e.sheet;
  for (var n = 0; n < document.styleSheets.length; n++)
    if (document.styleSheets[n].ownerNode === e)
      return document.styleSheets[n];
}
function Lz(e) {
  var n = document.createElement("style");
  return n.setAttribute("data-emotion", e.key), e.nonce !== void 0 && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n.setAttribute("data-s", ""), n;
}
var Rz = /* @__PURE__ */ function() {
  function e(i) {
    var a = this;
    this._insertTag = function(s) {
      var g;
      a.tags.length === 0 ? a.insertionPoint ? g = a.insertionPoint.nextSibling : a.prepend ? g = a.container.firstChild : g = a.before : g = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(s, g), a.tags.push(s);
    }, this.isSpeedy = i.speedy === void 0 ? !Mz : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var n = e.prototype;
  return n.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, n.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Lz(this));
    var s = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var g = Tz(s);
      try {
        g.insertRule(a, g.cssRules.length);
      } catch {
      }
    } else
      s.appendChild(document.createTextNode(a));
    this.ctr++;
  }, n.flush = function() {
    this.tags.forEach(function(a) {
      var s;
      return (s = a.parentNode) == null ? void 0 : s.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Rr = "-ms-", pA = "-moz-", Ft = "-webkit-", MS = "comm", Kh = "rule", Yh = "decl", Oz = "@import", TS = "@keyframes", Dz = "@layer", kz = Math.abs, WA = String.fromCharCode, jz = Object.assign;
function zz(e, n) {
  return ar(e, 0) ^ 45 ? (((n << 2 ^ ar(e, 0)) << 2 ^ ar(e, 1)) << 2 ^ ar(e, 2)) << 2 ^ ar(e, 3) : 0;
}
function LS(e) {
  return e.trim();
}
function Nz(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function Bt(e, n, i) {
  return e.replace(n, i);
}
function H7(e, n) {
  return e.indexOf(n);
}
function ar(e, n) {
  return e.charCodeAt(n) | 0;
}
function pf(e, n, i) {
  return e.slice(n, i);
}
function bi(e) {
  return e.length;
}
function Qh(e) {
  return e.length;
}
function PC(e, n) {
  return n.push(e), e;
}
function Pz(e, n) {
  return e.map(n).join("");
}
var VA = 1, Tc = 1, RS = 0, v3 = 0, p2 = 0, Pc = "";
function _A(e, n, i, a, s, g, c) {
  return { value: e, root: n, parent: i, type: a, props: s, children: g, line: VA, column: Tc, length: c, return: "" };
}
function Yg(e, n) {
  return jz(_A("", null, null, "", null, null, 0), e, { length: -e.length }, n);
}
function Fz() {
  return p2;
}
function Bz() {
  return p2 = v3 > 0 ? ar(Pc, --v3) : 0, Tc--, p2 === 10 && (Tc = 1, VA--), p2;
}
function R3() {
  return p2 = v3 < RS ? ar(Pc, v3++) : 0, Tc++, p2 === 10 && (Tc = 1, VA++), p2;
}
function Di() {
  return ar(Pc, v3);
}
function iA() {
  return v3;
}
function Lf(e, n) {
  return pf(Pc, e, n);
}
function hf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function OS(e) {
  return VA = Tc = 1, RS = bi(Pc = e), v3 = 0, [];
}
function DS(e) {
  return Pc = "", e;
}
function aA(e) {
  return LS(Lf(v3 - 1, U7(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Hz(e) {
  for (; (p2 = Di()) && p2 < 33; )
    R3();
  return hf(e) > 2 || hf(p2) > 3 ? "" : " ";
}
function Uz(e, n) {
  for (; --n && R3() && !(p2 < 48 || p2 > 102 || p2 > 57 && p2 < 65 || p2 > 70 && p2 < 97); )
    ;
  return Lf(e, iA() + (n < 6 && Di() == 32 && R3() == 32));
}
function U7(e) {
  for (; R3(); )
    switch (p2) {
      case e:
        return v3;
      case 34:
      case 39:
        e !== 34 && e !== 39 && U7(p2);
        break;
      case 40:
        e === 41 && U7(e);
        break;
      case 92:
        R3();
        break;
    }
  return v3;
}
function Wz(e, n) {
  for (; R3() && e + p2 !== 57; )
    if (e + p2 === 84 && Di() === 47)
      break;
  return "/*" + Lf(n, v3 - 1) + "*" + WA(e === 47 ? e : R3());
}
function Vz(e) {
  for (; !hf(Di()); )
    R3();
  return Lf(e, v3);
}
function _z(e) {
  return DS(oA("", null, null, null, [""], e = OS(e), 0, [0], e));
}
function oA(e, n, i, a, s, g, c, I, h) {
  for (var m = 0, w = 0, S = c, T = 0, D = 0, k = 0, z = 1, N = 1, W = 1, K = 0, V = "", Y = s, H = g, Z = a, Q = V; N; )
    switch (k = K, K = R3()) {
      case 40:
        if (k != 108 && ar(Q, S - 1) == 58) {
          H7(Q += Bt(aA(K), "&", "&\f"), "&\f") != -1 && (W = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        Q += aA(K);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        Q += Hz(k);
        break;
      case 92:
        Q += Uz(iA() - 1, 7);
        continue;
      case 47:
        switch (Di()) {
          case 42:
          case 47:
            PC(Jz(Wz(R3(), iA()), n, i), h);
            break;
          default:
            Q += "/";
        }
        break;
      case 123 * z:
        I[m++] = bi(Q) * W;
      case 125 * z:
      case 59:
      case 0:
        switch (K) {
          case 0:
          case 125:
            N = 0;
          case 59 + w:
            W == -1 && (Q = Bt(Q, /\f/g, "")), D > 0 && bi(Q) - S && PC(D > 32 ? kb(Q + ";", a, i, S - 1) : kb(Bt(Q, " ", "") + ";", a, i, S - 2), h);
            break;
          case 59:
            Q += ";";
          default:
            if (PC(Z = Db(Q, n, i, m, w, s, I, V, Y = [], H = [], S), g), K === 123)
              if (w === 0)
                oA(Q, n, Z, Z, Y, g, S, I, H);
              else
                switch (T === 99 && ar(Q, 3) === 110 ? 100 : T) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    oA(e, Z, Z, a && PC(Db(e, Z, Z, 0, 0, s, I, V, s, Y = [], S), H), s, H, S, I, a ? Y : H);
                    break;
                  default:
                    oA(Q, Z, Z, Z, [""], H, 0, I, H);
                }
        }
        m = w = D = 0, z = W = 1, V = Q = "", S = c;
        break;
      case 58:
        S = 1 + bi(Q), D = k;
      default:
        if (z < 1) {
          if (K == 123)
            --z;
          else if (K == 125 && z++ == 0 && Bz() == 125)
            continue;
        }
        switch (Q += WA(K), K * z) {
          case 38:
            W = w > 0 ? 1 : (Q += "\f", -1);
            break;
          case 44:
            I[m++] = (bi(Q) - 1) * W, W = 1;
            break;
          case 64:
            Di() === 45 && (Q += aA(R3())), T = Di(), w = S = bi(V = Q += Vz(iA())), K++;
            break;
          case 45:
            k === 45 && bi(Q) == 2 && (z = 0);
        }
    }
  return g;
}
function Db(e, n, i, a, s, g, c, I, h, m, w) {
  for (var S = s - 1, T = s === 0 ? g : [""], D = Qh(T), k = 0, z = 0, N = 0; k < a; ++k)
    for (var W = 0, K = pf(e, S + 1, S = kz(z = c[k])), V = e; W < D; ++W)
      (V = LS(z > 0 ? T[W] + " " + K : Bt(K, /&\f/g, T[W]))) && (h[N++] = V);
  return _A(e, n, i, s === 0 ? Kh : I, h, m, w);
}
function Jz(e, n, i) {
  return _A(e, n, i, MS, WA(Fz()), pf(e, 2, -2), 0);
}
function kb(e, n, i, a) {
  return _A(e, n, i, Yh, pf(e, 0, a), pf(e, a + 1, -1), a);
}
function Sc(e, n) {
  for (var i = "", a = Qh(e), s = 0; s < a; s++)
    i += n(e[s], s, e, n) || "";
  return i;
}
function Kz(e, n, i, a) {
  switch (e.type) {
    case Dz:
      if (e.children.length) break;
    case Oz:
    case Yh:
      return e.return = e.return || e.value;
    case MS:
      return "";
    case TS:
      return e.return = e.value + "{" + Sc(e.children, a) + "}";
    case Kh:
      e.value = e.props.join(",");
  }
  return bi(i = Sc(e.children, a)) ? e.return = e.value + "{" + i + "}" : "";
}
function Yz(e) {
  var n = Qh(e);
  return function(i, a, s, g) {
    for (var c = "", I = 0; I < n; I++)
      c += e[I](i, a, s, g) || "";
    return c;
  };
}
function Qz(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
var Xz = function(n, i, a) {
  for (var s = 0, g = 0; s = g, g = Di(), s === 38 && g === 12 && (i[a] = 1), !hf(g); )
    R3();
  return Lf(n, v3);
}, Gz = function(n, i) {
  var a = -1, s = 44;
  do
    switch (hf(s)) {
      case 0:
        s === 38 && Di() === 12 && (i[a] = 1), n[a] += Xz(v3 - 1, i, a);
        break;
      case 2:
        n[a] += aA(s);
        break;
      case 4:
        if (s === 44) {
          n[++a] = Di() === 58 ? "&\f" : "", i[a] = n[a].length;
          break;
        }
      default:
        n[a] += WA(s);
    }
  while (s = R3());
  return n;
}, qz = function(n, i) {
  return DS(Gz(OS(n), i));
}, jb = /* @__PURE__ */ new WeakMap(), Zz = function(n) {
  if (!(n.type !== "rule" || !n.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  n.length < 1)) {
    for (var i = n.value, a = n.parent, s = n.column === a.column && n.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a) return;
    if (!(n.props.length === 1 && i.charCodeAt(0) !== 58 && !jb.get(a)) && !s) {
      jb.set(n, !0);
      for (var g = [], c = qz(i, g), I = a.props, h = 0, m = 0; h < c.length; h++)
        for (var w = 0; w < I.length; w++, m++)
          n.props[m] = g[h] ? c[h].replace(/&\f/g, I[w]) : I[w] + " " + c[h];
    }
  }
}, $z = function(n) {
  if (n.type === "decl") {
    var i = n.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (n.return = "", n.value = "");
  }
};
function kS(e, n) {
  switch (zz(e, n)) {
    case 5103:
      return Ft + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ft + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ft + e + pA + e + Rr + e + e;
    case 6828:
    case 4268:
      return Ft + e + Rr + e + e;
    case 6165:
      return Ft + e + Rr + "flex-" + e + e;
    case 5187:
      return Ft + e + Bt(e, /(\w+).+(:[^]+)/, Ft + "box-$1$2" + Rr + "flex-$1$2") + e;
    case 5443:
      return Ft + e + Rr + "flex-item-" + Bt(e, /flex-|-self/, "") + e;
    case 4675:
      return Ft + e + Rr + "flex-line-pack" + Bt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Ft + e + Rr + Bt(e, "shrink", "negative") + e;
    case 5292:
      return Ft + e + Rr + Bt(e, "basis", "preferred-size") + e;
    case 6060:
      return Ft + "box-" + Bt(e, "-grow", "") + Ft + e + Rr + Bt(e, "grow", "positive") + e;
    case 4554:
      return Ft + Bt(e, /([^-])(transform)/g, "$1" + Ft + "$2") + e;
    case 6187:
      return Bt(Bt(Bt(e, /(zoom-|grab)/, Ft + "$1"), /(image-set)/, Ft + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Bt(e, /(image-set\([^]*)/, Ft + "$1$`$1");
    case 4968:
      return Bt(Bt(e, /(.+:)(flex-)?(.*)/, Ft + "box-pack:$3" + Rr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ft + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Bt(e, /(.+)-inline(.+)/, Ft + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (bi(e) - 1 - n > 6) switch (ar(e, n + 1)) {
        case 109:
          if (ar(e, n + 4) !== 45) break;
        case 102:
          return Bt(e, /(.+:)(.+)-([^]+)/, "$1" + Ft + "$2-$3$1" + pA + (ar(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~H7(e, "stretch") ? kS(Bt(e, "stretch", "fill-available"), n) + e : e;
      }
      break;
    case 4949:
      if (ar(e, n + 1) !== 115) break;
    case 6444:
      switch (ar(e, bi(e) - 3 - (~H7(e, "!important") && 10))) {
        case 107:
          return Bt(e, ":", ":" + Ft) + e;
        case 101:
          return Bt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ft + (ar(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ft + "$2$3$1" + Rr + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (ar(e, n + 11)) {
        case 114:
          return Ft + e + Rr + Bt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Ft + e + Rr + Bt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Ft + e + Rr + Bt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ft + e + Rr + e + e;
  }
  return e;
}
var eN = function(n, i, a, s) {
  if (n.length > -1 && !n.return) switch (n.type) {
    case Yh:
      n.return = kS(n.value, n.length);
      break;
    case TS:
      return Sc([Yg(n, {
        value: Bt(n.value, "@", "@" + Ft)
      })], s);
    case Kh:
      if (n.length) return Pz(n.props, function(g) {
        switch (Nz(g, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Sc([Yg(n, {
              props: [Bt(g, /:(read-\w+)/, ":" + pA + "$1")]
            })], s);
          case "::placeholder":
            return Sc([Yg(n, {
              props: [Bt(g, /:(plac\w+)/, ":" + Ft + "input-$1")]
            }), Yg(n, {
              props: [Bt(g, /:(plac\w+)/, ":" + pA + "$1")]
            }), Yg(n, {
              props: [Bt(g, /:(plac\w+)/, Rr + "input-$1")]
            })], s);
        }
        return "";
      });
  }
}, tN = [eN], nN = function(n) {
  var i = n.key;
  if (i === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(z) {
      var N = z.getAttribute("data-emotion");
      N.indexOf(" ") !== -1 && (document.head.appendChild(z), z.setAttribute("data-s", ""));
    });
  }
  var s = n.stylisPlugins || tN, g = {}, c, I = [];
  c = n.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(z) {
      for (var N = z.getAttribute("data-emotion").split(" "), W = 1; W < N.length; W++)
        g[N[W]] = !0;
      I.push(z);
    }
  );
  var h, m = [Zz, $z];
  {
    var w, S = [Kz, Qz(function(z) {
      w.insert(z);
    })], T = Yz(m.concat(s, S)), D = function(N) {
      return Sc(_z(N), T);
    };
    h = function(N, W, K, V) {
      w = K, D(N ? N + "{" + W.styles + "}" : W.styles), V && (k.inserted[W.name] = !0);
    };
  }
  var k = {
    key: i,
    sheet: new Rz({
      key: i,
      container: c,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend,
      insertionPoint: n.insertionPoint
    }),
    nonce: n.nonce,
    inserted: g,
    registered: {},
    insert: h
  };
  return k.sheet.hydrate(I), k;
}, W7 = { exports: {} }, Qg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zb;
function rN() {
  if (zb) return Qg;
  zb = 1;
  var e = Gt, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(I, h, m) {
    var w, S = {}, T = null, D = null;
    m !== void 0 && (T = "" + m), h.key !== void 0 && (T = "" + h.key), h.ref !== void 0 && (D = h.ref);
    for (w in h) a.call(h, w) && !g.hasOwnProperty(w) && (S[w] = h[w]);
    if (I && I.defaultProps) for (w in h = I.defaultProps, h) S[w] === void 0 && (S[w] = h[w]);
    return { $$typeof: n, type: I, key: T, ref: D, props: S, _owner: s.current };
  }
  return Qg.Fragment = i, Qg.jsx = c, Qg.jsxs = c, Qg;
}
var Xg = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nb;
function iN() {
  return Nb || (Nb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Gt, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), I = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), k = Symbol.iterator, z = "@@iterator";
    function N(J) {
      if (J === null || typeof J != "object")
        return null;
      var S1 = k && J[k] || J[z];
      return typeof S1 == "function" ? S1 : null;
    }
    var W = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function K(J) {
      {
        for (var S1 = arguments.length, X1 = new Array(S1 > 1 ? S1 - 1 : 0), Ae = 1; Ae < S1; Ae++)
          X1[Ae - 1] = arguments[Ae];
        V("error", J, X1);
      }
    }
    function V(J, S1, X1) {
      {
        var Ae = W.ReactDebugCurrentFrame, ot = Ae.getStackAddendum();
        ot !== "" && (S1 += "%s", X1 = X1.concat([ot]));
        var ut = X1.map(function(je) {
          return String(je);
        });
        ut.unshift("Warning: " + S1), Function.prototype.apply.call(console[J], console, ut);
      }
    }
    var Y = !1, H = !1, Z = !1, Q = !1, P1 = !1, Y1;
    Y1 = Symbol.for("react.module.reference");
    function O1(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === a || J === g || P1 || J === s || J === m || J === w || Q || J === D || Y || H || Z || typeof J == "object" && J !== null && (J.$$typeof === T || J.$$typeof === S || J.$$typeof === c || J.$$typeof === I || J.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === Y1 || J.getModuleId !== void 0));
    }
    function T1(J, S1, X1) {
      var Ae = J.displayName;
      if (Ae)
        return Ae;
      var ot = S1.displayName || S1.name || "";
      return ot !== "" ? X1 + "(" + ot + ")" : X1;
    }
    function J1(J) {
      return J.displayName || "Context";
    }
    function s1(J) {
      if (J == null)
        return null;
      if (typeof J.tag == "number" && K("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof J == "function")
        return J.displayName || J.name || null;
      if (typeof J == "string")
        return J;
      switch (J) {
        case a:
          return "Fragment";
        case i:
          return "Portal";
        case g:
          return "Profiler";
        case s:
          return "StrictMode";
        case m:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case I:
            var S1 = J;
            return J1(S1) + ".Consumer";
          case c:
            var X1 = J;
            return J1(X1._context) + ".Provider";
          case h:
            return T1(J, J.render, "ForwardRef");
          case S:
            var Ae = J.displayName || null;
            return Ae !== null ? Ae : s1(J.type) || "Memo";
          case T: {
            var ot = J, ut = ot._payload, je = ot._init;
            try {
              return s1(je(ut));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var d1 = Object.assign, h1 = 0, C1, L1, f1, B1, t1, y1, k1;
    function se() {
    }
    se.__reactDisabledLog = !0;
    function K1() {
      {
        if (h1 === 0) {
          C1 = console.log, L1 = console.info, f1 = console.warn, B1 = console.error, t1 = console.group, y1 = console.groupCollapsed, k1 = console.groupEnd;
          var J = {
            configurable: !0,
            enumerable: !0,
            value: se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: J,
            log: J,
            warn: J,
            error: J,
            group: J,
            groupCollapsed: J,
            groupEnd: J
          });
        }
        h1++;
      }
    }
    function le() {
      {
        if (h1--, h1 === 0) {
          var J = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: d1({}, J, {
              value: C1
            }),
            info: d1({}, J, {
              value: L1
            }),
            warn: d1({}, J, {
              value: f1
            }),
            error: d1({}, J, {
              value: B1
            }),
            group: d1({}, J, {
              value: t1
            }),
            groupCollapsed: d1({}, J, {
              value: y1
            }),
            groupEnd: d1({}, J, {
              value: k1
            })
          });
        }
        h1 < 0 && K("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G1 = W.ReactCurrentDispatcher, $1;
    function V1(J, S1, X1) {
      {
        if ($1 === void 0)
          try {
            throw Error();
          } catch (ot) {
            var Ae = ot.stack.trim().match(/\n( *(at )?)/);
            $1 = Ae && Ae[1] || "";
          }
        return `
` + $1 + J;
      }
    }
    var z1 = !1, ae;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new We();
    }
    function D1(J, S1) {
      if (!J || z1)
        return "";
      {
        var X1 = ae.get(J);
        if (X1 !== void 0)
          return X1;
      }
      var Ae;
      z1 = !0;
      var ot = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ut;
      ut = G1.current, G1.current = null, K1();
      try {
        if (S1) {
          var je = function() {
            throw Error();
          };
          if (Object.defineProperty(je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(je, []);
            } catch (Qn) {
              Ae = Qn;
            }
            Reflect.construct(J, [], je);
          } else {
            try {
              je.call();
            } catch (Qn) {
              Ae = Qn;
            }
            J.call(je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qn) {
            Ae = Qn;
          }
          J();
        }
      } catch (Qn) {
        if (Qn && Ae && typeof Qn.stack == "string") {
          for (var et = Qn.stack.split(`
`), Bn = Ae.stack.split(`
`), Pt = et.length - 1, Zt = Bn.length - 1; Pt >= 1 && Zt >= 0 && et[Pt] !== Bn[Zt]; )
            Zt--;
          for (; Pt >= 1 && Zt >= 0; Pt--, Zt--)
            if (et[Pt] !== Bn[Zt]) {
              if (Pt !== 1 || Zt !== 1)
                do
                  if (Pt--, Zt--, Zt < 0 || et[Pt] !== Bn[Zt]) {
                    var N2 = `
` + et[Pt].replace(" at new ", " at ");
                    return J.displayName && N2.includes("<anonymous>") && (N2 = N2.replace("<anonymous>", J.displayName)), typeof J == "function" && ae.set(J, N2), N2;
                  }
                while (Pt >= 1 && Zt >= 0);
              break;
            }
        }
      } finally {
        z1 = !1, G1.current = ut, le(), Error.prepareStackTrace = ot;
      }
      var P3 = J ? J.displayName || J.name : "", vt = P3 ? V1(P3) : "";
      return typeof J == "function" && ae.set(J, vt), vt;
    }
    function ue(J, S1, X1) {
      return D1(J, !1);
    }
    function b1(J) {
      var S1 = J.prototype;
      return !!(S1 && S1.isReactComponent);
    }
    function Pe(J, S1, X1) {
      if (J == null)
        return "";
      if (typeof J == "function")
        return D1(J, b1(J));
      if (typeof J == "string")
        return V1(J);
      switch (J) {
        case m:
          return V1("Suspense");
        case w:
          return V1("SuspenseList");
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case h:
            return ue(J.render);
          case S:
            return Pe(J.type, S1, X1);
          case T: {
            var Ae = J, ot = Ae._payload, ut = Ae._init;
            try {
              return Pe(ut(ot), S1, X1);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, W1 = {}, ke = W.ReactDebugCurrentFrame;
    function Xe(J) {
      if (J) {
        var S1 = J._owner, X1 = Pe(J.type, J._source, S1 ? S1.type : null);
        ke.setExtraStackFrame(X1);
      } else
        ke.setExtraStackFrame(null);
    }
    function St(J, S1, X1, Ae, ot) {
      {
        var ut = Function.call.bind($e);
        for (var je in J)
          if (ut(J, je)) {
            var et = void 0;
            try {
              if (typeof J[je] != "function") {
                var Bn = Error((Ae || "React class") + ": " + X1 + " type `" + je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Bn.name = "Invariant Violation", Bn;
              }
              et = J[je](S1, je, Ae, X1, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pt) {
              et = Pt;
            }
            et && !(et instanceof Error) && (Xe(ot), K("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ae || "React class", X1, je, typeof et), Xe(null)), et instanceof Error && !(et.message in W1) && (W1[et.message] = !0, Xe(ot), K("Failed %s type: %s", X1, et.message), Xe(null));
          }
      }
    }
    var tt = Array.isArray;
    function we(J) {
      return tt(J);
    }
    function An(J) {
      {
        var S1 = typeof Symbol == "function" && Symbol.toStringTag, X1 = S1 && J[Symbol.toStringTag] || J.constructor.name || "Object";
        return X1;
      }
    }
    function nt(J) {
      try {
        return In(J), !1;
      } catch {
        return !0;
      }
    }
    function In(J) {
      return "" + J;
    }
    function v2(J) {
      if (nt(J))
        return K("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", An(J)), In(J);
    }
    var tn = W.ReactCurrentOwner, s2 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fe, Pn, Q1;
    Q1 = {};
    function he(J) {
      if ($e.call(J, "ref")) {
        var S1 = Object.getOwnPropertyDescriptor(J, "ref").get;
        if (S1 && S1.isReactWarning)
          return !1;
      }
      return J.ref !== void 0;
    }
    function Ye(J) {
      if ($e.call(J, "key")) {
        var S1 = Object.getOwnPropertyDescriptor(J, "key").get;
        if (S1 && S1.isReactWarning)
          return !1;
      }
      return J.key !== void 0;
    }
    function Et(J, S1) {
      if (typeof J.ref == "string" && tn.current && S1 && tn.current.stateNode !== S1) {
        var X1 = s1(tn.current.type);
        Q1[X1] || (K('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', s1(tn.current.type), J.ref), Q1[X1] = !0);
      }
    }
    function Ut(J, S1) {
      {
        var X1 = function() {
          Fe || (Fe = !0, K("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S1));
        };
        X1.isReactWarning = !0, Object.defineProperty(J, "key", {
          get: X1,
          configurable: !0
        });
      }
    }
    function cn(J, S1) {
      {
        var X1 = function() {
          Pn || (Pn = !0, K("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S1));
        };
        X1.isReactWarning = !0, Object.defineProperty(J, "ref", {
          get: X1,
          configurable: !0
        });
      }
    }
    var nn = function(J, S1, X1, Ae, ot, ut, je) {
      var et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: J,
        key: S1,
        ref: X1,
        props: je,
        // Record the component responsible for creating this element.
        _owner: ut
      };
      return et._store = {}, Object.defineProperty(et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ae
      }), Object.defineProperty(et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ot
      }), Object.freeze && (Object.freeze(et.props), Object.freeze(et)), et;
    };
    function Fn(J, S1, X1, Ae, ot) {
      {
        var ut, je = {}, et = null, Bn = null;
        X1 !== void 0 && (v2(X1), et = "" + X1), Ye(S1) && (v2(S1.key), et = "" + S1.key), he(S1) && (Bn = S1.ref, Et(S1, ot));
        for (ut in S1)
          $e.call(S1, ut) && !s2.hasOwnProperty(ut) && (je[ut] = S1[ut]);
        if (J && J.defaultProps) {
          var Pt = J.defaultProps;
          for (ut in Pt)
            je[ut] === void 0 && (je[ut] = Pt[ut]);
        }
        if (et || Bn) {
          var Zt = typeof J == "function" ? J.displayName || J.name || "Unknown" : J;
          et && Ut(je, Zt), Bn && cn(je, Zt);
        }
        return nn(J, et, Bn, ot, Ae, tn.current, je);
      }
    }
    var zt = W.ReactCurrentOwner, y2 = W.ReactDebugCurrentFrame;
    function Nt(J) {
      if (J) {
        var S1 = J._owner, X1 = Pe(J.type, J._source, S1 ? S1.type : null);
        y2.setExtraStackFrame(X1);
      } else
        y2.setExtraStackFrame(null);
    }
    var Wt;
    Wt = !1;
    function j3(J) {
      return typeof J == "object" && J !== null && J.$$typeof === n;
    }
    function l0() {
      {
        if (zt.current) {
          var J = s1(zt.current.type);
          if (J)
            return `

Check the render method of \`` + J + "`.";
        }
        return "";
      }
    }
    function W0(J) {
      return "";
    }
    var Pi = {};
    function z3(J) {
      {
        var S1 = l0();
        if (!S1) {
          var X1 = typeof J == "string" ? J : J.displayName || J.name;
          X1 && (S1 = `

Check the top-level render call using <` + X1 + ">.");
        }
        return S1;
      }
    }
    function N3(J, S1) {
      {
        if (!J._store || J._store.validated || J.key != null)
          return;
        J._store.validated = !0;
        var X1 = z3(S1);
        if (Pi[X1])
          return;
        Pi[X1] = !0;
        var Ae = "";
        J && J._owner && J._owner !== zt.current && (Ae = " It was passed a child from " + s1(J._owner.type) + "."), Nt(J), K('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', X1, Ae), Nt(null);
      }
    }
    function Yn(J, S1) {
      {
        if (typeof J != "object")
          return;
        if (we(J))
          for (var X1 = 0; X1 < J.length; X1++) {
            var Ae = J[X1];
            j3(Ae) && N3(Ae, S1);
          }
        else if (j3(J))
          J._store && (J._store.validated = !0);
        else if (J) {
          var ot = N(J);
          if (typeof ot == "function" && ot !== J.entries)
            for (var ut = ot.call(J), je; !(je = ut.next()).done; )
              j3(je.value) && N3(je.value, S1);
        }
      }
    }
    function u0(J) {
      {
        var S1 = J.type;
        if (S1 == null || typeof S1 == "string")
          return;
        var X1;
        if (typeof S1 == "function")
          X1 = S1.propTypes;
        else if (typeof S1 == "object" && (S1.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        S1.$$typeof === S))
          X1 = S1.propTypes;
        else
          return;
        if (X1) {
          var Ae = s1(S1);
          St(X1, J.props, "prop", Ae, J);
        } else if (S1.PropTypes !== void 0 && !Wt) {
          Wt = !0;
          var ot = s1(S1);
          K("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ot || "Unknown");
        }
        typeof S1.getDefaultProps == "function" && !S1.getDefaultProps.isReactClassApproved && K("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function V0(J) {
      {
        for (var S1 = Object.keys(J.props), X1 = 0; X1 < S1.length; X1++) {
          var Ae = S1[X1];
          if (Ae !== "children" && Ae !== "key") {
            Nt(J), K("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ae), Nt(null);
            break;
          }
        }
        J.ref !== null && (Nt(J), K("Invalid attribute `ref` supplied to `React.Fragment`."), Nt(null));
      }
    }
    var rn = {};
    function Qr(J, S1, X1, Ae, ot, ut) {
      {
        var je = O1(J);
        if (!je) {
          var et = "";
          (J === void 0 || typeof J == "object" && J !== null && Object.keys(J).length === 0) && (et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Bn = W0();
          Bn ? et += Bn : et += l0();
          var Pt;
          J === null ? Pt = "null" : we(J) ? Pt = "array" : J !== void 0 && J.$$typeof === n ? (Pt = "<" + (s1(J.type) || "Unknown") + " />", et = " Did you accidentally export a JSX literal instead of a component?") : Pt = typeof J, K("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pt, et);
        }
        var Zt = Fn(J, S1, X1, ot, ut);
        if (Zt == null)
          return Zt;
        if (je) {
          var N2 = S1.children;
          if (N2 !== void 0)
            if (Ae)
              if (we(N2)) {
                for (var P3 = 0; P3 < N2.length; P3++)
                  Yn(N2[P3], J);
                Object.freeze && Object.freeze(N2);
              } else
                K("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yn(N2, J);
        }
        if ($e.call(S1, "key")) {
          var vt = s1(J), Qn = Object.keys(S1).filter(function(Gr) {
            return Gr !== "key";
          }), _2 = Qn.length > 0 ? "{key: someKey, " + Qn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!rn[vt + _2]) {
            var rt = Qn.length > 0 ? "{" + Qn.join(": ..., ") + ": ...}" : "{}";
            K(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, _2, vt, rt, vt), rn[vt + _2] = !0;
          }
        }
        return J === a ? V0(Zt) : u0(Zt), Zt;
      }
    }
    function j2(J, S1, X1) {
      return Qr(J, S1, X1, !0);
    }
    function z2(J, S1, X1) {
      return Qr(J, S1, X1, !1);
    }
    var Xr = z2, c0 = j2;
    Xg.Fragment = a, Xg.jsx = Xr, Xg.jsxs = c0;
  }()), Xg;
}
process.env.NODE_ENV === "production" ? W7.exports = rN() : W7.exports = iN();
var y = W7.exports;
let V7;
typeof document == "object" && (V7 = nN({
  key: "css",
  prepend: !0
}));
function jS(e) {
  const {
    injectFirst: n,
    children: i
  } = e;
  return n && V7 ? /* @__PURE__ */ y.jsx(cz, {
    value: V7,
    children: i
  }) : i;
}
process.env.NODE_ENV !== "production" && (jS.propTypes = {
  /**
   * Your component tree.
   */
  children: E.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: E.bool
});
function aN(e) {
  return e == null || Object.keys(e).length === 0;
}
function zS(e) {
  const {
    styles: n,
    defaultTheme: i = {}
  } = e, a = typeof n == "function" ? (s) => n(aN(s) ? i : s) : n;
  return /* @__PURE__ */ y.jsx(gz, {
    styles: a
  });
}
process.env.NODE_ENV !== "production" && (zS.propTypes = {
  defaultTheme: E.object,
  styles: E.oneOfType([E.array, E.string, E.object, E.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function NS(e, n) {
  const i = uz(e, n);
  return process.env.NODE_ENV !== "production" ? (...a) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return a.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : a.some((g) => g === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), i(...a);
  } : i;
}
const oN = (e, n) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = n(e.__emotion_styles));
}, sN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: zS,
  StyledEngineProvider: jS,
  ThemeContext: bS,
  css: fz,
  default: NS,
  internal_processStyles: oN,
  keyframes: UA
}, Symbol.toStringTag, { value: "Module" }));
function Vo(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function PS(e) {
  if (!Vo(e))
    return e;
  const n = {};
  return Object.keys(e).forEach((i) => {
    n[i] = PS(e[i]);
  }), n;
}
function ki(e, n, i = {
  clone: !0
}) {
  const a = i.clone ? m1({}, e) : e;
  return Vo(e) && Vo(n) && Object.keys(n).forEach((s) => {
    Vo(n[s]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, s) && Vo(e[s]) ? a[s] = ki(e[s], n[s], i) : i.clone ? a[s] = Vo(n[s]) ? PS(n[s]) : n[s] : a[s] = n[s];
  }), a;
}
const lN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ki,
  isPlainObject: Vo
}, Symbol.toStringTag, { value: "Module" })), uN = ["values", "unit", "step"], cN = (e) => {
  const n = Object.keys(e).map((i) => ({
    key: i,
    val: e[i]
  })) || [];
  return n.sort((i, a) => i.val - a.val), n.reduce((i, a) => m1({}, i, {
    [a.key]: a.val
  }), {});
};
function FS(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: n = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: i = "px",
    step: a = 5
  } = e, s = Tt(e, uN), g = cN(n), c = Object.keys(g);
  function I(T) {
    return `@media (min-width:${typeof n[T] == "number" ? n[T] : T}${i})`;
  }
  function h(T) {
    return `@media (max-width:${(typeof n[T] == "number" ? n[T] : T) - a / 100}${i})`;
  }
  function m(T, D) {
    const k = c.indexOf(D);
    return `@media (min-width:${typeof n[T] == "number" ? n[T] : T}${i}) and (max-width:${(k !== -1 && typeof n[c[k]] == "number" ? n[c[k]] : D) - a / 100}${i})`;
  }
  function w(T) {
    return c.indexOf(T) + 1 < c.length ? m(T, c[c.indexOf(T) + 1]) : I(T);
  }
  function S(T) {
    const D = c.indexOf(T);
    return D === 0 ? I(c[1]) : D === c.length - 1 ? h(c[D]) : m(T, c[c.indexOf(T) + 1]).replace("@media", "@media not all and");
  }
  return m1({
    keys: c,
    values: g,
    up: I,
    down: h,
    between: m,
    only: w,
    not: S,
    unit: i
  }, s);
}
const gN = {
  borderRadius: 4
}, Zo = process.env.NODE_ENV !== "production" ? E.oneOfType([E.number, E.string, E.object, E.array]) : {};
function uf(e, n) {
  return n ? ki(e, n, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Xh = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Pb = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Xh[e]}px)`
};
function Ta(e, n, i) {
  const a = e.theme || {};
  if (Array.isArray(n)) {
    const g = a.breakpoints || Pb;
    return n.reduce((c, I, h) => (c[g.up(g.keys[h])] = i(n[h]), c), {});
  }
  if (typeof n == "object") {
    const g = a.breakpoints || Pb;
    return Object.keys(n).reduce((c, I) => {
      if (Object.keys(g.values || Xh).indexOf(I) !== -1) {
        const h = g.up(I);
        c[h] = i(n[I], I);
      } else {
        const h = I;
        c[h] = n[h];
      }
      return c;
    }, {});
  }
  return i(n);
}
function fN(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((a, s) => {
    const g = e.up(s);
    return a[g] = {}, a;
  }, {})) || {};
}
function dN(e, n) {
  return e.reduce((i, a) => {
    const s = i[a];
    return (!s || Object.keys(s).length === 0) && delete i[a], i;
  }, n);
}
function or(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Cl(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const CN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: or
}, Symbol.toStringTag, { value: "Module" }));
function JA(e, n, i = !0) {
  if (!n || typeof n != "string")
    return null;
  if (e && e.vars && i) {
    const a = `vars.${n}`.split(".").reduce((s, g) => s && s[g] ? s[g] : null, e);
    if (a != null)
      return a;
  }
  return n.split(".").reduce((a, s) => a && a[s] != null ? a[s] : null, e);
}
function hA(e, n, i, a = i) {
  let s;
  return typeof e == "function" ? s = e(i) : Array.isArray(e) ? s = e[i] || a : s = JA(e, i) || a, n && (s = n(s, a, e)), s;
}
function a2(e) {
  const {
    prop: n,
    cssProperty: i = e.prop,
    themeKey: a,
    transform: s
  } = e, g = (c) => {
    if (c[n] == null)
      return null;
    const I = c[n], h = c.theme, m = JA(h, a) || {};
    return Ta(c, I, (S) => {
      let T = hA(m, s, S);
      return S === T && typeof S == "string" && (T = hA(m, s, `${n}${S === "default" ? "" : or(S)}`, S)), i === !1 ? T : {
        [i]: T
      };
    });
  };
  return g.propTypes = process.env.NODE_ENV !== "production" ? {
    [n]: Zo
  } : {}, g.filterProps = [n], g;
}
function AN(e) {
  const n = {};
  return (i) => (n[i] === void 0 && (n[i] = e(i)), n[i]);
}
const IN = {
  m: "margin",
  p: "padding"
}, pN = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Fb = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, hN = AN((e) => {
  if (e.length > 2)
    if (Fb[e])
      e = Fb[e];
    else
      return [e];
  const [n, i] = e.split(""), a = IN[n], s = pN[i] || "";
  return Array.isArray(s) ? s.map((g) => a + g) : [a + s];
}), KA = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], YA = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], mN = [...KA, ...YA];
function Rf(e, n, i, a) {
  var s;
  const g = (s = JA(e, n, !1)) != null ? s : i;
  return typeof g == "number" ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && typeof c != "number" && console.error(`MUI: Expected ${a} argument to be a number or a string, got ${c}.`), g * c) : Array.isArray(g) ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && (Number.isInteger(c) ? c > g.length - 1 && console.error([`MUI: The value provided (${c}) overflows.`, `The supported values are: ${JSON.stringify(g)}.`, `${c} > ${g.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${n}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${n}\` as a number.`].join(`
`))), g[c]) : typeof g == "function" ? g : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${n}\` value (${g}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function BS(e) {
  return Rf(e, "spacing", 8, "spacing");
}
function Of(e, n) {
  if (typeof n == "string" || n == null)
    return n;
  const i = Math.abs(n), a = e(i);
  return n >= 0 ? a : typeof a == "number" ? -a : `-${a}`;
}
function vN(e, n) {
  return (i) => e.reduce((a, s) => (a[s] = Of(n, i), a), {});
}
function yN(e, n, i, a) {
  if (n.indexOf(i) === -1)
    return null;
  const s = hN(i), g = vN(s, a), c = e[i];
  return Ta(e, c, g);
}
function HS(e, n) {
  const i = BS(e.theme);
  return Object.keys(e).map((a) => yN(e, n, a, i)).reduce(uf, {});
}
function _n(e) {
  return HS(e, KA);
}
_n.propTypes = process.env.NODE_ENV !== "production" ? KA.reduce((e, n) => (e[n] = Zo, e), {}) : {};
_n.filterProps = KA;
function Jn(e) {
  return HS(e, YA);
}
Jn.propTypes = process.env.NODE_ENV !== "production" ? YA.reduce((e, n) => (e[n] = Zo, e), {}) : {};
Jn.filterProps = YA;
process.env.NODE_ENV !== "production" && mN.reduce((e, n) => (e[n] = Zo, e), {});
function bN(e = 8) {
  if (e.mui)
    return e;
  const n = BS({
    spacing: e
  }), i = (...a) => (process.env.NODE_ENV !== "production" && (a.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${a.length}`)), (a.length === 0 ? [1] : a).map((g) => {
    const c = n(g);
    return typeof c == "number" ? `${c}px` : c;
  }).join(" "));
  return i.mui = !0, i;
}
function QA(...e) {
  const n = e.reduce((a, s) => (s.filterProps.forEach((g) => {
    a[g] = s;
  }), a), {}), i = (a) => Object.keys(a).reduce((s, g) => n[g] ? uf(s, n[g](a)) : s, {});
  return i.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((a, s) => Object.assign(a, s.propTypes), {}) : {}, i.filterProps = e.reduce((a, s) => a.concat(s.filterProps), []), i;
}
function r0(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function s0(e, n) {
  return a2({
    prop: e,
    themeKey: "borders",
    transform: n
  });
}
const wN = s0("border", r0), xN = s0("borderTop", r0), SN = s0("borderRight", r0), EN = s0("borderBottom", r0), MN = s0("borderLeft", r0), TN = s0("borderColor"), LN = s0("borderTopColor"), RN = s0("borderRightColor"), ON = s0("borderBottomColor"), DN = s0("borderLeftColor"), kN = s0("outline", r0), jN = s0("outlineColor"), XA = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const n = Rf(e.theme, "shape.borderRadius", 4, "borderRadius"), i = (a) => ({
      borderRadius: Of(n, a)
    });
    return Ta(e, e.borderRadius, i);
  }
  return null;
};
XA.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Zo
} : {};
XA.filterProps = ["borderRadius"];
QA(wN, xN, SN, EN, MN, TN, LN, RN, ON, DN, XA, kN, jN);
const GA = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const n = Rf(e.theme, "spacing", 8, "gap"), i = (a) => ({
      gap: Of(n, a)
    });
    return Ta(e, e.gap, i);
  }
  return null;
};
GA.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Zo
} : {};
GA.filterProps = ["gap"];
const qA = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const n = Rf(e.theme, "spacing", 8, "columnGap"), i = (a) => ({
      columnGap: Of(n, a)
    });
    return Ta(e, e.columnGap, i);
  }
  return null;
};
qA.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Zo
} : {};
qA.filterProps = ["columnGap"];
const ZA = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const n = Rf(e.theme, "spacing", 8, "rowGap"), i = (a) => ({
      rowGap: Of(n, a)
    });
    return Ta(e, e.rowGap, i);
  }
  return null;
};
ZA.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Zo
} : {};
ZA.filterProps = ["rowGap"];
const zN = a2({
  prop: "gridColumn"
}), NN = a2({
  prop: "gridRow"
}), PN = a2({
  prop: "gridAutoFlow"
}), FN = a2({
  prop: "gridAutoColumns"
}), BN = a2({
  prop: "gridAutoRows"
}), HN = a2({
  prop: "gridTemplateColumns"
}), UN = a2({
  prop: "gridTemplateRows"
}), WN = a2({
  prop: "gridTemplateAreas"
}), VN = a2({
  prop: "gridArea"
});
QA(GA, qA, ZA, zN, NN, PN, FN, BN, HN, UN, WN, VN);
function Ec(e, n) {
  return n === "grey" ? n : e;
}
const _N = a2({
  prop: "color",
  themeKey: "palette",
  transform: Ec
}), JN = a2({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ec
}), KN = a2({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ec
});
QA(_N, JN, KN);
function L3(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const YN = a2({
  prop: "width",
  transform: L3
}), Gh = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const n = (i) => {
      var a, s;
      const g = ((a = e.theme) == null || (a = a.breakpoints) == null || (a = a.values) == null ? void 0 : a[i]) || Xh[i];
      return g ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${g}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: g
      } : {
        maxWidth: L3(i)
      };
    };
    return Ta(e, e.maxWidth, n);
  }
  return null;
};
Gh.filterProps = ["maxWidth"];
const QN = a2({
  prop: "minWidth",
  transform: L3
}), XN = a2({
  prop: "height",
  transform: L3
}), GN = a2({
  prop: "maxHeight",
  transform: L3
}), qN = a2({
  prop: "minHeight",
  transform: L3
});
a2({
  prop: "size",
  cssProperty: "width",
  transform: L3
});
a2({
  prop: "size",
  cssProperty: "height",
  transform: L3
});
const ZN = a2({
  prop: "boxSizing"
});
QA(YN, Gh, QN, XN, GN, qN, ZN);
const Df = {
  // borders
  border: {
    themeKey: "borders",
    transform: r0
  },
  borderTop: {
    themeKey: "borders",
    transform: r0
  },
  borderRight: {
    themeKey: "borders",
    transform: r0
  },
  borderBottom: {
    themeKey: "borders",
    transform: r0
  },
  borderLeft: {
    themeKey: "borders",
    transform: r0
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: r0
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: XA
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ec
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ec
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ec
  },
  // spacing
  p: {
    style: Jn
  },
  pt: {
    style: Jn
  },
  pr: {
    style: Jn
  },
  pb: {
    style: Jn
  },
  pl: {
    style: Jn
  },
  px: {
    style: Jn
  },
  py: {
    style: Jn
  },
  padding: {
    style: Jn
  },
  paddingTop: {
    style: Jn
  },
  paddingRight: {
    style: Jn
  },
  paddingBottom: {
    style: Jn
  },
  paddingLeft: {
    style: Jn
  },
  paddingX: {
    style: Jn
  },
  paddingY: {
    style: Jn
  },
  paddingInline: {
    style: Jn
  },
  paddingInlineStart: {
    style: Jn
  },
  paddingInlineEnd: {
    style: Jn
  },
  paddingBlock: {
    style: Jn
  },
  paddingBlockStart: {
    style: Jn
  },
  paddingBlockEnd: {
    style: Jn
  },
  m: {
    style: _n
  },
  mt: {
    style: _n
  },
  mr: {
    style: _n
  },
  mb: {
    style: _n
  },
  ml: {
    style: _n
  },
  mx: {
    style: _n
  },
  my: {
    style: _n
  },
  margin: {
    style: _n
  },
  marginTop: {
    style: _n
  },
  marginRight: {
    style: _n
  },
  marginBottom: {
    style: _n
  },
  marginLeft: {
    style: _n
  },
  marginX: {
    style: _n
  },
  marginY: {
    style: _n
  },
  marginInline: {
    style: _n
  },
  marginInlineStart: {
    style: _n
  },
  marginInlineEnd: {
    style: _n
  },
  marginBlock: {
    style: _n
  },
  marginBlockStart: {
    style: _n
  },
  marginBlockEnd: {
    style: _n
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: GA
  },
  rowGap: {
    style: ZA
  },
  columnGap: {
    style: qA
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: L3
  },
  maxWidth: {
    style: Gh
  },
  minWidth: {
    transform: L3
  },
  height: {
    transform: L3
  },
  maxHeight: {
    transform: L3
  },
  minHeight: {
    transform: L3
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function $N(...e) {
  const n = e.reduce((a, s) => a.concat(Object.keys(s)), []), i = new Set(n);
  return e.every((a) => i.size === Object.keys(a).length);
}
function eP(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function US() {
  function e(i, a, s, g) {
    const c = {
      [i]: a,
      theme: s
    }, I = g[i];
    if (!I)
      return {
        [i]: a
      };
    const {
      cssProperty: h = i,
      themeKey: m,
      transform: w,
      style: S
    } = I;
    if (a == null)
      return null;
    if (m === "typography" && a === "inherit")
      return {
        [i]: a
      };
    const T = JA(s, m) || {};
    return S ? S(c) : Ta(c, a, (k) => {
      let z = hA(T, w, k);
      return k === z && typeof k == "string" && (z = hA(T, w, `${i}${k === "default" ? "" : or(k)}`, k)), h === !1 ? z : {
        [h]: z
      };
    });
  }
  function n(i) {
    var a;
    const {
      sx: s,
      theme: g = {}
    } = i || {};
    if (!s)
      return null;
    const c = (a = g.unstable_sxConfig) != null ? a : Df;
    function I(h) {
      let m = h;
      if (typeof h == "function")
        m = h(g);
      else if (typeof h != "object")
        return h;
      if (!m)
        return null;
      const w = fN(g.breakpoints), S = Object.keys(w);
      let T = w;
      return Object.keys(m).forEach((D) => {
        const k = eP(m[D], g);
        if (k != null)
          if (typeof k == "object")
            if (c[D])
              T = uf(T, e(D, k, g, c));
            else {
              const z = Ta({
                theme: g
              }, k, (N) => ({
                [D]: N
              }));
              $N(z, k) ? T[D] = n({
                sx: k,
                theme: g
              }) : T = uf(T, z);
            }
          else
            T = uf(T, e(D, k, g, c));
      }), dN(S, T);
    }
    return Array.isArray(s) ? s.map(I) : I(s);
  }
  return n;
}
const kf = US();
kf.filterProps = ["sx"];
function WS(e, n) {
  const i = this;
  return i.vars && typeof i.getColorSchemeSelector == "function" ? {
    [i.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: n
  } : i.palette.mode === e ? n : {};
}
const tP = ["breakpoints", "palette", "spacing", "shape"];
function qh(e = {}, ...n) {
  const {
    breakpoints: i = {},
    palette: a = {},
    spacing: s,
    shape: g = {}
  } = e, c = Tt(e, tP), I = FS(i), h = bN(s);
  let m = ki({
    breakpoints: I,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: m1({
      mode: "light"
    }, a),
    spacing: h,
    shape: m1({}, gN, g)
  }, c);
  return m.applyStyles = WS, m = n.reduce((w, S) => ki(w, S), m), m.unstable_sxConfig = m1({}, Df, c == null ? void 0 : c.unstable_sxConfig), m.unstable_sx = function(S) {
    return kf({
      sx: S,
      theme: this
    });
  }, m;
}
const nP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qh,
  private_createBreakpoints: FS,
  unstable_applyStyles: WS
}, Symbol.toStringTag, { value: "Module" }));
function rP(e) {
  return Object.keys(e).length === 0;
}
function VS(e = null) {
  const n = n1.useContext(bS);
  return !n || rP(n) ? e : n;
}
const iP = qh();
function _S(e = iP) {
  return VS(e);
}
const aP = ["sx"], oP = (e) => {
  var n, i;
  const a = {
    systemProps: {},
    otherProps: {}
  }, s = (n = e == null || (i = e.theme) == null ? void 0 : i.unstable_sxConfig) != null ? n : Df;
  return Object.keys(e).forEach((g) => {
    s[g] ? a.systemProps[g] = e[g] : a.otherProps[g] = e[g];
  }), a;
};
function Zh(e) {
  const {
    sx: n
  } = e, i = Tt(e, aP), {
    systemProps: a,
    otherProps: s
  } = oP(i);
  let g;
  return Array.isArray(n) ? g = [a, ...n] : typeof n == "function" ? g = (...c) => {
    const I = n(...c);
    return Vo(I) ? m1({}, a, I) : a;
  } : g = m1({}, a, n), m1({}, s, {
    sx: g
  });
}
const sP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kf,
  extendSxProp: Zh,
  unstable_createStyleFunctionSx: US,
  unstable_defaultSxConfig: Df
}, Symbol.toStringTag, { value: "Module" })), Bb = (e) => e, lP = () => {
  let e = Bb;
  return {
    configure(n) {
      e = n;
    },
    generate(n) {
      return e(n);
    },
    reset() {
      e = Bb;
    }
  };
}, JS = lP();
function KS(e) {
  var n, i, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (n = 0; n < s; n++) e[n] && (i = KS(e[n])) && (a && (a += " "), a += i);
  } else for (i in e) e[i] && (a && (a += " "), a += i);
  return a;
}
function Xt() {
  for (var e, n, i = 0, a = "", s = arguments.length; i < s; i++) (e = arguments[i]) && (n = KS(e)) && (a && (a += " "), a += n);
  return a;
}
const uP = ["className", "component"];
function cP(e = {}) {
  const {
    themeId: n,
    defaultTheme: i,
    defaultClassName: a = "MuiBox-root",
    generateClassName: s
  } = e, g = NS("div", {
    shouldForwardProp: (I) => I !== "theme" && I !== "sx" && I !== "as"
  })(kf);
  return /* @__PURE__ */ n1.forwardRef(function(h, m) {
    const w = _S(i), S = Zh(h), {
      className: T,
      component: D = "div"
    } = S, k = Tt(S, uP);
    return /* @__PURE__ */ y.jsx(g, m1({
      as: D,
      ref: m,
      className: Xt(T, s ? s(a) : a),
      theme: n && w[n] || w
    }, k));
  });
}
const gP = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function sr(e, n, i = "Mui") {
  const a = gP[n];
  return a ? `${i}-${a}` : `${JS.generate(e)}-${n}`;
}
function m2(e, n, i = "Mui") {
  const a = {};
  return n.forEach((s) => {
    a[s] = sr(e, s, i);
  }), a;
}
const fP = m2("MuiBox", ["root"]), YS = cP({
  defaultClassName: fP.root,
  generateClassName: JS.generate
});
process.env.NODE_ENV !== "production" && (YS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: E.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
var _7 = { exports: {} }, Yt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hb;
function dP() {
  if (Hb) return Yt;
  Hb = 1;
  var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), c = Symbol.for("react.context"), I = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), k;
  k = Symbol.for("react.module.reference");
  function z(N) {
    if (typeof N == "object" && N !== null) {
      var W = N.$$typeof;
      switch (W) {
        case e:
          switch (N = N.type, N) {
            case i:
            case s:
            case a:
            case m:
            case w:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case I:
                case c:
                case h:
                case T:
                case S:
                case g:
                  return N;
                default:
                  return W;
              }
          }
        case n:
          return W;
      }
    }
  }
  return Yt.ContextConsumer = c, Yt.ContextProvider = g, Yt.Element = e, Yt.ForwardRef = h, Yt.Fragment = i, Yt.Lazy = T, Yt.Memo = S, Yt.Portal = n, Yt.Profiler = s, Yt.StrictMode = a, Yt.Suspense = m, Yt.SuspenseList = w, Yt.isAsyncMode = function() {
    return !1;
  }, Yt.isConcurrentMode = function() {
    return !1;
  }, Yt.isContextConsumer = function(N) {
    return z(N) === c;
  }, Yt.isContextProvider = function(N) {
    return z(N) === g;
  }, Yt.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === e;
  }, Yt.isForwardRef = function(N) {
    return z(N) === h;
  }, Yt.isFragment = function(N) {
    return z(N) === i;
  }, Yt.isLazy = function(N) {
    return z(N) === T;
  }, Yt.isMemo = function(N) {
    return z(N) === S;
  }, Yt.isPortal = function(N) {
    return z(N) === n;
  }, Yt.isProfiler = function(N) {
    return z(N) === s;
  }, Yt.isStrictMode = function(N) {
    return z(N) === a;
  }, Yt.isSuspense = function(N) {
    return z(N) === m;
  }, Yt.isSuspenseList = function(N) {
    return z(N) === w;
  }, Yt.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === i || N === s || N === a || N === m || N === w || N === D || typeof N == "object" && N !== null && (N.$$typeof === T || N.$$typeof === S || N.$$typeof === g || N.$$typeof === c || N.$$typeof === h || N.$$typeof === k || N.getModuleId !== void 0);
  }, Yt.typeOf = z, Yt;
}
var Qt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ub;
function CP() {
  return Ub || (Ub = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), c = Symbol.for("react.context"), I = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), k = !1, z = !1, N = !1, W = !1, K = !1, V;
    V = Symbol.for("react.module.reference");
    function Y(b1) {
      return !!(typeof b1 == "string" || typeof b1 == "function" || b1 === i || b1 === s || K || b1 === a || b1 === m || b1 === w || W || b1 === D || k || z || N || typeof b1 == "object" && b1 !== null && (b1.$$typeof === T || b1.$$typeof === S || b1.$$typeof === g || b1.$$typeof === c || b1.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b1.$$typeof === V || b1.getModuleId !== void 0));
    }
    function H(b1) {
      if (typeof b1 == "object" && b1 !== null) {
        var Pe = b1.$$typeof;
        switch (Pe) {
          case e:
            var $e = b1.type;
            switch ($e) {
              case i:
              case s:
              case a:
              case m:
              case w:
                return $e;
              default:
                var W1 = $e && $e.$$typeof;
                switch (W1) {
                  case I:
                  case c:
                  case h:
                  case T:
                  case S:
                  case g:
                    return W1;
                  default:
                    return Pe;
                }
            }
          case n:
            return Pe;
        }
      }
    }
    var Z = c, Q = g, P1 = e, Y1 = h, O1 = i, T1 = T, J1 = S, s1 = n, d1 = s, h1 = a, C1 = m, L1 = w, f1 = !1, B1 = !1;
    function t1(b1) {
      return f1 || (f1 = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function y1(b1) {
      return B1 || (B1 = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function k1(b1) {
      return H(b1) === c;
    }
    function se(b1) {
      return H(b1) === g;
    }
    function K1(b1) {
      return typeof b1 == "object" && b1 !== null && b1.$$typeof === e;
    }
    function le(b1) {
      return H(b1) === h;
    }
    function G1(b1) {
      return H(b1) === i;
    }
    function $1(b1) {
      return H(b1) === T;
    }
    function V1(b1) {
      return H(b1) === S;
    }
    function z1(b1) {
      return H(b1) === n;
    }
    function ae(b1) {
      return H(b1) === s;
    }
    function We(b1) {
      return H(b1) === a;
    }
    function D1(b1) {
      return H(b1) === m;
    }
    function ue(b1) {
      return H(b1) === w;
    }
    Qt.ContextConsumer = Z, Qt.ContextProvider = Q, Qt.Element = P1, Qt.ForwardRef = Y1, Qt.Fragment = O1, Qt.Lazy = T1, Qt.Memo = J1, Qt.Portal = s1, Qt.Profiler = d1, Qt.StrictMode = h1, Qt.Suspense = C1, Qt.SuspenseList = L1, Qt.isAsyncMode = t1, Qt.isConcurrentMode = y1, Qt.isContextConsumer = k1, Qt.isContextProvider = se, Qt.isElement = K1, Qt.isForwardRef = le, Qt.isFragment = G1, Qt.isLazy = $1, Qt.isMemo = V1, Qt.isPortal = z1, Qt.isProfiler = ae, Qt.isStrictMode = We, Qt.isSuspense = D1, Qt.isSuspenseList = ue, Qt.isValidElementType = Y, Qt.typeOf = H;
  }()), Qt;
}
process.env.NODE_ENV === "production" ? _7.exports = dP() : _7.exports = CP();
var mA = _7.exports;
const AP = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function QS(e) {
  const n = `${e}`.match(AP);
  return n && n[1] || "";
}
function XS(e, n = "") {
  return e.displayName || e.name || QS(e) || n;
}
function Wb(e, n, i) {
  const a = XS(n);
  return e.displayName || (a !== "" ? `${i}(${a})` : i);
}
function IP(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return XS(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case mA.ForwardRef:
          return Wb(e, e.render, "ForwardRef");
        case mA.Memo:
          return Wb(e, e.type, "memo");
        default:
          return;
      }
  }
}
const pP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IP,
  getFunctionName: QS
}, Symbol.toStringTag, { value: "Module" }));
function vA(e, n) {
  const i = m1({}, n);
  return Object.keys(e).forEach((a) => {
    if (a.toString().match(/^(components|slots)$/))
      i[a] = m1({}, e[a], i[a]);
    else if (a.toString().match(/^(componentsProps|slotProps)$/)) {
      const s = e[a] || {}, g = n[a];
      i[a] = {}, !g || !Object.keys(g) ? i[a] = s : !s || !Object.keys(s) ? i[a] = g : (i[a] = m1({}, g), Object.keys(s).forEach((c) => {
        i[a][c] = vA(s[c], g[c]);
      }));
    } else i[a] === void 0 && (i[a] = e[a]);
  }), i;
}
function hP(e) {
  const {
    theme: n,
    name: i,
    props: a
  } = e;
  return !n || !n.components || !n.components[i] || !n.components[i].defaultProps ? a : vA(n.components[i].defaultProps, a);
}
const Lc = typeof window < "u" ? n1.useLayoutEffect : n1.useEffect;
function mP(e, n, i, a, s) {
  const [g, c] = n1.useState(() => s && i ? i(e).matches : a ? a(e).matches : n);
  return Lc(() => {
    let I = !0;
    if (!i)
      return;
    const h = i(e), m = () => {
      I && c(h.matches);
    };
    return m(), h.addListener(m), () => {
      I = !1, h.removeListener(m);
    };
  }, [e, i]), g;
}
const GS = n1.useSyncExternalStore;
function vP(e, n, i, a, s) {
  const g = n1.useCallback(() => n, [n]), c = n1.useMemo(() => {
    if (s && i)
      return () => i(e).matches;
    if (a !== null) {
      const {
        matches: w
      } = a(e);
      return () => w;
    }
    return g;
  }, [g, e, a, s, i]), [I, h] = n1.useMemo(() => {
    if (i === null)
      return [g, () => () => {
      }];
    const w = i(e);
    return [() => w.matches, (S) => (w.addListener(S), () => {
      w.removeListener(S);
    })];
  }, [g, i, e]);
  return GS(h, I, c);
}
function Vb(e, n = {}) {
  const i = VS(), a = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: s = !1,
    matchMedia: g = a ? window.matchMedia : null,
    ssrMatchMedia: c = null,
    noSsr: I = !1
  } = hP({
    name: "MuiUseMediaQuery",
    props: n,
    theme: i
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let h = typeof e == "function" ? e(i) : e;
  h = h.replace(/^@media( ?)/m, "");
  const w = (GS !== void 0 ? vP : mP)(h, s, g, c, I);
  return process.env.NODE_ENV !== "production" && n1.useDebugValue({
    query: h,
    match: w
  }), w;
}
function qS(e, n = Number.MIN_SAFE_INTEGER, i = Number.MAX_SAFE_INTEGER) {
  return Math.max(n, Math.min(e, i));
}
const yP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qS
}, Symbol.toStringTag, { value: "Module" }));
function bP(e, n = 0, i = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > i) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${i}].`), qS(e, n, i);
}
function wP(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(n);
  return i && i[0].length === 1 && (i = i.map((a) => a + a)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((a, s) => s < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function ZS(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return ZS(wP(e));
  const n = e.indexOf("("), i = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Cl(9, e));
  let a = e.substring(n + 1, e.length - 1), s;
  if (i === "color") {
    if (a = a.split(" "), s = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Cl(10, s));
  } else
    a = a.split(",");
  return a = a.map((g) => parseFloat(g)), {
    type: i,
    values: a,
    colorSpace: s
  };
}
function xP(e) {
  const {
    type: n,
    colorSpace: i
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((s, g) => g < 3 ? parseInt(s, 10) : s) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${i} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function SP(e, n) {
  return e = ZS(e), n = bP(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, xP(e);
}
function Fc(e, n) {
  return process.env.NODE_ENV === "production" ? () => null : function(...a) {
    return e(...a) || n(...a);
  };
}
function EP(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function $S(e, n, i, a, s) {
  const g = e[n], c = s || n;
  if (g == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let I;
  const h = g.type;
  return typeof h == "function" && !EP(h) && (I = "Did you accidentally use a plain function component for an element instead?"), I !== void 0 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an element that can hold a ref. ${I} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const jf = Fc(E.element, $S);
jf.isRequired = Fc(E.element.isRequired, $S);
function MP(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function TP(e, n, i, a, s) {
  const g = e[n], c = s || n;
  if (g == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let I;
  return typeof g == "function" && !MP(g) && (I = "Did you accidentally provide a plain function component instead?"), I !== void 0 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an element type that can hold a ref. ${I} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const eE = Fc(E.elementType, TP), LP = "exact-prop: ​";
function tE(e) {
  return process.env.NODE_ENV === "production" ? e : m1({}, e, {
    [LP]: (n) => {
      const i = Object.keys(n).filter((a) => !e.hasOwnProperty(a));
      return i.length > 0 ? new Error(`The following props are not supported: ${i.map((a) => `\`${a}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function mf(e, n, i, a, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const g = e[n], c = s || n;
  return g == null ? null : g && g.nodeType !== 1 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an HTMLElement.`) : null;
}
const nE = E.oneOfType([E.func, E.object]);
function _b(...e) {
  return e.reduce((n, i) => i == null ? n : function(...s) {
    n.apply(this, s), i.apply(this, s);
  }, () => {
  });
}
function RP(e, n = 166) {
  let i;
  function a(...s) {
    const g = () => {
      e.apply(this, s);
    };
    clearTimeout(i), i = setTimeout(g, n);
  }
  return a.clear = () => {
    clearTimeout(i);
  }, a;
}
function a0(e) {
  return e && e.ownerDocument || document;
}
function vf(e) {
  return a0(e).defaultView || window;
}
function J7(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
function vc(e) {
  const n = n1.useRef(e);
  return Lc(() => {
    n.current = e;
  }), n1.useRef((...i) => (
    // @ts-expect-error hide `this`
    (0, n.current)(...i)
  )).current;
}
function U0(...e) {
  return n1.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    e.forEach((i) => {
      J7(i, n);
    });
  }, e);
}
const Jb = {};
function OP(e, n) {
  const i = n1.useRef(Jb);
  return i.current === Jb && (i.current = e(n)), i;
}
const DP = [];
function kP(e) {
  n1.useEffect(e, DP);
}
class $A {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new $A();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(n, i) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, i();
    }, n);
  }
}
function rE() {
  const e = OP($A.create).current;
  return kP(e.disposeEffect), e;
}
let e6 = !0, K7 = !1;
const jP = new $A(), zP = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function NP(e) {
  const {
    type: n,
    tagName: i
  } = e;
  return !!(i === "INPUT" && zP[n] && !e.readOnly || i === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function PP(e) {
  e.metaKey || e.altKey || e.ctrlKey || (e6 = !0);
}
function Xp() {
  e6 = !1;
}
function FP() {
  this.visibilityState === "hidden" && K7 && (e6 = !0);
}
function BP(e) {
  e.addEventListener("keydown", PP, !0), e.addEventListener("mousedown", Xp, !0), e.addEventListener("pointerdown", Xp, !0), e.addEventListener("touchstart", Xp, !0), e.addEventListener("visibilitychange", FP, !0);
}
function HP(e) {
  const {
    target: n
  } = e;
  try {
    return n.matches(":focus-visible");
  } catch {
  }
  return e6 || NP(n);
}
function UP() {
  const e = n1.useCallback((s) => {
    s != null && BP(s.ownerDocument);
  }, []), n = n1.useRef(!1);
  function i() {
    return n.current ? (K7 = !0, jP.start(100, () => {
      K7 = !1;
    }), n.current = !1, !0) : !1;
  }
  function a(s) {
    return HP(s) ? (n.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: n,
    onFocus: a,
    onBlur: i,
    ref: e
  };
}
function iE(e) {
  const n = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - n);
}
function WP(e) {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return n;
  }
}
function VP(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const _P = Number.isInteger || VP;
function aE(e, n, i, a) {
  const s = e[n];
  if (s == null || !_P(s)) {
    const g = WP(s);
    return new RangeError(`Invalid ${a} \`${n}\` of type \`${g}\` supplied to \`${i}\`, expected \`integer\`.`);
  }
  return null;
}
function oE(e, n, ...i) {
  return e[n] === void 0 ? null : aE(e, n, ...i);
}
function Y7() {
  return null;
}
oE.isRequired = aE;
Y7.isRequired = Y7;
const sE = process.env.NODE_ENV === "production" ? Y7 : oE;
function Yr(e, n, i = void 0) {
  const a = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      a[s] = e[s].reduce((g, c) => {
        if (c) {
          const I = n(c);
          I !== "" && g.push(I), i && i[c] && g.push(i[c]);
        }
        return g;
      }, []).join(" ");
    }
  ), a;
}
function lE(e) {
  return typeof e == "string";
}
function JP(e, n, i) {
  return e === void 0 || lE(e) ? n : m1({}, n, {
    ownerState: m1({}, n.ownerState, i)
  });
}
function uE(e, n = []) {
  if (e === void 0)
    return {};
  const i = {};
  return Object.keys(e).filter((a) => a.match(/^on[A-Z]/) && typeof e[a] == "function" && !n.includes(a)).forEach((a) => {
    i[a] = e[a];
  }), i;
}
function Kb(e) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((i) => !(i.match(/^on[A-Z]/) && typeof e[i] == "function")).forEach((i) => {
    n[i] = e[i];
  }), n;
}
function KP(e) {
  const {
    getSlotProps: n,
    additionalProps: i,
    externalSlotProps: a,
    externalForwardedProps: s,
    className: g
  } = e;
  if (!n) {
    const D = Xt(i == null ? void 0 : i.className, g, s == null ? void 0 : s.className, a == null ? void 0 : a.className), k = m1({}, i == null ? void 0 : i.style, s == null ? void 0 : s.style, a == null ? void 0 : a.style), z = m1({}, i, s, a);
    return D.length > 0 && (z.className = D), Object.keys(k).length > 0 && (z.style = k), {
      props: z,
      internalRef: void 0
    };
  }
  const c = uE(m1({}, s, a)), I = Kb(a), h = Kb(s), m = n(c), w = Xt(m == null ? void 0 : m.className, i == null ? void 0 : i.className, g, s == null ? void 0 : s.className, a == null ? void 0 : a.className), S = m1({}, m == null ? void 0 : m.style, i == null ? void 0 : i.style, s == null ? void 0 : s.style, a == null ? void 0 : a.style), T = m1({}, m, i, h, I);
  return w.length > 0 && (T.className = w), Object.keys(S).length > 0 && (T.style = S), {
    props: T,
    internalRef: m.ref
  };
}
function YP(e, n, i) {
  return typeof e == "function" ? e(n, i) : e;
}
const QP = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Rc(e) {
  var n;
  const {
    elementType: i,
    externalSlotProps: a,
    ownerState: s,
    skipResolvingSlotProps: g = !1
  } = e, c = Tt(e, QP), I = g ? {} : YP(a, s), {
    props: h,
    internalRef: m
  } = KP(m1({}, c, {
    externalSlotProps: I
  })), w = U0(m, I == null ? void 0 : I.ref, (n = e.additionalProps) == null ? void 0 : n.ref);
  return JP(i, m1({}, h, {
    ref: w
  }), s);
}
const XP = /* @__PURE__ */ n1.createContext();
process.env.NODE_ENV !== "production" && (E.node, E.bool);
const GP = () => {
  const e = n1.useContext(XP);
  return e ?? !1;
}, qP = /* @__PURE__ */ n1.createContext(void 0);
process.env.NODE_ENV !== "production" && (E.node, E.object);
function ZP(e) {
  const {
    theme: n,
    name: i,
    props: a
  } = e;
  if (!n || !n.components || !n.components[i])
    return a;
  const s = n.components[i];
  return s.defaultProps ? vA(s.defaultProps, a) : !s.styleOverrides && !s.variants ? vA(s, a) : a;
}
function $P({
  props: e,
  name: n
}) {
  const i = n1.useContext(qP);
  return ZP({
    props: e,
    name: n,
    theme: {
      components: i
    }
  });
}
function La(e) {
  "@babel/helpers - typeof";
  return La = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, La(e);
}
function eF(e, n) {
  if (La(e) != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(e, n || "default");
    if (La(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function cE(e) {
  var n = eF(e, "string");
  return La(n) == "symbol" ? n : n + "";
}
function tF(e, n) {
  return m1({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
var o2 = {}, gE = { exports: {} };
(function(e) {
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gE);
var fE = gE.exports;
const nF = /* @__PURE__ */ qo(hz), rF = /* @__PURE__ */ qo(yP);
var dE = fE;
Object.defineProperty(o2, "__esModule", {
  value: !0
});
var i0 = o2.alpha = mE;
o2.blend = dF;
o2.colorChannel = void 0;
var CE = o2.darken = em;
o2.decomposeColor = o0;
o2.emphasize = vE;
var Yb = o2.getContrastRatio = lF;
o2.getLuminance = yA;
o2.hexToRgb = IE;
o2.hslToRgb = hE;
var AE = o2.lighten = tm;
o2.private_safeAlpha = uF;
o2.private_safeColorChannel = void 0;
o2.private_safeDarken = cF;
o2.private_safeEmphasize = fF;
o2.private_safeLighten = gF;
o2.recomposeColor = Bc;
o2.rgbToHex = sF;
var Qb = dE(nF), iF = dE(rF);
function $h(e, n = 0, i = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > i) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${i}].`), (0, iF.default)(e, n, i);
}
function IE(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(n);
  return i && i[0].length === 1 && (i = i.map((a) => a + a)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((a, s) => s < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function aF(e) {
  const n = e.toString(16);
  return n.length === 1 ? `0${n}` : n;
}
function o0(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return o0(IE(e));
  const n = e.indexOf("("), i = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, Qb.default)(9, e));
  let a = e.substring(n + 1, e.length - 1), s;
  if (i === "color") {
    if (a = a.split(" "), s = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, Qb.default)(10, s));
  } else
    a = a.split(",");
  return a = a.map((g) => parseFloat(g)), {
    type: i,
    values: a,
    colorSpace: s
  };
}
const pE = (e) => {
  const n = o0(e);
  return n.values.slice(0, 3).map((i, a) => n.type.indexOf("hsl") !== -1 && a !== 0 ? `${i}%` : i).join(" ");
};
o2.colorChannel = pE;
const oF = (e, n) => {
  try {
    return pE(e);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
};
o2.private_safeColorChannel = oF;
function Bc(e) {
  const {
    type: n,
    colorSpace: i
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((s, g) => g < 3 ? parseInt(s, 10) : s) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${i} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function sF(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: n
  } = o0(e);
  return `#${n.map((i, a) => aF(a === 3 ? Math.round(255 * i) : i)).join("")}`;
}
function hE(e) {
  e = o0(e);
  const {
    values: n
  } = e, i = n[0], a = n[1] / 100, s = n[2] / 100, g = a * Math.min(s, 1 - s), c = (m, w = (m + i / 30) % 12) => s - g * Math.max(Math.min(w - 3, 9 - w, 1), -1);
  let I = "rgb";
  const h = [Math.round(c(0) * 255), Math.round(c(8) * 255), Math.round(c(4) * 255)];
  return e.type === "hsla" && (I += "a", h.push(n[3])), Bc({
    type: I,
    values: h
  });
}
function yA(e) {
  e = o0(e);
  let n = e.type === "hsl" || e.type === "hsla" ? o0(hE(e)).values : e.values;
  return n = n.map((i) => (e.type !== "color" && (i /= 255), i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4)), Number((0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2]).toFixed(3));
}
function lF(e, n) {
  const i = yA(e), a = yA(n);
  return (Math.max(i, a) + 0.05) / (Math.min(i, a) + 0.05);
}
function mE(e, n) {
  return e = o0(e), n = $h(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, Bc(e);
}
function uF(e, n, i) {
  try {
    return mE(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function em(e, n) {
  if (e = o0(e), n = $h(n), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - n;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - n;
  return Bc(e);
}
function cF(e, n, i) {
  try {
    return em(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function tm(e, n) {
  if (e = o0(e), n = $h(n), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * n;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * n;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * n;
  return Bc(e);
}
function gF(e, n, i) {
  try {
    return tm(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function vE(e, n = 0.15) {
  return yA(e) > 0.5 ? em(e, n) : tm(e, n);
}
function fF(e, n, i) {
  try {
    return vE(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function dF(e, n, i, a = 1) {
  const s = (h, m) => Math.round((h ** (1 / a) * (1 - i) + m ** (1 / a) * i) ** a), g = o0(e), c = o0(n), I = [s(g.values[0], c.values[0]), s(g.values[1], c.values[1]), s(g.values[2], c.values[2])];
  return Bc({
    type: "rgb",
    values: I
  });
}
const yf = {
  black: "#000",
  white: "#fff"
}, CF = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, gc = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, fc = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Gg = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, dc = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Cc = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Ac = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, AF = ["mode", "contrastThreshold", "tonalOffset"], Xb = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: yf.white,
    default: yf.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Gp = {
  text: {
    primary: yf.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: yf.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Gb(e, n, i, a) {
  const s = a.light || a, g = a.dark || a * 1.5;
  e[n] || (e.hasOwnProperty(i) ? e[n] = e[i] : n === "light" ? e.light = AE(e.main, s) : n === "dark" && (e.dark = CE(e.main, g)));
}
function IF(e = "light") {
  return e === "dark" ? {
    main: dc[200],
    light: dc[50],
    dark: dc[400]
  } : {
    main: dc[700],
    light: dc[400],
    dark: dc[800]
  };
}
function pF(e = "light") {
  return e === "dark" ? {
    main: gc[200],
    light: gc[50],
    dark: gc[400]
  } : {
    main: gc[500],
    light: gc[300],
    dark: gc[700]
  };
}
function hF(e = "light") {
  return e === "dark" ? {
    main: fc[500],
    light: fc[300],
    dark: fc[700]
  } : {
    main: fc[700],
    light: fc[400],
    dark: fc[800]
  };
}
function mF(e = "light") {
  return e === "dark" ? {
    main: Cc[400],
    light: Cc[300],
    dark: Cc[700]
  } : {
    main: Cc[700],
    light: Cc[500],
    dark: Cc[900]
  };
}
function vF(e = "light") {
  return e === "dark" ? {
    main: Ac[400],
    light: Ac[300],
    dark: Ac[700]
  } : {
    main: Ac[800],
    light: Ac[500],
    dark: Ac[900]
  };
}
function yF(e = "light") {
  return e === "dark" ? {
    main: Gg[400],
    light: Gg[300],
    dark: Gg[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Gg[500],
    dark: Gg[900]
  };
}
function bF(e) {
  const {
    mode: n = "light",
    contrastThreshold: i = 3,
    tonalOffset: a = 0.2
  } = e, s = Tt(e, AF), g = e.primary || IF(n), c = e.secondary || pF(n), I = e.error || hF(n), h = e.info || mF(n), m = e.success || vF(n), w = e.warning || yF(n);
  function S(z) {
    const N = Yb(z, Gp.text.primary) >= i ? Gp.text.primary : Xb.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const W = Yb(z, N);
      W < 3 && console.error([`MUI: The contrast ratio of ${W}:1 for ${N} on ${z}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return N;
  }
  const T = ({
    color: z,
    name: N,
    mainShade: W = 500,
    lightShade: K = 300,
    darkShade: V = 700
  }) => {
    if (z = m1({}, z), !z.main && z[W] && (z.main = z[W]), !z.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${N ? ` (${N})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${W}\` property.` : Cl(11, N ? ` (${N})` : "", W));
    if (typeof z.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${N ? ` (${N})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(z.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Cl(12, N ? ` (${N})` : "", JSON.stringify(z.main)));
    return Gb(z, "light", K, a), Gb(z, "dark", V, a), z.contrastText || (z.contrastText = S(z.main)), z;
  }, D = {
    dark: Gp,
    light: Xb
  };
  return process.env.NODE_ENV !== "production" && (D[n] || console.error(`MUI: The palette mode \`${n}\` is not supported.`)), ki(m1({
    // A collection of common colors.
    common: m1({}, yf),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: n,
    // The colors used to represent primary interface elements for a user.
    primary: T({
      color: g,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: T({
      color: c,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: T({
      color: I,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: T({
      color: w,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: T({
      color: h,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: T({
      color: m,
      name: "success"
    }),
    // The grey colors.
    grey: CF,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: i,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: S,
    // Generate a rich color object.
    augmentColor: T,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: a
  }, D[n]), s);
}
const wF = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function xF(e) {
  return Math.round(e * 1e5) / 1e5;
}
const qb = {
  textTransform: "uppercase"
}, Zb = '"Roboto", "Helvetica", "Arial", sans-serif';
function SF(e, n) {
  const i = typeof n == "function" ? n(e) : n, {
    fontFamily: a = Zb,
    // The default font size of the Material Specification.
    fontSize: s = 14,
    // px
    fontWeightLight: g = 300,
    fontWeightRegular: c = 400,
    fontWeightMedium: I = 500,
    fontWeightBold: h = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: m = 16,
    // Apply the CSS properties to all the variants.
    allVariants: w,
    pxToRem: S
  } = i, T = Tt(i, wF);
  process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof m != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const D = s / 14, k = S || ((W) => `${W / m * D}rem`), z = (W, K, V, Y, H) => m1({
    fontFamily: a,
    fontWeight: W,
    fontSize: k(K),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: V
  }, a === Zb ? {
    letterSpacing: `${xF(Y / K)}em`
  } : {}, H, w), N = {
    h1: z(g, 96, 1.167, -1.5),
    h2: z(g, 60, 1.2, -0.5),
    h3: z(c, 48, 1.167, 0),
    h4: z(c, 34, 1.235, 0.25),
    h5: z(c, 24, 1.334, 0),
    h6: z(I, 20, 1.6, 0.15),
    subtitle1: z(c, 16, 1.75, 0.15),
    subtitle2: z(I, 14, 1.57, 0.1),
    body1: z(c, 16, 1.5, 0.15),
    body2: z(c, 14, 1.43, 0.15),
    button: z(I, 14, 1.75, 0.4, qb),
    caption: z(c, 12, 1.66, 0.4),
    overline: z(c, 12, 2.66, 1, qb),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ki(m1({
    htmlFontSize: m,
    pxToRem: k,
    fontFamily: a,
    fontSize: s,
    fontWeightLight: g,
    fontWeightRegular: c,
    fontWeightMedium: I,
    fontWeightBold: h
  }, N), T, {
    clone: !1
    // No need to clone deep
  });
}
const EF = 0.2, MF = 0.14, TF = 0.12;
function Tn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${EF})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${MF})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${TF})`].join(",");
}
const LF = ["none", Tn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Tn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Tn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Tn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Tn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Tn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Tn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Tn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Tn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Tn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Tn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Tn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Tn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Tn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Tn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Tn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Tn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Tn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Tn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Tn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Tn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Tn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Tn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Tn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], RF = ["duration", "easing", "delay"], OF = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, DF = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function $b(e) {
  return `${Math.round(e)}ms`;
}
function kF(e) {
  if (!e)
    return 0;
  const n = e / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function jF(e) {
  const n = m1({}, OF, e.easing), i = m1({}, DF, e.duration);
  return m1({
    getAutoHeightDuration: kF,
    create: (s = ["all"], g = {}) => {
      const {
        duration: c = i.standard,
        easing: I = n.easeInOut,
        delay: h = 0
      } = g, m = Tt(g, RF);
      if (process.env.NODE_ENV !== "production") {
        const w = (T) => typeof T == "string", S = (T) => !isNaN(parseFloat(T));
        !w(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !S(c) && !w(c) && console.error(`MUI: Argument "duration" must be a number or a string but found ${c}.`), w(I) || console.error('MUI: Argument "easing" must be a string.'), !S(h) && !w(h) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof g != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(m).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(m).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((w) => `${w} ${typeof c == "string" ? c : $b(c)} ${I} ${typeof h == "string" ? h : $b(h)}`).join(",");
    }
  }, e, {
    easing: n,
    duration: i
  });
}
const zF = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, NF = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Q7(e = {}, ...n) {
  const {
    mixins: i = {},
    palette: a = {},
    transitions: s = {},
    typography: g = {}
  } = e, c = Tt(e, NF);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Cl(18));
  const I = bF(a), h = qh(e);
  let m = ki(h, {
    mixins: tF(h.breakpoints, i),
    palette: I,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: LF.slice(),
    typography: SF(I, g),
    transitions: jF(s),
    zIndex: m1({}, zF)
  });
  if (m = ki(m, c), m = n.reduce((w, S) => ki(w, S), m), process.env.NODE_ENV !== "production") {
    const w = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], S = (T, D) => {
      let k;
      for (k in T) {
        const z = T[k];
        if (w.indexOf(k) !== -1 && Object.keys(z).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const N = sr("", k);
            console.error([`MUI: The \`${D}\` component increases the CSS specificity of the \`${k}\` internal state.`, "You can not override it like this: ", JSON.stringify(T, null, 2), "", `Instead, you need to use the '&.${N}' syntax:`, JSON.stringify({
              root: {
                [`&.${N}`]: z
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          T[k] = {};
        }
      }
    };
    Object.keys(m.components).forEach((T) => {
      const D = m.components[T].styleOverrides;
      D && T.indexOf("Mui") === 0 && S(D, T);
    });
  }
  return m.unstable_sxConfig = m1({}, Df, c == null ? void 0 : c.unstable_sxConfig), m.unstable_sx = function(S) {
    return kf({
      sx: S,
      theme: this
    });
  }, m;
}
const yE = Q7();
function t6() {
  const e = _S(yE);
  return process.env.NODE_ENV !== "production" && n1.useDebugValue(e), e[xS] || e;
}
var zf = {}, qp = { exports: {} }, ew;
function PF() {
  return ew || (ew = 1, function(e) {
    function n() {
      return e.exports = n = Object.assign ? Object.assign.bind() : function(i) {
        for (var a = 1; a < arguments.length; a++) {
          var s = arguments[a];
          for (var g in s) ({}).hasOwnProperty.call(s, g) && (i[g] = s[g]);
        }
        return i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(null, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(qp)), qp.exports;
}
var Zp = { exports: {} }, tw;
function FF() {
  return tw || (tw = 1, function(e) {
    function n(i, a) {
      if (i == null) return {};
      var s = {};
      for (var g in i) if ({}.hasOwnProperty.call(i, g)) {
        if (a.includes(g)) continue;
        s[g] = i[g];
      }
      return s;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Zp)), Zp.exports;
}
const BF = /* @__PURE__ */ qo(sN), HF = /* @__PURE__ */ qo(lN), UF = /* @__PURE__ */ qo(CN), WF = /* @__PURE__ */ qo(pP), VF = /* @__PURE__ */ qo(nP), _F = /* @__PURE__ */ qo(sP);
var Hc = fE;
Object.defineProperty(zf, "__esModule", {
  value: !0
});
var JF = zf.default = aB;
zf.shouldForwardProp = sA;
zf.systemDefaultTheme = void 0;
var t0 = Hc(PF()), X7 = Hc(FF()), nw = eB(BF), KF = HF, YF = Hc(UF), QF = Hc(WF), XF = Hc(VF), GF = Hc(_F);
const qF = ["ownerState"], ZF = ["variants"], $F = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function bE(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (bE = function(a) {
    return a ? i : n;
  })(e);
}
function eB(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var i = bE(n);
  if (i && i.has(e)) return i.get(e);
  var a = { __proto__: null }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e) if (g !== "default" && Object.prototype.hasOwnProperty.call(e, g)) {
    var c = s ? Object.getOwnPropertyDescriptor(e, g) : null;
    c && (c.get || c.set) ? Object.defineProperty(a, g, c) : a[g] = e[g];
  }
  return a.default = e, i && i.set(e, a), a;
}
function tB(e) {
  return Object.keys(e).length === 0;
}
function nB(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function sA(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const rB = zf.systemDefaultTheme = (0, XF.default)(), rw = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function FC({
  defaultTheme: e,
  theme: n,
  themeId: i
}) {
  return tB(n) ? e : n[i] || n;
}
function iB(e) {
  return e ? (n, i) => i[e] : null;
}
function lA(e, n) {
  let {
    ownerState: i
  } = n, a = (0, X7.default)(n, qF);
  const s = typeof e == "function" ? e((0, t0.default)({
    ownerState: i
  }, a)) : e;
  if (Array.isArray(s))
    return s.flatMap((g) => lA(g, (0, t0.default)({
      ownerState: i
    }, a)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: g = []
    } = s;
    let I = (0, X7.default)(s, ZF);
    return g.forEach((h) => {
      let m = !0;
      typeof h.props == "function" ? m = h.props((0, t0.default)({
        ownerState: i
      }, a, i)) : Object.keys(h.props).forEach((w) => {
        (i == null ? void 0 : i[w]) !== h.props[w] && a[w] !== h.props[w] && (m = !1);
      }), m && (Array.isArray(I) || (I = [I]), I.push(typeof h.style == "function" ? h.style((0, t0.default)({
        ownerState: i
      }, a, i)) : h.style));
    }), I;
  }
  return s;
}
function aB(e = {}) {
  const {
    themeId: n,
    defaultTheme: i = rB,
    rootShouldForwardProp: a = sA,
    slotShouldForwardProp: s = sA
  } = e, g = (c) => (0, GF.default)((0, t0.default)({}, c, {
    theme: FC((0, t0.default)({}, c, {
      defaultTheme: i,
      themeId: n
    }))
  }));
  return g.__mui_systemSx = !0, (c, I = {}) => {
    (0, nw.internal_processStyles)(c, (H) => H.filter((Z) => !(Z != null && Z.__mui_systemSx)));
    const {
      name: h,
      slot: m,
      skipVariantsResolver: w,
      skipSx: S,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: T = iB(rw(m))
    } = I, D = (0, X7.default)(I, $F), k = w !== void 0 ? w : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), z = S || !1;
    let N;
    process.env.NODE_ENV !== "production" && h && (N = `${h}-${rw(m || "Root")}`);
    let W = sA;
    m === "Root" || m === "root" ? W = a : m ? W = s : nB(c) && (W = void 0);
    const K = (0, nw.default)(c, (0, t0.default)({
      shouldForwardProp: W,
      label: N
    }, D)), V = (H) => typeof H == "function" && H.__emotion_real !== H || (0, KF.isPlainObject)(H) ? (Z) => lA(H, (0, t0.default)({}, Z, {
      theme: FC({
        theme: Z.theme,
        defaultTheme: i,
        themeId: n
      })
    })) : H, Y = (H, ...Z) => {
      let Q = V(H);
      const P1 = Z ? Z.map(V) : [];
      h && T && P1.push((T1) => {
        const J1 = FC((0, t0.default)({}, T1, {
          defaultTheme: i,
          themeId: n
        }));
        if (!J1.components || !J1.components[h] || !J1.components[h].styleOverrides)
          return null;
        const s1 = J1.components[h].styleOverrides, d1 = {};
        return Object.entries(s1).forEach(([h1, C1]) => {
          d1[h1] = lA(C1, (0, t0.default)({}, T1, {
            theme: J1
          }));
        }), T(T1, d1);
      }), h && !k && P1.push((T1) => {
        var J1;
        const s1 = FC((0, t0.default)({}, T1, {
          defaultTheme: i,
          themeId: n
        })), d1 = s1 == null || (J1 = s1.components) == null || (J1 = J1[h]) == null ? void 0 : J1.variants;
        return lA({
          variants: d1
        }, (0, t0.default)({}, T1, {
          theme: s1
        }));
      }), z || P1.push(g);
      const Y1 = P1.length - Z.length;
      if (Array.isArray(H) && Y1 > 0) {
        const T1 = new Array(Y1).fill("");
        Q = [...H, ...T1], Q.raw = [...H.raw, ...T1];
      }
      const O1 = K(Q, ...P1);
      if (process.env.NODE_ENV !== "production") {
        let T1;
        h && (T1 = `${h}${(0, YF.default)(m || "")}`), T1 === void 0 && (T1 = `Styled(${(0, QF.default)(c)})`), O1.displayName = T1;
      }
      return c.muiName && (O1.muiName = c.muiName), O1;
    };
    return K.withConfig && (Y.withConfig = K.withConfig), Y;
  };
}
function oB(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const nm = (e) => oB(e) && e !== "classes", Rn = JF({
  themeId: xS,
  defaultTheme: yE,
  rootShouldForwardProp: nm
}), iw = (e) => {
  let n;
  return e < 1 ? n = 5.11916 * e ** 2 : n = 4.5 * Math.log(e + 1) + 2, (n / 100).toFixed(2);
}, sB = (e) => ({
  logo: e.assets.logo,
  logoExpanded: e.assets.logo_expanded,
  logoSplash: e.assets.logo_splash,
  loginHero: e.assets.login_hero,
  loginHeroMobile: e.assets.login_hero_mobile
}), lB = "#1565c0", uB = "#434566", cB = "#0061a0", gB = "#434566", fB = "#ea15a4", dB = "#ffffff", CB = "#ffffff", AB = "#ffffff", IB = (e) => ({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&:before": {
            content: "unset"
          },
          ".MuiAccordionSummary-root": {
            "&:hover": { background: e.palette.common.neutrals[50] }
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: 0,
          borderBottom: `solid 1px ${e.palette.common.neutrals[200]}`
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          alignItems: "start",
          margin: "0",
          rowGap: "8px",
          // Center align only for checkbox and switch controls (small controls)
          "&:has(.MuiCheckbox-root), &:has(.MuiSwitch-root)": {
            alignItems: "center"
          }
        },
        label: {
          fontSize: "1rem",
          color: e.palette.common.neutrals[800],
          fontWeight: e.typography.fontWeightRegular,
          lineHeight: "1.5rem",
          "&.Mui-disabled": {
            color: e.palette.common.neutrals[300],
            fontSize: ".938rem"
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: e.palette.common.error[500],
            fontSize: "0.8rem"
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            lineHeight: "1rem"
          },
          "& .MuiInputLabel-shrink": {
            top: "2px"
          }
        },
        input: {
          "&.MuiAutocomplete-input": {
            paddingLeft: 2.5,
            paddingBottom: 2.5,
            paddingTop: 2.5
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.MuiOutlinedInput-input": {
            padding: "11.5px 12px",
            color: e.palette.common.neutrals[800],
            borderRadius: e.shape.borderRadius
          }
        },
        root: {
          borderRadius: e.shape.borderRadius,
          fontWeight: 400,
          "&.Mui-error": {
            backgroundColor: e.palette.common.error[100],
            color: e.palette.common.error[100]
          },
          "&.Mui-error fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.error[600]
          },
          "&.Mui-disabled": {
            cursor: "not-allowed",
            backgroundColor: e.palette.common.neutrals[100],
            "& .MuiInputBase-input": {
              cursor: "not-allowed"
            }
          },
          "&.Mui-disabled fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.neutrals[300]
          },
          "&.Mui-disabled:hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.neutrals[300]
          },
          "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.primary[500],
            borderWidth: "1px"
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: e.palette.common.neutrals[200]
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: e.shape.borderRadius
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme: n }) => n.unstable_sx({
          // https://mui.com/system/getting-started/the-sx-prop/#spacing
          px: 1,
          py: 0.25,
          // https://mui.com/system/borders/#border-radius
          borderRadius: 1
          // 4px as default.
        })
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: ({}) => ({}),
        paper: ({ theme: n }) => ({
          minWidth: "240px",
          backgroundColor: n.palette.common.tertiary[500],
          color: n.palette.common.white,
          "html.native-android &": {
            boxSizing: "border-box",
            paddingTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
            paddingBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
            "&.MuiDrawer-paperAnchorBottom": { paddingTop: 0 },
            "&.MuiDrawer-paperAnchorTop": { paddingBottom: 0 }
          }
        })
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          "html.native-android &.MuiDialog-paperFullScreen": {
            boxSizing: "border-box",
            paddingTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
            paddingBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          height: "100%",
          alignItems: "center"
        },
        root: ({ theme: n }) => ({
          minHeight: 48,
          height: 48,
          [n.breakpoints.up("sm")]: {
            minHeight: 72,
            height: 72,
            "& .MuiTabs-flexContainer": {
              gap: "24px"
            }
          }
        }),
        indicator: ({ theme: n }) => ({
          backgroundColor: n.palette.text.primary,
          height: 2
        })
      }
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(14),
          fontWeight: 500,
          lineHeight: 1.5,
          padding: "0 16px",
          minHeight: 48,
          textTransform: "none",
          "&.Mui-selected": {
            color: n.palette.text.primary
          },
          [n.breakpoints.up("sm")]: {
            fontSize: n.typography.pxToRem(16),
            minHeight: 72
          }
        })
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: () => ({
          svg: {
            width: 20,
            height: 20
          },
          "&.Mui-selected": {
            svg: {
              fill: "#b3e7f0"
            },
            color: "#008ba3"
          }
        }),
        label: () => ({
          paddingTop: "4px",
          fontSize: "14px",
          lineHeight: "17.6px",
          "&.Mui-selected": {
            fontSize: "14px"
          }
        })
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          backgroundColor: n.palette.background.default,
          color: "#353c42",
          fontWeight: 400,
          boxShadow: n.shadows[0],
          borderBottom: "solid 1px #e0e1e2",
          paddingBottom: "2px",
          "& .MuiTypography-h2": {
            fontSize: "17px",
            fontWeight: "400",
            lineHeight: "22px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
          }
        }),
        colorSecondary: ({ theme: n }) => ({
          backgroundColor: n.palette.grey[50]
        })
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: !1,
        disableElevation: !0
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          lineHeight: 1.9,
          borderRadius: e.shape.borderRadius,
          textTransform: "none"
        },
        startIcon: ({ theme: n }) => ({
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        endIcon: ({ theme: n }) => ({
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        iconSizeSmall: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(12),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(12)
          }
        }),
        iconSizeMedium: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(14),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        iconSizeLarge: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(16),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(16)
          }
        }),
        sizeSmall: {
          fontSize: 12
        },
        sizeMedium: {
          fontSize: 15
        },
        sizeLarge: {
          fontSize: 18
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        elevation: 3
      },
      styleOverrides: {
        paper: {
          borderRadius: e.shape.borderRadius
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: "12px 20px 12px 25px",
          borderRadius: e.shape.borderRadius,
          [`& .${lS.body1}`]: {
            fontSize: "14px"
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "40px",
          fontSize: "15px"
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          opacity: 1,
          background: e.palette.common.neutrals[200],
          transform: "scaleY(1.8) scaleX(1.4)"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          // Static link color; Blue800 keeps normal text at 4.5:1 or more on light backgrounds
          color: lB
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiSvgIcon-root": {
            fontSize: n.typography.pxToRem(16)
          }
        })
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          fontSize: "1.125rem"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiSvgIcon-root": {
            fontSize: n.typography.pxToRem(16)
          }
        }),
        sizeSmall: {
          "& > *:first-of-type": { fontSize: 12 }
        },
        sizeMedium: {
          "& > *:first-of-type": { fontSize: 16 }
        },
        sizeLarge: {
          "& > *:first-of-type": { fontSize: 18 }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiTableCell-head": {
            textTransform: "uppercase",
            fontWeight: 600,
            letterSpacing: "0.06rem",
            color: n.palette.text.secondary,
            "& .MuiSvgIcon-root": {
              verticalAlign: "middle"
            }
          }
        })
      }
    }
  }
}), yc = {
  50: "#FFF0EE",
  100: "#FFDAD6",
  200: "#FFB4AB",
  300: "#FF897D",
  400: "#FF5449",
  500: "#DE3730",
  600: "#BA1A1A",
  700: "#93000A",
  800: "#690005",
  900: "#410002",
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}, BC = {
  50: "#E6FCE8",
  100: "#B4F5BA",
  200: "#83EE8E",
  300: "#51E760",
  400: "#1FE032",
  500: "#1ABA2A",
  600: "#18AE27",
  700: "#117C1C",
  800: "#0A5D12",
  900: "#031905",
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}, pB = bj.orange, B0 = {
  50: "#FFFFFF",
  100: "#F2F2F2",
  200: "#DBDBDB",
  300: "#A8A6A6",
  400: "#BABABA",
  500: "#8A939A",
  600: "#7D7D7D",
  700: "#4D4D4F",
  800: "#262626",
  900: "#121212",
  A100: "#dfe3e8",
  A200: "#eef0f1",
  A400: "",
  A700: ""
};
function pe(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Oc(e, n) {
  return Oc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, a) {
    return i.__proto__ = a, i;
  }, Oc(e, n);
}
function rm(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Oc(e, n);
}
function bf(e) {
  return bf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, bf(e);
}
function hB(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function im() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (im = function() {
    return !!e;
  })();
}
function mB(e, n, i) {
  if (im()) return Reflect.construct.apply(null, arguments);
  var a = [null];
  a.push.apply(a, n);
  var s = new (e.bind.apply(e, a))();
  return i && Oc(s, i.prototype), s;
}
function G7(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return G7 = function(a) {
    if (a === null || !hB(a)) return a;
    if (typeof a != "function") throw new TypeError("Super expression must either be null or a function");
    if (n !== void 0) {
      if (n.has(a)) return n.get(a);
      n.set(a, s);
    }
    function s() {
      return mB(a, arguments, bf(this).constructor);
    }
    return s.prototype = Object.create(a.prototype, {
      constructor: {
        value: s,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Oc(s, a);
  }, G7(e);
}
var vB = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function yB() {
  for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
    n[i] = arguments[i];
  var a = n[0], s = [], g;
  for (g = 1; g < n.length; g += 1)
    s.push(n[g]);
  return s.forEach(function(c) {
    a = a.replace(/%[a-z]/, c);
  }), a;
}
var Mi = /* @__PURE__ */ function(e) {
  rm(n, e);
  function n(i) {
    var a;
    if (process.env.NODE_ENV === "production")
      a = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + i + " for more information.") || this;
    else {
      for (var s = arguments.length, g = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        g[c - 1] = arguments[c];
      a = e.call(this, yB.apply(void 0, [vB[i]].concat(g))) || this;
    }
    return pe(a);
  }
  return n;
}(/* @__PURE__ */ G7(Error));
function $p(e) {
  return Math.round(e * 255);
}
function bB(e, n, i) {
  return $p(e) + "," + $p(n) + "," + $p(i);
}
function wf(e, n, i, a) {
  if (a === void 0 && (a = bB), n === 0)
    return a(i, i, i);
  var s = (e % 360 + 360) % 360 / 60, g = (1 - Math.abs(2 * i - 1)) * n, c = g * (1 - Math.abs(s % 2 - 1)), I = 0, h = 0, m = 0;
  s >= 0 && s < 1 ? (I = g, h = c) : s >= 1 && s < 2 ? (I = c, h = g) : s >= 2 && s < 3 ? (h = g, m = c) : s >= 3 && s < 4 ? (h = c, m = g) : s >= 4 && s < 5 ? (I = c, m = g) : s >= 5 && s < 6 && (I = g, m = c);
  var w = i - g / 2, S = I + w, T = h + w, D = m + w;
  return a(S, T, D);
}
var aw = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function wB(e) {
  if (typeof e != "string") return e;
  var n = e.toLowerCase();
  return aw[n] ? "#" + aw[n] : e;
}
var xB = /^#[a-fA-F0-9]{6}$/, SB = /^#[a-fA-F0-9]{8}$/, EB = /^#[a-fA-F0-9]{3}$/, MB = /^#[a-fA-F0-9]{4}$/, e7 = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, TB = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, LB = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, RB = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function Dc(e) {
  if (typeof e != "string")
    throw new Mi(3);
  var n = wB(e);
  if (n.match(xB))
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16)
    };
  if (n.match(SB)) {
    var i = parseFloat((parseInt("" + n[7] + n[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16),
      alpha: i
    };
  }
  if (n.match(EB))
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16)
    };
  if (n.match(MB)) {
    var a = parseFloat((parseInt("" + n[4] + n[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16),
      alpha: a
    };
  }
  var s = e7.exec(n);
  if (s)
    return {
      red: parseInt("" + s[1], 10),
      green: parseInt("" + s[2], 10),
      blue: parseInt("" + s[3], 10)
    };
  var g = TB.exec(n.substring(0, 50));
  if (g)
    return {
      red: parseInt("" + g[1], 10),
      green: parseInt("" + g[2], 10),
      blue: parseInt("" + g[3], 10),
      alpha: parseFloat("" + g[4]) > 1 ? parseFloat("" + g[4]) / 100 : parseFloat("" + g[4])
    };
  var c = LB.exec(n);
  if (c) {
    var I = parseInt("" + c[1], 10), h = parseInt("" + c[2], 10) / 100, m = parseInt("" + c[3], 10) / 100, w = "rgb(" + wf(I, h, m) + ")", S = e7.exec(w);
    if (!S)
      throw new Mi(4, n, w);
    return {
      red: parseInt("" + S[1], 10),
      green: parseInt("" + S[2], 10),
      blue: parseInt("" + S[3], 10)
    };
  }
  var T = RB.exec(n.substring(0, 50));
  if (T) {
    var D = parseInt("" + T[1], 10), k = parseInt("" + T[2], 10) / 100, z = parseInt("" + T[3], 10) / 100, N = "rgb(" + wf(D, k, z) + ")", W = e7.exec(N);
    if (!W)
      throw new Mi(4, n, N);
    return {
      red: parseInt("" + W[1], 10),
      green: parseInt("" + W[2], 10),
      blue: parseInt("" + W[3], 10),
      alpha: parseFloat("" + T[4]) > 1 ? parseFloat("" + T[4]) / 100 : parseFloat("" + T[4])
    };
  }
  throw new Mi(5);
}
function OB(e) {
  var n = e.red / 255, i = e.green / 255, a = e.blue / 255, s = Math.max(n, i, a), g = Math.min(n, i, a), c = (s + g) / 2;
  if (s === g)
    return e.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: c,
      alpha: e.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: c
    };
  var I, h = s - g, m = c > 0.5 ? h / (2 - s - g) : h / (s + g);
  switch (s) {
    case n:
      I = (i - a) / h + (i < a ? 6 : 0);
      break;
    case i:
      I = (a - n) / h + 2;
      break;
    default:
      I = (n - i) / h + 4;
      break;
  }
  return I *= 60, e.alpha !== void 0 ? {
    hue: I,
    saturation: m,
    lightness: c,
    alpha: e.alpha
  } : {
    hue: I,
    saturation: m,
    lightness: c
  };
}
function $o(e) {
  return OB(Dc(e));
}
var DB = function(n) {
  return n.length === 7 && n[1] === n[2] && n[3] === n[4] && n[5] === n[6] ? "#" + n[1] + n[3] + n[5] : n;
}, q7 = DB;
function il(e) {
  var n = e.toString(16);
  return n.length === 1 ? "0" + n : n;
}
function t7(e) {
  return il(Math.round(e * 255));
}
function kB(e, n, i) {
  return q7("#" + t7(e) + t7(n) + t7(i));
}
function bA(e, n, i) {
  return wf(e, n, i, kB);
}
function jB(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return bA(e, n, i);
  if (typeof e == "object" && n === void 0 && i === void 0)
    return bA(e.hue, e.saturation, e.lightness);
  throw new Mi(1);
}
function zB(e, n, i, a) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof a == "number")
    return a >= 1 ? bA(e, n, i) : "rgba(" + wf(e, n, i) + "," + a + ")";
  if (typeof e == "object" && n === void 0 && i === void 0 && a === void 0)
    return e.alpha >= 1 ? bA(e.hue, e.saturation, e.lightness) : "rgba(" + wf(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
  throw new Mi(2);
}
function Z7(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return q7("#" + il(e) + il(n) + il(i));
  if (typeof e == "object" && n === void 0 && i === void 0)
    return q7("#" + il(e.red) + il(e.green) + il(e.blue));
  throw new Mi(6);
}
function n6(e, n, i, a) {
  if (typeof e == "string" && typeof n == "number") {
    var s = Dc(e);
    return "rgba(" + s.red + "," + s.green + "," + s.blue + "," + n + ")";
  } else {
    if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof a == "number")
      return a >= 1 ? Z7(e, n, i) : "rgba(" + e + "," + n + "," + i + "," + a + ")";
    if (typeof e == "object" && n === void 0 && i === void 0 && a === void 0)
      return e.alpha >= 1 ? Z7(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new Mi(7);
}
var NB = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, PB = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && typeof n.alpha == "number";
}, FB = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, BB = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && typeof n.alpha == "number";
};
function es(e) {
  if (typeof e != "object") throw new Mi(8);
  if (PB(e)) return n6(e);
  if (NB(e)) return Z7(e);
  if (BB(e)) return zB(e);
  if (FB(e)) return jB(e);
  throw new Mi(8);
}
function wE(e, n, i) {
  return function() {
    var s = i.concat(Array.prototype.slice.call(arguments));
    return s.length >= n ? e.apply(this, s) : wE(e, n, s);
  };
}
function D3(e) {
  return wE(e, e.length, []);
}
function HB(e, n) {
  if (n === "transparent") return n;
  var i = $o(n);
  return es(m1({}, i, {
    hue: i.hue + parseFloat(e)
  }));
}
D3(HB);
function Uc(e, n, i) {
  return Math.max(e, Math.min(n, i));
}
function UB(e, n) {
  if (n === "transparent") return n;
  var i = $o(n);
  return es(m1({}, i, {
    lightness: Uc(0, 1, i.lightness - parseFloat(e))
  }));
}
var WB = D3(UB), vi = WB;
function VB(e, n) {
  if (n === "transparent") return n;
  var i = $o(n);
  return es(m1({}, i, {
    saturation: Uc(0, 1, i.saturation - parseFloat(e))
  }));
}
D3(VB);
function _B(e, n) {
  if (n === "transparent") return n;
  var i = $o(n);
  return es(m1({}, i, {
    lightness: Uc(0, 1, i.lightness + parseFloat(e))
  }));
}
D3(_B);
function JB(e, n, i) {
  if (n === "transparent") return i;
  if (i === "transparent") return n;
  if (e === 0) return i;
  var a = Dc(n), s = m1({}, a, {
    alpha: typeof a.alpha == "number" ? a.alpha : 1
  }), g = Dc(i), c = m1({}, g, {
    alpha: typeof g.alpha == "number" ? g.alpha : 1
  }), I = s.alpha - c.alpha, h = parseFloat(e) * 2 - 1, m = h * I === -1 ? h : h + I, w = 1 + h * I, S = (m / w + 1) / 2, T = 1 - S, D = {
    red: Math.floor(s.red * S + c.red * T),
    green: Math.floor(s.green * S + c.green * T),
    blue: Math.floor(s.blue * S + c.blue * T),
    alpha: s.alpha * parseFloat(e) + c.alpha * (1 - parseFloat(e))
  };
  return n6(D);
}
var KB = D3(JB), xE = KB;
function YB(e, n) {
  if (n === "transparent") return n;
  var i = Dc(n), a = typeof i.alpha == "number" ? i.alpha : 1, s = m1({}, i, {
    alpha: Uc(0, 1, (a * 100 + parseFloat(e) * 100) / 100)
  });
  return n6(s);
}
D3(YB);
function QB(e, n) {
  if (n === "transparent") return n;
  var i = $o(n);
  return es(m1({}, i, {
    saturation: Uc(0, 1, i.saturation + parseFloat(e))
  }));
}
D3(QB);
function XB(e, n) {
  return n === "transparent" ? n : es(m1({}, $o(n), {
    hue: parseFloat(e)
  }));
}
D3(XB);
function GB(e, n) {
  return n === "transparent" ? n : es(m1({}, $o(n), {
    lightness: parseFloat(e)
  }));
}
D3(GB);
function qB(e, n) {
  return n === "transparent" ? n : es(m1({}, $o(n), {
    saturation: parseFloat(e)
  }));
}
D3(qB);
function ZB(e, n) {
  return n === "transparent" ? n : xE(parseFloat(e), "rgb(0, 0, 0)", n);
}
D3(ZB);
function $B(e, n) {
  return n === "transparent" ? n : xE(parseFloat(e), "rgb(255, 255, 255)", n);
}
D3($B);
function eH(e, n) {
  if (n === "transparent") return n;
  var i = Dc(n), a = typeof i.alpha == "number" ? i.alpha : 1, s = m1({}, i, {
    alpha: Uc(0, 1, +(a * 100 - parseFloat(e) * 100).toFixed(2) / 100)
  });
  return n6(s);
}
D3(eH);
const yi = {
  50: -0.55,
  100: -0.45,
  200: -0.35,
  300: -0.25,
  400: 0.05,
  500: 0,
  600: 0.05,
  700: 0.15,
  800: 0.25,
  900: 0.35
}, HC = (e) => ({
  50: vi(yi[50], e),
  100: vi(yi[100], e),
  200: vi(yi[200], e),
  300: vi(yi[300], e),
  400: vi(yi[400], e),
  500: vi(yi[500], e),
  600: vi(yi[600], e),
  700: vi(yi[700], e),
  800: vi(yi[800], e),
  900: vi(yi[900], e),
  // NOTE: These accent shades are supposedly not being used. It may
  // behoove us to eventually add them in, though for completeness
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}), tH = (e) => {
  const n = HC(e.color_palette.primary), i = HC(e.color_palette.secondary), a = HC(e.color_palette.tertiary), s = HC(e.color_palette.accent);
  return {
    mode: "light",
    primary: {
      main: n[500],
      dark: n[700],
      light: n[300],
      contrastText: e.color_palette.primary_contrast
    },
    secondary: {
      main: i[500],
      dark: i[700],
      light: i[300],
      contrastText: e.color_palette.secondary_contrast
    },
    error: {
      main: yc[500],
      dark: yc[700],
      light: yc[300],
      contrastText: B0[50]
    },
    // NOTE: For warning we fall back to MUI default settings which is an orange variant rather than yellow which is not a11y
    success: {
      main: BC[500],
      dark: BC[700],
      light: BC[300],
      contrastText: B0[50]
    },
    text: {
      primary: B0[800],
      secondary: B0[500],
      disabled: B0[400]
    },
    common: {
      /**
       * Configurable Theme colors
       */
      primary: n,
      primaryContrast: e.color_palette.primary_contrast,
      secondary: i,
      secondaryContrast: e.color_palette.secondary_contrast,
      tertiary: a,
      tertiaryContrast: e.color_palette.tertiary_contrast,
      accent: s,
      /**
       * Non-configurable theme colors
       */
      black: B0[800],
      white: B0[50],
      error: yc,
      success: BC,
      /**
       * @deprecated We need a more a11y warning color. Use mui orange defaults for now
       */
      warning: pB,
      neutrals: B0,
      /**
       * @deprecated Theme colors. DO NOT USE THESE!
       */
      cyan: n,
      blueGray: B0,
      red: {},
      sky: "",
      gray: {},
      figmaBlueGray: {},
      /** Refactor-aligned dark text color */
      darkText: "#212b36"
    },
    background: {
      default: B0[50],
      paper: B0[50]
    }
  };
}, nH = (e) => {
  var n, i, a, s, g;
  return {
    primary: ((n = e.common) == null ? void 0 : n.primary[500]) || "",
    tertiary: ((i = e.common) == null ? void 0 : i.tertiary[500]) || "",
    onTertiary: ((a = e.common) == null ? void 0 : a.neutrals[50]) || "",
    onBackground: ((s = e.common) == null ? void 0 : s.neutrals[800]) || "",
    onErrorContainer: yc[600],
    errorContainer: yc[100],
    secondaryContainer: "#E5F5FF",
    onSecondaryContainer: ((g = e.common) == null ? void 0 : g.neutrals[800]) || "",
    // Deprecated
    dark: "#232438",
    medium: "#434566"
  };
}, rH = "data:image/webp;base64,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", iH = "data:image/webp;base64,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", e0 = {
  color_palette: {
    primary: uB,
    primary_contrast: dB,
    secondary: cB,
    secondary_contrast: CB,
    tertiary: gB,
    tertiary_contrast: AB,
    accent: fB
  },
  assets: {
    logo: bb,
    logo_expanded: bb,
    logo_splash: pz,
    login_hero: rH,
    login_hero_mobile: iH
  }
}, aH = (e) => {
  var n, i, a, s, g, c, I, h, m, w, S, T;
  return {
    color_palette: {
      primary: ((n = e == null ? void 0 : e.color_palette) == null ? void 0 : n.primary) || e0.color_palette.primary,
      primary_contrast: ((i = e == null ? void 0 : e.color_palette) == null ? void 0 : i.primary_contrast) || e0.color_palette.primary_contrast,
      secondary: ((a = e == null ? void 0 : e.color_palette) == null ? void 0 : a.secondary) || e0.color_palette.secondary,
      secondary_contrast: ((s = e == null ? void 0 : e.color_palette) == null ? void 0 : s.secondary_contrast) || e0.color_palette.secondary_contrast,
      tertiary: ((g = e == null ? void 0 : e.color_palette) == null ? void 0 : g.tertiary) || e0.color_palette.tertiary,
      tertiary_contrast: ((c = e == null ? void 0 : e.color_palette) == null ? void 0 : c.tertiary_contrast) || e0.color_palette.tertiary_contrast,
      accent: ((I = e == null ? void 0 : e.color_palette) == null ? void 0 : I.accent) || e0.color_palette.accent
    },
    assets: {
      logo: ((h = e == null ? void 0 : e.assets) == null ? void 0 : h.logo) || e0.assets.logo,
      logo_expanded: ((m = e == null ? void 0 : e.assets) == null ? void 0 : m.logo_expanded) || e0.assets.logo_expanded,
      logo_splash: ((w = e == null ? void 0 : e.assets) == null ? void 0 : w.logo_splash) || e0.assets.logo_splash,
      login_hero: ((S = e == null ? void 0 : e.assets) == null ? void 0 : S.login_hero) || e0.assets.login_hero,
      login_hero_mobile: ((T = e == null ? void 0 : e.assets) == null ? void 0 : T.login_hero_mobile) || e0.assets.login_hero_mobile
    }
  };
}, SE = (e) => ({
  typography: {
    h1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      color: e.palette.common.neutrals[800],
      fontWeight: 600,
      lineHeight: "110%",
      fontSize: "2rem",
      [e.breakpoints.up("md")]: {
        fontSize: "2.5rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "2.25rem"
      },
      padding: "14px 24px"
    },
    h2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.75rem",
      fontWeight: 500,
      lineHeight: "130%",
      [e.breakpoints.up("md")]: {
        fontSize: "2rem"
      }
    },
    h3: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.5rem",
      fontWeight: 400,
      lineHeight: "130%",
      [e.breakpoints.up("md")]: {
        fontSize: "1.75rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "1.625rem"
      }
    },
    h4: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Bold', Sans-serif",
    },
    h5: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Bold', Sans-serif",
    },
    h6: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".938rem",
      fontWeight: 600,
      lineHeight: "110%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    },
    subtitle1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.188rem",
      fontWeight: 500,
      lineHeight: "150%"
    },
    subtitle2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    },
    body1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".938rem",
      fontWeight: 400,
      lineHeight: "150%",
      [e.breakpoints.up("md")]: {
        fontSize: ".938rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: ".938rem"
      }
    },
    body2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".875rem",
      fontWeight: 700,
      lineHeight: "150%",
      [e.breakpoints.up("md")]: {
        fontSize: ".875rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: ".875rem"
      }
    },
    label: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "160%",
      [e.breakpoints.up("md")]: {
        fontSize: "1.125rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "1.313rem",
        lineHeight: "120%"
      }
    },
    caption: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "0.8rem",
      fontWeight: 500,
      lineHeight: "150%"
    },
    overline: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    }
  }
}), oH = (e) => ({
  zIndex: {
    ...e.zIndex,
    slidingViews: 1e3
  }
}), G11 = (e) => {
  const n = aH(e), i = tH(n), a = sB(n), s = Q7({
    spacing: 8,
    shape: { borderRadius: 2 },
    palette: i,
    assets: a,
    /**
     * @deprecated Please use colors directly from palette.common instead
     */
    brandColors: nH(i)
  });
  return [SE, IB, oH].concat(
    (e == null ? void 0 : e.extensions) ?? []
  ).reduce(
    (I, h) => Q7(I, h(I)),
    s
  );
}, r6 = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  state: s = {}
}) => {
  const g = sz((e == null ? void 0 : e.toString()) || ""), c = n ?? (e ? !!g : void 0), I = V2(() => {
    if (e) return Wh;
    if (i) return "a";
  }, [e, i]);
  return {
    to: e,
    selected: c,
    component: I,
    href: i,
    target: a,
    ...e ? { state: s } : {}
  };
};
function k2({
  to: e,
  state: n,
  href: i,
  target: a,
  children: s,
  ...g
}) {
  const c = r6({ to: e, state: n, href: i, target: a });
  return /* @__PURE__ */ y.jsx(Dr, { ...c, ...g, children: s });
}
k2.displayName = "Button";
const q11 = ({ fallback: e, ...n }) => {
  var s;
  const a = ((s = yS().state) == null ? void 0 : s.goBackUrl) || e;
  return /* @__PURE__ */ y.jsx(k2, { ...n, to: a });
}, Z11 = ({ children: e }) => /* @__PURE__ */ y.jsx(wj, { color: "primary", overlap: "circular", variant: "dot", children: e });
process.env.NODE_ENV !== "production" && (E.node, E.object.isRequired);
function jr(e) {
  return $P(e);
}
var $7 = { exports: {} }, p3 = {}, UC = { exports: {} }, n7 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ow;
function sH() {
  return ow || (ow = 1, function(e) {
    function n(f1, B1) {
      var t1 = f1.length;
      f1.push(B1);
      e: for (; 0 < t1; ) {
        var y1 = t1 - 1 >>> 1, k1 = f1[y1];
        if (0 < s(k1, B1)) f1[y1] = B1, f1[t1] = k1, t1 = y1;
        else break e;
      }
    }
    function i(f1) {
      return f1.length === 0 ? null : f1[0];
    }
    function a(f1) {
      if (f1.length === 0) return null;
      var B1 = f1[0], t1 = f1.pop();
      if (t1 !== B1) {
        f1[0] = t1;
        e: for (var y1 = 0, k1 = f1.length, se = k1 >>> 1; y1 < se; ) {
          var K1 = 2 * (y1 + 1) - 1, le = f1[K1], G1 = K1 + 1, $1 = f1[G1];
          if (0 > s(le, t1)) G1 < k1 && 0 > s($1, le) ? (f1[y1] = $1, f1[G1] = t1, y1 = G1) : (f1[y1] = le, f1[K1] = t1, y1 = K1);
          else if (G1 < k1 && 0 > s($1, t1)) f1[y1] = $1, f1[G1] = t1, y1 = G1;
          else break e;
        }
      }
      return B1;
    }
    function s(f1, B1) {
      var t1 = f1.sortIndex - B1.sortIndex;
      return t1 !== 0 ? t1 : f1.id - B1.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      e.unstable_now = function() {
        return g.now();
      };
    } else {
      var c = Date, I = c.now();
      e.unstable_now = function() {
        return c.now() - I;
      };
    }
    var h = [], m = [], w = 1, S = null, T = 3, D = !1, k = !1, z = !1, N = typeof setTimeout == "function" ? setTimeout : null, W = typeof clearTimeout == "function" ? clearTimeout : null, K = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function V(f1) {
      for (var B1 = i(m); B1 !== null; ) {
        if (B1.callback === null) a(m);
        else if (B1.startTime <= f1) a(m), B1.sortIndex = B1.expirationTime, n(h, B1);
        else break;
        B1 = i(m);
      }
    }
    function Y(f1) {
      if (z = !1, V(f1), !k) if (i(h) !== null) k = !0, C1(H);
      else {
        var B1 = i(m);
        B1 !== null && L1(Y, B1.startTime - f1);
      }
    }
    function H(f1, B1) {
      k = !1, z && (z = !1, W(P1), P1 = -1), D = !0;
      var t1 = T;
      try {
        for (V(B1), S = i(h); S !== null && (!(S.expirationTime > B1) || f1 && !T1()); ) {
          var y1 = S.callback;
          if (typeof y1 == "function") {
            S.callback = null, T = S.priorityLevel;
            var k1 = y1(S.expirationTime <= B1);
            B1 = e.unstable_now(), typeof k1 == "function" ? S.callback = k1 : S === i(h) && a(h), V(B1);
          } else a(h);
          S = i(h);
        }
        if (S !== null) var se = !0;
        else {
          var K1 = i(m);
          K1 !== null && L1(Y, K1.startTime - B1), se = !1;
        }
        return se;
      } finally {
        S = null, T = t1, D = !1;
      }
    }
    var Z = !1, Q = null, P1 = -1, Y1 = 5, O1 = -1;
    function T1() {
      return !(e.unstable_now() - O1 < Y1);
    }
    function J1() {
      if (Q !== null) {
        var f1 = e.unstable_now();
        O1 = f1;
        var B1 = !0;
        try {
          B1 = Q(!0, f1);
        } finally {
          B1 ? s1() : (Z = !1, Q = null);
        }
      } else Z = !1;
    }
    var s1;
    if (typeof K == "function") s1 = function() {
      K(J1);
    };
    else if (typeof MessageChannel < "u") {
      var d1 = new MessageChannel(), h1 = d1.port2;
      d1.port1.onmessage = J1, s1 = function() {
        h1.postMessage(null);
      };
    } else s1 = function() {
      N(J1, 0);
    };
    function C1(f1) {
      Q = f1, Z || (Z = !0, s1());
    }
    function L1(f1, B1) {
      P1 = N(function() {
        f1(e.unstable_now());
      }, B1);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(f1) {
      f1.callback = null;
    }, e.unstable_continueExecution = function() {
      k || D || (k = !0, C1(H));
    }, e.unstable_forceFrameRate = function(f1) {
      0 > f1 || 125 < f1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Y1 = 0 < f1 ? Math.floor(1e3 / f1) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return T;
    }, e.unstable_getFirstCallbackNode = function() {
      return i(h);
    }, e.unstable_next = function(f1) {
      switch (T) {
        case 1:
        case 2:
        case 3:
          var B1 = 3;
          break;
        default:
          B1 = T;
      }
      var t1 = T;
      T = B1;
      try {
        return f1();
      } finally {
        T = t1;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(f1, B1) {
      switch (f1) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          f1 = 3;
      }
      var t1 = T;
      T = f1;
      try {
        return B1();
      } finally {
        T = t1;
      }
    }, e.unstable_scheduleCallback = function(f1, B1, t1) {
      var y1 = e.unstable_now();
      switch (typeof t1 == "object" && t1 !== null ? (t1 = t1.delay, t1 = typeof t1 == "number" && 0 < t1 ? y1 + t1 : y1) : t1 = y1, f1) {
        case 1:
          var k1 = -1;
          break;
        case 2:
          k1 = 250;
          break;
        case 5:
          k1 = 1073741823;
          break;
        case 4:
          k1 = 1e4;
          break;
        default:
          k1 = 5e3;
      }
      return k1 = t1 + k1, f1 = { id: w++, callback: B1, priorityLevel: f1, startTime: t1, expirationTime: k1, sortIndex: -1 }, t1 > y1 ? (f1.sortIndex = t1, n(m, f1), i(h) === null && f1 === i(m) && (z ? (W(P1), P1 = -1) : z = !0, L1(Y, t1 - y1))) : (f1.sortIndex = k1, n(h, f1), k || D || (k = !0, C1(H))), f1;
    }, e.unstable_shouldYield = T1, e.unstable_wrapCallback = function(f1) {
      var B1 = T;
      return function() {
        var t1 = T;
        T = B1;
        try {
          return f1.apply(this, arguments);
        } finally {
          T = t1;
        }
      };
    };
  }(n7)), n7;
}
var r7 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sw;
function lH() {
  return sw || (sw = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = !1, i = !1, a = 5;
      function s(Q1, he) {
        var Ye = Q1.length;
        Q1.push(he), I(Q1, he, Ye);
      }
      function g(Q1) {
        return Q1.length === 0 ? null : Q1[0];
      }
      function c(Q1) {
        if (Q1.length === 0)
          return null;
        var he = Q1[0], Ye = Q1.pop();
        return Ye !== he && (Q1[0] = Ye, h(Q1, Ye, 0)), he;
      }
      function I(Q1, he, Ye) {
        for (var Et = Ye; Et > 0; ) {
          var Ut = Et - 1 >>> 1, cn = Q1[Ut];
          if (m(cn, he) > 0)
            Q1[Ut] = he, Q1[Et] = cn, Et = Ut;
          else
            return;
        }
      }
      function h(Q1, he, Ye) {
        for (var Et = Ye, Ut = Q1.length, cn = Ut >>> 1; Et < cn; ) {
          var nn = (Et + 1) * 2 - 1, Fn = Q1[nn], zt = nn + 1, y2 = Q1[zt];
          if (m(Fn, he) < 0)
            zt < Ut && m(y2, Fn) < 0 ? (Q1[Et] = y2, Q1[zt] = he, Et = zt) : (Q1[Et] = Fn, Q1[nn] = he, Et = nn);
          else if (zt < Ut && m(y2, he) < 0)
            Q1[Et] = y2, Q1[zt] = he, Et = zt;
          else
            return;
        }
      }
      function m(Q1, he) {
        var Ye = Q1.sortIndex - he.sortIndex;
        return Ye !== 0 ? Ye : Q1.id - he.id;
      }
      var w = 1, S = 2, T = 3, D = 4, k = 5;
      function z(Q1, he) {
      }
      var N = typeof performance == "object" && typeof performance.now == "function";
      if (N) {
        var W = performance;
        e.unstable_now = function() {
          return W.now();
        };
      } else {
        var K = Date, V = K.now();
        e.unstable_now = function() {
          return K.now() - V;
        };
      }
      var Y = 1073741823, H = -1, Z = 250, Q = 5e3, P1 = 1e4, Y1 = Y, O1 = [], T1 = [], J1 = 1, s1 = null, d1 = T, h1 = !1, C1 = !1, L1 = !1, f1 = typeof setTimeout == "function" ? setTimeout : null, B1 = typeof clearTimeout == "function" ? clearTimeout : null, t1 = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function y1(Q1) {
        for (var he = g(T1); he !== null; ) {
          if (he.callback === null)
            c(T1);
          else if (he.startTime <= Q1)
            c(T1), he.sortIndex = he.expirationTime, s(O1, he);
          else
            return;
          he = g(T1);
        }
      }
      function k1(Q1) {
        if (L1 = !1, y1(Q1), !C1)
          if (g(O1) !== null)
            C1 = !0, v2(se);
          else {
            var he = g(T1);
            he !== null && tn(k1, he.startTime - Q1);
          }
      }
      function se(Q1, he) {
        C1 = !1, L1 && (L1 = !1, s2()), h1 = !0;
        var Ye = d1;
        try {
          var Et;
          if (!i) return K1(Q1, he);
        } finally {
          s1 = null, d1 = Ye, h1 = !1;
        }
      }
      function K1(Q1, he) {
        var Ye = he;
        for (y1(Ye), s1 = g(O1); s1 !== null && !n && !(s1.expirationTime > Ye && (!Q1 || Xe())); ) {
          var Et = s1.callback;
          if (typeof Et == "function") {
            s1.callback = null, d1 = s1.priorityLevel;
            var Ut = s1.expirationTime <= Ye, cn = Et(Ut);
            Ye = e.unstable_now(), typeof cn == "function" ? s1.callback = cn : s1 === g(O1) && c(O1), y1(Ye);
          } else
            c(O1);
          s1 = g(O1);
        }
        if (s1 !== null)
          return !0;
        var nn = g(T1);
        return nn !== null && tn(k1, nn.startTime - Ye), !1;
      }
      function le(Q1, he) {
        switch (Q1) {
          case w:
          case S:
          case T:
          case D:
          case k:
            break;
          default:
            Q1 = T;
        }
        var Ye = d1;
        d1 = Q1;
        try {
          return he();
        } finally {
          d1 = Ye;
        }
      }
      function G1(Q1) {
        var he;
        switch (d1) {
          case w:
          case S:
          case T:
            he = T;
            break;
          default:
            he = d1;
            break;
        }
        var Ye = d1;
        d1 = he;
        try {
          return Q1();
        } finally {
          d1 = Ye;
        }
      }
      function $1(Q1) {
        var he = d1;
        return function() {
          var Ye = d1;
          d1 = he;
          try {
            return Q1.apply(this, arguments);
          } finally {
            d1 = Ye;
          }
        };
      }
      function V1(Q1, he, Ye) {
        var Et = e.unstable_now(), Ut;
        if (typeof Ye == "object" && Ye !== null) {
          var cn = Ye.delay;
          typeof cn == "number" && cn > 0 ? Ut = Et + cn : Ut = Et;
        } else
          Ut = Et;
        var nn;
        switch (Q1) {
          case w:
            nn = H;
            break;
          case S:
            nn = Z;
            break;
          case k:
            nn = Y1;
            break;
          case D:
            nn = P1;
            break;
          case T:
          default:
            nn = Q;
            break;
        }
        var Fn = Ut + nn, zt = {
          id: J1++,
          callback: he,
          priorityLevel: Q1,
          startTime: Ut,
          expirationTime: Fn,
          sortIndex: -1
        };
        return Ut > Et ? (zt.sortIndex = Ut, s(T1, zt), g(O1) === null && zt === g(T1) && (L1 ? s2() : L1 = !0, tn(k1, Ut - Et))) : (zt.sortIndex = Fn, s(O1, zt), !C1 && !h1 && (C1 = !0, v2(se))), zt;
      }
      function z1() {
      }
      function ae() {
        !C1 && !h1 && (C1 = !0, v2(se));
      }
      function We() {
        return g(O1);
      }
      function D1(Q1) {
        Q1.callback = null;
      }
      function ue() {
        return d1;
      }
      var b1 = !1, Pe = null, $e = -1, W1 = a, ke = -1;
      function Xe() {
        var Q1 = e.unstable_now() - ke;
        return !(Q1 < W1);
      }
      function St() {
      }
      function tt(Q1) {
        if (Q1 < 0 || Q1 > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Q1 > 0 ? W1 = Math.floor(1e3 / Q1) : W1 = a;
      }
      var we = function() {
        if (Pe !== null) {
          var Q1 = e.unstable_now();
          ke = Q1;
          var he = !0, Ye = !0;
          try {
            Ye = Pe(he, Q1);
          } finally {
            Ye ? An() : (b1 = !1, Pe = null);
          }
        } else
          b1 = !1;
      }, An;
      if (typeof t1 == "function")
        An = function() {
          t1(we);
        };
      else if (typeof MessageChannel < "u") {
        var nt = new MessageChannel(), In = nt.port2;
        nt.port1.onmessage = we, An = function() {
          In.postMessage(null);
        };
      } else
        An = function() {
          f1(we, 0);
        };
      function v2(Q1) {
        Pe = Q1, b1 || (b1 = !0, An());
      }
      function tn(Q1, he) {
        $e = f1(function() {
          Q1(e.unstable_now());
        }, he);
      }
      function s2() {
        B1($e), $e = -1;
      }
      var Fe = St, Pn = null;
      e.unstable_IdlePriority = k, e.unstable_ImmediatePriority = w, e.unstable_LowPriority = D, e.unstable_NormalPriority = T, e.unstable_Profiling = Pn, e.unstable_UserBlockingPriority = S, e.unstable_cancelCallback = D1, e.unstable_continueExecution = ae, e.unstable_forceFrameRate = tt, e.unstable_getCurrentPriorityLevel = ue, e.unstable_getFirstCallbackNode = We, e.unstable_next = G1, e.unstable_pauseExecution = z1, e.unstable_requestPaint = Fe, e.unstable_runWithPriority = le, e.unstable_scheduleCallback = V1, e.unstable_shouldYield = Xe, e.unstable_wrapCallback = $1, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(r7)), r7;
}
var lw;
function EE() {
  return lw || (lw = 1, process.env.NODE_ENV === "production" ? UC.exports = sH() : UC.exports = lH()), UC.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uw;
function uH() {
  if (uw) return p3;
  uw = 1;
  var e = Gt, n = EE();
  function i(o) {
    for (var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, d = 1; d < arguments.length; d++) l += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + o + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var a = /* @__PURE__ */ new Set(), s = {};
  function g(o, l) {
    c(o, l), c(o + "Capture", l);
  }
  function c(o, l) {
    for (s[o] = l, o = 0; o < l.length; o++) a.add(l[o]);
  }
  var I = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h = Object.prototype.hasOwnProperty, m = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, w = {}, S = {};
  function T(o) {
    return h.call(S, o) ? !0 : h.call(w, o) ? !1 : m.test(o) ? S[o] = !0 : (w[o] = !0, !1);
  }
  function D(o, l, d, A) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof l) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return A ? !1 : d !== null ? !d.acceptsBooleans : (o = o.toLowerCase().slice(0, 5), o !== "data-" && o !== "aria-");
      default:
        return !1;
    }
  }
  function k(o, l, d, A) {
    if (l === null || typeof l > "u" || D(o, l, d, A)) return !0;
    if (A) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !l;
      case 4:
        return l === !1;
      case 5:
        return isNaN(l);
      case 6:
        return isNaN(l) || 1 > l;
    }
    return !1;
  }
  function z(o, l, d, A, v, x, j) {
    this.acceptsBooleans = l === 2 || l === 3 || l === 4, this.attributeName = A, this.attributeNamespace = v, this.mustUseProperty = d, this.propertyName = o, this.type = l, this.sanitizeURL = x, this.removeEmptyString = j;
  }
  var N = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    N[o] = new z(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var l = o[0];
    N[l] = new z(l, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    N[o] = new z(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    N[o] = new z(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    N[o] = new z(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    N[o] = new z(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    N[o] = new z(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    N[o] = new z(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    N[o] = new z(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var W = /[\-:]([a-z])/g;
  function K(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var l = o.replace(
      W,
      K
    );
    N[l] = new z(l, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var l = o.replace(W, K);
    N[l] = new z(l, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var l = o.replace(W, K);
    N[l] = new z(l, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    N[o] = new z(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), N.xlinkHref = new z("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    N[o] = new z(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  function V(o, l, d, A) {
    var v = N.hasOwnProperty(l) ? N[l] : null;
    (v !== null ? v.type !== 0 : A || !(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (k(l, d, v, A) && (d = null), A || v === null ? T(l) && (d === null ? o.removeAttribute(l) : o.setAttribute(l, "" + d)) : v.mustUseProperty ? o[v.propertyName] = d === null ? v.type === 3 ? !1 : "" : d : (l = v.attributeName, A = v.attributeNamespace, d === null ? o.removeAttribute(l) : (v = v.type, d = v === 3 || v === 4 && d === !0 ? "" : "" + d, A ? o.setAttributeNS(A, l, d) : o.setAttribute(l, d))));
  }
  var Y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, H = Symbol.for("react.element"), Z = Symbol.for("react.portal"), Q = Symbol.for("react.fragment"), P1 = Symbol.for("react.strict_mode"), Y1 = Symbol.for("react.profiler"), O1 = Symbol.for("react.provider"), T1 = Symbol.for("react.context"), J1 = Symbol.for("react.forward_ref"), s1 = Symbol.for("react.suspense"), d1 = Symbol.for("react.suspense_list"), h1 = Symbol.for("react.memo"), C1 = Symbol.for("react.lazy"), L1 = Symbol.for("react.offscreen"), f1 = Symbol.iterator;
  function B1(o) {
    return o === null || typeof o != "object" ? null : (o = f1 && o[f1] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var t1 = Object.assign, y1;
  function k1(o) {
    if (y1 === void 0) try {
      throw Error();
    } catch (d) {
      var l = d.stack.trim().match(/\n( *(at )?)/);
      y1 = l && l[1] || "";
    }
    return `
` + y1 + o;
  }
  var se = !1;
  function K1(o, l) {
    if (!o || se) return "";
    se = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (l) if (l = function() {
        throw Error();
      }, Object.defineProperty(l.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(l, []);
        } catch (c1) {
          var A = c1;
        }
        Reflect.construct(o, [], l);
      } else {
        try {
          l.call();
        } catch (c1) {
          A = c1;
        }
        o.call(l.prototype);
      }
      else {
        try {
          throw Error();
        } catch (c1) {
          A = c1;
        }
        o();
      }
    } catch (c1) {
      if (c1 && A && typeof c1.stack == "string") {
        for (var v = c1.stack.split(`
`), x = A.stack.split(`
`), j = v.length - 1, _ = x.length - 1; 1 <= j && 0 <= _ && v[j] !== x[_]; ) _--;
        for (; 1 <= j && 0 <= _; j--, _--) if (v[j] !== x[_]) {
          if (j !== 1 || _ !== 1)
            do
              if (j--, _--, 0 > _ || v[j] !== x[_]) {
                var X = `
` + v[j].replace(" at new ", " at ");
                return o.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", o.displayName)), X;
              }
            while (1 <= j && 0 <= _);
          break;
        }
      }
    } finally {
      se = !1, Error.prepareStackTrace = d;
    }
    return (o = o ? o.displayName || o.name : "") ? k1(o) : "";
  }
  function le(o) {
    switch (o.tag) {
      case 5:
        return k1(o.type);
      case 16:
        return k1("Lazy");
      case 13:
        return k1("Suspense");
      case 19:
        return k1("SuspenseList");
      case 0:
      case 2:
      case 15:
        return o = K1(o.type, !1), o;
      case 11:
        return o = K1(o.type.render, !1), o;
      case 1:
        return o = K1(o.type, !0), o;
      default:
        return "";
    }
  }
  function G1(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case Q:
        return "Fragment";
      case Z:
        return "Portal";
      case Y1:
        return "Profiler";
      case P1:
        return "StrictMode";
      case s1:
        return "Suspense";
      case d1:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case T1:
        return (o.displayName || "Context") + ".Consumer";
      case O1:
        return (o._context.displayName || "Context") + ".Provider";
      case J1:
        var l = o.render;
        return o = o.displayName, o || (o = l.displayName || l.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case h1:
        return l = o.displayName || null, l !== null ? l : G1(o.type) || "Memo";
      case C1:
        l = o._payload, o = o._init;
        try {
          return G1(o(l));
        } catch {
        }
    }
    return null;
  }
  function $1(o) {
    var l = o.type;
    switch (o.tag) {
      case 24:
        return "Cache";
      case 9:
        return (l.displayName || "Context") + ".Consumer";
      case 10:
        return (l._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return o = l.render, o = o.displayName || o.name || "", l.displayName || (o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return l;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return G1(l);
      case 8:
        return l === P1 ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof l == "function") return l.displayName || l.name || null;
        if (typeof l == "string") return l;
    }
    return null;
  }
  function V1(o) {
    switch (typeof o) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return o;
      case "object":
        return o;
      default:
        return "";
    }
  }
  function z1(o) {
    var l = o.type;
    return (o = o.nodeName) && o.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function ae(o) {
    var l = z1(o) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(o.constructor.prototype, l), A = "" + o[l];
    if (!o.hasOwnProperty(l) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var v = d.get, x = d.set;
      return Object.defineProperty(o, l, { configurable: !0, get: function() {
        return v.call(this);
      }, set: function(j) {
        A = "" + j, x.call(this, j);
      } }), Object.defineProperty(o, l, { enumerable: d.enumerable }), { getValue: function() {
        return A;
      }, setValue: function(j) {
        A = "" + j;
      }, stopTracking: function() {
        o._valueTracker = null, delete o[l];
      } };
    }
  }
  function We(o) {
    o._valueTracker || (o._valueTracker = ae(o));
  }
  function D1(o) {
    if (!o) return !1;
    var l = o._valueTracker;
    if (!l) return !0;
    var d = l.getValue(), A = "";
    return o && (A = z1(o) ? o.checked ? "true" : "false" : o.value), o = A, o !== d ? (l.setValue(o), !0) : !1;
  }
  function ue(o) {
    if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u") return null;
    try {
      return o.activeElement || o.body;
    } catch {
      return o.body;
    }
  }
  function b1(o, l) {
    var d = l.checked;
    return t1({}, l, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: d ?? o._wrapperState.initialChecked });
  }
  function Pe(o, l) {
    var d = l.defaultValue == null ? "" : l.defaultValue, A = l.checked != null ? l.checked : l.defaultChecked;
    d = V1(l.value != null ? l.value : d), o._wrapperState = { initialChecked: A, initialValue: d, controlled: l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null };
  }
  function $e(o, l) {
    l = l.checked, l != null && V(o, "checked", l, !1);
  }
  function W1(o, l) {
    $e(o, l);
    var d = V1(l.value), A = l.type;
    if (d != null) A === "number" ? (d === 0 && o.value === "" || o.value != d) && (o.value = "" + d) : o.value !== "" + d && (o.value = "" + d);
    else if (A === "submit" || A === "reset") {
      o.removeAttribute("value");
      return;
    }
    l.hasOwnProperty("value") ? Xe(o, l.type, d) : l.hasOwnProperty("defaultValue") && Xe(o, l.type, V1(l.defaultValue)), l.checked == null && l.defaultChecked != null && (o.defaultChecked = !!l.defaultChecked);
  }
  function ke(o, l, d) {
    if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
      var A = l.type;
      if (!(A !== "submit" && A !== "reset" || l.value !== void 0 && l.value !== null)) return;
      l = "" + o._wrapperState.initialValue, d || l === o.value || (o.value = l), o.defaultValue = l;
    }
    d = o.name, d !== "" && (o.name = ""), o.defaultChecked = !!o._wrapperState.initialChecked, d !== "" && (o.name = d);
  }
  function Xe(o, l, d) {
    (l !== "number" || ue(o.ownerDocument) !== o) && (d == null ? o.defaultValue = "" + o._wrapperState.initialValue : o.defaultValue !== "" + d && (o.defaultValue = "" + d));
  }
  var St = Array.isArray;
  function tt(o, l, d, A) {
    if (o = o.options, l) {
      l = {};
      for (var v = 0; v < d.length; v++) l["$" + d[v]] = !0;
      for (d = 0; d < o.length; d++) v = l.hasOwnProperty("$" + o[d].value), o[d].selected !== v && (o[d].selected = v), v && A && (o[d].defaultSelected = !0);
    } else {
      for (d = "" + V1(d), l = null, v = 0; v < o.length; v++) {
        if (o[v].value === d) {
          o[v].selected = !0, A && (o[v].defaultSelected = !0);
          return;
        }
        l !== null || o[v].disabled || (l = o[v]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function we(o, l) {
    if (l.dangerouslySetInnerHTML != null) throw Error(i(91));
    return t1({}, l, { value: void 0, defaultValue: void 0, children: "" + o._wrapperState.initialValue });
  }
  function An(o, l) {
    var d = l.value;
    if (d == null) {
      if (d = l.children, l = l.defaultValue, d != null) {
        if (l != null) throw Error(i(92));
        if (St(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        l = d;
      }
      l == null && (l = ""), d = l;
    }
    o._wrapperState = { initialValue: V1(d) };
  }
  function nt(o, l) {
    var d = V1(l.value), A = V1(l.defaultValue);
    d != null && (d = "" + d, d !== o.value && (o.value = d), l.defaultValue == null && o.defaultValue !== d && (o.defaultValue = d)), A != null && (o.defaultValue = "" + A);
  }
  function In(o) {
    var l = o.textContent;
    l === o._wrapperState.initialValue && l !== "" && l !== null && (o.value = l);
  }
  function v2(o) {
    switch (o) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function tn(o, l) {
    return o == null || o === "http://www.w3.org/1999/xhtml" ? v2(l) : o === "http://www.w3.org/2000/svg" && l === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o;
  }
  var s2, Fe = function(o) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, d, A, v) {
      MSApp.execUnsafeLocalFunction(function() {
        return o(l, d, A, v);
      });
    } : o;
  }(function(o, l) {
    if (o.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in o) o.innerHTML = l;
    else {
      for (s2 = s2 || document.createElement("div"), s2.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>", l = s2.firstChild; o.firstChild; ) o.removeChild(o.firstChild);
      for (; l.firstChild; ) o.appendChild(l.firstChild);
    }
  });
  function Pn(o, l) {
    if (l) {
      var d = o.firstChild;
      if (d && d === o.lastChild && d.nodeType === 3) {
        d.nodeValue = l;
        return;
      }
    }
    o.textContent = l;
  }
  var Q1 = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, he = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Q1).forEach(function(o) {
    he.forEach(function(l) {
      l = l + o.charAt(0).toUpperCase() + o.substring(1), Q1[l] = Q1[o];
    });
  });
  function Ye(o, l, d) {
    return l == null || typeof l == "boolean" || l === "" ? "" : d || typeof l != "number" || l === 0 || Q1.hasOwnProperty(o) && Q1[o] ? ("" + l).trim() : l + "px";
  }
  function Et(o, l) {
    o = o.style;
    for (var d in l) if (l.hasOwnProperty(d)) {
      var A = d.indexOf("--") === 0, v = Ye(d, l[d], A);
      d === "float" && (d = "cssFloat"), A ? o.setProperty(d, v) : o[d] = v;
    }
  }
  var Ut = t1({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function cn(o, l) {
    if (l) {
      if (Ut[o] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(i(137, o));
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(i(60));
        if (typeof l.dangerouslySetInnerHTML != "object" || !("__html" in l.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (l.style != null && typeof l.style != "object") throw Error(i(62));
    }
  }
  function nn(o, l) {
    if (o.indexOf("-") === -1) return typeof l.is == "string";
    switch (o) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Fn = null;
  function zt(o) {
    return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
  }
  var y2 = null, Nt = null, Wt = null;
  function j3(o) {
    if (o = As(o)) {
      if (typeof y2 != "function") throw Error(i(280));
      var l = o.stateNode;
      l && (l = ze(l), y2(o.stateNode, o.type, l));
    }
  }
  function l0(o) {
    Nt ? Wt ? Wt.push(o) : Wt = [o] : Nt = o;
  }
  function W0() {
    if (Nt) {
      var o = Nt, l = Wt;
      if (Wt = Nt = null, j3(o), l) for (o = 0; o < l.length; o++) j3(l[o]);
    }
  }
  function Pi(o, l) {
    return o(l);
  }
  function z3() {
  }
  var N3 = !1;
  function Yn(o, l, d) {
    if (N3) return o(l, d);
    N3 = !0;
    try {
      return Pi(o, l, d);
    } finally {
      N3 = !1, (Nt !== null || Wt !== null) && (z3(), W0());
    }
  }
  function u0(o, l) {
    var d = o.stateNode;
    if (d === null) return null;
    var A = ze(d);
    if (A === null) return null;
    d = A[l];
    e: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (A = !A.disabled) || (o = o.type, A = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !A;
        break e;
      default:
        o = !1;
    }
    if (o) return null;
    if (d && typeof d != "function") throw Error(i(231, l, typeof d));
    return d;
  }
  var V0 = !1;
  if (I) try {
    var rn = {};
    Object.defineProperty(rn, "passive", { get: function() {
      V0 = !0;
    } }), window.addEventListener("test", rn, rn), window.removeEventListener("test", rn, rn);
  } catch {
    V0 = !1;
  }
  function Qr(o, l, d, A, v, x, j, _, X) {
    var c1 = Array.prototype.slice.call(arguments, 3);
    try {
      l.apply(d, c1);
    } catch (R1) {
      this.onError(R1);
    }
  }
  var j2 = !1, z2 = null, Xr = !1, c0 = null, J = { onError: function(o) {
    j2 = !0, z2 = o;
  } };
  function S1(o, l, d, A, v, x, j, _, X) {
    j2 = !1, z2 = null, Qr.apply(J, arguments);
  }
  function X1(o, l, d, A, v, x, j, _, X) {
    if (S1.apply(this, arguments), j2) {
      if (j2) {
        var c1 = z2;
        j2 = !1, z2 = null;
      } else throw Error(i(198));
      Xr || (Xr = !0, c0 = c1);
    }
  }
  function Ae(o) {
    var l = o, d = o;
    if (o.alternate) for (; l.return; ) l = l.return;
    else {
      o = l;
      do
        l = o, l.flags & 4098 && (d = l.return), o = l.return;
      while (o);
    }
    return l.tag === 3 ? d : null;
  }
  function ot(o) {
    if (o.tag === 13) {
      var l = o.memoizedState;
      if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function ut(o) {
    if (Ae(o) !== o) throw Error(i(188));
  }
  function je(o) {
    var l = o.alternate;
    if (!l) {
      if (l = Ae(o), l === null) throw Error(i(188));
      return l !== o ? null : o;
    }
    for (var d = o, A = l; ; ) {
      var v = d.return;
      if (v === null) break;
      var x = v.alternate;
      if (x === null) {
        if (A = v.return, A !== null) {
          d = A;
          continue;
        }
        break;
      }
      if (v.child === x.child) {
        for (x = v.child; x; ) {
          if (x === d) return ut(v), o;
          if (x === A) return ut(v), l;
          x = x.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== A.return) d = v, A = x;
      else {
        for (var j = !1, _ = v.child; _; ) {
          if (_ === d) {
            j = !0, d = v, A = x;
            break;
          }
          if (_ === A) {
            j = !0, A = v, d = x;
            break;
          }
          _ = _.sibling;
        }
        if (!j) {
          for (_ = x.child; _; ) {
            if (_ === d) {
              j = !0, d = x, A = v;
              break;
            }
            if (_ === A) {
              j = !0, A = x, d = v;
              break;
            }
            _ = _.sibling;
          }
          if (!j) throw Error(i(189));
        }
      }
      if (d.alternate !== A) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? o : l;
  }
  function et(o) {
    return o = je(o), o !== null ? Bn(o) : null;
  }
  function Bn(o) {
    if (o.tag === 5 || o.tag === 6) return o;
    for (o = o.child; o !== null; ) {
      var l = Bn(o);
      if (l !== null) return l;
      o = o.sibling;
    }
    return null;
  }
  var Pt = n.unstable_scheduleCallback, Zt = n.unstable_cancelCallback, N2 = n.unstable_shouldYield, P3 = n.unstable_requestPaint, vt = n.unstable_now, Qn = n.unstable_getCurrentPriorityLevel, _2 = n.unstable_ImmediatePriority, rt = n.unstable_UserBlockingPriority, Gr = n.unstable_NormalPriority, ml = n.unstable_LowPriority, ts = n.unstable_IdlePriority, Fi = null, J2 = null;
  function vl(o) {
    if (J2 && typeof J2.onCommitFiberRoot == "function") try {
      J2.onCommitFiberRoot(Fi, o, void 0, (o.current.flags & 128) === 128);
    } catch {
    }
  }
  var lr = Math.clz32 ? Math.clz32 : bl, yl = Math.log, _0 = Math.LN2;
  function bl(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (yl(o) / _0 | 0) | 0;
  }
  var J0 = 64, g0 = 4194304;
  function f0(o) {
    switch (o & -o) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return o & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return o;
    }
  }
  function K2(o, l) {
    var d = o.pendingLanes;
    if (d === 0) return 0;
    var A = 0, v = o.suspendedLanes, x = o.pingedLanes, j = d & 268435455;
    if (j !== 0) {
      var _ = j & ~v;
      _ !== 0 ? A = f0(_) : (x &= j, x !== 0 && (A = f0(x)));
    } else j = d & ~v, j !== 0 ? A = f0(j) : x !== 0 && (A = f0(x));
    if (A === 0) return 0;
    if (l !== 0 && l !== A && !(l & v) && (v = A & -A, x = l & -l, v >= x || v === 16 && (x & 4194240) !== 0)) return l;
    if (A & 4 && (A |= d & 16), l = o.entangledLanes, l !== 0) for (o = o.entanglements, l &= A; 0 < l; ) d = 31 - lr(l), v = 1 << d, A |= o[d], l &= ~v;
    return A;
  }
  function za(o, l) {
    switch (o) {
      case 1:
      case 2:
      case 4:
        return l + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function K0(o, l) {
    for (var d = o.suspendedLanes, A = o.pingedLanes, v = o.expirationTimes, x = o.pendingLanes; 0 < x; ) {
      var j = 31 - lr(x), _ = 1 << j, X = v[j];
      X === -1 ? (!(_ & d) || _ & A) && (v[j] = za(_, l)) : X <= l && (o.expiredLanes |= _), x &= ~_;
    }
  }
  function ns(o) {
    return o = o.pendingLanes & -1073741825, o !== 0 ? o : o & 1073741824 ? 1073741824 : 0;
  }
  function Na() {
    var o = J0;
    return J0 <<= 1, !(J0 & 4194240) && (J0 = 64), o;
  }
  function Pa(o) {
    for (var l = [], d = 0; 31 > d; d++) l.push(o);
    return l;
  }
  function F3(o, l, d) {
    o.pendingLanes |= l, l !== 536870912 && (o.suspendedLanes = 0, o.pingedLanes = 0), o = o.eventTimes, l = 31 - lr(l), o[l] = d;
  }
  function Fa(o, l) {
    var d = o.pendingLanes & ~l;
    o.pendingLanes = l, o.suspendedLanes = 0, o.pingedLanes = 0, o.expiredLanes &= l, o.mutableReadLanes &= l, o.entangledLanes &= l, l = o.entanglements;
    var A = o.eventTimes;
    for (o = o.expirationTimes; 0 < d; ) {
      var v = 31 - lr(d), x = 1 << v;
      l[v] = 0, A[v] = -1, o[v] = -1, d &= ~x;
    }
  }
  function Bi(o, l) {
    var d = o.entangledLanes |= l;
    for (o = o.entanglements; d; ) {
      var A = 31 - lr(d), v = 1 << A;
      v & l | o[A] & l && (o[A] |= l), d &= ~v;
    }
  }
  var Be = 0;
  function Hi(o) {
    return o &= -o, 1 < o ? 4 < o ? o & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var rs, ur, yt, cr, Y2, Oe = !1, Y0 = [], wn = null, gr = null, fr = null, Ui = /* @__PURE__ */ new Map(), On = /* @__PURE__ */ new Map(), Dt = [], Vc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function zr(o, l) {
    switch (o) {
      case "focusin":
      case "focusout":
        wn = null;
        break;
      case "dragenter":
      case "dragleave":
        gr = null;
        break;
      case "mouseover":
      case "mouseout":
        fr = null;
        break;
      case "pointerover":
      case "pointerout":
        Ui.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        On.delete(l.pointerId);
    }
  }
  function l2(o, l, d, A, v, x) {
    return o === null || o.nativeEvent !== x ? (o = { blockedOn: l, domEventName: d, eventSystemFlags: A, nativeEvent: x, targetContainers: [v] }, l !== null && (l = As(l), l !== null && ur(l)), o) : (o.eventSystemFlags |= A, l = o.targetContainers, v !== null && l.indexOf(v) === -1 && l.push(v), o);
  }
  function B3(o, l, d, A, v) {
    switch (l) {
      case "focusin":
        return wn = l2(wn, o, l, d, A, v), !0;
      case "dragenter":
        return gr = l2(gr, o, l, d, A, v), !0;
      case "mouseover":
        return fr = l2(fr, o, l, d, A, v), !0;
      case "pointerover":
        var x = v.pointerId;
        return Ui.set(x, l2(Ui.get(x) || null, o, l, d, A, v)), !0;
      case "gotpointercapture":
        return x = v.pointerId, On.set(x, l2(On.get(x) || null, o, l, d, A, v)), !0;
    }
    return !1;
  }
  function Wi(o) {
    var l = $r(o.target);
    if (l !== null) {
      var d = Ae(l);
      if (d !== null) {
        if (l = d.tag, l === 13) {
          if (l = ot(d), l !== null) {
            o.blockedOn = l, Y2(o.priority, function() {
              yt(d);
            });
            return;
          }
        } else if (l === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          o.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    o.blockedOn = null;
  }
  function d0(o) {
    if (o.blockedOn !== null) return !1;
    for (var l = o.targetContainers; 0 < l.length; ) {
      var d = xe(o.domEventName, o.eventSystemFlags, l[0], o.nativeEvent);
      if (d === null) {
        d = o.nativeEvent;
        var A = new d.constructor(d.type, d);
        Fn = A, d.target.dispatchEvent(A), Fn = null;
      } else return l = As(d), l !== null && ur(l), o.blockedOn = d, !1;
      l.shift();
    }
    return !0;
  }
  function L(o, l, d) {
    d0(o) && d.delete(l);
  }
  function R() {
    Oe = !1, wn !== null && d0(wn) && (wn = null), gr !== null && d0(gr) && (gr = null), fr !== null && d0(fr) && (fr = null), Ui.forEach(L), On.forEach(L);
  }
  function B(o, l) {
    o.blockedOn === l && (o.blockedOn = null, Oe || (Oe = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, R)));
  }
  function U(o) {
    function l(v) {
      return B(v, o);
    }
    if (0 < Y0.length) {
      B(Y0[0], o);
      for (var d = 1; d < Y0.length; d++) {
        var A = Y0[d];
        A.blockedOn === o && (A.blockedOn = null);
      }
    }
    for (wn !== null && B(wn, o), gr !== null && B(gr, o), fr !== null && B(fr, o), Ui.forEach(l), On.forEach(l), d = 0; d < Dt.length; d++) A = Dt[d], A.blockedOn === o && (A.blockedOn = null);
    for (; 0 < Dt.length && (d = Dt[0], d.blockedOn === null); ) Wi(d), d.blockedOn === null && Dt.shift();
  }
  var G = Y.ReactCurrentBatchConfig, u1 = !0;
  function M1(o, l, d, A) {
    var v = Be, x = G.transition;
    G.transition = null;
    try {
      Be = 1, te(o, l, d, A);
    } finally {
      Be = v, G.transition = x;
    }
  }
  function p1(o, l, d, A) {
    var v = Be, x = G.transition;
    G.transition = null;
    try {
      Be = 4, te(o, l, d, A);
    } finally {
      Be = v, G.transition = x;
    }
  }
  function te(o, l, d, A) {
    if (u1) {
      var v = xe(o, l, d, A);
      if (v === null) kl(o, l, A, re, d), zr(o, A);
      else if (B3(v, o, l, d, A)) A.stopPropagation();
      else if (zr(o, A), l & 4 && -1 < Vc.indexOf(o)) {
        for (; v !== null; ) {
          var x = As(v);
          if (x !== null && rs(x), x = xe(o, l, d, A), x === null && kl(o, l, A, re, d), x === v) break;
          v = x;
        }
        v !== null && A.stopPropagation();
      } else kl(o, l, A, null, d);
    }
  }
  var re = null;
  function xe(o, l, d, A) {
    if (re = null, o = zt(A), o = $r(o), o !== null) if (l = Ae(o), l === null) o = null;
    else if (d = l.tag, d === 13) {
      if (o = ot(l), o !== null) return o;
      o = null;
    } else if (d === 3) {
      if (l.stateNode.current.memoizedState.isDehydrated) return l.tag === 3 ? l.stateNode.containerInfo : null;
      o = null;
    } else l !== o && (o = null);
    return re = o, null;
  }
  function st(o) {
    switch (o) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Qn()) {
          case _2:
            return 1;
          case rt:
            return 4;
          case Gr:
          case ml:
            return 16;
          case ts:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var gt = null, Xn = null, $t = null;
  function gn() {
    if ($t) return $t;
    var o, l = Xn, d = l.length, A, v = "value" in gt ? gt.value : gt.textContent, x = v.length;
    for (o = 0; o < d && l[o] === v[o]; o++) ;
    var j = d - o;
    for (A = 1; A <= j && l[d - A] === v[x - A]; A++) ;
    return $t = v.slice(o, 1 < A ? 1 - A : void 0);
  }
  function u2(o) {
    var l = o.keyCode;
    return "charCode" in o ? (o = o.charCode, o === 0 && l === 13 && (o = 13)) : o = l, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
  }
  function y3() {
    return !0;
  }
  function P2() {
    return !1;
  }
  function Gn(o) {
    function l(d, A, v, x, j) {
      this._reactName = d, this._targetInst = v, this.type = A, this.nativeEvent = x, this.target = j, this.currentTarget = null;
      for (var _ in o) o.hasOwnProperty(_) && (d = o[_], this[_] = d ? d(x) : x[_]);
      return this.isDefaultPrevented = (x.defaultPrevented != null ? x.defaultPrevented : x.returnValue === !1) ? y3 : P2, this.isPropagationStopped = P2, this;
    }
    return t1(l.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var d = this.nativeEvent;
      d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = y3);
    }, stopPropagation: function() {
      var d = this.nativeEvent;
      d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = y3);
    }, persist: function() {
    }, isPersistent: y3 }), l;
  }
  var qr = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(o) {
    return o.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Vi = Gn(qr), Ba = t1({}, qr, { view: 0, detail: 0 }), Vf = Gn(Ba), wl, _c, is, c2 = t1({}, Ba, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Qc, button: 0, buttons: 0, relatedTarget: function(o) {
    return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
  }, movementX: function(o) {
    return "movementX" in o ? o.movementX : (o !== is && (is && o.type === "mousemove" ? (wl = o.screenX - is.screenX, _c = o.screenY - is.screenY) : _c = wl = 0, is = o), wl);
  }, movementY: function(o) {
    return "movementY" in o ? o.movementY : _c;
  } }), xl = Gn(c2), _f = t1({}, c2, { dataTransfer: 0 }), Jf = Gn(_f), I6 = t1({}, Ba, { relatedTarget: 0 }), Q0 = Gn(I6), Jc = t1({}, qr, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Kf = Gn(Jc), p6 = t1({}, qr, { clipboardData: function(o) {
    return "clipboardData" in o ? o.clipboardData : window.clipboardData;
  } }), h6 = Gn(p6), m6 = t1({}, qr, { data: 0 }), Kc = Gn(m6), Yc = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Yf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Qf = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Xf(o) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(o) : (o = Qf[o]) ? !!l[o] : !1;
  }
  function Qc() {
    return Xf;
  }
  var C0 = t1({}, Ba, { key: function(o) {
    if (o.key) {
      var l = Yc[o.key] || o.key;
      if (l !== "Unidentified") return l;
    }
    return o.type === "keypress" ? (o = u2(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? Yf[o.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Qc, charCode: function(o) {
    return o.type === "keypress" ? u2(o) : 0;
  }, keyCode: function(o) {
    return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  }, which: function(o) {
    return o.type === "keypress" ? u2(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  } }), v6 = Gn(C0), Xc = t1({}, c2, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Sl = Gn(Xc), Gc = t1({}, Ba, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Qc }), y6 = Gn(Gc), El = t1({}, qr, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Gf = Gn(El), dr = t1({}, c2, {
    deltaX: function(o) {
      return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
    },
    deltaY: function(o) {
      return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), A0 = Gn(dr), Hn = [9, 13, 27, 32], b3 = I && "CompositionEvent" in window, _i = null;
  I && "documentMode" in document && (_i = document.documentMode);
  var Ml = I && "TextEvent" in window && !_i, qf = I && (!b3 || _i && 8 < _i && 11 >= _i), Ha = " ", Zf = !1;
  function $f(o, l) {
    switch (o) {
      case "keyup":
        return Hn.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Tl(o) {
    return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
  }
  var Ua = !1;
  function b6(o, l) {
    switch (o) {
      case "compositionend":
        return Tl(l);
      case "keypress":
        return l.which !== 32 ? null : (Zf = !0, Ha);
      case "textInput":
        return o = l.data, o === Ha && Zf ? null : o;
      default:
        return null;
    }
  }
  function w6(o, l) {
    if (Ua) return o === "compositionend" || !b3 && $f(o, l) ? (o = gn(), $t = Xn = gt = null, Ua = !1, o) : null;
    switch (o) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length) return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return qf && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var ed = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function td(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l === "input" ? !!ed[o.type] : l === "textarea";
  }
  function nd(o, l, d, A) {
    l0(A), l = fs(l, "onChange"), 0 < l.length && (d = new Vi("onChange", "change", null, d, A), o.push({ event: d, listeners: l }));
  }
  var as = null, Wa = null;
  function Va(o) {
    Dl(o, 0);
  }
  function _a(o) {
    var l = Ka(o);
    if (D1(l)) return o;
  }
  function rd(o, l) {
    if (o === "change") return l;
  }
  var qc = !1;
  if (I) {
    var Zc;
    if (I) {
      var $c = "oninput" in document;
      if (!$c) {
        var id = document.createElement("div");
        id.setAttribute("oninput", "return;"), $c = typeof id.oninput == "function";
      }
      Zc = $c;
    } else Zc = !1;
    qc = Zc && (!document.documentMode || 9 < document.documentMode);
  }
  function ad() {
    as && (as.detachEvent("onpropertychange", od), Wa = as = null);
  }
  function od(o) {
    if (o.propertyName === "value" && _a(Wa)) {
      var l = [];
      nd(l, Wa, o, zt(o)), Yn(Va, l);
    }
  }
  function x6(o, l, d) {
    o === "focusin" ? (ad(), as = l, Wa = d, as.attachEvent("onpropertychange", od)) : o === "focusout" && ad();
  }
  function S6(o) {
    if (o === "selectionchange" || o === "keyup" || o === "keydown") return _a(Wa);
  }
  function E6(o, l) {
    if (o === "click") return _a(l);
  }
  function sd(o, l) {
    if (o === "input" || o === "change") return _a(l);
  }
  function M6(o, l) {
    return o === l && (o !== 0 || 1 / o === 1 / l) || o !== o && l !== l;
  }
  var Zr = typeof Object.is == "function" ? Object.is : M6;
  function os(o, l) {
    if (Zr(o, l)) return !0;
    if (typeof o != "object" || o === null || typeof l != "object" || l === null) return !1;
    var d = Object.keys(o), A = Object.keys(l);
    if (d.length !== A.length) return !1;
    for (A = 0; A < d.length; A++) {
      var v = d[A];
      if (!h.call(l, v) || !Zr(o[v], l[v])) return !1;
    }
    return !0;
  }
  function ld(o) {
    for (; o && o.firstChild; ) o = o.firstChild;
    return o;
  }
  function ud(o, l) {
    var d = ld(o);
    o = 0;
    for (var A; d; ) {
      if (d.nodeType === 3) {
        if (A = o + d.textContent.length, o <= l && A >= l) return { node: d, offset: l - o };
        o = A;
      }
      e: {
        for (; d; ) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = ld(d);
    }
  }
  function cd(o, l) {
    return o && l ? o === l ? !0 : o && o.nodeType === 3 ? !1 : l && l.nodeType === 3 ? cd(o, l.parentNode) : "contains" in o ? o.contains(l) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function Ll() {
    for (var o = window, l = ue(); l instanceof o.HTMLIFrameElement; ) {
      try {
        var d = typeof l.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) o = l.contentWindow;
      else break;
      l = ue(o.document);
    }
    return l;
  }
  function I0(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l && (l === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || l === "textarea" || o.contentEditable === "true");
  }
  function Rl(o) {
    var l = Ll(), d = o.focusedElem, A = o.selectionRange;
    if (l !== d && d && d.ownerDocument && cd(d.ownerDocument.documentElement, d)) {
      if (A !== null && I0(d)) {
        if (l = A.start, o = A.end, o === void 0 && (o = l), "selectionStart" in d) d.selectionStart = l, d.selectionEnd = Math.min(o, d.value.length);
        else if (o = (l = d.ownerDocument || document) && l.defaultView || window, o.getSelection) {
          o = o.getSelection();
          var v = d.textContent.length, x = Math.min(A.start, v);
          A = A.end === void 0 ? x : Math.min(A.end, v), !o.extend && x > A && (v = A, A = x, x = v), v = ud(d, x);
          var j = ud(
            d,
            A
          );
          v && j && (o.rangeCount !== 1 || o.anchorNode !== v.node || o.anchorOffset !== v.offset || o.focusNode !== j.node || o.focusOffset !== j.offset) && (l = l.createRange(), l.setStart(v.node, v.offset), o.removeAllRanges(), x > A ? (o.addRange(l), o.extend(j.node, j.offset)) : (l.setEnd(j.node, j.offset), o.addRange(l)));
        }
      }
      for (l = [], o = d; o = o.parentNode; ) o.nodeType === 1 && l.push({ element: o, left: o.scrollLeft, top: o.scrollTop });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < l.length; d++) o = l[d], o.element.scrollLeft = o.left, o.element.scrollTop = o.top;
    }
  }
  var gd = I && "documentMode" in document && 11 >= document.documentMode, w3 = null, e4 = null, ss = null, t4 = !1;
  function fd(o, l, d) {
    var A = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    t4 || w3 == null || w3 !== ue(A) || (A = w3, "selectionStart" in A && I0(A) ? A = { start: A.selectionStart, end: A.selectionEnd } : (A = (A.ownerDocument && A.ownerDocument.defaultView || window).getSelection(), A = { anchorNode: A.anchorNode, anchorOffset: A.anchorOffset, focusNode: A.focusNode, focusOffset: A.focusOffset }), ss && os(ss, A) || (ss = A, A = fs(e4, "onSelect"), 0 < A.length && (l = new Vi("onSelect", "select", null, l, d), o.push({ event: l, listeners: A }), l.target = w3)));
  }
  function Ol(o, l) {
    var d = {};
    return d[o.toLowerCase()] = l.toLowerCase(), d["Webkit" + o] = "webkit" + l, d["Moz" + o] = "moz" + l, d;
  }
  var Ji = { animationend: Ol("Animation", "AnimationEnd"), animationiteration: Ol("Animation", "AnimationIteration"), animationstart: Ol("Animation", "AnimationStart"), transitionend: Ol("Transition", "TransitionEnd") }, n4 = {}, r4 = {};
  I && (r4 = document.createElement("div").style, "AnimationEvent" in window || (delete Ji.animationend.animation, delete Ji.animationiteration.animation, delete Ji.animationstart.animation), "TransitionEvent" in window || delete Ji.transitionend.transition);
  function g2(o) {
    if (n4[o]) return n4[o];
    if (!Ji[o]) return o;
    var l = Ji[o], d;
    for (d in l) if (l.hasOwnProperty(d) && d in r4) return n4[o] = l[d];
    return o;
  }
  var i4 = g2("animationend"), dd = g2("animationiteration"), Cd = g2("animationstart"), Ad = g2("transitionend"), Id = /* @__PURE__ */ new Map(), pd = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function p0(o, l) {
    Id.set(o, l), g(l, [o]);
  }
  for (var ls = 0; ls < pd.length; ls++) {
    var Ki = pd[ls], T6 = Ki.toLowerCase(), us = Ki[0].toUpperCase() + Ki.slice(1);
    p0(T6, "on" + us);
  }
  p0(i4, "onAnimationEnd"), p0(dd, "onAnimationIteration"), p0(Cd, "onAnimationStart"), p0("dblclick", "onDoubleClick"), p0("focusin", "onFocus"), p0("focusout", "onBlur"), p0(Ad, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), g("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), g("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), g("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), g("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var cs = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), L6 = new Set("cancel close invalid load scroll toggle".split(" ").concat(cs));
  function hd(o, l, d) {
    var A = o.type || "unknown-event";
    o.currentTarget = d, X1(A, l, void 0, o), o.currentTarget = null;
  }
  function Dl(o, l) {
    l = (l & 4) !== 0;
    for (var d = 0; d < o.length; d++) {
      var A = o[d], v = A.event;
      A = A.listeners;
      e: {
        var x = void 0;
        if (l) for (var j = A.length - 1; 0 <= j; j--) {
          var _ = A[j], X = _.instance, c1 = _.currentTarget;
          if (_ = _.listener, X !== x && v.isPropagationStopped()) break e;
          hd(v, _, c1), x = X;
        }
        else for (j = 0; j < A.length; j++) {
          if (_ = A[j], X = _.instance, c1 = _.currentTarget, _ = _.listener, X !== x && v.isPropagationStopped()) break e;
          hd(v, _, c1), x = X;
        }
      }
    }
    if (Xr) throw o = c0, Xr = !1, c0 = null, o;
  }
  function en(o, l) {
    var d = l[g4];
    d === void 0 && (d = l[g4] = /* @__PURE__ */ new Set());
    var A = o + "__bubble";
    d.has(A) || (md(l, o, 2, !1), d.add(A));
  }
  function X0(o, l, d) {
    var A = 0;
    l && (A |= 4), md(d, o, A, l);
  }
  var h0 = "_reactListening" + Math.random().toString(36).slice(2);
  function Ja(o) {
    if (!o[h0]) {
      o[h0] = !0, a.forEach(function(d) {
        d !== "selectionchange" && (L6.has(d) || X0(d, !1, o), X0(d, !0, o));
      });
      var l = o.nodeType === 9 ? o : o.ownerDocument;
      l === null || l[h0] || (l[h0] = !0, X0("selectionchange", !1, l));
    }
  }
  function md(o, l, d, A) {
    switch (st(l)) {
      case 1:
        var v = M1;
        break;
      case 4:
        v = p1;
        break;
      default:
        v = te;
    }
    d = v.bind(null, l, d, o), v = void 0, !V0 || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (v = !0), A ? v !== void 0 ? o.addEventListener(l, d, { capture: !0, passive: v }) : o.addEventListener(l, d, !0) : v !== void 0 ? o.addEventListener(l, d, { passive: v }) : o.addEventListener(l, d, !1);
  }
  function kl(o, l, d, A, v) {
    var x = A;
    if (!(l & 1) && !(l & 2) && A !== null) e: for (; ; ) {
      if (A === null) return;
      var j = A.tag;
      if (j === 3 || j === 4) {
        var _ = A.stateNode.containerInfo;
        if (_ === v || _.nodeType === 8 && _.parentNode === v) break;
        if (j === 4) for (j = A.return; j !== null; ) {
          var X = j.tag;
          if ((X === 3 || X === 4) && (X = j.stateNode.containerInfo, X === v || X.nodeType === 8 && X.parentNode === v)) return;
          j = j.return;
        }
        for (; _ !== null; ) {
          if (j = $r(_), j === null) return;
          if (X = j.tag, X === 5 || X === 6) {
            A = x = j;
            continue e;
          }
          _ = _.parentNode;
        }
      }
      A = A.return;
    }
    Yn(function() {
      var c1 = x, R1 = zt(d), j1 = [];
      e: {
        var x1 = Id.get(o);
        if (x1 !== void 0) {
          var ge = Vi, me = o;
          switch (o) {
            case "keypress":
              if (u2(d) === 0) break e;
            case "keydown":
            case "keyup":
              ge = v6;
              break;
            case "focusin":
              me = "focus", ge = Q0;
              break;
            case "focusout":
              me = "blur", ge = Q0;
              break;
            case "beforeblur":
            case "afterblur":
              ge = Q0;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              ge = xl;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              ge = Jf;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              ge = y6;
              break;
            case i4:
            case dd:
            case Cd:
              ge = Kf;
              break;
            case Ad:
              ge = Gf;
              break;
            case "scroll":
              ge = Vf;
              break;
            case "wheel":
              ge = A0;
              break;
            case "copy":
            case "cut":
            case "paste":
              ge = h6;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              ge = Sl;
          }
          var be = (l & 4) !== 0, jn = !be && o === "scroll", r1 = be ? x1 !== null ? x1 + "Capture" : null : x1;
          be = [];
          for (var $ = c1, o1; $ !== null; ) {
            o1 = $;
            var _1 = o1.stateNode;
            if (o1.tag === 5 && _1 !== null && (o1 = _1, r1 !== null && (_1 = u0($, r1), _1 != null && be.push(gs($, _1, o1)))), jn) break;
            $ = $.return;
          }
          0 < be.length && (x1 = new ge(x1, me, null, d, R1), j1.push({ event: x1, listeners: be }));
        }
      }
      if (!(l & 7)) {
        e: {
          if (x1 = o === "mouseover" || o === "pointerover", ge = o === "mouseout" || o === "pointerout", x1 && d !== Fn && (me = d.relatedTarget || d.fromElement) && ($r(me) || me[m0])) break e;
          if ((ge || x1) && (x1 = R1.window === R1 ? R1 : (x1 = R1.ownerDocument) ? x1.defaultView || x1.parentWindow : window, ge ? (me = d.relatedTarget || d.toElement, ge = c1, me = me ? $r(me) : null, me !== null && (jn = Ae(me), me !== jn || me.tag !== 5 && me.tag !== 6) && (me = null)) : (ge = null, me = c1), ge !== me)) {
            if (be = xl, _1 = "onMouseLeave", r1 = "onMouseEnter", $ = "mouse", (o === "pointerout" || o === "pointerover") && (be = Sl, _1 = "onPointerLeave", r1 = "onPointerEnter", $ = "pointer"), jn = ge == null ? x1 : Ka(ge), o1 = me == null ? x1 : Ka(me), x1 = new be(_1, $ + "leave", ge, d, R1), x1.target = jn, x1.relatedTarget = o1, _1 = null, $r(R1) === c1 && (be = new be(r1, $ + "enter", me, d, R1), be.target = o1, be.relatedTarget = jn, _1 = be), jn = _1, ge && me) t: {
              for (be = ge, r1 = me, $ = 0, o1 = be; o1; o1 = Yi(o1)) $++;
              for (o1 = 0, _1 = r1; _1; _1 = Yi(_1)) o1++;
              for (; 0 < $ - o1; ) be = Yi(be), $--;
              for (; 0 < o1 - $; ) r1 = Yi(r1), o1--;
              for (; $--; ) {
                if (be === r1 || r1 !== null && be === r1.alternate) break t;
                be = Yi(be), r1 = Yi(r1);
              }
              be = null;
            }
            else be = null;
            ge !== null && a4(j1, x1, ge, be, !1), me !== null && jn !== null && a4(j1, jn, me, be, !0);
          }
        }
        e: {
          if (x1 = c1 ? Ka(c1) : window, ge = x1.nodeName && x1.nodeName.toLowerCase(), ge === "select" || ge === "input" && x1.type === "file") var Ee = rd;
          else if (td(x1)) if (qc) Ee = sd;
          else {
            Ee = S6;
            var He = x6;
          }
          else (ge = x1.nodeName) && ge.toLowerCase() === "input" && (x1.type === "checkbox" || x1.type === "radio") && (Ee = E6);
          if (Ee && (Ee = Ee(o, c1))) {
            nd(j1, Ee, d, R1);
            break e;
          }
          He && He(o, x1, c1), o === "focusout" && (He = x1._wrapperState) && He.controlled && x1.type === "number" && Xe(x1, "number", x1.value);
        }
        switch (He = c1 ? Ka(c1) : window, o) {
          case "focusin":
            (td(He) || He.contentEditable === "true") && (w3 = He, e4 = c1, ss = null);
            break;
          case "focusout":
            ss = e4 = w3 = null;
            break;
          case "mousedown":
            t4 = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            t4 = !1, fd(j1, d, R1);
            break;
          case "selectionchange":
            if (gd) break;
          case "keydown":
          case "keyup":
            fd(j1, d, R1);
        }
        var ve;
        if (b3) e: {
          switch (o) {
            case "compositionstart":
              var Ue = "onCompositionStart";
              break e;
            case "compositionend":
              Ue = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Ue = "onCompositionUpdate";
              break e;
          }
          Ue = void 0;
        }
        else Ua ? $f(o, d) && (Ue = "onCompositionEnd") : o === "keydown" && d.keyCode === 229 && (Ue = "onCompositionStart");
        Ue && (qf && d.locale !== "ko" && (Ua || Ue !== "onCompositionStart" ? Ue === "onCompositionEnd" && Ua && (ve = gn()) : (gt = R1, Xn = "value" in gt ? gt.value : gt.textContent, Ua = !0)), He = fs(c1, Ue), 0 < He.length && (Ue = new Kc(Ue, o, null, d, R1), j1.push({ event: Ue, listeners: He }), ve ? Ue.data = ve : (ve = Tl(d), ve !== null && (Ue.data = ve)))), (ve = Ml ? b6(o, d) : w6(o, d)) && (c1 = fs(c1, "onBeforeInput"), 0 < c1.length && (R1 = new Kc("onBeforeInput", "beforeinput", null, d, R1), j1.push({ event: R1, listeners: c1 }), R1.data = ve));
      }
      Dl(j1, l);
    });
  }
  function gs(o, l, d) {
    return { instance: o, listener: l, currentTarget: d };
  }
  function fs(o, l) {
    for (var d = l + "Capture", A = []; o !== null; ) {
      var v = o, x = v.stateNode;
      v.tag === 5 && x !== null && (v = x, x = u0(o, d), x != null && A.unshift(gs(o, x, v)), x = u0(o, l), x != null && A.push(gs(o, x, v))), o = o.return;
    }
    return A;
  }
  function Yi(o) {
    if (o === null) return null;
    do
      o = o.return;
    while (o && o.tag !== 5);
    return o || null;
  }
  function a4(o, l, d, A, v) {
    for (var x = l._reactName, j = []; d !== null && d !== A; ) {
      var _ = d, X = _.alternate, c1 = _.stateNode;
      if (X !== null && X === A) break;
      _.tag === 5 && c1 !== null && (_ = c1, v ? (X = u0(d, x), X != null && j.unshift(gs(d, X, _))) : v || (X = u0(d, x), X != null && j.push(gs(d, X, _)))), d = d.return;
    }
    j.length !== 0 && o.push({ event: l, listeners: j });
  }
  var o4 = /\r\n?/g, R6 = /\u0000|\uFFFD/g;
  function s4(o) {
    return (typeof o == "string" ? o : "" + o).replace(o4, `
`).replace(R6, "");
  }
  function jl(o, l, d) {
    if (l = s4(l), s4(o) !== l && d) throw Error(i(425));
  }
  function zl() {
  }
  var l4 = null, Qi = null;
  function ds(o, l) {
    return o === "textarea" || o === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var Xi = typeof setTimeout == "function" ? setTimeout : void 0, vd = typeof clearTimeout == "function" ? clearTimeout : void 0, u4 = typeof Promise == "function" ? Promise : void 0, c4 = typeof queueMicrotask == "function" ? queueMicrotask : typeof u4 < "u" ? function(o) {
    return u4.resolve(null).then(o).catch(O6);
  } : Xi;
  function O6(o) {
    setTimeout(function() {
      throw o;
    });
  }
  function G0(o, l) {
    var d = l, A = 0;
    do {
      var v = d.nextSibling;
      if (o.removeChild(d), v && v.nodeType === 8) if (d = v.data, d === "/$") {
        if (A === 0) {
          o.removeChild(v), U(l);
          return;
        }
        A--;
      } else d !== "$" && d !== "$?" && d !== "$!" || A++;
      d = v;
    } while (d);
    U(l);
  }
  function x3(o) {
    for (; o != null; o = o.nextSibling) {
      var l = o.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = o.data, l === "$" || l === "$!" || l === "$?") break;
        if (l === "/$") return null;
      }
    }
    return o;
  }
  function Cs(o) {
    o = o.previousSibling;
    for (var l = 0; o; ) {
      if (o.nodeType === 8) {
        var d = o.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (l === 0) return o;
          l--;
        } else d === "/$" && l++;
      }
      o = o.previousSibling;
    }
    return null;
  }
  var q0 = Math.random().toString(36).slice(2), H3 = "__reactFiber$" + q0, Gi = "__reactProps$" + q0, m0 = "__reactContainer$" + q0, g4 = "__reactEvents$" + q0, D6 = "__reactListeners$" + q0, f4 = "__reactHandles$" + q0;
  function $r(o) {
    var l = o[H3];
    if (l) return l;
    for (var d = o.parentNode; d; ) {
      if (l = d[m0] || d[H3]) {
        if (d = l.alternate, l.child !== null || d !== null && d.child !== null) for (o = Cs(o); o !== null; ) {
          if (d = o[H3]) return d;
          o = Cs(o);
        }
        return l;
      }
      o = d, d = o.parentNode;
    }
    return null;
  }
  function As(o) {
    return o = o[H3] || o[m0], !o || o.tag !== 5 && o.tag !== 6 && o.tag !== 13 && o.tag !== 3 ? null : o;
  }
  function Ka(o) {
    if (o.tag === 5 || o.tag === 6) return o.stateNode;
    throw Error(i(33));
  }
  function ze(o) {
    return o[Gi] || null;
  }
  var Z0 = [], on = -1;
  function Ze(o) {
    return { current: o };
  }
  function Mt(o) {
    0 > on || (o.current = Z0[on], Z0[on] = null, on--);
  }
  function kt(o, l) {
    on++, Z0[on] = o.current, o.current = l;
  }
  var U3 = {}, _e = Ze(U3), xn = Ze(!1), Cr = U3;
  function e3(o, l) {
    var d = o.type.contextTypes;
    if (!d) return U3;
    var A = o.stateNode;
    if (A && A.__reactInternalMemoizedUnmaskedChildContext === l) return A.__reactInternalMemoizedMaskedChildContext;
    var v = {}, x;
    for (x in d) v[x] = l[x];
    return A && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = l, o.__reactInternalMemoizedMaskedChildContext = v), v;
  }
  function fn(o) {
    return o = o.childContextTypes, o != null;
  }
  function t3() {
    Mt(xn), Mt(_e);
  }
  function $0(o, l, d) {
    if (_e.current !== U3) throw Error(i(168));
    kt(_e, l), kt(xn, d);
  }
  function Is(o, l, d) {
    var A = o.stateNode;
    if (l = l.childContextTypes, typeof A.getChildContext != "function") return d;
    A = A.getChildContext();
    for (var v in A) if (!(v in l)) throw Error(i(108, $1(o) || "Unknown", v));
    return t1({}, d, A);
  }
  function Nl(o) {
    return o = (o = o.stateNode) && o.__reactInternalMemoizedMergedChildContext || U3, Cr = _e.current, kt(_e, o), kt(xn, xn.current), !0;
  }
  function yd(o, l, d) {
    var A = o.stateNode;
    if (!A) throw Error(i(169));
    d ? (o = Is(o, l, Cr), A.__reactInternalMemoizedMergedChildContext = o, Mt(xn), Mt(_e), kt(_e, o)) : Mt(xn), kt(xn, d);
  }
  var Nr = null, f2 = !1, ps = !1;
  function d4(o) {
    Nr === null ? Nr = [o] : Nr.push(o);
  }
  function C4(o) {
    f2 = !0, d4(o);
  }
  function Ar() {
    if (!ps && Nr !== null) {
      ps = !0;
      var o = 0, l = Be;
      try {
        var d = Nr;
        for (Be = 1; o < d.length; o++) {
          var A = d[o];
          do
            A = A(!0);
          while (A !== null);
        }
        Nr = null, f2 = !1;
      } catch (v) {
        throw Nr !== null && (Nr = Nr.slice(o + 1)), Pt(_2, Ar), v;
      } finally {
        Be = l, ps = !1;
      }
    }
    return null;
  }
  var ei = [], Ir = 0, qi = null, Ya = 0, pr = [], F2 = 0, n3 = null, b2 = 1, v0 = "";
  function Pr(o, l) {
    ei[Ir++] = Ya, ei[Ir++] = qi, qi = o, Ya = l;
  }
  function A4(o, l, d) {
    pr[F2++] = b2, pr[F2++] = v0, pr[F2++] = n3, n3 = o;
    var A = b2;
    o = v0;
    var v = 32 - lr(A) - 1;
    A &= ~(1 << v), d += 1;
    var x = 32 - lr(l) + v;
    if (30 < x) {
      var j = v - v % 5;
      x = (A & (1 << j) - 1).toString(32), A >>= j, v -= j, b2 = 1 << 32 - lr(l) + v | d << v | A, v0 = x + o;
    } else b2 = 1 << x | d << v | A, v0 = o;
  }
  function Pl(o) {
    o.return !== null && (Pr(o, 1), A4(o, 1, 0));
  }
  function I4(o) {
    for (; o === qi; ) qi = ei[--Ir], ei[Ir] = null, Ya = ei[--Ir], ei[Ir] = null;
    for (; o === n3; ) n3 = pr[--F2], pr[F2] = null, v0 = pr[--F2], pr[F2] = null, b2 = pr[--F2], pr[F2] = null;
  }
  var Fr = null, hr = null, sn = !1, r3 = null;
  function p4(o, l) {
    var d = g3(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = l, d.return = o, l = o.deletions, l === null ? (o.deletions = [d], o.flags |= 16) : l.push(d);
  }
  function bd(o, l) {
    switch (o.tag) {
      case 5:
        var d = o.type;
        return l = l.nodeType !== 1 || d.toLowerCase() !== l.nodeName.toLowerCase() ? null : l, l !== null ? (o.stateNode = l, Fr = o, hr = x3(l.firstChild), !0) : !1;
      case 6:
        return l = o.pendingProps === "" || l.nodeType !== 3 ? null : l, l !== null ? (o.stateNode = l, Fr = o, hr = null, !0) : !1;
      case 13:
        return l = l.nodeType !== 8 ? null : l, l !== null ? (d = n3 !== null ? { id: b2, overflow: v0 } : null, o.memoizedState = { dehydrated: l, treeContext: d, retryLane: 1073741824 }, d = g3(18, null, null, 0), d.stateNode = l, d.return = o, o.child = d, Fr = o, hr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Fl(o) {
    return (o.mode & 1) !== 0 && (o.flags & 128) === 0;
  }
  function Bl(o) {
    if (sn) {
      var l = hr;
      if (l) {
        var d = l;
        if (!bd(o, l)) {
          if (Fl(o)) throw Error(i(418));
          l = x3(d.nextSibling);
          var A = Fr;
          l && bd(o, l) ? p4(A, d) : (o.flags = o.flags & -4097 | 2, sn = !1, Fr = o);
        }
      } else {
        if (Fl(o)) throw Error(i(418));
        o.flags = o.flags & -4097 | 2, sn = !1, Fr = o;
      }
    }
  }
  function wd(o) {
    for (o = o.return; o !== null && o.tag !== 5 && o.tag !== 3 && o.tag !== 13; ) o = o.return;
    Fr = o;
  }
  function Hl(o) {
    if (o !== Fr) return !1;
    if (!sn) return wd(o), sn = !0, !1;
    var l;
    if ((l = o.tag !== 3) && !(l = o.tag !== 5) && (l = o.type, l = l !== "head" && l !== "body" && !ds(o.type, o.memoizedProps)), l && (l = hr)) {
      if (Fl(o)) throw xd(), Error(i(418));
      for (; l; ) p4(o, l), l = x3(l.nextSibling);
    }
    if (wd(o), o.tag === 13) {
      if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(i(317));
      e: {
        for (o = o.nextSibling, l = 0; o; ) {
          if (o.nodeType === 8) {
            var d = o.data;
            if (d === "/$") {
              if (l === 0) {
                hr = x3(o.nextSibling);
                break e;
              }
              l--;
            } else d !== "$" && d !== "$!" && d !== "$?" || l++;
          }
          o = o.nextSibling;
        }
        hr = null;
      }
    } else hr = Fr ? x3(o.stateNode.nextSibling) : null;
    return !0;
  }
  function xd() {
    for (var o = hr; o; ) o = x3(o.nextSibling);
  }
  function pn() {
    hr = Fr = null, sn = !1;
  }
  function h4(o) {
    r3 === null ? r3 = [o] : r3.push(o);
  }
  var Ul = Y.ReactCurrentBatchConfig;
  function Zi(o, l, d) {
    if (o = d.ref, o !== null && typeof o != "function" && typeof o != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var A = d.stateNode;
        }
        if (!A) throw Error(i(147, o));
        var v = A, x = "" + o;
        return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === x ? l.ref : (l = function(j) {
          var _ = v.refs;
          j === null ? delete _[x] : _[x] = j;
        }, l._stringRef = x, l);
      }
      if (typeof o != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, o));
    }
    return o;
  }
  function W3(o, l) {
    throw o = Object.prototype.toString.call(l), Error(i(31, o === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : o));
  }
  function Sd(o) {
    var l = o._init;
    return l(o._payload);
  }
  function Wl(o) {
    function l(r1, $) {
      if (o) {
        var o1 = r1.deletions;
        o1 === null ? (r1.deletions = [$], r1.flags |= 16) : o1.push($);
      }
    }
    function d(r1, $) {
      if (!o) return null;
      for (; $ !== null; ) l(r1, $), $ = $.sibling;
      return null;
    }
    function A(r1, $) {
      for (r1 = /* @__PURE__ */ new Map(); $ !== null; ) $.key !== null ? r1.set($.key, $) : r1.set($.index, $), $ = $.sibling;
      return r1;
    }
    function v(r1, $) {
      return r1 = li(r1, $), r1.index = 0, r1.sibling = null, r1;
    }
    function x(r1, $, o1) {
      return r1.index = o1, o ? (o1 = r1.alternate, o1 !== null ? (o1 = o1.index, o1 < $ ? (r1.flags |= 2, $) : o1) : (r1.flags |= 2, $)) : (r1.flags |= 1048576, $);
    }
    function j(r1) {
      return o && r1.alternate === null && (r1.flags |= 2), r1;
    }
    function _(r1, $, o1, _1) {
      return $ === null || $.tag !== 6 ? ($ = Lu(o1, r1.mode, _1), $.return = r1, $) : ($ = v($, o1), $.return = r1, $);
    }
    function X(r1, $, o1, _1) {
      var Ee = o1.type;
      return Ee === Q ? R1(r1, $, o1.props.children, _1, o1.key) : $ !== null && ($.elementType === Ee || typeof Ee == "object" && Ee !== null && Ee.$$typeof === C1 && Sd(Ee) === $.type) ? (_1 = v($, o1.props), _1.ref = Zi(r1, $, o1), _1.return = r1, _1) : (_1 = Mu(o1.type, o1.key, o1.props, null, r1.mode, _1), _1.ref = Zi(r1, $, o1), _1.return = r1, _1);
    }
    function c1(r1, $, o1, _1) {
      return $ === null || $.tag !== 4 || $.stateNode.containerInfo !== o1.containerInfo || $.stateNode.implementation !== o1.implementation ? ($ = zs(o1, r1.mode, _1), $.return = r1, $) : ($ = v($, o1.children || []), $.return = r1, $);
    }
    function R1(r1, $, o1, _1, Ee) {
      return $ === null || $.tag !== 7 ? ($ = da(o1, r1.mode, _1, Ee), $.return = r1, $) : ($ = v($, o1), $.return = r1, $);
    }
    function j1(r1, $, o1) {
      if (typeof $ == "string" && $ !== "" || typeof $ == "number") return $ = Lu("" + $, r1.mode, o1), $.return = r1, $;
      if (typeof $ == "object" && $ !== null) {
        switch ($.$$typeof) {
          case H:
            return o1 = Mu($.type, $.key, $.props, null, r1.mode, o1), o1.ref = Zi(r1, null, $), o1.return = r1, o1;
          case Z:
            return $ = zs($, r1.mode, o1), $.return = r1, $;
          case C1:
            var _1 = $._init;
            return j1(r1, _1($._payload), o1);
        }
        if (St($) || B1($)) return $ = da($, r1.mode, o1, null), $.return = r1, $;
        W3(r1, $);
      }
      return null;
    }
    function x1(r1, $, o1, _1) {
      var Ee = $ !== null ? $.key : null;
      if (typeof o1 == "string" && o1 !== "" || typeof o1 == "number") return Ee !== null ? null : _(r1, $, "" + o1, _1);
      if (typeof o1 == "object" && o1 !== null) {
        switch (o1.$$typeof) {
          case H:
            return o1.key === Ee ? X(r1, $, o1, _1) : null;
          case Z:
            return o1.key === Ee ? c1(r1, $, o1, _1) : null;
          case C1:
            return Ee = o1._init, x1(
              r1,
              $,
              Ee(o1._payload),
              _1
            );
        }
        if (St(o1) || B1(o1)) return Ee !== null ? null : R1(r1, $, o1, _1, null);
        W3(r1, o1);
      }
      return null;
    }
    function ge(r1, $, o1, _1, Ee) {
      if (typeof _1 == "string" && _1 !== "" || typeof _1 == "number") return r1 = r1.get(o1) || null, _($, r1, "" + _1, Ee);
      if (typeof _1 == "object" && _1 !== null) {
        switch (_1.$$typeof) {
          case H:
            return r1 = r1.get(_1.key === null ? o1 : _1.key) || null, X($, r1, _1, Ee);
          case Z:
            return r1 = r1.get(_1.key === null ? o1 : _1.key) || null, c1($, r1, _1, Ee);
          case C1:
            var He = _1._init;
            return ge(r1, $, o1, He(_1._payload), Ee);
        }
        if (St(_1) || B1(_1)) return r1 = r1.get(o1) || null, R1($, r1, _1, Ee, null);
        W3($, _1);
      }
      return null;
    }
    function me(r1, $, o1, _1) {
      for (var Ee = null, He = null, ve = $, Ue = $ = 0, t2 = null; ve !== null && Ue < o1.length; Ue++) {
        ve.index > Ue ? (t2 = ve, ve = null) : t2 = ve.sibling;
        var bt = x1(r1, ve, o1[Ue], _1);
        if (bt === null) {
          ve === null && (ve = t2);
          break;
        }
        o && ve && bt.alternate === null && l(r1, ve), $ = x(bt, $, Ue), He === null ? Ee = bt : He.sibling = bt, He = bt, ve = t2;
      }
      if (Ue === o1.length) return d(r1, ve), sn && Pr(r1, Ue), Ee;
      if (ve === null) {
        for (; Ue < o1.length; Ue++) ve = j1(r1, o1[Ue], _1), ve !== null && ($ = x(ve, $, Ue), He === null ? Ee = ve : He.sibling = ve, He = ve);
        return sn && Pr(r1, Ue), Ee;
      }
      for (ve = A(r1, ve); Ue < o1.length; Ue++) t2 = ge(ve, r1, Ue, o1[Ue], _1), t2 !== null && (o && t2.alternate !== null && ve.delete(t2.key === null ? Ue : t2.key), $ = x(t2, $, Ue), He === null ? Ee = t2 : He.sibling = t2, He = t2);
      return o && ve.forEach(function(M0) {
        return l(r1, M0);
      }), sn && Pr(r1, Ue), Ee;
    }
    function be(r1, $, o1, _1) {
      var Ee = B1(o1);
      if (typeof Ee != "function") throw Error(i(150));
      if (o1 = Ee.call(o1), o1 == null) throw Error(i(151));
      for (var He = Ee = null, ve = $, Ue = $ = 0, t2 = null, bt = o1.next(); ve !== null && !bt.done; Ue++, bt = o1.next()) {
        ve.index > Ue ? (t2 = ve, ve = null) : t2 = ve.sibling;
        var M0 = x1(r1, ve, bt.value, _1);
        if (M0 === null) {
          ve === null && (ve = t2);
          break;
        }
        o && ve && M0.alternate === null && l(r1, ve), $ = x(M0, $, Ue), He === null ? Ee = M0 : He.sibling = M0, He = M0, ve = t2;
      }
      if (bt.done) return d(
        r1,
        ve
      ), sn && Pr(r1, Ue), Ee;
      if (ve === null) {
        for (; !bt.done; Ue++, bt = o1.next()) bt = j1(r1, bt.value, _1), bt !== null && ($ = x(bt, $, Ue), He === null ? Ee = bt : He.sibling = bt, He = bt);
        return sn && Pr(r1, Ue), Ee;
      }
      for (ve = A(r1, ve); !bt.done; Ue++, bt = o1.next()) bt = ge(ve, r1, Ue, bt.value, _1), bt !== null && (o && bt.alternate !== null && ve.delete(bt.key === null ? Ue : bt.key), $ = x(bt, $, Ue), He === null ? Ee = bt : He.sibling = bt, He = bt);
      return o && ve.forEach(function(G6) {
        return l(r1, G6);
      }), sn && Pr(r1, Ue), Ee;
    }
    function jn(r1, $, o1, _1) {
      if (typeof o1 == "object" && o1 !== null && o1.type === Q && o1.key === null && (o1 = o1.props.children), typeof o1 == "object" && o1 !== null) {
        switch (o1.$$typeof) {
          case H:
            e: {
              for (var Ee = o1.key, He = $; He !== null; ) {
                if (He.key === Ee) {
                  if (Ee = o1.type, Ee === Q) {
                    if (He.tag === 7) {
                      d(r1, He.sibling), $ = v(He, o1.props.children), $.return = r1, r1 = $;
                      break e;
                    }
                  } else if (He.elementType === Ee || typeof Ee == "object" && Ee !== null && Ee.$$typeof === C1 && Sd(Ee) === He.type) {
                    d(r1, He.sibling), $ = v(He, o1.props), $.ref = Zi(r1, He, o1), $.return = r1, r1 = $;
                    break e;
                  }
                  d(r1, He);
                  break;
                } else l(r1, He);
                He = He.sibling;
              }
              o1.type === Q ? ($ = da(o1.props.children, r1.mode, _1, o1.key), $.return = r1, r1 = $) : (_1 = Mu(o1.type, o1.key, o1.props, null, r1.mode, _1), _1.ref = Zi(r1, $, o1), _1.return = r1, r1 = _1);
            }
            return j(r1);
          case Z:
            e: {
              for (He = o1.key; $ !== null; ) {
                if ($.key === He) if ($.tag === 4 && $.stateNode.containerInfo === o1.containerInfo && $.stateNode.implementation === o1.implementation) {
                  d(r1, $.sibling), $ = v($, o1.children || []), $.return = r1, r1 = $;
                  break e;
                } else {
                  d(r1, $);
                  break;
                }
                else l(r1, $);
                $ = $.sibling;
              }
              $ = zs(o1, r1.mode, _1), $.return = r1, r1 = $;
            }
            return j(r1);
          case C1:
            return He = o1._init, jn(r1, $, He(o1._payload), _1);
        }
        if (St(o1)) return me(r1, $, o1, _1);
        if (B1(o1)) return be(r1, $, o1, _1);
        W3(r1, o1);
      }
      return typeof o1 == "string" && o1 !== "" || typeof o1 == "number" ? (o1 = "" + o1, $ !== null && $.tag === 6 ? (d(r1, $.sibling), $ = v($, o1), $.return = r1, r1 = $) : (d(r1, $), $ = Lu(o1, r1.mode, _1), $.return = r1, r1 = $), j(r1)) : d(r1, $);
    }
    return jn;
  }
  var Qa = Wl(!0), Ed = Wl(!1), y0 = Ze(null), qn = null, q1 = null, i3 = null;
  function Br() {
    i3 = q1 = qn = null;
  }
  function m4(o) {
    var l = y0.current;
    Mt(y0), o._currentValue = l;
  }
  function v4(o, l, d) {
    for (; o !== null; ) {
      var A = o.alternate;
      if ((o.childLanes & l) !== l ? (o.childLanes |= l, A !== null && (A.childLanes |= l)) : A !== null && (A.childLanes & l) !== l && (A.childLanes |= l), o === d) break;
      o = o.return;
    }
  }
  function Xa(o, l) {
    qn = o, i3 = q1 = null, o = o.dependencies, o !== null && o.firstContext !== null && (o.lanes & l && (yr = !0), o.firstContext = null);
  }
  function a3(o) {
    var l = o._currentValue;
    if (i3 !== o) if (o = { context: o, memoizedValue: l, next: null }, q1 === null) {
      if (qn === null) throw Error(i(308));
      q1 = o, qn.dependencies = { lanes: 0, firstContext: o };
    } else q1 = q1.next = o;
    return l;
  }
  var $i = null;
  function Un(o) {
    $i === null ? $i = [o] : $i.push(o);
  }
  function Md(o, l, d, A) {
    var v = l.interleaved;
    return v === null ? (d.next = d, Un(l)) : (d.next = v.next, v.next = d), l.interleaved = d, b0(o, A);
  }
  function b0(o, l) {
    o.lanes |= l;
    var d = o.alternate;
    for (d !== null && (d.lanes |= l), d = o, o = o.return; o !== null; ) o.childLanes |= l, d = o.alternate, d !== null && (d.childLanes |= l), d = o, o = o.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var ti = !1;
  function Vl(o) {
    o.updateQueue = { baseState: o.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function Ga(o, l) {
    o = o.updateQueue, l.updateQueue === o && (l.updateQueue = { baseState: o.baseState, firstBaseUpdate: o.firstBaseUpdate, lastBaseUpdate: o.lastBaseUpdate, shared: o.shared, effects: o.effects });
  }
  function mr(o, l) {
    return { eventTime: o, lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function ni(o, l, d) {
    var A = o.updateQueue;
    if (A === null) return null;
    if (A = A.shared, ft & 2) {
      var v = A.pending;
      return v === null ? l.next = l : (l.next = v.next, v.next = l), A.pending = l, b0(o, d);
    }
    return v = A.interleaved, v === null ? (l.next = l, Un(A)) : (l.next = v.next, v.next = l), A.interleaved = l, b0(o, d);
  }
  function _l(o, l, d) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (d & 4194240) !== 0)) {
      var A = l.lanes;
      A &= o.pendingLanes, d |= A, l.lanes = d, Bi(o, d);
    }
  }
  function Td(o, l) {
    var d = o.updateQueue, A = o.alternate;
    if (A !== null && (A = A.updateQueue, d === A)) {
      var v = null, x = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var j = { eventTime: d.eventTime, lane: d.lane, tag: d.tag, payload: d.payload, callback: d.callback, next: null };
          x === null ? v = x = j : x = x.next = j, d = d.next;
        } while (d !== null);
        x === null ? v = x = l : x = x.next = l;
      } else v = x = l;
      d = { baseState: A.baseState, firstBaseUpdate: v, lastBaseUpdate: x, shared: A.shared, effects: A.effects }, o.updateQueue = d;
      return;
    }
    o = d.lastBaseUpdate, o === null ? d.firstBaseUpdate = l : o.next = l, d.lastBaseUpdate = l;
  }
  function Jl(o, l, d, A) {
    var v = o.updateQueue;
    ti = !1;
    var x = v.firstBaseUpdate, j = v.lastBaseUpdate, _ = v.shared.pending;
    if (_ !== null) {
      v.shared.pending = null;
      var X = _, c1 = X.next;
      X.next = null, j === null ? x = c1 : j.next = c1, j = X;
      var R1 = o.alternate;
      R1 !== null && (R1 = R1.updateQueue, _ = R1.lastBaseUpdate, _ !== j && (_ === null ? R1.firstBaseUpdate = c1 : _.next = c1, R1.lastBaseUpdate = X));
    }
    if (x !== null) {
      var j1 = v.baseState;
      j = 0, R1 = c1 = X = null, _ = x;
      do {
        var x1 = _.lane, ge = _.eventTime;
        if ((A & x1) === x1) {
          R1 !== null && (R1 = R1.next = {
            eventTime: ge,
            lane: 0,
            tag: _.tag,
            payload: _.payload,
            callback: _.callback,
            next: null
          });
          e: {
            var me = o, be = _;
            switch (x1 = l, ge = d, be.tag) {
              case 1:
                if (me = be.payload, typeof me == "function") {
                  j1 = me.call(ge, j1, x1);
                  break e;
                }
                j1 = me;
                break e;
              case 3:
                me.flags = me.flags & -65537 | 128;
              case 0:
                if (me = be.payload, x1 = typeof me == "function" ? me.call(ge, j1, x1) : me, x1 == null) break e;
                j1 = t1({}, j1, x1);
                break e;
              case 2:
                ti = !0;
            }
          }
          _.callback !== null && _.lane !== 0 && (o.flags |= 64, x1 = v.effects, x1 === null ? v.effects = [_] : x1.push(_));
        } else ge = { eventTime: ge, lane: x1, tag: _.tag, payload: _.payload, callback: _.callback, next: null }, R1 === null ? (c1 = R1 = ge, X = j1) : R1 = R1.next = ge, j |= x1;
        if (_ = _.next, _ === null) {
          if (_ = v.shared.pending, _ === null) break;
          x1 = _, _ = x1.next, x1.next = null, v.lastBaseUpdate = x1, v.shared.pending = null;
        }
      } while (!0);
      if (R1 === null && (X = j1), v.baseState = X, v.firstBaseUpdate = c1, v.lastBaseUpdate = R1, l = v.shared.interleaved, l !== null) {
        v = l;
        do
          j |= v.lane, v = v.next;
        while (v !== l);
      } else x === null && (v.shared.lanes = 0);
      ua |= j, o.lanes = j, o.memoizedState = j1;
    }
  }
  function Ld(o, l, d) {
    if (o = l.effects, l.effects = null, o !== null) for (l = 0; l < o.length; l++) {
      var A = o[l], v = A.callback;
      if (v !== null) {
        if (A.callback = null, A = d, typeof v != "function") throw Error(i(191, v));
        v.call(A);
      }
    }
  }
  var hs = {}, S3 = Ze(hs), qa = Ze(hs), ms = Ze(hs);
  function ea(o) {
    if (o === hs) throw Error(i(174));
    return o;
  }
  function y4(o, l) {
    switch (kt(ms, l), kt(qa, o), kt(S3, hs), o = l.nodeType, o) {
      case 9:
      case 11:
        l = (l = l.documentElement) ? l.namespaceURI : tn(null, "");
        break;
      default:
        o = o === 8 ? l.parentNode : l, l = o.namespaceURI || null, o = o.tagName, l = tn(l, o);
    }
    Mt(S3), kt(S3, l);
  }
  function Za() {
    Mt(S3), Mt(qa), Mt(ms);
  }
  function Rd(o) {
    ea(ms.current);
    var l = ea(S3.current), d = tn(l, o.type);
    l !== d && (kt(qa, o), kt(S3, d));
  }
  function b4(o) {
    qa.current === o && (Mt(S3), Mt(qa));
  }
  var dn = Ze(0);
  function Kl(o) {
    for (var l = o; l !== null; ) {
      if (l.tag === 13) {
        var d = l.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return l;
      } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
        if (l.flags & 128) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === o) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === o) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Yl = [];
  function w4() {
    for (var o = 0; o < Yl.length; o++) Yl[o]._workInProgressVersionPrimary = null;
    Yl.length = 0;
  }
  var Ql = Y.ReactCurrentDispatcher, vs = Y.ReactCurrentBatchConfig, Se = 0, Te = null, Je = null, lt = null, Hr = !1, $a = !1, ys = 0, k6 = 0;
  function B2() {
    throw Error(i(321));
  }
  function bs(o, l) {
    if (l === null) return !1;
    for (var d = 0; d < l.length && d < o.length; d++) if (!Zr(o[d], l[d])) return !1;
    return !0;
  }
  function w1(o, l, d, A, v, x) {
    if (Se = x, Te = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, Ql.current = o === null || o.memoizedState === null ? j6 : an, o = d(A, v), $a) {
      x = 0;
      do {
        if ($a = !1, ys = 0, 25 <= x) throw Error(i(301));
        x += 1, lt = Je = null, l.updateQueue = null, Ql.current = uu, o = d(A, v);
      } while ($a);
    }
    if (Ql.current = H2, l = Je !== null && Je.next !== null, Se = 0, lt = Je = Te = null, Hr = !1, l) throw Error(i(300));
    return o;
  }
  function Wn() {
    var o = ys !== 0;
    return ys = 0, o;
  }
  function Re() {
    var o = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return lt === null ? Te.memoizedState = lt = o : lt = lt.next = o, lt;
  }
  function w2() {
    if (Je === null) {
      var o = Te.alternate;
      o = o !== null ? o.memoizedState : null;
    } else o = Je.next;
    var l = lt === null ? Te.memoizedState : lt.next;
    if (l !== null) lt = l, Je = o;
    else {
      if (o === null) throw Error(i(310));
      Je = o, o = { memoizedState: Je.memoizedState, baseState: Je.baseState, baseQueue: Je.baseQueue, queue: Je.queue, next: null }, lt === null ? Te.memoizedState = lt = o : lt = lt.next = o;
    }
    return lt;
  }
  function Ur(o, l) {
    return typeof l == "function" ? l(o) : l;
  }
  function w0(o) {
    var l = w2(), d = l.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = o;
    var A = Je, v = A.baseQueue, x = d.pending;
    if (x !== null) {
      if (v !== null) {
        var j = v.next;
        v.next = x.next, x.next = j;
      }
      A.baseQueue = v = x, d.pending = null;
    }
    if (v !== null) {
      x = v.next, A = A.baseState;
      var _ = j = null, X = null, c1 = x;
      do {
        var R1 = c1.lane;
        if ((Se & R1) === R1) X !== null && (X = X.next = { lane: 0, action: c1.action, hasEagerState: c1.hasEagerState, eagerState: c1.eagerState, next: null }), A = c1.hasEagerState ? c1.eagerState : o(A, c1.action);
        else {
          var j1 = {
            lane: R1,
            action: c1.action,
            hasEagerState: c1.hasEagerState,
            eagerState: c1.eagerState,
            next: null
          };
          X === null ? (_ = X = j1, j = A) : X = X.next = j1, Te.lanes |= R1, ua |= R1;
        }
        c1 = c1.next;
      } while (c1 !== null && c1 !== x);
      X === null ? j = A : X.next = _, Zr(A, l.memoizedState) || (yr = !0), l.memoizedState = A, l.baseState = j, l.baseQueue = X, d.lastRenderedState = A;
    }
    if (o = d.interleaved, o !== null) {
      v = o;
      do
        x = v.lane, Te.lanes |= x, ua |= x, v = v.next;
      while (v !== o);
    } else v === null && (d.lanes = 0);
    return [l.memoizedState, d.dispatch];
  }
  function o3(o) {
    var l = w2(), d = l.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = o;
    var A = d.dispatch, v = d.pending, x = l.memoizedState;
    if (v !== null) {
      d.pending = null;
      var j = v = v.next;
      do
        x = o(x, j.action), j = j.next;
      while (j !== v);
      Zr(x, l.memoizedState) || (yr = !0), l.memoizedState = x, l.baseQueue === null && (l.baseState = x), d.lastRenderedState = x;
    }
    return [x, A];
  }
  function eo() {
  }
  function ta(o, l) {
    var d = Te, A = w2(), v = l(), x = !Zr(A.memoizedState, v);
    if (x && (A.memoizedState = v, yr = !0), A = A.queue, ws(Gl.bind(null, d, A, o), [o]), A.getSnapshot !== l || x || lt !== null && lt.memoizedState.tag & 1) {
      if (d.flags |= 2048, na(9, Xl.bind(null, d, A, v, l), void 0, null), En === null) throw Error(i(349));
      Se & 30 || to(d, l, v);
    }
    return v;
  }
  function to(o, l, d) {
    o.flags |= 16384, o = { getSnapshot: l, value: d }, l = Te.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Te.updateQueue = l, l.stores = [o]) : (d = l.stores, d === null ? l.stores = [o] : d.push(o));
  }
  function Xl(o, l, d, A) {
    l.value = d, l.getSnapshot = A, ql(l) && Zl(o);
  }
  function Gl(o, l, d) {
    return d(function() {
      ql(l) && Zl(o);
    });
  }
  function ql(o) {
    var l = o.getSnapshot;
    o = o.value;
    try {
      var d = l();
      return !Zr(o, d);
    } catch {
      return !0;
    }
  }
  function Zl(o) {
    var l = b0(o, 1);
    l !== null && hn(l, o, 1, -1);
  }
  function $l(o) {
    var l = Re();
    return typeof o == "function" && (o = o()), l.memoizedState = l.baseState = o, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ur, lastRenderedState: o }, l.queue = o, o = o.dispatch = xs.bind(null, Te, o), [l.memoizedState, o];
  }
  function na(o, l, d, A) {
    return o = { tag: o, create: l, destroy: d, deps: A, next: null }, l = Te.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Te.updateQueue = l, l.lastEffect = o.next = o) : (d = l.lastEffect, d === null ? l.lastEffect = o.next = o : (A = d.next, d.next = o, o.next = A, l.lastEffect = o)), o;
  }
  function eu() {
    return w2().memoizedState;
  }
  function no(o, l, d, A) {
    var v = Re();
    Te.flags |= o, v.memoizedState = na(1 | l, d, void 0, A === void 0 ? null : A);
  }
  function ro(o, l, d, A) {
    var v = w2();
    A = A === void 0 ? null : A;
    var x = void 0;
    if (Je !== null) {
      var j = Je.memoizedState;
      if (x = j.destroy, A !== null && bs(A, j.deps)) {
        v.memoizedState = na(l, d, x, A);
        return;
      }
    }
    Te.flags |= o, v.memoizedState = na(1 | l, d, x, A);
  }
  function tu(o, l) {
    return no(8390656, 8, o, l);
  }
  function ws(o, l) {
    return ro(2048, 8, o, l);
  }
  function nu(o, l) {
    return ro(4, 2, o, l);
  }
  function ru(o, l) {
    return ro(4, 4, o, l);
  }
  function iu(o, l) {
    if (typeof l == "function") return o = o(), l(o), function() {
      l(null);
    };
    if (l != null) return o = o(), l.current = o, function() {
      l.current = null;
    };
  }
  function au(o, l, d) {
    return d = d != null ? d.concat([o]) : null, ro(4, 4, iu.bind(null, l, o), d);
  }
  function io() {
  }
  function ra(o, l) {
    var d = w2();
    l = l === void 0 ? null : l;
    var A = d.memoizedState;
    return A !== null && l !== null && bs(l, A[1]) ? A[0] : (d.memoizedState = [o, l], o);
  }
  function ou(o, l) {
    var d = w2();
    l = l === void 0 ? null : l;
    var A = d.memoizedState;
    return A !== null && l !== null && bs(l, A[1]) ? A[0] : (o = o(), d.memoizedState = [o, l], o);
  }
  function su(o, l, d) {
    return Se & 21 ? (Zr(d, l) || (d = Na(), Te.lanes |= d, ua |= d, o.baseState = !0), l) : (o.baseState && (o.baseState = !1, yr = !0), o.memoizedState = d);
  }
  function x4(o, l) {
    var d = Be;
    Be = d !== 0 && 4 > d ? d : 4, o(!0);
    var A = vs.transition;
    vs.transition = {};
    try {
      o(!1), l();
    } finally {
      Be = d, vs.transition = A;
    }
  }
  function lu() {
    return w2().memoizedState;
  }
  function Od(o, l, d) {
    var A = E0(o);
    if (d = { lane: A, action: d, hasEagerState: !1, eagerState: null, next: null }, S4(o)) ao(l, d);
    else if (d = Md(o, l, d, A), d !== null) {
      var v = A2();
      hn(d, o, A, v), ri(d, l, A);
    }
  }
  function xs(o, l, d) {
    var A = E0(o), v = { lane: A, action: d, hasEagerState: !1, eagerState: null, next: null };
    if (S4(o)) ao(l, v);
    else {
      var x = o.alternate;
      if (o.lanes === 0 && (x === null || x.lanes === 0) && (x = l.lastRenderedReducer, x !== null)) try {
        var j = l.lastRenderedState, _ = x(j, d);
        if (v.hasEagerState = !0, v.eagerState = _, Zr(_, j)) {
          var X = l.interleaved;
          X === null ? (v.next = v, Un(l)) : (v.next = X.next, X.next = v), l.interleaved = v;
          return;
        }
      } catch {
      } finally {
      }
      d = Md(o, l, v, A), d !== null && (v = A2(), hn(d, o, A, v), ri(d, l, A));
    }
  }
  function S4(o) {
    var l = o.alternate;
    return o === Te || l !== null && l === Te;
  }
  function ao(o, l) {
    $a = Hr = !0;
    var d = o.pending;
    d === null ? l.next = l : (l.next = d.next, d.next = l), o.pending = l;
  }
  function ri(o, l, d) {
    if (d & 4194240) {
      var A = l.lanes;
      A &= o.pendingLanes, d |= A, l.lanes = d, Bi(o, d);
    }
  }
  var H2 = { readContext: a3, useCallback: B2, useContext: B2, useEffect: B2, useImperativeHandle: B2, useInsertionEffect: B2, useLayoutEffect: B2, useMemo: B2, useReducer: B2, useRef: B2, useState: B2, useDebugValue: B2, useDeferredValue: B2, useTransition: B2, useMutableSource: B2, useSyncExternalStore: B2, useId: B2, unstable_isNewReconciler: !1 }, j6 = { readContext: a3, useCallback: function(o, l) {
    return Re().memoizedState = [o, l === void 0 ? null : l], o;
  }, useContext: a3, useEffect: tu, useImperativeHandle: function(o, l, d) {
    return d = d != null ? d.concat([o]) : null, no(
      4194308,
      4,
      iu.bind(null, l, o),
      d
    );
  }, useLayoutEffect: function(o, l) {
    return no(4194308, 4, o, l);
  }, useInsertionEffect: function(o, l) {
    return no(4, 2, o, l);
  }, useMemo: function(o, l) {
    var d = Re();
    return l = l === void 0 ? null : l, o = o(), d.memoizedState = [o, l], o;
  }, useReducer: function(o, l, d) {
    var A = Re();
    return l = d !== void 0 ? d(l) : l, A.memoizedState = A.baseState = l, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: o, lastRenderedState: l }, A.queue = o, o = o.dispatch = Od.bind(null, Te, o), [A.memoizedState, o];
  }, useRef: function(o) {
    var l = Re();
    return o = { current: o }, l.memoizedState = o;
  }, useState: $l, useDebugValue: io, useDeferredValue: function(o) {
    return Re().memoizedState = o;
  }, useTransition: function() {
    var o = $l(!1), l = o[0];
    return o = x4.bind(null, o[1]), Re().memoizedState = o, [l, o];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(o, l, d) {
    var A = Te, v = Re();
    if (sn) {
      if (d === void 0) throw Error(i(407));
      d = d();
    } else {
      if (d = l(), En === null) throw Error(i(349));
      Se & 30 || to(A, l, d);
    }
    v.memoizedState = d;
    var x = { value: d, getSnapshot: l };
    return v.queue = x, tu(Gl.bind(
      null,
      A,
      x,
      o
    ), [o]), A.flags |= 2048, na(9, Xl.bind(null, A, x, d, l), void 0, null), d;
  }, useId: function() {
    var o = Re(), l = En.identifierPrefix;
    if (sn) {
      var d = v0, A = b2;
      d = (A & ~(1 << 32 - lr(A) - 1)).toString(32) + d, l = ":" + l + "R" + d, d = ys++, 0 < d && (l += "H" + d.toString(32)), l += ":";
    } else d = k6++, l = ":" + l + "r" + d.toString(32) + ":";
    return o.memoizedState = l;
  }, unstable_isNewReconciler: !1 }, an = {
    readContext: a3,
    useCallback: ra,
    useContext: a3,
    useEffect: ws,
    useImperativeHandle: au,
    useInsertionEffect: nu,
    useLayoutEffect: ru,
    useMemo: ou,
    useReducer: w0,
    useRef: eu,
    useState: function() {
      return w0(Ur);
    },
    useDebugValue: io,
    useDeferredValue: function(o) {
      var l = w2();
      return su(l, Je.memoizedState, o);
    },
    useTransition: function() {
      var o = w0(Ur)[0], l = w2().memoizedState;
      return [o, l];
    },
    useMutableSource: eo,
    useSyncExternalStore: ta,
    useId: lu,
    unstable_isNewReconciler: !1
  }, uu = { readContext: a3, useCallback: ra, useContext: a3, useEffect: ws, useImperativeHandle: au, useInsertionEffect: nu, useLayoutEffect: ru, useMemo: ou, useReducer: o3, useRef: eu, useState: function() {
    return o3(Ur);
  }, useDebugValue: io, useDeferredValue: function(o) {
    var l = w2();
    return Je === null ? l.memoizedState = o : su(l, Je.memoizedState, o);
  }, useTransition: function() {
    var o = o3(Ur)[0], l = w2().memoizedState;
    return [o, l];
  }, useMutableSource: eo, useSyncExternalStore: ta, useId: lu, unstable_isNewReconciler: !1 };
  function vr(o, l) {
    if (o && o.defaultProps) {
      l = t1({}, l), o = o.defaultProps;
      for (var d in o) l[d] === void 0 && (l[d] = o[d]);
      return l;
    }
    return l;
  }
  function ia(o, l, d, A) {
    l = o.memoizedState, d = d(A, l), d = d == null ? l : t1({}, l, d), o.memoizedState = d, o.lanes === 0 && (o.updateQueue.baseState = d);
  }
  var aa = { isMounted: function(o) {
    return (o = o._reactInternals) ? Ae(o) === o : !1;
  }, enqueueSetState: function(o, l, d) {
    o = o._reactInternals;
    var A = A2(), v = E0(o), x = mr(A, v);
    x.payload = l, d != null && (x.callback = d), l = ni(o, x, v), l !== null && (hn(l, o, v, A), _l(l, o, v));
  }, enqueueReplaceState: function(o, l, d) {
    o = o._reactInternals;
    var A = A2(), v = E0(o), x = mr(A, v);
    x.tag = 1, x.payload = l, d != null && (x.callback = d), l = ni(o, x, v), l !== null && (hn(l, o, v, A), _l(l, o, v));
  }, enqueueForceUpdate: function(o, l) {
    o = o._reactInternals;
    var d = A2(), A = E0(o), v = mr(d, A);
    v.tag = 2, l != null && (v.callback = l), l = ni(o, v, A), l !== null && (hn(l, o, A, d), _l(l, o, A));
  } };
  function Dd(o, l, d, A, v, x, j) {
    return o = o.stateNode, typeof o.shouldComponentUpdate == "function" ? o.shouldComponentUpdate(A, x, j) : l.prototype && l.prototype.isPureReactComponent ? !os(d, A) || !os(v, x) : !0;
  }
  function kd(o, l, d) {
    var A = !1, v = U3, x = l.contextType;
    return typeof x == "object" && x !== null ? x = a3(x) : (v = fn(l) ? Cr : _e.current, A = l.contextTypes, x = (A = A != null) ? e3(o, v) : U3), l = new l(d, x), o.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, l.updater = aa, o.stateNode = l, l._reactInternals = o, A && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = v, o.__reactInternalMemoizedMaskedChildContext = x), l;
  }
  function jd(o, l, d, A) {
    o = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(d, A), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(d, A), l.state !== o && aa.enqueueReplaceState(l, l.state, null);
  }
  function E4(o, l, d, A) {
    var v = o.stateNode;
    v.props = d, v.state = o.memoizedState, v.refs = {}, Vl(o);
    var x = l.contextType;
    typeof x == "object" && x !== null ? v.context = a3(x) : (x = fn(l) ? Cr : _e.current, v.context = e3(o, x)), v.state = o.memoizedState, x = l.getDerivedStateFromProps, typeof x == "function" && (ia(o, l, x, d), v.state = o.memoizedState), typeof l.getDerivedStateFromProps == "function" || typeof v.getSnapshotBeforeUpdate == "function" || typeof v.UNSAFE_componentWillMount != "function" && typeof v.componentWillMount != "function" || (l = v.state, typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount(), l !== v.state && aa.enqueueReplaceState(v, v.state, null), Jl(o, d, v, A), v.state = o.memoizedState), typeof v.componentDidMount == "function" && (o.flags |= 4194308);
  }
  function ii(o, l) {
    try {
      var d = "", A = l;
      do
        d += le(A), A = A.return;
      while (A);
      var v = d;
    } catch (x) {
      v = `
Error generating stack: ` + x.message + `
` + x.stack;
    }
    return { value: o, source: l, stack: v, digest: null };
  }
  function M4(o, l, d) {
    return { value: o, source: null, stack: d ?? null, digest: l ?? null };
  }
  function Ss(o, l) {
    try {
      console.error(l.value);
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  var zd = typeof WeakMap == "function" ? WeakMap : Map;
  function Nd(o, l, d) {
    d = mr(-1, d), d.tag = 3, d.payload = { element: null };
    var A = l.value;
    return d.callback = function() {
      yu || (yu = !0, N4 = A), Ss(o, l);
    }, d;
  }
  function Pd(o, l, d) {
    d = mr(-1, d), d.tag = 3;
    var A = o.type.getDerivedStateFromError;
    if (typeof A == "function") {
      var v = l.value;
      d.payload = function() {
        return A(v);
      }, d.callback = function() {
        Ss(o, l);
      };
    }
    var x = o.stateNode;
    return x !== null && typeof x.componentDidCatch == "function" && (d.callback = function() {
      Ss(o, l), typeof A != "function" && (u3 === null ? u3 = /* @__PURE__ */ new Set([this]) : u3.add(this));
      var j = l.stack;
      this.componentDidCatch(l.value, { componentStack: j !== null ? j : "" });
    }), d;
  }
  function Es(o, l, d) {
    var A = o.pingCache;
    if (A === null) {
      A = o.pingCache = new zd();
      var v = /* @__PURE__ */ new Set();
      A.set(l, v);
    } else v = A.get(l), v === void 0 && (v = /* @__PURE__ */ new Set(), A.set(l, v));
    v.has(d) || (v.add(d), o = _6.bind(null, o, l, d), l.then(o, o));
  }
  function Fd(o) {
    do {
      var l;
      if ((l = o.tag === 13) && (l = o.memoizedState, l = l !== null ? l.dehydrated !== null : !0), l) return o;
      o = o.return;
    } while (o !== null);
    return null;
  }
  function T4(o, l, d, A, v) {
    return o.mode & 1 ? (o.flags |= 65536, o.lanes = v, o) : (o === l ? o.flags |= 65536 : (o.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (l = mr(-1, 1), l.tag = 2, ni(d, l, 1))), d.lanes |= 1), o);
  }
  var Bd = Y.ReactCurrentOwner, yr = !1;
  function Dn(o, l, d, A) {
    l.child = o === null ? Ed(l, null, d, A) : Qa(l, o.child, d, A);
  }
  function oo(o, l, d, A, v) {
    d = d.render;
    var x = l.ref;
    return Xa(l, v), A = w1(o, l, d, A, x, v), d = Wn(), o !== null && !yr ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~v, kn(o, l, v)) : (sn && d && Pl(l), l.flags |= 1, Dn(o, l, A, v), l.child);
  }
  function ai(o, l, d, A, v) {
    if (o === null) {
      var x = d.type;
      return typeof x == "function" && !U4(x) && x.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (l.tag = 15, l.type = x, cu(o, l, x, A, v)) : (o = Mu(d.type, null, A, l, l.mode, v), o.ref = l.ref, o.return = l, l.child = o);
    }
    if (x = o.child, !(o.lanes & v)) {
      var j = x.memoizedProps;
      if (d = d.compare, d = d !== null ? d : os, d(j, A) && o.ref === l.ref) return kn(o, l, v);
    }
    return l.flags |= 1, o = li(x, A), o.ref = l.ref, o.return = l, l.child = o;
  }
  function cu(o, l, d, A, v) {
    if (o !== null) {
      var x = o.memoizedProps;
      if (os(x, A) && o.ref === l.ref) if (yr = !1, l.pendingProps = A = x, (o.lanes & v) !== 0) o.flags & 131072 && (yr = !0);
      else return l.lanes = o.lanes, kn(o, l, v);
    }
    return qe(o, l, d, A, v);
  }
  function br(o, l, d) {
    var A = l.pendingProps, v = A.children, x = o !== null ? o.memoizedState : null;
    if (A.mode === "hidden") if (!(l.mode & 1)) l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, kt(po, wr), wr |= d;
    else {
      if (!(d & 1073741824)) return o = x !== null ? x.baseLanes | d : d, l.lanes = l.childLanes = 1073741824, l.memoizedState = { baseLanes: o, cachePool: null, transitions: null }, l.updateQueue = null, kt(po, wr), wr |= o, null;
      l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, A = x !== null ? x.baseLanes : d, kt(po, wr), wr |= A;
    }
    else x !== null ? (A = x.baseLanes | d, l.memoizedState = null) : A = d, kt(po, wr), wr |= A;
    return Dn(o, l, v, d), l.child;
  }
  function oa(o, l) {
    var d = l.ref;
    (o === null && d !== null || o !== null && o.ref !== d) && (l.flags |= 512, l.flags |= 2097152);
  }
  function qe(o, l, d, A, v) {
    var x = fn(d) ? Cr : _e.current;
    return x = e3(l, x), Xa(l, v), d = w1(o, l, d, A, x, v), A = Wn(), o !== null && !yr ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~v, kn(o, l, v)) : (sn && A && Pl(l), l.flags |= 1, Dn(o, l, d, v), l.child);
  }
  function Ms(o, l, d, A, v) {
    if (fn(d)) {
      var x = !0;
      Nl(l);
    } else x = !1;
    if (Xa(l, v), l.stateNode === null) Ls(o, l), kd(l, d, A), E4(l, d, A, v), A = !0;
    else if (o === null) {
      var j = l.stateNode, _ = l.memoizedProps;
      j.props = _;
      var X = j.context, c1 = d.contextType;
      typeof c1 == "object" && c1 !== null ? c1 = a3(c1) : (c1 = fn(d) ? Cr : _e.current, c1 = e3(l, c1));
      var R1 = d.getDerivedStateFromProps, j1 = typeof R1 == "function" || typeof j.getSnapshotBeforeUpdate == "function";
      j1 || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (_ !== A || X !== c1) && jd(l, j, A, c1), ti = !1;
      var x1 = l.memoizedState;
      j.state = x1, Jl(l, A, j, v), X = l.memoizedState, _ !== A || x1 !== X || xn.current || ti ? (typeof R1 == "function" && (ia(l, d, R1, A), X = l.memoizedState), (_ = ti || Dd(l, d, _, A, x1, X, c1)) ? (j1 || typeof j.UNSAFE_componentWillMount != "function" && typeof j.componentWillMount != "function" || (typeof j.componentWillMount == "function" && j.componentWillMount(), typeof j.UNSAFE_componentWillMount == "function" && j.UNSAFE_componentWillMount()), typeof j.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof j.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = A, l.memoizedState = X), j.props = A, j.state = X, j.context = c1, A = _) : (typeof j.componentDidMount == "function" && (l.flags |= 4194308), A = !1);
    } else {
      j = l.stateNode, Ga(o, l), _ = l.memoizedProps, c1 = l.type === l.elementType ? _ : vr(l.type, _), j.props = c1, j1 = l.pendingProps, x1 = j.context, X = d.contextType, typeof X == "object" && X !== null ? X = a3(X) : (X = fn(d) ? Cr : _e.current, X = e3(l, X));
      var ge = d.getDerivedStateFromProps;
      (R1 = typeof ge == "function" || typeof j.getSnapshotBeforeUpdate == "function") || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (_ !== j1 || x1 !== X) && jd(l, j, A, X), ti = !1, x1 = l.memoizedState, j.state = x1, Jl(l, A, j, v);
      var me = l.memoizedState;
      _ !== j1 || x1 !== me || xn.current || ti ? (typeof ge == "function" && (ia(l, d, ge, A), me = l.memoizedState), (c1 = ti || Dd(l, d, c1, A, x1, me, X) || !1) ? (R1 || typeof j.UNSAFE_componentWillUpdate != "function" && typeof j.componentWillUpdate != "function" || (typeof j.componentWillUpdate == "function" && j.componentWillUpdate(A, me, X), typeof j.UNSAFE_componentWillUpdate == "function" && j.UNSAFE_componentWillUpdate(A, me, X)), typeof j.componentDidUpdate == "function" && (l.flags |= 4), typeof j.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof j.componentDidUpdate != "function" || _ === o.memoizedProps && x1 === o.memoizedState || (l.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || _ === o.memoizedProps && x1 === o.memoizedState || (l.flags |= 1024), l.memoizedProps = A, l.memoizedState = me), j.props = A, j.state = me, j.context = X, A = c1) : (typeof j.componentDidUpdate != "function" || _ === o.memoizedProps && x1 === o.memoizedState || (l.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || _ === o.memoizedProps && x1 === o.memoizedState || (l.flags |= 1024), A = !1);
    }
    return gu(o, l, d, A, x, v);
  }
  function gu(o, l, d, A, v, x) {
    oa(o, l);
    var j = (l.flags & 128) !== 0;
    if (!A && !j) return v && yd(l, d, !1), kn(o, l, x);
    A = l.stateNode, Bd.current = l;
    var _ = j && typeof d.getDerivedStateFromError != "function" ? null : A.render();
    return l.flags |= 1, o !== null && j ? (l.child = Qa(l, o.child, null, x), l.child = Qa(l, null, _, x)) : Dn(o, l, _, x), l.memoizedState = A.state, v && yd(l, d, !0), l.child;
  }
  function z6(o) {
    var l = o.stateNode;
    l.pendingContext ? $0(o, l.pendingContext, l.pendingContext !== l.context) : l.context && $0(o, l.context, !1), y4(o, l.containerInfo);
  }
  function Hd(o, l, d, A, v) {
    return pn(), h4(v), l.flags |= 256, Dn(o, l, d, A), l.child;
  }
  var Ts = { dehydrated: null, treeContext: null, retryLane: 0 };
  function sa(o) {
    return { baseLanes: o, cachePool: null, transitions: null };
  }
  function Ud(o, l, d) {
    var A = l.pendingProps, v = dn.current, x = !1, j = (l.flags & 128) !== 0, _;
    if ((_ = j) || (_ = o !== null && o.memoizedState === null ? !1 : (v & 2) !== 0), _ ? (x = !0, l.flags &= -129) : (o === null || o.memoizedState !== null) && (v |= 1), kt(dn, v & 1), o === null)
      return Bl(l), o = l.memoizedState, o !== null && (o = o.dehydrated, o !== null) ? (l.mode & 1 ? o.data === "$!" ? l.lanes = 8 : l.lanes = 1073741824 : l.lanes = 1, null) : (j = A.children, o = A.fallback, x ? (A = l.mode, x = l.child, j = { mode: "hidden", children: j }, !(A & 1) && x !== null ? (x.childLanes = 0, x.pendingProps = j) : x = Tu(j, A, 0, null), o = da(o, A, d, null), x.return = l, o.return = l, x.sibling = o, l.child = x, l.child.memoizedState = sa(d), l.memoizedState = Ts, o) : fu(l, j));
    if (v = o.memoizedState, v !== null && (_ = v.dehydrated, _ !== null)) return L4(o, l, j, A, _, v, d);
    if (x) {
      x = A.fallback, j = l.mode, v = o.child, _ = v.sibling;
      var X = { mode: "hidden", children: A.children };
      return !(j & 1) && l.child !== v ? (A = l.child, A.childLanes = 0, A.pendingProps = X, l.deletions = null) : (A = li(v, X), A.subtreeFlags = v.subtreeFlags & 14680064), _ !== null ? x = li(_, x) : (x = da(x, j, d, null), x.flags |= 2), x.return = l, A.return = l, A.sibling = x, l.child = A, A = x, x = l.child, j = o.child.memoizedState, j = j === null ? sa(d) : { baseLanes: j.baseLanes | d, cachePool: null, transitions: j.transitions }, x.memoizedState = j, x.childLanes = o.childLanes & ~d, l.memoizedState = Ts, A;
    }
    return x = o.child, o = x.sibling, A = li(x, { mode: "visible", children: A.children }), !(l.mode & 1) && (A.lanes = d), A.return = l, A.sibling = null, o !== null && (d = l.deletions, d === null ? (l.deletions = [o], l.flags |= 16) : d.push(o)), l.child = A, l.memoizedState = null, A;
  }
  function fu(o, l) {
    return l = Tu({ mode: "visible", children: l }, o.mode, 0, null), l.return = o, o.child = l;
  }
  function du(o, l, d, A) {
    return A !== null && h4(A), Qa(l, o.child, null, d), o = fu(l, l.pendingProps.children), o.flags |= 2, l.memoizedState = null, o;
  }
  function L4(o, l, d, A, v, x, j) {
    if (d)
      return l.flags & 256 ? (l.flags &= -257, A = M4(Error(i(422))), du(o, l, j, A)) : l.memoizedState !== null ? (l.child = o.child, l.flags |= 128, null) : (x = A.fallback, v = l.mode, A = Tu({ mode: "visible", children: A.children }, v, 0, null), x = da(x, v, j, null), x.flags |= 2, A.return = l, x.return = l, A.sibling = x, l.child = A, l.mode & 1 && Qa(l, o.child, null, j), l.child.memoizedState = sa(j), l.memoizedState = Ts, x);
    if (!(l.mode & 1)) return du(o, l, j, null);
    if (v.data === "$!") {
      if (A = v.nextSibling && v.nextSibling.dataset, A) var _ = A.dgst;
      return A = _, x = Error(i(419)), A = M4(x, A, void 0), du(o, l, j, A);
    }
    if (_ = (j & o.childLanes) !== 0, yr || _) {
      if (A = En, A !== null) {
        switch (j & -j) {
          case 4:
            v = 2;
            break;
          case 16:
            v = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            v = 32;
            break;
          case 536870912:
            v = 268435456;
            break;
          default:
            v = 0;
        }
        v = v & (A.suspendedLanes | j) ? 0 : v, v !== 0 && v !== x.retryLane && (x.retryLane = v, b0(o, v), hn(A, o, v, -1));
      }
      return js(), A = M4(Error(i(421))), du(o, l, j, A);
    }
    return v.data === "$?" ? (l.flags |= 128, l.child = o.child, l = H4.bind(null, o), v._reactRetry = l, null) : (o = x.treeContext, hr = x3(v.nextSibling), Fr = l, sn = !0, r3 = null, o !== null && (pr[F2++] = b2, pr[F2++] = v0, pr[F2++] = n3, b2 = o.id, v0 = o.overflow, n3 = l), l = fu(l, A.children), l.flags |= 4096, l);
  }
  function Wd(o, l, d) {
    o.lanes |= l;
    var A = o.alternate;
    A !== null && (A.lanes |= l), v4(o.return, l, d);
  }
  function Cu(o, l, d, A, v) {
    var x = o.memoizedState;
    x === null ? o.memoizedState = { isBackwards: l, rendering: null, renderingStartTime: 0, last: A, tail: d, tailMode: v } : (x.isBackwards = l, x.rendering = null, x.renderingStartTime = 0, x.last = A, x.tail = d, x.tailMode = v);
  }
  function R4(o, l, d) {
    var A = l.pendingProps, v = A.revealOrder, x = A.tail;
    if (Dn(o, l, A.children, d), A = dn.current, A & 2) A = A & 1 | 2, l.flags |= 128;
    else {
      if (o !== null && o.flags & 128) e: for (o = l.child; o !== null; ) {
        if (o.tag === 13) o.memoizedState !== null && Wd(o, d, l);
        else if (o.tag === 19) Wd(o, d, l);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === l) break e;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === l) break e;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      A &= 1;
    }
    if (kt(dn, A), !(l.mode & 1)) l.memoizedState = null;
    else switch (v) {
      case "forwards":
        for (d = l.child, v = null; d !== null; ) o = d.alternate, o !== null && Kl(o) === null && (v = d), d = d.sibling;
        d = v, d === null ? (v = l.child, l.child = null) : (v = d.sibling, d.sibling = null), Cu(l, !1, v, d, x);
        break;
      case "backwards":
        for (d = null, v = l.child, l.child = null; v !== null; ) {
          if (o = v.alternate, o !== null && Kl(o) === null) {
            l.child = v;
            break;
          }
          o = v.sibling, v.sibling = d, d = v, v = o;
        }
        Cu(l, !0, d, null, x);
        break;
      case "together":
        Cu(l, !1, null, null, void 0);
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function Ls(o, l) {
    !(l.mode & 1) && o !== null && (o.alternate = null, l.alternate = null, l.flags |= 2);
  }
  function kn(o, l, d) {
    if (o !== null && (l.dependencies = o.dependencies), ua |= l.lanes, !(d & l.childLanes)) return null;
    if (o !== null && l.child !== o.child) throw Error(i(153));
    if (l.child !== null) {
      for (o = l.child, d = li(o, o.pendingProps), l.child = d, d.return = l; o.sibling !== null; ) o = o.sibling, d = d.sibling = li(o, o.pendingProps), d.return = l;
      d.sibling = null;
    }
    return l.child;
  }
  function x0(o, l, d) {
    switch (l.tag) {
      case 3:
        z6(l), pn();
        break;
      case 5:
        Rd(l);
        break;
      case 1:
        fn(l.type) && Nl(l);
        break;
      case 4:
        y4(l, l.stateNode.containerInfo);
        break;
      case 10:
        var A = l.type._context, v = l.memoizedProps.value;
        kt(y0, A._currentValue), A._currentValue = v;
        break;
      case 13:
        if (A = l.memoizedState, A !== null)
          return A.dehydrated !== null ? (kt(dn, dn.current & 1), l.flags |= 128, null) : d & l.child.childLanes ? Ud(o, l, d) : (kt(dn, dn.current & 1), o = kn(o, l, d), o !== null ? o.sibling : null);
        kt(dn, dn.current & 1);
        break;
      case 19:
        if (A = (d & l.childLanes) !== 0, o.flags & 128) {
          if (A) return R4(o, l, d);
          l.flags |= 128;
        }
        if (v = l.memoizedState, v !== null && (v.rendering = null, v.tail = null, v.lastEffect = null), kt(dn, dn.current), A) break;
        return null;
      case 22:
      case 23:
        return l.lanes = 0, br(o, l, d);
    }
    return kn(o, l, d);
  }
  var V3, so, lo, s3;
  V3 = function(o, l) {
    for (var d = l.child; d !== null; ) {
      if (d.tag === 5 || d.tag === 6) o.appendChild(d.stateNode);
      else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === l) break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === l) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, so = function() {
  }, lo = function(o, l, d, A) {
    var v = o.memoizedProps;
    if (v !== A) {
      o = l.stateNode, ea(S3.current);
      var x = null;
      switch (d) {
        case "input":
          v = b1(o, v), A = b1(o, A), x = [];
          break;
        case "select":
          v = t1({}, v, { value: void 0 }), A = t1({}, A, { value: void 0 }), x = [];
          break;
        case "textarea":
          v = we(o, v), A = we(o, A), x = [];
          break;
        default:
          typeof v.onClick != "function" && typeof A.onClick == "function" && (o.onclick = zl);
      }
      cn(d, A);
      var j;
      d = null;
      for (c1 in v) if (!A.hasOwnProperty(c1) && v.hasOwnProperty(c1) && v[c1] != null) if (c1 === "style") {
        var _ = v[c1];
        for (j in _) _.hasOwnProperty(j) && (d || (d = {}), d[j] = "");
      } else c1 !== "dangerouslySetInnerHTML" && c1 !== "children" && c1 !== "suppressContentEditableWarning" && c1 !== "suppressHydrationWarning" && c1 !== "autoFocus" && (s.hasOwnProperty(c1) ? x || (x = []) : (x = x || []).push(c1, null));
      for (c1 in A) {
        var X = A[c1];
        if (_ = v != null ? v[c1] : void 0, A.hasOwnProperty(c1) && X !== _ && (X != null || _ != null)) if (c1 === "style") if (_) {
          for (j in _) !_.hasOwnProperty(j) || X && X.hasOwnProperty(j) || (d || (d = {}), d[j] = "");
          for (j in X) X.hasOwnProperty(j) && _[j] !== X[j] && (d || (d = {}), d[j] = X[j]);
        } else d || (x || (x = []), x.push(
          c1,
          d
        )), d = X;
        else c1 === "dangerouslySetInnerHTML" ? (X = X ? X.__html : void 0, _ = _ ? _.__html : void 0, X != null && _ !== X && (x = x || []).push(c1, X)) : c1 === "children" ? typeof X != "string" && typeof X != "number" || (x = x || []).push(c1, "" + X) : c1 !== "suppressContentEditableWarning" && c1 !== "suppressHydrationWarning" && (s.hasOwnProperty(c1) ? (X != null && c1 === "onScroll" && en("scroll", o), x || _ === X || (x = [])) : (x = x || []).push(c1, X));
      }
      d && (x = x || []).push("style", d);
      var c1 = x;
      (l.updateQueue = c1) && (l.flags |= 4);
    }
  }, s3 = function(o, l, d, A) {
    d !== A && (l.flags |= 4);
  };
  function Sn(o, l) {
    if (!sn) switch (o.tailMode) {
      case "hidden":
        l = o.tail;
        for (var d = null; l !== null; ) l.alternate !== null && (d = l), l = l.sibling;
        d === null ? o.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = o.tail;
        for (var A = null; d !== null; ) d.alternate !== null && (A = d), d = d.sibling;
        A === null ? l || o.tail === null ? o.tail = null : o.tail.sibling = null : A.sibling = null;
    }
  }
  function U2(o) {
    var l = o.alternate !== null && o.alternate.child === o.child, d = 0, A = 0;
    if (l) for (var v = o.child; v !== null; ) d |= v.lanes | v.childLanes, A |= v.subtreeFlags & 14680064, A |= v.flags & 14680064, v.return = o, v = v.sibling;
    else for (v = o.child; v !== null; ) d |= v.lanes | v.childLanes, A |= v.subtreeFlags, A |= v.flags, v.return = o, v = v.sibling;
    return o.subtreeFlags |= A, o.childLanes = d, l;
  }
  function N6(o, l, d) {
    var A = l.pendingProps;
    switch (I4(l), l.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return U2(l), null;
      case 1:
        return fn(l.type) && t3(), U2(l), null;
      case 3:
        return A = l.stateNode, Za(), Mt(xn), Mt(_e), w4(), A.pendingContext && (A.context = A.pendingContext, A.pendingContext = null), (o === null || o.child === null) && (Hl(l) ? l.flags |= 4 : o === null || o.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, r3 !== null && (P4(r3), r3 = null))), so(o, l), U2(l), null;
      case 5:
        b4(l);
        var v = ea(ms.current);
        if (d = l.type, o !== null && l.stateNode != null) lo(o, l, d, A, v), o.ref !== l.ref && (l.flags |= 512, l.flags |= 2097152);
        else {
          if (!A) {
            if (l.stateNode === null) throw Error(i(166));
            return U2(l), null;
          }
          if (o = ea(S3.current), Hl(l)) {
            A = l.stateNode, d = l.type;
            var x = l.memoizedProps;
            switch (A[H3] = l, A[Gi] = x, o = (l.mode & 1) !== 0, d) {
              case "dialog":
                en("cancel", A), en("close", A);
                break;
              case "iframe":
              case "object":
              case "embed":
                en("load", A);
                break;
              case "video":
              case "audio":
                for (v = 0; v < cs.length; v++) en(cs[v], A);
                break;
              case "source":
                en("error", A);
                break;
              case "img":
              case "image":
              case "link":
                en(
                  "error",
                  A
                ), en("load", A);
                break;
              case "details":
                en("toggle", A);
                break;
              case "input":
                Pe(A, x), en("invalid", A);
                break;
              case "select":
                A._wrapperState = { wasMultiple: !!x.multiple }, en("invalid", A);
                break;
              case "textarea":
                An(A, x), en("invalid", A);
            }
            cn(d, x), v = null;
            for (var j in x) if (x.hasOwnProperty(j)) {
              var _ = x[j];
              j === "children" ? typeof _ == "string" ? A.textContent !== _ && (x.suppressHydrationWarning !== !0 && jl(A.textContent, _, o), v = ["children", _]) : typeof _ == "number" && A.textContent !== "" + _ && (x.suppressHydrationWarning !== !0 && jl(
                A.textContent,
                _,
                o
              ), v = ["children", "" + _]) : s.hasOwnProperty(j) && _ != null && j === "onScroll" && en("scroll", A);
            }
            switch (d) {
              case "input":
                We(A), ke(A, x, !0);
                break;
              case "textarea":
                We(A), In(A);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof x.onClick == "function" && (A.onclick = zl);
            }
            A = v, l.updateQueue = A, A !== null && (l.flags |= 4);
          } else {
            j = v.nodeType === 9 ? v : v.ownerDocument, o === "http://www.w3.org/1999/xhtml" && (o = v2(d)), o === "http://www.w3.org/1999/xhtml" ? d === "script" ? (o = j.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild)) : typeof A.is == "string" ? o = j.createElement(d, { is: A.is }) : (o = j.createElement(d), d === "select" && (j = o, A.multiple ? j.multiple = !0 : A.size && (j.size = A.size))) : o = j.createElementNS(o, d), o[H3] = l, o[Gi] = A, V3(o, l, !1, !1), l.stateNode = o;
            e: {
              switch (j = nn(d, A), d) {
                case "dialog":
                  en("cancel", o), en("close", o), v = A;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  en("load", o), v = A;
                  break;
                case "video":
                case "audio":
                  for (v = 0; v < cs.length; v++) en(cs[v], o);
                  v = A;
                  break;
                case "source":
                  en("error", o), v = A;
                  break;
                case "img":
                case "image":
                case "link":
                  en(
                    "error",
                    o
                  ), en("load", o), v = A;
                  break;
                case "details":
                  en("toggle", o), v = A;
                  break;
                case "input":
                  Pe(o, A), v = b1(o, A), en("invalid", o);
                  break;
                case "option":
                  v = A;
                  break;
                case "select":
                  o._wrapperState = { wasMultiple: !!A.multiple }, v = t1({}, A, { value: void 0 }), en("invalid", o);
                  break;
                case "textarea":
                  An(o, A), v = we(o, A), en("invalid", o);
                  break;
                default:
                  v = A;
              }
              cn(d, v), _ = v;
              for (x in _) if (_.hasOwnProperty(x)) {
                var X = _[x];
                x === "style" ? Et(o, X) : x === "dangerouslySetInnerHTML" ? (X = X ? X.__html : void 0, X != null && Fe(o, X)) : x === "children" ? typeof X == "string" ? (d !== "textarea" || X !== "") && Pn(o, X) : typeof X == "number" && Pn(o, "" + X) : x !== "suppressContentEditableWarning" && x !== "suppressHydrationWarning" && x !== "autoFocus" && (s.hasOwnProperty(x) ? X != null && x === "onScroll" && en("scroll", o) : X != null && V(o, x, X, j));
              }
              switch (d) {
                case "input":
                  We(o), ke(o, A, !1);
                  break;
                case "textarea":
                  We(o), In(o);
                  break;
                case "option":
                  A.value != null && o.setAttribute("value", "" + V1(A.value));
                  break;
                case "select":
                  o.multiple = !!A.multiple, x = A.value, x != null ? tt(o, !!A.multiple, x, !1) : A.defaultValue != null && tt(
                    o,
                    !!A.multiple,
                    A.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof v.onClick == "function" && (o.onclick = zl);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  A = !!A.autoFocus;
                  break e;
                case "img":
                  A = !0;
                  break e;
                default:
                  A = !1;
              }
            }
            A && (l.flags |= 4);
          }
          l.ref !== null && (l.flags |= 512, l.flags |= 2097152);
        }
        return U2(l), null;
      case 6:
        if (o && l.stateNode != null) s3(o, l, o.memoizedProps, A);
        else {
          if (typeof A != "string" && l.stateNode === null) throw Error(i(166));
          if (d = ea(ms.current), ea(S3.current), Hl(l)) {
            if (A = l.stateNode, d = l.memoizedProps, A[H3] = l, (x = A.nodeValue !== d) && (o = Fr, o !== null)) switch (o.tag) {
              case 3:
                jl(A.nodeValue, d, (o.mode & 1) !== 0);
                break;
              case 5:
                o.memoizedProps.suppressHydrationWarning !== !0 && jl(A.nodeValue, d, (o.mode & 1) !== 0);
            }
            x && (l.flags |= 4);
          } else A = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(A), A[H3] = l, l.stateNode = A;
        }
        return U2(l), null;
      case 13:
        if (Mt(dn), A = l.memoizedState, o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
          if (sn && hr !== null && l.mode & 1 && !(l.flags & 128)) xd(), pn(), l.flags |= 98560, x = !1;
          else if (x = Hl(l), A !== null && A.dehydrated !== null) {
            if (o === null) {
              if (!x) throw Error(i(318));
              if (x = l.memoizedState, x = x !== null ? x.dehydrated : null, !x) throw Error(i(317));
              x[H3] = l;
            } else pn(), !(l.flags & 128) && (l.memoizedState = null), l.flags |= 4;
            U2(l), x = !1;
          } else r3 !== null && (P4(r3), r3 = null), x = !0;
          if (!x) return l.flags & 65536 ? l : null;
        }
        return l.flags & 128 ? (l.lanes = d, l) : (A = A !== null, A !== (o !== null && o.memoizedState !== null) && A && (l.child.flags |= 8192, l.mode & 1 && (o === null || dn.current & 1 ? $n === 0 && ($n = 3) : js())), l.updateQueue !== null && (l.flags |= 4), U2(l), null);
      case 4:
        return Za(), so(o, l), o === null && Ja(l.stateNode.containerInfo), U2(l), null;
      case 10:
        return m4(l.type._context), U2(l), null;
      case 17:
        return fn(l.type) && t3(), U2(l), null;
      case 19:
        if (Mt(dn), x = l.memoizedState, x === null) return U2(l), null;
        if (A = (l.flags & 128) !== 0, j = x.rendering, j === null) if (A) Sn(x, !1);
        else {
          if ($n !== 0 || o !== null && o.flags & 128) for (o = l.child; o !== null; ) {
            if (j = Kl(o), j !== null) {
              for (l.flags |= 128, Sn(x, !1), A = j.updateQueue, A !== null && (l.updateQueue = A, l.flags |= 4), l.subtreeFlags = 0, A = d, d = l.child; d !== null; ) x = d, o = A, x.flags &= 14680066, j = x.alternate, j === null ? (x.childLanes = 0, x.lanes = o, x.child = null, x.subtreeFlags = 0, x.memoizedProps = null, x.memoizedState = null, x.updateQueue = null, x.dependencies = null, x.stateNode = null) : (x.childLanes = j.childLanes, x.lanes = j.lanes, x.child = j.child, x.subtreeFlags = 0, x.deletions = null, x.memoizedProps = j.memoizedProps, x.memoizedState = j.memoizedState, x.updateQueue = j.updateQueue, x.type = j.type, o = j.dependencies, x.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), d = d.sibling;
              return kt(dn, dn.current & 1 | 2), l.child;
            }
            o = o.sibling;
          }
          x.tail !== null && vt() > mo && (l.flags |= 128, A = !0, Sn(x, !1), l.lanes = 4194304);
        }
        else {
          if (!A) if (o = Kl(j), o !== null) {
            if (l.flags |= 128, A = !0, d = o.updateQueue, d !== null && (l.updateQueue = d, l.flags |= 4), Sn(x, !0), x.tail === null && x.tailMode === "hidden" && !j.alternate && !sn) return U2(l), null;
          } else 2 * vt() - x.renderingStartTime > mo && d !== 1073741824 && (l.flags |= 128, A = !0, Sn(x, !1), l.lanes = 4194304);
          x.isBackwards ? (j.sibling = l.child, l.child = j) : (d = x.last, d !== null ? d.sibling = j : l.child = j, x.last = j);
        }
        return x.tail !== null ? (l = x.tail, x.rendering = l, x.tail = l.sibling, x.renderingStartTime = vt(), l.sibling = null, d = dn.current, kt(dn, A ? d & 1 | 2 : d & 1), l) : (U2(l), null);
      case 22:
      case 23:
        return Su(), A = l.memoizedState !== null, o !== null && o.memoizedState !== null !== A && (l.flags |= 8192), A && l.mode & 1 ? wr & 1073741824 && (U2(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : U2(l), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, l.tag));
  }
  function P6(o, l) {
    switch (I4(l), l.tag) {
      case 1:
        return fn(l.type) && t3(), o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 3:
        return Za(), Mt(xn), Mt(_e), w4(), o = l.flags, o & 65536 && !(o & 128) ? (l.flags = o & -65537 | 128, l) : null;
      case 5:
        return b4(l), null;
      case 13:
        if (Mt(dn), o = l.memoizedState, o !== null && o.dehydrated !== null) {
          if (l.alternate === null) throw Error(i(340));
          pn();
        }
        return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 19:
        return Mt(dn), null;
      case 4:
        return Za(), null;
      case 10:
        return m4(l.type._context), null;
      case 22:
      case 23:
        return Su(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var uo = !1, x2 = !1, Au = typeof WeakSet == "function" ? WeakSet : Set, Ie = null;
  function co(o, l) {
    var d = o.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (A) {
      Mn(o, l, A);
    }
    else d.current = null;
  }
  function O4(o, l, d) {
    try {
      d();
    } catch (A) {
      Mn(o, l, A);
    }
  }
  var Iu = !1;
  function F6(o, l) {
    if (l4 = u1, o = Ll(), I0(o)) {
      if ("selectionStart" in o) var d = { start: o.selectionStart, end: o.selectionEnd };
      else e: {
        d = (d = o.ownerDocument) && d.defaultView || window;
        var A = d.getSelection && d.getSelection();
        if (A && A.rangeCount !== 0) {
          d = A.anchorNode;
          var v = A.anchorOffset, x = A.focusNode;
          A = A.focusOffset;
          try {
            d.nodeType, x.nodeType;
          } catch {
            d = null;
            break e;
          }
          var j = 0, _ = -1, X = -1, c1 = 0, R1 = 0, j1 = o, x1 = null;
          t: for (; ; ) {
            for (var ge; j1 !== d || v !== 0 && j1.nodeType !== 3 || (_ = j + v), j1 !== x || A !== 0 && j1.nodeType !== 3 || (X = j + A), j1.nodeType === 3 && (j += j1.nodeValue.length), (ge = j1.firstChild) !== null; )
              x1 = j1, j1 = ge;
            for (; ; ) {
              if (j1 === o) break t;
              if (x1 === d && ++c1 === v && (_ = j), x1 === x && ++R1 === A && (X = j), (ge = j1.nextSibling) !== null) break;
              j1 = x1, x1 = j1.parentNode;
            }
            j1 = ge;
          }
          d = _ === -1 || X === -1 ? null : { start: _, end: X };
        } else d = null;
      }
      d = d || { start: 0, end: 0 };
    } else d = null;
    for (Qi = { focusedElem: o, selectionRange: d }, u1 = !1, Ie = l; Ie !== null; ) if (l = Ie, o = l.child, (l.subtreeFlags & 1028) !== 0 && o !== null) o.return = l, Ie = o;
    else for (; Ie !== null; ) {
      l = Ie;
      try {
        var me = l.alternate;
        if (l.flags & 1024) switch (l.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (me !== null) {
              var be = me.memoizedProps, jn = me.memoizedState, r1 = l.stateNode, $ = r1.getSnapshotBeforeUpdate(l.elementType === l.type ? be : vr(l.type, be), jn);
              r1.__reactInternalSnapshotBeforeUpdate = $;
            }
            break;
          case 3:
            var o1 = l.stateNode.containerInfo;
            o1.nodeType === 1 ? o1.textContent = "" : o1.nodeType === 9 && o1.documentElement && o1.removeChild(o1.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (_1) {
        Mn(l, l.return, _1);
      }
      if (o = l.sibling, o !== null) {
        o.return = l.return, Ie = o;
        break;
      }
      Ie = l.return;
    }
    return me = Iu, Iu = !1, me;
  }
  function go(o, l, d) {
    var A = l.updateQueue;
    if (A = A !== null ? A.lastEffect : null, A !== null) {
      var v = A = A.next;
      do {
        if ((v.tag & o) === o) {
          var x = v.destroy;
          v.destroy = void 0, x !== void 0 && O4(l, d, x);
        }
        v = v.next;
      } while (v !== A);
    }
  }
  function pu(o, l) {
    if (l = l.updateQueue, l = l !== null ? l.lastEffect : null, l !== null) {
      var d = l = l.next;
      do {
        if ((d.tag & o) === o) {
          var A = d.create;
          d.destroy = A();
        }
        d = d.next;
      } while (d !== l);
    }
  }
  function hu(o) {
    var l = o.ref;
    if (l !== null) {
      var d = o.stateNode;
      switch (o.tag) {
        case 5:
          o = d;
          break;
        default:
          o = d;
      }
      typeof l == "function" ? l(o) : l.current = o;
    }
  }
  function Vd(o) {
    var l = o.alternate;
    l !== null && (o.alternate = null, Vd(l)), o.child = null, o.deletions = null, o.sibling = null, o.tag === 5 && (l = o.stateNode, l !== null && (delete l[H3], delete l[Gi], delete l[g4], delete l[D6], delete l[f4])), o.stateNode = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
  }
  function D4(o) {
    return o.tag === 5 || o.tag === 3 || o.tag === 4;
  }
  function _d(o) {
    e: for (; ; ) {
      for (; o.sibling === null; ) {
        if (o.return === null || D4(o.return)) return null;
        o = o.return;
      }
      for (o.sibling.return = o.return, o = o.sibling; o.tag !== 5 && o.tag !== 6 && o.tag !== 18; ) {
        if (o.flags & 2 || o.child === null || o.tag === 4) continue e;
        o.child.return = o, o = o.child;
      }
      if (!(o.flags & 2)) return o.stateNode;
    }
  }
  function Rs(o, l, d) {
    var A = o.tag;
    if (A === 5 || A === 6) o = o.stateNode, l ? d.nodeType === 8 ? d.parentNode.insertBefore(o, l) : d.insertBefore(o, l) : (d.nodeType === 8 ? (l = d.parentNode, l.insertBefore(o, d)) : (l = d, l.appendChild(o)), d = d._reactRootContainer, d != null || l.onclick !== null || (l.onclick = zl));
    else if (A !== 4 && (o = o.child, o !== null)) for (Rs(o, l, d), o = o.sibling; o !== null; ) Rs(o, l, d), o = o.sibling;
  }
  function fo(o, l, d) {
    var A = o.tag;
    if (A === 5 || A === 6) o = o.stateNode, l ? d.insertBefore(o, l) : d.appendChild(o);
    else if (A !== 4 && (o = o.child, o !== null)) for (fo(o, l, d), o = o.sibling; o !== null; ) fo(o, l, d), o = o.sibling;
  }
  var Cn = null, d2 = !1;
  function Q2(o, l, d) {
    for (d = d.child; d !== null; ) Co(o, l, d), d = d.sibling;
  }
  function Co(o, l, d) {
    if (J2 && typeof J2.onCommitFiberUnmount == "function") try {
      J2.onCommitFiberUnmount(Fi, d);
    } catch {
    }
    switch (d.tag) {
      case 5:
        x2 || co(d, l);
      case 6:
        var A = Cn, v = d2;
        Cn = null, Q2(o, l, d), Cn = A, d2 = v, Cn !== null && (d2 ? (o = Cn, d = d.stateNode, o.nodeType === 8 ? o.parentNode.removeChild(d) : o.removeChild(d)) : Cn.removeChild(d.stateNode));
        break;
      case 18:
        Cn !== null && (d2 ? (o = Cn, d = d.stateNode, o.nodeType === 8 ? G0(o.parentNode, d) : o.nodeType === 1 && G0(o, d), U(o)) : G0(Cn, d.stateNode));
        break;
      case 4:
        A = Cn, v = d2, Cn = d.stateNode.containerInfo, d2 = !0, Q2(o, l, d), Cn = A, d2 = v;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!x2 && (A = d.updateQueue, A !== null && (A = A.lastEffect, A !== null))) {
          v = A = A.next;
          do {
            var x = v, j = x.destroy;
            x = x.tag, j !== void 0 && (x & 2 || x & 4) && O4(d, l, j), v = v.next;
          } while (v !== A);
        }
        Q2(o, l, d);
        break;
      case 1:
        if (!x2 && (co(d, l), A = d.stateNode, typeof A.componentWillUnmount == "function")) try {
          A.props = d.memoizedProps, A.state = d.memoizedState, A.componentWillUnmount();
        } catch (_) {
          Mn(d, l, _);
        }
        Q2(o, l, d);
        break;
      case 21:
        Q2(o, l, d);
        break;
      case 22:
        d.mode & 1 ? (x2 = (A = x2) || d.memoizedState !== null, Q2(o, l, d), x2 = A) : Q2(o, l, d);
        break;
      default:
        Q2(o, l, d);
    }
  }
  function Ao(o) {
    var l = o.updateQueue;
    if (l !== null) {
      o.updateQueue = null;
      var d = o.stateNode;
      d === null && (d = o.stateNode = new Au()), l.forEach(function(A) {
        var v = J6.bind(null, o, A);
        d.has(A) || (d.add(A), A.then(v, v));
      });
    }
  }
  function C2(o, l) {
    var d = l.deletions;
    if (d !== null) for (var A = 0; A < d.length; A++) {
      var v = d[A];
      try {
        var x = o, j = l, _ = j;
        e: for (; _ !== null; ) {
          switch (_.tag) {
            case 5:
              Cn = _.stateNode, d2 = !1;
              break e;
            case 3:
              Cn = _.stateNode.containerInfo, d2 = !0;
              break e;
            case 4:
              Cn = _.stateNode.containerInfo, d2 = !0;
              break e;
          }
          _ = _.return;
        }
        if (Cn === null) throw Error(i(160));
        Co(x, j, v), Cn = null, d2 = !1;
        var X = v.alternate;
        X !== null && (X.return = null), v.return = null;
      } catch (c1) {
        Mn(v, l, c1);
      }
    }
    if (l.subtreeFlags & 12854) for (l = l.child; l !== null; ) Jd(l, o), l = l.sibling;
  }
  function Jd(o, l) {
    var d = o.alternate, A = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (C2(l, o), _3(o), A & 4) {
          try {
            go(3, o, o.return), pu(3, o);
          } catch (be) {
            Mn(o, o.return, be);
          }
          try {
            go(5, o, o.return);
          } catch (be) {
            Mn(o, o.return, be);
          }
        }
        break;
      case 1:
        C2(l, o), _3(o), A & 512 && d !== null && co(d, d.return);
        break;
      case 5:
        if (C2(l, o), _3(o), A & 512 && d !== null && co(d, d.return), o.flags & 32) {
          var v = o.stateNode;
          try {
            Pn(v, "");
          } catch (be) {
            Mn(o, o.return, be);
          }
        }
        if (A & 4 && (v = o.stateNode, v != null)) {
          var x = o.memoizedProps, j = d !== null ? d.memoizedProps : x, _ = o.type, X = o.updateQueue;
          if (o.updateQueue = null, X !== null) try {
            _ === "input" && x.type === "radio" && x.name != null && $e(v, x), nn(_, j);
            var c1 = nn(_, x);
            for (j = 0; j < X.length; j += 2) {
              var R1 = X[j], j1 = X[j + 1];
              R1 === "style" ? Et(v, j1) : R1 === "dangerouslySetInnerHTML" ? Fe(v, j1) : R1 === "children" ? Pn(v, j1) : V(v, R1, j1, c1);
            }
            switch (_) {
              case "input":
                W1(v, x);
                break;
              case "textarea":
                nt(v, x);
                break;
              case "select":
                var x1 = v._wrapperState.wasMultiple;
                v._wrapperState.wasMultiple = !!x.multiple;
                var ge = x.value;
                ge != null ? tt(v, !!x.multiple, ge, !1) : x1 !== !!x.multiple && (x.defaultValue != null ? tt(
                  v,
                  !!x.multiple,
                  x.defaultValue,
                  !0
                ) : tt(v, !!x.multiple, x.multiple ? [] : "", !1));
            }
            v[Gi] = x;
          } catch (be) {
            Mn(o, o.return, be);
          }
        }
        break;
      case 6:
        if (C2(l, o), _3(o), A & 4) {
          if (o.stateNode === null) throw Error(i(162));
          v = o.stateNode, x = o.memoizedProps;
          try {
            v.nodeValue = x;
          } catch (be) {
            Mn(o, o.return, be);
          }
        }
        break;
      case 3:
        if (C2(l, o), _3(o), A & 4 && d !== null && d.memoizedState.isDehydrated) try {
          U(l.containerInfo);
        } catch (be) {
          Mn(o, o.return, be);
        }
        break;
      case 4:
        C2(l, o), _3(o);
        break;
      case 13:
        C2(l, o), _3(o), v = o.child, v.flags & 8192 && (x = v.memoizedState !== null, v.stateNode.isHidden = x, !x || v.alternate !== null && v.alternate.memoizedState !== null || (vu = vt())), A & 4 && Ao(o);
        break;
      case 22:
        if (R1 = d !== null && d.memoizedState !== null, o.mode & 1 ? (x2 = (c1 = x2) || R1, C2(l, o), x2 = c1) : C2(l, o), _3(o), A & 8192) {
          if (c1 = o.memoizedState !== null, (o.stateNode.isHidden = c1) && !R1 && o.mode & 1) for (Ie = o, R1 = o.child; R1 !== null; ) {
            for (j1 = Ie = R1; Ie !== null; ) {
              switch (x1 = Ie, ge = x1.child, x1.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  go(4, x1, x1.return);
                  break;
                case 1:
                  co(x1, x1.return);
                  var me = x1.stateNode;
                  if (typeof me.componentWillUnmount == "function") {
                    A = x1, d = x1.return;
                    try {
                      l = A, me.props = l.memoizedProps, me.state = l.memoizedState, me.componentWillUnmount();
                    } catch (be) {
                      Mn(A, d, be);
                    }
                  }
                  break;
                case 5:
                  co(x1, x1.return);
                  break;
                case 22:
                  if (x1.memoizedState !== null) {
                    Kd(j1);
                    continue;
                  }
              }
              ge !== null ? (ge.return = x1, Ie = ge) : Kd(j1);
            }
            R1 = R1.sibling;
          }
          e: for (R1 = null, j1 = o; ; ) {
            if (j1.tag === 5) {
              if (R1 === null) {
                R1 = j1;
                try {
                  v = j1.stateNode, c1 ? (x = v.style, typeof x.setProperty == "function" ? x.setProperty("display", "none", "important") : x.display = "none") : (_ = j1.stateNode, X = j1.memoizedProps.style, j = X != null && X.hasOwnProperty("display") ? X.display : null, _.style.display = Ye("display", j));
                } catch (be) {
                  Mn(o, o.return, be);
                }
              }
            } else if (j1.tag === 6) {
              if (R1 === null) try {
                j1.stateNode.nodeValue = c1 ? "" : j1.memoizedProps;
              } catch (be) {
                Mn(o, o.return, be);
              }
            } else if ((j1.tag !== 22 && j1.tag !== 23 || j1.memoizedState === null || j1 === o) && j1.child !== null) {
              j1.child.return = j1, j1 = j1.child;
              continue;
            }
            if (j1 === o) break e;
            for (; j1.sibling === null; ) {
              if (j1.return === null || j1.return === o) break e;
              R1 === j1 && (R1 = null), j1 = j1.return;
            }
            R1 === j1 && (R1 = null), j1.sibling.return = j1.return, j1 = j1.sibling;
          }
        }
        break;
      case 19:
        C2(l, o), _3(o), A & 4 && Ao(o);
        break;
      case 21:
        break;
      default:
        C2(
          l,
          o
        ), _3(o);
    }
  }
  function _3(o) {
    var l = o.flags;
    if (l & 2) {
      try {
        e: {
          for (var d = o.return; d !== null; ) {
            if (D4(d)) {
              var A = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (A.tag) {
          case 5:
            var v = A.stateNode;
            A.flags & 32 && (Pn(v, ""), A.flags &= -33);
            var x = _d(o);
            fo(o, x, v);
            break;
          case 3:
          case 4:
            var j = A.stateNode.containerInfo, _ = _d(o);
            Rs(o, _, j);
            break;
          default:
            throw Error(i(161));
        }
      } catch (X) {
        Mn(o, o.return, X);
      }
      o.flags &= -3;
    }
    l & 4096 && (o.flags &= -4097);
  }
  function B6(o, l, d) {
    Ie = o, k4(o);
  }
  function k4(o, l, d) {
    for (var A = (o.mode & 1) !== 0; Ie !== null; ) {
      var v = Ie, x = v.child;
      if (v.tag === 22 && A) {
        var j = v.memoizedState !== null || uo;
        if (!j) {
          var _ = v.alternate, X = _ !== null && _.memoizedState !== null || x2;
          _ = uo;
          var c1 = x2;
          if (uo = j, (x2 = X) && !c1) for (Ie = v; Ie !== null; ) j = Ie, X = j.child, j.tag === 22 && j.memoizedState !== null ? j4(v) : X !== null ? (X.return = j, Ie = X) : j4(v);
          for (; x !== null; ) Ie = x, k4(x), x = x.sibling;
          Ie = v, uo = _, x2 = c1;
        }
        Io(o);
      } else v.subtreeFlags & 8772 && x !== null ? (x.return = v, Ie = x) : Io(o);
    }
  }
  function Io(o) {
    for (; Ie !== null; ) {
      var l = Ie;
      if (l.flags & 8772) {
        var d = l.alternate;
        try {
          if (l.flags & 8772) switch (l.tag) {
            case 0:
            case 11:
            case 15:
              x2 || pu(5, l);
              break;
            case 1:
              var A = l.stateNode;
              if (l.flags & 4 && !x2) if (d === null) A.componentDidMount();
              else {
                var v = l.elementType === l.type ? d.memoizedProps : vr(l.type, d.memoizedProps);
                A.componentDidUpdate(v, d.memoizedState, A.__reactInternalSnapshotBeforeUpdate);
              }
              var x = l.updateQueue;
              x !== null && Ld(l, x, A);
              break;
            case 3:
              var j = l.updateQueue;
              if (j !== null) {
                if (d = null, l.child !== null) switch (l.child.tag) {
                  case 5:
                    d = l.child.stateNode;
                    break;
                  case 1:
                    d = l.child.stateNode;
                }
                Ld(l, j, d);
              }
              break;
            case 5:
              var _ = l.stateNode;
              if (d === null && l.flags & 4) {
                d = _;
                var X = l.memoizedProps;
                switch (l.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    X.autoFocus && d.focus();
                    break;
                  case "img":
                    X.src && (d.src = X.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (l.memoizedState === null) {
                var c1 = l.alternate;
                if (c1 !== null) {
                  var R1 = c1.memoizedState;
                  if (R1 !== null) {
                    var j1 = R1.dehydrated;
                    j1 !== null && U(j1);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          x2 || l.flags & 512 && hu(l);
        } catch (x1) {
          Mn(l, l.return, x1);
        }
      }
      if (l === o) {
        Ie = null;
        break;
      }
      if (d = l.sibling, d !== null) {
        d.return = l.return, Ie = d;
        break;
      }
      Ie = l.return;
    }
  }
  function Kd(o) {
    for (; Ie !== null; ) {
      var l = Ie;
      if (l === o) {
        Ie = null;
        break;
      }
      var d = l.sibling;
      if (d !== null) {
        d.return = l.return, Ie = d;
        break;
      }
      Ie = l.return;
    }
  }
  function j4(o) {
    for (; Ie !== null; ) {
      var l = Ie;
      try {
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            var d = l.return;
            try {
              pu(4, l);
            } catch (X) {
              Mn(l, d, X);
            }
            break;
          case 1:
            var A = l.stateNode;
            if (typeof A.componentDidMount == "function") {
              var v = l.return;
              try {
                A.componentDidMount();
              } catch (X) {
                Mn(l, v, X);
              }
            }
            var x = l.return;
            try {
              hu(l);
            } catch (X) {
              Mn(l, x, X);
            }
            break;
          case 5:
            var j = l.return;
            try {
              hu(l);
            } catch (X) {
              Mn(l, j, X);
            }
        }
      } catch (X) {
        Mn(l, l.return, X);
      }
      if (l === o) {
        Ie = null;
        break;
      }
      var _ = l.sibling;
      if (_ !== null) {
        _.return = l.return, Ie = _;
        break;
      }
      Ie = l.return;
    }
  }
  var H6 = Math.ceil, la = Y.ReactCurrentDispatcher, mu = Y.ReactCurrentOwner, l3 = Y.ReactCurrentBatchConfig, ft = 0, En = null, ln = null, Zn = 0, wr = 0, po = Ze(0), $n = 0, Os = null, ua = 0, ho = 0, z4 = 0, oi = null, W2 = null, vu = 0, mo = 1 / 0, S0 = null, yu = !1, N4 = null, u3 = null, vo = !1, c3 = null, bu = 0, Ds = 0, wu = null, ks = -1, ca = 0;
  function A2() {
    return ft & 6 ? vt() : ks !== -1 ? ks : ks = vt();
  }
  function E0(o) {
    return o.mode & 1 ? ft & 2 && Zn !== 0 ? Zn & -Zn : Ul.transition !== null ? (ca === 0 && (ca = Na()), ca) : (o = Be, o !== 0 || (o = window.event, o = o === void 0 ? 16 : st(o.type)), o) : 1;
  }
  function hn(o, l, d, A) {
    if (50 < Ds) throw Ds = 0, wu = null, Error(i(185));
    F3(o, d, A), (!(ft & 2) || o !== En) && (o === En && (!(ft & 2) && (ho |= d), $n === 4 && J3(o, Zn)), e2(o, A), d === 1 && ft === 0 && !(l.mode & 1) && (mo = vt() + 500, f2 && Ar()));
  }
  function e2(o, l) {
    var d = o.callbackNode;
    K0(o, l);
    var A = K2(o, o === En ? Zn : 0);
    if (A === 0) d !== null && Zt(d), o.callbackNode = null, o.callbackPriority = 0;
    else if (l = A & -A, o.callbackPriority !== l) {
      if (d != null && Zt(d), l === 1) o.tag === 0 ? C4(yo.bind(null, o)) : d4(yo.bind(null, o)), c4(function() {
        !(ft & 6) && Ar();
      }), d = null;
      else {
        switch (Hi(A)) {
          case 1:
            d = _2;
            break;
          case 4:
            d = rt;
            break;
          case 16:
            d = Gr;
            break;
          case 536870912:
            d = ts;
            break;
          default:
            d = Gr;
        }
        d = e9(d, xu.bind(null, o));
      }
      o.callbackPriority = l, o.callbackNode = d;
    }
  }
  function xu(o, l) {
    if (ks = -1, ca = 0, ft & 6) throw Error(i(327));
    var d = o.callbackNode;
    if (bo() && o.callbackNode !== d) return null;
    var A = K2(o, o === En ? Zn : 0);
    if (A === 0) return null;
    if (A & 30 || A & o.expiredLanes || l) l = Eu(o, A);
    else {
      l = A;
      var v = ft;
      ft |= 2;
      var x = Qd();
      (En !== o || Zn !== l) && (S0 = null, mo = vt() + 500, fa(o, l));
      do
        try {
          W6();
          break;
        } catch (_) {
          Yd(o, _);
        }
      while (!0);
      Br(), la.current = x, ft = v, ln !== null ? l = 0 : (En = null, Zn = 0, l = $n);
    }
    if (l !== 0) {
      if (l === 2 && (v = ns(o), v !== 0 && (A = v, l = ga(o, v))), l === 1) throw d = Os, fa(o, 0), J3(o, A), e2(o, vt()), d;
      if (l === 6) J3(o, A);
      else {
        if (v = o.current.alternate, !(A & 30) && !F4(v) && (l = Eu(o, A), l === 2 && (x = ns(o), x !== 0 && (A = x, l = ga(o, x))), l === 1)) throw d = Os, fa(o, 0), J3(o, A), e2(o, vt()), d;
        switch (o.finishedWork = v, o.finishedLanes = A, l) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            si(o, W2, S0);
            break;
          case 3:
            if (J3(o, A), (A & 130023424) === A && (l = vu + 500 - vt(), 10 < l)) {
              if (K2(o, 0) !== 0) break;
              if (v = o.suspendedLanes, (v & A) !== A) {
                A2(), o.pingedLanes |= o.suspendedLanes & v;
                break;
              }
              o.timeoutHandle = Xi(si.bind(null, o, W2, S0), l);
              break;
            }
            si(o, W2, S0);
            break;
          case 4:
            if (J3(o, A), (A & 4194240) === A) break;
            for (l = o.eventTimes, v = -1; 0 < A; ) {
              var j = 31 - lr(A);
              x = 1 << j, j = l[j], j > v && (v = j), A &= ~x;
            }
            if (A = v, A = vt() - A, A = (120 > A ? 120 : 480 > A ? 480 : 1080 > A ? 1080 : 1920 > A ? 1920 : 3e3 > A ? 3e3 : 4320 > A ? 4320 : 1960 * H6(A / 1960)) - A, 10 < A) {
              o.timeoutHandle = Xi(si.bind(null, o, W2, S0), A);
              break;
            }
            si(o, W2, S0);
            break;
          case 5:
            si(o, W2, S0);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return e2(o, vt()), o.callbackNode === d ? xu.bind(null, o) : null;
  }
  function ga(o, l) {
    var d = oi;
    return o.current.memoizedState.isDehydrated && (fa(o, l).flags |= 256), o = Eu(o, l), o !== 2 && (l = W2, W2 = d, l !== null && P4(l)), o;
  }
  function P4(o) {
    W2 === null ? W2 = o : W2.push.apply(W2, o);
  }
  function F4(o) {
    for (var l = o; ; ) {
      if (l.flags & 16384) {
        var d = l.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var A = 0; A < d.length; A++) {
          var v = d[A], x = v.getSnapshot;
          v = v.value;
          try {
            if (!Zr(x(), v)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = l.child, l.subtreeFlags & 16384 && d !== null) d.return = l, l = d;
      else {
        if (l === o) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === o) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function J3(o, l) {
    for (l &= ~z4, l &= ~ho, o.suspendedLanes |= l, o.pingedLanes &= ~l, o = o.expirationTimes; 0 < l; ) {
      var d = 31 - lr(l), A = 1 << d;
      o[d] = -1, l &= ~A;
    }
  }
  function yo(o) {
    if (ft & 6) throw Error(i(327));
    bo();
    var l = K2(o, 0);
    if (!(l & 1)) return e2(o, vt()), null;
    var d = Eu(o, l);
    if (o.tag !== 0 && d === 2) {
      var A = ns(o);
      A !== 0 && (l = A, d = ga(o, A));
    }
    if (d === 1) throw d = Os, fa(o, 0), J3(o, l), e2(o, vt()), d;
    if (d === 6) throw Error(i(345));
    return o.finishedWork = o.current.alternate, o.finishedLanes = l, si(o, W2, S0), e2(o, vt()), null;
  }
  function B4(o, l) {
    var d = ft;
    ft |= 1;
    try {
      return o(l);
    } finally {
      ft = d, ft === 0 && (mo = vt() + 500, f2 && Ar());
    }
  }
  function K3(o) {
    c3 !== null && c3.tag === 0 && !(ft & 6) && bo();
    var l = ft;
    ft |= 1;
    var d = l3.transition, A = Be;
    try {
      if (l3.transition = null, Be = 1, o) return o();
    } finally {
      Be = A, l3.transition = d, ft = l, !(ft & 6) && Ar();
    }
  }
  function Su() {
    wr = po.current, Mt(po);
  }
  function fa(o, l) {
    o.finishedWork = null, o.finishedLanes = 0;
    var d = o.timeoutHandle;
    if (d !== -1 && (o.timeoutHandle = -1, vd(d)), ln !== null) for (d = ln.return; d !== null; ) {
      var A = d;
      switch (I4(A), A.tag) {
        case 1:
          A = A.type.childContextTypes, A != null && t3();
          break;
        case 3:
          Za(), Mt(xn), Mt(_e), w4();
          break;
        case 5:
          b4(A);
          break;
        case 4:
          Za();
          break;
        case 13:
          Mt(dn);
          break;
        case 19:
          Mt(dn);
          break;
        case 10:
          m4(A.type._context);
          break;
        case 22:
        case 23:
          Su();
      }
      d = d.return;
    }
    if (En = o, ln = o = li(o.current, null), Zn = wr = l, $n = 0, Os = null, z4 = ho = ua = 0, W2 = oi = null, $i !== null) {
      for (l = 0; l < $i.length; l++) if (d = $i[l], A = d.interleaved, A !== null) {
        d.interleaved = null;
        var v = A.next, x = d.pending;
        if (x !== null) {
          var j = x.next;
          x.next = v, A.next = j;
        }
        d.pending = A;
      }
      $i = null;
    }
    return o;
  }
  function Yd(o, l) {
    do {
      var d = ln;
      try {
        if (Br(), Ql.current = H2, Hr) {
          for (var A = Te.memoizedState; A !== null; ) {
            var v = A.queue;
            v !== null && (v.pending = null), A = A.next;
          }
          Hr = !1;
        }
        if (Se = 0, lt = Je = Te = null, $a = !1, ys = 0, mu.current = null, d === null || d.return === null) {
          $n = 1, Os = l, ln = null;
          break;
        }
        e: {
          var x = o, j = d.return, _ = d, X = l;
          if (l = Zn, _.flags |= 32768, X !== null && typeof X == "object" && typeof X.then == "function") {
            var c1 = X, R1 = _, j1 = R1.tag;
            if (!(R1.mode & 1) && (j1 === 0 || j1 === 11 || j1 === 15)) {
              var x1 = R1.alternate;
              x1 ? (R1.updateQueue = x1.updateQueue, R1.memoizedState = x1.memoizedState, R1.lanes = x1.lanes) : (R1.updateQueue = null, R1.memoizedState = null);
            }
            var ge = Fd(j);
            if (ge !== null) {
              ge.flags &= -257, T4(ge, j, _, x, l), ge.mode & 1 && Es(x, c1, l), l = ge, X = c1;
              var me = l.updateQueue;
              if (me === null) {
                var be = /* @__PURE__ */ new Set();
                be.add(X), l.updateQueue = be;
              } else me.add(X);
              break e;
            } else {
              if (!(l & 1)) {
                Es(x, c1, l), js();
                break e;
              }
              X = Error(i(426));
            }
          } else if (sn && _.mode & 1) {
            var jn = Fd(j);
            if (jn !== null) {
              !(jn.flags & 65536) && (jn.flags |= 256), T4(jn, j, _, x, l), h4(ii(X, _));
              break e;
            }
          }
          x = X = ii(X, _), $n !== 4 && ($n = 2), oi === null ? oi = [x] : oi.push(x), x = j;
          do {
            switch (x.tag) {
              case 3:
                x.flags |= 65536, l &= -l, x.lanes |= l;
                var r1 = Nd(x, X, l);
                Td(x, r1);
                break e;
              case 1:
                _ = X;
                var $ = x.type, o1 = x.stateNode;
                if (!(x.flags & 128) && (typeof $.getDerivedStateFromError == "function" || o1 !== null && typeof o1.componentDidCatch == "function" && (u3 === null || !u3.has(o1)))) {
                  x.flags |= 65536, l &= -l, x.lanes |= l;
                  var _1 = Pd(x, _, l);
                  Td(x, _1);
                  break e;
                }
            }
            x = x.return;
          } while (x !== null);
        }
        Gd(d);
      } catch (Ee) {
        l = Ee, ln === d && d !== null && (ln = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Qd() {
    var o = la.current;
    return la.current = H2, o === null ? H2 : o;
  }
  function js() {
    ($n === 0 || $n === 3 || $n === 2) && ($n = 4), En === null || !(ua & 268435455) && !(ho & 268435455) || J3(En, Zn);
  }
  function Eu(o, l) {
    var d = ft;
    ft |= 2;
    var A = Qd();
    (En !== o || Zn !== l) && (S0 = null, fa(o, l));
    do
      try {
        U6();
        break;
      } catch (v) {
        Yd(o, v);
      }
    while (!0);
    if (Br(), ft = d, la.current = A, ln !== null) throw Error(i(261));
    return En = null, Zn = 0, $n;
  }
  function U6() {
    for (; ln !== null; ) Xd(ln);
  }
  function W6() {
    for (; ln !== null && !N2(); ) Xd(ln);
  }
  function Xd(o) {
    var l = $d(o.alternate, o, wr);
    o.memoizedProps = o.pendingProps, l === null ? Gd(o) : ln = l, mu.current = null;
  }
  function Gd(o) {
    var l = o;
    do {
      var d = l.alternate;
      if (o = l.return, l.flags & 32768) {
        if (d = P6(d, l), d !== null) {
          d.flags &= 32767, ln = d;
          return;
        }
        if (o !== null) o.flags |= 32768, o.subtreeFlags = 0, o.deletions = null;
        else {
          $n = 6, ln = null;
          return;
        }
      } else if (d = N6(d, l, wr), d !== null) {
        ln = d;
        return;
      }
      if (l = l.sibling, l !== null) {
        ln = l;
        return;
      }
      ln = l = o;
    } while (l !== null);
    $n === 0 && ($n = 5);
  }
  function si(o, l, d) {
    var A = Be, v = l3.transition;
    try {
      l3.transition = null, Be = 1, V6(o, l, d, A);
    } finally {
      l3.transition = v, Be = A;
    }
    return null;
  }
  function V6(o, l, d, A) {
    do
      bo();
    while (c3 !== null);
    if (ft & 6) throw Error(i(327));
    d = o.finishedWork;
    var v = o.finishedLanes;
    if (d === null) return null;
    if (o.finishedWork = null, o.finishedLanes = 0, d === o.current) throw Error(i(177));
    o.callbackNode = null, o.callbackPriority = 0;
    var x = d.lanes | d.childLanes;
    if (Fa(o, x), o === En && (ln = En = null, Zn = 0), !(d.subtreeFlags & 2064) && !(d.flags & 2064) || vo || (vo = !0, e9(Gr, function() {
      return bo(), null;
    })), x = (d.flags & 15990) !== 0, d.subtreeFlags & 15990 || x) {
      x = l3.transition, l3.transition = null;
      var j = Be;
      Be = 1;
      var _ = ft;
      ft |= 4, mu.current = null, F6(o, d), Jd(d, o), Rl(Qi), u1 = !!l4, Qi = l4 = null, o.current = d, B6(d), P3(), ft = _, Be = j, l3.transition = x;
    } else o.current = d;
    if (vo && (vo = !1, c3 = o, bu = v), x = o.pendingLanes, x === 0 && (u3 = null), vl(d.stateNode), e2(o, vt()), l !== null) for (A = o.onRecoverableError, d = 0; d < l.length; d++) v = l[d], A(v.value, { componentStack: v.stack, digest: v.digest });
    if (yu) throw yu = !1, o = N4, N4 = null, o;
    return bu & 1 && o.tag !== 0 && bo(), x = o.pendingLanes, x & 1 ? o === wu ? Ds++ : (Ds = 0, wu = o) : Ds = 0, Ar(), null;
  }
  function bo() {
    if (c3 !== null) {
      var o = Hi(bu), l = l3.transition, d = Be;
      try {
        if (l3.transition = null, Be = 16 > o ? 16 : o, c3 === null) var A = !1;
        else {
          if (o = c3, c3 = null, bu = 0, ft & 6) throw Error(i(331));
          var v = ft;
          for (ft |= 4, Ie = o.current; Ie !== null; ) {
            var x = Ie, j = x.child;
            if (Ie.flags & 16) {
              var _ = x.deletions;
              if (_ !== null) {
                for (var X = 0; X < _.length; X++) {
                  var c1 = _[X];
                  for (Ie = c1; Ie !== null; ) {
                    var R1 = Ie;
                    switch (R1.tag) {
                      case 0:
                      case 11:
                      case 15:
                        go(8, R1, x);
                    }
                    var j1 = R1.child;
                    if (j1 !== null) j1.return = R1, Ie = j1;
                    else for (; Ie !== null; ) {
                      R1 = Ie;
                      var x1 = R1.sibling, ge = R1.return;
                      if (Vd(R1), R1 === c1) {
                        Ie = null;
                        break;
                      }
                      if (x1 !== null) {
                        x1.return = ge, Ie = x1;
                        break;
                      }
                      Ie = ge;
                    }
                  }
                }
                var me = x.alternate;
                if (me !== null) {
                  var be = me.child;
                  if (be !== null) {
                    me.child = null;
                    do {
                      var jn = be.sibling;
                      be.sibling = null, be = jn;
                    } while (be !== null);
                  }
                }
                Ie = x;
              }
            }
            if (x.subtreeFlags & 2064 && j !== null) j.return = x, Ie = j;
            else e: for (; Ie !== null; ) {
              if (x = Ie, x.flags & 2048) switch (x.tag) {
                case 0:
                case 11:
                case 15:
                  go(9, x, x.return);
              }
              var r1 = x.sibling;
              if (r1 !== null) {
                r1.return = x.return, Ie = r1;
                break e;
              }
              Ie = x.return;
            }
          }
          var $ = o.current;
          for (Ie = $; Ie !== null; ) {
            j = Ie;
            var o1 = j.child;
            if (j.subtreeFlags & 2064 && o1 !== null) o1.return = j, Ie = o1;
            else e: for (j = $; Ie !== null; ) {
              if (_ = Ie, _.flags & 2048) try {
                switch (_.tag) {
                  case 0:
                  case 11:
                  case 15:
                    pu(9, _);
                }
              } catch (Ee) {
                Mn(_, _.return, Ee);
              }
              if (_ === j) {
                Ie = null;
                break e;
              }
              var _1 = _.sibling;
              if (_1 !== null) {
                _1.return = _.return, Ie = _1;
                break e;
              }
              Ie = _.return;
            }
          }
          if (ft = v, Ar(), J2 && typeof J2.onPostCommitFiberRoot == "function") try {
            J2.onPostCommitFiberRoot(Fi, o);
          } catch {
          }
          A = !0;
        }
        return A;
      } finally {
        Be = d, l3.transition = l;
      }
    }
    return !1;
  }
  function qd(o, l, d) {
    l = ii(d, l), l = Nd(o, l, 1), o = ni(o, l, 1), l = A2(), o !== null && (F3(o, 1, l), e2(o, l));
  }
  function Mn(o, l, d) {
    if (o.tag === 3) qd(o, o, d);
    else for (; l !== null; ) {
      if (l.tag === 3) {
        qd(l, o, d);
        break;
      } else if (l.tag === 1) {
        var A = l.stateNode;
        if (typeof l.type.getDerivedStateFromError == "function" || typeof A.componentDidCatch == "function" && (u3 === null || !u3.has(A))) {
          o = ii(d, o), o = Pd(l, o, 1), l = ni(l, o, 1), o = A2(), l !== null && (F3(l, 1, o), e2(l, o));
          break;
        }
      }
      l = l.return;
    }
  }
  function _6(o, l, d) {
    var A = o.pingCache;
    A !== null && A.delete(l), l = A2(), o.pingedLanes |= o.suspendedLanes & d, En === o && (Zn & d) === d && ($n === 4 || $n === 3 && (Zn & 130023424) === Zn && 500 > vt() - vu ? fa(o, 0) : z4 |= d), e2(o, l);
  }
  function Zd(o, l) {
    l === 0 && (o.mode & 1 ? (l = g0, g0 <<= 1, !(g0 & 130023424) && (g0 = 4194304)) : l = 1);
    var d = A2();
    o = b0(o, l), o !== null && (F3(o, l, d), e2(o, d));
  }
  function H4(o) {
    var l = o.memoizedState, d = 0;
    l !== null && (d = l.retryLane), Zd(o, d);
  }
  function J6(o, l) {
    var d = 0;
    switch (o.tag) {
      case 13:
        var A = o.stateNode, v = o.memoizedState;
        v !== null && (d = v.retryLane);
        break;
      case 19:
        A = o.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    A !== null && A.delete(l), Zd(o, d);
  }
  var $d;
  $d = function(o, l, d) {
    if (o !== null) if (o.memoizedProps !== l.pendingProps || xn.current) yr = !0;
    else {
      if (!(o.lanes & d) && !(l.flags & 128)) return yr = !1, x0(o, l, d);
      yr = !!(o.flags & 131072);
    }
    else yr = !1, sn && l.flags & 1048576 && A4(l, Ya, l.index);
    switch (l.lanes = 0, l.tag) {
      case 2:
        var A = l.type;
        Ls(o, l), o = l.pendingProps;
        var v = e3(l, _e.current);
        Xa(l, d), v = w1(null, l, A, o, v, d);
        var x = Wn();
        return l.flags |= 1, typeof v == "object" && v !== null && typeof v.render == "function" && v.$$typeof === void 0 ? (l.tag = 1, l.memoizedState = null, l.updateQueue = null, fn(A) ? (x = !0, Nl(l)) : x = !1, l.memoizedState = v.state !== null && v.state !== void 0 ? v.state : null, Vl(l), v.updater = aa, l.stateNode = v, v._reactInternals = l, E4(l, A, o, d), l = gu(null, l, A, !0, x, d)) : (l.tag = 0, sn && x && Pl(l), Dn(null, l, v, d), l = l.child), l;
      case 16:
        A = l.elementType;
        e: {
          switch (Ls(o, l), o = l.pendingProps, v = A._init, A = v(A._payload), l.type = A, v = l.tag = K6(A), o = vr(A, o), v) {
            case 0:
              l = qe(null, l, A, o, d);
              break e;
            case 1:
              l = Ms(null, l, A, o, d);
              break e;
            case 11:
              l = oo(null, l, A, o, d);
              break e;
            case 14:
              l = ai(null, l, A, vr(A.type, o), d);
              break e;
          }
          throw Error(i(
            306,
            A,
            ""
          ));
        }
        return l;
      case 0:
        return A = l.type, v = l.pendingProps, v = l.elementType === A ? v : vr(A, v), qe(o, l, A, v, d);
      case 1:
        return A = l.type, v = l.pendingProps, v = l.elementType === A ? v : vr(A, v), Ms(o, l, A, v, d);
      case 3:
        e: {
          if (z6(l), o === null) throw Error(i(387));
          A = l.pendingProps, x = l.memoizedState, v = x.element, Ga(o, l), Jl(l, A, null, d);
          var j = l.memoizedState;
          if (A = j.element, x.isDehydrated) if (x = { element: A, isDehydrated: !1, cache: j.cache, pendingSuspenseBoundaries: j.pendingSuspenseBoundaries, transitions: j.transitions }, l.updateQueue.baseState = x, l.memoizedState = x, l.flags & 256) {
            v = ii(Error(i(423)), l), l = Hd(o, l, A, d, v);
            break e;
          } else if (A !== v) {
            v = ii(Error(i(424)), l), l = Hd(o, l, A, d, v);
            break e;
          } else for (hr = x3(l.stateNode.containerInfo.firstChild), Fr = l, sn = !0, r3 = null, d = Ed(l, null, A, d), l.child = d; d; ) d.flags = d.flags & -3 | 4096, d = d.sibling;
          else {
            if (pn(), A === v) {
              l = kn(o, l, d);
              break e;
            }
            Dn(o, l, A, d);
          }
          l = l.child;
        }
        return l;
      case 5:
        return Rd(l), o === null && Bl(l), A = l.type, v = l.pendingProps, x = o !== null ? o.memoizedProps : null, j = v.children, ds(A, v) ? j = null : x !== null && ds(A, x) && (l.flags |= 32), oa(o, l), Dn(o, l, j, d), l.child;
      case 6:
        return o === null && Bl(l), null;
      case 13:
        return Ud(o, l, d);
      case 4:
        return y4(l, l.stateNode.containerInfo), A = l.pendingProps, o === null ? l.child = Qa(l, null, A, d) : Dn(o, l, A, d), l.child;
      case 11:
        return A = l.type, v = l.pendingProps, v = l.elementType === A ? v : vr(A, v), oo(o, l, A, v, d);
      case 7:
        return Dn(o, l, l.pendingProps, d), l.child;
      case 8:
        return Dn(o, l, l.pendingProps.children, d), l.child;
      case 12:
        return Dn(o, l, l.pendingProps.children, d), l.child;
      case 10:
        e: {
          if (A = l.type._context, v = l.pendingProps, x = l.memoizedProps, j = v.value, kt(y0, A._currentValue), A._currentValue = j, x !== null) if (Zr(x.value, j)) {
            if (x.children === v.children && !xn.current) {
              l = kn(o, l, d);
              break e;
            }
          } else for (x = l.child, x !== null && (x.return = l); x !== null; ) {
            var _ = x.dependencies;
            if (_ !== null) {
              j = x.child;
              for (var X = _.firstContext; X !== null; ) {
                if (X.context === A) {
                  if (x.tag === 1) {
                    X = mr(-1, d & -d), X.tag = 2;
                    var c1 = x.updateQueue;
                    if (c1 !== null) {
                      c1 = c1.shared;
                      var R1 = c1.pending;
                      R1 === null ? X.next = X : (X.next = R1.next, R1.next = X), c1.pending = X;
                    }
                  }
                  x.lanes |= d, X = x.alternate, X !== null && (X.lanes |= d), v4(
                    x.return,
                    d,
                    l
                  ), _.lanes |= d;
                  break;
                }
                X = X.next;
              }
            } else if (x.tag === 10) j = x.type === l.type ? null : x.child;
            else if (x.tag === 18) {
              if (j = x.return, j === null) throw Error(i(341));
              j.lanes |= d, _ = j.alternate, _ !== null && (_.lanes |= d), v4(j, d, l), j = x.sibling;
            } else j = x.child;
            if (j !== null) j.return = x;
            else for (j = x; j !== null; ) {
              if (j === l) {
                j = null;
                break;
              }
              if (x = j.sibling, x !== null) {
                x.return = j.return, j = x;
                break;
              }
              j = j.return;
            }
            x = j;
          }
          Dn(o, l, v.children, d), l = l.child;
        }
        return l;
      case 9:
        return v = l.type, A = l.pendingProps.children, Xa(l, d), v = a3(v), A = A(v), l.flags |= 1, Dn(o, l, A, d), l.child;
      case 14:
        return A = l.type, v = vr(A, l.pendingProps), v = vr(A.type, v), ai(o, l, A, v, d);
      case 15:
        return cu(o, l, l.type, l.pendingProps, d);
      case 17:
        return A = l.type, v = l.pendingProps, v = l.elementType === A ? v : vr(A, v), Ls(o, l), l.tag = 1, fn(A) ? (o = !0, Nl(l)) : o = !1, Xa(l, d), kd(l, A, v), E4(l, A, v, d), gu(null, l, A, !0, o, d);
      case 19:
        return R4(o, l, d);
      case 22:
        return br(o, l, d);
    }
    throw Error(i(156, l.tag));
  };
  function e9(o, l) {
    return Pt(o, l);
  }
  function t9(o, l, d, A) {
    this.tag = o, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = A, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function g3(o, l, d, A) {
    return new t9(o, l, d, A);
  }
  function U4(o) {
    return o = o.prototype, !(!o || !o.isReactComponent);
  }
  function K6(o) {
    if (typeof o == "function") return U4(o) ? 1 : 0;
    if (o != null) {
      if (o = o.$$typeof, o === J1) return 11;
      if (o === h1) return 14;
    }
    return 2;
  }
  function li(o, l) {
    var d = o.alternate;
    return d === null ? (d = g3(o.tag, l, o.key, o.mode), d.elementType = o.elementType, d.type = o.type, d.stateNode = o.stateNode, d.alternate = o, o.alternate = d) : (d.pendingProps = l, d.type = o.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = o.flags & 14680064, d.childLanes = o.childLanes, d.lanes = o.lanes, d.child = o.child, d.memoizedProps = o.memoizedProps, d.memoizedState = o.memoizedState, d.updateQueue = o.updateQueue, l = o.dependencies, d.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, d.sibling = o.sibling, d.index = o.index, d.ref = o.ref, d;
  }
  function Mu(o, l, d, A, v, x) {
    var j = 2;
    if (A = o, typeof o == "function") U4(o) && (j = 1);
    else if (typeof o == "string") j = 5;
    else e: switch (o) {
      case Q:
        return da(d.children, v, x, l);
      case P1:
        j = 8, v |= 8;
        break;
      case Y1:
        return o = g3(12, d, l, v | 2), o.elementType = Y1, o.lanes = x, o;
      case s1:
        return o = g3(13, d, l, v), o.elementType = s1, o.lanes = x, o;
      case d1:
        return o = g3(19, d, l, v), o.elementType = d1, o.lanes = x, o;
      case L1:
        return Tu(d, v, x, l);
      default:
        if (typeof o == "object" && o !== null) switch (o.$$typeof) {
          case O1:
            j = 10;
            break e;
          case T1:
            j = 9;
            break e;
          case J1:
            j = 11;
            break e;
          case h1:
            j = 14;
            break e;
          case C1:
            j = 16, A = null;
            break e;
        }
        throw Error(i(130, o == null ? o : typeof o, ""));
    }
    return l = g3(j, d, l, v), l.elementType = o, l.type = A, l.lanes = x, l;
  }
  function da(o, l, d, A) {
    return o = g3(7, o, A, l), o.lanes = d, o;
  }
  function Tu(o, l, d, A) {
    return o = g3(22, o, A, l), o.elementType = L1, o.lanes = d, o.stateNode = { isHidden: !1 }, o;
  }
  function Lu(o, l, d) {
    return o = g3(6, o, null, l), o.lanes = d, o;
  }
  function zs(o, l, d) {
    return l = g3(4, o.children !== null ? o.children : [], o.key, l), l.lanes = d, l.stateNode = { containerInfo: o.containerInfo, pendingChildren: null, implementation: o.implementation }, l;
  }
  function Ns(o, l, d, A, v) {
    this.tag = l, this.containerInfo = o, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Pa(0), this.expirationTimes = Pa(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Pa(0), this.identifierPrefix = A, this.onRecoverableError = v, this.mutableSourceEagerHydrationData = null;
  }
  function W4(o, l, d, A, v, x, j, _, X) {
    return o = new Ns(o, l, d, _, X), l === 1 ? (l = 1, x === !0 && (l |= 8)) : l = 0, x = g3(3, null, null, l), o.current = x, x.stateNode = o, x.memoizedState = { element: A, isDehydrated: d, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Vl(x), o;
  }
  function n9(o, l, d) {
    var A = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Z, key: A == null ? null : "" + A, children: o, containerInfo: l, implementation: d };
  }
  function V4(o) {
    if (!o) return U3;
    o = o._reactInternals;
    e: {
      if (Ae(o) !== o || o.tag !== 1) throw Error(i(170));
      var l = o;
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context;
            break e;
          case 1:
            if (fn(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        l = l.return;
      } while (l !== null);
      throw Error(i(171));
    }
    if (o.tag === 1) {
      var d = o.type;
      if (fn(d)) return Is(o, d, l);
    }
    return l;
  }
  function _4(o, l, d, A, v, x, j, _, X) {
    return o = W4(d, A, !0, o, v, x, j, _, X), o.context = V4(null), d = o.current, A = A2(), v = E0(d), x = mr(A, v), x.callback = l ?? null, ni(d, x, v), o.current.lanes = v, F3(o, v, A), e2(o, A), o;
  }
  function Ru(o, l, d, A) {
    var v = l.current, x = A2(), j = E0(v);
    return d = V4(d), l.context === null ? l.context = d : l.pendingContext = d, l = mr(x, j), l.payload = { element: o }, A = A === void 0 ? null : A, A !== null && (l.callback = A), o = ni(v, l, j), o !== null && (hn(o, v, j, x), _l(o, v, j)), j;
  }
  function Ps(o) {
    if (o = o.current, !o.child) return null;
    switch (o.child.tag) {
      case 5:
        return o.child.stateNode;
      default:
        return o.child.stateNode;
    }
  }
  function r9(o, l) {
    if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
      var d = o.retryLane;
      o.retryLane = d !== 0 && d < l ? d : l;
    }
  }
  function J4(o, l) {
    r9(o, l), (o = o.alternate) && r9(o, l);
  }
  function Y6() {
    return null;
  }
  var K4 = typeof reportError == "function" ? reportError : function(o) {
    console.error(o);
  };
  function Ou(o) {
    this._internalRoot = o;
  }
  Fs.prototype.render = Ou.prototype.render = function(o) {
    var l = this._internalRoot;
    if (l === null) throw Error(i(409));
    Ru(o, l, null, null);
  }, Fs.prototype.unmount = Ou.prototype.unmount = function() {
    var o = this._internalRoot;
    if (o !== null) {
      this._internalRoot = null;
      var l = o.containerInfo;
      K3(function() {
        Ru(null, o, null, null);
      }), l[m0] = null;
    }
  };
  function Fs(o) {
    this._internalRoot = o;
  }
  Fs.prototype.unstable_scheduleHydration = function(o) {
    if (o) {
      var l = cr();
      o = { blockedOn: null, target: o, priority: l };
      for (var d = 0; d < Dt.length && l !== 0 && l < Dt[d].priority; d++) ;
      Dt.splice(d, 0, o), d === 0 && Wi(o);
    }
  };
  function ui(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11);
  }
  function Du(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11 && (o.nodeType !== 8 || o.nodeValue !== " react-mount-point-unstable "));
  }
  function i9() {
  }
  function Q6(o, l, d, A, v) {
    if (v) {
      if (typeof A == "function") {
        var x = A;
        A = function() {
          var c1 = Ps(j);
          x.call(c1);
        };
      }
      var j = _4(l, A, o, 0, null, !1, !1, "", i9);
      return o._reactRootContainer = j, o[m0] = j.current, Ja(o.nodeType === 8 ? o.parentNode : o), K3(), j;
    }
    for (; v = o.lastChild; ) o.removeChild(v);
    if (typeof A == "function") {
      var _ = A;
      A = function() {
        var c1 = Ps(X);
        _.call(c1);
      };
    }
    var X = W4(o, 0, !1, null, null, !1, !1, "", i9);
    return o._reactRootContainer = X, o[m0] = X.current, Ja(o.nodeType === 8 ? o.parentNode : o), K3(function() {
      Ru(l, X, d, A);
    }), X;
  }
  function ku(o, l, d, A, v) {
    var x = d._reactRootContainer;
    if (x) {
      var j = x;
      if (typeof v == "function") {
        var _ = v;
        v = function() {
          var X = Ps(j);
          _.call(X);
        };
      }
      Ru(l, j, o, v);
    } else j = Q6(d, l, o, v, A);
    return Ps(j);
  }
  rs = function(o) {
    switch (o.tag) {
      case 3:
        var l = o.stateNode;
        if (l.current.memoizedState.isDehydrated) {
          var d = f0(l.pendingLanes);
          d !== 0 && (Bi(l, d | 1), e2(l, vt()), !(ft & 6) && (mo = vt() + 500, Ar()));
        }
        break;
      case 13:
        K3(function() {
          var A = b0(o, 1);
          if (A !== null) {
            var v = A2();
            hn(A, o, 1, v);
          }
        }), J4(o, 1);
    }
  }, ur = function(o) {
    if (o.tag === 13) {
      var l = b0(o, 134217728);
      if (l !== null) {
        var d = A2();
        hn(l, o, 134217728, d);
      }
      J4(o, 134217728);
    }
  }, yt = function(o) {
    if (o.tag === 13) {
      var l = E0(o), d = b0(o, l);
      if (d !== null) {
        var A = A2();
        hn(d, o, l, A);
      }
      J4(o, l);
    }
  }, cr = function() {
    return Be;
  }, Y2 = function(o, l) {
    var d = Be;
    try {
      return Be = o, l();
    } finally {
      Be = d;
    }
  }, y2 = function(o, l, d) {
    switch (l) {
      case "input":
        if (W1(o, d), l = d.name, d.type === "radio" && l != null) {
          for (d = o; d.parentNode; ) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), l = 0; l < d.length; l++) {
            var A = d[l];
            if (A !== o && A.form === o.form) {
              var v = ze(A);
              if (!v) throw Error(i(90));
              D1(A), W1(A, v);
            }
          }
        }
        break;
      case "textarea":
        nt(o, d);
        break;
      case "select":
        l = d.value, l != null && tt(o, !!d.multiple, l, !1);
    }
  }, Pi = B4, z3 = K3;
  var X6 = { usingClientEntryPoint: !1, Events: [As, Ka, ze, l0, W0, B4] }, Bs = { findFiberByHostInstance: $r, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, a9 = { bundleType: Bs.bundleType, version: Bs.version, rendererPackageName: Bs.rendererPackageName, rendererConfig: Bs.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Y.ReactCurrentDispatcher, findHostInstanceByFiber: function(o) {
    return o = et(o), o === null ? null : o.stateNode;
  }, findFiberByHostInstance: Bs.findFiberByHostInstance || Y6, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ju = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ju.isDisabled && ju.supportsFiber) try {
      Fi = ju.inject(a9), J2 = ju;
    } catch {
    }
  }
  return p3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = X6, p3.createPortal = function(o, l) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!ui(l)) throw Error(i(200));
    return n9(o, l, null, d);
  }, p3.createRoot = function(o, l) {
    if (!ui(o)) throw Error(i(299));
    var d = !1, A = "", v = K4;
    return l != null && (l.unstable_strictMode === !0 && (d = !0), l.identifierPrefix !== void 0 && (A = l.identifierPrefix), l.onRecoverableError !== void 0 && (v = l.onRecoverableError)), l = W4(o, 1, !1, null, null, d, !1, A, v), o[m0] = l.current, Ja(o.nodeType === 8 ? o.parentNode : o), new Ou(l);
  }, p3.findDOMNode = function(o) {
    if (o == null) return null;
    if (o.nodeType === 1) return o;
    var l = o._reactInternals;
    if (l === void 0)
      throw typeof o.render == "function" ? Error(i(188)) : (o = Object.keys(o).join(","), Error(i(268, o)));
    return o = et(l), o = o === null ? null : o.stateNode, o;
  }, p3.flushSync = function(o) {
    return K3(o);
  }, p3.hydrate = function(o, l, d) {
    if (!Du(l)) throw Error(i(200));
    return ku(null, o, l, !0, d);
  }, p3.hydrateRoot = function(o, l, d) {
    if (!ui(o)) throw Error(i(405));
    var A = d != null && d.hydratedSources || null, v = !1, x = "", j = K4;
    if (d != null && (d.unstable_strictMode === !0 && (v = !0), d.identifierPrefix !== void 0 && (x = d.identifierPrefix), d.onRecoverableError !== void 0 && (j = d.onRecoverableError)), l = _4(l, null, o, 1, d ?? null, v, !1, x, j), o[m0] = l.current, Ja(o), A) for (o = 0; o < A.length; o++) d = A[o], v = d._getVersion, v = v(d._source), l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [d, v] : l.mutableSourceEagerHydrationData.push(
      d,
      v
    );
    return new Fs(l);
  }, p3.render = function(o, l, d) {
    if (!Du(l)) throw Error(i(200));
    return ku(null, o, l, !1, d);
  }, p3.unmountComponentAtNode = function(o) {
    if (!Du(o)) throw Error(i(40));
    return o._reactRootContainer ? (K3(function() {
      ku(null, null, o, !1, function() {
        o._reactRootContainer = null, o[m0] = null;
      });
    }), !0) : !1;
  }, p3.unstable_batchedUpdates = B4, p3.unstable_renderSubtreeIntoContainer = function(o, l, d, A) {
    if (!Du(d)) throw Error(i(200));
    if (o == null || o._reactInternals === void 0) throw Error(i(38));
    return ku(o, l, d, !1, A);
  }, p3.version = "18.3.1-next-f1338f8080-20240426", p3;
}
var h3 = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cw;
function cH() {
  return cw || (cw = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Gt, n = EE(), i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, a = !1;
    function s(t) {
      a = t;
    }
    function g(t) {
      if (!a) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), f = 1; f < r; f++)
          u[f - 1] = arguments[f];
        I("warn", t, u);
      }
    }
    function c(t) {
      if (!a) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), f = 1; f < r; f++)
          u[f - 1] = arguments[f];
        I("error", t, u);
      }
    }
    function I(t, r, u) {
      {
        var f = i.ReactDebugCurrentFrame, C = f.getStackAddendum();
        C !== "" && (r += "%s", u = u.concat([C]));
        var p = u.map(function(b) {
          return String(b);
        });
        p.unshift("Warning: " + r), Function.prototype.apply.call(console[t], console, p);
      }
    }
    var h = 0, m = 1, w = 2, S = 3, T = 4, D = 5, k = 6, z = 7, N = 8, W = 9, K = 10, V = 11, Y = 12, H = 13, Z = 14, Q = 15, P1 = 16, Y1 = 17, O1 = 18, T1 = 19, J1 = 21, s1 = 22, d1 = 23, h1 = 24, C1 = 25, L1 = !0, f1 = !1, B1 = !1, t1 = !1, y1 = !1, k1 = !0, se = !1, K1 = !0, le = !0, G1 = !0, $1 = !0, V1 = /* @__PURE__ */ new Set(), z1 = {}, ae = {};
    function We(t, r) {
      D1(t, r), D1(t + "Capture", r);
    }
    function D1(t, r) {
      z1[t] && c("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", t), z1[t] = r;
      {
        var u = t.toLowerCase();
        ae[u] = t, t === "onDoubleClick" && (ae.ondblclick = t);
      }
      for (var f = 0; f < r.length; f++)
        V1.add(r[f]);
    }
    var ue = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b1 = Object.prototype.hasOwnProperty;
    function Pe(t) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, u = r && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function $e(t) {
      try {
        return W1(t), !1;
      } catch {
        return !0;
      }
    }
    function W1(t) {
      return "" + t;
    }
    function ke(t, r) {
      if ($e(t))
        return c("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Pe(t)), W1(t);
    }
    function Xe(t) {
      if ($e(t))
        return c("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pe(t)), W1(t);
    }
    function St(t, r) {
      if ($e(t))
        return c("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Pe(t)), W1(t);
    }
    function tt(t, r) {
      if ($e(t))
        return c("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Pe(t)), W1(t);
    }
    function we(t) {
      if ($e(t))
        return c("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Pe(t)), W1(t);
    }
    function An(t) {
      if ($e(t))
        return c("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Pe(t)), W1(t);
    }
    var nt = 0, In = 1, v2 = 2, tn = 3, s2 = 4, Fe = 5, Pn = 6, Q1 = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", he = Q1 + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ye = new RegExp("^[" + Q1 + "][" + he + "]*$"), Et = {}, Ut = {};
    function cn(t) {
      return b1.call(Ut, t) ? !0 : b1.call(Et, t) ? !1 : Ye.test(t) ? (Ut[t] = !0, !0) : (Et[t] = !0, c("Invalid attribute name: `%s`", t), !1);
    }
    function nn(t, r, u) {
      return r !== null ? r.type === nt : u ? !1 : t.length > 2 && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N");
    }
    function Fn(t, r, u, f) {
      if (u !== null && u.type === nt)
        return !1;
      switch (typeof r) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (f)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var C = t.toLowerCase().slice(0, 5);
          return C !== "data-" && C !== "aria-";
        }
        default:
          return !1;
      }
    }
    function zt(t, r, u, f) {
      if (r === null || typeof r > "u" || Fn(t, r, u, f))
        return !0;
      if (f)
        return !1;
      if (u !== null)
        switch (u.type) {
          case tn:
            return !r;
          case s2:
            return r === !1;
          case Fe:
            return isNaN(r);
          case Pn:
            return isNaN(r) || r < 1;
        }
      return !1;
    }
    function y2(t) {
      return Wt.hasOwnProperty(t) ? Wt[t] : null;
    }
    function Nt(t, r, u, f, C, p, b) {
      this.acceptsBooleans = r === v2 || r === tn || r === s2, this.attributeName = f, this.attributeNamespace = C, this.mustUseProperty = u, this.propertyName = t, this.type = r, this.sanitizeURL = p, this.removeEmptyString = b;
    }
    var Wt = {}, j3 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    j3.forEach(function(t) {
      Wt[t] = new Nt(
        t,
        nt,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(t) {
      var r = t[0], u = t[1];
      Wt[r] = new Nt(
        r,
        In,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        v2,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        v2,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        tn,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        tn,
        !0,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        s2,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        Pn,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        Fe,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var l0 = /[\-\:]([a-z])/g, W0 = function(t) {
      return t[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(l0, W0);
      Wt[r] = new Nt(
        r,
        In,
        !1,
        // mustUseProperty
        t,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(l0, W0);
      Wt[r] = new Nt(
        r,
        In,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(l0, W0);
      Wt[r] = new Nt(
        r,
        In,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        In,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Pi = "xlinkHref";
    Wt[Pi] = new Nt(
      "xlinkHref",
      In,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(t) {
      Wt[t] = new Nt(
        t,
        In,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var z3 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, N3 = !1;
    function Yn(t) {
      !N3 && z3.test(t) && (N3 = !0, c("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(t)));
    }
    function u0(t, r, u, f) {
      if (f.mustUseProperty) {
        var C = f.propertyName;
        return t[C];
      } else {
        ke(u, r), f.sanitizeURL && Yn("" + u);
        var p = f.attributeName, b = null;
        if (f.type === s2) {
          if (t.hasAttribute(p)) {
            var M = t.getAttribute(p);
            return M === "" ? !0 : zt(r, u, f, !1) ? M : M === "" + u ? u : M;
          }
        } else if (t.hasAttribute(p)) {
          if (zt(r, u, f, !1))
            return t.getAttribute(p);
          if (f.type === tn)
            return u;
          b = t.getAttribute(p);
        }
        return zt(r, u, f, !1) ? b === null ? u : b : b === "" + u ? u : b;
      }
    }
    function V0(t, r, u, f) {
      {
        if (!cn(r))
          return;
        if (!t.hasAttribute(r))
          return u === void 0 ? void 0 : null;
        var C = t.getAttribute(r);
        return ke(u, r), C === "" + u ? u : C;
      }
    }
    function rn(t, r, u, f) {
      var C = y2(r);
      if (!nn(r, C, f)) {
        if (zt(r, u, C, f) && (u = null), f || C === null) {
          if (cn(r)) {
            var p = r;
            u === null ? t.removeAttribute(p) : (ke(u, r), t.setAttribute(p, "" + u));
          }
          return;
        }
        var b = C.mustUseProperty;
        if (b) {
          var M = C.propertyName;
          if (u === null) {
            var O = C.type;
            t[M] = O === tn ? !1 : "";
          } else
            t[M] = u;
          return;
        }
        var P = C.attributeName, F = C.attributeNamespace;
        if (u === null)
          t.removeAttribute(P);
        else {
          var e1 = C.type, q;
          e1 === tn || e1 === s2 && u === !0 ? q = "" : (ke(u, P), q = "" + u, C.sanitizeURL && Yn(q.toString())), F ? t.setAttributeNS(F, P, q) : t.setAttribute(P, q);
        }
      }
    }
    var Qr = Symbol.for("react.element"), j2 = Symbol.for("react.portal"), z2 = Symbol.for("react.fragment"), Xr = Symbol.for("react.strict_mode"), c0 = Symbol.for("react.profiler"), J = Symbol.for("react.provider"), S1 = Symbol.for("react.context"), X1 = Symbol.for("react.forward_ref"), Ae = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), ut = Symbol.for("react.memo"), je = Symbol.for("react.lazy"), et = Symbol.for("react.scope"), Bn = Symbol.for("react.debug_trace_mode"), Pt = Symbol.for("react.offscreen"), Zt = Symbol.for("react.legacy_hidden"), N2 = Symbol.for("react.cache"), P3 = Symbol.for("react.tracing_marker"), vt = Symbol.iterator, Qn = "@@iterator";
    function _2(t) {
      if (t === null || typeof t != "object")
        return null;
      var r = vt && t[vt] || t[Qn];
      return typeof r == "function" ? r : null;
    }
    var rt = Object.assign, Gr = 0, ml, ts, Fi, J2, vl, lr, yl;
    function _0() {
    }
    _0.__reactDisabledLog = !0;
    function bl() {
      {
        if (Gr === 0) {
          ml = console.log, ts = console.info, Fi = console.warn, J2 = console.error, vl = console.group, lr = console.groupCollapsed, yl = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: _0,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Gr++;
      }
    }
    function J0() {
      {
        if (Gr--, Gr === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: rt({}, t, {
              value: ml
            }),
            info: rt({}, t, {
              value: ts
            }),
            warn: rt({}, t, {
              value: Fi
            }),
            error: rt({}, t, {
              value: J2
            }),
            group: rt({}, t, {
              value: vl
            }),
            groupCollapsed: rt({}, t, {
              value: lr
            }),
            groupEnd: rt({}, t, {
              value: yl
            })
          });
        }
        Gr < 0 && c("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var g0 = i.ReactCurrentDispatcher, f0;
    function K2(t, r, u) {
      {
        if (f0 === void 0)
          try {
            throw Error();
          } catch (C) {
            var f = C.stack.trim().match(/\n( *(at )?)/);
            f0 = f && f[1] || "";
          }
        return `
` + f0 + t;
      }
    }
    var za = !1, K0;
    {
      var ns = typeof WeakMap == "function" ? WeakMap : Map;
      K0 = new ns();
    }
    function Na(t, r) {
      if (!t || za)
        return "";
      {
        var u = K0.get(t);
        if (u !== void 0)
          return u;
      }
      var f;
      za = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var p;
      p = g0.current, g0.current = null, bl();
      try {
        if (r) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (g1) {
              f = g1;
            }
            Reflect.construct(t, [], b);
          } else {
            try {
              b.call();
            } catch (g1) {
              f = g1;
            }
            t.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (g1) {
            f = g1;
          }
          t();
        }
      } catch (g1) {
        if (g1 && f && typeof g1.stack == "string") {
          for (var M = g1.stack.split(`
`), O = f.stack.split(`
`), P = M.length - 1, F = O.length - 1; P >= 1 && F >= 0 && M[P] !== O[F]; )
            F--;
          for (; P >= 1 && F >= 0; P--, F--)
            if (M[P] !== O[F]) {
              if (P !== 1 || F !== 1)
                do
                  if (P--, F--, F < 0 || M[P] !== O[F]) {
                    var e1 = `
` + M[P].replace(" at new ", " at ");
                    return t.displayName && e1.includes("<anonymous>") && (e1 = e1.replace("<anonymous>", t.displayName)), typeof t == "function" && K0.set(t, e1), e1;
                  }
                while (P >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        za = !1, g0.current = p, J0(), Error.prepareStackTrace = C;
      }
      var q = t ? t.displayName || t.name : "", l1 = q ? K2(q) : "";
      return typeof t == "function" && K0.set(t, l1), l1;
    }
    function Pa(t, r, u) {
      return Na(t, !0);
    }
    function F3(t, r, u) {
      return Na(t, !1);
    }
    function Fa(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function Bi(t, r, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Na(t, Fa(t));
      if (typeof t == "string")
        return K2(t);
      switch (t) {
        case Ae:
          return K2("Suspense");
        case ot:
          return K2("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case X1:
            return F3(t.render);
          case ut:
            return Bi(t.type, r, u);
          case je: {
            var f = t, C = f._payload, p = f._init;
            try {
              return Bi(p(C), r, u);
            } catch {
            }
          }
        }
      return "";
    }
    function Be(t) {
      switch (t._debugOwner && t._debugOwner.type, t._debugSource, t.tag) {
        case D:
          return K2(t.type);
        case P1:
          return K2("Lazy");
        case H:
          return K2("Suspense");
        case T1:
          return K2("SuspenseList");
        case h:
        case w:
        case Q:
          return F3(t.type);
        case V:
          return F3(t.type.render);
        case m:
          return Pa(t.type);
        default:
          return "";
      }
    }
    function Hi(t) {
      try {
        var r = "", u = t;
        do
          r += Be(u), u = u.return;
        while (u);
        return r;
      } catch (f) {
        return `
Error generating stack: ` + f.message + `
` + f.stack;
      }
    }
    function rs(t, r, u) {
      var f = t.displayName;
      if (f)
        return f;
      var C = r.displayName || r.name || "";
      return C !== "" ? u + "(" + C + ")" : u;
    }
    function ur(t) {
      return t.displayName || "Context";
    }
    function yt(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && c("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case z2:
          return "Fragment";
        case j2:
          return "Portal";
        case c0:
          return "Profiler";
        case Xr:
          return "StrictMode";
        case Ae:
          return "Suspense";
        case ot:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case S1:
            var r = t;
            return ur(r) + ".Consumer";
          case J:
            var u = t;
            return ur(u._context) + ".Provider";
          case X1:
            return rs(t, t.render, "ForwardRef");
          case ut:
            var f = t.displayName || null;
            return f !== null ? f : yt(t.type) || "Memo";
          case je: {
            var C = t, p = C._payload, b = C._init;
            try {
              return yt(b(p));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function cr(t, r, u) {
      var f = r.displayName || r.name || "";
      return t.displayName || (f !== "" ? u + "(" + f + ")" : u);
    }
    function Y2(t) {
      return t.displayName || "Context";
    }
    function Oe(t) {
      var r = t.tag, u = t.type;
      switch (r) {
        case h1:
          return "Cache";
        case W:
          var f = u;
          return Y2(f) + ".Consumer";
        case K:
          var C = u;
          return Y2(C._context) + ".Provider";
        case O1:
          return "DehydratedFragment";
        case V:
          return cr(u, u.render, "ForwardRef");
        case z:
          return "Fragment";
        case D:
          return u;
        case T:
          return "Portal";
        case S:
          return "Root";
        case k:
          return "Text";
        case P1:
          return yt(u);
        case N:
          return u === Xr ? "StrictMode" : "Mode";
        case s1:
          return "Offscreen";
        case Y:
          return "Profiler";
        case J1:
          return "Scope";
        case H:
          return "Suspense";
        case T1:
          return "SuspenseList";
        case C1:
          return "TracingMarker";
        case m:
        case h:
        case Y1:
        case w:
        case Z:
        case Q:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var Y0 = i.ReactDebugCurrentFrame, wn = null, gr = !1;
    function fr() {
      {
        if (wn === null)
          return null;
        var t = wn._debugOwner;
        if (t !== null && typeof t < "u")
          return Oe(t);
      }
      return null;
    }
    function Ui() {
      return wn === null ? "" : Hi(wn);
    }
    function On() {
      Y0.getCurrentStack = null, wn = null, gr = !1;
    }
    function Dt(t) {
      Y0.getCurrentStack = t === null ? null : Ui, wn = t, gr = !1;
    }
    function Vc() {
      return wn;
    }
    function zr(t) {
      gr = t;
    }
    function l2(t) {
      return "" + t;
    }
    function B3(t) {
      switch (typeof t) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return t;
        case "object":
          return An(t), t;
        default:
          return "";
      }
    }
    var Wi = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function d0(t, r) {
      Wi[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || c("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), r.onChange || r.readOnly || r.disabled || r.checked == null || c("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function L(t) {
      var r = t.type, u = t.nodeName;
      return u && u.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
    }
    function R(t) {
      return t._valueTracker;
    }
    function B(t) {
      t._valueTracker = null;
    }
    function U(t) {
      var r = "";
      return t && (L(t) ? r = t.checked ? "true" : "false" : r = t.value), r;
    }
    function G(t) {
      var r = L(t) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(t.constructor.prototype, r);
      An(t[r]);
      var f = "" + t[r];
      if (!(t.hasOwnProperty(r) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var C = u.get, p = u.set;
        Object.defineProperty(t, r, {
          configurable: !0,
          get: function() {
            return C.call(this);
          },
          set: function(M) {
            An(M), f = "" + M, p.call(this, M);
          }
        }), Object.defineProperty(t, r, {
          enumerable: u.enumerable
        });
        var b = {
          getValue: function() {
            return f;
          },
          setValue: function(M) {
            An(M), f = "" + M;
          },
          stopTracking: function() {
            B(t), delete t[r];
          }
        };
        return b;
      }
    }
    function u1(t) {
      R(t) || (t._valueTracker = G(t));
    }
    function M1(t) {
      if (!t)
        return !1;
      var r = R(t);
      if (!r)
        return !0;
      var u = r.getValue(), f = U(t);
      return f !== u ? (r.setValue(f), !0) : !1;
    }
    function p1(t) {
      if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u")
        return null;
      try {
        return t.activeElement || t.body;
      } catch {
        return t.body;
      }
    }
    var te = !1, re = !1, xe = !1, st = !1;
    function gt(t) {
      var r = t.type === "checkbox" || t.type === "radio";
      return r ? t.checked != null : t.value != null;
    }
    function Xn(t, r) {
      var u = t, f = r.checked, C = rt({}, r, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: f ?? u._wrapperState.initialChecked
      });
      return C;
    }
    function $t(t, r) {
      d0("input", r), r.checked !== void 0 && r.defaultChecked !== void 0 && !re && (c("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", fr() || "A component", r.type), re = !0), r.value !== void 0 && r.defaultValue !== void 0 && !te && (c("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", fr() || "A component", r.type), te = !0);
      var u = t, f = r.defaultValue == null ? "" : r.defaultValue;
      u._wrapperState = {
        initialChecked: r.checked != null ? r.checked : r.defaultChecked,
        initialValue: B3(r.value != null ? r.value : f),
        controlled: gt(r)
      };
    }
    function gn(t, r) {
      var u = t, f = r.checked;
      f != null && rn(u, "checked", f, !1);
    }
    function u2(t, r) {
      var u = t;
      {
        var f = gt(r);
        !u._wrapperState.controlled && f && !st && (c("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), st = !0), u._wrapperState.controlled && !f && !xe && (c("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), xe = !0);
      }
      gn(t, r);
      var C = B3(r.value), p = r.type;
      if (C != null)
        p === "number" ? (C === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != C) && (u.value = l2(C)) : u.value !== l2(C) && (u.value = l2(C));
      else if (p === "submit" || p === "reset") {
        u.removeAttribute("value");
        return;
      }
      r.hasOwnProperty("value") ? qr(u, r.type, C) : r.hasOwnProperty("defaultValue") && qr(u, r.type, B3(r.defaultValue)), r.checked == null && r.defaultChecked != null && (u.defaultChecked = !!r.defaultChecked);
    }
    function y3(t, r, u) {
      var f = t;
      if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
        var C = r.type, p = C === "submit" || C === "reset";
        if (p && (r.value === void 0 || r.value === null))
          return;
        var b = l2(f._wrapperState.initialValue);
        u || b !== f.value && (f.value = b), f.defaultValue = b;
      }
      var M = f.name;
      M !== "" && (f.name = ""), f.defaultChecked = !f.defaultChecked, f.defaultChecked = !!f._wrapperState.initialChecked, M !== "" && (f.name = M);
    }
    function P2(t, r) {
      var u = t;
      u2(u, r), Gn(u, r);
    }
    function Gn(t, r) {
      var u = r.name;
      if (r.type === "radio" && u != null) {
        for (var f = t; f.parentNode; )
          f = f.parentNode;
        ke(u, "name");
        for (var C = f.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), p = 0; p < C.length; p++) {
          var b = C[p];
          if (!(b === t || b.form !== t.form)) {
            var M = b9(b);
            if (!M)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            M1(b), u2(b, M);
          }
        }
      }
    }
    function qr(t, r, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (r !== "number" || p1(t.ownerDocument) !== t) && (u == null ? t.defaultValue = l2(t._wrapperState.initialValue) : t.defaultValue !== l2(u) && (t.defaultValue = l2(u)));
    }
    var Vi = !1, Ba = !1, Vf = !1;
    function wl(t, r) {
      r.value == null && (typeof r.children == "object" && r.children !== null ? e.Children.forEach(r.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || Ba || (Ba = !0, c("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : r.dangerouslySetInnerHTML != null && (Vf || (Vf = !0, c("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), r.selected != null && !Vi && (c("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Vi = !0);
    }
    function _c(t, r) {
      r.value != null && t.setAttribute("value", l2(B3(r.value)));
    }
    var is = Array.isArray;
    function c2(t) {
      return is(t);
    }
    var xl;
    xl = !1;
    function _f() {
      var t = fr();
      return t ? `

Check the render method of \`` + t + "`." : "";
    }
    var Jf = ["value", "defaultValue"];
    function I6(t) {
      {
        d0("select", t);
        for (var r = 0; r < Jf.length; r++) {
          var u = Jf[r];
          if (t[u] != null) {
            var f = c2(t[u]);
            t.multiple && !f ? c("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, _f()) : !t.multiple && f && c("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, _f());
          }
        }
      }
    }
    function Q0(t, r, u, f) {
      var C = t.options;
      if (r) {
        for (var p = u, b = {}, M = 0; M < p.length; M++)
          b["$" + p[M]] = !0;
        for (var O = 0; O < C.length; O++) {
          var P = b.hasOwnProperty("$" + C[O].value);
          C[O].selected !== P && (C[O].selected = P), P && f && (C[O].defaultSelected = !0);
        }
      } else {
        for (var F = l2(B3(u)), e1 = null, q = 0; q < C.length; q++) {
          if (C[q].value === F) {
            C[q].selected = !0, f && (C[q].defaultSelected = !0);
            return;
          }
          e1 === null && !C[q].disabled && (e1 = C[q]);
        }
        e1 !== null && (e1.selected = !0);
      }
    }
    function Jc(t, r) {
      return rt({}, r, {
        value: void 0
      });
    }
    function Kf(t, r) {
      var u = t;
      I6(r), u._wrapperState = {
        wasMultiple: !!r.multiple
      }, r.value !== void 0 && r.defaultValue !== void 0 && !xl && (c("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), xl = !0);
    }
    function p6(t, r) {
      var u = t;
      u.multiple = !!r.multiple;
      var f = r.value;
      f != null ? Q0(u, !!r.multiple, f, !1) : r.defaultValue != null && Q0(u, !!r.multiple, r.defaultValue, !0);
    }
    function h6(t, r) {
      var u = t, f = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!r.multiple;
      var C = r.value;
      C != null ? Q0(u, !!r.multiple, C, !1) : f !== !!r.multiple && (r.defaultValue != null ? Q0(u, !!r.multiple, r.defaultValue, !0) : Q0(u, !!r.multiple, r.multiple ? [] : "", !1));
    }
    function m6(t, r) {
      var u = t, f = r.value;
      f != null && Q0(u, !!r.multiple, f, !1);
    }
    var Kc = !1;
    function Yc(t, r) {
      var u = t;
      if (r.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var f = rt({}, r, {
        value: void 0,
        defaultValue: void 0,
        children: l2(u._wrapperState.initialValue)
      });
      return f;
    }
    function Yf(t, r) {
      var u = t;
      d0("textarea", r), r.value !== void 0 && r.defaultValue !== void 0 && !Kc && (c("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", fr() || "A component"), Kc = !0);
      var f = r.value;
      if (f == null) {
        var C = r.children, p = r.defaultValue;
        if (C != null) {
          c("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (p != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (c2(C)) {
              if (C.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              C = C[0];
            }
            p = C;
          }
        }
        p == null && (p = ""), f = p;
      }
      u._wrapperState = {
        initialValue: B3(f)
      };
    }
    function Qf(t, r) {
      var u = t, f = B3(r.value), C = B3(r.defaultValue);
      if (f != null) {
        var p = l2(f);
        p !== u.value && (u.value = p), r.defaultValue == null && u.defaultValue !== p && (u.defaultValue = p);
      }
      C != null && (u.defaultValue = l2(C));
    }
    function Xf(t, r) {
      var u = t, f = u.textContent;
      f === u._wrapperState.initialValue && f !== "" && f !== null && (u.value = f);
    }
    function Qc(t, r) {
      Qf(t, r);
    }
    var C0 = "http://www.w3.org/1999/xhtml", v6 = "http://www.w3.org/1998/Math/MathML", Xc = "http://www.w3.org/2000/svg";
    function Sl(t) {
      switch (t) {
        case "svg":
          return Xc;
        case "math":
          return v6;
        default:
          return C0;
      }
    }
    function Gc(t, r) {
      return t == null || t === C0 ? Sl(r) : t === Xc && r === "foreignObject" ? C0 : t;
    }
    var y6 = function(t) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, f, C) {
        MSApp.execUnsafeLocalFunction(function() {
          return t(r, u, f, C);
        });
      } : t;
    }, El, Gf = y6(function(t, r) {
      if (t.namespaceURI === Xc && !("innerHTML" in t)) {
        El = El || document.createElement("div"), El.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>";
        for (var u = El.firstChild; t.firstChild; )
          t.removeChild(t.firstChild);
        for (; u.firstChild; )
          t.appendChild(u.firstChild);
        return;
      }
      t.innerHTML = r;
    }), dr = 1, A0 = 3, Hn = 8, b3 = 9, _i = 11, Ml = function(t, r) {
      if (r) {
        var u = t.firstChild;
        if (u && u === t.lastChild && u.nodeType === A0) {
          u.nodeValue = r;
          return;
        }
      }
      t.textContent = r;
    }, qf = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Ha = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Zf(t, r) {
      return t + r.charAt(0).toUpperCase() + r.substring(1);
    }
    var $f = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ha).forEach(function(t) {
      $f.forEach(function(r) {
        Ha[Zf(r, t)] = Ha[t];
      });
    });
    function Tl(t, r, u) {
      var f = r == null || typeof r == "boolean" || r === "";
      return f ? "" : !u && typeof r == "number" && r !== 0 && !(Ha.hasOwnProperty(t) && Ha[t]) ? r + "px" : (tt(r, t), ("" + r).trim());
    }
    var Ua = /([A-Z])/g, b6 = /^ms-/;
    function w6(t) {
      return t.replace(Ua, "-$1").toLowerCase().replace(b6, "-ms-");
    }
    var ed = function() {
    };
    {
      var td = /^(?:webkit|moz|o)[A-Z]/, nd = /^-ms-/, as = /-(.)/g, Wa = /;\s*$/, Va = {}, _a = {}, rd = !1, qc = !1, Zc = function(t) {
        return t.replace(as, function(r, u) {
          return u.toUpperCase();
        });
      }, $c = function(t) {
        Va.hasOwnProperty(t) && Va[t] || (Va[t] = !0, c(
          "Unsupported style property %s. Did you mean %s?",
          t,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Zc(t.replace(nd, "ms-"))
        ));
      }, id = function(t) {
        Va.hasOwnProperty(t) && Va[t] || (Va[t] = !0, c("Unsupported vendor-prefixed style property %s. Did you mean %s?", t, t.charAt(0).toUpperCase() + t.slice(1)));
      }, ad = function(t, r) {
        _a.hasOwnProperty(r) && _a[r] || (_a[r] = !0, c(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, t, r.replace(Wa, "")));
      }, od = function(t, r) {
        rd || (rd = !0, c("`NaN` is an invalid value for the `%s` css style property.", t));
      }, x6 = function(t, r) {
        qc || (qc = !0, c("`Infinity` is an invalid value for the `%s` css style property.", t));
      };
      ed = function(t, r) {
        t.indexOf("-") > -1 ? $c(t) : td.test(t) ? id(t) : Wa.test(r) && ad(t, r), typeof r == "number" && (isNaN(r) ? od(t, r) : isFinite(r) || x6(t, r));
      };
    }
    var S6 = ed;
    function E6(t) {
      {
        var r = "", u = "";
        for (var f in t)
          if (t.hasOwnProperty(f)) {
            var C = t[f];
            if (C != null) {
              var p = f.indexOf("--") === 0;
              r += u + (p ? f : w6(f)) + ":", r += Tl(f, C, p), u = ";";
            }
          }
        return r || null;
      }
    }
    function sd(t, r) {
      var u = t.style;
      for (var f in r)
        if (r.hasOwnProperty(f)) {
          var C = f.indexOf("--") === 0;
          C || S6(f, r[f]);
          var p = Tl(f, r[f], C);
          f === "float" && (f = "cssFloat"), C ? u.setProperty(f, p) : u[f] = p;
        }
    }
    function M6(t) {
      return t == null || typeof t == "boolean" || t === "";
    }
    function Zr(t) {
      var r = {};
      for (var u in t)
        for (var f = qf[u] || [u], C = 0; C < f.length; C++)
          r[f[C]] = u;
      return r;
    }
    function os(t, r) {
      {
        if (!r)
          return;
        var u = Zr(t), f = Zr(r), C = {};
        for (var p in u) {
          var b = u[p], M = f[p];
          if (M && b !== M) {
            var O = b + "," + M;
            if (C[O])
              continue;
            C[O] = !0, c("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", M6(t[b]) ? "Removing" : "Updating", b, M);
          }
        }
      }
    }
    var ld = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, ud = rt({
      menuitem: !0
    }, ld), cd = "__html";
    function Ll(t, r) {
      if (r) {
        if (ud[t] && (r.children != null || r.dangerouslySetInnerHTML != null))
          throw new Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (r.dangerouslySetInnerHTML != null) {
          if (r.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof r.dangerouslySetInnerHTML != "object" || !(cd in r.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!r.suppressContentEditableWarning && r.contentEditable && r.children != null && c("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), r.style != null && typeof r.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function I0(t, r) {
      if (t.indexOf("-") === -1)
        return typeof r.is == "string";
      switch (t) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Rl = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, gd = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, w3 = {}, e4 = new RegExp("^(aria)-[" + he + "]*$"), ss = new RegExp("^(aria)[A-Z][" + he + "]*$");
    function t4(t, r) {
      {
        if (b1.call(w3, r) && w3[r])
          return !0;
        if (ss.test(r)) {
          var u = "aria-" + r.slice(4).toLowerCase(), f = gd.hasOwnProperty(u) ? u : null;
          if (f == null)
            return c("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", r), w3[r] = !0, !0;
          if (r !== f)
            return c("Invalid ARIA attribute `%s`. Did you mean `%s`?", r, f), w3[r] = !0, !0;
        }
        if (e4.test(r)) {
          var C = r.toLowerCase(), p = gd.hasOwnProperty(C) ? C : null;
          if (p == null)
            return w3[r] = !0, !1;
          if (r !== p)
            return c("Unknown ARIA attribute `%s`. Did you mean `%s`?", r, p), w3[r] = !0, !0;
        }
      }
      return !0;
    }
    function fd(t, r) {
      {
        var u = [];
        for (var f in r) {
          var C = t4(t, f);
          C || u.push(f);
        }
        var p = u.map(function(b) {
          return "`" + b + "`";
        }).join(", ");
        u.length === 1 ? c("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, t) : u.length > 1 && c("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, t);
      }
    }
    function Ol(t, r) {
      I0(t, r) || fd(t, r);
    }
    var Ji = !1;
    function n4(t, r) {
      {
        if (t !== "input" && t !== "textarea" && t !== "select")
          return;
        r != null && r.value === null && !Ji && (Ji = !0, t === "select" && r.multiple ? c("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", t) : c("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", t));
      }
    }
    var r4 = function() {
    };
    {
      var g2 = {}, i4 = /^on./, dd = /^on[^A-Z]/, Cd = new RegExp("^(aria)-[" + he + "]*$"), Ad = new RegExp("^(aria)[A-Z][" + he + "]*$");
      r4 = function(t, r, u, f) {
        if (b1.call(g2, r) && g2[r])
          return !0;
        var C = r.toLowerCase();
        if (C === "onfocusin" || C === "onfocusout")
          return c("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), g2[r] = !0, !0;
        if (f != null) {
          var p = f.registrationNameDependencies, b = f.possibleRegistrationNames;
          if (p.hasOwnProperty(r))
            return !0;
          var M = b.hasOwnProperty(C) ? b[C] : null;
          if (M != null)
            return c("Invalid event handler property `%s`. Did you mean `%s`?", r, M), g2[r] = !0, !0;
          if (i4.test(r))
            return c("Unknown event handler property `%s`. It will be ignored.", r), g2[r] = !0, !0;
        } else if (i4.test(r))
          return dd.test(r) && c("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", r), g2[r] = !0, !0;
        if (Cd.test(r) || Ad.test(r))
          return !0;
        if (C === "innerhtml")
          return c("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), g2[r] = !0, !0;
        if (C === "aria")
          return c("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), g2[r] = !0, !0;
        if (C === "is" && u !== null && u !== void 0 && typeof u != "string")
          return c("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), g2[r] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return c("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", r), g2[r] = !0, !0;
        var O = y2(r), P = O !== null && O.type === nt;
        if (Rl.hasOwnProperty(C)) {
          var F = Rl[C];
          if (F !== r)
            return c("Invalid DOM property `%s`. Did you mean `%s`?", r, F), g2[r] = !0, !0;
        } else if (!P && r !== C)
          return c("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", r, C), g2[r] = !0, !0;
        return typeof u == "boolean" && Fn(r, u, O, !1) ? (u ? c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, r, r, u, r) : c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, r, r, u, r, r, r), g2[r] = !0, !0) : P ? !0 : Fn(r, u, O, !1) ? (g2[r] = !0, !1) : ((u === "false" || u === "true") && O !== null && O.type === tn && (c("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, r, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', r, u), g2[r] = !0), !0);
      };
    }
    var Id = function(t, r, u) {
      {
        var f = [];
        for (var C in r) {
          var p = r4(t, C, r[C], u);
          p || f.push(C);
        }
        var b = f.map(function(M) {
          return "`" + M + "`";
        }).join(", ");
        f.length === 1 ? c("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", b, t) : f.length > 1 && c("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", b, t);
      }
    };
    function pd(t, r, u) {
      I0(t, r) || Id(t, r, u);
    }
    var p0 = 1, ls = 2, Ki = 4, T6 = p0 | ls | Ki, us = null;
    function cs(t) {
      us !== null && c("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), us = t;
    }
    function L6() {
      us === null && c("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), us = null;
    }
    function hd(t) {
      return t === us;
    }
    function Dl(t) {
      var r = t.target || t.srcElement || window;
      return r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === A0 ? r.parentNode : r;
    }
    var en = null, X0 = null, h0 = null;
    function Ja(t) {
      var r = So(t);
      if (r) {
        if (typeof en != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = r.stateNode;
        if (u) {
          var f = b9(u);
          en(r.stateNode, r.type, f);
        }
      }
    }
    function md(t) {
      en = t;
    }
    function kl(t) {
      X0 ? h0 ? h0.push(t) : h0 = [t] : X0 = t;
    }
    function gs() {
      return X0 !== null || h0 !== null;
    }
    function fs() {
      if (X0) {
        var t = X0, r = h0;
        if (X0 = null, h0 = null, Ja(t), r)
          for (var u = 0; u < r.length; u++)
            Ja(r[u]);
      }
    }
    var Yi = function(t, r) {
      return t(r);
    }, a4 = function() {
    }, o4 = !1;
    function R6() {
      var t = gs();
      t && (a4(), fs());
    }
    function s4(t, r, u) {
      if (o4)
        return t(r, u);
      o4 = !0;
      try {
        return Yi(t, r, u);
      } finally {
        o4 = !1, R6();
      }
    }
    function jl(t, r, u) {
      Yi = t, a4 = u;
    }
    function zl(t) {
      return t === "button" || t === "input" || t === "select" || t === "textarea";
    }
    function l4(t, r, u) {
      switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && zl(r));
        default:
          return !1;
      }
    }
    function Qi(t, r) {
      var u = t.stateNode;
      if (u === null)
        return null;
      var f = b9(u);
      if (f === null)
        return null;
      var C = f[r];
      if (l4(r, t.type, f))
        return null;
      if (C && typeof C != "function")
        throw new Error("Expected `" + r + "` listener to be a function, instead got a value of `" + typeof C + "` type.");
      return C;
    }
    var ds = !1;
    if (ue)
      try {
        var Xi = {};
        Object.defineProperty(Xi, "passive", {
          get: function() {
            ds = !0;
          }
        }), window.addEventListener("test", Xi, Xi), window.removeEventListener("test", Xi, Xi);
      } catch {
        ds = !1;
      }
    function vd(t, r, u, f, C, p, b, M, O) {
      var P = Array.prototype.slice.call(arguments, 3);
      try {
        r.apply(u, P);
      } catch (F) {
        this.onError(F);
      }
    }
    var u4 = vd;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var c4 = document.createElement("react");
      u4 = function(r, u, f, C, p, b, M, O, P) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var F = document.createEvent("Event"), e1 = !1, q = !0, l1 = window.event, g1 = Object.getOwnPropertyDescriptor(window, "event");
        function A1() {
          c4.removeEventListener(I1, Ne, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = l1);
        }
        var oe = Array.prototype.slice.call(arguments, 3);
        function Ne() {
          e1 = !0, A1(), u.apply(f, oe), q = !1;
        }
        var Le, At = !1, dt = !1;
        function i1(a1) {
          if (Le = a1.error, At = !0, Le === null && a1.colno === 0 && a1.lineno === 0 && (dt = !0), a1.defaultPrevented && Le != null && typeof Le == "object")
            try {
              Le._suppressLogging = !0;
            } catch {
            }
        }
        var I1 = "react-" + (r || "invokeguardedcallback");
        if (window.addEventListener("error", i1), c4.addEventListener(I1, Ne, !1), F.initEvent(I1, !1, !1), c4.dispatchEvent(F), g1 && Object.defineProperty(window, "event", g1), e1 && q && (At ? dt && (Le = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Le = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Le)), window.removeEventListener("error", i1), !e1)
          return A1(), vd.apply(this, arguments);
      };
    }
    var O6 = u4, G0 = !1, x3 = null, Cs = !1, q0 = null, H3 = {
      onError: function(t) {
        G0 = !0, x3 = t;
      }
    };
    function Gi(t, r, u, f, C, p, b, M, O) {
      G0 = !1, x3 = null, O6.apply(H3, arguments);
    }
    function m0(t, r, u, f, C, p, b, M, O) {
      if (Gi.apply(this, arguments), G0) {
        var P = f4();
        Cs || (Cs = !0, q0 = P);
      }
    }
    function g4() {
      if (Cs) {
        var t = q0;
        throw Cs = !1, q0 = null, t;
      }
    }
    function D6() {
      return G0;
    }
    function f4() {
      if (G0) {
        var t = x3;
        return G0 = !1, x3 = null, t;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function $r(t) {
      return t._reactInternals;
    }
    function As(t) {
      return t._reactInternals !== void 0;
    }
    function Ka(t, r) {
      t._reactInternals = r;
    }
    var ze = (
      /*                      */
      0
    ), Z0 = (
      /*                */
      1
    ), on = (
      /*                    */
      2
    ), Ze = (
      /*                       */
      4
    ), Mt = (
      /*                */
      16
    ), kt = (
      /*                 */
      32
    ), U3 = (
      /*                     */
      64
    ), _e = (
      /*                   */
      128
    ), xn = (
      /*            */
      256
    ), Cr = (
      /*                          */
      512
    ), e3 = (
      /*                     */
      1024
    ), fn = (
      /*                      */
      2048
    ), t3 = (
      /*                    */
      4096
    ), $0 = (
      /*                   */
      8192
    ), Is = (
      /*             */
      16384
    ), Nl = fn | Ze | U3 | Cr | e3 | Is, yd = (
      /*               */
      32767
    ), Nr = (
      /*                   */
      32768
    ), f2 = (
      /*                */
      65536
    ), ps = (
      /* */
      131072
    ), d4 = (
      /*                       */
      1048576
    ), C4 = (
      /*                    */
      2097152
    ), Ar = (
      /*                 */
      4194304
    ), ei = (
      /*                */
      8388608
    ), Ir = (
      /*               */
      16777216
    ), qi = (
      /*              */
      33554432
    ), Ya = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Ze | e3 | 0
    ), pr = on | Ze | Mt | kt | Cr | t3 | $0, F2 = Ze | U3 | Cr | $0, n3 = fn | Mt, b2 = Ar | ei | C4, v0 = i.ReactCurrentOwner;
    function Pr(t) {
      var r = t, u = t;
      if (t.alternate)
        for (; r.return; )
          r = r.return;
      else {
        var f = r;
        do
          r = f, (r.flags & (on | t3)) !== ze && (u = r.return), f = r.return;
        while (f);
      }
      return r.tag === S ? u : null;
    }
    function A4(t) {
      if (t.tag === H) {
        var r = t.memoizedState;
        if (r === null) {
          var u = t.alternate;
          u !== null && (r = u.memoizedState);
        }
        if (r !== null)
          return r.dehydrated;
      }
      return null;
    }
    function Pl(t) {
      return t.tag === S ? t.stateNode.containerInfo : null;
    }
    function I4(t) {
      return Pr(t) === t;
    }
    function Fr(t) {
      {
        var r = v0.current;
        if (r !== null && r.tag === m) {
          var u = r, f = u.stateNode;
          f._warnedAboutRefsInRender || c("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Oe(u) || "A component"), f._warnedAboutRefsInRender = !0;
        }
      }
      var C = $r(t);
      return C ? Pr(C) === C : !1;
    }
    function hr(t) {
      if (Pr(t) !== t)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function sn(t) {
      var r = t.alternate;
      if (!r) {
        var u = Pr(t);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== t ? null : t;
      }
      for (var f = t, C = r; ; ) {
        var p = f.return;
        if (p === null)
          break;
        var b = p.alternate;
        if (b === null) {
          var M = p.return;
          if (M !== null) {
            f = C = M;
            continue;
          }
          break;
        }
        if (p.child === b.child) {
          for (var O = p.child; O; ) {
            if (O === f)
              return hr(p), t;
            if (O === C)
              return hr(p), r;
            O = O.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (f.return !== C.return)
          f = p, C = b;
        else {
          for (var P = !1, F = p.child; F; ) {
            if (F === f) {
              P = !0, f = p, C = b;
              break;
            }
            if (F === C) {
              P = !0, C = p, f = b;
              break;
            }
            F = F.sibling;
          }
          if (!P) {
            for (F = b.child; F; ) {
              if (F === f) {
                P = !0, f = b, C = p;
                break;
              }
              if (F === C) {
                P = !0, C = b, f = p;
                break;
              }
              F = F.sibling;
            }
            if (!P)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (f.alternate !== C)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (f.tag !== S)
        throw new Error("Unable to find node on an unmounted component.");
      return f.stateNode.current === f ? t : r;
    }
    function r3(t) {
      var r = sn(t);
      return r !== null ? p4(r) : null;
    }
    function p4(t) {
      if (t.tag === D || t.tag === k)
        return t;
      for (var r = t.child; r !== null; ) {
        var u = p4(r);
        if (u !== null)
          return u;
        r = r.sibling;
      }
      return null;
    }
    function bd(t) {
      var r = sn(t);
      return r !== null ? Fl(r) : null;
    }
    function Fl(t) {
      if (t.tag === D || t.tag === k)
        return t;
      for (var r = t.child; r !== null; ) {
        if (r.tag !== T) {
          var u = Fl(r);
          if (u !== null)
            return u;
        }
        r = r.sibling;
      }
      return null;
    }
    var Bl = n.unstable_scheduleCallback, wd = n.unstable_cancelCallback, Hl = n.unstable_shouldYield, xd = n.unstable_requestPaint, pn = n.unstable_now, h4 = n.unstable_getCurrentPriorityLevel, Ul = n.unstable_ImmediatePriority, Zi = n.unstable_UserBlockingPriority, W3 = n.unstable_NormalPriority, Sd = n.unstable_LowPriority, Wl = n.unstable_IdlePriority, Qa = n.unstable_yieldValue, Ed = n.unstable_setDisableYieldValue, y0 = null, qn = null, q1 = null, i3 = !1, Br = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function m4(t) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (r.isDisabled)
        return !0;
      if (!r.supportsFiber)
        return c("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        le && (t = rt({}, t, {
          getLaneLabelMap: b0,
          injectProfilingHooks: Md
        })), y0 = r.inject(t), qn = r;
      } catch (u) {
        c("React instrumentation encountered an error: %s.", u);
      }
      return !!r.checkDCE;
    }
    function v4(t, r) {
      if (qn && typeof qn.onScheduleFiberRoot == "function")
        try {
          qn.onScheduleFiberRoot(y0, t, r);
        } catch (u) {
          i3 || (i3 = !0, c("React instrumentation encountered an error: %s", u));
        }
    }
    function Xa(t, r) {
      if (qn && typeof qn.onCommitFiberRoot == "function")
        try {
          var u = (t.current.flags & _e) === _e;
          if (G1) {
            var f;
            switch (r) {
              case kn:
                f = Ul;
                break;
              case x0:
                f = Zi;
                break;
              case V3:
                f = W3;
                break;
              case so:
                f = Wl;
                break;
              default:
                f = W3;
                break;
            }
            qn.onCommitFiberRoot(y0, t, f, u);
          }
        } catch (C) {
          i3 || (i3 = !0, c("React instrumentation encountered an error: %s", C));
        }
    }
    function a3(t) {
      if (qn && typeof qn.onPostCommitFiberRoot == "function")
        try {
          qn.onPostCommitFiberRoot(y0, t);
        } catch (r) {
          i3 || (i3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function $i(t) {
      if (qn && typeof qn.onCommitFiberUnmount == "function")
        try {
          qn.onCommitFiberUnmount(y0, t);
        } catch (r) {
          i3 || (i3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function Un(t) {
      if (typeof Qa == "function" && (Ed(t), s(t)), qn && typeof qn.setStrictMode == "function")
        try {
          qn.setStrictMode(y0, t);
        } catch (r) {
          i3 || (i3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function Md(t) {
      q1 = t;
    }
    function b0() {
      {
        for (var t = /* @__PURE__ */ new Map(), r = 1, u = 0; u < bs; u++) {
          var f = j6(r);
          t.set(r, f), r *= 2;
        }
        return t;
      }
    }
    function ti(t) {
      q1 !== null && typeof q1.markCommitStarted == "function" && q1.markCommitStarted(t);
    }
    function Vl() {
      q1 !== null && typeof q1.markCommitStopped == "function" && q1.markCommitStopped();
    }
    function Ga(t) {
      q1 !== null && typeof q1.markComponentRenderStarted == "function" && q1.markComponentRenderStarted(t);
    }
    function mr() {
      q1 !== null && typeof q1.markComponentRenderStopped == "function" && q1.markComponentRenderStopped();
    }
    function ni(t) {
      q1 !== null && typeof q1.markComponentPassiveEffectMountStarted == "function" && q1.markComponentPassiveEffectMountStarted(t);
    }
    function _l() {
      q1 !== null && typeof q1.markComponentPassiveEffectMountStopped == "function" && q1.markComponentPassiveEffectMountStopped();
    }
    function Td(t) {
      q1 !== null && typeof q1.markComponentPassiveEffectUnmountStarted == "function" && q1.markComponentPassiveEffectUnmountStarted(t);
    }
    function Jl() {
      q1 !== null && typeof q1.markComponentPassiveEffectUnmountStopped == "function" && q1.markComponentPassiveEffectUnmountStopped();
    }
    function Ld(t) {
      q1 !== null && typeof q1.markComponentLayoutEffectMountStarted == "function" && q1.markComponentLayoutEffectMountStarted(t);
    }
    function hs() {
      q1 !== null && typeof q1.markComponentLayoutEffectMountStopped == "function" && q1.markComponentLayoutEffectMountStopped();
    }
    function S3(t) {
      q1 !== null && typeof q1.markComponentLayoutEffectUnmountStarted == "function" && q1.markComponentLayoutEffectUnmountStarted(t);
    }
    function qa() {
      q1 !== null && typeof q1.markComponentLayoutEffectUnmountStopped == "function" && q1.markComponentLayoutEffectUnmountStopped();
    }
    function ms(t, r, u) {
      q1 !== null && typeof q1.markComponentErrored == "function" && q1.markComponentErrored(t, r, u);
    }
    function ea(t, r, u) {
      q1 !== null && typeof q1.markComponentSuspended == "function" && q1.markComponentSuspended(t, r, u);
    }
    function y4(t) {
      q1 !== null && typeof q1.markLayoutEffectsStarted == "function" && q1.markLayoutEffectsStarted(t);
    }
    function Za() {
      q1 !== null && typeof q1.markLayoutEffectsStopped == "function" && q1.markLayoutEffectsStopped();
    }
    function Rd(t) {
      q1 !== null && typeof q1.markPassiveEffectsStarted == "function" && q1.markPassiveEffectsStarted(t);
    }
    function b4() {
      q1 !== null && typeof q1.markPassiveEffectsStopped == "function" && q1.markPassiveEffectsStopped();
    }
    function dn(t) {
      q1 !== null && typeof q1.markRenderStarted == "function" && q1.markRenderStarted(t);
    }
    function Kl() {
      q1 !== null && typeof q1.markRenderYielded == "function" && q1.markRenderYielded();
    }
    function Yl() {
      q1 !== null && typeof q1.markRenderStopped == "function" && q1.markRenderStopped();
    }
    function w4(t) {
      q1 !== null && typeof q1.markRenderScheduled == "function" && q1.markRenderScheduled(t);
    }
    function Ql(t, r) {
      q1 !== null && typeof q1.markForceUpdateScheduled == "function" && q1.markForceUpdateScheduled(t, r);
    }
    function vs(t, r) {
      q1 !== null && typeof q1.markStateUpdateScheduled == "function" && q1.markStateUpdateScheduled(t, r);
    }
    var Se = (
      /*                         */
      0
    ), Te = (
      /*                 */
      1
    ), Je = (
      /*                    */
      2
    ), lt = (
      /*               */
      8
    ), Hr = (
      /*              */
      16
    ), $a = Math.clz32 ? Math.clz32 : B2, ys = Math.log, k6 = Math.LN2;
    function B2(t) {
      var r = t >>> 0;
      return r === 0 ? 32 : 31 - (ys(r) / k6 | 0) | 0;
    }
    var bs = 31, w1 = (
      /*                        */
      0
    ), Wn = (
      /*                          */
      0
    ), Re = (
      /*                        */
      1
    ), w2 = (
      /*    */
      2
    ), Ur = (
      /*             */
      4
    ), w0 = (
      /*            */
      8
    ), o3 = (
      /*                     */
      16
    ), eo = (
      /*                */
      32
    ), ta = (
      /*                       */
      4194240
    ), to = (
      /*                        */
      64
    ), Xl = (
      /*                        */
      128
    ), Gl = (
      /*                        */
      256
    ), ql = (
      /*                        */
      512
    ), Zl = (
      /*                        */
      1024
    ), $l = (
      /*                        */
      2048
    ), na = (
      /*                        */
      4096
    ), eu = (
      /*                        */
      8192
    ), no = (
      /*                        */
      16384
    ), ro = (
      /*                       */
      32768
    ), tu = (
      /*                       */
      65536
    ), ws = (
      /*                       */
      131072
    ), nu = (
      /*                       */
      262144
    ), ru = (
      /*                       */
      524288
    ), iu = (
      /*                       */
      1048576
    ), au = (
      /*                       */
      2097152
    ), io = (
      /*                            */
      130023424
    ), ra = (
      /*                             */
      4194304
    ), ou = (
      /*                             */
      8388608
    ), su = (
      /*                             */
      16777216
    ), x4 = (
      /*                             */
      33554432
    ), lu = (
      /*                             */
      67108864
    ), Od = ra, xs = (
      /*          */
      134217728
    ), S4 = (
      /*                          */
      268435455
    ), ao = (
      /*               */
      268435456
    ), ri = (
      /*                        */
      536870912
    ), H2 = (
      /*                   */
      1073741824
    );
    function j6(t) {
      {
        if (t & Re)
          return "Sync";
        if (t & w2)
          return "InputContinuousHydration";
        if (t & Ur)
          return "InputContinuous";
        if (t & w0)
          return "DefaultHydration";
        if (t & o3)
          return "Default";
        if (t & eo)
          return "TransitionHydration";
        if (t & ta)
          return "Transition";
        if (t & io)
          return "Retry";
        if (t & xs)
          return "SelectiveHydration";
        if (t & ao)
          return "IdleHydration";
        if (t & ri)
          return "Idle";
        if (t & H2)
          return "Offscreen";
      }
    }
    var an = -1, uu = to, vr = ra;
    function ia(t) {
      switch (Dn(t)) {
        case Re:
          return Re;
        case w2:
          return w2;
        case Ur:
          return Ur;
        case w0:
          return w0;
        case o3:
          return o3;
        case eo:
          return eo;
        case to:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case na:
        case eu:
        case no:
        case ro:
        case tu:
        case ws:
        case nu:
        case ru:
        case iu:
        case au:
          return t & ta;
        case ra:
        case ou:
        case su:
        case x4:
        case lu:
          return t & io;
        case xs:
          return xs;
        case ao:
          return ao;
        case ri:
          return ri;
        case H2:
          return H2;
        default:
          return c("Should have found matching lanes. This is a bug in React."), t;
      }
    }
    function aa(t, r) {
      var u = t.pendingLanes;
      if (u === w1)
        return w1;
      var f = w1, C = t.suspendedLanes, p = t.pingedLanes, b = u & S4;
      if (b !== w1) {
        var M = b & ~C;
        if (M !== w1)
          f = ia(M);
        else {
          var O = b & p;
          O !== w1 && (f = ia(O));
        }
      } else {
        var P = u & ~C;
        P !== w1 ? f = ia(P) : p !== w1 && (f = ia(p));
      }
      if (f === w1)
        return w1;
      if (r !== w1 && r !== f && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (r & C) === w1) {
        var F = Dn(f), e1 = Dn(r);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          F >= e1 || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          F === o3 && (e1 & ta) !== w1
        )
          return r;
      }
      (f & Ur) !== w1 && (f |= u & o3);
      var q = t.entangledLanes;
      if (q !== w1)
        for (var l1 = t.entanglements, g1 = f & q; g1 > 0; ) {
          var A1 = ai(g1), oe = 1 << A1;
          f |= l1[A1], g1 &= ~oe;
        }
      return f;
    }
    function Dd(t, r) {
      for (var u = t.eventTimes, f = an; r > 0; ) {
        var C = ai(r), p = 1 << C, b = u[C];
        b > f && (f = b), r &= ~p;
      }
      return f;
    }
    function kd(t, r) {
      switch (t) {
        case Re:
        case w2:
        case Ur:
          return r + 250;
        case w0:
        case o3:
        case eo:
        case to:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case na:
        case eu:
        case no:
        case ro:
        case tu:
        case ws:
        case nu:
        case ru:
        case iu:
        case au:
          return r + 5e3;
        case ra:
        case ou:
        case su:
        case x4:
        case lu:
          return an;
        case xs:
        case ao:
        case ri:
        case H2:
          return an;
        default:
          return c("Should have found matching lanes. This is a bug in React."), an;
      }
    }
    function jd(t, r) {
      for (var u = t.pendingLanes, f = t.suspendedLanes, C = t.pingedLanes, p = t.expirationTimes, b = u; b > 0; ) {
        var M = ai(b), O = 1 << M, P = p[M];
        P === an ? ((O & f) === w1 || (O & C) !== w1) && (p[M] = kd(O, r)) : P <= r && (t.expiredLanes |= O), b &= ~O;
      }
    }
    function E4(t) {
      return ia(t.pendingLanes);
    }
    function ii(t) {
      var r = t.pendingLanes & ~H2;
      return r !== w1 ? r : r & H2 ? H2 : w1;
    }
    function M4(t) {
      return (t & Re) !== w1;
    }
    function Ss(t) {
      return (t & S4) !== w1;
    }
    function zd(t) {
      return (t & io) === t;
    }
    function Nd(t) {
      var r = Re | Ur | o3;
      return (t & r) === w1;
    }
    function Pd(t) {
      return (t & ta) === t;
    }
    function Es(t, r) {
      var u = w2 | Ur | w0 | o3;
      return (r & u) !== w1;
    }
    function Fd(t, r) {
      return (r & t.expiredLanes) !== w1;
    }
    function T4(t) {
      return (t & ta) !== w1;
    }
    function Bd() {
      var t = uu;
      return uu <<= 1, (uu & ta) === w1 && (uu = to), t;
    }
    function yr() {
      var t = vr;
      return vr <<= 1, (vr & io) === w1 && (vr = ra), t;
    }
    function Dn(t) {
      return t & -t;
    }
    function oo(t) {
      return Dn(t);
    }
    function ai(t) {
      return 31 - $a(t);
    }
    function cu(t) {
      return ai(t);
    }
    function br(t, r) {
      return (t & r) !== w1;
    }
    function oa(t, r) {
      return (t & r) === r;
    }
    function qe(t, r) {
      return t | r;
    }
    function Ms(t, r) {
      return t & ~r;
    }
    function gu(t, r) {
      return t & r;
    }
    function z6(t) {
      return t;
    }
    function Hd(t, r) {
      return t !== Wn && t < r ? t : r;
    }
    function Ts(t) {
      for (var r = [], u = 0; u < bs; u++)
        r.push(t);
      return r;
    }
    function sa(t, r, u) {
      t.pendingLanes |= r, r !== ri && (t.suspendedLanes = w1, t.pingedLanes = w1);
      var f = t.eventTimes, C = cu(r);
      f[C] = u;
    }
    function Ud(t, r) {
      t.suspendedLanes |= r, t.pingedLanes &= ~r;
      for (var u = t.expirationTimes, f = r; f > 0; ) {
        var C = ai(f), p = 1 << C;
        u[C] = an, f &= ~p;
      }
    }
    function fu(t, r, u) {
      t.pingedLanes |= t.suspendedLanes & r;
    }
    function du(t, r) {
      var u = t.pendingLanes & ~r;
      t.pendingLanes = r, t.suspendedLanes = w1, t.pingedLanes = w1, t.expiredLanes &= r, t.mutableReadLanes &= r, t.entangledLanes &= r;
      for (var f = t.entanglements, C = t.eventTimes, p = t.expirationTimes, b = u; b > 0; ) {
        var M = ai(b), O = 1 << M;
        f[M] = w1, C[M] = an, p[M] = an, b &= ~O;
      }
    }
    function L4(t, r) {
      for (var u = t.entangledLanes |= r, f = t.entanglements, C = u; C; ) {
        var p = ai(C), b = 1 << p;
        // Is this one of the newly entangled lanes?
        b & r | // Is this lane transitively entangled with the newly entangled lanes?
        f[p] & r && (f[p] |= r), C &= ~b;
      }
    }
    function Wd(t, r) {
      var u = Dn(r), f;
      switch (u) {
        case Ur:
          f = w2;
          break;
        case o3:
          f = w0;
          break;
        case to:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case na:
        case eu:
        case no:
        case ro:
        case tu:
        case ws:
        case nu:
        case ru:
        case iu:
        case au:
        case ra:
        case ou:
        case su:
        case x4:
        case lu:
          f = eo;
          break;
        case ri:
          f = ao;
          break;
        default:
          f = Wn;
          break;
      }
      return (f & (t.suspendedLanes | r)) !== Wn ? Wn : f;
    }
    function Cu(t, r, u) {
      if (Br)
        for (var f = t.pendingUpdatersLaneMap; u > 0; ) {
          var C = cu(u), p = 1 << C, b = f[C];
          b.add(r), u &= ~p;
        }
    }
    function R4(t, r) {
      if (Br)
        for (var u = t.pendingUpdatersLaneMap, f = t.memoizedUpdaters; r > 0; ) {
          var C = cu(r), p = 1 << C, b = u[C];
          b.size > 0 && (b.forEach(function(M) {
            var O = M.alternate;
            (O === null || !f.has(O)) && f.add(M);
          }), b.clear()), r &= ~p;
        }
    }
    function Ls(t, r) {
      return null;
    }
    var kn = Re, x0 = Ur, V3 = o3, so = ri, lo = Wn;
    function s3() {
      return lo;
    }
    function Sn(t) {
      lo = t;
    }
    function U2(t, r) {
      var u = lo;
      try {
        return lo = t, r();
      } finally {
        lo = u;
      }
    }
    function N6(t, r) {
      return t !== 0 && t < r ? t : r;
    }
    function P6(t, r) {
      return t > r ? t : r;
    }
    function uo(t, r) {
      return t !== 0 && t < r;
    }
    function x2(t) {
      var r = Dn(t);
      return uo(kn, r) ? uo(x0, r) ? Ss(r) ? V3 : so : x0 : kn;
    }
    function Au(t) {
      var r = t.current.memoizedState;
      return r.isDehydrated;
    }
    var Ie;
    function co(t) {
      Ie = t;
    }
    function O4(t) {
      Ie(t);
    }
    var Iu;
    function F6(t) {
      Iu = t;
    }
    var go;
    function pu(t) {
      go = t;
    }
    var hu;
    function Vd(t) {
      hu = t;
    }
    var D4;
    function _d(t) {
      D4 = t;
    }
    var Rs = !1, fo = [], Cn = null, d2 = null, Q2 = null, Co = /* @__PURE__ */ new Map(), Ao = /* @__PURE__ */ new Map(), C2 = [], Jd = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function _3(t) {
      return Jd.indexOf(t) > -1;
    }
    function B6(t, r, u, f, C) {
      return {
        blockedOn: t,
        domEventName: r,
        eventSystemFlags: u,
        nativeEvent: C,
        targetContainers: [f]
      };
    }
    function k4(t, r) {
      switch (t) {
        case "focusin":
        case "focusout":
          Cn = null;
          break;
        case "dragenter":
        case "dragleave":
          d2 = null;
          break;
        case "mouseover":
        case "mouseout":
          Q2 = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = r.pointerId;
          Co.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var f = r.pointerId;
          Ao.delete(f);
          break;
        }
      }
    }
    function Io(t, r, u, f, C, p) {
      if (t === null || t.nativeEvent !== p) {
        var b = B6(r, u, f, C, p);
        if (r !== null) {
          var M = So(r);
          M !== null && Iu(M);
        }
        return b;
      }
      t.eventSystemFlags |= f;
      var O = t.targetContainers;
      return C !== null && O.indexOf(C) === -1 && O.push(C), t;
    }
    function Kd(t, r, u, f, C) {
      switch (r) {
        case "focusin": {
          var p = C;
          return Cn = Io(Cn, t, r, u, f, p), !0;
        }
        case "dragenter": {
          var b = C;
          return d2 = Io(d2, t, r, u, f, b), !0;
        }
        case "mouseover": {
          var M = C;
          return Q2 = Io(Q2, t, r, u, f, M), !0;
        }
        case "pointerover": {
          var O = C, P = O.pointerId;
          return Co.set(P, Io(Co.get(P) || null, t, r, u, f, O)), !0;
        }
        case "gotpointercapture": {
          var F = C, e1 = F.pointerId;
          return Ao.set(e1, Io(Ao.get(e1) || null, t, r, u, f, F)), !0;
        }
      }
      return !1;
    }
    function j4(t) {
      var r = Ws(t.target);
      if (r !== null) {
        var u = Pr(r);
        if (u !== null) {
          var f = u.tag;
          if (f === H) {
            var C = A4(u);
            if (C !== null) {
              t.blockedOn = C, D4(t.priority, function() {
                go(u);
              });
              return;
            }
          } else if (f === S) {
            var p = u.stateNode;
            if (Au(p)) {
              t.blockedOn = Pl(u);
              return;
            }
          }
        }
      }
      t.blockedOn = null;
    }
    function H6(t) {
      for (var r = hu(), u = {
        blockedOn: null,
        target: t,
        priority: r
      }, f = 0; f < C2.length && uo(r, C2[f].priority); f++)
        ;
      C2.splice(f, 0, u), f === 0 && j4(u);
    }
    function la(t) {
      if (t.blockedOn !== null)
        return !1;
      for (var r = t.targetContainers; r.length > 0; ) {
        var u = r[0], f = W2(t.domEventName, t.eventSystemFlags, u, t.nativeEvent);
        if (f === null) {
          var C = t.nativeEvent, p = new C.constructor(C.type, C);
          cs(p), C.target.dispatchEvent(p), L6();
        } else {
          var b = So(f);
          return b !== null && Iu(b), t.blockedOn = f, !1;
        }
        r.shift();
      }
      return !0;
    }
    function mu(t, r, u) {
      la(t) && u.delete(r);
    }
    function l3() {
      Rs = !1, Cn !== null && la(Cn) && (Cn = null), d2 !== null && la(d2) && (d2 = null), Q2 !== null && la(Q2) && (Q2 = null), Co.forEach(mu), Ao.forEach(mu);
    }
    function ft(t, r) {
      t.blockedOn === r && (t.blockedOn = null, Rs || (Rs = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, l3)));
    }
    function En(t) {
      if (fo.length > 0) {
        ft(fo[0], t);
        for (var r = 1; r < fo.length; r++) {
          var u = fo[r];
          u.blockedOn === t && (u.blockedOn = null);
        }
      }
      Cn !== null && ft(Cn, t), d2 !== null && ft(d2, t), Q2 !== null && ft(Q2, t);
      var f = function(M) {
        return ft(M, t);
      };
      Co.forEach(f), Ao.forEach(f);
      for (var C = 0; C < C2.length; C++) {
        var p = C2[C];
        p.blockedOn === t && (p.blockedOn = null);
      }
      for (; C2.length > 0; ) {
        var b = C2[0];
        if (b.blockedOn !== null)
          break;
        j4(b), b.blockedOn === null && C2.shift();
      }
    }
    var ln = i.ReactCurrentBatchConfig, Zn = !0;
    function wr(t) {
      Zn = !!t;
    }
    function po() {
      return Zn;
    }
    function $n(t, r, u) {
      var f = vu(r), C;
      switch (f) {
        case kn:
          C = Os;
          break;
        case x0:
          C = ua;
          break;
        case V3:
        default:
          C = ho;
          break;
      }
      return C.bind(null, r, u, t);
    }
    function Os(t, r, u, f) {
      var C = s3(), p = ln.transition;
      ln.transition = null;
      try {
        Sn(kn), ho(t, r, u, f);
      } finally {
        Sn(C), ln.transition = p;
      }
    }
    function ua(t, r, u, f) {
      var C = s3(), p = ln.transition;
      ln.transition = null;
      try {
        Sn(x0), ho(t, r, u, f);
      } finally {
        Sn(C), ln.transition = p;
      }
    }
    function ho(t, r, u, f) {
      Zn && z4(t, r, u, f);
    }
    function z4(t, r, u, f) {
      var C = W2(t, r, u, f);
      if (C === null) {
        rI(t, r, f, oi, u), k4(t, f);
        return;
      }
      if (Kd(C, t, r, u, f)) {
        f.stopPropagation();
        return;
      }
      if (k4(t, f), r & Ki && _3(t)) {
        for (; C !== null; ) {
          var p = So(C);
          p !== null && O4(p);
          var b = W2(t, r, u, f);
          if (b === null && rI(t, r, f, oi, u), b === C)
            break;
          C = b;
        }
        C !== null && f.stopPropagation();
        return;
      }
      rI(t, r, f, null, u);
    }
    var oi = null;
    function W2(t, r, u, f) {
      oi = null;
      var C = Dl(f), p = Ws(C);
      if (p !== null) {
        var b = Pr(p);
        if (b === null)
          p = null;
        else {
          var M = b.tag;
          if (M === H) {
            var O = A4(b);
            if (O !== null)
              return O;
            p = null;
          } else if (M === S) {
            var P = b.stateNode;
            if (Au(P))
              return Pl(b);
            p = null;
          } else b !== p && (p = null);
        }
      }
      return oi = p, null;
    }
    function vu(t) {
      switch (t) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return kn;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return x0;
        case "message": {
          var r = h4();
          switch (r) {
            case Ul:
              return kn;
            case Zi:
              return x0;
            case W3:
            case Sd:
              return V3;
            case Wl:
              return so;
            default:
              return V3;
          }
        }
        default:
          return V3;
      }
    }
    function mo(t, r, u) {
      return t.addEventListener(r, u, !1), u;
    }
    function S0(t, r, u) {
      return t.addEventListener(r, u, !0), u;
    }
    function yu(t, r, u, f) {
      return t.addEventListener(r, u, {
        capture: !0,
        passive: f
      }), u;
    }
    function N4(t, r, u, f) {
      return t.addEventListener(r, u, {
        passive: f
      }), u;
    }
    var u3 = null, vo = null, c3 = null;
    function bu(t) {
      return u3 = t, vo = ks(), !0;
    }
    function Ds() {
      u3 = null, vo = null, c3 = null;
    }
    function wu() {
      if (c3)
        return c3;
      var t, r = vo, u = r.length, f, C = ks(), p = C.length;
      for (t = 0; t < u && r[t] === C[t]; t++)
        ;
      var b = u - t;
      for (f = 1; f <= b && r[u - f] === C[p - f]; f++)
        ;
      var M = f > 1 ? 1 - f : void 0;
      return c3 = C.slice(t, M), c3;
    }
    function ks() {
      return "value" in u3 ? u3.value : u3.textContent;
    }
    function ca(t) {
      var r, u = t.keyCode;
      return "charCode" in t ? (r = t.charCode, r === 0 && u === 13 && (r = 13)) : r = u, r === 10 && (r = 13), r >= 32 || r === 13 ? r : 0;
    }
    function A2() {
      return !0;
    }
    function E0() {
      return !1;
    }
    function hn(t) {
      function r(u, f, C, p, b) {
        this._reactName = u, this._targetInst = C, this.type = f, this.nativeEvent = p, this.target = b, this.currentTarget = null;
        for (var M in t)
          if (t.hasOwnProperty(M)) {
            var O = t[M];
            O ? this[M] = O(p) : this[M] = p[M];
          }
        var P = p.defaultPrevented != null ? p.defaultPrevented : p.returnValue === !1;
        return P ? this.isDefaultPrevented = A2 : this.isDefaultPrevented = E0, this.isPropagationStopped = E0, this;
      }
      return rt(r.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = A2);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = A2);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: A2
      }), r;
    }
    var e2 = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(t) {
        return t.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, xu = hn(e2), ga = rt({}, e2, {
      view: 0,
      detail: 0
    }), P4 = hn(ga), F4, J3, yo;
    function B4(t) {
      t !== yo && (yo && t.type === "mousemove" ? (F4 = t.screenX - yo.screenX, J3 = t.screenY - yo.screenY) : (F4 = 0, J3 = 0), yo = t);
    }
    var K3 = rt({}, ga, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: H4,
      button: 0,
      buttons: 0,
      relatedTarget: function(t) {
        return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
      },
      movementX: function(t) {
        return "movementX" in t ? t.movementX : (B4(t), F4);
      },
      movementY: function(t) {
        return "movementY" in t ? t.movementY : J3;
      }
    }), Su = hn(K3), fa = rt({}, K3, {
      dataTransfer: 0
    }), Yd = hn(fa), Qd = rt({}, ga, {
      relatedTarget: 0
    }), js = hn(Qd), Eu = rt({}, e2, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), U6 = hn(Eu), W6 = rt({}, e2, {
      clipboardData: function(t) {
        return "clipboardData" in t ? t.clipboardData : window.clipboardData;
      }
    }), Xd = hn(W6), Gd = rt({}, e2, {
      data: 0
    }), si = hn(Gd), V6 = si, bo = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, qd = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Mn(t) {
      if (t.key) {
        var r = bo[t.key] || t.key;
        if (r !== "Unidentified")
          return r;
      }
      if (t.type === "keypress") {
        var u = ca(t);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return t.type === "keydown" || t.type === "keyup" ? qd[t.keyCode] || "Unidentified" : "";
    }
    var _6 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Zd(t) {
      var r = this, u = r.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(t);
      var f = _6[t];
      return f ? !!u[f] : !1;
    }
    function H4(t) {
      return Zd;
    }
    var J6 = rt({}, ga, {
      key: Mn,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: H4,
      // Legacy Interface
      charCode: function(t) {
        return t.type === "keypress" ? ca(t) : 0;
      },
      keyCode: function(t) {
        return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      },
      which: function(t) {
        return t.type === "keypress" ? ca(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      }
    }), $d = hn(J6), e9 = rt({}, K3, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), t9 = hn(e9), g3 = rt({}, ga, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: H4
    }), U4 = hn(g3), K6 = rt({}, e2, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), li = hn(K6), Mu = rt({}, K3, {
      deltaX: function(t) {
        return "deltaX" in t ? t.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in t ? -t.wheelDeltaX : 0
        );
      },
      deltaY: function(t) {
        return "deltaY" in t ? t.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in t ? -t.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in t ? -t.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), da = hn(Mu), Tu = [9, 13, 27, 32], Lu = 229, zs = ue && "CompositionEvent" in window, Ns = null;
    ue && "documentMode" in document && (Ns = document.documentMode);
    var W4 = ue && "TextEvent" in window && !Ns, n9 = ue && (!zs || Ns && Ns > 8 && Ns <= 11), V4 = 32, _4 = String.fromCharCode(V4);
    function Ru() {
      We("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), We("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), We("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), We("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Ps = !1;
    function r9(t) {
      return (t.ctrlKey || t.altKey || t.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(t.ctrlKey && t.altKey);
    }
    function J4(t) {
      switch (t) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Y6(t, r) {
      return t === "keydown" && r.keyCode === Lu;
    }
    function K4(t, r) {
      switch (t) {
        case "keyup":
          return Tu.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== Lu;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ou(t) {
      var r = t.detail;
      return typeof r == "object" && "data" in r ? r.data : null;
    }
    function Fs(t) {
      return t.locale === "ko";
    }
    var ui = !1;
    function Du(t, r, u, f, C) {
      var p, b;
      if (zs ? p = J4(r) : ui ? K4(r, f) && (p = "onCompositionEnd") : Y6(r, f) && (p = "onCompositionStart"), !p)
        return null;
      n9 && !Fs(f) && (!ui && p === "onCompositionStart" ? ui = bu(C) : p === "onCompositionEnd" && ui && (b = wu()));
      var M = u9(u, p);
      if (M.length > 0) {
        var O = new si(p, r, null, f, C);
        if (t.push({
          event: O,
          listeners: M
        }), b)
          O.data = b;
        else {
          var P = Ou(f);
          P !== null && (O.data = P);
        }
      }
    }
    function i9(t, r) {
      switch (t) {
        case "compositionend":
          return Ou(r);
        case "keypress":
          var u = r.which;
          return u !== V4 ? null : (Ps = !0, _4);
        case "textInput":
          var f = r.data;
          return f === _4 && Ps ? null : f;
        default:
          return null;
      }
    }
    function Q6(t, r) {
      if (ui) {
        if (t === "compositionend" || !zs && K4(t, r)) {
          var u = wu();
          return Ds(), ui = !1, u;
        }
        return null;
      }
      switch (t) {
        case "paste":
          return null;
        case "keypress":
          if (!r9(r)) {
            if (r.char && r.char.length > 1)
              return r.char;
            if (r.which)
              return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return n9 && !Fs(r) ? null : r.data;
        default:
          return null;
      }
    }
    function ku(t, r, u, f, C) {
      var p;
      if (W4 ? p = i9(r, f) : p = Q6(r, f), !p)
        return null;
      var b = u9(u, "onBeforeInput");
      if (b.length > 0) {
        var M = new V6("onBeforeInput", "beforeinput", null, f, C);
        t.push({
          event: M,
          listeners: b
        }), M.data = p;
      }
    }
    function X6(t, r, u, f, C, p, b) {
      Du(t, r, u, f, C), ku(t, r, u, f, C);
    }
    var Bs = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function a9(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r === "input" ? !!Bs[t.type] : r === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function ju(t) {
      if (!ue)
        return !1;
      var r = "on" + t, u = r in document;
      if (!u) {
        var f = document.createElement("div");
        f.setAttribute(r, "return;"), u = typeof f[r] == "function";
      }
      return u;
    }
    function o() {
      We("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function l(t, r, u, f) {
      kl(f);
      var C = u9(r, "onChange");
      if (C.length > 0) {
        var p = new xu("onChange", "change", null, u, f);
        t.push({
          event: p,
          listeners: C
        });
      }
    }
    var d = null, A = null;
    function v(t) {
      var r = t.nodeName && t.nodeName.toLowerCase();
      return r === "select" || r === "input" && t.type === "file";
    }
    function x(t) {
      var r = [];
      l(r, A, t, Dl(t)), s4(j, r);
    }
    function j(t) {
      Gm(t, 0);
    }
    function _(t) {
      var r = Hu(t);
      if (M1(r))
        return t;
    }
    function X(t, r) {
      if (t === "change")
        return r;
    }
    var c1 = !1;
    ue && (c1 = ju("input") && (!document.documentMode || document.documentMode > 9));
    function R1(t, r) {
      d = t, A = r, d.attachEvent("onpropertychange", x1);
    }
    function j1() {
      d && (d.detachEvent("onpropertychange", x1), d = null, A = null);
    }
    function x1(t) {
      t.propertyName === "value" && _(A) && x(t);
    }
    function ge(t, r, u) {
      t === "focusin" ? (j1(), R1(r, u)) : t === "focusout" && j1();
    }
    function me(t, r) {
      if (t === "selectionchange" || t === "keyup" || t === "keydown")
        return _(A);
    }
    function be(t) {
      var r = t.nodeName;
      return r && r.toLowerCase() === "input" && (t.type === "checkbox" || t.type === "radio");
    }
    function jn(t, r) {
      if (t === "click")
        return _(r);
    }
    function r1(t, r) {
      if (t === "input" || t === "change")
        return _(r);
    }
    function $(t) {
      var r = t._wrapperState;
      !r || !r.controlled || t.type !== "number" || qr(t, "number", t.value);
    }
    function o1(t, r, u, f, C, p, b) {
      var M = u ? Hu(u) : window, O, P;
      if (v(M) ? O = X : a9(M) ? c1 ? O = r1 : (O = me, P = ge) : be(M) && (O = jn), O) {
        var F = O(r, u);
        if (F) {
          l(t, F, f, C);
          return;
        }
      }
      P && P(r, M, u), r === "focusout" && $(M);
    }
    function _1() {
      D1("onMouseEnter", ["mouseout", "mouseover"]), D1("onMouseLeave", ["mouseout", "mouseover"]), D1("onPointerEnter", ["pointerout", "pointerover"]), D1("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Ee(t, r, u, f, C, p, b) {
      var M = r === "mouseover" || r === "pointerover", O = r === "mouseout" || r === "pointerout";
      if (M && !hd(f)) {
        var P = f.relatedTarget || f.fromElement;
        if (P && (Ws(P) || og(P)))
          return;
      }
      if (!(!O && !M)) {
        var F;
        if (C.window === C)
          F = C;
        else {
          var e1 = C.ownerDocument;
          e1 ? F = e1.defaultView || e1.parentWindow : F = window;
        }
        var q, l1;
        if (O) {
          var g1 = f.relatedTarget || f.toElement;
          if (q = u, l1 = g1 ? Ws(g1) : null, l1 !== null) {
            var A1 = Pr(l1);
            (l1 !== A1 || l1.tag !== D && l1.tag !== k) && (l1 = null);
          }
        } else
          q = null, l1 = u;
        if (q !== l1) {
          var oe = Su, Ne = "onMouseLeave", Le = "onMouseEnter", At = "mouse";
          (r === "pointerout" || r === "pointerover") && (oe = t9, Ne = "onPointerLeave", Le = "onPointerEnter", At = "pointer");
          var dt = q == null ? F : Hu(q), i1 = l1 == null ? F : Hu(l1), I1 = new oe(Ne, At + "leave", q, f, C);
          I1.target = dt, I1.relatedTarget = i1;
          var a1 = null, N1 = Ws(C);
          if (N1 === u) {
            var de = new oe(Le, At + "enter", l1, f, C);
            de.target = i1, de.relatedTarget = dt, a1 = de;
          }
          eL(t, I1, a1, q, l1);
        }
      }
    }
    function He(t, r) {
      return t === r && (t !== 0 || 1 / t === 1 / r) || t !== t && r !== r;
    }
    var ve = typeof Object.is == "function" ? Object.is : He;
    function Ue(t, r) {
      if (ve(t, r))
        return !0;
      if (typeof t != "object" || t === null || typeof r != "object" || r === null)
        return !1;
      var u = Object.keys(t), f = Object.keys(r);
      if (u.length !== f.length)
        return !1;
      for (var C = 0; C < u.length; C++) {
        var p = u[C];
        if (!b1.call(r, p) || !ve(t[p], r[p]))
          return !1;
      }
      return !0;
    }
    function t2(t) {
      for (; t && t.firstChild; )
        t = t.firstChild;
      return t;
    }
    function bt(t) {
      for (; t; ) {
        if (t.nextSibling)
          return t.nextSibling;
        t = t.parentNode;
      }
    }
    function M0(t, r) {
      for (var u = t2(t), f = 0, C = 0; u; ) {
        if (u.nodeType === A0) {
          if (C = f + u.textContent.length, f <= r && C >= r)
            return {
              node: u,
              offset: r - f
            };
          f = C;
        }
        u = t2(bt(u));
      }
    }
    function G6(t) {
      var r = t.ownerDocument, u = r && r.defaultView || window, f = u.getSelection && u.getSelection();
      if (!f || f.rangeCount === 0)
        return null;
      var C = f.anchorNode, p = f.anchorOffset, b = f.focusNode, M = f.focusOffset;
      try {
        C.nodeType, b.nodeType;
      } catch {
        return null;
      }
      return jT(t, C, p, b, M);
    }
    function jT(t, r, u, f, C) {
      var p = 0, b = -1, M = -1, O = 0, P = 0, F = t, e1 = null;
      e: for (; ; ) {
        for (var q = null; F === r && (u === 0 || F.nodeType === A0) && (b = p + u), F === f && (C === 0 || F.nodeType === A0) && (M = p + C), F.nodeType === A0 && (p += F.nodeValue.length), (q = F.firstChild) !== null; )
          e1 = F, F = q;
        for (; ; ) {
          if (F === t)
            break e;
          if (e1 === r && ++O === u && (b = p), e1 === f && ++P === C && (M = p), (q = F.nextSibling) !== null)
            break;
          F = e1, e1 = F.parentNode;
        }
        F = q;
      }
      return b === -1 || M === -1 ? null : {
        start: b,
        end: M
      };
    }
    function zT(t, r) {
      var u = t.ownerDocument || document, f = u && u.defaultView || window;
      if (f.getSelection) {
        var C = f.getSelection(), p = t.textContent.length, b = Math.min(r.start, p), M = r.end === void 0 ? b : Math.min(r.end, p);
        if (!C.extend && b > M) {
          var O = M;
          M = b, b = O;
        }
        var P = M0(t, b), F = M0(t, M);
        if (P && F) {
          if (C.rangeCount === 1 && C.anchorNode === P.node && C.anchorOffset === P.offset && C.focusNode === F.node && C.focusOffset === F.offset)
            return;
          var e1 = u.createRange();
          e1.setStart(P.node, P.offset), C.removeAllRanges(), b > M ? (C.addRange(e1), C.extend(F.node, F.offset)) : (e1.setEnd(F.node, F.offset), C.addRange(e1));
        }
      }
    }
    function Fm(t) {
      return t && t.nodeType === A0;
    }
    function Bm(t, r) {
      return !t || !r ? !1 : t === r ? !0 : Fm(t) ? !1 : Fm(r) ? Bm(t, r.parentNode) : "contains" in t ? t.contains(r) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(r) & 16) : !1;
    }
    function NT(t) {
      return t && t.ownerDocument && Bm(t.ownerDocument.documentElement, t);
    }
    function PT(t) {
      try {
        return typeof t.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Hm() {
      for (var t = window, r = p1(); r instanceof t.HTMLIFrameElement; ) {
        if (PT(r))
          t = r.contentWindow;
        else
          return r;
        r = p1(t.document);
      }
      return r;
    }
    function q6(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r && (r === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || r === "textarea" || t.contentEditable === "true");
    }
    function FT() {
      var t = Hm();
      return {
        focusedElem: t,
        selectionRange: q6(t) ? HT(t) : null
      };
    }
    function BT(t) {
      var r = Hm(), u = t.focusedElem, f = t.selectionRange;
      if (r !== u && NT(u)) {
        f !== null && q6(u) && UT(u, f);
        for (var C = [], p = u; p = p.parentNode; )
          p.nodeType === dr && C.push({
            element: p,
            left: p.scrollLeft,
            top: p.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var b = 0; b < C.length; b++) {
          var M = C[b];
          M.element.scrollLeft = M.left, M.element.scrollTop = M.top;
        }
      }
    }
    function HT(t) {
      var r;
      return "selectionStart" in t ? r = {
        start: t.selectionStart,
        end: t.selectionEnd
      } : r = G6(t), r || {
        start: 0,
        end: 0
      };
    }
    function UT(t, r) {
      var u = r.start, f = r.end;
      f === void 0 && (f = u), "selectionStart" in t ? (t.selectionStart = u, t.selectionEnd = Math.min(f, t.value.length)) : zT(t, r);
    }
    var WT = ue && "documentMode" in document && document.documentMode <= 11;
    function VT() {
      We("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var zu = null, Z6 = null, Y4 = null, $6 = !1;
    function _T(t) {
      if ("selectionStart" in t && q6(t))
        return {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      var r = t.ownerDocument && t.ownerDocument.defaultView || window, u = r.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function JT(t) {
      return t.window === t ? t.document : t.nodeType === b3 ? t : t.ownerDocument;
    }
    function Um(t, r, u) {
      var f = JT(u);
      if (!($6 || zu == null || zu !== p1(f))) {
        var C = _T(zu);
        if (!Y4 || !Ue(Y4, C)) {
          Y4 = C;
          var p = u9(Z6, "onSelect");
          if (p.length > 0) {
            var b = new xu("onSelect", "select", null, r, u);
            t.push({
              event: b,
              listeners: p
            }), b.target = zu;
          }
        }
      }
    }
    function KT(t, r, u, f, C, p, b) {
      var M = u ? Hu(u) : window;
      switch (r) {
        case "focusin":
          (a9(M) || M.contentEditable === "true") && (zu = M, Z6 = u, Y4 = null);
          break;
        case "focusout":
          zu = null, Z6 = null, Y4 = null;
          break;
        case "mousedown":
          $6 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          $6 = !1, Um(t, f, C);
          break;
        case "selectionchange":
          if (WT)
            break;
        case "keydown":
        case "keyup":
          Um(t, f, C);
      }
    }
    function o9(t, r) {
      var u = {};
      return u[t.toLowerCase()] = r.toLowerCase(), u["Webkit" + t] = "webkit" + r, u["Moz" + t] = "moz" + r, u;
    }
    var Nu = {
      animationend: o9("Animation", "AnimationEnd"),
      animationiteration: o9("Animation", "AnimationIteration"),
      animationstart: o9("Animation", "AnimationStart"),
      transitionend: o9("Transition", "TransitionEnd")
    }, eI = {}, Wm = {};
    ue && (Wm = document.createElement("div").style, "AnimationEvent" in window || (delete Nu.animationend.animation, delete Nu.animationiteration.animation, delete Nu.animationstart.animation), "TransitionEvent" in window || delete Nu.transitionend.transition);
    function s9(t) {
      if (eI[t])
        return eI[t];
      if (!Nu[t])
        return t;
      var r = Nu[t];
      for (var u in r)
        if (r.hasOwnProperty(u) && u in Wm)
          return eI[t] = r[u];
      return t;
    }
    var Vm = s9("animationend"), _m = s9("animationiteration"), Jm = s9("animationstart"), Km = s9("transitionend"), Ym = /* @__PURE__ */ new Map(), Qm = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function wo(t, r) {
      Ym.set(t, r), We(r, [t]);
    }
    function YT() {
      for (var t = 0; t < Qm.length; t++) {
        var r = Qm[t], u = r.toLowerCase(), f = r[0].toUpperCase() + r.slice(1);
        wo(u, "on" + f);
      }
      wo(Vm, "onAnimationEnd"), wo(_m, "onAnimationIteration"), wo(Jm, "onAnimationStart"), wo("dblclick", "onDoubleClick"), wo("focusin", "onFocus"), wo("focusout", "onBlur"), wo(Km, "onTransitionEnd");
    }
    function QT(t, r, u, f, C, p, b) {
      var M = Ym.get(r);
      if (M !== void 0) {
        var O = xu, P = r;
        switch (r) {
          case "keypress":
            if (ca(f) === 0)
              return;
          case "keydown":
          case "keyup":
            O = $d;
            break;
          case "focusin":
            P = "focus", O = js;
            break;
          case "focusout":
            P = "blur", O = js;
            break;
          case "beforeblur":
          case "afterblur":
            O = js;
            break;
          case "click":
            if (f.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            O = Su;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            O = Yd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            O = U4;
            break;
          case Vm:
          case _m:
          case Jm:
            O = U6;
            break;
          case Km:
            O = li;
            break;
          case "scroll":
            O = P4;
            break;
          case "wheel":
            O = da;
            break;
          case "copy":
          case "cut":
          case "paste":
            O = Xd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            O = t9;
            break;
        }
        var F = (p & Ki) !== 0;
        {
          var e1 = !F && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          r === "scroll", q = ZT(u, M, f.type, F, e1);
          if (q.length > 0) {
            var l1 = new O(M, P, null, f, C);
            t.push({
              event: l1,
              listeners: q
            });
          }
        }
      }
    }
    YT(), _1(), o(), VT(), Ru();
    function XT(t, r, u, f, C, p, b) {
      QT(t, r, u, f, C, p);
      var M = (p & T6) === 0;
      M && (Ee(t, r, u, f, C), o1(t, r, u, f, C), KT(t, r, u, f, C), X6(t, r, u, f, C));
    }
    var Q4 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], tI = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Q4));
    function Xm(t, r, u) {
      var f = t.type || "unknown-event";
      t.currentTarget = u, m0(f, r, void 0, t), t.currentTarget = null;
    }
    function GT(t, r, u) {
      var f;
      if (u)
        for (var C = r.length - 1; C >= 0; C--) {
          var p = r[C], b = p.instance, M = p.currentTarget, O = p.listener;
          if (b !== f && t.isPropagationStopped())
            return;
          Xm(t, O, M), f = b;
        }
      else
        for (var P = 0; P < r.length; P++) {
          var F = r[P], e1 = F.instance, q = F.currentTarget, l1 = F.listener;
          if (e1 !== f && t.isPropagationStopped())
            return;
          Xm(t, l1, q), f = e1;
        }
    }
    function Gm(t, r) {
      for (var u = (r & Ki) !== 0, f = 0; f < t.length; f++) {
        var C = t[f], p = C.event, b = C.listeners;
        GT(p, b, u);
      }
      g4();
    }
    function qT(t, r, u, f, C) {
      var p = Dl(u), b = [];
      XT(b, t, f, u, p, r), Gm(b, r);
    }
    function mn(t, r) {
      tI.has(t) || c('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', t);
      var u = !1, f = MR(r), C = tL(t);
      f.has(C) || (qm(r, t, ls, u), f.add(C));
    }
    function nI(t, r, u) {
      tI.has(t) && !r && c('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', t);
      var f = 0;
      r && (f |= Ki), qm(u, t, f, r);
    }
    var l9 = "_reactListening" + Math.random().toString(36).slice(2);
    function X4(t) {
      if (!t[l9]) {
        t[l9] = !0, V1.forEach(function(u) {
          u !== "selectionchange" && (tI.has(u) || nI(u, !1, t), nI(u, !0, t));
        });
        var r = t.nodeType === b3 ? t : t.ownerDocument;
        r !== null && (r[l9] || (r[l9] = !0, nI("selectionchange", !1, r)));
      }
    }
    function qm(t, r, u, f, C) {
      var p = $n(t, r, u), b = void 0;
      ds && (r === "touchstart" || r === "touchmove" || r === "wheel") && (b = !0), t = t, f ? b !== void 0 ? yu(t, r, p, b) : S0(t, r, p) : b !== void 0 ? N4(t, r, p, b) : mo(t, r, p);
    }
    function Zm(t, r) {
      return t === r || t.nodeType === Hn && t.parentNode === r;
    }
    function rI(t, r, u, f, C) {
      var p = f;
      if (!(r & p0) && !(r & ls)) {
        var b = C;
        if (f !== null) {
          var M = f;
          e: for (; ; ) {
            if (M === null)
              return;
            var O = M.tag;
            if (O === S || O === T) {
              var P = M.stateNode.containerInfo;
              if (Zm(P, b))
                break;
              if (O === T)
                for (var F = M.return; F !== null; ) {
                  var e1 = F.tag;
                  if (e1 === S || e1 === T) {
                    var q = F.stateNode.containerInfo;
                    if (Zm(q, b))
                      return;
                  }
                  F = F.return;
                }
              for (; P !== null; ) {
                var l1 = Ws(P);
                if (l1 === null)
                  return;
                var g1 = l1.tag;
                if (g1 === D || g1 === k) {
                  M = p = l1;
                  continue e;
                }
                P = P.parentNode;
              }
            }
            M = M.return;
          }
        }
      }
      s4(function() {
        return qT(t, r, u, p);
      });
    }
    function G4(t, r, u) {
      return {
        instance: t,
        listener: r,
        currentTarget: u
      };
    }
    function ZT(t, r, u, f, C, p) {
      for (var b = r !== null ? r + "Capture" : null, M = f ? b : r, O = [], P = t, F = null; P !== null; ) {
        var e1 = P, q = e1.stateNode, l1 = e1.tag;
        if (l1 === D && q !== null && (F = q, M !== null)) {
          var g1 = Qi(P, M);
          g1 != null && O.push(G4(P, g1, F));
        }
        if (C)
          break;
        P = P.return;
      }
      return O;
    }
    function u9(t, r) {
      for (var u = r + "Capture", f = [], C = t; C !== null; ) {
        var p = C, b = p.stateNode, M = p.tag;
        if (M === D && b !== null) {
          var O = b, P = Qi(C, u);
          P != null && f.unshift(G4(C, P, O));
          var F = Qi(C, r);
          F != null && f.push(G4(C, F, O));
        }
        C = C.return;
      }
      return f;
    }
    function Pu(t) {
      if (t === null)
        return null;
      do
        t = t.return;
      while (t && t.tag !== D);
      return t || null;
    }
    function $T(t, r) {
      for (var u = t, f = r, C = 0, p = u; p; p = Pu(p))
        C++;
      for (var b = 0, M = f; M; M = Pu(M))
        b++;
      for (; C - b > 0; )
        u = Pu(u), C--;
      for (; b - C > 0; )
        f = Pu(f), b--;
      for (var O = C; O--; ) {
        if (u === f || f !== null && u === f.alternate)
          return u;
        u = Pu(u), f = Pu(f);
      }
      return null;
    }
    function $m(t, r, u, f, C) {
      for (var p = r._reactName, b = [], M = u; M !== null && M !== f; ) {
        var O = M, P = O.alternate, F = O.stateNode, e1 = O.tag;
        if (P !== null && P === f)
          break;
        if (e1 === D && F !== null) {
          var q = F;
          if (C) {
            var l1 = Qi(M, p);
            l1 != null && b.unshift(G4(M, l1, q));
          } else if (!C) {
            var g1 = Qi(M, p);
            g1 != null && b.push(G4(M, g1, q));
          }
        }
        M = M.return;
      }
      b.length !== 0 && t.push({
        event: r,
        listeners: b
      });
    }
    function eL(t, r, u, f, C) {
      var p = f && C ? $T(f, C) : null;
      f !== null && $m(t, r, f, p, !1), C !== null && u !== null && $m(t, u, C, p, !0);
    }
    function tL(t, r) {
      return t + "__bubble";
    }
    var f3 = !1, q4 = "dangerouslySetInnerHTML", c9 = "suppressContentEditableWarning", xo = "suppressHydrationWarning", e8 = "autoFocus", Hs = "children", Us = "style", g9 = "__html", iI, f9, Z4, t8, d9, n8, r8;
    iI = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, f9 = function(t, r) {
      Ol(t, r), n4(t, r), pd(t, r, {
        registrationNameDependencies: z1,
        possibleRegistrationNames: ae
      });
    }, n8 = ue && !document.documentMode, Z4 = function(t, r, u) {
      if (!f3) {
        var f = C9(u), C = C9(r);
        C !== f && (f3 = !0, c("Prop `%s` did not match. Server: %s Client: %s", t, JSON.stringify(C), JSON.stringify(f)));
      }
    }, t8 = function(t) {
      if (!f3) {
        f3 = !0;
        var r = [];
        t.forEach(function(u) {
          r.push(u);
        }), c("Extra attributes from the server: %s", r);
      }
    }, d9 = function(t, r) {
      r === !1 ? c("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", t, t, t) : c("Expected `%s` listener to be a function, instead got a value of `%s` type.", t, typeof r);
    }, r8 = function(t, r) {
      var u = t.namespaceURI === C0 ? t.ownerDocument.createElement(t.tagName) : t.ownerDocument.createElementNS(t.namespaceURI, t.tagName);
      return u.innerHTML = r, u.innerHTML;
    };
    var nL = /\r\n?/g, rL = /\u0000|\uFFFD/g;
    function C9(t) {
      we(t);
      var r = typeof t == "string" ? t : "" + t;
      return r.replace(nL, `
`).replace(rL, "");
    }
    function A9(t, r, u, f) {
      var C = C9(r), p = C9(t);
      if (p !== C && (f && (f3 || (f3 = !0, c('Text content did not match. Server: "%s" Client: "%s"', p, C))), u && L1))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function i8(t) {
      return t.nodeType === b3 ? t : t.ownerDocument;
    }
    function iL() {
    }
    function I9(t) {
      t.onclick = iL;
    }
    function aL(t, r, u, f, C) {
      for (var p in f)
        if (f.hasOwnProperty(p)) {
          var b = f[p];
          if (p === Us)
            b && Object.freeze(b), sd(r, b);
          else if (p === q4) {
            var M = b ? b[g9] : void 0;
            M != null && Gf(r, M);
          } else if (p === Hs)
            if (typeof b == "string") {
              var O = t !== "textarea" || b !== "";
              O && Ml(r, b);
            } else typeof b == "number" && Ml(r, "" + b);
          else p === c9 || p === xo || p === e8 || (z1.hasOwnProperty(p) ? b != null && (typeof b != "function" && d9(p, b), p === "onScroll" && mn("scroll", r)) : b != null && rn(r, p, b, C));
        }
    }
    function oL(t, r, u, f) {
      for (var C = 0; C < r.length; C += 2) {
        var p = r[C], b = r[C + 1];
        p === Us ? sd(t, b) : p === q4 ? Gf(t, b) : p === Hs ? Ml(t, b) : rn(t, p, b, f);
      }
    }
    function sL(t, r, u, f) {
      var C, p = i8(u), b, M = f;
      if (M === C0 && (M = Sl(t)), M === C0) {
        if (C = I0(t, r), !C && t !== t.toLowerCase() && c("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", t), t === "script") {
          var O = p.createElement("div");
          O.innerHTML = "<script><\/script>";
          var P = O.firstChild;
          b = O.removeChild(P);
        } else if (typeof r.is == "string")
          b = p.createElement(t, {
            is: r.is
          });
        else if (b = p.createElement(t), t === "select") {
          var F = b;
          r.multiple ? F.multiple = !0 : r.size && (F.size = r.size);
        }
      } else
        b = p.createElementNS(M, t);
      return M === C0 && !C && Object.prototype.toString.call(b) === "[object HTMLUnknownElement]" && !b1.call(iI, t) && (iI[t] = !0, c("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", t)), b;
    }
    function lL(t, r) {
      return i8(r).createTextNode(t);
    }
    function uL(t, r, u, f) {
      var C = I0(r, u);
      f9(r, u);
      var p;
      switch (r) {
        case "dialog":
          mn("cancel", t), mn("close", t), p = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          mn("load", t), p = u;
          break;
        case "video":
        case "audio":
          for (var b = 0; b < Q4.length; b++)
            mn(Q4[b], t);
          p = u;
          break;
        case "source":
          mn("error", t), p = u;
          break;
        case "img":
        case "image":
        case "link":
          mn("error", t), mn("load", t), p = u;
          break;
        case "details":
          mn("toggle", t), p = u;
          break;
        case "input":
          $t(t, u), p = Xn(t, u), mn("invalid", t);
          break;
        case "option":
          wl(t, u), p = u;
          break;
        case "select":
          Kf(t, u), p = Jc(t, u), mn("invalid", t);
          break;
        case "textarea":
          Yf(t, u), p = Yc(t, u), mn("invalid", t);
          break;
        default:
          p = u;
      }
      switch (Ll(r, p), aL(r, t, f, p, C), r) {
        case "input":
          u1(t), y3(t, u, !1);
          break;
        case "textarea":
          u1(t), Xf(t);
          break;
        case "option":
          _c(t, u);
          break;
        case "select":
          p6(t, u);
          break;
        default:
          typeof p.onClick == "function" && I9(t);
          break;
      }
    }
    function cL(t, r, u, f, C) {
      f9(r, f);
      var p = null, b, M;
      switch (r) {
        case "input":
          b = Xn(t, u), M = Xn(t, f), p = [];
          break;
        case "select":
          b = Jc(t, u), M = Jc(t, f), p = [];
          break;
        case "textarea":
          b = Yc(t, u), M = Yc(t, f), p = [];
          break;
        default:
          b = u, M = f, typeof b.onClick != "function" && typeof M.onClick == "function" && I9(t);
          break;
      }
      Ll(r, M);
      var O, P, F = null;
      for (O in b)
        if (!(M.hasOwnProperty(O) || !b.hasOwnProperty(O) || b[O] == null))
          if (O === Us) {
            var e1 = b[O];
            for (P in e1)
              e1.hasOwnProperty(P) && (F || (F = {}), F[P] = "");
          } else O === q4 || O === Hs || O === c9 || O === xo || O === e8 || (z1.hasOwnProperty(O) ? p || (p = []) : (p = p || []).push(O, null));
      for (O in M) {
        var q = M[O], l1 = b != null ? b[O] : void 0;
        if (!(!M.hasOwnProperty(O) || q === l1 || q == null && l1 == null))
          if (O === Us)
            if (q && Object.freeze(q), l1) {
              for (P in l1)
                l1.hasOwnProperty(P) && (!q || !q.hasOwnProperty(P)) && (F || (F = {}), F[P] = "");
              for (P in q)
                q.hasOwnProperty(P) && l1[P] !== q[P] && (F || (F = {}), F[P] = q[P]);
            } else
              F || (p || (p = []), p.push(O, F)), F = q;
          else if (O === q4) {
            var g1 = q ? q[g9] : void 0, A1 = l1 ? l1[g9] : void 0;
            g1 != null && A1 !== g1 && (p = p || []).push(O, g1);
          } else O === Hs ? (typeof q == "string" || typeof q == "number") && (p = p || []).push(O, "" + q) : O === c9 || O === xo || (z1.hasOwnProperty(O) ? (q != null && (typeof q != "function" && d9(O, q), O === "onScroll" && mn("scroll", t)), !p && l1 !== q && (p = [])) : (p = p || []).push(O, q));
      }
      return F && (os(F, M[Us]), (p = p || []).push(Us, F)), p;
    }
    function gL(t, r, u, f, C) {
      u === "input" && C.type === "radio" && C.name != null && gn(t, C);
      var p = I0(u, f), b = I0(u, C);
      switch (oL(t, r, p, b), u) {
        case "input":
          u2(t, C);
          break;
        case "textarea":
          Qf(t, C);
          break;
        case "select":
          h6(t, C);
          break;
      }
    }
    function fL(t) {
      {
        var r = t.toLowerCase();
        return Rl.hasOwnProperty(r) && Rl[r] || null;
      }
    }
    function dL(t, r, u, f, C, p, b) {
      var M, O;
      switch (M = I0(r, u), f9(r, u), r) {
        case "dialog":
          mn("cancel", t), mn("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          mn("load", t);
          break;
        case "video":
        case "audio":
          for (var P = 0; P < Q4.length; P++)
            mn(Q4[P], t);
          break;
        case "source":
          mn("error", t);
          break;
        case "img":
        case "image":
        case "link":
          mn("error", t), mn("load", t);
          break;
        case "details":
          mn("toggle", t);
          break;
        case "input":
          $t(t, u), mn("invalid", t);
          break;
        case "option":
          wl(t, u);
          break;
        case "select":
          Kf(t, u), mn("invalid", t);
          break;
        case "textarea":
          Yf(t, u), mn("invalid", t);
          break;
      }
      Ll(r, u);
      {
        O = /* @__PURE__ */ new Set();
        for (var F = t.attributes, e1 = 0; e1 < F.length; e1++) {
          var q = F[e1].name.toLowerCase();
          switch (q) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              O.add(F[e1].name);
          }
        }
      }
      var l1 = null;
      for (var g1 in u)
        if (u.hasOwnProperty(g1)) {
          var A1 = u[g1];
          if (g1 === Hs)
            typeof A1 == "string" ? t.textContent !== A1 && (u[xo] !== !0 && A9(t.textContent, A1, p, b), l1 = [Hs, A1]) : typeof A1 == "number" && t.textContent !== "" + A1 && (u[xo] !== !0 && A9(t.textContent, A1, p, b), l1 = [Hs, "" + A1]);
          else if (z1.hasOwnProperty(g1))
            A1 != null && (typeof A1 != "function" && d9(g1, A1), g1 === "onScroll" && mn("scroll", t));
          else if (b && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof M == "boolean") {
            var oe = void 0, Ne = M && se ? null : y2(g1);
            if (u[xo] !== !0) {
              if (!(g1 === c9 || g1 === xo || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              g1 === "value" || g1 === "checked" || g1 === "selected")) {
                if (g1 === q4) {
                  var Le = t.innerHTML, At = A1 ? A1[g9] : void 0;
                  if (At != null) {
                    var dt = r8(t, At);
                    dt !== Le && Z4(g1, Le, dt);
                  }
                } else if (g1 === Us) {
                  if (O.delete(g1), n8) {
                    var i1 = E6(A1);
                    oe = t.getAttribute("style"), i1 !== oe && Z4(g1, oe, i1);
                  }
                } else if (M && !se)
                  O.delete(g1.toLowerCase()), oe = V0(t, g1, A1), A1 !== oe && Z4(g1, oe, A1);
                else if (!nn(g1, Ne, M) && !zt(g1, A1, Ne, M)) {
                  var I1 = !1;
                  if (Ne !== null)
                    O.delete(Ne.attributeName), oe = u0(t, g1, A1, Ne);
                  else {
                    var a1 = f;
                    if (a1 === C0 && (a1 = Sl(r)), a1 === C0)
                      O.delete(g1.toLowerCase());
                    else {
                      var N1 = fL(g1);
                      N1 !== null && N1 !== g1 && (I1 = !0, O.delete(N1)), O.delete(g1);
                    }
                    oe = V0(t, g1, A1);
                  }
                  var de = se;
                  !de && A1 !== oe && !I1 && Z4(g1, oe, A1);
                }
              }
            }
          }
        }
      switch (b && // $FlowFixMe - Should be inferred as not undefined.
      O.size > 0 && u[xo] !== !0 && t8(O), r) {
        case "input":
          u1(t), y3(t, u, !0);
          break;
        case "textarea":
          u1(t), Xf(t);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && I9(t);
          break;
      }
      return l1;
    }
    function CL(t, r, u) {
      var f = t.nodeValue !== r;
      return f;
    }
    function aI(t, r) {
      {
        if (f3)
          return;
        f3 = !0, c("Did not expect server HTML to contain a <%s> in <%s>.", r.nodeName.toLowerCase(), t.nodeName.toLowerCase());
      }
    }
    function oI(t, r) {
      {
        if (f3)
          return;
        f3 = !0, c('Did not expect server HTML to contain the text node "%s" in <%s>.', r.nodeValue, t.nodeName.toLowerCase());
      }
    }
    function sI(t, r, u) {
      {
        if (f3)
          return;
        f3 = !0, c("Expected server HTML to contain a matching <%s> in <%s>.", r, t.nodeName.toLowerCase());
      }
    }
    function lI(t, r) {
      {
        if (r === "" || f3)
          return;
        f3 = !0, c('Expected server HTML to contain a matching text node for "%s" in <%s>.', r, t.nodeName.toLowerCase());
      }
    }
    function AL(t, r, u) {
      switch (r) {
        case "input":
          P2(t, u);
          return;
        case "textarea":
          Qc(t, u);
          return;
        case "select":
          m6(t, u);
          return;
      }
    }
    var $4 = function() {
    }, eg = function() {
    };
    {
      var IL = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], a8 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], pL = a8.concat(["button"]), hL = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], o8 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      eg = function(t, r) {
        var u = rt({}, t || o8), f = {
          tag: r
        };
        return a8.indexOf(r) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), pL.indexOf(r) !== -1 && (u.pTagInButtonScope = null), IL.indexOf(r) !== -1 && r !== "address" && r !== "div" && r !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = f, r === "form" && (u.formTag = f), r === "a" && (u.aTagInScope = f), r === "button" && (u.buttonTagInScope = f), r === "nobr" && (u.nobrTagInScope = f), r === "p" && (u.pTagInButtonScope = f), r === "li" && (u.listItemTagAutoclosing = f), (r === "dd" || r === "dt") && (u.dlItemTagAutoclosing = f), u;
      };
      var mL = function(t, r) {
        switch (r) {
          case "select":
            return t === "option" || t === "optgroup" || t === "#text";
          case "optgroup":
            return t === "option" || t === "#text";
          case "option":
            return t === "#text";
          case "tr":
            return t === "th" || t === "td" || t === "style" || t === "script" || t === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return t === "tr" || t === "style" || t === "script" || t === "template";
          case "colgroup":
            return t === "col" || t === "template";
          case "table":
            return t === "caption" || t === "colgroup" || t === "tbody" || t === "tfoot" || t === "thead" || t === "style" || t === "script" || t === "template";
          case "head":
            return t === "base" || t === "basefont" || t === "bgsound" || t === "link" || t === "meta" || t === "title" || t === "noscript" || t === "noframes" || t === "style" || t === "script" || t === "template";
          case "html":
            return t === "head" || t === "body" || t === "frameset";
          case "frameset":
            return t === "frame";
          case "#document":
            return t === "html";
        }
        switch (t) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r !== "h1" && r !== "h2" && r !== "h3" && r !== "h4" && r !== "h5" && r !== "h6";
          case "rp":
          case "rt":
            return hL.indexOf(r) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return r == null;
        }
        return !0;
      }, vL = function(t, r) {
        switch (t) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r.pTagInButtonScope;
          case "form":
            return r.formTag || r.pTagInButtonScope;
          case "li":
            return r.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return r.dlItemTagAutoclosing;
          case "button":
            return r.buttonTagInScope;
          case "a":
            return r.aTagInScope;
          case "nobr":
            return r.nobrTagInScope;
        }
        return null;
      }, s8 = {};
      $4 = function(t, r, u) {
        u = u || o8;
        var f = u.current, C = f && f.tag;
        r != null && (t != null && c("validateDOMNesting: when childText is passed, childTag should be null"), t = "#text");
        var p = mL(t, C) ? null : f, b = p ? null : vL(t, u), M = p || b;
        if (M) {
          var O = M.tag, P = !!p + "|" + t + "|" + O;
          if (!s8[P]) {
            s8[P] = !0;
            var F = t, e1 = "";
            if (t === "#text" ? /\S/.test(r) ? F = "Text nodes" : (F = "Whitespace text nodes", e1 = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : F = "<" + t + ">", p) {
              var q = "";
              O === "table" && t === "tr" && (q += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), c("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", F, O, e1, q);
            } else
              c("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", F, O);
          }
        }
      };
    }
    var p9 = "suppressHydrationWarning", h9 = "$", m9 = "/$", tg = "$?", ng = "$!", yL = "style", uI = null, cI = null;
    function bL(t) {
      var r, u, f = t.nodeType;
      switch (f) {
        case b3:
        case _i: {
          r = f === b3 ? "#document" : "#fragment";
          var C = t.documentElement;
          u = C ? C.namespaceURI : Gc(null, "");
          break;
        }
        default: {
          var p = f === Hn ? t.parentNode : t, b = p.namespaceURI || null;
          r = p.tagName, u = Gc(b, r);
          break;
        }
      }
      {
        var M = r.toLowerCase(), O = eg(null, M);
        return {
          namespace: u,
          ancestorInfo: O
        };
      }
    }
    function wL(t, r, u) {
      {
        var f = t, C = Gc(f.namespace, r), p = eg(f.ancestorInfo, r);
        return {
          namespace: C,
          ancestorInfo: p
        };
      }
    }
    function N11(t) {
      return t;
    }
    function xL(t) {
      uI = po(), cI = FT();
      var r = null;
      return wr(!1), r;
    }
    function SL(t) {
      BT(cI), wr(uI), uI = null, cI = null;
    }
    function EL(t, r, u, f, C) {
      var p;
      {
        var b = f;
        if ($4(t, null, b.ancestorInfo), typeof r.children == "string" || typeof r.children == "number") {
          var M = "" + r.children, O = eg(b.ancestorInfo, t);
          $4(null, M, O);
        }
        p = b.namespace;
      }
      var P = sL(t, r, u, p);
      return ag(C, P), hI(P, r), P;
    }
    function ML(t, r) {
      t.appendChild(r);
    }
    function TL(t, r, u, f, C) {
      switch (uL(t, r, u, f), r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function LL(t, r, u, f, C, p) {
      {
        var b = p;
        if (typeof f.children != typeof u.children && (typeof f.children == "string" || typeof f.children == "number")) {
          var M = "" + f.children, O = eg(b.ancestorInfo, r);
          $4(null, M, O);
        }
      }
      return cL(t, r, u, f);
    }
    function gI(t, r) {
      return t === "textarea" || t === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
    }
    function RL(t, r, u, f) {
      {
        var C = u;
        $4(null, t, C.ancestorInfo);
      }
      var p = lL(t, r);
      return ag(f, p), p;
    }
    function OL() {
      var t = window.event;
      return t === void 0 ? V3 : vu(t.type);
    }
    var fI = typeof setTimeout == "function" ? setTimeout : void 0, DL = typeof clearTimeout == "function" ? clearTimeout : void 0, dI = -1, l8 = typeof Promise == "function" ? Promise : void 0, kL = typeof queueMicrotask == "function" ? queueMicrotask : typeof l8 < "u" ? function(t) {
      return l8.resolve(null).then(t).catch(jL);
    } : fI;
    function jL(t) {
      setTimeout(function() {
        throw t;
      });
    }
    function zL(t, r, u, f) {
      switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && t.focus();
          return;
        case "img": {
          u.src && (t.src = u.src);
          return;
        }
      }
    }
    function NL(t, r, u, f, C, p) {
      gL(t, r, u, f, C), hI(t, C);
    }
    function u8(t) {
      Ml(t, "");
    }
    function PL(t, r, u) {
      t.nodeValue = u;
    }
    function FL(t, r) {
      t.appendChild(r);
    }
    function BL(t, r) {
      var u;
      t.nodeType === Hn ? (u = t.parentNode, u.insertBefore(r, t)) : (u = t, u.appendChild(r));
      var f = t._reactRootContainer;
      f == null && u.onclick === null && I9(u);
    }
    function HL(t, r, u) {
      t.insertBefore(r, u);
    }
    function UL(t, r, u) {
      t.nodeType === Hn ? t.parentNode.insertBefore(r, u) : t.insertBefore(r, u);
    }
    function WL(t, r) {
      t.removeChild(r);
    }
    function VL(t, r) {
      t.nodeType === Hn ? t.parentNode.removeChild(r) : t.removeChild(r);
    }
    function CI(t, r) {
      var u = r, f = 0;
      do {
        var C = u.nextSibling;
        if (t.removeChild(u), C && C.nodeType === Hn) {
          var p = C.data;
          if (p === m9)
            if (f === 0) {
              t.removeChild(C), En(r);
              return;
            } else
              f--;
          else (p === h9 || p === tg || p === ng) && f++;
        }
        u = C;
      } while (u);
      En(r);
    }
    function _L(t, r) {
      t.nodeType === Hn ? CI(t.parentNode, r) : t.nodeType === dr && CI(t, r), En(t);
    }
    function JL(t) {
      t = t;
      var r = t.style;
      typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
    }
    function KL(t) {
      t.nodeValue = "";
    }
    function YL(t, r) {
      t = t;
      var u = r[yL], f = u != null && u.hasOwnProperty("display") ? u.display : null;
      t.style.display = Tl("display", f);
    }
    function QL(t, r) {
      t.nodeValue = r;
    }
    function XL(t) {
      t.nodeType === dr ? t.textContent = "" : t.nodeType === b3 && t.documentElement && t.removeChild(t.documentElement);
    }
    function GL(t, r, u) {
      return t.nodeType !== dr || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t;
    }
    function qL(t, r) {
      return r === "" || t.nodeType !== A0 ? null : t;
    }
    function ZL(t) {
      return t.nodeType !== Hn ? null : t;
    }
    function c8(t) {
      return t.data === tg;
    }
    function AI(t) {
      return t.data === ng;
    }
    function $L(t) {
      var r = t.nextSibling && t.nextSibling.dataset, u, f, C;
      return r && (u = r.dgst, f = r.msg, C = r.stck), {
        message: f,
        digest: u,
        stack: C
      };
    }
    function eR(t, r) {
      t._reactRetry = r;
    }
    function v9(t) {
      for (; t != null; t = t.nextSibling) {
        var r = t.nodeType;
        if (r === dr || r === A0)
          break;
        if (r === Hn) {
          var u = t.data;
          if (u === h9 || u === ng || u === tg)
            break;
          if (u === m9)
            return null;
        }
      }
      return t;
    }
    function rg(t) {
      return v9(t.nextSibling);
    }
    function tR(t) {
      return v9(t.firstChild);
    }
    function nR(t) {
      return v9(t.firstChild);
    }
    function rR(t) {
      return v9(t.nextSibling);
    }
    function iR(t, r, u, f, C, p, b) {
      ag(p, t), hI(t, u);
      var M;
      {
        var O = C;
        M = O.namespace;
      }
      var P = (p.mode & Te) !== Se;
      return dL(t, r, u, M, f, P, b);
    }
    function aR(t, r, u, f) {
      return ag(u, t), u.mode & Te, CL(t, r);
    }
    function oR(t, r) {
      ag(r, t);
    }
    function sR(t) {
      for (var r = t.nextSibling, u = 0; r; ) {
        if (r.nodeType === Hn) {
          var f = r.data;
          if (f === m9) {
            if (u === 0)
              return rg(r);
            u--;
          } else (f === h9 || f === ng || f === tg) && u++;
        }
        r = r.nextSibling;
      }
      return null;
    }
    function g8(t) {
      for (var r = t.previousSibling, u = 0; r; ) {
        if (r.nodeType === Hn) {
          var f = r.data;
          if (f === h9 || f === ng || f === tg) {
            if (u === 0)
              return r;
            u--;
          } else f === m9 && u++;
        }
        r = r.previousSibling;
      }
      return null;
    }
    function lR(t) {
      En(t);
    }
    function uR(t) {
      En(t);
    }
    function cR(t) {
      return t !== "head" && t !== "body";
    }
    function gR(t, r, u, f) {
      var C = !0;
      A9(r.nodeValue, u, f, C);
    }
    function fR(t, r, u, f, C, p) {
      if (r[p9] !== !0) {
        var b = !0;
        A9(f.nodeValue, C, p, b);
      }
    }
    function dR(t, r) {
      r.nodeType === dr ? aI(t, r) : r.nodeType === Hn || oI(t, r);
    }
    function CR(t, r) {
      {
        var u = t.parentNode;
        u !== null && (r.nodeType === dr ? aI(u, r) : r.nodeType === Hn || oI(u, r));
      }
    }
    function AR(t, r, u, f, C) {
      (C || r[p9] !== !0) && (f.nodeType === dr ? aI(u, f) : f.nodeType === Hn || oI(u, f));
    }
    function IR(t, r, u) {
      sI(t, r);
    }
    function pR(t, r) {
      lI(t, r);
    }
    function hR(t, r, u) {
      {
        var f = t.parentNode;
        f !== null && sI(f, r);
      }
    }
    function mR(t, r) {
      {
        var u = t.parentNode;
        u !== null && lI(u, r);
      }
    }
    function vR(t, r, u, f, C, p) {
      (p || r[p9] !== !0) && sI(u, f);
    }
    function yR(t, r, u, f, C) {
      (C || r[p9] !== !0) && lI(u, f);
    }
    function bR(t) {
      c("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", t.nodeName.toLowerCase());
    }
    function wR(t) {
      X4(t);
    }
    var Fu = Math.random().toString(36).slice(2), Bu = "__reactFiber$" + Fu, II = "__reactProps$" + Fu, ig = "__reactContainer$" + Fu, pI = "__reactEvents$" + Fu, xR = "__reactListeners$" + Fu, SR = "__reactHandles$" + Fu;
    function ER(t) {
      delete t[Bu], delete t[II], delete t[pI], delete t[xR], delete t[SR];
    }
    function ag(t, r) {
      r[Bu] = t;
    }
    function y9(t, r) {
      r[ig] = t;
    }
    function f8(t) {
      t[ig] = null;
    }
    function og(t) {
      return !!t[ig];
    }
    function Ws(t) {
      var r = t[Bu];
      if (r)
        return r;
      for (var u = t.parentNode; u; ) {
        if (r = u[ig] || u[Bu], r) {
          var f = r.alternate;
          if (r.child !== null || f !== null && f.child !== null)
            for (var C = g8(t); C !== null; ) {
              var p = C[Bu];
              if (p)
                return p;
              C = g8(C);
            }
          return r;
        }
        t = u, u = t.parentNode;
      }
      return null;
    }
    function So(t) {
      var r = t[Bu] || t[ig];
      return r && (r.tag === D || r.tag === k || r.tag === H || r.tag === S) ? r : null;
    }
    function Hu(t) {
      if (t.tag === D || t.tag === k)
        return t.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function b9(t) {
      return t[II] || null;
    }
    function hI(t, r) {
      t[II] = r;
    }
    function MR(t) {
      var r = t[pI];
      return r === void 0 && (r = t[pI] = /* @__PURE__ */ new Set()), r;
    }
    var d8 = {}, C8 = i.ReactDebugCurrentFrame;
    function w9(t) {
      if (t) {
        var r = t._owner, u = Bi(t.type, t._source, r ? r.type : null);
        C8.setExtraStackFrame(u);
      } else
        C8.setExtraStackFrame(null);
    }
    function T0(t, r, u, f, C) {
      {
        var p = Function.call.bind(b1);
        for (var b in t)
          if (p(t, b)) {
            var M = void 0;
            try {
              if (typeof t[b] != "function") {
                var O = Error((f || "React class") + ": " + u + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              M = t[b](r, b, f, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              M = P;
            }
            M && !(M instanceof Error) && (w9(C), c("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", u, b, typeof M), w9(null)), M instanceof Error && !(M.message in d8) && (d8[M.message] = !0, w9(C), c("Failed %s type: %s", u, M.message), w9(null));
          }
      }
    }
    var mI = [], x9;
    x9 = [];
    var Ca = -1;
    function Eo(t) {
      return {
        current: t
      };
    }
    function xr(t, r) {
      if (Ca < 0) {
        c("Unexpected pop.");
        return;
      }
      r !== x9[Ca] && c("Unexpected Fiber popped."), t.current = mI[Ca], mI[Ca] = null, x9[Ca] = null, Ca--;
    }
    function Sr(t, r, u) {
      Ca++, mI[Ca] = t.current, x9[Ca] = u, t.current = r;
    }
    var vI;
    vI = {};
    var E3 = {};
    Object.freeze(E3);
    var Aa = Eo(E3), ci = Eo(!1), yI = E3;
    function Uu(t, r, u) {
      return u && gi(r) ? yI : Aa.current;
    }
    function A8(t, r, u) {
      {
        var f = t.stateNode;
        f.__reactInternalMemoizedUnmaskedChildContext = r, f.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function Wu(t, r) {
      {
        var u = t.type, f = u.contextTypes;
        if (!f)
          return E3;
        var C = t.stateNode;
        if (C && C.__reactInternalMemoizedUnmaskedChildContext === r)
          return C.__reactInternalMemoizedMaskedChildContext;
        var p = {};
        for (var b in f)
          p[b] = r[b];
        {
          var M = Oe(t) || "Unknown";
          T0(f, p, "context", M);
        }
        return C && A8(t, r, p), p;
      }
    }
    function S9() {
      return ci.current;
    }
    function gi(t) {
      {
        var r = t.childContextTypes;
        return r != null;
      }
    }
    function E9(t) {
      xr(ci, t), xr(Aa, t);
    }
    function bI(t) {
      xr(ci, t), xr(Aa, t);
    }
    function I8(t, r, u) {
      {
        if (Aa.current !== E3)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Sr(Aa, r, t), Sr(ci, u, t);
      }
    }
    function p8(t, r, u) {
      {
        var f = t.stateNode, C = r.childContextTypes;
        if (typeof f.getChildContext != "function") {
          {
            var p = Oe(t) || "Unknown";
            vI[p] || (vI[p] = !0, c("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", p, p));
          }
          return u;
        }
        var b = f.getChildContext();
        for (var M in b)
          if (!(M in C))
            throw new Error((Oe(t) || "Unknown") + '.getChildContext(): key "' + M + '" is not defined in childContextTypes.');
        {
          var O = Oe(t) || "Unknown";
          T0(C, b, "child context", O);
        }
        return rt({}, u, b);
      }
    }
    function M9(t) {
      {
        var r = t.stateNode, u = r && r.__reactInternalMemoizedMergedChildContext || E3;
        return yI = Aa.current, Sr(Aa, u, t), Sr(ci, ci.current, t), !0;
      }
    }
    function h8(t, r, u) {
      {
        var f = t.stateNode;
        if (!f)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var C = p8(t, r, yI);
          f.__reactInternalMemoizedMergedChildContext = C, xr(ci, t), xr(Aa, t), Sr(Aa, C, t), Sr(ci, u, t);
        } else
          xr(ci, t), Sr(ci, u, t);
      }
    }
    function TR(t) {
      {
        if (!I4(t) || t.tag !== m)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var r = t;
        do {
          switch (r.tag) {
            case S:
              return r.stateNode.context;
            case m: {
              var u = r.type;
              if (gi(u))
                return r.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          r = r.return;
        } while (r !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Mo = 0, T9 = 1, Ia = null, wI = !1, xI = !1;
    function m8(t) {
      Ia === null ? Ia = [t] : Ia.push(t);
    }
    function LR(t) {
      wI = !0, m8(t);
    }
    function v8() {
      wI && To();
    }
    function To() {
      if (!xI && Ia !== null) {
        xI = !0;
        var t = 0, r = s3();
        try {
          var u = !0, f = Ia;
          for (Sn(kn); t < f.length; t++) {
            var C = f[t];
            do
              C = C(u);
            while (C !== null);
          }
          Ia = null, wI = !1;
        } catch (p) {
          throw Ia !== null && (Ia = Ia.slice(t + 1)), Bl(Ul, To), p;
        } finally {
          Sn(r), xI = !1;
        }
      }
      return null;
    }
    var Vu = [], _u = 0, L9 = null, R9 = 0, Y3 = [], Q3 = 0, Vs = null, pa = 1, ha = "";
    function RR(t) {
      return Js(), (t.flags & d4) !== ze;
    }
    function OR(t) {
      return Js(), R9;
    }
    function DR() {
      var t = ha, r = pa, u = r & ~kR(r);
      return u.toString(32) + t;
    }
    function _s(t, r) {
      Js(), Vu[_u++] = R9, Vu[_u++] = L9, L9 = t, R9 = r;
    }
    function y8(t, r, u) {
      Js(), Y3[Q3++] = pa, Y3[Q3++] = ha, Y3[Q3++] = Vs, Vs = t;
      var f = pa, C = ha, p = O9(f) - 1, b = f & ~(1 << p), M = u + 1, O = O9(r) + p;
      if (O > 30) {
        var P = p - p % 5, F = (1 << P) - 1, e1 = (b & F).toString(32), q = b >> P, l1 = p - P, g1 = O9(r) + l1, A1 = M << l1, oe = A1 | q, Ne = e1 + C;
        pa = 1 << g1 | oe, ha = Ne;
      } else {
        var Le = M << p, At = Le | b, dt = C;
        pa = 1 << O | At, ha = dt;
      }
    }
    function SI(t) {
      Js();
      var r = t.return;
      if (r !== null) {
        var u = 1, f = 0;
        _s(t, u), y8(t, u, f);
      }
    }
    function O9(t) {
      return 32 - $a(t);
    }
    function kR(t) {
      return 1 << O9(t) - 1;
    }
    function EI(t) {
      for (; t === L9; )
        L9 = Vu[--_u], Vu[_u] = null, R9 = Vu[--_u], Vu[_u] = null;
      for (; t === Vs; )
        Vs = Y3[--Q3], Y3[Q3] = null, ha = Y3[--Q3], Y3[Q3] = null, pa = Y3[--Q3], Y3[Q3] = null;
    }
    function jR() {
      return Js(), Vs !== null ? {
        id: pa,
        overflow: ha
      } : null;
    }
    function zR(t, r) {
      Js(), Y3[Q3++] = pa, Y3[Q3++] = ha, Y3[Q3++] = Vs, pa = r.id, ha = r.overflow, Vs = t;
    }
    function Js() {
      G2() || c("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var X2 = null, X3 = null, L0 = !1, Ks = !1, Lo = null;
    function NR() {
      L0 && c("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function b8() {
      Ks = !0;
    }
    function PR() {
      return Ks;
    }
    function FR(t) {
      var r = t.stateNode.containerInfo;
      return X3 = nR(r), X2 = t, L0 = !0, Lo = null, Ks = !1, !0;
    }
    function BR(t, r, u) {
      return X3 = rR(r), X2 = t, L0 = !0, Lo = null, Ks = !1, u !== null && zR(t, u), !0;
    }
    function w8(t, r) {
      switch (t.tag) {
        case S: {
          dR(t.stateNode.containerInfo, r);
          break;
        }
        case D: {
          var u = (t.mode & Te) !== Se;
          AR(
            t.type,
            t.memoizedProps,
            t.stateNode,
            r,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case H: {
          var f = t.memoizedState;
          f.dehydrated !== null && CR(f.dehydrated, r);
          break;
        }
      }
    }
    function x8(t, r) {
      w8(t, r);
      var u = Vk();
      u.stateNode = r, u.return = t;
      var f = t.deletions;
      f === null ? (t.deletions = [u], t.flags |= Mt) : f.push(u);
    }
    function MI(t, r) {
      {
        if (Ks)
          return;
        switch (t.tag) {
          case S: {
            var u = t.stateNode.containerInfo;
            switch (r.tag) {
              case D:
                var f = r.type;
                r.pendingProps, IR(u, f);
                break;
              case k:
                var C = r.pendingProps;
                pR(u, C);
                break;
            }
            break;
          }
          case D: {
            var p = t.type, b = t.memoizedProps, M = t.stateNode;
            switch (r.tag) {
              case D: {
                var O = r.type, P = r.pendingProps, F = (t.mode & Te) !== Se;
                vR(
                  p,
                  b,
                  M,
                  O,
                  P,
                  // TODO: Delete this argument when we remove the legacy root API.
                  F
                );
                break;
              }
              case k: {
                var e1 = r.pendingProps, q = (t.mode & Te) !== Se;
                yR(
                  p,
                  b,
                  M,
                  e1,
                  // TODO: Delete this argument when we remove the legacy root API.
                  q
                );
                break;
              }
            }
            break;
          }
          case H: {
            var l1 = t.memoizedState, g1 = l1.dehydrated;
            if (g1 !== null) switch (r.tag) {
              case D:
                var A1 = r.type;
                r.pendingProps, hR(g1, A1);
                break;
              case k:
                var oe = r.pendingProps;
                mR(g1, oe);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function S8(t, r) {
      r.flags = r.flags & ~t3 | on, MI(t, r);
    }
    function E8(t, r) {
      switch (t.tag) {
        case D: {
          var u = t.type;
          t.pendingProps;
          var f = GL(r, u);
          return f !== null ? (t.stateNode = f, X2 = t, X3 = tR(f), !0) : !1;
        }
        case k: {
          var C = t.pendingProps, p = qL(r, C);
          return p !== null ? (t.stateNode = p, X2 = t, X3 = null, !0) : !1;
        }
        case H: {
          var b = ZL(r);
          if (b !== null) {
            var M = {
              dehydrated: b,
              treeContext: jR(),
              retryLane: H2
            };
            t.memoizedState = M;
            var O = _k(b);
            return O.return = t, t.child = O, X2 = t, X3 = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function TI(t) {
      return (t.mode & Te) !== Se && (t.flags & _e) === ze;
    }
    function LI(t) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function RI(t) {
      if (L0) {
        var r = X3;
        if (!r) {
          TI(t) && (MI(X2, t), LI()), S8(X2, t), L0 = !1, X2 = t;
          return;
        }
        var u = r;
        if (!E8(t, r)) {
          TI(t) && (MI(X2, t), LI()), r = rg(u);
          var f = X2;
          if (!r || !E8(t, r)) {
            S8(X2, t), L0 = !1, X2 = t;
            return;
          }
          x8(f, u);
        }
      }
    }
    function HR(t, r, u) {
      var f = t.stateNode, C = !Ks, p = iR(f, t.type, t.memoizedProps, r, u, t, C);
      return t.updateQueue = p, p !== null;
    }
    function UR(t) {
      var r = t.stateNode, u = t.memoizedProps, f = aR(r, u, t);
      if (f) {
        var C = X2;
        if (C !== null)
          switch (C.tag) {
            case S: {
              var p = C.stateNode.containerInfo, b = (C.mode & Te) !== Se;
              gR(
                p,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                b
              );
              break;
            }
            case D: {
              var M = C.type, O = C.memoizedProps, P = C.stateNode, F = (C.mode & Te) !== Se;
              fR(
                M,
                O,
                P,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                F
              );
              break;
            }
          }
      }
      return f;
    }
    function WR(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      oR(u, t);
    }
    function VR(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return sR(u);
    }
    function M8(t) {
      for (var r = t.return; r !== null && r.tag !== D && r.tag !== S && r.tag !== H; )
        r = r.return;
      X2 = r;
    }
    function D9(t) {
      if (t !== X2)
        return !1;
      if (!L0)
        return M8(t), L0 = !0, !1;
      if (t.tag !== S && (t.tag !== D || cR(t.type) && !gI(t.type, t.memoizedProps))) {
        var r = X3;
        if (r)
          if (TI(t))
            T8(t), LI();
          else
            for (; r; )
              x8(t, r), r = rg(r);
      }
      return M8(t), t.tag === H ? X3 = VR(t) : X3 = X2 ? rg(t.stateNode) : null, !0;
    }
    function _R() {
      return L0 && X3 !== null;
    }
    function T8(t) {
      for (var r = X3; r; )
        w8(t, r), r = rg(r);
    }
    function Ju() {
      X2 = null, X3 = null, L0 = !1, Ks = !1;
    }
    function L8() {
      Lo !== null && (by(Lo), Lo = null);
    }
    function G2() {
      return L0;
    }
    function OI(t) {
      Lo === null ? Lo = [t] : Lo.push(t);
    }
    var JR = i.ReactCurrentBatchConfig, KR = null;
    function YR() {
      return JR.transition;
    }
    var R0 = {
      recordUnsafeLifecycleWarnings: function(t, r) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(t, r) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var QR = function(t) {
        for (var r = null, u = t; u !== null; )
          u.mode & lt && (r = u), u = u.return;
        return r;
      }, Ys = function(t) {
        var r = [];
        return t.forEach(function(u) {
          r.push(u);
        }), r.sort().join(", ");
      }, sg = [], lg = [], ug = [], cg = [], gg = [], fg = [], Qs = /* @__PURE__ */ new Set();
      R0.recordUnsafeLifecycleWarnings = function(t, r) {
        Qs.has(t.type) || (typeof r.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        r.componentWillMount.__suppressDeprecationWarning !== !0 && sg.push(t), t.mode & lt && typeof r.UNSAFE_componentWillMount == "function" && lg.push(t), typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && ug.push(t), t.mode & lt && typeof r.UNSAFE_componentWillReceiveProps == "function" && cg.push(t), typeof r.componentWillUpdate == "function" && r.componentWillUpdate.__suppressDeprecationWarning !== !0 && gg.push(t), t.mode & lt && typeof r.UNSAFE_componentWillUpdate == "function" && fg.push(t));
      }, R0.flushPendingUnsafeLifecycleWarnings = function() {
        var t = /* @__PURE__ */ new Set();
        sg.length > 0 && (sg.forEach(function(q) {
          t.add(Oe(q) || "Component"), Qs.add(q.type);
        }), sg = []);
        var r = /* @__PURE__ */ new Set();
        lg.length > 0 && (lg.forEach(function(q) {
          r.add(Oe(q) || "Component"), Qs.add(q.type);
        }), lg = []);
        var u = /* @__PURE__ */ new Set();
        ug.length > 0 && (ug.forEach(function(q) {
          u.add(Oe(q) || "Component"), Qs.add(q.type);
        }), ug = []);
        var f = /* @__PURE__ */ new Set();
        cg.length > 0 && (cg.forEach(function(q) {
          f.add(Oe(q) || "Component"), Qs.add(q.type);
        }), cg = []);
        var C = /* @__PURE__ */ new Set();
        gg.length > 0 && (gg.forEach(function(q) {
          C.add(Oe(q) || "Component"), Qs.add(q.type);
        }), gg = []);
        var p = /* @__PURE__ */ new Set();
        if (fg.length > 0 && (fg.forEach(function(q) {
          p.add(Oe(q) || "Component"), Qs.add(q.type);
        }), fg = []), r.size > 0) {
          var b = Ys(r);
          c(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, b);
        }
        if (f.size > 0) {
          var M = Ys(f);
          c(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, M);
        }
        if (p.size > 0) {
          var O = Ys(p);
          c(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, O);
        }
        if (t.size > 0) {
          var P = Ys(t);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, P);
        }
        if (u.size > 0) {
          var F = Ys(u);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, F);
        }
        if (C.size > 0) {
          var e1 = Ys(C);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, e1);
        }
      };
      var k9 = /* @__PURE__ */ new Map(), R8 = /* @__PURE__ */ new Set();
      R0.recordLegacyContextWarning = function(t, r) {
        var u = QR(t);
        if (u === null) {
          c("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!R8.has(t.type)) {
          var f = k9.get(u);
          (t.type.contextTypes != null || t.type.childContextTypes != null || r !== null && typeof r.getChildContext == "function") && (f === void 0 && (f = [], k9.set(u, f)), f.push(t));
        }
      }, R0.flushLegacyContextWarning = function() {
        k9.forEach(function(t, r) {
          if (t.length !== 0) {
            var u = t[0], f = /* @__PURE__ */ new Set();
            t.forEach(function(p) {
              f.add(Oe(p) || "Component"), R8.add(p.type);
            });
            var C = Ys(f);
            try {
              Dt(u), c(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, C);
            } finally {
              On();
            }
          }
        });
      }, R0.discardPendingWarnings = function() {
        sg = [], lg = [], ug = [], cg = [], gg = [], fg = [], k9 = /* @__PURE__ */ new Map();
      };
    }
    var DI, kI, jI, zI, NI, O8 = function(t, r) {
    };
    DI = !1, kI = !1, jI = {}, zI = {}, NI = {}, O8 = function(t, r) {
      if (!(t === null || typeof t != "object") && !(!t._store || t._store.validated || t.key != null)) {
        if (typeof t._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        t._store.validated = !0;
        var u = Oe(r) || "Component";
        zI[u] || (zI[u] = !0, c('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function XR(t) {
      return t.prototype && t.prototype.isReactComponent;
    }
    function dg(t, r, u) {
      var f = u.ref;
      if (f !== null && typeof f != "function" && typeof f != "object") {
        if ((t.mode & lt || K1) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self) && // Will already throw with "Function components cannot have string refs"
        !(u._owner && u._owner.tag !== m) && // Will already warn with "Function components cannot be given refs"
        !(typeof u.type == "function" && !XR(u.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        u._owner) {
          var C = Oe(t) || "Component";
          jI[C] || (c('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', C, f), jI[C] = !0);
        }
        if (u._owner) {
          var p = u._owner, b;
          if (p) {
            var M = p;
            if (M.tag !== m)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            b = M.stateNode;
          }
          if (!b)
            throw new Error("Missing owner for string ref " + f + ". This error is likely caused by a bug in React. Please file an issue.");
          var O = b;
          St(f, "ref");
          var P = "" + f;
          if (r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === P)
            return r.ref;
          var F = function(e1) {
            var q = O.refs;
            e1 === null ? delete q[P] : q[P] = e1;
          };
          return F._stringRef = P, F;
        } else {
          if (typeof f != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + f + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return f;
    }
    function j9(t, r) {
      var u = Object.prototype.toString.call(r);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function z9(t) {
      {
        var r = Oe(t) || "Component";
        if (NI[r])
          return;
        NI[r] = !0, c("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function D8(t) {
      var r = t._payload, u = t._init;
      return u(r);
    }
    function k8(t) {
      function r(i1, I1) {
        if (t) {
          var a1 = i1.deletions;
          a1 === null ? (i1.deletions = [I1], i1.flags |= Mt) : a1.push(I1);
        }
      }
      function u(i1, I1) {
        if (!t)
          return null;
        for (var a1 = I1; a1 !== null; )
          r(i1, a1), a1 = a1.sibling;
        return null;
      }
      function f(i1, I1) {
        for (var a1 = /* @__PURE__ */ new Map(), N1 = I1; N1 !== null; )
          N1.key !== null ? a1.set(N1.key, N1) : a1.set(N1.index, N1), N1 = N1.sibling;
        return a1;
      }
      function C(i1, I1) {
        var a1 = rl(i1, I1);
        return a1.index = 0, a1.sibling = null, a1;
      }
      function p(i1, I1, a1) {
        if (i1.index = a1, !t)
          return i1.flags |= d4, I1;
        var N1 = i1.alternate;
        if (N1 !== null) {
          var de = N1.index;
          return de < I1 ? (i1.flags |= on, I1) : de;
        } else
          return i1.flags |= on, I1;
      }
      function b(i1) {
        return t && i1.alternate === null && (i1.flags |= on), i1;
      }
      function M(i1, I1, a1, N1) {
        if (I1 === null || I1.tag !== k) {
          var de = Op(a1, i1.mode, N1);
          return de.return = i1, de;
        } else {
          var ce = C(I1, a1);
          return ce.return = i1, ce;
        }
      }
      function O(i1, I1, a1, N1) {
        var de = a1.type;
        if (de === z2)
          return F(i1, I1, a1.props.children, N1, a1.key);
        if (I1 !== null && (I1.elementType === de || // Keep this check inline so it only runs on the false path:
        Fy(I1, a1) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof de == "object" && de !== null && de.$$typeof === je && D8(de) === I1.type)) {
          var ce = C(I1, a1.props);
          return ce.ref = dg(i1, I1, a1), ce.return = i1, ce._debugSource = a1._source, ce._debugOwner = a1._owner, ce;
        }
        var Ve = Rp(a1, i1.mode, N1);
        return Ve.ref = dg(i1, I1, a1), Ve.return = i1, Ve;
      }
      function P(i1, I1, a1, N1) {
        if (I1 === null || I1.tag !== T || I1.stateNode.containerInfo !== a1.containerInfo || I1.stateNode.implementation !== a1.implementation) {
          var de = Dp(a1, i1.mode, N1);
          return de.return = i1, de;
        } else {
          var ce = C(I1, a1.children || []);
          return ce.return = i1, ce;
        }
      }
      function F(i1, I1, a1, N1, de) {
        if (I1 === null || I1.tag !== z) {
          var ce = Ho(a1, i1.mode, N1, de);
          return ce.return = i1, ce;
        } else {
          var Ve = C(I1, a1);
          return Ve.return = i1, Ve;
        }
      }
      function e1(i1, I1, a1) {
        if (typeof I1 == "string" && I1 !== "" || typeof I1 == "number") {
          var N1 = Op("" + I1, i1.mode, a1);
          return N1.return = i1, N1;
        }
        if (typeof I1 == "object" && I1 !== null) {
          switch (I1.$$typeof) {
            case Qr: {
              var de = Rp(I1, i1.mode, a1);
              return de.ref = dg(i1, null, I1), de.return = i1, de;
            }
            case j2: {
              var ce = Dp(I1, i1.mode, a1);
              return ce.return = i1, ce;
            }
            case je: {
              var Ve = I1._payload, Ge = I1._init;
              return e1(i1, Ge(Ve), a1);
            }
          }
          if (c2(I1) || _2(I1)) {
            var _t = Ho(I1, i1.mode, a1, null);
            return _t.return = i1, _t;
          }
          j9(i1, I1);
        }
        return typeof I1 == "function" && z9(i1), null;
      }
      function q(i1, I1, a1, N1) {
        var de = I1 !== null ? I1.key : null;
        if (typeof a1 == "string" && a1 !== "" || typeof a1 == "number")
          return de !== null ? null : M(i1, I1, "" + a1, N1);
        if (typeof a1 == "object" && a1 !== null) {
          switch (a1.$$typeof) {
            case Qr:
              return a1.key === de ? O(i1, I1, a1, N1) : null;
            case j2:
              return a1.key === de ? P(i1, I1, a1, N1) : null;
            case je: {
              var ce = a1._payload, Ve = a1._init;
              return q(i1, I1, Ve(ce), N1);
            }
          }
          if (c2(a1) || _2(a1))
            return de !== null ? null : F(i1, I1, a1, N1, null);
          j9(i1, a1);
        }
        return typeof a1 == "function" && z9(i1), null;
      }
      function l1(i1, I1, a1, N1, de) {
        if (typeof N1 == "string" && N1 !== "" || typeof N1 == "number") {
          var ce = i1.get(a1) || null;
          return M(I1, ce, "" + N1, de);
        }
        if (typeof N1 == "object" && N1 !== null) {
          switch (N1.$$typeof) {
            case Qr: {
              var Ve = i1.get(N1.key === null ? a1 : N1.key) || null;
              return O(I1, Ve, N1, de);
            }
            case j2: {
              var Ge = i1.get(N1.key === null ? a1 : N1.key) || null;
              return P(I1, Ge, N1, de);
            }
            case je:
              var _t = N1._payload, wt = N1._init;
              return l1(i1, I1, a1, wt(_t), de);
          }
          if (c2(N1) || _2(N1)) {
            var n2 = i1.get(a1) || null;
            return F(I1, n2, N1, de, null);
          }
          j9(I1, N1);
        }
        return typeof N1 == "function" && z9(I1), null;
      }
      function g1(i1, I1, a1) {
        {
          if (typeof i1 != "object" || i1 === null)
            return I1;
          switch (i1.$$typeof) {
            case Qr:
            case j2:
              O8(i1, a1);
              var N1 = i1.key;
              if (typeof N1 != "string")
                break;
              if (I1 === null) {
                I1 = /* @__PURE__ */ new Set(), I1.add(N1);
                break;
              }
              if (!I1.has(N1)) {
                I1.add(N1);
                break;
              }
              c("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", N1);
              break;
            case je:
              var de = i1._payload, ce = i1._init;
              g1(ce(de), I1, a1);
              break;
          }
        }
        return I1;
      }
      function A1(i1, I1, a1, N1) {
        for (var de = null, ce = 0; ce < a1.length; ce++) {
          var Ve = a1[ce];
          de = g1(Ve, de, i1);
        }
        for (var Ge = null, _t = null, wt = I1, n2 = 0, xt = 0, Vn = null; wt !== null && xt < a1.length; xt++) {
          wt.index > xt ? (Vn = wt, wt = null) : Vn = wt.sibling;
          var Mr = q(i1, wt, a1[xt], N1);
          if (Mr === null) {
            wt === null && (wt = Vn);
            break;
          }
          t && wt && Mr.alternate === null && r(i1, wt), n2 = p(Mr, n2, xt), _t === null ? Ge = Mr : _t.sibling = Mr, _t = Mr, wt = Vn;
        }
        if (xt === a1.length) {
          if (u(i1, wt), G2()) {
            var rr = xt;
            _s(i1, rr);
          }
          return Ge;
        }
        if (wt === null) {
          for (; xt < a1.length; xt++) {
            var T3 = e1(i1, a1[xt], N1);
            T3 !== null && (n2 = p(T3, n2, xt), _t === null ? Ge = T3 : _t.sibling = T3, _t = T3);
          }
          if (G2()) {
            var Jr = xt;
            _s(i1, Jr);
          }
          return Ge;
        }
        for (var Kr = f(i1, wt); xt < a1.length; xt++) {
          var Tr = l1(Kr, i1, xt, a1[xt], N1);
          Tr !== null && (t && Tr.alternate !== null && Kr.delete(Tr.key === null ? xt : Tr.key), n2 = p(Tr, n2, xt), _t === null ? Ge = Tr : _t.sibling = Tr, _t = Tr);
        }
        if (t && Kr.forEach(function(cc) {
          return r(i1, cc);
        }), G2()) {
          var Sa = xt;
          _s(i1, Sa);
        }
        return Ge;
      }
      function oe(i1, I1, a1, N1) {
        var de = _2(a1);
        if (typeof de != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          a1[Symbol.toStringTag] === "Generator" && (kI || c("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), kI = !0), a1.entries === de && (DI || c("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), DI = !0);
          var ce = de.call(a1);
          if (ce)
            for (var Ve = null, Ge = ce.next(); !Ge.done; Ge = ce.next()) {
              var _t = Ge.value;
              Ve = g1(_t, Ve, i1);
            }
        }
        var wt = de.call(a1);
        if (wt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var n2 = null, xt = null, Vn = I1, Mr = 0, rr = 0, T3 = null, Jr = wt.next(); Vn !== null && !Jr.done; rr++, Jr = wt.next()) {
          Vn.index > rr ? (T3 = Vn, Vn = null) : T3 = Vn.sibling;
          var Kr = q(i1, Vn, Jr.value, N1);
          if (Kr === null) {
            Vn === null && (Vn = T3);
            break;
          }
          t && Vn && Kr.alternate === null && r(i1, Vn), Mr = p(Kr, Mr, rr), xt === null ? n2 = Kr : xt.sibling = Kr, xt = Kr, Vn = T3;
        }
        if (Jr.done) {
          if (u(i1, Vn), G2()) {
            var Tr = rr;
            _s(i1, Tr);
          }
          return n2;
        }
        if (Vn === null) {
          for (; !Jr.done; rr++, Jr = wt.next()) {
            var Sa = e1(i1, Jr.value, N1);
            Sa !== null && (Mr = p(Sa, Mr, rr), xt === null ? n2 = Sa : xt.sibling = Sa, xt = Sa);
          }
          if (G2()) {
            var cc = rr;
            _s(i1, cc);
          }
          return n2;
        }
        for (var Jg = f(i1, Vn); !Jr.done; rr++, Jr = wt.next()) {
          var mi = l1(Jg, i1, rr, Jr.value, N1);
          mi !== null && (t && mi.alternate !== null && Jg.delete(mi.key === null ? rr : mi.key), Mr = p(mi, Mr, rr), xt === null ? n2 = mi : xt.sibling = mi, xt = mi);
        }
        if (t && Jg.forEach(function(yj) {
          return r(i1, yj);
        }), G2()) {
          var vj = rr;
          _s(i1, vj);
        }
        return n2;
      }
      function Ne(i1, I1, a1, N1) {
        if (I1 !== null && I1.tag === k) {
          u(i1, I1.sibling);
          var de = C(I1, a1);
          return de.return = i1, de;
        }
        u(i1, I1);
        var ce = Op(a1, i1.mode, N1);
        return ce.return = i1, ce;
      }
      function Le(i1, I1, a1, N1) {
        for (var de = a1.key, ce = I1; ce !== null; ) {
          if (ce.key === de) {
            var Ve = a1.type;
            if (Ve === z2) {
              if (ce.tag === z) {
                u(i1, ce.sibling);
                var Ge = C(ce, a1.props.children);
                return Ge.return = i1, Ge._debugSource = a1._source, Ge._debugOwner = a1._owner, Ge;
              }
            } else if (ce.elementType === Ve || // Keep this check inline so it only runs on the false path:
            Fy(ce, a1) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Ve == "object" && Ve !== null && Ve.$$typeof === je && D8(Ve) === ce.type) {
              u(i1, ce.sibling);
              var _t = C(ce, a1.props);
              return _t.ref = dg(i1, ce, a1), _t.return = i1, _t._debugSource = a1._source, _t._debugOwner = a1._owner, _t;
            }
            u(i1, ce);
            break;
          } else
            r(i1, ce);
          ce = ce.sibling;
        }
        if (a1.type === z2) {
          var wt = Ho(a1.props.children, i1.mode, N1, a1.key);
          return wt.return = i1, wt;
        } else {
          var n2 = Rp(a1, i1.mode, N1);
          return n2.ref = dg(i1, I1, a1), n2.return = i1, n2;
        }
      }
      function At(i1, I1, a1, N1) {
        for (var de = a1.key, ce = I1; ce !== null; ) {
          if (ce.key === de)
            if (ce.tag === T && ce.stateNode.containerInfo === a1.containerInfo && ce.stateNode.implementation === a1.implementation) {
              u(i1, ce.sibling);
              var Ve = C(ce, a1.children || []);
              return Ve.return = i1, Ve;
            } else {
              u(i1, ce);
              break;
            }
          else
            r(i1, ce);
          ce = ce.sibling;
        }
        var Ge = Dp(a1, i1.mode, N1);
        return Ge.return = i1, Ge;
      }
      function dt(i1, I1, a1, N1) {
        var de = typeof a1 == "object" && a1 !== null && a1.type === z2 && a1.key === null;
        if (de && (a1 = a1.props.children), typeof a1 == "object" && a1 !== null) {
          switch (a1.$$typeof) {
            case Qr:
              return b(Le(i1, I1, a1, N1));
            case j2:
              return b(At(i1, I1, a1, N1));
            case je:
              var ce = a1._payload, Ve = a1._init;
              return dt(i1, I1, Ve(ce), N1);
          }
          if (c2(a1))
            return A1(i1, I1, a1, N1);
          if (_2(a1))
            return oe(i1, I1, a1, N1);
          j9(i1, a1);
        }
        return typeof a1 == "string" && a1 !== "" || typeof a1 == "number" ? b(Ne(i1, I1, "" + a1, N1)) : (typeof a1 == "function" && z9(i1), u(i1, I1));
      }
      return dt;
    }
    var Ku = k8(!0), j8 = k8(!1);
    function GR(t, r) {
      if (t !== null && r.child !== t.child)
        throw new Error("Resuming work not yet implemented.");
      if (r.child !== null) {
        var u = r.child, f = rl(u, u.pendingProps);
        for (r.child = f, f.return = r; u.sibling !== null; )
          u = u.sibling, f = f.sibling = rl(u, u.pendingProps), f.return = r;
        f.sibling = null;
      }
    }
    function qR(t, r) {
      for (var u = t.child; u !== null; )
        Fk(u, r), u = u.sibling;
    }
    var PI = Eo(null), FI;
    FI = {};
    var N9 = null, Yu = null, BI = null, P9 = !1;
    function F9() {
      N9 = null, Yu = null, BI = null, P9 = !1;
    }
    function z8() {
      P9 = !0;
    }
    function N8() {
      P9 = !1;
    }
    function P8(t, r, u) {
      Sr(PI, r._currentValue, t), r._currentValue = u, r._currentRenderer !== void 0 && r._currentRenderer !== null && r._currentRenderer !== FI && c("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), r._currentRenderer = FI;
    }
    function HI(t, r) {
      var u = PI.current;
      xr(PI, r), t._currentValue = u;
    }
    function UI(t, r, u) {
      for (var f = t; f !== null; ) {
        var C = f.alternate;
        if (oa(f.childLanes, r) ? C !== null && !oa(C.childLanes, r) && (C.childLanes = qe(C.childLanes, r)) : (f.childLanes = qe(f.childLanes, r), C !== null && (C.childLanes = qe(C.childLanes, r))), f === u)
          break;
        f = f.return;
      }
      f !== u && c("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ZR(t, r, u) {
      $R(t, r, u);
    }
    function $R(t, r, u) {
      var f = t.child;
      for (f !== null && (f.return = t); f !== null; ) {
        var C = void 0, p = f.dependencies;
        if (p !== null) {
          C = f.child;
          for (var b = p.firstContext; b !== null; ) {
            if (b.context === r) {
              if (f.tag === m) {
                var M = oo(u), O = ma(an, M);
                O.tag = H9;
                var P = f.updateQueue;
                if (P !== null) {
                  var F = P.shared, e1 = F.pending;
                  e1 === null ? O.next = O : (O.next = e1.next, e1.next = O), F.pending = O;
                }
              }
              f.lanes = qe(f.lanes, u);
              var q = f.alternate;
              q !== null && (q.lanes = qe(q.lanes, u)), UI(f.return, u, t), p.lanes = qe(p.lanes, u);
              break;
            }
            b = b.next;
          }
        } else if (f.tag === K)
          C = f.type === t.type ? null : f.child;
        else if (f.tag === O1) {
          var l1 = f.return;
          if (l1 === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          l1.lanes = qe(l1.lanes, u);
          var g1 = l1.alternate;
          g1 !== null && (g1.lanes = qe(g1.lanes, u)), UI(l1, u, t), C = f.sibling;
        } else
          C = f.child;
        if (C !== null)
          C.return = f;
        else
          for (C = f; C !== null; ) {
            if (C === t) {
              C = null;
              break;
            }
            var A1 = C.sibling;
            if (A1 !== null) {
              A1.return = C.return, C = A1;
              break;
            }
            C = C.return;
          }
        f = C;
      }
    }
    function Qu(t, r) {
      N9 = t, Yu = null, BI = null;
      var u = t.dependencies;
      if (u !== null) {
        var f = u.firstContext;
        f !== null && (br(u.lanes, r) && Tg(), u.firstContext = null);
      }
    }
    function I2(t) {
      P9 && c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var r = t._currentValue;
      if (BI !== t) {
        var u = {
          context: t,
          memoizedValue: r,
          next: null
        };
        if (Yu === null) {
          if (N9 === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Yu = u, N9.dependencies = {
            lanes: w1,
            firstContext: u
          };
        } else
          Yu = Yu.next = u;
      }
      return r;
    }
    var Xs = null;
    function WI(t) {
      Xs === null ? Xs = [t] : Xs.push(t);
    }
    function eO() {
      if (Xs !== null) {
        for (var t = 0; t < Xs.length; t++) {
          var r = Xs[t], u = r.interleaved;
          if (u !== null) {
            r.interleaved = null;
            var f = u.next, C = r.pending;
            if (C !== null) {
              var p = C.next;
              C.next = f, u.next = p;
            }
            r.pending = u;
          }
        }
        Xs = null;
      }
    }
    function F8(t, r, u, f) {
      var C = r.interleaved;
      return C === null ? (u.next = u, WI(r)) : (u.next = C.next, C.next = u), r.interleaved = u, B9(t, f);
    }
    function tO(t, r, u, f) {
      var C = r.interleaved;
      C === null ? (u.next = u, WI(r)) : (u.next = C.next, C.next = u), r.interleaved = u;
    }
    function nO(t, r, u, f) {
      var C = r.interleaved;
      return C === null ? (u.next = u, WI(r)) : (u.next = C.next, C.next = u), r.interleaved = u, B9(t, f);
    }
    function d3(t, r) {
      return B9(t, r);
    }
    var rO = B9;
    function B9(t, r) {
      t.lanes = qe(t.lanes, r);
      var u = t.alternate;
      u !== null && (u.lanes = qe(u.lanes, r)), u === null && (t.flags & (on | t3)) !== ze && jy(t);
      for (var f = t, C = t.return; C !== null; )
        C.childLanes = qe(C.childLanes, r), u = C.alternate, u !== null ? u.childLanes = qe(u.childLanes, r) : (C.flags & (on | t3)) !== ze && jy(t), f = C, C = C.return;
      if (f.tag === S) {
        var p = f.stateNode;
        return p;
      } else
        return null;
    }
    var B8 = 0, H8 = 1, H9 = 2, VI = 3, U9 = !1, _I, W9;
    _I = !1, W9 = null;
    function JI(t) {
      var r = {
        baseState: t.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: w1
        },
        effects: null
      };
      t.updateQueue = r;
    }
    function U8(t, r) {
      var u = r.updateQueue, f = t.updateQueue;
      if (u === f) {
        var C = {
          baseState: f.baseState,
          firstBaseUpdate: f.firstBaseUpdate,
          lastBaseUpdate: f.lastBaseUpdate,
          shared: f.shared,
          effects: f.effects
        };
        r.updateQueue = C;
      }
    }
    function ma(t, r) {
      var u = {
        eventTime: t,
        lane: r,
        tag: B8,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function Ro(t, r, u) {
      var f = t.updateQueue;
      if (f === null)
        return null;
      var C = f.shared;
      if (W9 === C && !_I && (c("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), _I = !0), tk()) {
        var p = C.pending;
        return p === null ? r.next = r : (r.next = p.next, p.next = r), C.pending = r, rO(t, u);
      } else
        return nO(t, C, r, u);
    }
    function V9(t, r, u) {
      var f = r.updateQueue;
      if (f !== null) {
        var C = f.shared;
        if (T4(u)) {
          var p = C.lanes;
          p = gu(p, t.pendingLanes);
          var b = qe(p, u);
          C.lanes = b, L4(t, b);
        }
      }
    }
    function KI(t, r) {
      var u = t.updateQueue, f = t.alternate;
      if (f !== null) {
        var C = f.updateQueue;
        if (u === C) {
          var p = null, b = null, M = u.firstBaseUpdate;
          if (M !== null) {
            var O = M;
            do {
              var P = {
                eventTime: O.eventTime,
                lane: O.lane,
                tag: O.tag,
                payload: O.payload,
                callback: O.callback,
                next: null
              };
              b === null ? p = b = P : (b.next = P, b = P), O = O.next;
            } while (O !== null);
            b === null ? p = b = r : (b.next = r, b = r);
          } else
            p = b = r;
          u = {
            baseState: C.baseState,
            firstBaseUpdate: p,
            lastBaseUpdate: b,
            shared: C.shared,
            effects: C.effects
          }, t.updateQueue = u;
          return;
        }
      }
      var F = u.lastBaseUpdate;
      F === null ? u.firstBaseUpdate = r : F.next = r, u.lastBaseUpdate = r;
    }
    function iO(t, r, u, f, C, p) {
      switch (u.tag) {
        case H8: {
          var b = u.payload;
          if (typeof b == "function") {
            z8();
            var M = b.call(p, f, C);
            {
              if (t.mode & lt) {
                Un(!0);
                try {
                  b.call(p, f, C);
                } finally {
                  Un(!1);
                }
              }
              N8();
            }
            return M;
          }
          return b;
        }
        case VI:
          t.flags = t.flags & ~f2 | _e;
        case B8: {
          var O = u.payload, P;
          if (typeof O == "function") {
            z8(), P = O.call(p, f, C);
            {
              if (t.mode & lt) {
                Un(!0);
                try {
                  O.call(p, f, C);
                } finally {
                  Un(!1);
                }
              }
              N8();
            }
          } else
            P = O;
          return P == null ? f : rt({}, f, P);
        }
        case H9:
          return U9 = !0, f;
      }
      return f;
    }
    function _9(t, r, u, f) {
      var C = t.updateQueue;
      U9 = !1, W9 = C.shared;
      var p = C.firstBaseUpdate, b = C.lastBaseUpdate, M = C.shared.pending;
      if (M !== null) {
        C.shared.pending = null;
        var O = M, P = O.next;
        O.next = null, b === null ? p = P : b.next = P, b = O;
        var F = t.alternate;
        if (F !== null) {
          var e1 = F.updateQueue, q = e1.lastBaseUpdate;
          q !== b && (q === null ? e1.firstBaseUpdate = P : q.next = P, e1.lastBaseUpdate = O);
        }
      }
      if (p !== null) {
        var l1 = C.baseState, g1 = w1, A1 = null, oe = null, Ne = null, Le = p;
        do {
          var At = Le.lane, dt = Le.eventTime;
          if (oa(f, At)) {
            if (Ne !== null) {
              var I1 = {
                eventTime: dt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Wn,
                tag: Le.tag,
                payload: Le.payload,
                callback: Le.callback,
                next: null
              };
              Ne = Ne.next = I1;
            }
            l1 = iO(t, C, Le, l1, r, u);
            var a1 = Le.callback;
            if (a1 !== null && // If the update was already committed, we should not queue its
            // callback again.
            Le.lane !== Wn) {
              t.flags |= U3;
              var N1 = C.effects;
              N1 === null ? C.effects = [Le] : N1.push(Le);
            }
          } else {
            var i1 = {
              eventTime: dt,
              lane: At,
              tag: Le.tag,
              payload: Le.payload,
              callback: Le.callback,
              next: null
            };
            Ne === null ? (oe = Ne = i1, A1 = l1) : Ne = Ne.next = i1, g1 = qe(g1, At);
          }
          if (Le = Le.next, Le === null) {
            if (M = C.shared.pending, M === null)
              break;
            var de = M, ce = de.next;
            de.next = null, Le = ce, C.lastBaseUpdate = de, C.shared.pending = null;
          }
        } while (!0);
        Ne === null && (A1 = l1), C.baseState = A1, C.firstBaseUpdate = oe, C.lastBaseUpdate = Ne;
        var Ve = C.shared.interleaved;
        if (Ve !== null) {
          var Ge = Ve;
          do
            g1 = qe(g1, Ge.lane), Ge = Ge.next;
          while (Ge !== Ve);
        } else p === null && (C.shared.lanes = w1);
        Hg(g1), t.lanes = g1, t.memoizedState = l1;
      }
      W9 = null;
    }
    function aO(t, r) {
      if (typeof t != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + t));
      t.call(r);
    }
    function W8() {
      U9 = !1;
    }
    function J9() {
      return U9;
    }
    function V8(t, r, u) {
      var f = r.effects;
      if (r.effects = null, f !== null)
        for (var C = 0; C < f.length; C++) {
          var p = f[C], b = p.callback;
          b !== null && (p.callback = null, aO(b, u));
        }
    }
    var Cg = {}, Oo = Eo(Cg), Ag = Eo(Cg), K9 = Eo(Cg);
    function Y9(t) {
      if (t === Cg)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return t;
    }
    function _8() {
      var t = Y9(K9.current);
      return t;
    }
    function YI(t, r) {
      Sr(K9, r, t), Sr(Ag, t, t), Sr(Oo, Cg, t);
      var u = bL(r);
      xr(Oo, t), Sr(Oo, u, t);
    }
    function Xu(t) {
      xr(Oo, t), xr(Ag, t), xr(K9, t);
    }
    function QI() {
      var t = Y9(Oo.current);
      return t;
    }
    function J8(t) {
      Y9(K9.current);
      var r = Y9(Oo.current), u = wL(r, t.type);
      r !== u && (Sr(Ag, t, t), Sr(Oo, u, t));
    }
    function XI(t) {
      Ag.current === t && (xr(Oo, t), xr(Ag, t));
    }
    var oO = 0, K8 = 1, Y8 = 1, Ig = 2, O0 = Eo(oO);
    function GI(t, r) {
      return (t & r) !== 0;
    }
    function Gu(t) {
      return t & K8;
    }
    function qI(t, r) {
      return t & K8 | r;
    }
    function sO(t, r) {
      return t | r;
    }
    function Do(t, r) {
      Sr(O0, r, t);
    }
    function qu(t) {
      xr(O0, t);
    }
    function lO(t, r) {
      var u = t.memoizedState;
      return u !== null ? u.dehydrated !== null : (t.memoizedProps, !0);
    }
    function Q9(t) {
      for (var r = t; r !== null; ) {
        if (r.tag === H) {
          var u = r.memoizedState;
          if (u !== null) {
            var f = u.dehydrated;
            if (f === null || c8(f) || AI(f))
              return r;
          }
        } else if (r.tag === T1 && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        r.memoizedProps.revealOrder !== void 0) {
          var C = (r.flags & _e) !== ze;
          if (C)
            return r;
        } else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === t)
          return null;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return null;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return null;
    }
    var C3 = (
      /*   */
      0
    ), S2 = (
      /* */
      1
    ), fi = (
      /*  */
      2
    ), E2 = (
      /*    */
      4
    ), q2 = (
      /*   */
      8
    ), ZI = [];
    function $I() {
      for (var t = 0; t < ZI.length; t++) {
        var r = ZI[t];
        r._workInProgressVersionPrimary = null;
      }
      ZI.length = 0;
    }
    function uO(t, r) {
      var u = r._getVersion, f = u(r._source);
      t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [r, f] : t.mutableSourceEagerHydrationData.push(r, f);
    }
    var fe = i.ReactCurrentDispatcher, pg = i.ReactCurrentBatchConfig, e5, Zu;
    e5 = /* @__PURE__ */ new Set();
    var Gs = w1, Vt = null, M2 = null, T2 = null, X9 = !1, hg = !1, mg = 0, cO = 0, gO = 25, v1 = null, G3 = null, ko = -1, t5 = !1;
    function jt() {
      {
        var t = v1;
        G3 === null ? G3 = [t] : G3.push(t);
      }
    }
    function Z1() {
      {
        var t = v1;
        G3 !== null && (ko++, G3[ko] !== t && fO(t));
      }
    }
    function $u(t) {
      t != null && !c2(t) && c("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", v1, typeof t);
    }
    function fO(t) {
      {
        var r = Oe(Vt);
        if (!e5.has(r) && (e5.add(r), G3 !== null)) {
          for (var u = "", f = 30, C = 0; C <= ko; C++) {
            for (var p = G3[C], b = C === ko ? t : p, M = C + 1 + ". " + p; M.length < f; )
              M += " ";
            M += b + `
`, u += M;
          }
          c(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, r, u);
        }
      }
    }
    function Er() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function n5(t, r) {
      if (t5)
        return !1;
      if (r === null)
        return c("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", v1), !1;
      t.length !== r.length && c(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, v1, "[" + r.join(", ") + "]", "[" + t.join(", ") + "]");
      for (var u = 0; u < r.length && u < t.length; u++)
        if (!ve(t[u], r[u]))
          return !1;
      return !0;
    }
    function ec(t, r, u, f, C, p) {
      Gs = p, Vt = r, G3 = t !== null ? t._debugHookTypes : null, ko = -1, t5 = t !== null && t.type !== r.type, r.memoizedState = null, r.updateQueue = null, r.lanes = w1, t !== null && t.memoizedState !== null ? fe.current = Av : G3 !== null ? fe.current = Cv : fe.current = dv;
      var b = u(f, C);
      if (hg) {
        var M = 0;
        do {
          if (hg = !1, mg = 0, M >= gO)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          M += 1, t5 = !1, M2 = null, T2 = null, r.updateQueue = null, ko = -1, fe.current = Iv, b = u(f, C);
        } while (hg);
      }
      fe.current = lC, r._debugHookTypes = G3;
      var O = M2 !== null && M2.next !== null;
      if (Gs = w1, Vt = null, M2 = null, T2 = null, v1 = null, G3 = null, ko = -1, t !== null && (t.flags & b2) !== (r.flags & b2) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (t.mode & Te) !== Se && c("Internal React error: Expected static flag was missing. Please notify the React team."), X9 = !1, O)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return b;
    }
    function tc() {
      var t = mg !== 0;
      return mg = 0, t;
    }
    function Q8(t, r, u) {
      r.updateQueue = t.updateQueue, (r.mode & Hr) !== Se ? r.flags &= ~(qi | Ir | fn | Ze) : r.flags &= ~(fn | Ze), t.lanes = Ms(t.lanes, u);
    }
    function X8() {
      if (fe.current = lC, X9) {
        for (var t = Vt.memoizedState; t !== null; ) {
          var r = t.queue;
          r !== null && (r.pending = null), t = t.next;
        }
        X9 = !1;
      }
      Gs = w1, Vt = null, M2 = null, T2 = null, G3 = null, ko = -1, v1 = null, lv = !1, hg = !1, mg = 0;
    }
    function di() {
      var t = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return T2 === null ? Vt.memoizedState = T2 = t : T2 = T2.next = t, T2;
    }
    function q3() {
      var t;
      if (M2 === null) {
        var r = Vt.alternate;
        r !== null ? t = r.memoizedState : t = null;
      } else
        t = M2.next;
      var u;
      if (T2 === null ? u = Vt.memoizedState : u = T2.next, u !== null)
        T2 = u, u = T2.next, M2 = t;
      else {
        if (t === null)
          throw new Error("Rendered more hooks than during the previous render.");
        M2 = t;
        var f = {
          memoizedState: M2.memoizedState,
          baseState: M2.baseState,
          baseQueue: M2.baseQueue,
          queue: M2.queue,
          next: null
        };
        T2 === null ? Vt.memoizedState = T2 = f : T2 = T2.next = f;
      }
      return T2;
    }
    function G8() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function r5(t, r) {
      return typeof r == "function" ? r(t) : r;
    }
    function i5(t, r, u) {
      var f = di(), C;
      u !== void 0 ? C = u(r) : C = r, f.memoizedState = f.baseState = C;
      var p = {
        pending: null,
        interleaved: null,
        lanes: w1,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: C
      };
      f.queue = p;
      var b = p.dispatch = IO.bind(null, Vt, p);
      return [f.memoizedState, b];
    }
    function a5(t, r, u) {
      var f = q3(), C = f.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = t;
      var p = M2, b = p.baseQueue, M = C.pending;
      if (M !== null) {
        if (b !== null) {
          var O = b.next, P = M.next;
          b.next = P, M.next = O;
        }
        p.baseQueue !== b && c("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), p.baseQueue = b = M, C.pending = null;
      }
      if (b !== null) {
        var F = b.next, e1 = p.baseState, q = null, l1 = null, g1 = null, A1 = F;
        do {
          var oe = A1.lane;
          if (oa(Gs, oe)) {
            if (g1 !== null) {
              var Le = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Wn,
                action: A1.action,
                hasEagerState: A1.hasEagerState,
                eagerState: A1.eagerState,
                next: null
              };
              g1 = g1.next = Le;
            }
            if (A1.hasEagerState)
              e1 = A1.eagerState;
            else {
              var At = A1.action;
              e1 = t(e1, At);
            }
          } else {
            var Ne = {
              lane: oe,
              action: A1.action,
              hasEagerState: A1.hasEagerState,
              eagerState: A1.eagerState,
              next: null
            };
            g1 === null ? (l1 = g1 = Ne, q = e1) : g1 = g1.next = Ne, Vt.lanes = qe(Vt.lanes, oe), Hg(oe);
          }
          A1 = A1.next;
        } while (A1 !== null && A1 !== F);
        g1 === null ? q = e1 : g1.next = l1, ve(e1, f.memoizedState) || Tg(), f.memoizedState = e1, f.baseState = q, f.baseQueue = g1, C.lastRenderedState = e1;
      }
      var dt = C.interleaved;
      if (dt !== null) {
        var i1 = dt;
        do {
          var I1 = i1.lane;
          Vt.lanes = qe(Vt.lanes, I1), Hg(I1), i1 = i1.next;
        } while (i1 !== dt);
      } else b === null && (C.lanes = w1);
      var a1 = C.dispatch;
      return [f.memoizedState, a1];
    }
    function o5(t, r, u) {
      var f = q3(), C = f.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = t;
      var p = C.dispatch, b = C.pending, M = f.memoizedState;
      if (b !== null) {
        C.pending = null;
        var O = b.next, P = O;
        do {
          var F = P.action;
          M = t(M, F), P = P.next;
        } while (P !== O);
        ve(M, f.memoizedState) || Tg(), f.memoizedState = M, f.baseQueue === null && (f.baseState = M), C.lastRenderedState = M;
      }
      return [M, p];
    }
    function P11(t, r, u) {
    }
    function F11(t, r, u) {
    }
    function s5(t, r, u) {
      var f = Vt, C = di(), p, b = G2();
      if (b) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        p = u(), Zu || p !== u() && (c("The result of getServerSnapshot should be cached to avoid an infinite loop"), Zu = !0);
      } else {
        if (p = r(), !Zu) {
          var M = r();
          ve(p, M) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), Zu = !0);
        }
        var O = MC();
        if (O === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Es(O, Gs) || q8(f, r, p);
      }
      C.memoizedState = p;
      var P = {
        value: p,
        getSnapshot: r
      };
      return C.queue = P, eC($8.bind(null, f, P, t), [t]), f.flags |= fn, vg(S2 | q2, Z8.bind(null, f, P, p, r), void 0, null), p;
    }
    function G9(t, r, u) {
      var f = Vt, C = q3(), p = r();
      if (!Zu) {
        var b = r();
        ve(p, b) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), Zu = !0);
      }
      var M = C.memoizedState, O = !ve(M, p);
      O && (C.memoizedState = p, Tg());
      var P = C.queue;
      if (bg($8.bind(null, f, P, t), [t]), P.getSnapshot !== r || O || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      T2 !== null && T2.memoizedState.tag & S2) {
        f.flags |= fn, vg(S2 | q2, Z8.bind(null, f, P, p, r), void 0, null);
        var F = MC();
        if (F === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Es(F, Gs) || q8(f, r, p);
      }
      return p;
    }
    function q8(t, r, u) {
      t.flags |= Is;
      var f = {
        getSnapshot: r,
        value: u
      }, C = Vt.updateQueue;
      if (C === null)
        C = G8(), Vt.updateQueue = C, C.stores = [f];
      else {
        var p = C.stores;
        p === null ? C.stores = [f] : p.push(f);
      }
    }
    function Z8(t, r, u, f) {
      r.value = u, r.getSnapshot = f, ev(r) && tv(t);
    }
    function $8(t, r, u) {
      var f = function() {
        ev(r) && tv(t);
      };
      return u(f);
    }
    function ev(t) {
      var r = t.getSnapshot, u = t.value;
      try {
        var f = r();
        return !ve(u, f);
      } catch {
        return !0;
      }
    }
    function tv(t) {
      var r = d3(t, Re);
      r !== null && D2(r, t, Re, an);
    }
    function q9(t) {
      var r = di();
      typeof t == "function" && (t = t()), r.memoizedState = r.baseState = t;
      var u = {
        pending: null,
        interleaved: null,
        lanes: w1,
        dispatch: null,
        lastRenderedReducer: r5,
        lastRenderedState: t
      };
      r.queue = u;
      var f = u.dispatch = pO.bind(null, Vt, u);
      return [r.memoizedState, f];
    }
    function l5(t) {
      return a5(r5);
    }
    function u5(t) {
      return o5(r5);
    }
    function vg(t, r, u, f) {
      var C = {
        tag: t,
        create: r,
        destroy: u,
        deps: f,
        // Circular
        next: null
      }, p = Vt.updateQueue;
      if (p === null)
        p = G8(), Vt.updateQueue = p, p.lastEffect = C.next = C;
      else {
        var b = p.lastEffect;
        if (b === null)
          p.lastEffect = C.next = C;
        else {
          var M = b.next;
          b.next = C, C.next = M, p.lastEffect = C;
        }
      }
      return C;
    }
    function c5(t) {
      var r = di();
      {
        var u = {
          current: t
        };
        return r.memoizedState = u, u;
      }
    }
    function Z9(t) {
      var r = q3();
      return r.memoizedState;
    }
    function yg(t, r, u, f) {
      var C = di(), p = f === void 0 ? null : f;
      Vt.flags |= t, C.memoizedState = vg(S2 | r, u, void 0, p);
    }
    function $9(t, r, u, f) {
      var C = q3(), p = f === void 0 ? null : f, b = void 0;
      if (M2 !== null) {
        var M = M2.memoizedState;
        if (b = M.destroy, p !== null) {
          var O = M.deps;
          if (n5(p, O)) {
            C.memoizedState = vg(r, u, b, p);
            return;
          }
        }
      }
      Vt.flags |= t, C.memoizedState = vg(S2 | r, u, b, p);
    }
    function eC(t, r) {
      return (Vt.mode & Hr) !== Se ? yg(qi | fn | ei, q2, t, r) : yg(fn | ei, q2, t, r);
    }
    function bg(t, r) {
      return $9(fn, q2, t, r);
    }
    function g5(t, r) {
      return yg(Ze, fi, t, r);
    }
    function tC(t, r) {
      return $9(Ze, fi, t, r);
    }
    function f5(t, r) {
      var u = Ze;
      return u |= Ar, (Vt.mode & Hr) !== Se && (u |= Ir), yg(u, E2, t, r);
    }
    function nC(t, r) {
      return $9(Ze, E2, t, r);
    }
    function nv(t, r) {
      if (typeof r == "function") {
        var u = r, f = t();
        return u(f), function() {
          u(null);
        };
      } else if (r != null) {
        var C = r;
        C.hasOwnProperty("current") || c("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(C).join(", ") + "}");
        var p = t();
        return C.current = p, function() {
          C.current = null;
        };
      }
    }
    function d5(t, r, u) {
      typeof r != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var f = u != null ? u.concat([t]) : null, C = Ze;
      return C |= Ar, (Vt.mode & Hr) !== Se && (C |= Ir), yg(C, E2, nv.bind(null, r, t), f);
    }
    function rC(t, r, u) {
      typeof r != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var f = u != null ? u.concat([t]) : null;
      return $9(Ze, E2, nv.bind(null, r, t), f);
    }
    function dO(t, r) {
    }
    var iC = dO;
    function C5(t, r) {
      var u = di(), f = r === void 0 ? null : r;
      return u.memoizedState = [t, f], t;
    }
    function aC(t, r) {
      var u = q3(), f = r === void 0 ? null : r, C = u.memoizedState;
      if (C !== null && f !== null) {
        var p = C[1];
        if (n5(f, p))
          return C[0];
      }
      return u.memoizedState = [t, f], t;
    }
    function A5(t, r) {
      var u = di(), f = r === void 0 ? null : r, C = t();
      return u.memoizedState = [C, f], C;
    }
    function oC(t, r) {
      var u = q3(), f = r === void 0 ? null : r, C = u.memoizedState;
      if (C !== null && f !== null) {
        var p = C[1];
        if (n5(f, p))
          return C[0];
      }
      var b = t();
      return u.memoizedState = [b, f], b;
    }
    function I5(t) {
      var r = di();
      return r.memoizedState = t, t;
    }
    function rv(t) {
      var r = q3(), u = M2, f = u.memoizedState;
      return av(r, f, t);
    }
    function iv(t) {
      var r = q3();
      if (M2 === null)
        return r.memoizedState = t, t;
      var u = M2.memoizedState;
      return av(r, u, t);
    }
    function av(t, r, u) {
      var f = !Nd(Gs);
      if (f) {
        if (!ve(u, r)) {
          var C = Bd();
          Vt.lanes = qe(Vt.lanes, C), Hg(C), t.baseState = !0;
        }
        return r;
      } else
        return t.baseState && (t.baseState = !1, Tg()), t.memoizedState = u, u;
    }
    function CO(t, r, u) {
      var f = s3();
      Sn(N6(f, x0)), t(!0);
      var C = pg.transition;
      pg.transition = {};
      var p = pg.transition;
      pg.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        t(!1), r();
      } finally {
        if (Sn(f), pg.transition = C, C === null && p._updatedFibers) {
          var b = p._updatedFibers.size;
          b > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), p._updatedFibers.clear();
        }
      }
    }
    function p5() {
      var t = q9(!1), r = t[0], u = t[1], f = CO.bind(null, u), C = di();
      return C.memoizedState = f, [r, f];
    }
    function ov() {
      var t = l5(), r = t[0], u = q3(), f = u.memoizedState;
      return [r, f];
    }
    function sv() {
      var t = u5(), r = t[0], u = q3(), f = u.memoizedState;
      return [r, f];
    }
    var lv = !1;
    function AO() {
      return lv;
    }
    function h5() {
      var t = di(), r = MC(), u = r.identifierPrefix, f;
      if (G2()) {
        var C = DR();
        f = ":" + u + "R" + C;
        var p = mg++;
        p > 0 && (f += "H" + p.toString(32)), f += ":";
      } else {
        var b = cO++;
        f = ":" + u + "r" + b.toString(32) + ":";
      }
      return t.memoizedState = f, f;
    }
    function sC() {
      var t = q3(), r = t.memoizedState;
      return r;
    }
    function IO(t, r, u) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = Fo(t), C = {
        lane: f,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uv(t))
        cv(r, C);
      else {
        var p = F8(t, r, C, f);
        if (p !== null) {
          var b = _r();
          D2(p, t, f, b), gv(p, r, f);
        }
      }
      fv(t, f);
    }
    function pO(t, r, u) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = Fo(t), C = {
        lane: f,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uv(t))
        cv(r, C);
      else {
        var p = t.alternate;
        if (t.lanes === w1 && (p === null || p.lanes === w1)) {
          var b = r.lastRenderedReducer;
          if (b !== null) {
            var M;
            M = fe.current, fe.current = D0;
            try {
              var O = r.lastRenderedState, P = b(O, u);
              if (C.hasEagerState = !0, C.eagerState = P, ve(P, O)) {
                tO(t, r, C, f);
                return;
              }
            } catch {
            } finally {
              fe.current = M;
            }
          }
        }
        var F = F8(t, r, C, f);
        if (F !== null) {
          var e1 = _r();
          D2(F, t, f, e1), gv(F, r, f);
        }
      }
      fv(t, f);
    }
    function uv(t) {
      var r = t.alternate;
      return t === Vt || r !== null && r === Vt;
    }
    function cv(t, r) {
      hg = X9 = !0;
      var u = t.pending;
      u === null ? r.next = r : (r.next = u.next, u.next = r), t.pending = r;
    }
    function gv(t, r, u) {
      if (T4(u)) {
        var f = r.lanes;
        f = gu(f, t.pendingLanes);
        var C = qe(f, u);
        r.lanes = C, L4(t, C);
      }
    }
    function fv(t, r, u) {
      vs(t, r);
    }
    var lC = {
      readContext: I2,
      useCallback: Er,
      useContext: Er,
      useEffect: Er,
      useImperativeHandle: Er,
      useInsertionEffect: Er,
      useLayoutEffect: Er,
      useMemo: Er,
      useReducer: Er,
      useRef: Er,
      useState: Er,
      useDebugValue: Er,
      useDeferredValue: Er,
      useTransition: Er,
      useMutableSource: Er,
      useSyncExternalStore: Er,
      useId: Er,
      unstable_isNewReconciler: f1
    }, dv = null, Cv = null, Av = null, Iv = null, Ci = null, D0 = null, uC = null;
    {
      var m5 = function() {
        c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Qe = function() {
        c("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      dv = {
        readContext: function(t) {
          return I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", jt(), $u(r), C5(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", jt(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", jt(), $u(r), eC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", jt(), $u(u), d5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", jt(), $u(r), g5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", jt(), $u(r), f5(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", jt(), $u(r);
          var u = fe.current;
          fe.current = Ci;
          try {
            return A5(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", jt();
          var f = fe.current;
          fe.current = Ci;
          try {
            return i5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", jt(), c5(t);
        },
        useState: function(t) {
          v1 = "useState", jt();
          var r = fe.current;
          fe.current = Ci;
          try {
            return q9(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", jt(), void 0;
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", jt(), I5(t);
        },
        useTransition: function() {
          return v1 = "useTransition", jt(), p5();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", jt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", jt(), s5(t, r, u);
        },
        useId: function() {
          return v1 = "useId", jt(), h5();
        },
        unstable_isNewReconciler: f1
      }, Cv = {
        readContext: function(t) {
          return I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Z1(), C5(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Z1(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Z1(), eC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Z1(), d5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Z1(), g5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Z1(), f5(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Z1();
          var u = fe.current;
          fe.current = Ci;
          try {
            return A5(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Z1();
          var f = fe.current;
          fe.current = Ci;
          try {
            return i5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Z1(), c5(t);
        },
        useState: function(t) {
          v1 = "useState", Z1();
          var r = fe.current;
          fe.current = Ci;
          try {
            return q9(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Z1(), void 0;
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Z1(), I5(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Z1(), p5();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Z1(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Z1(), s5(t, r, u);
        },
        useId: function() {
          return v1 = "useId", Z1(), h5();
        },
        unstable_isNewReconciler: f1
      }, Av = {
        readContext: function(t) {
          return I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Z1(), aC(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Z1(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Z1(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Z1(), rC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Z1(), tC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Z1(), nC(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Z1();
          var u = fe.current;
          fe.current = D0;
          try {
            return oC(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Z1();
          var f = fe.current;
          fe.current = D0;
          try {
            return a5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Z1(), Z9();
        },
        useState: function(t) {
          v1 = "useState", Z1();
          var r = fe.current;
          fe.current = D0;
          try {
            return l5(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Z1(), iC();
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Z1(), rv(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Z1(), ov();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Z1(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Z1(), G9(t, r);
        },
        useId: function() {
          return v1 = "useId", Z1(), sC();
        },
        unstable_isNewReconciler: f1
      }, Iv = {
        readContext: function(t) {
          return I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Z1(), aC(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Z1(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Z1(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Z1(), rC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Z1(), tC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Z1(), nC(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Z1();
          var u = fe.current;
          fe.current = uC;
          try {
            return oC(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Z1();
          var f = fe.current;
          fe.current = uC;
          try {
            return o5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Z1(), Z9();
        },
        useState: function(t) {
          v1 = "useState", Z1();
          var r = fe.current;
          fe.current = uC;
          try {
            return u5(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Z1(), iC();
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Z1(), iv(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Z1(), sv();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Z1(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Z1(), G9(t, r);
        },
        useId: function() {
          return v1 = "useId", Z1(), sC();
        },
        unstable_isNewReconciler: f1
      }, Ci = {
        readContext: function(t) {
          return m5(), I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Qe(), jt(), C5(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Qe(), jt(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Qe(), jt(), eC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Qe(), jt(), d5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Qe(), jt(), g5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Qe(), jt(), f5(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Qe(), jt();
          var u = fe.current;
          fe.current = Ci;
          try {
            return A5(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Qe(), jt();
          var f = fe.current;
          fe.current = Ci;
          try {
            return i5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Qe(), jt(), c5(t);
        },
        useState: function(t) {
          v1 = "useState", Qe(), jt();
          var r = fe.current;
          fe.current = Ci;
          try {
            return q9(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Qe(), jt(), void 0;
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Qe(), jt(), I5(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Qe(), jt(), p5();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Qe(), jt(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Qe(), jt(), s5(t, r, u);
        },
        useId: function() {
          return v1 = "useId", Qe(), jt(), h5();
        },
        unstable_isNewReconciler: f1
      }, D0 = {
        readContext: function(t) {
          return m5(), I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Qe(), Z1(), aC(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Qe(), Z1(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Qe(), Z1(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Qe(), Z1(), rC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Qe(), Z1(), tC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Qe(), Z1(), nC(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Qe(), Z1();
          var u = fe.current;
          fe.current = D0;
          try {
            return oC(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Qe(), Z1();
          var f = fe.current;
          fe.current = D0;
          try {
            return a5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Qe(), Z1(), Z9();
        },
        useState: function(t) {
          v1 = "useState", Qe(), Z1();
          var r = fe.current;
          fe.current = D0;
          try {
            return l5(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Qe(), Z1(), iC();
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Qe(), Z1(), rv(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Qe(), Z1(), ov();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Qe(), Z1(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Qe(), Z1(), G9(t, r);
        },
        useId: function() {
          return v1 = "useId", Qe(), Z1(), sC();
        },
        unstable_isNewReconciler: f1
      }, uC = {
        readContext: function(t) {
          return m5(), I2(t);
        },
        useCallback: function(t, r) {
          return v1 = "useCallback", Qe(), Z1(), aC(t, r);
        },
        useContext: function(t) {
          return v1 = "useContext", Qe(), Z1(), I2(t);
        },
        useEffect: function(t, r) {
          return v1 = "useEffect", Qe(), Z1(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return v1 = "useImperativeHandle", Qe(), Z1(), rC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return v1 = "useInsertionEffect", Qe(), Z1(), tC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return v1 = "useLayoutEffect", Qe(), Z1(), nC(t, r);
        },
        useMemo: function(t, r) {
          v1 = "useMemo", Qe(), Z1();
          var u = fe.current;
          fe.current = D0;
          try {
            return oC(t, r);
          } finally {
            fe.current = u;
          }
        },
        useReducer: function(t, r, u) {
          v1 = "useReducer", Qe(), Z1();
          var f = fe.current;
          fe.current = D0;
          try {
            return o5(t, r, u);
          } finally {
            fe.current = f;
          }
        },
        useRef: function(t) {
          return v1 = "useRef", Qe(), Z1(), Z9();
        },
        useState: function(t) {
          v1 = "useState", Qe(), Z1();
          var r = fe.current;
          fe.current = D0;
          try {
            return u5(t);
          } finally {
            fe.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return v1 = "useDebugValue", Qe(), Z1(), iC();
        },
        useDeferredValue: function(t) {
          return v1 = "useDeferredValue", Qe(), Z1(), iv(t);
        },
        useTransition: function() {
          return v1 = "useTransition", Qe(), Z1(), sv();
        },
        useMutableSource: function(t, r, u) {
          return v1 = "useMutableSource", Qe(), Z1(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return v1 = "useSyncExternalStore", Qe(), Z1(), G9(t, r);
        },
        useId: function() {
          return v1 = "useId", Qe(), Z1(), sC();
        },
        unstable_isNewReconciler: f1
      };
    }
    var jo = n.unstable_now, pv = 0, cC = -1, wg = -1, gC = -1, v5 = !1, fC = !1;
    function hv() {
      return v5;
    }
    function hO() {
      fC = !0;
    }
    function mO() {
      v5 = !1, fC = !1;
    }
    function vO() {
      v5 = fC, fC = !1;
    }
    function mv() {
      return pv;
    }
    function vv() {
      pv = jo();
    }
    function y5(t) {
      wg = jo(), t.actualStartTime < 0 && (t.actualStartTime = jo());
    }
    function yv(t) {
      wg = -1;
    }
    function dC(t, r) {
      if (wg >= 0) {
        var u = jo() - wg;
        t.actualDuration += u, r && (t.selfBaseDuration = u), wg = -1;
      }
    }
    function Ai(t) {
      if (cC >= 0) {
        var r = jo() - cC;
        cC = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case S:
              var f = u.stateNode;
              f.effectDuration += r;
              return;
            case Y:
              var C = u.stateNode;
              C.effectDuration += r;
              return;
          }
          u = u.return;
        }
      }
    }
    function b5(t) {
      if (gC >= 0) {
        var r = jo() - gC;
        gC = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case S:
              var f = u.stateNode;
              f !== null && (f.passiveEffectDuration += r);
              return;
            case Y:
              var C = u.stateNode;
              C !== null && (C.passiveEffectDuration += r);
              return;
          }
          u = u.return;
        }
      }
    }
    function Ii() {
      cC = jo();
    }
    function w5() {
      gC = jo();
    }
    function x5(t) {
      for (var r = t.child; r; )
        t.actualDuration += r.actualDuration, r = r.sibling;
    }
    function k0(t, r) {
      if (t && t.defaultProps) {
        var u = rt({}, r), f = t.defaultProps;
        for (var C in f)
          u[C] === void 0 && (u[C] = f[C]);
        return u;
      }
      return r;
    }
    var S5 = {}, E5, M5, T5, L5, R5, bv, CC, O5, D5, k5, xg;
    {
      E5 = /* @__PURE__ */ new Set(), M5 = /* @__PURE__ */ new Set(), T5 = /* @__PURE__ */ new Set(), L5 = /* @__PURE__ */ new Set(), O5 = /* @__PURE__ */ new Set(), R5 = /* @__PURE__ */ new Set(), D5 = /* @__PURE__ */ new Set(), k5 = /* @__PURE__ */ new Set(), xg = /* @__PURE__ */ new Set();
      var wv = /* @__PURE__ */ new Set();
      CC = function(t, r) {
        if (!(t === null || typeof t == "function")) {
          var u = r + "_" + t;
          wv.has(u) || (wv.add(u), c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t));
        }
      }, bv = function(t, r) {
        if (r === void 0) {
          var u = yt(t) || "Component";
          R5.has(u) || (R5.add(u), c("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(S5, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(S5);
    }
    function j5(t, r, u, f) {
      var C = t.memoizedState, p = u(f, C);
      {
        if (t.mode & lt) {
          Un(!0);
          try {
            p = u(f, C);
          } finally {
            Un(!1);
          }
        }
        bv(r, p);
      }
      var b = p == null ? C : rt({}, C, p);
      if (t.memoizedState = b, t.lanes === w1) {
        var M = t.updateQueue;
        M.baseState = b;
      }
    }
    var z5 = {
      isMounted: Fr,
      enqueueSetState: function(t, r, u) {
        var f = $r(t), C = _r(), p = Fo(f), b = ma(C, p);
        b.payload = r, u != null && (CC(u, "setState"), b.callback = u);
        var M = Ro(f, b, p);
        M !== null && (D2(M, f, p, C), V9(M, f, p)), vs(f, p);
      },
      enqueueReplaceState: function(t, r, u) {
        var f = $r(t), C = _r(), p = Fo(f), b = ma(C, p);
        b.tag = H8, b.payload = r, u != null && (CC(u, "replaceState"), b.callback = u);
        var M = Ro(f, b, p);
        M !== null && (D2(M, f, p, C), V9(M, f, p)), vs(f, p);
      },
      enqueueForceUpdate: function(t, r) {
        var u = $r(t), f = _r(), C = Fo(u), p = ma(f, C);
        p.tag = H9, r != null && (CC(r, "forceUpdate"), p.callback = r);
        var b = Ro(u, p, C);
        b !== null && (D2(b, u, C, f), V9(b, u, C)), Ql(u, C);
      }
    };
    function xv(t, r, u, f, C, p, b) {
      var M = t.stateNode;
      if (typeof M.shouldComponentUpdate == "function") {
        var O = M.shouldComponentUpdate(f, p, b);
        {
          if (t.mode & lt) {
            Un(!0);
            try {
              O = M.shouldComponentUpdate(f, p, b);
            } finally {
              Un(!1);
            }
          }
          O === void 0 && c("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", yt(r) || "Component");
        }
        return O;
      }
      return r.prototype && r.prototype.isPureReactComponent ? !Ue(u, f) || !Ue(C, p) : !0;
    }
    function yO(t, r, u) {
      var f = t.stateNode;
      {
        var C = yt(r) || "Component", p = f.render;
        p || (r.prototype && typeof r.prototype.render == "function" ? c("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : c("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), f.getInitialState && !f.getInitialState.isReactClassApproved && !f.state && c("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), f.getDefaultProps && !f.getDefaultProps.isReactClassApproved && c("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), f.propTypes && c("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), f.contextType && c("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), r.childContextTypes && !xg.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & lt) === Se && (xg.add(r), c(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, C)), r.contextTypes && !xg.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & lt) === Se && (xg.add(r), c(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, C)), f.contextTypes && c("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), r.contextType && r.contextTypes && !D5.has(r) && (D5.add(r), c("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof f.componentShouldUpdate == "function" && c("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), r.prototype && r.prototype.isPureReactComponent && typeof f.shouldComponentUpdate < "u" && c("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", yt(r) || "A pure component"), typeof f.componentDidUnmount == "function" && c("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof f.componentDidReceiveProps == "function" && c("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof f.componentWillRecieveProps == "function" && c("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof f.UNSAFE_componentWillRecieveProps == "function" && c("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var b = f.props !== u;
        f.props !== void 0 && b && c("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), f.defaultProps && c("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof f.getSnapshotBeforeUpdate == "function" && typeof f.componentDidUpdate != "function" && !T5.has(r) && (T5.add(r), c("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", yt(r))), typeof f.getDerivedStateFromProps == "function" && c("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof f.getDerivedStateFromError == "function" && c("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof r.getSnapshotBeforeUpdate == "function" && c("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var M = f.state;
        M && (typeof M != "object" || c2(M)) && c("%s.state: must be set to an object or null", C), typeof f.getChildContext == "function" && typeof r.childContextTypes != "object" && c("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function Sv(t, r) {
      r.updater = z5, t.stateNode = r, Ka(r, t), r._reactInternalInstance = S5;
    }
    function Ev(t, r, u) {
      var f = !1, C = E3, p = E3, b = r.contextType;
      if ("contextType" in r) {
        var M = (
          // Allow null for conditional declaration
          b === null || b !== void 0 && b.$$typeof === S1 && b._context === void 0
        );
        if (!M && !k5.has(r)) {
          k5.add(r);
          var O = "";
          b === void 0 ? O = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof b != "object" ? O = " However, it is set to a " + typeof b + "." : b.$$typeof === J ? O = " Did you accidentally pass the Context.Provider instead?" : b._context !== void 0 ? O = " Did you accidentally pass the Context.Consumer instead?" : O = " However, it is set to an object with keys {" + Object.keys(b).join(", ") + "}.", c("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", yt(r) || "Component", O);
        }
      }
      if (typeof b == "object" && b !== null)
        p = I2(b);
      else {
        C = Uu(t, r, !0);
        var P = r.contextTypes;
        f = P != null, p = f ? Wu(t, C) : E3;
      }
      var F = new r(u, p);
      if (t.mode & lt) {
        Un(!0);
        try {
          F = new r(u, p);
        } finally {
          Un(!1);
        }
      }
      var e1 = t.memoizedState = F.state !== null && F.state !== void 0 ? F.state : null;
      Sv(t, F);
      {
        if (typeof r.getDerivedStateFromProps == "function" && e1 === null) {
          var q = yt(r) || "Component";
          M5.has(q) || (M5.add(q), c("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", q, F.state === null ? "null" : "undefined", q));
        }
        if (typeof r.getDerivedStateFromProps == "function" || typeof F.getSnapshotBeforeUpdate == "function") {
          var l1 = null, g1 = null, A1 = null;
          if (typeof F.componentWillMount == "function" && F.componentWillMount.__suppressDeprecationWarning !== !0 ? l1 = "componentWillMount" : typeof F.UNSAFE_componentWillMount == "function" && (l1 = "UNSAFE_componentWillMount"), typeof F.componentWillReceiveProps == "function" && F.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? g1 = "componentWillReceiveProps" : typeof F.UNSAFE_componentWillReceiveProps == "function" && (g1 = "UNSAFE_componentWillReceiveProps"), typeof F.componentWillUpdate == "function" && F.componentWillUpdate.__suppressDeprecationWarning !== !0 ? A1 = "componentWillUpdate" : typeof F.UNSAFE_componentWillUpdate == "function" && (A1 = "UNSAFE_componentWillUpdate"), l1 !== null || g1 !== null || A1 !== null) {
            var oe = yt(r) || "Component", Ne = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            L5.has(oe) || (L5.add(oe), c(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, oe, Ne, l1 !== null ? `
  ` + l1 : "", g1 !== null ? `
  ` + g1 : "", A1 !== null ? `
  ` + A1 : ""));
          }
        }
      }
      return f && A8(t, C, p), F;
    }
    function bO(t, r) {
      var u = r.state;
      typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), u !== r.state && (c("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Oe(t) || "Component"), z5.enqueueReplaceState(r, r.state, null));
    }
    function Mv(t, r, u, f) {
      var C = r.state;
      if (typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, f), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, f), r.state !== C) {
        {
          var p = Oe(t) || "Component";
          E5.has(p) || (E5.add(p), c("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", p));
        }
        z5.enqueueReplaceState(r, r.state, null);
      }
    }
    function N5(t, r, u, f) {
      yO(t, r, u);
      var C = t.stateNode;
      C.props = u, C.state = t.memoizedState, C.refs = {}, JI(t);
      var p = r.contextType;
      if (typeof p == "object" && p !== null)
        C.context = I2(p);
      else {
        var b = Uu(t, r, !0);
        C.context = Wu(t, b);
      }
      {
        if (C.state === u) {
          var M = yt(r) || "Component";
          O5.has(M) || (O5.add(M), c("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", M));
        }
        t.mode & lt && R0.recordLegacyContextWarning(t, C), R0.recordUnsafeLifecycleWarnings(t, C);
      }
      C.state = t.memoizedState;
      var O = r.getDerivedStateFromProps;
      if (typeof O == "function" && (j5(t, r, O, u), C.state = t.memoizedState), typeof r.getDerivedStateFromProps != "function" && typeof C.getSnapshotBeforeUpdate != "function" && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (bO(t, C), _9(t, u, C, f), C.state = t.memoizedState), typeof C.componentDidMount == "function") {
        var P = Ze;
        P |= Ar, (t.mode & Hr) !== Se && (P |= Ir), t.flags |= P;
      }
    }
    function wO(t, r, u, f) {
      var C = t.stateNode, p = t.memoizedProps;
      C.props = p;
      var b = C.context, M = r.contextType, O = E3;
      if (typeof M == "object" && M !== null)
        O = I2(M);
      else {
        var P = Uu(t, r, !0);
        O = Wu(t, P);
      }
      var F = r.getDerivedStateFromProps, e1 = typeof F == "function" || typeof C.getSnapshotBeforeUpdate == "function";
      !e1 && (typeof C.UNSAFE_componentWillReceiveProps == "function" || typeof C.componentWillReceiveProps == "function") && (p !== u || b !== O) && Mv(t, C, u, O), W8();
      var q = t.memoizedState, l1 = C.state = q;
      if (_9(t, u, C, f), l1 = t.memoizedState, p === u && q === l1 && !S9() && !J9()) {
        if (typeof C.componentDidMount == "function") {
          var g1 = Ze;
          g1 |= Ar, (t.mode & Hr) !== Se && (g1 |= Ir), t.flags |= g1;
        }
        return !1;
      }
      typeof F == "function" && (j5(t, r, F, u), l1 = t.memoizedState);
      var A1 = J9() || xv(t, r, p, u, q, l1, O);
      if (A1) {
        if (!e1 && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function") {
          var oe = Ze;
          oe |= Ar, (t.mode & Hr) !== Se && (oe |= Ir), t.flags |= oe;
        }
      } else {
        if (typeof C.componentDidMount == "function") {
          var Ne = Ze;
          Ne |= Ar, (t.mode & Hr) !== Se && (Ne |= Ir), t.flags |= Ne;
        }
        t.memoizedProps = u, t.memoizedState = l1;
      }
      return C.props = u, C.state = l1, C.context = O, A1;
    }
    function xO(t, r, u, f, C) {
      var p = r.stateNode;
      U8(t, r);
      var b = r.memoizedProps, M = r.type === r.elementType ? b : k0(r.type, b);
      p.props = M;
      var O = r.pendingProps, P = p.context, F = u.contextType, e1 = E3;
      if (typeof F == "object" && F !== null)
        e1 = I2(F);
      else {
        var q = Uu(r, u, !0);
        e1 = Wu(r, q);
      }
      var l1 = u.getDerivedStateFromProps, g1 = typeof l1 == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !g1 && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (b !== O || P !== e1) && Mv(r, p, f, e1), W8();
      var A1 = r.memoizedState, oe = p.state = A1;
      if (_9(r, f, p, C), oe = r.memoizedState, b === O && A1 === oe && !S9() && !J9() && !B1)
        return typeof p.componentDidUpdate == "function" && (b !== t.memoizedProps || A1 !== t.memoizedState) && (r.flags |= Ze), typeof p.getSnapshotBeforeUpdate == "function" && (b !== t.memoizedProps || A1 !== t.memoizedState) && (r.flags |= e3), !1;
      typeof l1 == "function" && (j5(r, u, l1, f), oe = r.memoizedState);
      var Ne = J9() || xv(r, u, M, f, A1, oe, e1) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      B1;
      return Ne ? (!g1 && (typeof p.UNSAFE_componentWillUpdate == "function" || typeof p.componentWillUpdate == "function") && (typeof p.componentWillUpdate == "function" && p.componentWillUpdate(f, oe, e1), typeof p.UNSAFE_componentWillUpdate == "function" && p.UNSAFE_componentWillUpdate(f, oe, e1)), typeof p.componentDidUpdate == "function" && (r.flags |= Ze), typeof p.getSnapshotBeforeUpdate == "function" && (r.flags |= e3)) : (typeof p.componentDidUpdate == "function" && (b !== t.memoizedProps || A1 !== t.memoizedState) && (r.flags |= Ze), typeof p.getSnapshotBeforeUpdate == "function" && (b !== t.memoizedProps || A1 !== t.memoizedState) && (r.flags |= e3), r.memoizedProps = f, r.memoizedState = oe), p.props = f, p.state = oe, p.context = e1, Ne;
    }
    function qs(t, r) {
      return {
        value: t,
        source: r,
        stack: Hi(r),
        digest: null
      };
    }
    function P5(t, r, u) {
      return {
        value: t,
        source: null,
        stack: u ?? null,
        digest: r ?? null
      };
    }
    function SO(t, r) {
      return !0;
    }
    function F5(t, r) {
      try {
        var u = SO(t, r);
        if (u === !1)
          return;
        var f = r.value, C = r.source, p = r.stack, b = p !== null ? p : "";
        if (f != null && f._suppressLogging) {
          if (t.tag === m)
            return;
          console.error(f);
        }
        var M = C ? Oe(C) : null, O = M ? "The above error occurred in the <" + M + "> component:" : "The above error occurred in one of your React components:", P;
        if (t.tag === S)
          P = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var F = Oe(t) || "Anonymous";
          P = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + F + ".");
        }
        var e1 = O + `
` + b + `

` + ("" + P);
        console.error(e1);
      } catch (q) {
        setTimeout(function() {
          throw q;
        });
      }
    }
    var EO = typeof WeakMap == "function" ? WeakMap : Map;
    function Tv(t, r, u) {
      var f = ma(an, u);
      f.tag = VI, f.payload = {
        element: null
      };
      var C = r.value;
      return f.callback = function() {
        hk(C), F5(t, r);
      }, f;
    }
    function B5(t, r, u) {
      var f = ma(an, u);
      f.tag = VI;
      var C = t.type.getDerivedStateFromError;
      if (typeof C == "function") {
        var p = r.value;
        f.payload = function() {
          return C(p);
        }, f.callback = function() {
          By(t), F5(t, r);
        };
      }
      var b = t.stateNode;
      return b !== null && typeof b.componentDidCatch == "function" && (f.callback = function() {
        By(t), F5(t, r), typeof C != "function" && Ik(this);
        var O = r.value, P = r.stack;
        this.componentDidCatch(O, {
          componentStack: P !== null ? P : ""
        }), typeof C != "function" && (br(t.lanes, Re) || c("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Oe(t) || "Unknown"));
      }), f;
    }
    function Lv(t, r, u) {
      var f = t.pingCache, C;
      if (f === null ? (f = t.pingCache = new EO(), C = /* @__PURE__ */ new Set(), f.set(r, C)) : (C = f.get(r), C === void 0 && (C = /* @__PURE__ */ new Set(), f.set(r, C))), !C.has(u)) {
        C.add(u);
        var p = mk.bind(null, t, r, u);
        Br && Ug(t, u), r.then(p, p);
      }
    }
    function MO(t, r, u, f) {
      var C = t.updateQueue;
      if (C === null) {
        var p = /* @__PURE__ */ new Set();
        p.add(u), t.updateQueue = p;
      } else
        C.add(u);
    }
    function TO(t, r) {
      var u = t.tag;
      if ((t.mode & Te) === Se && (u === h || u === V || u === Q)) {
        var f = t.alternate;
        f ? (t.updateQueue = f.updateQueue, t.memoizedState = f.memoizedState, t.lanes = f.lanes) : (t.updateQueue = null, t.memoizedState = null);
      }
    }
    function Rv(t) {
      var r = t;
      do {
        if (r.tag === H && lO(r))
          return r;
        r = r.return;
      } while (r !== null);
      return null;
    }
    function Ov(t, r, u, f, C) {
      if ((t.mode & Te) === Se) {
        if (t === r)
          t.flags |= f2;
        else {
          if (t.flags |= _e, u.flags |= ps, u.flags &= ~(Nl | Nr), u.tag === m) {
            var p = u.alternate;
            if (p === null)
              u.tag = Y1;
            else {
              var b = ma(an, Re);
              b.tag = H9, Ro(u, b, Re);
            }
          }
          u.lanes = qe(u.lanes, Re);
        }
        return t;
      }
      return t.flags |= f2, t.lanes = C, t;
    }
    function LO(t, r, u, f, C) {
      if (u.flags |= Nr, Br && Ug(t, C), f !== null && typeof f == "object" && typeof f.then == "function") {
        var p = f;
        TO(u), G2() && u.mode & Te && b8();
        var b = Rv(r);
        if (b !== null) {
          b.flags &= ~xn, Ov(b, r, u, t, C), b.mode & Te && Lv(t, p, C), MO(b, t, p);
          return;
        } else {
          if (!M4(C)) {
            Lv(t, p, C), hp();
            return;
          }
          var M = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          f = M;
        }
      } else if (G2() && u.mode & Te) {
        b8();
        var O = Rv(r);
        if (O !== null) {
          (O.flags & f2) === ze && (O.flags |= xn), Ov(O, r, u, t, C), OI(qs(f, u));
          return;
        }
      }
      f = qs(f, u), lk(f);
      var P = r;
      do {
        switch (P.tag) {
          case S: {
            var F = f;
            P.flags |= f2;
            var e1 = oo(C);
            P.lanes = qe(P.lanes, e1);
            var q = Tv(P, F, e1);
            KI(P, q);
            return;
          }
          case m:
            var l1 = f, g1 = P.type, A1 = P.stateNode;
            if ((P.flags & _e) === ze && (typeof g1.getDerivedStateFromError == "function" || A1 !== null && typeof A1.componentDidCatch == "function" && !Ry(A1))) {
              P.flags |= f2;
              var oe = oo(C);
              P.lanes = qe(P.lanes, oe);
              var Ne = B5(P, l1, oe);
              KI(P, Ne);
              return;
            }
            break;
        }
        P = P.return;
      } while (P !== null);
    }
    function RO() {
      return null;
    }
    var Sg = i.ReactCurrentOwner, j0 = !1, H5, Eg, U5, W5, V5, Zs, _5, AC, Mg;
    H5 = {}, Eg = {}, U5 = {}, W5 = {}, V5 = {}, Zs = !1, _5 = {}, AC = {}, Mg = {};
    function Wr(t, r, u, f) {
      t === null ? r.child = j8(r, null, u, f) : r.child = Ku(r, t.child, u, f);
    }
    function OO(t, r, u, f) {
      r.child = Ku(r, t.child, null, f), r.child = Ku(r, null, u, f);
    }
    function Dv(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = u.propTypes;
        p && T0(
          p,
          f,
          // Resolved props
          "prop",
          yt(u)
        );
      }
      var b = u.render, M = r.ref, O, P;
      Qu(r, C), Ga(r);
      {
        if (Sg.current = r, zr(!0), O = ec(t, r, b, f, M, C), P = tc(), r.mode & lt) {
          Un(!0);
          try {
            O = ec(t, r, b, f, M, C), P = tc();
          } finally {
            Un(!1);
          }
        }
        zr(!1);
      }
      return mr(), t !== null && !j0 ? (Q8(t, r, C), va(t, r, C)) : (G2() && P && SI(r), r.flags |= Z0, Wr(t, r, O, C), r.child);
    }
    function kv(t, r, u, f, C) {
      if (t === null) {
        var p = u.type;
        if (Nk(p) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var b = p;
          return b = uc(p), r.tag = Q, r.type = b, Y5(r, p), jv(t, r, b, f, C);
        }
        {
          var M = p.propTypes;
          if (M && T0(
            M,
            f,
            // Resolved props
            "prop",
            yt(p)
          ), u.defaultProps !== void 0) {
            var O = yt(p) || "Unknown";
            Mg[O] || (c("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", O), Mg[O] = !0);
          }
        }
        var P = Lp(u.type, null, f, r, r.mode, C);
        return P.ref = r.ref, P.return = r, r.child = P, P;
      }
      {
        var F = u.type, e1 = F.propTypes;
        e1 && T0(
          e1,
          f,
          // Resolved props
          "prop",
          yt(F)
        );
      }
      var q = t.child, l1 = $5(t, C);
      if (!l1) {
        var g1 = q.memoizedProps, A1 = u.compare;
        if (A1 = A1 !== null ? A1 : Ue, A1(g1, f) && t.ref === r.ref)
          return va(t, r, C);
      }
      r.flags |= Z0;
      var oe = rl(q, f);
      return oe.ref = r.ref, oe.return = r, r.child = oe, oe;
    }
    function jv(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = r.elementType;
        if (p.$$typeof === je) {
          var b = p, M = b._payload, O = b._init;
          try {
            p = O(M);
          } catch {
            p = null;
          }
          var P = p && p.propTypes;
          P && T0(
            P,
            f,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            yt(p)
          );
        }
      }
      if (t !== null) {
        var F = t.memoizedProps;
        if (Ue(F, f) && t.ref === r.ref && // Prevent bailout if the implementation changed due to hot reload.
        r.type === t.type)
          if (j0 = !1, r.pendingProps = f = F, $5(t, C))
            (t.flags & ps) !== ze && (j0 = !0);
          else return r.lanes = t.lanes, va(t, r, C);
      }
      return J5(t, r, u, f, C);
    }
    function zv(t, r, u) {
      var f = r.pendingProps, C = f.children, p = t !== null ? t.memoizedState : null;
      if (f.mode === "hidden" || t1)
        if ((r.mode & Te) === Se) {
          var b = {
            baseLanes: w1,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = b, TC(r, u);
        } else if (br(u, H2)) {
          var e1 = {
            baseLanes: w1,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = e1;
          var q = p !== null ? p.baseLanes : u;
          TC(r, q);
        } else {
          var M = null, O;
          if (p !== null) {
            var P = p.baseLanes;
            O = qe(P, u);
          } else
            O = u;
          r.lanes = r.childLanes = H2;
          var F = {
            baseLanes: O,
            cachePool: M,
            transitions: null
          };
          return r.memoizedState = F, r.updateQueue = null, TC(r, O), null;
        }
      else {
        var l1;
        p !== null ? (l1 = qe(p.baseLanes, u), r.memoizedState = null) : l1 = u, TC(r, l1);
      }
      return Wr(t, r, C, u), r.child;
    }
    function DO(t, r, u) {
      var f = r.pendingProps;
      return Wr(t, r, f, u), r.child;
    }
    function kO(t, r, u) {
      var f = r.pendingProps.children;
      return Wr(t, r, f, u), r.child;
    }
    function jO(t, r, u) {
      {
        r.flags |= Ze;
        {
          var f = r.stateNode;
          f.effectDuration = 0, f.passiveEffectDuration = 0;
        }
      }
      var C = r.pendingProps, p = C.children;
      return Wr(t, r, p, u), r.child;
    }
    function Nv(t, r) {
      var u = r.ref;
      (t === null && u !== null || t !== null && t.ref !== u) && (r.flags |= Cr, r.flags |= C4);
    }
    function J5(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = u.propTypes;
        p && T0(
          p,
          f,
          // Resolved props
          "prop",
          yt(u)
        );
      }
      var b;
      {
        var M = Uu(r, u, !0);
        b = Wu(r, M);
      }
      var O, P;
      Qu(r, C), Ga(r);
      {
        if (Sg.current = r, zr(!0), O = ec(t, r, u, f, b, C), P = tc(), r.mode & lt) {
          Un(!0);
          try {
            O = ec(t, r, u, f, b, C), P = tc();
          } finally {
            Un(!1);
          }
        }
        zr(!1);
      }
      return mr(), t !== null && !j0 ? (Q8(t, r, C), va(t, r, C)) : (G2() && P && SI(r), r.flags |= Z0, Wr(t, r, O, C), r.child);
    }
    function Pv(t, r, u, f, C) {
      {
        switch (qk(r)) {
          case !1: {
            var p = r.stateNode, b = r.type, M = new b(r.memoizedProps, p.context), O = M.state;
            p.updater.enqueueSetState(p, O, null);
            break;
          }
          case !0: {
            r.flags |= _e, r.flags |= f2;
            var P = new Error("Simulated error coming from DevTools"), F = oo(C);
            r.lanes = qe(r.lanes, F);
            var e1 = B5(r, qs(P, r), F);
            KI(r, e1);
            break;
          }
        }
        if (r.type !== r.elementType) {
          var q = u.propTypes;
          q && T0(
            q,
            f,
            // Resolved props
            "prop",
            yt(u)
          );
        }
      }
      var l1;
      gi(u) ? (l1 = !0, M9(r)) : l1 = !1, Qu(r, C);
      var g1 = r.stateNode, A1;
      g1 === null ? (pC(t, r), Ev(r, u, f), N5(r, u, f, C), A1 = !0) : t === null ? A1 = wO(r, u, f, C) : A1 = xO(t, r, u, f, C);
      var oe = K5(t, r, u, A1, l1, C);
      {
        var Ne = r.stateNode;
        A1 && Ne.props !== f && (Zs || c("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Oe(r) || "a component"), Zs = !0);
      }
      return oe;
    }
    function K5(t, r, u, f, C, p) {
      Nv(t, r);
      var b = (r.flags & _e) !== ze;
      if (!f && !b)
        return C && h8(r, u, !1), va(t, r, p);
      var M = r.stateNode;
      Sg.current = r;
      var O;
      if (b && typeof u.getDerivedStateFromError != "function")
        O = null, yv();
      else {
        Ga(r);
        {
          if (zr(!0), O = M.render(), r.mode & lt) {
            Un(!0);
            try {
              M.render();
            } finally {
              Un(!1);
            }
          }
          zr(!1);
        }
        mr();
      }
      return r.flags |= Z0, t !== null && b ? OO(t, r, O, p) : Wr(t, r, O, p), r.memoizedState = M.state, C && h8(r, u, !0), r.child;
    }
    function Fv(t) {
      var r = t.stateNode;
      r.pendingContext ? I8(t, r.pendingContext, r.pendingContext !== r.context) : r.context && I8(t, r.context, !1), YI(t, r.containerInfo);
    }
    function zO(t, r, u) {
      if (Fv(r), t === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var f = r.pendingProps, C = r.memoizedState, p = C.element;
      U8(t, r), _9(r, f, null, u);
      var b = r.memoizedState;
      r.stateNode;
      var M = b.element;
      if (C.isDehydrated) {
        var O = {
          element: M,
          isDehydrated: !1,
          cache: b.cache,
          pendingSuspenseBoundaries: b.pendingSuspenseBoundaries,
          transitions: b.transitions
        }, P = r.updateQueue;
        if (P.baseState = O, r.memoizedState = O, r.flags & xn) {
          var F = qs(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), r);
          return Bv(t, r, M, u, F);
        } else if (M !== p) {
          var e1 = qs(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), r);
          return Bv(t, r, M, u, e1);
        } else {
          FR(r);
          var q = j8(r, null, M, u);
          r.child = q;
          for (var l1 = q; l1; )
            l1.flags = l1.flags & ~on | t3, l1 = l1.sibling;
        }
      } else {
        if (Ju(), M === p)
          return va(t, r, u);
        Wr(t, r, M, u);
      }
      return r.child;
    }
    function Bv(t, r, u, f, C) {
      return Ju(), OI(C), r.flags |= xn, Wr(t, r, u, f), r.child;
    }
    function NO(t, r, u) {
      J8(r), t === null && RI(r);
      var f = r.type, C = r.pendingProps, p = t !== null ? t.memoizedProps : null, b = C.children, M = gI(f, C);
      return M ? b = null : p !== null && gI(f, p) && (r.flags |= kt), Nv(t, r), Wr(t, r, b, u), r.child;
    }
    function PO(t, r) {
      return t === null && RI(r), null;
    }
    function FO(t, r, u, f) {
      pC(t, r);
      var C = r.pendingProps, p = u, b = p._payload, M = p._init, O = M(b);
      r.type = O;
      var P = r.tag = Pk(O), F = k0(O, C), e1;
      switch (P) {
        case h:
          return Y5(r, O), r.type = O = uc(O), e1 = J5(null, r, O, F, f), e1;
        case m:
          return r.type = O = wp(O), e1 = Pv(null, r, O, F, f), e1;
        case V:
          return r.type = O = xp(O), e1 = Dv(null, r, O, F, f), e1;
        case Z: {
          if (r.type !== r.elementType) {
            var q = O.propTypes;
            q && T0(
              q,
              F,
              // Resolved for outer only
              "prop",
              yt(O)
            );
          }
          return e1 = kv(
            null,
            r,
            O,
            k0(O.type, F),
            // The inner type can have defaults too
            f
          ), e1;
        }
      }
      var l1 = "";
      throw O !== null && typeof O == "object" && O.$$typeof === je && (l1 = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + O + ". " + ("Lazy element type must resolve to a class or function." + l1));
    }
    function BO(t, r, u, f, C) {
      pC(t, r), r.tag = m;
      var p;
      return gi(u) ? (p = !0, M9(r)) : p = !1, Qu(r, C), Ev(r, u, f), N5(r, u, f, C), K5(null, r, u, !0, p, C);
    }
    function HO(t, r, u, f) {
      pC(t, r);
      var C = r.pendingProps, p;
      {
        var b = Uu(r, u, !1);
        p = Wu(r, b);
      }
      Qu(r, f);
      var M, O;
      Ga(r);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var P = yt(u) || "Unknown";
          H5[P] || (c("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", P, P), H5[P] = !0);
        }
        r.mode & lt && R0.recordLegacyContextWarning(r, null), zr(!0), Sg.current = r, M = ec(null, r, u, C, p, f), O = tc(), zr(!1);
      }
      if (mr(), r.flags |= Z0, typeof M == "object" && M !== null && typeof M.render == "function" && M.$$typeof === void 0) {
        var F = yt(u) || "Unknown";
        Eg[F] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", F, F, F), Eg[F] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof M == "object" && M !== null && typeof M.render == "function" && M.$$typeof === void 0
      ) {
        {
          var e1 = yt(u) || "Unknown";
          Eg[e1] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", e1, e1, e1), Eg[e1] = !0);
        }
        r.tag = m, r.memoizedState = null, r.updateQueue = null;
        var q = !1;
        return gi(u) ? (q = !0, M9(r)) : q = !1, r.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null, JI(r), Sv(r, M), N5(r, u, C, f), K5(null, r, u, !0, q, f);
      } else {
        if (r.tag = h, r.mode & lt) {
          Un(!0);
          try {
            M = ec(null, r, u, C, p, f), O = tc();
          } finally {
            Un(!1);
          }
        }
        return G2() && O && SI(r), Wr(null, r, M, f), Y5(r, u), r.child;
      }
    }
    function Y5(t, r) {
      {
        if (r && r.childContextTypes && c("%s(...): childContextTypes cannot be defined on a function component.", r.displayName || r.name || "Component"), t.ref !== null) {
          var u = "", f = fr();
          f && (u += `

Check the render method of \`` + f + "`.");
          var C = f || "", p = t._debugSource;
          p && (C = p.fileName + ":" + p.lineNumber), V5[C] || (V5[C] = !0, c("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (r.defaultProps !== void 0) {
          var b = yt(r) || "Unknown";
          Mg[b] || (c("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", b), Mg[b] = !0);
        }
        if (typeof r.getDerivedStateFromProps == "function") {
          var M = yt(r) || "Unknown";
          W5[M] || (c("%s: Function components do not support getDerivedStateFromProps.", M), W5[M] = !0);
        }
        if (typeof r.contextType == "object" && r.contextType !== null) {
          var O = yt(r) || "Unknown";
          U5[O] || (c("%s: Function components do not support contextType.", O), U5[O] = !0);
        }
      }
    }
    var Q5 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Wn
    };
    function X5(t) {
      return {
        baseLanes: t,
        cachePool: RO(),
        transitions: null
      };
    }
    function UO(t, r) {
      var u = null;
      return {
        baseLanes: qe(t.baseLanes, r),
        cachePool: u,
        transitions: t.transitions
      };
    }
    function WO(t, r, u, f) {
      if (r !== null) {
        var C = r.memoizedState;
        if (C === null)
          return !1;
      }
      return GI(t, Ig);
    }
    function VO(t, r) {
      return Ms(t.childLanes, r);
    }
    function Hv(t, r, u) {
      var f = r.pendingProps;
      Zk(r) && (r.flags |= _e);
      var C = O0.current, p = !1, b = (r.flags & _e) !== ze;
      if (b || WO(C, t) ? (p = !0, r.flags &= ~_e) : (t === null || t.memoizedState !== null) && (C = sO(C, Y8)), C = Gu(C), Do(r, C), t === null) {
        RI(r);
        var M = r.memoizedState;
        if (M !== null) {
          var O = M.dehydrated;
          if (O !== null)
            return QO(r, O);
        }
        var P = f.children, F = f.fallback;
        if (p) {
          var e1 = _O(r, P, F, u), q = r.child;
          return q.memoizedState = X5(u), r.memoizedState = Q5, e1;
        } else
          return G5(r, P);
      } else {
        var l1 = t.memoizedState;
        if (l1 !== null) {
          var g1 = l1.dehydrated;
          if (g1 !== null)
            return XO(t, r, b, f, g1, l1, u);
        }
        if (p) {
          var A1 = f.fallback, oe = f.children, Ne = KO(t, r, oe, A1, u), Le = r.child, At = t.child.memoizedState;
          return Le.memoizedState = At === null ? X5(u) : UO(At, u), Le.childLanes = VO(t, u), r.memoizedState = Q5, Ne;
        } else {
          var dt = f.children, i1 = JO(t, r, dt, u);
          return r.memoizedState = null, i1;
        }
      }
    }
    function G5(t, r, u) {
      var f = t.mode, C = {
        mode: "visible",
        children: r
      }, p = q5(C, f);
      return p.return = t, t.child = p, p;
    }
    function _O(t, r, u, f) {
      var C = t.mode, p = t.child, b = {
        mode: "hidden",
        children: r
      }, M, O;
      return (C & Te) === Se && p !== null ? (M = p, M.childLanes = w1, M.pendingProps = b, t.mode & Je && (M.actualDuration = 0, M.actualStartTime = -1, M.selfBaseDuration = 0, M.treeBaseDuration = 0), O = Ho(u, C, f, null)) : (M = q5(b, C), O = Ho(u, C, f, null)), M.return = t, O.return = t, M.sibling = O, t.child = M, O;
    }
    function q5(t, r, u) {
      return Uy(t, r, w1, null);
    }
    function Uv(t, r) {
      return rl(t, r);
    }
    function JO(t, r, u, f) {
      var C = t.child, p = C.sibling, b = Uv(C, {
        mode: "visible",
        children: u
      });
      if ((r.mode & Te) === Se && (b.lanes = f), b.return = r, b.sibling = null, p !== null) {
        var M = r.deletions;
        M === null ? (r.deletions = [p], r.flags |= Mt) : M.push(p);
      }
      return r.child = b, b;
    }
    function KO(t, r, u, f, C) {
      var p = r.mode, b = t.child, M = b.sibling, O = {
        mode: "hidden",
        children: u
      }, P;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (p & Te) === Se && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        r.child !== b
      ) {
        var F = r.child;
        P = F, P.childLanes = w1, P.pendingProps = O, r.mode & Je && (P.actualDuration = 0, P.actualStartTime = -1, P.selfBaseDuration = b.selfBaseDuration, P.treeBaseDuration = b.treeBaseDuration), r.deletions = null;
      } else
        P = Uv(b, O), P.subtreeFlags = b.subtreeFlags & b2;
      var e1;
      return M !== null ? e1 = rl(M, f) : (e1 = Ho(f, p, C, null), e1.flags |= on), e1.return = r, P.return = r, P.sibling = e1, r.child = P, e1;
    }
    function IC(t, r, u, f) {
      f !== null && OI(f), Ku(r, t.child, null, u);
      var C = r.pendingProps, p = C.children, b = G5(r, p);
      return b.flags |= on, r.memoizedState = null, b;
    }
    function YO(t, r, u, f, C) {
      var p = r.mode, b = {
        mode: "visible",
        children: u
      }, M = q5(b, p), O = Ho(f, p, C, null);
      return O.flags |= on, M.return = r, O.return = r, M.sibling = O, r.child = M, (r.mode & Te) !== Se && Ku(r, t.child, null, C), O;
    }
    function QO(t, r, u) {
      return (t.mode & Te) === Se ? (c("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), t.lanes = Re) : AI(r) ? t.lanes = w0 : t.lanes = H2, null;
    }
    function XO(t, r, u, f, C, p, b) {
      if (u)
        if (r.flags & xn) {
          r.flags &= ~xn;
          var i1 = P5(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return IC(t, r, b, i1);
        } else {
          if (r.memoizedState !== null)
            return r.child = t.child, r.flags |= _e, null;
          var I1 = f.children, a1 = f.fallback, N1 = YO(t, r, I1, a1, b), de = r.child;
          return de.memoizedState = X5(b), r.memoizedState = Q5, N1;
        }
      else {
        if (NR(), (r.mode & Te) === Se)
          return IC(
            t,
            r,
            b,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (AI(C)) {
          var M, O, P;
          {
            var F = $L(C);
            M = F.digest, O = F.message, P = F.stack;
          }
          var e1;
          O ? e1 = new Error(O) : e1 = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var q = P5(e1, M, P);
          return IC(t, r, b, q);
        }
        var l1 = br(b, t.childLanes);
        if (j0 || l1) {
          var g1 = MC();
          if (g1 !== null) {
            var A1 = Wd(g1, b);
            if (A1 !== Wn && A1 !== p.retryLane) {
              p.retryLane = A1;
              var oe = an;
              d3(t, A1), D2(g1, t, A1, oe);
            }
          }
          hp();
          var Ne = P5(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return IC(t, r, b, Ne);
        } else if (c8(C)) {
          r.flags |= _e, r.child = t.child;
          var Le = vk.bind(null, t);
          return eR(C, Le), null;
        } else {
          BR(r, C, p.treeContext);
          var At = f.children, dt = G5(r, At);
          return dt.flags |= t3, dt;
        }
      }
    }
    function Wv(t, r, u) {
      t.lanes = qe(t.lanes, r);
      var f = t.alternate;
      f !== null && (f.lanes = qe(f.lanes, r)), UI(t.return, r, u);
    }
    function GO(t, r, u) {
      for (var f = r; f !== null; ) {
        if (f.tag === H) {
          var C = f.memoizedState;
          C !== null && Wv(f, u, t);
        } else if (f.tag === T1)
          Wv(f, u, t);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === t)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === t)
            return;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
    }
    function qO(t) {
      for (var r = t, u = null; r !== null; ) {
        var f = r.alternate;
        f !== null && Q9(f) === null && (u = r), r = r.sibling;
      }
      return u;
    }
    function ZO(t) {
      if (t !== void 0 && t !== "forwards" && t !== "backwards" && t !== "together" && !_5[t])
        if (_5[t] = !0, typeof t == "string")
          switch (t.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', t, t.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', t, t.toLowerCase());
              break;
            }
            default:
              c('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
              break;
          }
        else
          c('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
    }
    function $O(t, r) {
      t !== void 0 && !AC[t] && (t !== "collapsed" && t !== "hidden" ? (AC[t] = !0, c('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', t)) : r !== "forwards" && r !== "backwards" && (AC[t] = !0, c('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', t)));
    }
    function Vv(t, r) {
      {
        var u = c2(t), f = !u && typeof _2(t) == "function";
        if (u || f) {
          var C = u ? "array" : "iterable";
          return c("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", C, r, C), !1;
        }
      }
      return !0;
    }
    function eD(t, r) {
      if ((r === "forwards" || r === "backwards") && t !== void 0 && t !== null && t !== !1)
        if (c2(t)) {
          for (var u = 0; u < t.length; u++)
            if (!Vv(t[u], u))
              return;
        } else {
          var f = _2(t);
          if (typeof f == "function") {
            var C = f.call(t);
            if (C)
              for (var p = C.next(), b = 0; !p.done; p = C.next()) {
                if (!Vv(p.value, b))
                  return;
                b++;
              }
          } else
            c('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', r);
        }
    }
    function Z5(t, r, u, f, C) {
      var p = t.memoizedState;
      p === null ? t.memoizedState = {
        isBackwards: r,
        rendering: null,
        renderingStartTime: 0,
        last: f,
        tail: u,
        tailMode: C
      } : (p.isBackwards = r, p.rendering = null, p.renderingStartTime = 0, p.last = f, p.tail = u, p.tailMode = C);
    }
    function _v(t, r, u) {
      var f = r.pendingProps, C = f.revealOrder, p = f.tail, b = f.children;
      ZO(C), $O(p, C), eD(b, C), Wr(t, r, b, u);
      var M = O0.current, O = GI(M, Ig);
      if (O)
        M = qI(M, Ig), r.flags |= _e;
      else {
        var P = t !== null && (t.flags & _e) !== ze;
        P && GO(r, r.child, u), M = Gu(M);
      }
      if (Do(r, M), (r.mode & Te) === Se)
        r.memoizedState = null;
      else
        switch (C) {
          case "forwards": {
            var F = qO(r.child), e1;
            F === null ? (e1 = r.child, r.child = null) : (e1 = F.sibling, F.sibling = null), Z5(
              r,
              !1,
              // isBackwards
              e1,
              F,
              p
            );
            break;
          }
          case "backwards": {
            var q = null, l1 = r.child;
            for (r.child = null; l1 !== null; ) {
              var g1 = l1.alternate;
              if (g1 !== null && Q9(g1) === null) {
                r.child = l1;
                break;
              }
              var A1 = l1.sibling;
              l1.sibling = q, q = l1, l1 = A1;
            }
            Z5(
              r,
              !0,
              // isBackwards
              q,
              null,
              // last
              p
            );
            break;
          }
          case "together": {
            Z5(
              r,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            r.memoizedState = null;
        }
      return r.child;
    }
    function tD(t, r, u) {
      YI(r, r.stateNode.containerInfo);
      var f = r.pendingProps;
      return t === null ? r.child = Ku(r, null, f, u) : Wr(t, r, f, u), r.child;
    }
    var Jv = !1;
    function nD(t, r, u) {
      var f = r.type, C = f._context, p = r.pendingProps, b = r.memoizedProps, M = p.value;
      {
        "value" in p || Jv || (Jv = !0, c("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var O = r.type.propTypes;
        O && T0(O, p, "prop", "Context.Provider");
      }
      if (P8(r, C, M), b !== null) {
        var P = b.value;
        if (ve(P, M)) {
          if (b.children === p.children && !S9())
            return va(t, r, u);
        } else
          ZR(r, C, u);
      }
      var F = p.children;
      return Wr(t, r, F, u), r.child;
    }
    var Kv = !1;
    function rD(t, r, u) {
      var f = r.type;
      f._context === void 0 ? f !== f.Consumer && (Kv || (Kv = !0, c("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : f = f._context;
      var C = r.pendingProps, p = C.children;
      typeof p != "function" && c("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Qu(r, u);
      var b = I2(f);
      Ga(r);
      var M;
      return Sg.current = r, zr(!0), M = p(b), zr(!1), mr(), r.flags |= Z0, Wr(t, r, M, u), r.child;
    }
    function Tg() {
      j0 = !0;
    }
    function pC(t, r) {
      (r.mode & Te) === Se && t !== null && (t.alternate = null, r.alternate = null, r.flags |= on);
    }
    function va(t, r, u) {
      return t !== null && (r.dependencies = t.dependencies), yv(), Hg(r.lanes), br(u, r.childLanes) ? (GR(t, r), r.child) : null;
    }
    function iD(t, r, u) {
      {
        var f = r.return;
        if (f === null)
          throw new Error("Cannot swap the root fiber.");
        if (t.alternate = null, r.alternate = null, u.index = r.index, u.sibling = r.sibling, u.return = r.return, u.ref = r.ref, r === f.child)
          f.child = u;
        else {
          var C = f.child;
          if (C === null)
            throw new Error("Expected parent to have a child.");
          for (; C.sibling !== r; )
            if (C = C.sibling, C === null)
              throw new Error("Expected to find the previous sibling.");
          C.sibling = u;
        }
        var p = f.deletions;
        return p === null ? (f.deletions = [t], f.flags |= Mt) : p.push(t), u.flags |= on, u;
      }
    }
    function $5(t, r) {
      var u = t.lanes;
      return !!br(u, r);
    }
    function aD(t, r, u) {
      switch (r.tag) {
        case S:
          Fv(r), r.stateNode, Ju();
          break;
        case D:
          J8(r);
          break;
        case m: {
          var f = r.type;
          gi(f) && M9(r);
          break;
        }
        case T:
          YI(r, r.stateNode.containerInfo);
          break;
        case K: {
          var C = r.memoizedProps.value, p = r.type._context;
          P8(r, p, C);
          break;
        }
        case Y:
          {
            var b = br(u, r.childLanes);
            b && (r.flags |= Ze);
            {
              var M = r.stateNode;
              M.effectDuration = 0, M.passiveEffectDuration = 0;
            }
          }
          break;
        case H: {
          var O = r.memoizedState;
          if (O !== null) {
            if (O.dehydrated !== null)
              return Do(r, Gu(O0.current)), r.flags |= _e, null;
            var P = r.child, F = P.childLanes;
            if (br(u, F))
              return Hv(t, r, u);
            Do(r, Gu(O0.current));
            var e1 = va(t, r, u);
            return e1 !== null ? e1.sibling : null;
          } else
            Do(r, Gu(O0.current));
          break;
        }
        case T1: {
          var q = (t.flags & _e) !== ze, l1 = br(u, r.childLanes);
          if (q) {
            if (l1)
              return _v(t, r, u);
            r.flags |= _e;
          }
          var g1 = r.memoizedState;
          if (g1 !== null && (g1.rendering = null, g1.tail = null, g1.lastEffect = null), Do(r, O0.current), l1)
            break;
          return null;
        }
        case s1:
        case d1:
          return r.lanes = w1, zv(t, r, u);
      }
      return va(t, r, u);
    }
    function Yv(t, r, u) {
      if (r._debugNeedsRemount && t !== null)
        return iD(t, r, Lp(r.type, r.key, r.pendingProps, r._debugOwner || null, r.mode, r.lanes));
      if (t !== null) {
        var f = t.memoizedProps, C = r.pendingProps;
        if (f !== C || S9() || // Force a re-render if the implementation changed due to hot reload:
        r.type !== t.type)
          j0 = !0;
        else {
          var p = $5(t, u);
          if (!p && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (r.flags & _e) === ze)
            return j0 = !1, aD(t, r, u);
          (t.flags & ps) !== ze ? j0 = !0 : j0 = !1;
        }
      } else if (j0 = !1, G2() && RR(r)) {
        var b = r.index, M = OR();
        y8(r, M, b);
      }
      switch (r.lanes = w1, r.tag) {
        case w:
          return HO(t, r, r.type, u);
        case P1: {
          var O = r.elementType;
          return FO(t, r, O, u);
        }
        case h: {
          var P = r.type, F = r.pendingProps, e1 = r.elementType === P ? F : k0(P, F);
          return J5(t, r, P, e1, u);
        }
        case m: {
          var q = r.type, l1 = r.pendingProps, g1 = r.elementType === q ? l1 : k0(q, l1);
          return Pv(t, r, q, g1, u);
        }
        case S:
          return zO(t, r, u);
        case D:
          return NO(t, r, u);
        case k:
          return PO(t, r);
        case H:
          return Hv(t, r, u);
        case T:
          return tD(t, r, u);
        case V: {
          var A1 = r.type, oe = r.pendingProps, Ne = r.elementType === A1 ? oe : k0(A1, oe);
          return Dv(t, r, A1, Ne, u);
        }
        case z:
          return DO(t, r, u);
        case N:
          return kO(t, r, u);
        case Y:
          return jO(t, r, u);
        case K:
          return nD(t, r, u);
        case W:
          return rD(t, r, u);
        case Z: {
          var Le = r.type, At = r.pendingProps, dt = k0(Le, At);
          if (r.type !== r.elementType) {
            var i1 = Le.propTypes;
            i1 && T0(
              i1,
              dt,
              // Resolved for outer only
              "prop",
              yt(Le)
            );
          }
          return dt = k0(Le.type, dt), kv(t, r, Le, dt, u);
        }
        case Q:
          return jv(t, r, r.type, r.pendingProps, u);
        case Y1: {
          var I1 = r.type, a1 = r.pendingProps, N1 = r.elementType === I1 ? a1 : k0(I1, a1);
          return BO(t, r, I1, N1, u);
        }
        case T1:
          return _v(t, r, u);
        case J1:
          break;
        case s1:
          return zv(t, r, u);
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function nc(t) {
      t.flags |= Ze;
    }
    function Qv(t) {
      t.flags |= Cr, t.flags |= C4;
    }
    var Xv, ep, Gv, qv;
    Xv = function(t, r, u, f) {
      for (var C = r.child; C !== null; ) {
        if (C.tag === D || C.tag === k)
          ML(t, C.stateNode);
        else if (C.tag !== T) {
          if (C.child !== null) {
            C.child.return = C, C = C.child;
            continue;
          }
        }
        if (C === r)
          return;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === r)
            return;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      }
    }, ep = function(t, r) {
    }, Gv = function(t, r, u, f, C) {
      var p = t.memoizedProps;
      if (p !== f) {
        var b = r.stateNode, M = QI(), O = LL(b, u, p, f, C, M);
        r.updateQueue = O, O && nc(r);
      }
    }, qv = function(t, r, u, f) {
      u !== f && nc(r);
    };
    function Lg(t, r) {
      if (!G2())
        switch (t.tailMode) {
          case "hidden": {
            for (var u = t.tail, f = null; u !== null; )
              u.alternate !== null && (f = u), u = u.sibling;
            f === null ? t.tail = null : f.sibling = null;
            break;
          }
          case "collapsed": {
            for (var C = t.tail, p = null; C !== null; )
              C.alternate !== null && (p = C), C = C.sibling;
            p === null ? !r && t.tail !== null ? t.tail.sibling = null : t.tail = null : p.sibling = null;
            break;
          }
        }
    }
    function Z2(t) {
      var r = t.alternate !== null && t.alternate.child === t.child, u = w1, f = ze;
      if (r) {
        if ((t.mode & Je) !== Se) {
          for (var O = t.selfBaseDuration, P = t.child; P !== null; )
            u = qe(u, qe(P.lanes, P.childLanes)), f |= P.subtreeFlags & b2, f |= P.flags & b2, O += P.treeBaseDuration, P = P.sibling;
          t.treeBaseDuration = O;
        } else
          for (var F = t.child; F !== null; )
            u = qe(u, qe(F.lanes, F.childLanes)), f |= F.subtreeFlags & b2, f |= F.flags & b2, F.return = t, F = F.sibling;
        t.subtreeFlags |= f;
      } else {
        if ((t.mode & Je) !== Se) {
          for (var C = t.actualDuration, p = t.selfBaseDuration, b = t.child; b !== null; )
            u = qe(u, qe(b.lanes, b.childLanes)), f |= b.subtreeFlags, f |= b.flags, C += b.actualDuration, p += b.treeBaseDuration, b = b.sibling;
          t.actualDuration = C, t.treeBaseDuration = p;
        } else
          for (var M = t.child; M !== null; )
            u = qe(u, qe(M.lanes, M.childLanes)), f |= M.subtreeFlags, f |= M.flags, M.return = t, M = M.sibling;
        t.subtreeFlags |= f;
      }
      return t.childLanes = u, r;
    }
    function oD(t, r, u) {
      if (_R() && (r.mode & Te) !== Se && (r.flags & _e) === ze)
        return T8(r), Ju(), r.flags |= xn | Nr | f2, !1;
      var f = D9(r);
      if (u !== null && u.dehydrated !== null)
        if (t === null) {
          if (!f)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (WR(r), Z2(r), (r.mode & Je) !== Se) {
            var C = u !== null;
            if (C) {
              var p = r.child;
              p !== null && (r.treeBaseDuration -= p.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Ju(), (r.flags & _e) === ze && (r.memoizedState = null), r.flags |= Ze, Z2(r), (r.mode & Je) !== Se) {
            var b = u !== null;
            if (b) {
              var M = r.child;
              M !== null && (r.treeBaseDuration -= M.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return L8(), !0;
    }
    function Zv(t, r, u) {
      var f = r.pendingProps;
      switch (EI(r), r.tag) {
        case w:
        case P1:
        case Q:
        case h:
        case V:
        case z:
        case N:
        case Y:
        case W:
        case Z:
          return Z2(r), null;
        case m: {
          var C = r.type;
          return gi(C) && E9(r), Z2(r), null;
        }
        case S: {
          var p = r.stateNode;
          if (Xu(r), bI(r), $I(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), t === null || t.child === null) {
            var b = D9(r);
            if (b)
              nc(r);
            else if (t !== null) {
              var M = t.memoizedState;
              // Check if this is a client root
              (!M.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (r.flags & xn) !== ze) && (r.flags |= e3, L8());
            }
          }
          return ep(t, r), Z2(r), null;
        }
        case D: {
          XI(r);
          var O = _8(), P = r.type;
          if (t !== null && r.stateNode != null)
            Gv(t, r, P, f, O), t.ref !== r.ref && Qv(r);
          else {
            if (!f) {
              if (r.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Z2(r), null;
            }
            var F = QI(), e1 = D9(r);
            if (e1)
              HR(r, O, F) && nc(r);
            else {
              var q = EL(P, f, O, F, r);
              Xv(q, r, !1, !1), r.stateNode = q, TL(q, P, f, O) && nc(r);
            }
            r.ref !== null && Qv(r);
          }
          return Z2(r), null;
        }
        case k: {
          var l1 = f;
          if (t && r.stateNode != null) {
            var g1 = t.memoizedProps;
            qv(t, r, g1, l1);
          } else {
            if (typeof l1 != "string" && r.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var A1 = _8(), oe = QI(), Ne = D9(r);
            Ne ? UR(r) && nc(r) : r.stateNode = RL(l1, A1, oe, r);
          }
          return Z2(r), null;
        }
        case H: {
          qu(r);
          var Le = r.memoizedState;
          if (t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
            var At = oD(t, r, Le);
            if (!At)
              return r.flags & f2 ? r : null;
          }
          if ((r.flags & _e) !== ze)
            return r.lanes = u, (r.mode & Je) !== Se && x5(r), r;
          var dt = Le !== null, i1 = t !== null && t.memoizedState !== null;
          if (dt !== i1 && dt) {
            var I1 = r.child;
            if (I1.flags |= $0, (r.mode & Te) !== Se) {
              var a1 = t === null && (r.memoizedProps.unstable_avoidThisFallback !== !0 || !y1);
              a1 || GI(O0.current, Y8) ? sk() : hp();
            }
          }
          var N1 = r.updateQueue;
          if (N1 !== null && (r.flags |= Ze), Z2(r), (r.mode & Je) !== Se && dt) {
            var de = r.child;
            de !== null && (r.treeBaseDuration -= de.treeBaseDuration);
          }
          return null;
        }
        case T:
          return Xu(r), ep(t, r), t === null && wR(r.stateNode.containerInfo), Z2(r), null;
        case K:
          var ce = r.type._context;
          return HI(ce, r), Z2(r), null;
        case Y1: {
          var Ve = r.type;
          return gi(Ve) && E9(r), Z2(r), null;
        }
        case T1: {
          qu(r);
          var Ge = r.memoizedState;
          if (Ge === null)
            return Z2(r), null;
          var _t = (r.flags & _e) !== ze, wt = Ge.rendering;
          if (wt === null)
            if (_t)
              Lg(Ge, !1);
            else {
              var n2 = uk() && (t === null || (t.flags & _e) === ze);
              if (!n2)
                for (var xt = r.child; xt !== null; ) {
                  var Vn = Q9(xt);
                  if (Vn !== null) {
                    _t = !0, r.flags |= _e, Lg(Ge, !1);
                    var Mr = Vn.updateQueue;
                    return Mr !== null && (r.updateQueue = Mr, r.flags |= Ze), r.subtreeFlags = ze, qR(r, u), Do(r, qI(O0.current, Ig)), r.child;
                  }
                  xt = xt.sibling;
                }
              Ge.tail !== null && pn() > my() && (r.flags |= _e, _t = !0, Lg(Ge, !1), r.lanes = Od);
            }
          else {
            if (!_t) {
              var rr = Q9(wt);
              if (rr !== null) {
                r.flags |= _e, _t = !0;
                var T3 = rr.updateQueue;
                if (T3 !== null && (r.updateQueue = T3, r.flags |= Ze), Lg(Ge, !0), Ge.tail === null && Ge.tailMode === "hidden" && !wt.alternate && !G2())
                  return Z2(r), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              pn() * 2 - Ge.renderingStartTime > my() && u !== H2 && (r.flags |= _e, _t = !0, Lg(Ge, !1), r.lanes = Od);
            }
            if (Ge.isBackwards)
              wt.sibling = r.child, r.child = wt;
            else {
              var Jr = Ge.last;
              Jr !== null ? Jr.sibling = wt : r.child = wt, Ge.last = wt;
            }
          }
          if (Ge.tail !== null) {
            var Kr = Ge.tail;
            Ge.rendering = Kr, Ge.tail = Kr.sibling, Ge.renderingStartTime = pn(), Kr.sibling = null;
            var Tr = O0.current;
            return _t ? Tr = qI(Tr, Ig) : Tr = Gu(Tr), Do(r, Tr), Kr;
          }
          return Z2(r), null;
        }
        case J1:
          break;
        case s1:
        case d1: {
          pp(r);
          var Sa = r.memoizedState, cc = Sa !== null;
          if (t !== null) {
            var Jg = t.memoizedState, mi = Jg !== null;
            mi !== cc && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !t1 && (r.flags |= $0);
          }
          return !cc || (r.mode & Te) === Se ? Z2(r) : br(hi, H2) && (Z2(r), r.subtreeFlags & (on | Ze) && (r.flags |= $0)), null;
        }
        case h1:
          return null;
        case C1:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function sD(t, r, u) {
      switch (EI(r), r.tag) {
        case m: {
          var f = r.type;
          gi(f) && E9(r);
          var C = r.flags;
          return C & f2 ? (r.flags = C & ~f2 | _e, (r.mode & Je) !== Se && x5(r), r) : null;
        }
        case S: {
          r.stateNode, Xu(r), bI(r), $I();
          var p = r.flags;
          return (p & f2) !== ze && (p & _e) === ze ? (r.flags = p & ~f2 | _e, r) : null;
        }
        case D:
          return XI(r), null;
        case H: {
          qu(r);
          var b = r.memoizedState;
          if (b !== null && b.dehydrated !== null) {
            if (r.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Ju();
          }
          var M = r.flags;
          return M & f2 ? (r.flags = M & ~f2 | _e, (r.mode & Je) !== Se && x5(r), r) : null;
        }
        case T1:
          return qu(r), null;
        case T:
          return Xu(r), null;
        case K:
          var O = r.type._context;
          return HI(O, r), null;
        case s1:
        case d1:
          return pp(r), null;
        case h1:
          return null;
        default:
          return null;
      }
    }
    function $v(t, r, u) {
      switch (EI(r), r.tag) {
        case m: {
          var f = r.type.childContextTypes;
          f != null && E9(r);
          break;
        }
        case S: {
          r.stateNode, Xu(r), bI(r), $I();
          break;
        }
        case D: {
          XI(r);
          break;
        }
        case T:
          Xu(r);
          break;
        case H:
          qu(r);
          break;
        case T1:
          qu(r);
          break;
        case K:
          var C = r.type._context;
          HI(C, r);
          break;
        case s1:
        case d1:
          pp(r);
          break;
      }
    }
    var ey = null;
    ey = /* @__PURE__ */ new Set();
    var hC = !1, $2 = !1, lD = typeof WeakSet == "function" ? WeakSet : Set, ye = null, rc = null, ic = null;
    function uD(t) {
      Gi(null, function() {
        throw t;
      }), f4();
    }
    var cD = function(t, r) {
      if (r.props = t.memoizedProps, r.state = t.memoizedState, t.mode & Je)
        try {
          Ii(), r.componentWillUnmount();
        } finally {
          Ai(t);
        }
      else
        r.componentWillUnmount();
    };
    function ty(t, r) {
      try {
        zo(E2, t);
      } catch (u) {
        un(t, r, u);
      }
    }
    function tp(t, r, u) {
      try {
        cD(t, u);
      } catch (f) {
        un(t, r, f);
      }
    }
    function gD(t, r, u) {
      try {
        u.componentDidMount();
      } catch (f) {
        un(t, r, f);
      }
    }
    function ny(t, r) {
      try {
        iy(t);
      } catch (u) {
        un(t, r, u);
      }
    }
    function ac(t, r) {
      var u = t.ref;
      if (u !== null)
        if (typeof u == "function") {
          var f;
          try {
            if (G1 && $1 && t.mode & Je)
              try {
                Ii(), f = u(null);
              } finally {
                Ai(t);
              }
            else
              f = u(null);
          } catch (C) {
            un(t, r, C);
          }
          typeof f == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Oe(t));
        } else
          u.current = null;
    }
    function mC(t, r, u) {
      try {
        u();
      } catch (f) {
        un(t, r, f);
      }
    }
    var ry = !1;
    function fD(t, r) {
      xL(t.containerInfo), ye = r, dD();
      var u = ry;
      return ry = !1, u;
    }
    function dD() {
      for (; ye !== null; ) {
        var t = ye, r = t.child;
        (t.subtreeFlags & Ya) !== ze && r !== null ? (r.return = t, ye = r) : CD();
      }
    }
    function CD() {
      for (; ye !== null; ) {
        var t = ye;
        Dt(t);
        try {
          AD(t);
        } catch (u) {
          un(t, t.return, u);
        }
        On();
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, ye = r;
          return;
        }
        ye = t.return;
      }
    }
    function AD(t) {
      var r = t.alternate, u = t.flags;
      if ((u & e3) !== ze) {
        switch (Dt(t), t.tag) {
          case h:
          case V:
          case Q:
            break;
          case m: {
            if (r !== null) {
              var f = r.memoizedProps, C = r.memoizedState, p = t.stateNode;
              t.type === t.elementType && !Zs && (p.props !== t.memoizedProps && c("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Oe(t) || "instance"), p.state !== t.memoizedState && c("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Oe(t) || "instance"));
              var b = p.getSnapshotBeforeUpdate(t.elementType === t.type ? f : k0(t.type, f), C);
              {
                var M = ey;
                b === void 0 && !M.has(t.type) && (M.add(t.type), c("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Oe(t)));
              }
              p.__reactInternalSnapshotBeforeUpdate = b;
            }
            break;
          }
          case S: {
            {
              var O = t.stateNode;
              XL(O.containerInfo);
            }
            break;
          }
          case D:
          case k:
          case T:
          case Y1:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        On();
      }
    }
    function z0(t, r, u) {
      var f = r.updateQueue, C = f !== null ? f.lastEffect : null;
      if (C !== null) {
        var p = C.next, b = p;
        do {
          if ((b.tag & t) === t) {
            var M = b.destroy;
            b.destroy = void 0, M !== void 0 && ((t & q2) !== C3 ? Td(r) : (t & E2) !== C3 && S3(r), (t & fi) !== C3 && Wg(!0), mC(r, u, M), (t & fi) !== C3 && Wg(!1), (t & q2) !== C3 ? Jl() : (t & E2) !== C3 && qa());
          }
          b = b.next;
        } while (b !== p);
      }
    }
    function zo(t, r) {
      var u = r.updateQueue, f = u !== null ? u.lastEffect : null;
      if (f !== null) {
        var C = f.next, p = C;
        do {
          if ((p.tag & t) === t) {
            (t & q2) !== C3 ? ni(r) : (t & E2) !== C3 && Ld(r);
            var b = p.create;
            (t & fi) !== C3 && Wg(!0), p.destroy = b(), (t & fi) !== C3 && Wg(!1), (t & q2) !== C3 ? _l() : (t & E2) !== C3 && hs();
            {
              var M = p.destroy;
              if (M !== void 0 && typeof M != "function") {
                var O = void 0;
                (p.tag & E2) !== ze ? O = "useLayoutEffect" : (p.tag & fi) !== ze ? O = "useInsertionEffect" : O = "useEffect";
                var P = void 0;
                M === null ? P = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof M.then == "function" ? P = `

It looks like you wrote ` + O + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + O + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : P = " You returned: " + M, c("%s must not return anything besides a function, which is used for clean-up.%s", O, P);
              }
            }
          }
          p = p.next;
        } while (p !== C);
      }
    }
    function ID(t, r) {
      if ((r.flags & Ze) !== ze)
        switch (r.tag) {
          case Y: {
            var u = r.stateNode.passiveEffectDuration, f = r.memoizedProps, C = f.id, p = f.onPostCommit, b = mv(), M = r.alternate === null ? "mount" : "update";
            hv() && (M = "nested-update"), typeof p == "function" && p(C, M, u, b);
            var O = r.return;
            e: for (; O !== null; ) {
              switch (O.tag) {
                case S:
                  var P = O.stateNode;
                  P.passiveEffectDuration += u;
                  break e;
                case Y:
                  var F = O.stateNode;
                  F.passiveEffectDuration += u;
                  break e;
              }
              O = O.return;
            }
            break;
          }
        }
    }
    function pD(t, r, u, f) {
      if ((u.flags & F2) !== ze)
        switch (u.tag) {
          case h:
          case V:
          case Q: {
            if (!$2)
              if (u.mode & Je)
                try {
                  Ii(), zo(E2 | S2, u);
                } finally {
                  Ai(u);
                }
              else
                zo(E2 | S2, u);
            break;
          }
          case m: {
            var C = u.stateNode;
            if (u.flags & Ze && !$2)
              if (r === null)
                if (u.type === u.elementType && !Zs && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Oe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Oe(u) || "instance")), u.mode & Je)
                  try {
                    Ii(), C.componentDidMount();
                  } finally {
                    Ai(u);
                  }
                else
                  C.componentDidMount();
              else {
                var p = u.elementType === u.type ? r.memoizedProps : k0(u.type, r.memoizedProps), b = r.memoizedState;
                if (u.type === u.elementType && !Zs && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Oe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Oe(u) || "instance")), u.mode & Je)
                  try {
                    Ii(), C.componentDidUpdate(p, b, C.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Ai(u);
                  }
                else
                  C.componentDidUpdate(p, b, C.__reactInternalSnapshotBeforeUpdate);
              }
            var M = u.updateQueue;
            M !== null && (u.type === u.elementType && !Zs && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Oe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Oe(u) || "instance")), V8(u, M, C));
            break;
          }
          case S: {
            var O = u.updateQueue;
            if (O !== null) {
              var P = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case D:
                    P = u.child.stateNode;
                    break;
                  case m:
                    P = u.child.stateNode;
                    break;
                }
              V8(u, O, P);
            }
            break;
          }
          case D: {
            var F = u.stateNode;
            if (r === null && u.flags & Ze) {
              var e1 = u.type, q = u.memoizedProps;
              zL(F, e1, q);
            }
            break;
          }
          case k:
            break;
          case T:
            break;
          case Y: {
            {
              var l1 = u.memoizedProps, g1 = l1.onCommit, A1 = l1.onRender, oe = u.stateNode.effectDuration, Ne = mv(), Le = r === null ? "mount" : "update";
              hv() && (Le = "nested-update"), typeof A1 == "function" && A1(u.memoizedProps.id, Le, u.actualDuration, u.treeBaseDuration, u.actualStartTime, Ne);
              {
                typeof g1 == "function" && g1(u.memoizedProps.id, Le, oe, Ne), Ck(u);
                var At = u.return;
                e: for (; At !== null; ) {
                  switch (At.tag) {
                    case S:
                      var dt = At.stateNode;
                      dt.effectDuration += oe;
                      break e;
                    case Y:
                      var i1 = At.stateNode;
                      i1.effectDuration += oe;
                      break e;
                  }
                  At = At.return;
                }
              }
            }
            break;
          }
          case H: {
            SD(t, u);
            break;
          }
          case T1:
          case Y1:
          case J1:
          case s1:
          case d1:
          case C1:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      $2 || u.flags & Cr && iy(u);
    }
    function hD(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          if (t.mode & Je)
            try {
              Ii(), ty(t, t.return);
            } finally {
              Ai(t);
            }
          else
            ty(t, t.return);
          break;
        }
        case m: {
          var r = t.stateNode;
          typeof r.componentDidMount == "function" && gD(t, t.return, r), ny(t, t.return);
          break;
        }
        case D: {
          ny(t, t.return);
          break;
        }
      }
    }
    function mD(t, r) {
      for (var u = null, f = t; ; ) {
        if (f.tag === D) {
          if (u === null) {
            u = f;
            try {
              var C = f.stateNode;
              r ? JL(C) : YL(f.stateNode, f.memoizedProps);
            } catch (b) {
              un(t, t.return, b);
            }
          }
        } else if (f.tag === k) {
          if (u === null)
            try {
              var p = f.stateNode;
              r ? KL(p) : QL(p, f.memoizedProps);
            } catch (b) {
              un(t, t.return, b);
            }
        } else if (!((f.tag === s1 || f.tag === d1) && f.memoizedState !== null && f !== t)) {
          if (f.child !== null) {
            f.child.return = f, f = f.child;
            continue;
          }
        }
        if (f === t)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === t)
            return;
          u === f && (u = null), f = f.return;
        }
        u === f && (u = null), f.sibling.return = f.return, f = f.sibling;
      }
    }
    function iy(t) {
      var r = t.ref;
      if (r !== null) {
        var u = t.stateNode, f;
        switch (t.tag) {
          case D:
            f = u;
            break;
          default:
            f = u;
        }
        if (typeof r == "function") {
          var C;
          if (t.mode & Je)
            try {
              Ii(), C = r(f);
            } finally {
              Ai(t);
            }
          else
            C = r(f);
          typeof C == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Oe(t));
        } else
          r.hasOwnProperty("current") || c("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Oe(t)), r.current = f;
      }
    }
    function vD(t) {
      var r = t.alternate;
      r !== null && (r.return = null), t.return = null;
    }
    function ay(t) {
      var r = t.alternate;
      r !== null && (t.alternate = null, ay(r));
      {
        if (t.child = null, t.deletions = null, t.sibling = null, t.tag === D) {
          var u = t.stateNode;
          u !== null && ER(u);
        }
        t.stateNode = null, t._debugOwner = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
      }
    }
    function yD(t) {
      for (var r = t.return; r !== null; ) {
        if (oy(r))
          return r;
        r = r.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function oy(t) {
      return t.tag === D || t.tag === S || t.tag === T;
    }
    function sy(t) {
      var r = t;
      e: for (; ; ) {
        for (; r.sibling === null; ) {
          if (r.return === null || oy(r.return))
            return null;
          r = r.return;
        }
        for (r.sibling.return = r.return, r = r.sibling; r.tag !== D && r.tag !== k && r.tag !== O1; ) {
          if (r.flags & on || r.child === null || r.tag === T)
            continue e;
          r.child.return = r, r = r.child;
        }
        if (!(r.flags & on))
          return r.stateNode;
      }
    }
    function bD(t) {
      var r = yD(t);
      switch (r.tag) {
        case D: {
          var u = r.stateNode;
          r.flags & kt && (u8(u), r.flags &= ~kt);
          var f = sy(t);
          rp(t, f, u);
          break;
        }
        case S:
        case T: {
          var C = r.stateNode.containerInfo, p = sy(t);
          np(t, p, C);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function np(t, r, u) {
      var f = t.tag, C = f === D || f === k;
      if (C) {
        var p = t.stateNode;
        r ? UL(u, p, r) : BL(u, p);
      } else if (f !== T) {
        var b = t.child;
        if (b !== null) {
          np(b, r, u);
          for (var M = b.sibling; M !== null; )
            np(M, r, u), M = M.sibling;
        }
      }
    }
    function rp(t, r, u) {
      var f = t.tag, C = f === D || f === k;
      if (C) {
        var p = t.stateNode;
        r ? HL(u, p, r) : FL(u, p);
      } else if (f !== T) {
        var b = t.child;
        if (b !== null) {
          rp(b, r, u);
          for (var M = b.sibling; M !== null; )
            rp(M, r, u), M = M.sibling;
        }
      }
    }
    var er = null, N0 = !1;
    function wD(t, r, u) {
      {
        var f = r;
        e: for (; f !== null; ) {
          switch (f.tag) {
            case D: {
              er = f.stateNode, N0 = !1;
              break e;
            }
            case S: {
              er = f.stateNode.containerInfo, N0 = !0;
              break e;
            }
            case T: {
              er = f.stateNode.containerInfo, N0 = !0;
              break e;
            }
          }
          f = f.return;
        }
        if (er === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        ly(t, r, u), er = null, N0 = !1;
      }
      vD(u);
    }
    function No(t, r, u) {
      for (var f = u.child; f !== null; )
        ly(t, r, f), f = f.sibling;
    }
    function ly(t, r, u) {
      switch ($i(u), u.tag) {
        case D:
          $2 || ac(u, r);
        case k: {
          {
            var f = er, C = N0;
            er = null, No(t, r, u), er = f, N0 = C, er !== null && (N0 ? VL(er, u.stateNode) : WL(er, u.stateNode));
          }
          return;
        }
        case O1: {
          er !== null && (N0 ? _L(er, u.stateNode) : CI(er, u.stateNode));
          return;
        }
        case T: {
          {
            var p = er, b = N0;
            er = u.stateNode.containerInfo, N0 = !0, No(t, r, u), er = p, N0 = b;
          }
          return;
        }
        case h:
        case V:
        case Z:
        case Q: {
          if (!$2) {
            var M = u.updateQueue;
            if (M !== null) {
              var O = M.lastEffect;
              if (O !== null) {
                var P = O.next, F = P;
                do {
                  var e1 = F, q = e1.destroy, l1 = e1.tag;
                  q !== void 0 && ((l1 & fi) !== C3 ? mC(u, r, q) : (l1 & E2) !== C3 && (S3(u), u.mode & Je ? (Ii(), mC(u, r, q), Ai(u)) : mC(u, r, q), qa())), F = F.next;
                } while (F !== P);
              }
            }
          }
          No(t, r, u);
          return;
        }
        case m: {
          if (!$2) {
            ac(u, r);
            var g1 = u.stateNode;
            typeof g1.componentWillUnmount == "function" && tp(u, r, g1);
          }
          No(t, r, u);
          return;
        }
        case J1: {
          No(t, r, u);
          return;
        }
        case s1: {
          if (
            // TODO: Remove this dead flag
            u.mode & Te
          ) {
            var A1 = $2;
            $2 = A1 || u.memoizedState !== null, No(t, r, u), $2 = A1;
          } else
            No(t, r, u);
          break;
        }
        default: {
          No(t, r, u);
          return;
        }
      }
    }
    function xD(t) {
      t.memoizedState;
    }
    function SD(t, r) {
      var u = r.memoizedState;
      if (u === null) {
        var f = r.alternate;
        if (f !== null) {
          var C = f.memoizedState;
          if (C !== null) {
            var p = C.dehydrated;
            p !== null && uR(p);
          }
        }
      }
    }
    function uy(t) {
      var r = t.updateQueue;
      if (r !== null) {
        t.updateQueue = null;
        var u = t.stateNode;
        u === null && (u = t.stateNode = new lD()), r.forEach(function(f) {
          var C = yk.bind(null, t, f);
          if (!u.has(f)) {
            if (u.add(f), Br)
              if (rc !== null && ic !== null)
                Ug(ic, rc);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            f.then(C, C);
          }
        });
      }
    }
    function ED(t, r, u) {
      rc = u, ic = t, Dt(r), cy(r, t), Dt(r), rc = null, ic = null;
    }
    function P0(t, r, u) {
      var f = r.deletions;
      if (f !== null)
        for (var C = 0; C < f.length; C++) {
          var p = f[C];
          try {
            wD(t, r, p);
          } catch (O) {
            un(p, r, O);
          }
        }
      var b = Vc();
      if (r.subtreeFlags & pr)
        for (var M = r.child; M !== null; )
          Dt(M), cy(M, t), M = M.sibling;
      Dt(b);
    }
    function cy(t, r, u) {
      var f = t.alternate, C = t.flags;
      switch (t.tag) {
        case h:
        case V:
        case Z:
        case Q: {
          if (P0(r, t), pi(t), C & Ze) {
            try {
              z0(fi | S2, t, t.return), zo(fi | S2, t);
            } catch (Ve) {
              un(t, t.return, Ve);
            }
            if (t.mode & Je) {
              try {
                Ii(), z0(E2 | S2, t, t.return);
              } catch (Ve) {
                un(t, t.return, Ve);
              }
              Ai(t);
            } else
              try {
                z0(E2 | S2, t, t.return);
              } catch (Ve) {
                un(t, t.return, Ve);
              }
          }
          return;
        }
        case m: {
          P0(r, t), pi(t), C & Cr && f !== null && ac(f, f.return);
          return;
        }
        case D: {
          P0(r, t), pi(t), C & Cr && f !== null && ac(f, f.return);
          {
            if (t.flags & kt) {
              var p = t.stateNode;
              try {
                u8(p);
              } catch (Ve) {
                un(t, t.return, Ve);
              }
            }
            if (C & Ze) {
              var b = t.stateNode;
              if (b != null) {
                var M = t.memoizedProps, O = f !== null ? f.memoizedProps : M, P = t.type, F = t.updateQueue;
                if (t.updateQueue = null, F !== null)
                  try {
                    NL(b, F, P, O, M, t);
                  } catch (Ve) {
                    un(t, t.return, Ve);
                  }
              }
            }
          }
          return;
        }
        case k: {
          if (P0(r, t), pi(t), C & Ze) {
            if (t.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var e1 = t.stateNode, q = t.memoizedProps, l1 = f !== null ? f.memoizedProps : q;
            try {
              PL(e1, l1, q);
            } catch (Ve) {
              un(t, t.return, Ve);
            }
          }
          return;
        }
        case S: {
          if (P0(r, t), pi(t), C & Ze && f !== null) {
            var g1 = f.memoizedState;
            if (g1.isDehydrated)
              try {
                lR(r.containerInfo);
              } catch (Ve) {
                un(t, t.return, Ve);
              }
          }
          return;
        }
        case T: {
          P0(r, t), pi(t);
          return;
        }
        case H: {
          P0(r, t), pi(t);
          var A1 = t.child;
          if (A1.flags & $0) {
            var oe = A1.stateNode, Ne = A1.memoizedState, Le = Ne !== null;
            if (oe.isHidden = Le, Le) {
              var At = A1.alternate !== null && A1.alternate.memoizedState !== null;
              At || ok();
            }
          }
          if (C & Ze) {
            try {
              xD(t);
            } catch (Ve) {
              un(t, t.return, Ve);
            }
            uy(t);
          }
          return;
        }
        case s1: {
          var dt = f !== null && f.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            t.mode & Te
          ) {
            var i1 = $2;
            $2 = i1 || dt, P0(r, t), $2 = i1;
          } else
            P0(r, t);
          if (pi(t), C & $0) {
            var I1 = t.stateNode, a1 = t.memoizedState, N1 = a1 !== null, de = t;
            if (I1.isHidden = N1, N1 && !dt && (de.mode & Te) !== Se) {
              ye = de;
              for (var ce = de.child; ce !== null; )
                ye = ce, TD(ce), ce = ce.sibling;
            }
            mD(de, N1);
          }
          return;
        }
        case T1: {
          P0(r, t), pi(t), C & Ze && uy(t);
          return;
        }
        case J1:
          return;
        default: {
          P0(r, t), pi(t);
          return;
        }
      }
    }
    function pi(t) {
      var r = t.flags;
      if (r & on) {
        try {
          bD(t);
        } catch (u) {
          un(t, t.return, u);
        }
        t.flags &= ~on;
      }
      r & t3 && (t.flags &= ~t3);
    }
    function MD(t, r, u) {
      rc = u, ic = r, ye = t, gy(t, r, u), rc = null, ic = null;
    }
    function gy(t, r, u) {
      for (var f = (t.mode & Te) !== Se; ye !== null; ) {
        var C = ye, p = C.child;
        if (C.tag === s1 && f) {
          var b = C.memoizedState !== null, M = b || hC;
          if (M) {
            ip(t, r, u);
            continue;
          } else {
            var O = C.alternate, P = O !== null && O.memoizedState !== null, F = P || $2, e1 = hC, q = $2;
            hC = M, $2 = F, $2 && !q && (ye = C, LD(C));
            for (var l1 = p; l1 !== null; )
              ye = l1, gy(
                l1,
                // New root; bubble back up to here and stop.
                r,
                u
              ), l1 = l1.sibling;
            ye = C, hC = e1, $2 = q, ip(t, r, u);
            continue;
          }
        }
        (C.subtreeFlags & F2) !== ze && p !== null ? (p.return = C, ye = p) : ip(t, r, u);
      }
    }
    function ip(t, r, u) {
      for (; ye !== null; ) {
        var f = ye;
        if ((f.flags & F2) !== ze) {
          var C = f.alternate;
          Dt(f);
          try {
            pD(r, C, f, u);
          } catch (b) {
            un(f, f.return, b);
          }
          On();
        }
        if (f === t) {
          ye = null;
          return;
        }
        var p = f.sibling;
        if (p !== null) {
          p.return = f.return, ye = p;
          return;
        }
        ye = f.return;
      }
    }
    function TD(t) {
      for (; ye !== null; ) {
        var r = ye, u = r.child;
        switch (r.tag) {
          case h:
          case V:
          case Z:
          case Q: {
            if (r.mode & Je)
              try {
                Ii(), z0(E2, r, r.return);
              } finally {
                Ai(r);
              }
            else
              z0(E2, r, r.return);
            break;
          }
          case m: {
            ac(r, r.return);
            var f = r.stateNode;
            typeof f.componentWillUnmount == "function" && tp(r, r.return, f);
            break;
          }
          case D: {
            ac(r, r.return);
            break;
          }
          case s1: {
            var C = r.memoizedState !== null;
            if (C) {
              fy(t);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = r, ye = u) : fy(t);
      }
    }
    function fy(t) {
      for (; ye !== null; ) {
        var r = ye;
        if (r === t) {
          ye = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, ye = u;
          return;
        }
        ye = r.return;
      }
    }
    function LD(t) {
      for (; ye !== null; ) {
        var r = ye, u = r.child;
        if (r.tag === s1) {
          var f = r.memoizedState !== null;
          if (f) {
            dy(t);
            continue;
          }
        }
        u !== null ? (u.return = r, ye = u) : dy(t);
      }
    }
    function dy(t) {
      for (; ye !== null; ) {
        var r = ye;
        Dt(r);
        try {
          hD(r);
        } catch (f) {
          un(r, r.return, f);
        }
        if (On(), r === t) {
          ye = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, ye = u;
          return;
        }
        ye = r.return;
      }
    }
    function RD(t, r, u, f) {
      ye = r, OD(r, t, u, f);
    }
    function OD(t, r, u, f) {
      for (; ye !== null; ) {
        var C = ye, p = C.child;
        (C.subtreeFlags & n3) !== ze && p !== null ? (p.return = C, ye = p) : DD(t, r, u, f);
      }
    }
    function DD(t, r, u, f) {
      for (; ye !== null; ) {
        var C = ye;
        if ((C.flags & fn) !== ze) {
          Dt(C);
          try {
            kD(r, C, u, f);
          } catch (b) {
            un(C, C.return, b);
          }
          On();
        }
        if (C === t) {
          ye = null;
          return;
        }
        var p = C.sibling;
        if (p !== null) {
          p.return = C.return, ye = p;
          return;
        }
        ye = C.return;
      }
    }
    function kD(t, r, u, f) {
      switch (r.tag) {
        case h:
        case V:
        case Q: {
          if (r.mode & Je) {
            w5();
            try {
              zo(q2 | S2, r);
            } finally {
              b5(r);
            }
          } else
            zo(q2 | S2, r);
          break;
        }
      }
    }
    function jD(t) {
      ye = t, zD();
    }
    function zD() {
      for (; ye !== null; ) {
        var t = ye, r = t.child;
        if ((ye.flags & Mt) !== ze) {
          var u = t.deletions;
          if (u !== null) {
            for (var f = 0; f < u.length; f++) {
              var C = u[f];
              ye = C, FD(C, t);
            }
            {
              var p = t.alternate;
              if (p !== null) {
                var b = p.child;
                if (b !== null) {
                  p.child = null;
                  do {
                    var M = b.sibling;
                    b.sibling = null, b = M;
                  } while (b !== null);
                }
              }
            }
            ye = t;
          }
        }
        (t.subtreeFlags & n3) !== ze && r !== null ? (r.return = t, ye = r) : ND();
      }
    }
    function ND() {
      for (; ye !== null; ) {
        var t = ye;
        (t.flags & fn) !== ze && (Dt(t), PD(t), On());
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, ye = r;
          return;
        }
        ye = t.return;
      }
    }
    function PD(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          t.mode & Je ? (w5(), z0(q2 | S2, t, t.return), b5(t)) : z0(q2 | S2, t, t.return);
          break;
        }
      }
    }
    function FD(t, r) {
      for (; ye !== null; ) {
        var u = ye;
        Dt(u), HD(u, r), On();
        var f = u.child;
        f !== null ? (f.return = u, ye = f) : BD(t);
      }
    }
    function BD(t) {
      for (; ye !== null; ) {
        var r = ye, u = r.sibling, f = r.return;
        if (ay(r), r === t) {
          ye = null;
          return;
        }
        if (u !== null) {
          u.return = f, ye = u;
          return;
        }
        ye = f;
      }
    }
    function HD(t, r) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          t.mode & Je ? (w5(), z0(q2, t, r), b5(t)) : z0(q2, t, r);
          break;
        }
      }
    }
    function UD(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          try {
            zo(E2 | S2, t);
          } catch (u) {
            un(t, t.return, u);
          }
          break;
        }
        case m: {
          var r = t.stateNode;
          try {
            r.componentDidMount();
          } catch (u) {
            un(t, t.return, u);
          }
          break;
        }
      }
    }
    function WD(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          try {
            zo(q2 | S2, t);
          } catch (r) {
            un(t, t.return, r);
          }
          break;
        }
      }
    }
    function VD(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q: {
          try {
            z0(E2 | S2, t, t.return);
          } catch (u) {
            un(t, t.return, u);
          }
          break;
        }
        case m: {
          var r = t.stateNode;
          typeof r.componentWillUnmount == "function" && tp(t, t.return, r);
          break;
        }
      }
    }
    function _D(t) {
      switch (t.tag) {
        case h:
        case V:
        case Q:
          try {
            z0(q2 | S2, t, t.return);
          } catch (r) {
            un(t, t.return, r);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Rg = Symbol.for;
      Rg("selector.component"), Rg("selector.has_pseudo_class"), Rg("selector.role"), Rg("selector.test_id"), Rg("selector.text");
    }
    var JD = [];
    function KD() {
      JD.forEach(function(t) {
        return t();
      });
    }
    var YD = i.ReactCurrentActQueue;
    function QD(t) {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && r !== !1;
      }
    }
    function Cy() {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !t && YD.current !== null && c("The current testing environment is not configured to support act(...)"), t;
      }
    }
    var XD = Math.ceil, ap = i.ReactCurrentDispatcher, op = i.ReactCurrentOwner, tr = i.ReactCurrentBatchConfig, F0 = i.ReactCurrentActQueue, L2 = (
      /*             */
      0
    ), Ay = (
      /*               */
      1
    ), nr = (
      /*                */
      2
    ), Z3 = (
      /*                */
      4
    ), ya = 0, Og = 1, $s = 2, vC = 3, Dg = 4, Iy = 5, sp = 6, Ct = L2, Vr = null, zn = null, R2 = w1, hi = w1, lp = Eo(w1), O2 = ya, kg = null, yC = w1, jg = w1, bC = w1, zg = null, A3 = null, up = 0, py = 500, hy = 1 / 0, GD = 500, ba = null;
    function Ng() {
      hy = pn() + GD;
    }
    function my() {
      return hy;
    }
    var wC = !1, cp = null, oc = null, el = !1, Po = null, Pg = w1, gp = [], fp = null, qD = 50, Fg = 0, dp = null, Cp = !1, xC = !1, ZD = 50, sc = 0, SC = null, Bg = an, EC = w1, vy = !1;
    function MC() {
      return Vr;
    }
    function _r() {
      return (Ct & (nr | Z3)) !== L2 ? pn() : (Bg !== an || (Bg = pn()), Bg);
    }
    function Fo(t) {
      var r = t.mode;
      if ((r & Te) === Se)
        return Re;
      if ((Ct & nr) !== L2 && R2 !== w1)
        return oo(R2);
      var u = YR() !== KR;
      if (u) {
        if (tr.transition !== null) {
          var f = tr.transition;
          f._updatedFibers || (f._updatedFibers = /* @__PURE__ */ new Set()), f._updatedFibers.add(t);
        }
        return EC === Wn && (EC = Bd()), EC;
      }
      var C = s3();
      if (C !== Wn)
        return C;
      var p = OL();
      return p;
    }
    function $D(t) {
      var r = t.mode;
      return (r & Te) === Se ? Re : yr();
    }
    function D2(t, r, u, f) {
      wk(), vy && c("useInsertionEffect must not schedule updates."), Cp && (xC = !0), sa(t, u, f), (Ct & nr) !== w1 && t === Vr ? Ek(r) : (Br && Cu(t, r, u), Mk(r), t === Vr && ((Ct & nr) === L2 && (jg = qe(jg, u)), O2 === Dg && Bo(t, R2)), I3(t, f), u === Re && Ct === L2 && (r.mode & Te) === Se && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !F0.isBatchingLegacy && (Ng(), v8()));
    }
    function ek(t, r, u) {
      var f = t.current;
      f.lanes = r, sa(t, r, u), I3(t, u);
    }
    function tk(t) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Ct & nr) !== L2
      );
    }
    function I3(t, r) {
      var u = t.callbackNode;
      jd(t, r);
      var f = aa(t, t === Vr ? R2 : w1);
      if (f === w1) {
        u !== null && Ny(u), t.callbackNode = null, t.callbackPriority = Wn;
        return;
      }
      var C = Dn(f), p = t.callbackPriority;
      if (p === C && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(F0.current !== null && u !== yp)) {
        u == null && p !== Re && c("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && Ny(u);
      var b;
      if (C === Re)
        t.tag === Mo ? (F0.isBatchingLegacy !== null && (F0.didScheduleLegacyUpdate = !0), LR(wy.bind(null, t))) : m8(wy.bind(null, t)), F0.current !== null ? F0.current.push(To) : kL(function() {
          (Ct & (nr | Z3)) === L2 && To();
        }), b = null;
      else {
        var M;
        switch (x2(f)) {
          case kn:
            M = Ul;
            break;
          case x0:
            M = Zi;
            break;
          case V3:
            M = W3;
            break;
          case so:
            M = Wl;
            break;
          default:
            M = W3;
            break;
        }
        b = bp(M, yy.bind(null, t));
      }
      t.callbackPriority = C, t.callbackNode = b;
    }
    function yy(t, r) {
      if (mO(), Bg = an, EC = w1, (Ct & (nr | Z3)) !== L2)
        throw new Error("Should not already be working.");
      var u = t.callbackNode, f = xa();
      if (f && t.callbackNode !== u)
        return null;
      var C = aa(t, t === Vr ? R2 : w1);
      if (C === w1)
        return null;
      var p = !Es(t, C) && !Fd(t, C) && !r, b = p ? gk(t, C) : LC(t, C);
      if (b !== ya) {
        if (b === $s) {
          var M = ii(t);
          M !== w1 && (C = M, b = Ap(t, M));
        }
        if (b === Og) {
          var O = kg;
          throw tl(t, w1), Bo(t, C), I3(t, pn()), O;
        }
        if (b === sp)
          Bo(t, C);
        else {
          var P = !Es(t, C), F = t.current.alternate;
          if (P && !rk(F)) {
            if (b = LC(t, C), b === $s) {
              var e1 = ii(t);
              e1 !== w1 && (C = e1, b = Ap(t, e1));
            }
            if (b === Og) {
              var q = kg;
              throw tl(t, w1), Bo(t, C), I3(t, pn()), q;
            }
          }
          t.finishedWork = F, t.finishedLanes = C, nk(t, b, C);
        }
      }
      return I3(t, pn()), t.callbackNode === u ? yy.bind(null, t) : null;
    }
    function Ap(t, r) {
      var u = zg;
      if (Au(t)) {
        var f = tl(t, r);
        f.flags |= xn, bR(t.containerInfo);
      }
      var C = LC(t, r);
      if (C !== $s) {
        var p = A3;
        A3 = u, p !== null && by(p);
      }
      return C;
    }
    function by(t) {
      A3 === null ? A3 = t : A3.push.apply(A3, t);
    }
    function nk(t, r, u) {
      switch (r) {
        case ya:
        case Og:
          throw new Error("Root did not complete. This is a bug in React.");
        case $s: {
          nl(t, A3, ba);
          break;
        }
        case vC: {
          if (Bo(t, u), zd(u) && // do not delay if we're inside an act() scope
          !Py()) {
            var f = up + py - pn();
            if (f > 10) {
              var C = aa(t, w1);
              if (C !== w1)
                break;
              var p = t.suspendedLanes;
              if (!oa(p, u)) {
                _r(), fu(t, p);
                break;
              }
              t.timeoutHandle = fI(nl.bind(null, t, A3, ba), f);
              break;
            }
          }
          nl(t, A3, ba);
          break;
        }
        case Dg: {
          if (Bo(t, u), Pd(u))
            break;
          if (!Py()) {
            var b = Dd(t, u), M = b, O = pn() - M, P = bk(O) - O;
            if (P > 10) {
              t.timeoutHandle = fI(nl.bind(null, t, A3, ba), P);
              break;
            }
          }
          nl(t, A3, ba);
          break;
        }
        case Iy: {
          nl(t, A3, ba);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function rk(t) {
      for (var r = t; ; ) {
        if (r.flags & Is) {
          var u = r.updateQueue;
          if (u !== null) {
            var f = u.stores;
            if (f !== null)
              for (var C = 0; C < f.length; C++) {
                var p = f[C], b = p.getSnapshot, M = p.value;
                try {
                  if (!ve(b(), M))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var O = r.child;
        if (r.subtreeFlags & Is && O !== null) {
          O.return = r, r = O;
          continue;
        }
        if (r === t)
          return !0;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return !0;
    }
    function Bo(t, r) {
      r = Ms(r, bC), r = Ms(r, jg), Ud(t, r);
    }
    function wy(t) {
      if (vO(), (Ct & (nr | Z3)) !== L2)
        throw new Error("Should not already be working.");
      xa();
      var r = aa(t, w1);
      if (!br(r, Re))
        return I3(t, pn()), null;
      var u = LC(t, r);
      if (t.tag !== Mo && u === $s) {
        var f = ii(t);
        f !== w1 && (r = f, u = Ap(t, f));
      }
      if (u === Og) {
        var C = kg;
        throw tl(t, w1), Bo(t, r), I3(t, pn()), C;
      }
      if (u === sp)
        throw new Error("Root did not complete. This is a bug in React.");
      var p = t.current.alternate;
      return t.finishedWork = p, t.finishedLanes = r, nl(t, A3, ba), I3(t, pn()), null;
    }
    function ik(t, r) {
      r !== w1 && (L4(t, qe(r, Re)), I3(t, pn()), (Ct & (nr | Z3)) === L2 && (Ng(), To()));
    }
    function Ip(t, r) {
      var u = Ct;
      Ct |= Ay;
      try {
        return t(r);
      } finally {
        Ct = u, Ct === L2 && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !F0.isBatchingLegacy && (Ng(), v8());
      }
    }
    function ak(t, r, u, f, C) {
      var p = s3(), b = tr.transition;
      try {
        return tr.transition = null, Sn(kn), t(r, u, f, C);
      } finally {
        Sn(p), tr.transition = b, Ct === L2 && Ng();
      }
    }
    function wa(t) {
      Po !== null && Po.tag === Mo && (Ct & (nr | Z3)) === L2 && xa();
      var r = Ct;
      Ct |= Ay;
      var u = tr.transition, f = s3();
      try {
        return tr.transition = null, Sn(kn), t ? t() : void 0;
      } finally {
        Sn(f), tr.transition = u, Ct = r, (Ct & (nr | Z3)) === L2 && To();
      }
    }
    function xy() {
      return (Ct & (nr | Z3)) !== L2;
    }
    function TC(t, r) {
      Sr(lp, hi, t), hi = qe(hi, r);
    }
    function pp(t) {
      hi = lp.current, xr(lp, t);
    }
    function tl(t, r) {
      t.finishedWork = null, t.finishedLanes = w1;
      var u = t.timeoutHandle;
      if (u !== dI && (t.timeoutHandle = dI, DL(u)), zn !== null)
        for (var f = zn.return; f !== null; ) {
          var C = f.alternate;
          $v(C, f), f = f.return;
        }
      Vr = t;
      var p = rl(t.current, null);
      return zn = p, R2 = hi = r, O2 = ya, kg = null, yC = w1, jg = w1, bC = w1, zg = null, A3 = null, eO(), R0.discardPendingWarnings(), p;
    }
    function Sy(t, r) {
      do {
        var u = zn;
        try {
          if (F9(), X8(), On(), op.current = null, u === null || u.return === null) {
            O2 = Og, kg = r, zn = null;
            return;
          }
          if (G1 && u.mode & Je && dC(u, !0), le)
            if (mr(), r !== null && typeof r == "object" && typeof r.then == "function") {
              var f = r;
              ea(u, f, R2);
            } else
              ms(u, r, R2);
          LO(t, u.return, u, r, R2), Ly(u);
        } catch (C) {
          r = C, zn === u && u !== null ? (u = u.return, zn = u) : u = zn;
          continue;
        }
        return;
      } while (!0);
    }
    function Ey() {
      var t = ap.current;
      return ap.current = lC, t === null ? lC : t;
    }
    function My(t) {
      ap.current = t;
    }
    function ok() {
      up = pn();
    }
    function Hg(t) {
      yC = qe(t, yC);
    }
    function sk() {
      O2 === ya && (O2 = vC);
    }
    function hp() {
      (O2 === ya || O2 === vC || O2 === $s) && (O2 = Dg), Vr !== null && (Ss(yC) || Ss(jg)) && Bo(Vr, R2);
    }
    function lk(t) {
      O2 !== Dg && (O2 = $s), zg === null ? zg = [t] : zg.push(t);
    }
    function uk() {
      return O2 === ya;
    }
    function LC(t, r) {
      var u = Ct;
      Ct |= nr;
      var f = Ey();
      if (Vr !== t || R2 !== r) {
        if (Br) {
          var C = t.memoizedUpdaters;
          C.size > 0 && (Ug(t, R2), C.clear()), R4(t, r);
        }
        ba = Ls(), tl(t, r);
      }
      dn(r);
      do
        try {
          ck();
          break;
        } catch (p) {
          Sy(t, p);
        }
      while (!0);
      if (F9(), Ct = u, My(f), zn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Yl(), Vr = null, R2 = w1, O2;
    }
    function ck() {
      for (; zn !== null; )
        Ty(zn);
    }
    function gk(t, r) {
      var u = Ct;
      Ct |= nr;
      var f = Ey();
      if (Vr !== t || R2 !== r) {
        if (Br) {
          var C = t.memoizedUpdaters;
          C.size > 0 && (Ug(t, R2), C.clear()), R4(t, r);
        }
        ba = Ls(), Ng(), tl(t, r);
      }
      dn(r);
      do
        try {
          fk();
          break;
        } catch (p) {
          Sy(t, p);
        }
      while (!0);
      return F9(), My(f), Ct = u, zn !== null ? (Kl(), ya) : (Yl(), Vr = null, R2 = w1, O2);
    }
    function fk() {
      for (; zn !== null && !Hl(); )
        Ty(zn);
    }
    function Ty(t) {
      var r = t.alternate;
      Dt(t);
      var u;
      (t.mode & Je) !== Se ? (y5(t), u = mp(r, t, hi), dC(t, !0)) : u = mp(r, t, hi), On(), t.memoizedProps = t.pendingProps, u === null ? Ly(t) : zn = u, op.current = null;
    }
    function Ly(t) {
      var r = t;
      do {
        var u = r.alternate, f = r.return;
        if ((r.flags & Nr) === ze) {
          Dt(r);
          var C = void 0;
          if ((r.mode & Je) === Se ? C = Zv(u, r, hi) : (y5(r), C = Zv(u, r, hi), dC(r, !1)), On(), C !== null) {
            zn = C;
            return;
          }
        } else {
          var p = sD(u, r);
          if (p !== null) {
            p.flags &= yd, zn = p;
            return;
          }
          if ((r.mode & Je) !== Se) {
            dC(r, !1);
            for (var b = r.actualDuration, M = r.child; M !== null; )
              b += M.actualDuration, M = M.sibling;
            r.actualDuration = b;
          }
          if (f !== null)
            f.flags |= Nr, f.subtreeFlags = ze, f.deletions = null;
          else {
            O2 = sp, zn = null;
            return;
          }
        }
        var O = r.sibling;
        if (O !== null) {
          zn = O;
          return;
        }
        r = f, zn = r;
      } while (r !== null);
      O2 === ya && (O2 = Iy);
    }
    function nl(t, r, u) {
      var f = s3(), C = tr.transition;
      try {
        tr.transition = null, Sn(kn), dk(t, r, u, f);
      } finally {
        tr.transition = C, Sn(f);
      }
      return null;
    }
    function dk(t, r, u, f) {
      do
        xa();
      while (Po !== null);
      if (xk(), (Ct & (nr | Z3)) !== L2)
        throw new Error("Should not already be working.");
      var C = t.finishedWork, p = t.finishedLanes;
      if (ti(p), C === null)
        return Vl(), null;
      if (p === w1 && c("root.finishedLanes should not be empty during a commit. This is a bug in React."), t.finishedWork = null, t.finishedLanes = w1, C === t.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      t.callbackNode = null, t.callbackPriority = Wn;
      var b = qe(C.lanes, C.childLanes);
      du(t, b), t === Vr && (Vr = null, zn = null, R2 = w1), ((C.subtreeFlags & n3) !== ze || (C.flags & n3) !== ze) && (el || (el = !0, fp = u, bp(W3, function() {
        return xa(), null;
      })));
      var M = (C.subtreeFlags & (Ya | pr | F2 | n3)) !== ze, O = (C.flags & (Ya | pr | F2 | n3)) !== ze;
      if (M || O) {
        var P = tr.transition;
        tr.transition = null;
        var F = s3();
        Sn(kn);
        var e1 = Ct;
        Ct |= Z3, op.current = null, fD(t, C), vv(), ED(t, C, p), SL(t.containerInfo), t.current = C, y4(p), MD(C, t, p), Za(), xd(), Ct = e1, Sn(F), tr.transition = P;
      } else
        t.current = C, vv();
      var q = el;
      if (el ? (el = !1, Po = t, Pg = p) : (sc = 0, SC = null), b = t.pendingLanes, b === w1 && (oc = null), q || ky(t.current, !1), Xa(C.stateNode, f), Br && t.memoizedUpdaters.clear(), KD(), I3(t, pn()), r !== null)
        for (var l1 = t.onRecoverableError, g1 = 0; g1 < r.length; g1++) {
          var A1 = r[g1], oe = A1.stack, Ne = A1.digest;
          l1(A1.value, {
            componentStack: oe,
            digest: Ne
          });
        }
      if (wC) {
        wC = !1;
        var Le = cp;
        throw cp = null, Le;
      }
      return br(Pg, Re) && t.tag !== Mo && xa(), b = t.pendingLanes, br(b, Re) ? (hO(), t === dp ? Fg++ : (Fg = 0, dp = t)) : Fg = 0, To(), Vl(), null;
    }
    function xa() {
      if (Po !== null) {
        var t = x2(Pg), r = P6(V3, t), u = tr.transition, f = s3();
        try {
          return tr.transition = null, Sn(r), Ak();
        } finally {
          Sn(f), tr.transition = u;
        }
      }
      return !1;
    }
    function Ck(t) {
      gp.push(t), el || (el = !0, bp(W3, function() {
        return xa(), null;
      }));
    }
    function Ak() {
      if (Po === null)
        return !1;
      var t = fp;
      fp = null;
      var r = Po, u = Pg;
      if (Po = null, Pg = w1, (Ct & (nr | Z3)) !== L2)
        throw new Error("Cannot flush passive effects while already rendering.");
      Cp = !0, xC = !1, Rd(u);
      var f = Ct;
      Ct |= Z3, jD(r.current), RD(r, r.current, u, t);
      {
        var C = gp;
        gp = [];
        for (var p = 0; p < C.length; p++) {
          var b = C[p];
          ID(r, b);
        }
      }
      b4(), ky(r.current, !0), Ct = f, To(), xC ? r === SC ? sc++ : (sc = 0, SC = r) : sc = 0, Cp = !1, xC = !1, a3(r);
      {
        var M = r.current.stateNode;
        M.effectDuration = 0, M.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Ry(t) {
      return oc !== null && oc.has(t);
    }
    function Ik(t) {
      oc === null ? oc = /* @__PURE__ */ new Set([t]) : oc.add(t);
    }
    function pk(t) {
      wC || (wC = !0, cp = t);
    }
    var hk = pk;
    function Oy(t, r, u) {
      var f = qs(u, r), C = Tv(t, f, Re), p = Ro(t, C, Re), b = _r();
      p !== null && (sa(p, Re, b), I3(p, b));
    }
    function un(t, r, u) {
      if (uD(u), Wg(!1), t.tag === S) {
        Oy(t, t, u);
        return;
      }
      var f = null;
      for (f = r; f !== null; ) {
        if (f.tag === S) {
          Oy(f, t, u);
          return;
        } else if (f.tag === m) {
          var C = f.type, p = f.stateNode;
          if (typeof C.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && !Ry(p)) {
            var b = qs(u, t), M = B5(f, b, Re), O = Ro(f, M, Re), P = _r();
            O !== null && (sa(O, Re, P), I3(O, P));
            return;
          }
        }
        f = f.return;
      }
      c(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function mk(t, r, u) {
      var f = t.pingCache;
      f !== null && f.delete(r);
      var C = _r();
      fu(t, u), Tk(t), Vr === t && oa(R2, u) && (O2 === Dg || O2 === vC && zd(R2) && pn() - up < py ? tl(t, w1) : bC = qe(bC, u)), I3(t, C);
    }
    function Dy(t, r) {
      r === Wn && (r = $D(t));
      var u = _r(), f = d3(t, r);
      f !== null && (sa(f, r, u), I3(f, u));
    }
    function vk(t) {
      var r = t.memoizedState, u = Wn;
      r !== null && (u = r.retryLane), Dy(t, u);
    }
    function yk(t, r) {
      var u = Wn, f;
      switch (t.tag) {
        case H:
          f = t.stateNode;
          var C = t.memoizedState;
          C !== null && (u = C.retryLane);
          break;
        case T1:
          f = t.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      f !== null && f.delete(r), Dy(t, u);
    }
    function bk(t) {
      return t < 120 ? 120 : t < 480 ? 480 : t < 1080 ? 1080 : t < 1920 ? 1920 : t < 3e3 ? 3e3 : t < 4320 ? 4320 : XD(t / 1960) * 1960;
    }
    function wk() {
      if (Fg > qD)
        throw Fg = 0, dp = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      sc > ZD && (sc = 0, SC = null, c("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function xk() {
      R0.flushLegacyContextWarning(), R0.flushPendingUnsafeLifecycleWarnings();
    }
    function ky(t, r) {
      Dt(t), RC(t, Ir, VD), r && RC(t, qi, _D), RC(t, Ir, UD), r && RC(t, qi, WD), On();
    }
    function RC(t, r, u) {
      for (var f = t, C = null; f !== null; ) {
        var p = f.subtreeFlags & r;
        f !== C && f.child !== null && p !== ze ? f = f.child : ((f.flags & r) !== ze && u(f), f.sibling !== null ? f = f.sibling : f = C = f.return);
      }
    }
    var OC = null;
    function jy(t) {
      {
        if ((Ct & nr) !== L2 || !(t.mode & Te))
          return;
        var r = t.tag;
        if (r !== w && r !== S && r !== m && r !== h && r !== V && r !== Z && r !== Q)
          return;
        var u = Oe(t) || "ReactComponent";
        if (OC !== null) {
          if (OC.has(u))
            return;
          OC.add(u);
        } else
          OC = /* @__PURE__ */ new Set([u]);
        var f = wn;
        try {
          Dt(t), c("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          f ? Dt(t) : On();
        }
      }
    }
    var mp;
    {
      var Sk = null;
      mp = function(t, r, u) {
        var f = Wy(Sk, r);
        try {
          return Yv(t, r, u);
        } catch (p) {
          if (PR() || p !== null && typeof p == "object" && typeof p.then == "function")
            throw p;
          if (F9(), X8(), $v(t, r), Wy(r, f), r.mode & Je && y5(r), Gi(null, Yv, null, t, r, u), D6()) {
            var C = f4();
            typeof C == "object" && C !== null && C._suppressLogging && typeof p == "object" && p !== null && !p._suppressLogging && (p._suppressLogging = !0);
          }
          throw p;
        }
      };
    }
    var zy = !1, vp;
    vp = /* @__PURE__ */ new Set();
    function Ek(t) {
      if (gr && !AO())
        switch (t.tag) {
          case h:
          case V:
          case Q: {
            var r = zn && Oe(zn) || "Unknown", u = r;
            if (!vp.has(u)) {
              vp.add(u);
              var f = Oe(t) || "Unknown";
              c("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", f, r, r);
            }
            break;
          }
          case m: {
            zy || (c("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), zy = !0);
            break;
          }
        }
    }
    function Ug(t, r) {
      if (Br) {
        var u = t.memoizedUpdaters;
        u.forEach(function(f) {
          Cu(t, f, r);
        });
      }
    }
    var yp = {};
    function bp(t, r) {
      {
        var u = F0.current;
        return u !== null ? (u.push(r), yp) : Bl(t, r);
      }
    }
    function Ny(t) {
      if (t !== yp)
        return wd(t);
    }
    function Py() {
      return F0.current !== null;
    }
    function Mk(t) {
      {
        if (t.mode & Te) {
          if (!Cy())
            return;
        } else if (!QD() || Ct !== L2 || t.tag !== h && t.tag !== V && t.tag !== Q)
          return;
        if (F0.current === null) {
          var r = wn;
          try {
            Dt(t), c(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Oe(t));
          } finally {
            r ? Dt(t) : On();
          }
        }
      }
    }
    function Tk(t) {
      t.tag !== Mo && Cy() && F0.current === null && c(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Wg(t) {
      vy = t;
    }
    var $3 = null, lc = null, Lk = function(t) {
      $3 = t;
    };
    function uc(t) {
      {
        if ($3 === null)
          return t;
        var r = $3(t);
        return r === void 0 ? t : r.current;
      }
    }
    function wp(t) {
      return uc(t);
    }
    function xp(t) {
      {
        if ($3 === null)
          return t;
        var r = $3(t);
        if (r === void 0) {
          if (t != null && typeof t.render == "function") {
            var u = uc(t.render);
            if (t.render !== u) {
              var f = {
                $$typeof: X1,
                render: u
              };
              return t.displayName !== void 0 && (f.displayName = t.displayName), f;
            }
          }
          return t;
        }
        return r.current;
      }
    }
    function Fy(t, r) {
      {
        if ($3 === null)
          return !1;
        var u = t.elementType, f = r.type, C = !1, p = typeof f == "object" && f !== null ? f.$$typeof : null;
        switch (t.tag) {
          case m: {
            typeof f == "function" && (C = !0);
            break;
          }
          case h: {
            (typeof f == "function" || p === je) && (C = !0);
            break;
          }
          case V: {
            (p === X1 || p === je) && (C = !0);
            break;
          }
          case Z:
          case Q: {
            (p === ut || p === je) && (C = !0);
            break;
          }
          default:
            return !1;
        }
        if (C) {
          var b = $3(u);
          if (b !== void 0 && b === $3(f))
            return !0;
        }
        return !1;
      }
    }
    function By(t) {
      {
        if ($3 === null || typeof WeakSet != "function")
          return;
        lc === null && (lc = /* @__PURE__ */ new WeakSet()), lc.add(t);
      }
    }
    var Rk = function(t, r) {
      {
        if ($3 === null)
          return;
        var u = r.staleFamilies, f = r.updatedFamilies;
        xa(), wa(function() {
          Sp(t.current, f, u);
        });
      }
    }, Ok = function(t, r) {
      {
        if (t.context !== E3)
          return;
        xa(), wa(function() {
          Vg(r, t, null, null);
        });
      }
    };
    function Sp(t, r, u) {
      {
        var f = t.alternate, C = t.child, p = t.sibling, b = t.tag, M = t.type, O = null;
        switch (b) {
          case h:
          case Q:
          case m:
            O = M;
            break;
          case V:
            O = M.render;
            break;
        }
        if ($3 === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var P = !1, F = !1;
        if (O !== null) {
          var e1 = $3(O);
          e1 !== void 0 && (u.has(e1) ? F = !0 : r.has(e1) && (b === m ? F = !0 : P = !0));
        }
        if (lc !== null && (lc.has(t) || f !== null && lc.has(f)) && (F = !0), F && (t._debugNeedsRemount = !0), F || P) {
          var q = d3(t, Re);
          q !== null && D2(q, t, Re, an);
        }
        C !== null && !F && Sp(C, r, u), p !== null && Sp(p, r, u);
      }
    }
    var Dk = function(t, r) {
      {
        var u = /* @__PURE__ */ new Set(), f = new Set(r.map(function(C) {
          return C.current;
        }));
        return Ep(t.current, f, u), u;
      }
    };
    function Ep(t, r, u) {
      {
        var f = t.child, C = t.sibling, p = t.tag, b = t.type, M = null;
        switch (p) {
          case h:
          case Q:
          case m:
            M = b;
            break;
          case V:
            M = b.render;
            break;
        }
        var O = !1;
        M !== null && r.has(M) && (O = !0), O ? kk(t, u) : f !== null && Ep(f, r, u), C !== null && Ep(C, r, u);
      }
    }
    function kk(t, r) {
      {
        var u = jk(t, r);
        if (u)
          return;
        for (var f = t; ; ) {
          switch (f.tag) {
            case D:
              r.add(f.stateNode);
              return;
            case T:
              r.add(f.stateNode.containerInfo);
              return;
            case S:
              r.add(f.stateNode.containerInfo);
              return;
          }
          if (f.return === null)
            throw new Error("Expected to reach root first.");
          f = f.return;
        }
      }
    }
    function jk(t, r) {
      for (var u = t, f = !1; ; ) {
        if (u.tag === D)
          f = !0, r.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === t)
          return f;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === t)
            return f;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var Mp;
    {
      Mp = !1;
      try {
        var Hy = Object.preventExtensions({});
      } catch {
        Mp = !0;
      }
    }
    function zk(t, r, u, f) {
      this.tag = t, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = r, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = f, this.flags = ze, this.subtreeFlags = ze, this.deletions = null, this.lanes = w1, this.childLanes = w1, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Mp && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var M3 = function(t, r, u, f) {
      return new zk(t, r, u, f);
    };
    function Tp(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function Nk(t) {
      return typeof t == "function" && !Tp(t) && t.defaultProps === void 0;
    }
    function Pk(t) {
      if (typeof t == "function")
        return Tp(t) ? m : h;
      if (t != null) {
        var r = t.$$typeof;
        if (r === X1)
          return V;
        if (r === ut)
          return Z;
      }
      return w;
    }
    function rl(t, r) {
      var u = t.alternate;
      u === null ? (u = M3(t.tag, r, t.key, t.mode), u.elementType = t.elementType, u.type = t.type, u.stateNode = t.stateNode, u._debugSource = t._debugSource, u._debugOwner = t._debugOwner, u._debugHookTypes = t._debugHookTypes, u.alternate = t, t.alternate = u) : (u.pendingProps = r, u.type = t.type, u.flags = ze, u.subtreeFlags = ze, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = t.flags & b2, u.childLanes = t.childLanes, u.lanes = t.lanes, u.child = t.child, u.memoizedProps = t.memoizedProps, u.memoizedState = t.memoizedState, u.updateQueue = t.updateQueue;
      var f = t.dependencies;
      switch (u.dependencies = f === null ? null : {
        lanes: f.lanes,
        firstContext: f.firstContext
      }, u.sibling = t.sibling, u.index = t.index, u.ref = t.ref, u.selfBaseDuration = t.selfBaseDuration, u.treeBaseDuration = t.treeBaseDuration, u._debugNeedsRemount = t._debugNeedsRemount, u.tag) {
        case w:
        case h:
        case Q:
          u.type = uc(t.type);
          break;
        case m:
          u.type = wp(t.type);
          break;
        case V:
          u.type = xp(t.type);
          break;
      }
      return u;
    }
    function Fk(t, r) {
      t.flags &= b2 | on;
      var u = t.alternate;
      if (u === null)
        t.childLanes = w1, t.lanes = r, t.child = null, t.subtreeFlags = ze, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null, t.selfBaseDuration = 0, t.treeBaseDuration = 0;
      else {
        t.childLanes = u.childLanes, t.lanes = u.lanes, t.child = u.child, t.subtreeFlags = ze, t.deletions = null, t.memoizedProps = u.memoizedProps, t.memoizedState = u.memoizedState, t.updateQueue = u.updateQueue, t.type = u.type;
        var f = u.dependencies;
        t.dependencies = f === null ? null : {
          lanes: f.lanes,
          firstContext: f.firstContext
        }, t.selfBaseDuration = u.selfBaseDuration, t.treeBaseDuration = u.treeBaseDuration;
      }
      return t;
    }
    function Bk(t, r, u) {
      var f;
      return t === T9 ? (f = Te, r === !0 && (f |= lt, f |= Hr)) : f = Se, Br && (f |= Je), M3(S, null, null, f);
    }
    function Lp(t, r, u, f, C, p) {
      var b = w, M = t;
      if (typeof t == "function")
        Tp(t) ? (b = m, M = wp(M)) : M = uc(M);
      else if (typeof t == "string")
        b = D;
      else
        e: switch (t) {
          case z2:
            return Ho(u.children, C, p, r);
          case Xr:
            b = N, C |= lt, (C & Te) !== Se && (C |= Hr);
            break;
          case c0:
            return Hk(u, C, p, r);
          case Ae:
            return Uk(u, C, p, r);
          case ot:
            return Wk(u, C, p, r);
          case Pt:
            return Uy(u, C, p, r);
          case Zt:
          case et:
          case N2:
          case P3:
          case Bn:
          default: {
            if (typeof t == "object" && t !== null)
              switch (t.$$typeof) {
                case J:
                  b = K;
                  break e;
                case S1:
                  b = W;
                  break e;
                case X1:
                  b = V, M = xp(M);
                  break e;
                case ut:
                  b = Z;
                  break e;
                case je:
                  b = P1, M = null;
                  break e;
              }
            var O = "";
            {
              (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var P = f ? Oe(f) : null;
              P && (O += `

Check the render method of \`` + P + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (t == null ? t : typeof t) + "." + O));
          }
        }
      var F = M3(b, u, r, C);
      return F.elementType = t, F.type = M, F.lanes = p, F._debugOwner = f, F;
    }
    function Rp(t, r, u) {
      var f = null;
      f = t._owner;
      var C = t.type, p = t.key, b = t.props, M = Lp(C, p, b, f, r, u);
      return M._debugSource = t._source, M._debugOwner = t._owner, M;
    }
    function Ho(t, r, u, f) {
      var C = M3(z, t, f, r);
      return C.lanes = u, C;
    }
    function Hk(t, r, u, f) {
      typeof t.id != "string" && c('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof t.id);
      var C = M3(Y, t, f, r | Je);
      return C.elementType = c0, C.lanes = u, C.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, C;
    }
    function Uk(t, r, u, f) {
      var C = M3(H, t, f, r);
      return C.elementType = Ae, C.lanes = u, C;
    }
    function Wk(t, r, u, f) {
      var C = M3(T1, t, f, r);
      return C.elementType = ot, C.lanes = u, C;
    }
    function Uy(t, r, u, f) {
      var C = M3(s1, t, f, r);
      C.elementType = Pt, C.lanes = u;
      var p = {
        isHidden: !1
      };
      return C.stateNode = p, C;
    }
    function Op(t, r, u) {
      var f = M3(k, t, null, r);
      return f.lanes = u, f;
    }
    function Vk() {
      var t = M3(D, null, null, Se);
      return t.elementType = "DELETED", t;
    }
    function _k(t) {
      var r = M3(O1, null, null, Se);
      return r.stateNode = t, r;
    }
    function Dp(t, r, u) {
      var f = t.children !== null ? t.children : [], C = M3(T, f, t.key, r);
      return C.lanes = u, C.stateNode = {
        containerInfo: t.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: t.implementation
      }, C;
    }
    function Wy(t, r) {
      return t === null && (t = M3(w, null, null, Se)), t.tag = r.tag, t.key = r.key, t.elementType = r.elementType, t.type = r.type, t.stateNode = r.stateNode, t.return = r.return, t.child = r.child, t.sibling = r.sibling, t.index = r.index, t.ref = r.ref, t.pendingProps = r.pendingProps, t.memoizedProps = r.memoizedProps, t.updateQueue = r.updateQueue, t.memoizedState = r.memoizedState, t.dependencies = r.dependencies, t.mode = r.mode, t.flags = r.flags, t.subtreeFlags = r.subtreeFlags, t.deletions = r.deletions, t.lanes = r.lanes, t.childLanes = r.childLanes, t.alternate = r.alternate, t.actualDuration = r.actualDuration, t.actualStartTime = r.actualStartTime, t.selfBaseDuration = r.selfBaseDuration, t.treeBaseDuration = r.treeBaseDuration, t._debugSource = r._debugSource, t._debugOwner = r._debugOwner, t._debugNeedsRemount = r._debugNeedsRemount, t._debugHookTypes = r._debugHookTypes, t;
    }
    function Jk(t, r, u, f, C) {
      this.tag = r, this.containerInfo = t, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = dI, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Wn, this.eventTimes = Ts(w1), this.expirationTimes = Ts(an), this.pendingLanes = w1, this.suspendedLanes = w1, this.pingedLanes = w1, this.expiredLanes = w1, this.mutableReadLanes = w1, this.finishedLanes = w1, this.entangledLanes = w1, this.entanglements = Ts(w1), this.identifierPrefix = f, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var p = this.pendingUpdatersLaneMap = [], b = 0; b < bs; b++)
          p.push(/* @__PURE__ */ new Set());
      }
      switch (r) {
        case T9:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case Mo:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function Vy(t, r, u, f, C, p, b, M, O, P) {
      var F = new Jk(t, r, u, M, O), e1 = Bk(r, p);
      F.current = e1, e1.stateNode = F;
      {
        var q = {
          element: f,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        e1.memoizedState = q;
      }
      return JI(e1), F;
    }
    var kp = "18.3.1";
    function Kk(t, r, u) {
      var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Xe(f), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: j2,
        key: f == null ? null : "" + f,
        children: t,
        containerInfo: r,
        implementation: u
      };
    }
    var jp, zp;
    jp = !1, zp = {};
    function _y(t) {
      if (!t)
        return E3;
      var r = $r(t), u = TR(r);
      if (r.tag === m) {
        var f = r.type;
        if (gi(f))
          return p8(r, f, u);
      }
      return u;
    }
    function Yk(t, r) {
      {
        var u = $r(t);
        if (u === void 0) {
          if (typeof t.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var f = Object.keys(t).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + f);
        }
        var C = r3(u);
        if (C === null)
          return null;
        if (C.mode & lt) {
          var p = Oe(u) || "Component";
          if (!zp[p]) {
            zp[p] = !0;
            var b = wn;
            try {
              Dt(C), u.mode & lt ? c("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, p) : c("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, p);
            } finally {
              b ? Dt(b) : On();
            }
          }
        }
        return C.stateNode;
      }
    }
    function Jy(t, r, u, f, C, p, b, M) {
      var O = !1, P = null;
      return Vy(t, r, O, P, u, f, C, p, b);
    }
    function Ky(t, r, u, f, C, p, b, M, O, P) {
      var F = !0, e1 = Vy(u, f, F, t, C, p, b, M, O);
      e1.context = _y(null);
      var q = e1.current, l1 = _r(), g1 = Fo(q), A1 = ma(l1, g1);
      return A1.callback = r ?? null, Ro(q, A1, g1), ek(e1, g1, l1), e1;
    }
    function Vg(t, r, u, f) {
      v4(r, t);
      var C = r.current, p = _r(), b = Fo(C);
      w4(b);
      var M = _y(u);
      r.context === null ? r.context = M : r.pendingContext = M, gr && wn !== null && !jp && (jp = !0, c(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Oe(wn) || "Unknown"));
      var O = ma(p, b);
      O.payload = {
        element: t
      }, f = f === void 0 ? null : f, f !== null && (typeof f != "function" && c("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", f), O.callback = f);
      var P = Ro(C, O, b);
      return P !== null && (D2(P, C, b, p), V9(P, C, b)), b;
    }
    function DC(t) {
      var r = t.current;
      if (!r.child)
        return null;
      switch (r.child.tag) {
        case D:
          return r.child.stateNode;
        default:
          return r.child.stateNode;
      }
    }
    function Qk(t) {
      switch (t.tag) {
        case S: {
          var r = t.stateNode;
          if (Au(r)) {
            var u = E4(r);
            ik(r, u);
          }
          break;
        }
        case H: {
          wa(function() {
            var C = d3(t, Re);
            if (C !== null) {
              var p = _r();
              D2(C, t, Re, p);
            }
          });
          var f = Re;
          Np(t, f);
          break;
        }
      }
    }
    function Yy(t, r) {
      var u = t.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = Hd(u.retryLane, r));
    }
    function Np(t, r) {
      Yy(t, r);
      var u = t.alternate;
      u && Yy(u, r);
    }
    function Xk(t) {
      if (t.tag === H) {
        var r = xs, u = d3(t, r);
        if (u !== null) {
          var f = _r();
          D2(u, t, r, f);
        }
        Np(t, r);
      }
    }
    function Gk(t) {
      if (t.tag === H) {
        var r = Fo(t), u = d3(t, r);
        if (u !== null) {
          var f = _r();
          D2(u, t, r, f);
        }
        Np(t, r);
      }
    }
    function Qy(t) {
      var r = bd(t);
      return r === null ? null : r.stateNode;
    }
    var Xy = function(t) {
      return null;
    };
    function qk(t) {
      return Xy(t);
    }
    var Gy = function(t) {
      return !1;
    };
    function Zk(t) {
      return Gy(t);
    }
    var qy = null, Zy = null, $y = null, eb = null, tb = null, nb = null, rb = null, ib = null, ab = null;
    {
      var ob = function(t, r, u) {
        var f = r[u], C = c2(t) ? t.slice() : rt({}, t);
        return u + 1 === r.length ? (c2(C) ? C.splice(f, 1) : delete C[f], C) : (C[f] = ob(t[f], r, u + 1), C);
      }, sb = function(t, r) {
        return ob(t, r, 0);
      }, lb = function(t, r, u, f) {
        var C = r[f], p = c2(t) ? t.slice() : rt({}, t);
        if (f + 1 === r.length) {
          var b = u[f];
          p[b] = p[C], c2(p) ? p.splice(C, 1) : delete p[C];
        } else
          p[C] = lb(
            // $FlowFixMe number or string is fine here
            t[C],
            r,
            u,
            f + 1
          );
        return p;
      }, ub = function(t, r, u) {
        if (r.length !== u.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var f = 0; f < u.length - 1; f++)
            if (r[f] !== u[f]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return lb(t, r, u, 0);
      }, cb = function(t, r, u, f) {
        if (u >= r.length)
          return f;
        var C = r[u], p = c2(t) ? t.slice() : rt({}, t);
        return p[C] = cb(t[C], r, u + 1, f), p;
      }, gb = function(t, r, u) {
        return cb(t, r, 0, u);
      }, Pp = function(t, r) {
        for (var u = t.memoizedState; u !== null && r > 0; )
          u = u.next, r--;
        return u;
      };
      qy = function(t, r, u, f) {
        var C = Pp(t, r);
        if (C !== null) {
          var p = gb(C.memoizedState, u, f);
          C.memoizedState = p, C.baseState = p, t.memoizedProps = rt({}, t.memoizedProps);
          var b = d3(t, Re);
          b !== null && D2(b, t, Re, an);
        }
      }, Zy = function(t, r, u) {
        var f = Pp(t, r);
        if (f !== null) {
          var C = sb(f.memoizedState, u);
          f.memoizedState = C, f.baseState = C, t.memoizedProps = rt({}, t.memoizedProps);
          var p = d3(t, Re);
          p !== null && D2(p, t, Re, an);
        }
      }, $y = function(t, r, u, f) {
        var C = Pp(t, r);
        if (C !== null) {
          var p = ub(C.memoizedState, u, f);
          C.memoizedState = p, C.baseState = p, t.memoizedProps = rt({}, t.memoizedProps);
          var b = d3(t, Re);
          b !== null && D2(b, t, Re, an);
        }
      }, eb = function(t, r, u) {
        t.pendingProps = gb(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var f = d3(t, Re);
        f !== null && D2(f, t, Re, an);
      }, tb = function(t, r) {
        t.pendingProps = sb(t.memoizedProps, r), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var u = d3(t, Re);
        u !== null && D2(u, t, Re, an);
      }, nb = function(t, r, u) {
        t.pendingProps = ub(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var f = d3(t, Re);
        f !== null && D2(f, t, Re, an);
      }, rb = function(t) {
        var r = d3(t, Re);
        r !== null && D2(r, t, Re, an);
      }, ib = function(t) {
        Xy = t;
      }, ab = function(t) {
        Gy = t;
      };
    }
    function $k(t) {
      var r = r3(t);
      return r === null ? null : r.stateNode;
    }
    function ej(t) {
      return null;
    }
    function tj() {
      return wn;
    }
    function nj(t) {
      var r = t.findFiberByHostInstance, u = i.ReactCurrentDispatcher;
      return m4({
        bundleType: t.bundleType,
        version: t.version,
        rendererPackageName: t.rendererPackageName,
        rendererConfig: t.rendererConfig,
        overrideHookState: qy,
        overrideHookStateDeletePath: Zy,
        overrideHookStateRenamePath: $y,
        overrideProps: eb,
        overridePropsDeletePath: tb,
        overridePropsRenamePath: nb,
        setErrorHandler: ib,
        setSuspenseHandler: ab,
        scheduleUpdate: rb,
        currentDispatcherRef: u,
        findHostInstanceByFiber: $k,
        findFiberByHostInstance: r || ej,
        // React Refresh
        findHostInstancesForRefresh: Dk,
        scheduleRefresh: Rk,
        scheduleRoot: Ok,
        setRefreshHandler: Lk,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: tj,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: kp
      });
    }
    var fb = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(t) {
      console.error(t);
    };
    function Fp(t) {
      this._internalRoot = t;
    }
    kC.prototype.render = Fp.prototype.render = function(t) {
      var r = this._internalRoot;
      if (r === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? c("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : jC(arguments[1]) ? c("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && c("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = r.containerInfo;
        if (u.nodeType !== Hn) {
          var f = Qy(r.current);
          f && f.parentNode !== u && c("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Vg(t, r, null, null);
    }, kC.prototype.unmount = Fp.prototype.unmount = function() {
      typeof arguments[0] == "function" && c("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var t = this._internalRoot;
      if (t !== null) {
        this._internalRoot = null;
        var r = t.containerInfo;
        xy() && c("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), wa(function() {
          Vg(null, t, null, null);
        }), f8(r);
      }
    };
    function rj(t, r) {
      if (!jC(t))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      db(t);
      var u = !1, f = !1, C = "", p = fb;
      r != null && (r.hydrate ? g("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof r == "object" && r !== null && r.$$typeof === Qr && c(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (C = r.identifierPrefix), r.onRecoverableError !== void 0 && (p = r.onRecoverableError), r.transitionCallbacks !== void 0 && r.transitionCallbacks);
      var b = Jy(t, T9, null, u, f, C, p);
      y9(b.current, t);
      var M = t.nodeType === Hn ? t.parentNode : t;
      return X4(M), new Fp(b);
    }
    function kC(t) {
      this._internalRoot = t;
    }
    function ij(t) {
      t && H6(t);
    }
    kC.prototype.unstable_scheduleHydration = ij;
    function aj(t, r, u) {
      if (!jC(t))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      db(t), r === void 0 && c("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var f = u ?? null, C = u != null && u.hydratedSources || null, p = !1, b = !1, M = "", O = fb;
      u != null && (u.unstable_strictMode === !0 && (p = !0), u.identifierPrefix !== void 0 && (M = u.identifierPrefix), u.onRecoverableError !== void 0 && (O = u.onRecoverableError));
      var P = Ky(r, null, t, T9, f, p, b, M, O);
      if (y9(P.current, t), X4(t), C)
        for (var F = 0; F < C.length; F++) {
          var e1 = C[F];
          uO(P, e1);
        }
      return new kC(P);
    }
    function jC(t) {
      return !!(t && (t.nodeType === dr || t.nodeType === b3 || t.nodeType === _i || !k1));
    }
    function _g(t) {
      return !!(t && (t.nodeType === dr || t.nodeType === b3 || t.nodeType === _i || t.nodeType === Hn && t.nodeValue === " react-mount-point-unstable "));
    }
    function db(t) {
      t.nodeType === dr && t.tagName && t.tagName.toUpperCase() === "BODY" && c("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), og(t) && (t._reactRootContainer ? c("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : c("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var oj = i.ReactCurrentOwner, Cb;
    Cb = function(t) {
      if (t._reactRootContainer && t.nodeType !== Hn) {
        var r = Qy(t._reactRootContainer.current);
        r && r.parentNode !== t && c("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!t._reactRootContainer, f = Bp(t), C = !!(f && So(f));
      C && !u && c("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), t.nodeType === dr && t.tagName && t.tagName.toUpperCase() === "BODY" && c("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function Bp(t) {
      return t ? t.nodeType === b3 ? t.documentElement : t.firstChild : null;
    }
    function Ab() {
    }
    function sj(t, r, u, f, C) {
      if (C) {
        if (typeof f == "function") {
          var p = f;
          f = function() {
            var q = DC(b);
            p.call(q);
          };
        }
        var b = Ky(
          r,
          f,
          t,
          Mo,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          Ab
        );
        t._reactRootContainer = b, y9(b.current, t);
        var M = t.nodeType === Hn ? t.parentNode : t;
        return X4(M), wa(), b;
      } else {
        for (var O; O = t.lastChild; )
          t.removeChild(O);
        if (typeof f == "function") {
          var P = f;
          f = function() {
            var q = DC(F);
            P.call(q);
          };
        }
        var F = Jy(
          t,
          Mo,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          Ab
        );
        t._reactRootContainer = F, y9(F.current, t);
        var e1 = t.nodeType === Hn ? t.parentNode : t;
        return X4(e1), wa(function() {
          Vg(r, F, u, f);
        }), F;
      }
    }
    function lj(t, r) {
      t !== null && typeof t != "function" && c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t);
    }
    function zC(t, r, u, f, C) {
      Cb(u), lj(C === void 0 ? null : C, "render");
      var p = u._reactRootContainer, b;
      if (!p)
        b = sj(u, r, t, C, f);
      else {
        if (b = p, typeof C == "function") {
          var M = C;
          C = function() {
            var O = DC(b);
            M.call(O);
          };
        }
        Vg(r, b, t, C);
      }
      return DC(b);
    }
    var Ib = !1;
    function uj(t) {
      {
        Ib || (Ib = !0, c("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var r = oj.current;
        if (r !== null && r.stateNode !== null) {
          var u = r.stateNode._warnedAboutRefsInRender;
          u || c("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", yt(r.type) || "A component"), r.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return t == null ? null : t.nodeType === dr ? t : Yk(t, "findDOMNode");
    }
    function cj(t, r, u) {
      if (c("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !_g(r))
        throw new Error("Target container is not a DOM element.");
      {
        var f = og(r) && r._reactRootContainer === void 0;
        f && c("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return zC(null, t, r, !0, u);
    }
    function gj(t, r, u) {
      if (c("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !_g(r))
        throw new Error("Target container is not a DOM element.");
      {
        var f = og(r) && r._reactRootContainer === void 0;
        f && c("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return zC(null, t, r, !1, u);
    }
    function fj(t, r, u, f) {
      if (c("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !_g(u))
        throw new Error("Target container is not a DOM element.");
      if (t == null || !As(t))
        throw new Error("parentComponent must be a valid React Component");
      return zC(t, r, u, !1, f);
    }
    var pb = !1;
    function dj(t) {
      if (pb || (pb = !0, c("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !_g(t))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var r = og(t) && t._reactRootContainer === void 0;
        r && c("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (t._reactRootContainer) {
        {
          var u = Bp(t), f = u && !So(u);
          f && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return wa(function() {
          zC(null, null, t, !1, function() {
            t._reactRootContainer = null, f8(t);
          });
        }), !0;
      } else {
        {
          var C = Bp(t), p = !!(C && So(C)), b = t.nodeType === dr && _g(t.parentNode) && !!t.parentNode._reactRootContainer;
          p && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", b ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    co(Qk), F6(Xk), pu(Gk), Vd(s3), _d(U2), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && c("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), md(AL), jl(Ip, ak, wa);
    function Cj(t, r) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!jC(r))
        throw new Error("Target container is not a DOM element.");
      return Kk(t, r, null, u);
    }
    function Aj(t, r, u, f) {
      return fj(t, r, u, f);
    }
    var Hp = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [So, Hu, b9, kl, fs, Ip]
    };
    function Ij(t, r) {
      return Hp.usingClientEntryPoint || c('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), rj(t, r);
    }
    function pj(t, r, u) {
      return Hp.usingClientEntryPoint || c('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), aj(t, r, u);
    }
    function hj(t) {
      return xy() && c("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), wa(t);
    }
    var mj = nj({
      findFiberByHostInstance: Ws,
      bundleType: 1,
      version: kp,
      rendererPackageName: "react-dom"
    });
    if (!mj && ue && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var hb = window.location.protocol;
      /^(https?|file):$/.test(hb) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (hb === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    h3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Hp, h3.createPortal = Cj, h3.createRoot = Ij, h3.findDOMNode = uj, h3.flushSync = hj, h3.hydrate = cj, h3.hydrateRoot = pj, h3.render = gj, h3.unmountComponentAtNode = dj, h3.unstable_batchedUpdates = Ip, h3.unstable_renderSubtreeIntoContainer = Aj, h3.version = kp, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), h3;
}
function ME() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(ME);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (ME(), $7.exports = uH()) : $7.exports = cH();
var TE = $7.exports;
const WC = /* @__PURE__ */ _h(TE), gw = {
  disabled: !1
};
var gH = process.env.NODE_ENV !== "production" ? E.oneOfType([E.number, E.shape({
  enter: E.number,
  exit: E.number,
  appear: E.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && E.oneOfType([E.string, E.shape({
  enter: E.string,
  exit: E.string,
  active: E.string
}), E.shape({
  enter: E.string,
  enterDone: E.string,
  enterActive: E.string,
  exit: E.string,
  exitDone: E.string,
  exitActive: E.string
})]);
const wA = Gt.createContext(null);
var fH = function(n) {
  return n.scrollTop;
}, sf = "unmounted", al = "exited", ol = "entering", mc = "entered", eh = "exiting", zi = /* @__PURE__ */ function(e) {
  rm(n, e);
  function n(a, s) {
    var g;
    g = e.call(this, a, s) || this;
    var c = s, I = c && !c.isMounting ? a.enter : a.appear, h;
    return g.appearStatus = null, a.in ? I ? (h = al, g.appearStatus = ol) : h = mc : a.unmountOnExit || a.mountOnEnter ? h = sf : h = al, g.state = {
      status: h
    }, g.nextCallback = null, g;
  }
  n.getDerivedStateFromProps = function(s, g) {
    var c = s.in;
    return c && g.status === sf ? {
      status: al
    } : null;
  };
  var i = n.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(s) {
    var g = null;
    if (s !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== ol && c !== mc && (g = ol) : (c === ol || c === mc) && (g = eh);
    }
    this.updateStatus(!1, g);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var s = this.props.timeout, g, c, I;
    return g = c = I = s, s != null && typeof s != "number" && (g = s.exit, c = s.enter, I = s.appear !== void 0 ? s.appear : c), {
      exit: g,
      enter: c,
      appear: I
    };
  }, i.updateStatus = function(s, g) {
    if (s === void 0 && (s = !1), g !== null)
      if (this.cancelNextCallback(), g === ol) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : WC.findDOMNode(this);
          c && fH(c);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === al && this.setState({
      status: sf
    });
  }, i.performEnter = function(s) {
    var g = this, c = this.props.enter, I = this.context ? this.context.isMounting : s, h = this.props.nodeRef ? [I] : [WC.findDOMNode(this), I], m = h[0], w = h[1], S = this.getTimeouts(), T = I ? S.appear : S.enter;
    if (!s && !c || gw.disabled) {
      this.safeSetState({
        status: mc
      }, function() {
        g.props.onEntered(m);
      });
      return;
    }
    this.props.onEnter(m, w), this.safeSetState({
      status: ol
    }, function() {
      g.props.onEntering(m, w), g.onTransitionEnd(T, function() {
        g.safeSetState({
          status: mc
        }, function() {
          g.props.onEntered(m, w);
        });
      });
    });
  }, i.performExit = function() {
    var s = this, g = this.props.exit, c = this.getTimeouts(), I = this.props.nodeRef ? void 0 : WC.findDOMNode(this);
    if (!g || gw.disabled) {
      this.safeSetState({
        status: al
      }, function() {
        s.props.onExited(I);
      });
      return;
    }
    this.props.onExit(I), this.safeSetState({
      status: eh
    }, function() {
      s.props.onExiting(I), s.onTransitionEnd(c.exit, function() {
        s.safeSetState({
          status: al
        }, function() {
          s.props.onExited(I);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(s, g) {
    g = this.setNextCallback(g), this.setState(s, g);
  }, i.setNextCallback = function(s) {
    var g = this, c = !0;
    return this.nextCallback = function(I) {
      c && (c = !1, g.nextCallback = null, s(I));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(s, g) {
    this.setNextCallback(g);
    var c = this.props.nodeRef ? this.props.nodeRef.current : WC.findDOMNode(this), I = s == null && !this.props.addEndListener;
    if (!c || I) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], m = h[0], w = h[1];
      this.props.addEndListener(m, w);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, i.render = function() {
    var s = this.state.status;
    if (s === sf)
      return null;
    var g = this.props, c = g.children;
    g.in, g.mountOnEnter, g.unmountOnExit, g.appear, g.enter, g.exit, g.timeout, g.addEndListener, g.onEnter, g.onEntering, g.onEntered, g.onExit, g.onExiting, g.onExited, g.nodeRef;
    var I = Tt(g, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Gt.createElement(wA.Provider, {
        value: null
      }, typeof c == "function" ? c(s, I) : Gt.cloneElement(Gt.Children.only(c), I))
    );
  }, n;
}(Gt.Component);
zi.contextType = wA;
zi.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: E.shape({
    current: typeof Element > "u" ? E.any : function(e, n, i, a, s, g) {
      var c = e[n];
      return E.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(e, n, i, a, s, g);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: E.oneOfType([E.func.isRequired, E.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: E.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: E.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: E.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: E.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: E.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: E.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(n) {
    var i = gH;
    n.addEndListener || (i = i.isRequired);
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), g = 1; g < a; g++)
      s[g - 1] = arguments[g];
    return i.apply(void 0, [n].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: E.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: E.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: E.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: E.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: E.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: E.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: E.func
} : {};
function Ic() {
}
zi.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ic,
  onEntering: Ic,
  onEntered: Ic,
  onExit: Ic,
  onExiting: Ic,
  onExited: Ic
};
zi.UNMOUNTED = sf;
zi.EXITED = al;
zi.ENTERING = ol;
zi.ENTERED = mc;
zi.EXITING = eh;
function am(e, n) {
  var i = function(g) {
    return n && tA(g) ? n(g) : g;
  }, a = /* @__PURE__ */ Object.create(null);
  return e && az.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    a[s.key] = i(s);
  }), a;
}
function dH(e, n) {
  e = e || {}, n = n || {};
  function i(w) {
    return w in n ? n[w] : e[w];
  }
  var a = /* @__PURE__ */ Object.create(null), s = [];
  for (var g in e)
    g in n ? s.length && (a[g] = s, s = []) : s.push(g);
  var c, I = {};
  for (var h in n) {
    if (a[h])
      for (c = 0; c < a[h].length; c++) {
        var m = a[h][c];
        I[a[h][c]] = i(m);
      }
    I[h] = i(h);
  }
  for (c = 0; c < s.length; c++)
    I[s[c]] = i(s[c]);
  return I;
}
function ul(e, n, i) {
  return i[n] != null ? i[n] : e.props[n];
}
function CH(e, n) {
  return am(e.children, function(i) {
    return nA(i, {
      onExited: n.bind(null, i),
      in: !0,
      appear: ul(i, "appear", e),
      enter: ul(i, "enter", e),
      exit: ul(i, "exit", e)
    });
  });
}
function AH(e, n, i) {
  var a = am(e.children), s = dH(n, a);
  return Object.keys(s).forEach(function(g) {
    var c = s[g];
    if (tA(c)) {
      var I = g in n, h = g in a, m = n[g], w = tA(m) && !m.props.in;
      h && (!I || w) ? s[g] = nA(c, {
        onExited: i.bind(null, c),
        in: !0,
        exit: ul(c, "exit", e),
        enter: ul(c, "enter", e)
      }) : !h && I && !w ? s[g] = nA(c, {
        in: !1
      }) : h && I && tA(m) && (s[g] = nA(c, {
        onExited: i.bind(null, c),
        in: m.props.in,
        exit: ul(c, "exit", e),
        enter: ul(c, "enter", e)
      }));
    }
  }), s;
}
var IH = Object.values || function(e) {
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}, pH = {
  component: "div",
  childFactory: function(n) {
    return n;
  }
}, om = /* @__PURE__ */ function(e) {
  rm(n, e);
  function n(a, s) {
    var g;
    g = e.call(this, a, s) || this;
    var c = g.handleExited.bind(pe(g));
    return g.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: c,
      firstRender: !0
    }, g;
  }
  var i = n.prototype;
  return i.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, i.componentWillUnmount = function() {
    this.mounted = !1;
  }, n.getDerivedStateFromProps = function(s, g) {
    var c = g.children, I = g.handleExited, h = g.firstRender;
    return {
      children: h ? CH(s, I) : AH(s, c, I),
      firstRender: !1
    };
  }, i.handleExited = function(s, g) {
    var c = am(this.props.children);
    s.key in c || (s.props.onExited && s.props.onExited(g), this.mounted && this.setState(function(I) {
      var h = m1({}, I.children);
      return delete h[s.key], {
        children: h
      };
    }));
  }, i.render = function() {
    var s = this.props, g = s.component, c = s.childFactory, I = Tt(s, ["component", "childFactory"]), h = this.state.contextValue, m = IH(this.state.children).map(c);
    return delete I.appear, delete I.enter, delete I.exit, g === null ? /* @__PURE__ */ Gt.createElement(wA.Provider, {
      value: h
    }, m) : /* @__PURE__ */ Gt.createElement(wA.Provider, {
      value: h
    }, /* @__PURE__ */ Gt.createElement(g, I, m));
  }, n;
}(Gt.Component);
om.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: E.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: E.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: E.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: E.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: E.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: E.func
} : {};
om.defaultProps = pH;
function LE(e) {
  const {
    className: n,
    classes: i,
    pulsate: a = !1,
    rippleX: s,
    rippleY: g,
    rippleSize: c,
    in: I,
    onExited: h,
    timeout: m
  } = e, [w, S] = n1.useState(!1), T = Xt(n, i.ripple, i.rippleVisible, a && i.ripplePulsate), D = {
    width: c,
    height: c,
    top: -(c / 2) + g,
    left: -(c / 2) + s
  }, k = Xt(i.child, w && i.childLeaving, a && i.childPulsate);
  return !I && !w && S(!0), n1.useEffect(() => {
    if (!I && h != null) {
      const z = setTimeout(h, m);
      return () => {
        clearTimeout(z);
      };
    }
  }, [h, I, m]), /* @__PURE__ */ y.jsx("span", {
    className: T,
    style: D,
    children: /* @__PURE__ */ y.jsx("span", {
      className: k
    })
  });
}
process.env.NODE_ENV !== "production" && (LE.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object.isRequired,
  className: E.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: E.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: E.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: E.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: E.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: E.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: E.number,
  /**
   * exit delay
   */
  timeout: E.number.isRequired
});
const n0 = m2("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), hH = ["center", "classes", "className"];
let i6 = (e) => e, fw, dw, Cw, Aw;
const th = 550, mH = 80, vH = UA(fw || (fw = i6`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), yH = UA(dw || (dw = i6`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), bH = UA(Cw || (Cw = i6`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), wH = Rn("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), xH = Rn(LE, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(Aw || (Aw = i6`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), n0.rippleVisible, vH, th, ({
  theme: e
}) => e.transitions.easing.easeInOut, n0.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, n0.child, n0.childLeaving, yH, th, ({
  theme: e
}) => e.transitions.easing.easeInOut, n0.childPulsate, bH, ({
  theme: e
}) => e.transitions.easing.easeInOut), RE = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: g = {},
    className: c
  } = a, I = Tt(a, hH), [h, m] = n1.useState([]), w = n1.useRef(0), S = n1.useRef(null);
  n1.useEffect(() => {
    S.current && (S.current(), S.current = null);
  }, [h]);
  const T = n1.useRef(!1), D = rE(), k = n1.useRef(null), z = n1.useRef(null), N = n1.useCallback((Y) => {
    const {
      pulsate: H,
      rippleX: Z,
      rippleY: Q,
      rippleSize: P1,
      cb: Y1
    } = Y;
    m((O1) => [...O1, /* @__PURE__ */ y.jsx(xH, {
      classes: {
        ripple: Xt(g.ripple, n0.ripple),
        rippleVisible: Xt(g.rippleVisible, n0.rippleVisible),
        ripplePulsate: Xt(g.ripplePulsate, n0.ripplePulsate),
        child: Xt(g.child, n0.child),
        childLeaving: Xt(g.childLeaving, n0.childLeaving),
        childPulsate: Xt(g.childPulsate, n0.childPulsate)
      },
      timeout: th,
      pulsate: H,
      rippleX: Z,
      rippleY: Q,
      rippleSize: P1
    }, w.current)]), w.current += 1, S.current = Y1;
  }, [g]), W = n1.useCallback((Y = {}, H = {}, Z = () => {
  }) => {
    const {
      pulsate: Q = !1,
      center: P1 = s || H.pulsate,
      fakeElement: Y1 = !1
      // For test purposes
    } = H;
    if ((Y == null ? void 0 : Y.type) === "mousedown" && T.current) {
      T.current = !1;
      return;
    }
    (Y == null ? void 0 : Y.type) === "touchstart" && (T.current = !0);
    const O1 = Y1 ? null : z.current, T1 = O1 ? O1.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let J1, s1, d1;
    if (P1 || Y === void 0 || Y.clientX === 0 && Y.clientY === 0 || !Y.clientX && !Y.touches)
      J1 = Math.round(T1.width / 2), s1 = Math.round(T1.height / 2);
    else {
      const {
        clientX: h1,
        clientY: C1
      } = Y.touches && Y.touches.length > 0 ? Y.touches[0] : Y;
      J1 = Math.round(h1 - T1.left), s1 = Math.round(C1 - T1.top);
    }
    if (P1)
      d1 = Math.sqrt((2 * T1.width ** 2 + T1.height ** 2) / 3), d1 % 2 === 0 && (d1 += 1);
    else {
      const h1 = Math.max(Math.abs((O1 ? O1.clientWidth : 0) - J1), J1) * 2 + 2, C1 = Math.max(Math.abs((O1 ? O1.clientHeight : 0) - s1), s1) * 2 + 2;
      d1 = Math.sqrt(h1 ** 2 + C1 ** 2);
    }
    Y != null && Y.touches ? k.current === null && (k.current = () => {
      N({
        pulsate: Q,
        rippleX: J1,
        rippleY: s1,
        rippleSize: d1,
        cb: Z
      });
    }, D.start(mH, () => {
      k.current && (k.current(), k.current = null);
    })) : N({
      pulsate: Q,
      rippleX: J1,
      rippleY: s1,
      rippleSize: d1,
      cb: Z
    });
  }, [s, N, D]), K = n1.useCallback(() => {
    W({}, {
      pulsate: !0
    });
  }, [W]), V = n1.useCallback((Y, H) => {
    if (D.clear(), (Y == null ? void 0 : Y.type) === "touchend" && k.current) {
      k.current(), k.current = null, D.start(0, () => {
        V(Y, H);
      });
      return;
    }
    k.current = null, m((Z) => Z.length > 0 ? Z.slice(1) : Z), S.current = H;
  }, [D]);
  return n1.useImperativeHandle(i, () => ({
    pulsate: K,
    start: W,
    stop: V
  }), [K, W, V]), /* @__PURE__ */ y.jsx(wH, m1({
    className: Xt(n0.root, g.root, c),
    ref: z
  }, I, {
    children: /* @__PURE__ */ y.jsx(om, {
      component: null,
      exit: !0,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (RE.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: E.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string
});
function SH(e) {
  return sr("MuiButtonBase", e);
}
const EH = m2("MuiButtonBase", ["root", "disabled", "focusVisible"]), MH = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], TH = (e) => {
  const {
    disabled: n,
    focusVisible: i,
    focusVisibleClassName: a,
    classes: s
  } = e, c = Yr({
    root: ["root", n && "disabled", i && "focusVisible"]
  }, SH, s);
  return i && a && (c.root += ` ${a}`), c;
}, LH = Rn("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${EH.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), sm = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: g = !1,
    children: c,
    className: I,
    component: h = "button",
    disabled: m = !1,
    disableRipple: w = !1,
    disableTouchRipple: S = !1,
    focusRipple: T = !1,
    LinkComponent: D = "a",
    onBlur: k,
    onClick: z,
    onContextMenu: N,
    onDragLeave: W,
    onFocus: K,
    onFocusVisible: V,
    onKeyDown: Y,
    onKeyUp: H,
    onMouseDown: Z,
    onMouseLeave: Q,
    onMouseUp: P1,
    onTouchEnd: Y1,
    onTouchMove: O1,
    onTouchStart: T1,
    tabIndex: J1 = 0,
    TouchRippleProps: s1,
    touchRippleRef: d1,
    type: h1
  } = a, C1 = Tt(a, MH), L1 = n1.useRef(null), f1 = n1.useRef(null), B1 = U0(f1, d1), {
    isFocusVisibleRef: t1,
    onFocus: y1,
    onBlur: k1,
    ref: se
  } = UP(), [K1, le] = n1.useState(!1);
  m && K1 && le(!1), n1.useImperativeHandle(s, () => ({
    focusVisible: () => {
      le(!0), L1.current.focus();
    }
  }), []);
  const [G1, $1] = n1.useState(!1);
  n1.useEffect(() => {
    $1(!0);
  }, []);
  const V1 = G1 && !w && !m;
  n1.useEffect(() => {
    K1 && T && !w && G1 && f1.current.pulsate();
  }, [w, T, K1, G1]);
  function z1(Fe, Pn, Q1 = S) {
    return vc((he) => (Pn && Pn(he), !Q1 && f1.current && f1.current[Fe](he), !0));
  }
  const ae = z1("start", Z), We = z1("stop", N), D1 = z1("stop", W), ue = z1("stop", P1), b1 = z1("stop", (Fe) => {
    K1 && Fe.preventDefault(), Q && Q(Fe);
  }), Pe = z1("start", T1), $e = z1("stop", Y1), W1 = z1("stop", O1), ke = z1("stop", (Fe) => {
    k1(Fe), t1.current === !1 && le(!1), k && k(Fe);
  }, !1), Xe = vc((Fe) => {
    L1.current || (L1.current = Fe.currentTarget), y1(Fe), t1.current === !0 && (le(!0), V && V(Fe)), K && K(Fe);
  }), St = () => {
    const Fe = L1.current;
    return h && h !== "button" && !(Fe.tagName === "A" && Fe.href);
  }, tt = n1.useRef(!1), we = vc((Fe) => {
    T && !tt.current && K1 && f1.current && Fe.key === " " && (tt.current = !0, f1.current.stop(Fe, () => {
      f1.current.start(Fe);
    })), Fe.target === Fe.currentTarget && St() && Fe.key === " " && Fe.preventDefault(), Y && Y(Fe), Fe.target === Fe.currentTarget && St() && Fe.key === "Enter" && !m && (Fe.preventDefault(), z && z(Fe));
  }), An = vc((Fe) => {
    T && Fe.key === " " && f1.current && K1 && !Fe.defaultPrevented && (tt.current = !1, f1.current.stop(Fe, () => {
      f1.current.pulsate(Fe);
    })), H && H(Fe), z && Fe.target === Fe.currentTarget && St() && Fe.key === " " && !Fe.defaultPrevented && z(Fe);
  });
  let nt = h;
  nt === "button" && (C1.href || C1.to) && (nt = D);
  const In = {};
  nt === "button" ? (In.type = h1 === void 0 ? "button" : h1, In.disabled = m) : (!C1.href && !C1.to && (In.role = "button"), m && (In["aria-disabled"] = m));
  const v2 = U0(i, se, L1);
  process.env.NODE_ENV !== "production" && n1.useEffect(() => {
    V1 && !f1.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [V1]);
  const tn = m1({}, a, {
    centerRipple: g,
    component: h,
    disabled: m,
    disableRipple: w,
    disableTouchRipple: S,
    focusRipple: T,
    tabIndex: J1,
    focusVisible: K1
  }), s2 = TH(tn);
  return /* @__PURE__ */ y.jsxs(LH, m1({
    as: nt,
    className: Xt(s2.root, I),
    ownerState: tn,
    onBlur: ke,
    onClick: z,
    onContextMenu: We,
    onFocus: Xe,
    onKeyDown: we,
    onKeyUp: An,
    onMouseDown: ae,
    onMouseLeave: b1,
    onMouseUp: ue,
    onDragLeave: D1,
    onTouchEnd: $e,
    onTouchMove: W1,
    onTouchStart: Pe,
    ref: v2,
    tabIndex: m ? -1 : J1,
    type: h1
  }, In, C1, {
    children: [c, V1 ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ y.jsx(RE, m1({
        ref: B1,
        center: g
      }, s1))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (sm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: nE,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: E.bool,
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: eE,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: E.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: E.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: E.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: E.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: E.string,
  /**
   * @ignore
   */
  href: E.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: E.elementType,
  /**
   * @ignore
   */
  onBlur: E.func,
  /**
   * @ignore
   */
  onClick: E.func,
  /**
   * @ignore
   */
  onContextMenu: E.func,
  /**
   * @ignore
   */
  onDragLeave: E.func,
  /**
   * @ignore
   */
  onFocus: E.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: E.func,
  /**
   * @ignore
   */
  onKeyDown: E.func,
  /**
   * @ignore
   */
  onKeyUp: E.func,
  /**
   * @ignore
   */
  onMouseDown: E.func,
  /**
   * @ignore
   */
  onMouseLeave: E.func,
  /**
   * @ignore
   */
  onMouseUp: E.func,
  /**
   * @ignore
   */
  onTouchEnd: E.func,
  /**
   * @ignore
   */
  onTouchMove: E.func,
  /**
   * @ignore
   */
  onTouchStart: E.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * @default 0
   */
  tabIndex: E.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: E.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: E.oneOfType([E.func, E.shape({
    current: E.shape({
      pulsate: E.func.isRequired,
      start: E.func.isRequired,
      stop: E.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: E.oneOfType([E.oneOf(["button", "reset", "submit"]), E.string])
});
function RH(e) {
  return sr("MuiIconButton", e);
}
const OH = m2("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), DH = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], kH = (e) => {
  const {
    classes: n,
    disabled: i,
    color: a,
    edge: s,
    size: g
  } = e, c = {
    root: ["root", i && "disabled", a !== "default" && `color${or(a)}`, s && `edge${or(s)}`, `size${or(g)}`]
  };
  return Yr(c, RH, n);
}, jH = Rn(sm, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.color !== "default" && n[`color${or(i.color)}`], i.edge && n[`edge${or(i.edge)}`], n[`size${or(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: n
}) => m1({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !n.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : i0(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, n.edge === "start" && {
  marginLeft: n.size === "small" ? -3 : -12
}, n.edge === "end" && {
  marginRight: n.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: n
}) => {
  var i;
  const a = (i = (e.vars || e).palette) == null ? void 0 : i[n.color];
  return m1({}, n.color === "inherit" && {
    color: "inherit"
  }, n.color !== "inherit" && n.color !== "default" && m1({
    color: a == null ? void 0 : a.main
  }, !n.disableRipple && {
    "&:hover": m1({}, a && {
      backgroundColor: e.vars ? `rgba(${a.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : i0(a.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), n.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, n.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${OH.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), OE = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: g,
    className: c,
    color: I = "default",
    disabled: h = !1,
    disableFocusRipple: m = !1,
    size: w = "medium"
  } = a, S = Tt(a, DH), T = m1({}, a, {
    edge: s,
    color: I,
    disabled: h,
    disableFocusRipple: m,
    size: w
  }), D = kH(T);
  return /* @__PURE__ */ y.jsx(jH, m1({
    className: Xt(D.root, c),
    centerRipple: !0,
    focusRipple: !m,
    disabled: h,
    ref: i
  }, S, {
    ownerState: T,
    children: g
  }));
});
process.env.NODE_ENV !== "production" && (OE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Fc(E.node, (e) => n1.Children.toArray(e.children).some((i) => /* @__PURE__ */ n1.isValidElement(i) && i.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: E.oneOfType([E.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), E.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: E.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: E.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: E.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: E.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: E.oneOfType([E.oneOf(["small", "medium", "large"]), E.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const $11 = (e) => {
  const [n, i] = lz(), a = h2(() => {
    const h = {};
    for (const [m, w] of n.entries())
      h[m] = w;
    return h;
  }, [n]), s = V2(a, [a]), g = h2(
    (h) => {
      Object.keys(h).forEach((m) => {
        n.set(m, h[m] || "");
      }), i(n, { replace: !0 });
    },
    [i]
  ), c = h2(
    (h) => {
      const w = {
        ...a(),
        ...h
      };
      g(w);
    },
    [a, g]
  ), I = h2(() => {
    const h = [];
    for (const [m, w] of n.entries()) {
      const S = e[m];
      (S !== w || S === void 0) && h.push(m);
    }
    return h;
  }, [n]);
  return If(() => {
    const h = a(), m = {
      ...e,
      ...h
    };
    g(m);
  }, [a, g]), {
    state: s,
    getState: a,
    setState: g,
    updateState: c,
    listChangedParams: I
  };
}, zH = () => {
  const e = Da(), n = hc(e.breakpoints.only("xs")), i = hc(e.breakpoints.only("sm")), a = hc(e.breakpoints.only("md")), s = hc(e.breakpoints.only("lg")), g = hc(e.breakpoints.only("xl")), c = n || i;
  return {
    isXs: n,
    isSm: i,
    isMd: a,
    isLg: s,
    isXl: g,
    isMobile: c,
    isTablet: a,
    isDesktop: !c
  };
}, NH = typeof window > "u" ? vn : If;
function Iw() {
  var e, n, i, a;
  return typeof window > "u" ? { height: 430, width: 320, top: 0, left: 0, layoutHeight: 430 } : {
    height: ((e = window.visualViewport) == null ? void 0 : e.height) ?? window.innerHeight,
    width: ((n = window.visualViewport) == null ? void 0 : n.width) ?? window.innerWidth,
    top: ((i = window.visualViewport) == null ? void 0 : i.offsetTop) ?? 0,
    left: ((a = window.visualViewport) == null ? void 0 : a.offsetLeft) ?? 0,
    layoutHeight: window.innerHeight
  };
}
function PH(e, n, i, a) {
  const [s, g] = qt(Iw), [c, I] = qt(null);
  NH(() => {
    var S, T;
    if (!e || !n) return;
    const w = () => {
      g(Iw()), I((i == null ? void 0 : i.getBoundingClientRect().left) ?? null);
    };
    return w(), (S = window.visualViewport) == null || S.addEventListener("resize", w), (T = window.visualViewport) == null || T.addEventListener("scroll", w), window.addEventListener("resize", w), window.addEventListener("scroll", w), () => {
      var D, k;
      (D = window.visualViewport) == null || D.removeEventListener("resize", w), (k = window.visualViewport) == null || k.removeEventListener("scroll", w), window.removeEventListener("resize", w), window.removeEventListener("scroll", w);
    };
  }, [e, n, i]);
  const h = Math.min(a, Math.max(0, s.width - 16)), m = Math.max(s.left + 8, Math.min(
    c ?? s.left + 8,
    s.left + s.width - h - 8
  ));
  return {
    viewport: s,
    // Landscape or keyboard-shrunken viewports need a predictable bottom edge.
    compact: s.height <= 430 || s.height < s.layoutHeight - 100,
    veryShort: s.height < 220,
    anchorPosition: {
      top: Math.round(s.top + s.height - 8),
      left: Math.round(m)
    }
  };
}
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function FH(e, n, i) {
  return (n = HH(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function pw(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function U1(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? pw(Object(i), !0).forEach(function(a) {
      FH(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : pw(Object(i)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return e;
}
function BH(e, n) {
  if (typeof e != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(e, n || "default");
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function HH(e) {
  var n = BH(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
const hw = () => {
};
let lm = {}, DE = {}, kE = null, jE = {
  mark: hw,
  measure: hw
};
try {
  typeof window < "u" && (lm = window), typeof document < "u" && (DE = document), typeof MutationObserver < "u" && (kE = MutationObserver), typeof performance < "u" && (jE = performance);
} catch {
}
const {
  userAgent: mw = ""
} = lm.navigator || {}, Ko = lm, bn = DE, vw = kE, VC = jE;
Ko.document;
const ja = !!bn.documentElement && !!bn.head && typeof bn.addEventListener == "function" && typeof bn.createElement == "function", zE = ~mw.indexOf("MSIE") || ~mw.indexOf("Trident/");
var UH = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, WH = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, NE = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, VH = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, PE = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], kr = "classic", a6 = "duotone", _H = "sharp", JH = "sharp-duotone", FE = [kr, a6, _H, JH], KH = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, YH = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, QH = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), XH = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, GH = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], yw = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, qH = ["kit"], ZH = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, $H = ["fak", "fakd"], eU = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, bw = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, _C = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, tU = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], nU = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], rU = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, iU = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, aU = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, nh = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, oU = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], rh = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...tU, ...oU], sU = ["solid", "regular", "light", "thin", "duotone", "brands"], BE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], lU = BE.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), uU = [...Object.keys(aU), ...sU, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", _C.GROUP, _C.SWAP_OPACITY, _C.PRIMARY, _C.SECONDARY].concat(BE.map((e) => "".concat(e, "x"))).concat(lU.map((e) => "w-".concat(e))), cU = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Ra = "___FONT_AWESOME___", ih = 16, HE = "fa", UE = "svg-inline--fa", Al = "data-fa-i2svg", ah = "data-fa-pseudo-element", gU = "data-fa-pseudo-element-pending", um = "data-prefix", cm = "data-icon", ww = "fontawesome-i2svg", fU = "async", dU = ["HTML", "HEAD", "STYLE", "SCRIPT"], WE = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Nf(e) {
  return new Proxy(e, {
    get(n, i) {
      return i in n ? n[i] : n[kr];
    }
  });
}
const VE = U1({}, NE);
VE[kr] = U1(U1(U1(U1({}, {
  "fa-duotone": "duotone"
}), NE[kr]), yw.kit), yw["kit-duotone"]);
const CU = Nf(VE), oh = U1({}, XH);
oh[kr] = U1(U1(U1(U1({}, {
  duotone: "fad"
}), oh[kr]), bw.kit), bw["kit-duotone"]);
const xw = Nf(oh), sh = U1({}, nh);
sh[kr] = U1(U1({}, sh[kr]), eU.kit);
const gm = Nf(sh), lh = U1({}, iU);
lh[kr] = U1(U1({}, lh[kr]), ZH.kit);
Nf(lh);
const AU = UH, _E = "fa-layers-text", IU = WH, pU = U1({}, KH);
Nf(pU);
const hU = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], i7 = VH, mU = [...qH, ...uU], cf = Ko.FontAwesomeConfig || {};
function vU(e) {
  var n = bn.querySelector("script[" + e + "]");
  if (n)
    return n.getAttribute(e);
}
function yU(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
bn && typeof bn.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((n) => {
  let [i, a] = n;
  const s = yU(vU(i));
  s != null && (cf[a] = s);
});
const JE = {
  styleDefault: "solid",
  familyDefault: kr,
  cssPrefix: HE,
  replacementClass: UE,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
cf.familyPrefix && (cf.cssPrefix = cf.familyPrefix);
const kc = U1(U1({}, JE), cf);
kc.autoReplaceSvg || (kc.observeMutations = !1);
const De = {};
Object.keys(JE).forEach((e) => {
  Object.defineProperty(De, e, {
    enumerable: !0,
    set: function(n) {
      kc[e] = n, gf.forEach((i) => i(De));
    },
    get: function() {
      return kc[e];
    }
  });
});
Object.defineProperty(De, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    kc.cssPrefix = e, gf.forEach((n) => n(De));
  },
  get: function() {
    return kc.cssPrefix;
  }
});
Ko.FontAwesomeConfig = De;
const gf = [];
function bU(e) {
  return gf.push(e), () => {
    gf.splice(gf.indexOf(e), 1);
  };
}
const Uo = ih, Ti = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function wU(e) {
  if (!e || !ja)
    return;
  const n = bn.createElement("style");
  n.setAttribute("type", "text/css"), n.innerHTML = e;
  const i = bn.head.childNodes;
  let a = null;
  for (let s = i.length - 1; s > -1; s--) {
    const g = i[s], c = (g.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(c) > -1 && (a = g);
  }
  return bn.head.insertBefore(n, a), e;
}
const xU = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function xf() {
  let e = 12, n = "";
  for (; e-- > 0; )
    n += xU[Math.random() * 62 | 0];
  return n;
}
function Wc(e) {
  const n = [];
  for (let i = (e || []).length >>> 0; i--; )
    n[i] = e[i];
  return n;
}
function fm(e) {
  return e.classList ? Wc(e.classList) : (e.getAttribute("class") || "").split(" ").filter((n) => n);
}
function KE(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function SU(e) {
  return Object.keys(e || {}).reduce((n, i) => n + "".concat(i, '="').concat(KE(e[i]), '" '), "").trim();
}
function o6(e) {
  return Object.keys(e || {}).reduce((n, i) => n + "".concat(i, ": ").concat(e[i].trim(), ";"), "");
}
function dm(e) {
  return e.size !== Ti.size || e.x !== Ti.x || e.y !== Ti.y || e.rotate !== Ti.rotate || e.flipX || e.flipY;
}
function EU(e) {
  let {
    transform: n,
    containerWidth: i,
    iconWidth: a
  } = e;
  const s = {
    transform: "translate(".concat(i / 2, " 256)")
  }, g = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), I = "rotate(".concat(n.rotate, " 0 0)"), h = {
    transform: "".concat(g, " ").concat(c, " ").concat(I)
  }, m = {
    transform: "translate(".concat(a / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: h,
    path: m
  };
}
function MU(e) {
  let {
    transform: n,
    width: i = ih,
    height: a = ih,
    startCentered: s = !1
  } = e, g = "";
  return s && zE ? g += "translate(".concat(n.x / Uo - i / 2, "em, ").concat(n.y / Uo - a / 2, "em) ") : s ? g += "translate(calc(-50% + ".concat(n.x / Uo, "em), calc(-50% + ").concat(n.y / Uo, "em)) ") : g += "translate(".concat(n.x / Uo, "em, ").concat(n.y / Uo, "em) "), g += "scale(".concat(n.size / Uo * (n.flipX ? -1 : 1), ", ").concat(n.size / Uo * (n.flipY ? -1 : 1), ") "), g += "rotate(".concat(n.rotate, "deg) "), g;
}
var TU = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function YE() {
  const e = HE, n = UE, i = De.cssPrefix, a = De.replacementClass;
  let s = TU;
  if (i !== e || a !== n) {
    const g = new RegExp("\\.".concat(e, "\\-"), "g"), c = new RegExp("\\--".concat(e, "\\-"), "g"), I = new RegExp("\\.".concat(n), "g");
    s = s.replace(g, ".".concat(i, "-")).replace(c, "--".concat(i, "-")).replace(I, ".".concat(a));
  }
  return s;
}
let Sw = !1;
function a7() {
  De.autoAddCss && !Sw && (wU(YE()), Sw = !0);
}
var LU = {
  mixout() {
    return {
      dom: {
        css: YE,
        insertCss: a7
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        a7();
      },
      beforeI2svg() {
        a7();
      }
    };
  }
};
const Oa = Ko || {};
Oa[Ra] || (Oa[Ra] = {});
Oa[Ra].styles || (Oa[Ra].styles = {});
Oa[Ra].hooks || (Oa[Ra].hooks = {});
Oa[Ra].shims || (Oa[Ra].shims = []);
var Li = Oa[Ra];
const QE = [], XE = function() {
  bn.removeEventListener("DOMContentLoaded", XE), xA = 1, QE.map((e) => e());
};
let xA = !1;
ja && (xA = (bn.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(bn.readyState), xA || bn.addEventListener("DOMContentLoaded", XE));
function RU(e) {
  ja && (xA ? setTimeout(e, 0) : QE.push(e));
}
function Pf(e) {
  const {
    tag: n,
    attributes: i = {},
    children: a = []
  } = e;
  return typeof e == "string" ? KE(e) : "<".concat(n, " ").concat(SU(i), ">").concat(a.map(Pf).join(""), "</").concat(n, ">");
}
function Ew(e, n, i) {
  if (e && e[n] && e[n][i])
    return {
      prefix: n,
      iconName: i,
      icon: e[n][i]
    };
}
var o7 = function(n, i, a, s) {
  var g = Object.keys(n), c = g.length, I = i, h, m, w;
  for (a === void 0 ? (h = 1, w = n[g[0]]) : (h = 0, w = a); h < c; h++)
    m = g[h], w = I(w, n[m], m, n);
  return w;
};
function OU(e) {
  const n = [];
  let i = 0;
  const a = e.length;
  for (; i < a; ) {
    const s = e.charCodeAt(i++);
    if (s >= 55296 && s <= 56319 && i < a) {
      const g = e.charCodeAt(i++);
      (g & 64512) == 56320 ? n.push(((s & 1023) << 10) + (g & 1023) + 65536) : (n.push(s), i--);
    } else
      n.push(s);
  }
  return n;
}
function uh(e) {
  const n = OU(e);
  return n.length === 1 ? n[0].toString(16) : null;
}
function DU(e, n) {
  const i = e.length;
  let a = e.charCodeAt(n), s;
  return a >= 55296 && a <= 56319 && i > n + 1 && (s = e.charCodeAt(n + 1), s >= 56320 && s <= 57343) ? (a - 55296) * 1024 + s - 56320 + 65536 : a;
}
function Mw(e) {
  return Object.keys(e).reduce((n, i) => {
    const a = e[i];
    return !!a.icon ? n[a.iconName] = a.icon : n[i] = a, n;
  }, {});
}
function ch(e, n) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: a = !1
  } = i, s = Mw(n);
  typeof Li.hooks.addPack == "function" && !a ? Li.hooks.addPack(e, Mw(n)) : Li.styles[e] = U1(U1({}, Li.styles[e] || {}), s), e === "fas" && ch("fa", n);
}
const {
  styles: Sf,
  shims: kU
} = Li, GE = Object.keys(gm), jU = GE.reduce((e, n) => (e[n] = Object.keys(gm[n]), e), {});
let Cm = null, qE = {}, ZE = {}, $E = {}, eM = {}, tM = {};
function zU(e) {
  return ~mU.indexOf(e);
}
function NU(e, n) {
  const i = n.split("-"), a = i[0], s = i.slice(1).join("-");
  return a === e && s !== "" && !zU(s) ? s : null;
}
const nM = () => {
  const e = (a) => o7(Sf, (s, g, c) => (s[c] = o7(g, a, {}), s), {});
  qE = e((a, s, g) => (s[3] && (a[s[3]] = g), s[2] && s[2].filter((I) => typeof I == "number").forEach((I) => {
    a[I.toString(16)] = g;
  }), a)), ZE = e((a, s, g) => (a[g] = g, s[2] && s[2].filter((I) => typeof I == "string").forEach((I) => {
    a[I] = g;
  }), a)), tM = e((a, s, g) => {
    const c = s[2];
    return a[g] = g, c.forEach((I) => {
      a[I] = g;
    }), a;
  });
  const n = "far" in Sf || De.autoFetchSvg, i = o7(kU, (a, s) => {
    const g = s[0];
    let c = s[1];
    const I = s[2];
    return c === "far" && !n && (c = "fas"), typeof g == "string" && (a.names[g] = {
      prefix: c,
      iconName: I
    }), typeof g == "number" && (a.unicodes[g.toString(16)] = {
      prefix: c,
      iconName: I
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  $E = i.names, eM = i.unicodes, Cm = s6(De.styleDefault, {
    family: De.familyDefault
  });
};
bU((e) => {
  Cm = s6(e.styleDefault, {
    family: De.familyDefault
  });
});
nM();
function Am(e, n) {
  return (qE[e] || {})[n];
}
function PU(e, n) {
  return (ZE[e] || {})[n];
}
function cl(e, n) {
  return (tM[e] || {})[n];
}
function rM(e) {
  return $E[e] || {
    prefix: null,
    iconName: null
  };
}
function FU(e) {
  const n = eM[e], i = Am("fas", e);
  return n || (i ? {
    prefix: "fas",
    iconName: i
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Yo() {
  return Cm;
}
const iM = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function BU(e) {
  let n = kr;
  const i = GE.reduce((a, s) => (a[s] = "".concat(De.cssPrefix, "-").concat(s), a), {});
  return FE.forEach((a) => {
    (e.includes(i[a]) || e.some((s) => jU[a].includes(s))) && (n = a);
  }), n;
}
function s6(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: i = kr
  } = n, a = CU[i][e];
  if (i === a6 && !e)
    return "fad";
  const s = xw[i][e] || xw[i][a], g = e in Li.styles ? e : null;
  return s || g || null;
}
function HU(e) {
  let n = [], i = null;
  return e.forEach((a) => {
    const s = NU(De.cssPrefix, a);
    s ? i = s : a && n.push(a);
  }), {
    iconName: i,
    rest: n
  };
}
function Tw(e) {
  return e.sort().filter((n, i, a) => a.indexOf(n) === i);
}
function l6(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: i = !1
  } = n;
  let a = null;
  const s = rh.concat(nU), g = Tw(e.filter((S) => s.includes(S))), c = Tw(e.filter((S) => !rh.includes(S))), I = g.filter((S) => (a = S, !PE.includes(S))), [h = null] = I, m = BU(g), w = U1(U1({}, HU(c)), {}, {
    prefix: s6(h, {
      family: m
    })
  });
  return U1(U1(U1({}, w), _U({
    values: e,
    family: m,
    styles: Sf,
    config: De,
    canonical: w,
    givenPrefix: a
  })), UU(i, a, w));
}
function UU(e, n, i) {
  let {
    prefix: a,
    iconName: s
  } = i;
  if (e || !a || !s)
    return {
      prefix: a,
      iconName: s
    };
  const g = n === "fa" ? rM(s) : {}, c = cl(a, s);
  return s = g.iconName || c || s, a = g.prefix || a, a === "far" && !Sf.far && Sf.fas && !De.autoFetchSvg && (a = "fas"), {
    prefix: a,
    iconName: s
  };
}
const WU = FE.filter((e) => e !== kr || e !== a6), VU = Object.keys(nh).filter((e) => e !== kr).map((e) => Object.keys(nh[e])).flat();
function _U(e) {
  const {
    values: n,
    family: i,
    canonical: a,
    givenPrefix: s = "",
    styles: g = {},
    config: c = {}
  } = e, I = i === a6, h = n.includes("fa-duotone") || n.includes("fad"), m = c.familyDefault === "duotone", w = a.prefix === "fad" || a.prefix === "fa-duotone";
  if (!I && (h || m || w) && (a.prefix = "fad"), (n.includes("fa-brands") || n.includes("fab")) && (a.prefix = "fab"), !a.prefix && WU.includes(i) && (Object.keys(g).find((T) => VU.includes(T)) || c.autoFetchSvg)) {
    const T = QH.get(i).defaultShortPrefixId;
    a.prefix = T, a.iconName = cl(a.prefix, a.iconName) || a.iconName;
  }
  return (a.prefix === "fa" || s === "fa") && (a.prefix = Yo() || "fas"), a;
}
class JU {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    const s = i.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((g) => {
      this.definitions[g] = U1(U1({}, this.definitions[g] || {}), s[g]), ch(g, s[g]);
      const c = gm[kr][g];
      c && ch(c, s[g]), nM();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(n, i) {
    const a = i.prefix && i.iconName && i.icon ? {
      0: i
    } : i;
    return Object.keys(a).map((s) => {
      const {
        prefix: g,
        iconName: c,
        icon: I
      } = a[s], h = I[2];
      n[g] || (n[g] = {}), h.length > 0 && h.forEach((m) => {
        typeof m == "string" && (n[g][m] = I);
      }), n[g][c] = I;
    }), n;
  }
}
let Lw = [], bc = {};
const Mc = {}, KU = Object.keys(Mc);
function YU(e, n) {
  let {
    mixoutsTo: i
  } = n;
  return Lw = e, bc = {}, Object.keys(Mc).forEach((a) => {
    KU.indexOf(a) === -1 && delete Mc[a];
  }), Lw.forEach((a) => {
    const s = a.mixout ? a.mixout() : {};
    if (Object.keys(s).forEach((g) => {
      typeof s[g] == "function" && (i[g] = s[g]), typeof s[g] == "object" && Object.keys(s[g]).forEach((c) => {
        i[g] || (i[g] = {}), i[g][c] = s[g][c];
      });
    }), a.hooks) {
      const g = a.hooks();
      Object.keys(g).forEach((c) => {
        bc[c] || (bc[c] = []), bc[c].push(g[c]);
      });
    }
    a.provides && a.provides(Mc);
  }), i;
}
function gh(e, n) {
  for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++)
    a[s - 2] = arguments[s];
  return (bc[e] || []).forEach((c) => {
    n = c.apply(null, [n, ...a]);
  }), n;
}
function Il(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    i[a - 1] = arguments[a];
  (bc[e] || []).forEach((g) => {
    g.apply(null, i);
  });
}
function Qo() {
  const e = arguments[0], n = Array.prototype.slice.call(arguments, 1);
  return Mc[e] ? Mc[e].apply(null, n) : void 0;
}
function fh(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: n
  } = e;
  const i = e.prefix || Yo();
  if (n)
    return n = cl(i, n) || n, Ew(aM.definitions, i, n) || Ew(Li.styles, i, n);
}
const aM = new JU(), QU = () => {
  De.autoReplaceSvg = !1, De.observeMutations = !1, Il("noAuto");
}, XU = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ja ? (Il("beforeI2svg", e), Qo("pseudoElements2svg", e), Qo("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: n
    } = e;
    De.autoReplaceSvg === !1 && (De.autoReplaceSvg = !0), De.observeMutations = !0, RU(() => {
      qU({
        autoReplaceSvgRoot: n
      }), Il("watch", e);
    });
  }
}, GU = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: cl(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const n = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], i = s6(e[0]);
      return {
        prefix: i,
        iconName: cl(i, n) || n
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(De.cssPrefix, "-")) > -1 || e.match(AU))) {
      const n = l6(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: n.prefix || Yo(),
        iconName: cl(n.prefix, n.iconName) || n.iconName
      };
    }
    if (typeof e == "string") {
      const n = Yo();
      return {
        prefix: n,
        iconName: cl(n, e) || e
      };
    }
  }
}, k3 = {
  noAuto: QU,
  config: De,
  dom: XU,
  parse: GU,
  library: aM,
  findIconDefinition: fh,
  toHtml: Pf
}, qU = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: n = bn
  } = e;
  (Object.keys(Li.styles).length > 0 || De.autoFetchSvg) && ja && De.autoReplaceSvg && k3.dom.i2svg({
    node: n
  });
};
function u6(e, n) {
  return Object.defineProperty(e, "abstract", {
    get: n
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((i) => Pf(i));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!ja) return;
      const i = bn.createElement("div");
      return i.innerHTML = e.html, i.children;
    }
  }), e;
}
function ZU(e) {
  let {
    children: n,
    main: i,
    mask: a,
    attributes: s,
    styles: g,
    transform: c
  } = e;
  if (dm(c) && i.found && !a.found) {
    const {
      width: I,
      height: h
    } = i, m = {
      x: I / h / 2,
      y: 0.5
    };
    s.style = o6(U1(U1({}, g), {}, {
      "transform-origin": "".concat(m.x + c.x / 16, "em ").concat(m.y + c.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: n
  }];
}
function $U(e) {
  let {
    prefix: n,
    iconName: i,
    children: a,
    attributes: s,
    symbol: g
  } = e;
  const c = g === !0 ? "".concat(n, "-").concat(De.cssPrefix, "-").concat(i) : g;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: U1(U1({}, s), {}, {
        id: c
      }),
      children: a
    }]
  }];
}
function Im(e) {
  const {
    icons: {
      main: n,
      mask: i
    },
    prefix: a,
    iconName: s,
    transform: g,
    symbol: c,
    title: I,
    maskId: h,
    titleId: m,
    extra: w,
    watchable: S = !1
  } = e, {
    width: T,
    height: D
  } = i.found ? i : n, k = $H.includes(a), z = [De.replacementClass, s ? "".concat(De.cssPrefix, "-").concat(s) : ""].filter((H) => w.classes.indexOf(H) === -1).filter((H) => H !== "" || !!H).concat(w.classes).join(" ");
  let N = {
    children: [],
    attributes: U1(U1({}, w.attributes), {}, {
      "data-prefix": a,
      "data-icon": s,
      class: z,
      role: w.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(T, " ").concat(D)
    })
  };
  const W = k && !~w.classes.indexOf("fa-fw") ? {
    width: "".concat(T / D * 16 * 0.0625, "em")
  } : {};
  S && (N.attributes[Al] = ""), I && (N.children.push({
    tag: "title",
    attributes: {
      id: N.attributes["aria-labelledby"] || "title-".concat(m || xf())
    },
    children: [I]
  }), delete N.attributes.title);
  const K = U1(U1({}, N), {}, {
    prefix: a,
    iconName: s,
    main: n,
    mask: i,
    maskId: h,
    transform: g,
    symbol: c,
    styles: U1(U1({}, W), w.styles)
  }), {
    children: V,
    attributes: Y
  } = i.found && n.found ? Qo("generateAbstractMask", K) || {
    children: [],
    attributes: {}
  } : Qo("generateAbstractIcon", K) || {
    children: [],
    attributes: {}
  };
  return K.children = V, K.attributes = Y, c ? $U(K) : ZU(K);
}
function Rw(e) {
  const {
    content: n,
    width: i,
    height: a,
    transform: s,
    title: g,
    extra: c,
    watchable: I = !1
  } = e, h = U1(U1(U1({}, c.attributes), g ? {
    title: g
  } : {}), {}, {
    class: c.classes.join(" ")
  });
  I && (h[Al] = "");
  const m = U1({}, c.styles);
  dm(s) && (m.transform = MU({
    transform: s,
    startCentered: !0,
    width: i,
    height: a
  }), m["-webkit-transform"] = m.transform);
  const w = o6(m);
  w.length > 0 && (h.style = w);
  const S = [];
  return S.push({
    tag: "span",
    attributes: h,
    children: [n]
  }), g && S.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [g]
  }), S;
}
function eW(e) {
  const {
    content: n,
    title: i,
    extra: a
  } = e, s = U1(U1(U1({}, a.attributes), i ? {
    title: i
  } : {}), {}, {
    class: a.classes.join(" ")
  }), g = o6(a.styles);
  g.length > 0 && (s.style = g);
  const c = [];
  return c.push({
    tag: "span",
    attributes: s,
    children: [n]
  }), i && c.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), c;
}
const {
  styles: s7
} = Li;
function dh(e) {
  const n = e[0], i = e[1], [a] = e.slice(4);
  let s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(De.cssPrefix, "-").concat(i7.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(De.cssPrefix, "-").concat(i7.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(De.cssPrefix, "-").concat(i7.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: n,
    height: i,
    icon: s
  };
}
const tW = {
  found: !1,
  width: 512,
  height: 512
};
function nW(e, n) {
  !WE && !De.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(n, '" is missing.'));
}
function Ch(e, n) {
  let i = n;
  return n === "fa" && De.styleDefault !== null && (n = Yo()), new Promise((a, s) => {
    if (i === "fa") {
      const g = rM(e) || {};
      e = g.iconName || e, n = g.prefix || n;
    }
    if (e && n && s7[n] && s7[n][e]) {
      const g = s7[n][e];
      return a(dh(g));
    }
    nW(e, n), a(U1(U1({}, tW), {}, {
      icon: De.showMissingIcons && e ? Qo("missingIconAbstract") || {} : {}
    }));
  });
}
const Ow = () => {
}, Ah = De.measurePerformance && VC && VC.mark && VC.measure ? VC : {
  mark: Ow,
  measure: Ow
}, lf = 'FA "6.7.2"', rW = (e) => (Ah.mark("".concat(lf, " ").concat(e, " begins")), () => oM(e)), oM = (e) => {
  Ah.mark("".concat(lf, " ").concat(e, " ends")), Ah.measure("".concat(lf, " ").concat(e), "".concat(lf, " ").concat(e, " begins"), "".concat(lf, " ").concat(e, " ends"));
};
var pm = {
  begin: rW,
  end: oM
};
const uA = () => {
};
function Dw(e) {
  return typeof (e.getAttribute ? e.getAttribute(Al) : null) == "string";
}
function iW(e) {
  const n = e.getAttribute ? e.getAttribute(um) : null, i = e.getAttribute ? e.getAttribute(cm) : null;
  return n && i;
}
function aW(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(De.replacementClass);
}
function oW() {
  return De.autoReplaceSvg === !0 ? cA.replace : cA[De.autoReplaceSvg] || cA.replace;
}
function sW(e) {
  return bn.createElementNS("http://www.w3.org/2000/svg", e);
}
function lW(e) {
  return bn.createElement(e);
}
function sM(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: i = e.tag === "svg" ? sW : lW
  } = n;
  if (typeof e == "string")
    return bn.createTextNode(e);
  const a = i(e.tag);
  return Object.keys(e.attributes || []).forEach(function(g) {
    a.setAttribute(g, e.attributes[g]);
  }), (e.children || []).forEach(function(g) {
    a.appendChild(sM(g, {
      ceFn: i
    }));
  }), a;
}
function uW(e) {
  let n = " ".concat(e.outerHTML, " ");
  return n = "".concat(n, "Font Awesome fontawesome.com "), n;
}
const cA = {
  replace: function(e) {
    const n = e[0];
    if (n.parentNode)
      if (e[1].forEach((i) => {
        n.parentNode.insertBefore(sM(i), n);
      }), n.getAttribute(Al) === null && De.keepOriginalSource) {
        let i = bn.createComment(uW(n));
        n.parentNode.replaceChild(i, n);
      } else
        n.remove();
  },
  nest: function(e) {
    const n = e[0], i = e[1];
    if (~fm(n).indexOf(De.replacementClass))
      return cA.replace(e);
    const a = new RegExp("".concat(De.cssPrefix, "-.*"));
    if (delete i[0].attributes.id, i[0].attributes.class) {
      const g = i[0].attributes.class.split(" ").reduce((c, I) => (I === De.replacementClass || I.match(a) ? c.toSvg.push(I) : c.toNode.push(I), c), {
        toNode: [],
        toSvg: []
      });
      i[0].attributes.class = g.toSvg.join(" "), g.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", g.toNode.join(" "));
    }
    const s = i.map((g) => Pf(g)).join(`
`);
    n.setAttribute(Al, ""), n.innerHTML = s;
  }
};
function kw(e) {
  e();
}
function lM(e, n) {
  const i = typeof n == "function" ? n : uA;
  if (e.length === 0)
    i();
  else {
    let a = kw;
    De.mutateApproach === fU && (a = Ko.requestAnimationFrame || kw), a(() => {
      const s = oW(), g = pm.begin("mutate");
      e.map(s), g(), i();
    });
  }
}
let hm = !1;
function uM() {
  hm = !0;
}
function Ih() {
  hm = !1;
}
let SA = null;
function jw(e) {
  if (!vw || !De.observeMutations)
    return;
  const {
    treeCallback: n = uA,
    nodeCallback: i = uA,
    pseudoElementsCallback: a = uA,
    observeMutationsRoot: s = bn
  } = e;
  SA = new vw((g) => {
    if (hm) return;
    const c = Yo();
    Wc(g).forEach((I) => {
      if (I.type === "childList" && I.addedNodes.length > 0 && !Dw(I.addedNodes[0]) && (De.searchPseudoElements && a(I.target), n(I.target)), I.type === "attributes" && I.target.parentNode && De.searchPseudoElements && a(I.target.parentNode), I.type === "attributes" && Dw(I.target) && ~hU.indexOf(I.attributeName))
        if (I.attributeName === "class" && iW(I.target)) {
          const {
            prefix: h,
            iconName: m
          } = l6(fm(I.target));
          I.target.setAttribute(um, h || c), m && I.target.setAttribute(cm, m);
        } else aW(I.target) && i(I.target);
    });
  }), ja && SA.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function cW() {
  SA && SA.disconnect();
}
function gW(e) {
  const n = e.getAttribute("style");
  let i = [];
  return n && (i = n.split(";").reduce((a, s) => {
    const g = s.split(":"), c = g[0], I = g.slice(1);
    return c && I.length > 0 && (a[c] = I.join(":").trim()), a;
  }, {})), i;
}
function fW(e) {
  const n = e.getAttribute("data-prefix"), i = e.getAttribute("data-icon"), a = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = l6(fm(e));
  return s.prefix || (s.prefix = Yo()), n && i && (s.prefix = n, s.iconName = i), s.iconName && s.prefix || (s.prefix && a.length > 0 && (s.iconName = PU(s.prefix, e.innerText) || Am(s.prefix, uh(e.innerText))), !s.iconName && De.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function dW(e) {
  const n = Wc(e.attributes).reduce((s, g) => (s.name !== "class" && s.name !== "style" && (s[g.name] = g.value), s), {}), i = e.getAttribute("title"), a = e.getAttribute("data-fa-title-id");
  return De.autoA11y && (i ? n["aria-labelledby"] = "".concat(De.replacementClass, "-title-").concat(a || xf()) : (n["aria-hidden"] = "true", n.focusable = "false")), n;
}
function CW() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ti,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function zw(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: i,
    prefix: a,
    rest: s
  } = fW(e), g = dW(e), c = gh("parseNodeAttributes", {}, e);
  let I = n.styleParser ? gW(e) : [];
  return U1({
    iconName: i,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: Ti,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: I,
      attributes: g
    }
  }, c);
}
const {
  styles: AW
} = Li;
function cM(e) {
  const n = De.autoReplaceSvg === "nest" ? zw(e, {
    styleParser: !1
  }) : zw(e);
  return ~n.extra.classes.indexOf(_E) ? Qo("generateLayersText", e, n) : Qo("generateSvgReplacementMutation", e, n);
}
function IW() {
  return [...GH, ...rh];
}
function Nw(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!ja) return Promise.resolve();
  const i = bn.documentElement.classList, a = (w) => i.add("".concat(ww, "-").concat(w)), s = (w) => i.remove("".concat(ww, "-").concat(w)), g = De.autoFetchSvg ? IW() : PE.concat(Object.keys(AW));
  g.includes("fa") || g.push("fa");
  const c = [".".concat(_E, ":not([").concat(Al, "])")].concat(g.map((w) => ".".concat(w, ":not([").concat(Al, "])"))).join(", ");
  if (c.length === 0)
    return Promise.resolve();
  let I = [];
  try {
    I = Wc(e.querySelectorAll(c));
  } catch {
  }
  if (I.length > 0)
    a("pending"), s("complete");
  else
    return Promise.resolve();
  const h = pm.begin("onTree"), m = I.reduce((w, S) => {
    try {
      const T = cM(S);
      T && w.push(T);
    } catch (T) {
      WE || T.name === "MissingIcon" && console.error(T);
    }
    return w;
  }, []);
  return new Promise((w, S) => {
    Promise.all(m).then((T) => {
      lM(T, () => {
        a("active"), a("complete"), s("pending"), typeof n == "function" && n(), h(), w();
      });
    }).catch((T) => {
      h(), S(T);
    });
  });
}
function pW(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  cM(e).then((i) => {
    i && lM([i], n);
  });
}
function hW(e) {
  return function(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = (n || {}).icon ? n : fh(n || {});
    let {
      mask: s
    } = i;
    return s && (s = (s || {}).icon ? s : fh(s || {})), e(a, U1(U1({}, i), {}, {
      mask: s
    }));
  };
}
const mW = function(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: i = Ti,
    symbol: a = !1,
    mask: s = null,
    maskId: g = null,
    title: c = null,
    titleId: I = null,
    classes: h = [],
    attributes: m = {},
    styles: w = {}
  } = n;
  if (!e) return;
  const {
    prefix: S,
    iconName: T,
    icon: D
  } = e;
  return u6(U1({
    type: "icon"
  }, e), () => (Il("beforeDOMElementCreation", {
    iconDefinition: e,
    params: n
  }), De.autoA11y && (c ? m["aria-labelledby"] = "".concat(De.replacementClass, "-title-").concat(I || xf()) : (m["aria-hidden"] = "true", m.focusable = "false")), Im({
    icons: {
      main: dh(D),
      mask: s ? dh(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: S,
    iconName: T,
    transform: U1(U1({}, Ti), i),
    symbol: a,
    title: c,
    maskId: g,
    titleId: I,
    extra: {
      attributes: m,
      styles: w,
      classes: h
    }
  })));
};
var vW = {
  mixout() {
    return {
      icon: hW(mW)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = Nw, e.nodeCallback = pW, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(n) {
      const {
        node: i = bn,
        callback: a = () => {
        }
      } = n;
      return Nw(i, a);
    }, e.generateSvgReplacementMutation = function(n, i) {
      const {
        iconName: a,
        title: s,
        titleId: g,
        prefix: c,
        transform: I,
        symbol: h,
        mask: m,
        maskId: w,
        extra: S
      } = i;
      return new Promise((T, D) => {
        Promise.all([Ch(a, c), m.iconName ? Ch(m.iconName, m.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((k) => {
          let [z, N] = k;
          T([n, Im({
            icons: {
              main: z,
              mask: N
            },
            prefix: c,
            iconName: a,
            transform: I,
            symbol: h,
            maskId: w,
            title: s,
            titleId: g,
            extra: S,
            watchable: !0
          })]);
        }).catch(D);
      });
    }, e.generateAbstractIcon = function(n) {
      let {
        children: i,
        attributes: a,
        main: s,
        transform: g,
        styles: c
      } = n;
      const I = o6(c);
      I.length > 0 && (a.style = I);
      let h;
      return dm(g) && (h = Qo("generateAbstractTransformGrouping", {
        main: s,
        transform: g,
        containerWidth: s.width,
        iconWidth: s.width
      })), i.push(h || s.icon), {
        children: i,
        attributes: a
      };
    };
  }
}, yW = {
  mixout() {
    return {
      layer(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: i = []
        } = n;
        return u6({
          type: "layer"
        }, () => {
          Il("beforeDOMElementCreation", {
            assembler: e,
            params: n
          });
          let a = [];
          return e((s) => {
            Array.isArray(s) ? s.map((g) => {
              a = a.concat(g.abstract);
            }) : a = a.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(De.cssPrefix, "-layers"), ...i].join(" ")
            },
            children: a
          }];
        });
      }
    };
  }
}, bW = {
  mixout() {
    return {
      counter(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: i = null,
          classes: a = [],
          attributes: s = {},
          styles: g = {}
        } = n;
        return u6({
          type: "counter",
          content: e
        }, () => (Il("beforeDOMElementCreation", {
          content: e,
          params: n
        }), eW({
          content: e.toString(),
          title: i,
          extra: {
            attributes: s,
            styles: g,
            classes: ["".concat(De.cssPrefix, "-layers-counter"), ...a]
          }
        })));
      }
    };
  }
}, wW = {
  mixout() {
    return {
      text(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: i = Ti,
          title: a = null,
          classes: s = [],
          attributes: g = {},
          styles: c = {}
        } = n;
        return u6({
          type: "text",
          content: e
        }, () => (Il("beforeDOMElementCreation", {
          content: e,
          params: n
        }), Rw({
          content: e,
          transform: U1(U1({}, Ti), i),
          title: a,
          extra: {
            attributes: g,
            styles: c,
            classes: ["".concat(De.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(n, i) {
      const {
        title: a,
        transform: s,
        extra: g
      } = i;
      let c = null, I = null;
      if (zE) {
        const h = parseInt(getComputedStyle(n).fontSize, 10), m = n.getBoundingClientRect();
        c = m.width / h, I = m.height / h;
      }
      return De.autoA11y && !a && (g.attributes["aria-hidden"] = "true"), Promise.resolve([n, Rw({
        content: n.innerHTML,
        width: c,
        height: I,
        transform: s,
        title: a,
        extra: g,
        watchable: !0
      })]);
    };
  }
};
const xW = new RegExp('"', "ug"), Pw = [1105920, 1112319], Fw = U1(U1(U1(U1({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), YH), cU), rU), ph = Object.keys(Fw).reduce((e, n) => (e[n.toLowerCase()] = Fw[n], e), {}), SW = Object.keys(ph).reduce((e, n) => {
  const i = ph[n];
  return e[n] = i[900] || [...Object.entries(i)][0][1], e;
}, {});
function EW(e) {
  const n = e.replace(xW, ""), i = DU(n, 0), a = i >= Pw[0] && i <= Pw[1], s = n.length === 2 ? n[0] === n[1] : !1;
  return {
    value: uh(s ? n[0] : n),
    isSecondary: a || s
  };
}
function MW(e, n) {
  const i = e.replace(/^['"]|['"]$/g, "").toLowerCase(), a = parseInt(n), s = isNaN(a) ? "normal" : a;
  return (ph[i] || {})[s] || SW[i];
}
function Bw(e, n) {
  const i = "".concat(gU).concat(n.replace(":", "-"));
  return new Promise((a, s) => {
    if (e.getAttribute(i) !== null)
      return a();
    const c = Wc(e.children).filter((T) => T.getAttribute(ah) === n)[0], I = Ko.getComputedStyle(e, n), h = I.getPropertyValue("font-family"), m = h.match(IU), w = I.getPropertyValue("font-weight"), S = I.getPropertyValue("content");
    if (c && !m)
      return e.removeChild(c), a();
    if (m && S !== "none" && S !== "") {
      const T = I.getPropertyValue("content");
      let D = MW(h, w);
      const {
        value: k,
        isSecondary: z
      } = EW(T), N = m[0].startsWith("FontAwesome");
      let W = Am(D, k), K = W;
      if (N) {
        const V = FU(k);
        V.iconName && V.prefix && (W = V.iconName, D = V.prefix);
      }
      if (W && !z && (!c || c.getAttribute(um) !== D || c.getAttribute(cm) !== K)) {
        e.setAttribute(i, K), c && e.removeChild(c);
        const V = CW(), {
          extra: Y
        } = V;
        Y.attributes[ah] = n, Ch(W, D).then((H) => {
          const Z = Im(U1(U1({}, V), {}, {
            icons: {
              main: H,
              mask: iM()
            },
            prefix: D,
            iconName: K,
            extra: Y,
            watchable: !0
          })), Q = bn.createElementNS("http://www.w3.org/2000/svg", "svg");
          n === "::before" ? e.insertBefore(Q, e.firstChild) : e.appendChild(Q), Q.outerHTML = Z.map((P1) => Pf(P1)).join(`
`), e.removeAttribute(i), a();
        }).catch(s);
      } else
        a();
    } else
      a();
  });
}
function TW(e) {
  return Promise.all([Bw(e, "::before"), Bw(e, "::after")]);
}
function LW(e) {
  return e.parentNode !== document.head && !~dU.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(ah) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function Hw(e) {
  if (ja)
    return new Promise((n, i) => {
      const a = Wc(e.querySelectorAll("*")).filter(LW).map(TW), s = pm.begin("searchPseudoElements");
      uM(), Promise.all(a).then(() => {
        s(), Ih(), n();
      }).catch(() => {
        s(), Ih(), i();
      });
    });
}
var RW = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = Hw, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(n) {
      const {
        node: i = bn
      } = n;
      De.searchPseudoElements && Hw(i);
    };
  }
};
let Uw = !1;
var OW = {
  mixout() {
    return {
      dom: {
        unwatch() {
          uM(), Uw = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        jw(gh("mutationObserverCallbacks", {}));
      },
      noAuto() {
        cW();
      },
      watch(e) {
        const {
          observeMutationsRoot: n
        } = e;
        Uw ? Ih() : jw(gh("mutationObserverCallbacks", {
          observeMutationsRoot: n
        }));
      }
    };
  }
};
const Ww = (e) => {
  let n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((i, a) => {
    const s = a.toLowerCase().split("-"), g = s[0];
    let c = s.slice(1).join("-");
    if (g && c === "h")
      return i.flipX = !0, i;
    if (g && c === "v")
      return i.flipY = !0, i;
    if (c = parseFloat(c), isNaN(c))
      return i;
    switch (g) {
      case "grow":
        i.size = i.size + c;
        break;
      case "shrink":
        i.size = i.size - c;
        break;
      case "left":
        i.x = i.x - c;
        break;
      case "right":
        i.x = i.x + c;
        break;
      case "up":
        i.y = i.y - c;
        break;
      case "down":
        i.y = i.y + c;
        break;
      case "rotate":
        i.rotate = i.rotate + c;
        break;
    }
    return i;
  }, n);
};
var DW = {
  mixout() {
    return {
      parse: {
        transform: (e) => Ww(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-transform");
        return i && (e.transform = Ww(i)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(n) {
      let {
        main: i,
        transform: a,
        containerWidth: s,
        iconWidth: g
      } = n;
      const c = {
        transform: "translate(".concat(s / 2, " 256)")
      }, I = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), h = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), m = "rotate(".concat(a.rotate, " 0 0)"), w = {
        transform: "".concat(I, " ").concat(h, " ").concat(m)
      }, S = {
        transform: "translate(".concat(g / 2 * -1, " -256)")
      }, T = {
        outer: c,
        inner: w,
        path: S
      };
      return {
        tag: "g",
        attributes: U1({}, T.outer),
        children: [{
          tag: "g",
          attributes: U1({}, T.inner),
          children: [{
            tag: i.icon.tag,
            children: i.icon.children,
            attributes: U1(U1({}, i.icon.attributes), T.path)
          }]
        }]
      };
    };
  }
};
const l7 = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Vw(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || n) && (e.attributes.fill = "black"), e;
}
function kW(e) {
  return e.tag === "g" ? e.children : [e];
}
var jW = {
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-mask"), a = i ? l6(i.split(" ").map((s) => s.trim())) : iM();
        return a.prefix || (a.prefix = Yo()), e.mask = a, e.maskId = n.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(n) {
      let {
        children: i,
        attributes: a,
        main: s,
        mask: g,
        maskId: c,
        transform: I
      } = n;
      const {
        width: h,
        icon: m
      } = s, {
        width: w,
        icon: S
      } = g, T = EU({
        transform: I,
        containerWidth: w,
        iconWidth: h
      }), D = {
        tag: "rect",
        attributes: U1(U1({}, l7), {}, {
          fill: "white"
        })
      }, k = m.children ? {
        children: m.children.map(Vw)
      } : {}, z = {
        tag: "g",
        attributes: U1({}, T.inner),
        children: [Vw(U1({
          tag: m.tag,
          attributes: U1(U1({}, m.attributes), T.path)
        }, k))]
      }, N = {
        tag: "g",
        attributes: U1({}, T.outer),
        children: [z]
      }, W = "mask-".concat(c || xf()), K = "clip-".concat(c || xf()), V = {
        tag: "mask",
        attributes: U1(U1({}, l7), {}, {
          id: W,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [D, N]
      }, Y = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: K
          },
          children: kW(S)
        }, V]
      };
      return i.push(Y, {
        tag: "rect",
        attributes: U1({
          fill: "currentColor",
          "clip-path": "url(#".concat(K, ")"),
          mask: "url(#".concat(W, ")")
        }, l7)
      }), {
        children: i,
        attributes: a
      };
    };
  }
}, zW = {
  provides(e) {
    let n = !1;
    Ko.matchMedia && (n = Ko.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const i = [], a = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      i.push({
        tag: "path",
        attributes: U1(U1({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const g = U1(U1({}, s), {}, {
        attributeName: "opacity"
      }), c = {
        tag: "circle",
        attributes: U1(U1({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || c.children.push({
        tag: "animate",
        attributes: U1(U1({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: U1(U1({}, g), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), i.push(c), i.push({
        tag: "path",
        attributes: U1(U1({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: U1(U1({}, g), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || i.push({
        tag: "path",
        attributes: U1(U1({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: U1(U1({}, g), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: i
      };
    };
  }
}, NW = {
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-symbol"), a = i === null ? !1 : i === "" ? !0 : i;
        return e.symbol = a, e;
      }
    };
  }
}, PW = [LU, vW, yW, bW, wW, RW, OW, DW, jW, zW, NW];
YU(PW, {
  mixoutsTo: k3
});
k3.noAuto;
k3.config;
k3.library;
k3.dom;
const hh = k3.parse;
k3.findIconDefinition;
k3.toHtml;
const FW = k3.icon;
k3.layer;
k3.text;
k3.counter;
function _w(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function wi(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? _w(Object(i), !0).forEach(function(a) {
      wc(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : _w(Object(i)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return e;
}
function EA(e) {
  "@babel/helpers - typeof";
  return EA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, EA(e);
}
function wc(e, n, i) {
  return n in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function BW(e, n) {
  if (e == null) return {};
  var i = {}, a = Object.keys(e), s, g;
  for (g = 0; g < a.length; g++)
    s = a[g], !(n.indexOf(s) >= 0) && (i[s] = e[s]);
  return i;
}
function HW(e, n) {
  if (e == null) return {};
  var i = BW(e, n), a, s;
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(e);
    for (s = 0; s < g.length; s++)
      a = g[s], !(n.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (i[a] = e[a]);
  }
  return i;
}
function mh(e) {
  return UW(e) || WW(e) || VW(e) || _W();
}
function UW(e) {
  if (Array.isArray(e)) return vh(e);
}
function WW(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function VW(e, n) {
  if (e) {
    if (typeof e == "string") return vh(e, n);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return vh(e, n);
  }
}
function vh(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, a = new Array(n); i < n; i++) a[i] = e[i];
  return a;
}
function _W() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JW(e) {
  var n, i = e.beat, a = e.fade, s = e.beatFade, g = e.bounce, c = e.shake, I = e.flash, h = e.spin, m = e.spinPulse, w = e.spinReverse, S = e.pulse, T = e.fixedWidth, D = e.inverse, k = e.border, z = e.listItem, N = e.flip, W = e.size, K = e.rotation, V = e.pull, Y = (n = {
    "fa-beat": i,
    "fa-fade": a,
    "fa-beat-fade": s,
    "fa-bounce": g,
    "fa-shake": c,
    "fa-flash": I,
    "fa-spin": h,
    "fa-spin-reverse": w,
    "fa-spin-pulse": m,
    "fa-pulse": S,
    "fa-fw": T,
    "fa-inverse": D,
    "fa-border": k,
    "fa-li": z,
    "fa-flip": N === !0,
    "fa-flip-horizontal": N === "horizontal" || N === "both",
    "fa-flip-vertical": N === "vertical" || N === "both"
  }, wc(n, "fa-".concat(W), typeof W < "u" && W !== null), wc(n, "fa-rotate-".concat(K), typeof K < "u" && K !== null && K !== 0), wc(n, "fa-pull-".concat(V), typeof V < "u" && V !== null), wc(n, "fa-swap-opacity", e.swapOpacity), n);
  return Object.keys(Y).map(function(H) {
    return Y[H] ? H : null;
  }).filter(function(H) {
    return H;
  });
}
function KW(e) {
  return e = e - 0, e === e;
}
function gM(e) {
  return KW(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(n, i) {
    return i ? i.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var YW = ["style"];
function QW(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function XW(e) {
  return e.split(";").map(function(n) {
    return n.trim();
  }).filter(function(n) {
    return n;
  }).reduce(function(n, i) {
    var a = i.indexOf(":"), s = gM(i.slice(0, a)), g = i.slice(a + 1).trim();
    return s.startsWith("webkit") ? n[QW(s)] = g : n[s] = g, n;
  }, {});
}
function fM(e, n) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof n == "string")
    return n;
  var a = (n.children || []).map(function(h) {
    return fM(e, h);
  }), s = Object.keys(n.attributes || {}).reduce(function(h, m) {
    var w = n.attributes[m];
    switch (m) {
      case "class":
        h.attrs.className = w, delete n.attributes.class;
        break;
      case "style":
        h.attrs.style = XW(w);
        break;
      default:
        m.indexOf("aria-") === 0 || m.indexOf("data-") === 0 ? h.attrs[m.toLowerCase()] = w : h.attrs[gM(m)] = w;
    }
    return h;
  }, {
    attrs: {}
  }), g = i.style, c = g === void 0 ? {} : g, I = HW(i, YW);
  return s.attrs.style = wi(wi({}, s.attrs.style), c), e.apply(void 0, [n.tag, wi(wi({}, s.attrs), I)].concat(mh(a)));
}
var dM = !1;
try {
  dM = process.env.NODE_ENV === "production";
} catch {
}
function GW() {
  if (!dM && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Jw(e) {
  if (e && EA(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (hh.icon)
    return hh.icon(e);
  if (e === null)
    return null;
  if (e && EA(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function u7(e, n) {
  return Array.isArray(n) && n.length > 0 || !Array.isArray(n) && n ? wc({}, e, n) : {};
}
var Kw = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, mm = /* @__PURE__ */ Gt.forwardRef(function(e, n) {
  var i = wi(wi({}, Kw), e), a = i.icon, s = i.mask, g = i.symbol, c = i.className, I = i.title, h = i.titleId, m = i.maskId, w = Jw(a), S = u7("classes", [].concat(mh(JW(i)), mh((c || "").split(" ")))), T = u7("transform", typeof i.transform == "string" ? hh.transform(i.transform) : i.transform), D = u7("mask", Jw(s)), k = FW(w, wi(wi(wi(wi({}, S), T), D), {}, {
    symbol: g,
    title: I,
    titleId: h,
    maskId: m
  }));
  if (!k)
    return GW("Could not find icon", w), null;
  var z = k.abstract, N = {
    ref: n
  };
  return Object.keys(i).forEach(function(W) {
    Kw.hasOwnProperty(W) || (N[W] = i[W]);
  }), qW(z[0], N);
});
mm.displayName = "FontAwesomeIcon";
mm.propTypes = {
  beat: E.bool,
  border: E.bool,
  beatFade: E.bool,
  bounce: E.bool,
  className: E.string,
  fade: E.bool,
  flash: E.bool,
  mask: E.oneOfType([E.object, E.array, E.string]),
  maskId: E.string,
  fixedWidth: E.bool,
  inverse: E.bool,
  flip: E.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: E.oneOfType([E.object, E.array, E.string]),
  listItem: E.bool,
  pull: E.oneOf(["right", "left"]),
  pulse: E.bool,
  rotation: E.oneOf([0, 90, 180, 270]),
  shake: E.bool,
  size: E.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: E.bool,
  spinPulse: E.bool,
  spinReverse: E.bool,
  symbol: E.oneOfType([E.bool, E.string]),
  title: E.string,
  titleId: E.string,
  transform: E.oneOfType([E.string, E.object]),
  swapOpacity: E.bool
};
var qW = fM.bind(null, Gt.createElement);
const ZW = (e) => /* @__PURE__ */ n1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 634 512", ...e }, /* @__PURE__ */ n1.createElement("path", { d: "M196.2 503.5c-21.6 20.9-67.9-19.2-43.8-43.8s41-40 41-40c-54.3-2.9-100-23.8-137.1-62.9S1 272.1 1 217.8C1 161.6 20 114 59.1 74.9s86.7-59 143.8-59c0 0 48.7 0 84.2 0s35.5 62.9 0 62.9-84.2 0-84.2 0c-39 0-72.4 13.3-99 40c-27.6 26.7-41 60-41 98.1c0 37.1 12.4 68.6 37.1 95.2c23.8 26.7 55.2 41 91.4 43.8c0 0-13.9-14.4-39-39s19.3-65.8 43.8-42.9 115.2 114.3 115.2 114.3-93.6 94.3-115.2 115.2zM353.6 49.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zm0 167c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zM621.7 388.7c0 18.5-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8z" })), $W = (e) => /* @__PURE__ */ n1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ n1.createElement("path", { d: "M39.3 142.3c0-6.5 5.7-13.1 13.1-13.1l314.1 0c6.5 0 13.1 6.5 13.1 13.1l0 18.8-18.8 14.7c13.9-4.9 29.4-7.4 45-7.4c2 0 3.9 .2 5.9 .4c2.2 .2 4.6 .4 7.1 .4l0-27c0-28.6-23.7-52.3-52.3-52.3l-314.1 0C22.9 89.9 0 113.7 0 142.3L0 351.7C0 381.1 22.9 404 52.3 404l242.1 0c-9.8-11.5-18-24.5-22.9-39.3l-219.2 0c-7.4 0-13.1-5.7-13.1-13.1l0-139.9 116.1 94.9c30.3 25.4 74.4 26.2 106.3 1.6c.8-23.7 7.4-46.6 18-66.3L238 276.4c-17.2 13.9-40.9 13.9-58.1 0L39.3 161.1l0-18.8zM300.4 365.4A113.3 113.3 0 1 0 496.6 252 113.3 113.3 0 1 0 300.4 365.4zm98.4-7.1c-6.2 0-10.6-4.4-10.6-10.6l0-28.4-28.4 0c-6.2 0-10.6-4.4-10.6-10.6c0-5.8 4.4-10.6 10.6-10.6l28.4 0 0-28.4c0-5.8 4.4-10.6 10.6-10.6c5.8 0 10.6 4.9 10.6 10.6l0 28.4 28.4 0c5.8 0 10.6 4.9 10.6 10.6c0 6.2-4.9 10.6-10.6 10.6l-28.4 0 0 28.4c0 6.2-4.9 10.6-10.6 10.6z" })), eV = (e) => /* @__PURE__ */ n1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 491 512", ...e }, /* @__PURE__ */ n1.createElement("path", { d: "M224 59.3c-2.6 6.1-3.9 12.7-3.9 19.4c0 8 1.9 15.7 5.4 22.6l-169.4-.1c-7.7 0-14 6.3-14 14V367.7c0 7.7 6.3 14 14 14h84.2c23.2 0 42.1 18.8 42.1 42.1v14l63.6-47.7c7.3-5.4 16.1-8.4 25.2-8.4H392.8c7.7 0 14-6.3 14-14l-.7-123.9c4.5 1.4 9.3 2.2 14.3 2.2c7.7 0 15.2-1.8 22.1-5.6c1.3-.7 3.3-1.8 5.7-3.4l.7 130.7c0 30.9-25.2 56.1-56.1 56.1H271.2l-88.8 66.6-.2 .2-4.5 3.3-15 11.2c-4.3 3.2-10 3.7-14.7 1.3s-7.7-7.2-7.7-12.5v-70H56.1c-31 0-56.1-25.2-56.1-56.1V115.2c0-31 25.2-56.1 56.1-56.1L224 59.3zM133.3 269.6c-11.7 0-21 9.4-21 21s9.4 21 21 21h98.2c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zm0-84.2c-11.7 0-21 9.4-21 21s9.4 21 21 21H315.6c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zM353.5 1.2c5.1 2.3 8.4 7.4 8.4 12.9V42.5h49.6c43 0 77.9 34.9 77.9 77.9c0 50.2-36.1 72.6-44.4 77.1c-1.1 .6-2.3 .8-3.6 .8c-4.8 0-8.7-3.9-8.7-8.7c0-3.3 1.9-6.4 4.3-8.6c4.2-3.9 9.8-11.7 9.8-25.1c0-23.5-19-42.5-42.5-42.5H361.9v28.3c0 5.6-3.3 10.7-8.4 12.9s-11.1 1.3-15.2-2.4L267.4 88.5c-3-2.7-4.7-6.6-4.7-10.6s1.7-7.8 4.7-10.5L338.2 3.6c4.2-3.8 10.1-4.7 15.2-2.4z" })), tV = (e) => /* @__PURE__ */ n1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 492 512", ...e }, /* @__PURE__ */ n1.createElement("path", { d: "M115.4 56.3l261.1 0c3.8 0 7.7 3.8 7.7 7.7l0 163.2 40.3-34.6 5.8-2.9 0-125.8c0-28.8-25-53.8-53.8-53.8l-261.1 0c-29.8 0-53.8 25-53.8 53.8l0 125.8c.4 .4 1 .8 1.6 1.3c.9 .7 2.1 1.5 3.2 2.6l41.3 33.6 0-163.2c0-3.8 2.9-7.7 7.7-7.7zM46.3 448l0-171.8L182.6 387.5c36.5 30.7 89.3 30.7 126.7 0L445.7 276.2l0 171.8c0 4.8-3.8 7.7-7.7 7.7l-384 0c-4.8 0-7.7-2.9-7.7-7.7zM28.1 209.9c-15.4 0-27.8 13.4-27.8 28.8L.2 448c0 29.8 24 53.8 53.8 53.8l384 0c29.8 0 53.8-24 53.8-53.8l0-209.3c0-15.4-13.4-28.8-28.8-28.8c-6.7 0-13.4 2.9-18.2 6.7L279.6 352c-20.2 16.3-48 16.3-68.2 0L46.3 216.6c-4.8-3.8-11.5-6.7-18.2-6.7zM203.4 103.7c3.7-4.1 3.4-10.4-.8-14.1c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .8l-23 25.5-9.2-9.2c-3.9-3.9-10.3-3.9-14.1 0s-3.9 10.3 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.2 7.2-3.3l30.1-33.4zm0 66.8c3.7-4.1 3.4-10.4-.8-14.2c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .7l-23 25.5-9.2-9.2c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.3 7.2-3.3l30.1-33.4zM246 100.3c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm0 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm-26.7 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l120.2 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-120.2 0zm-42.8 3.3a20 20 0 1 0 -34.7 20 20 20 0 1 0 34.7-20z" })), vm = {
  lowPriority: ZW,
  newEmail: $W,
  replyToMessage: eV,
  requests: tV
}, nV = ({ icon: e, ...n }) => {
  const i = vm[e];
  return /* @__PURE__ */ y.jsx(i, { ...n });
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const rV = {
  prefix: "fab",
  iconName: "microsoft",
  icon: [448, 512, [], "f3ca", "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"]
}, iV = {
  prefix: "fab",
  iconName: "chrome",
  icon: [512, 512, [], "f268", "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"]
}, aV = {
  prefix: "fab",
  iconName: "apple",
  icon: [384, 512, [], "f179", "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"]
}, oV = {
  prefix: "fab",
  iconName: "linux",
  icon: [448, 512, [], "f17c", "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"]
}, sV = {
  prefix: "fab",
  iconName: "android",
  icon: [576, 512, [], "f17b", "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const Yw = {
  prefix: "fad",
  iconName: "list-tree",
  icon: [512, 512, [], "e1d2", ["M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48z"]]
}, lV = {
  prefix: "fad",
  iconName: "arrow-rotate-right",
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", ["M32 256c0 57.3 21.9 114.7 65.6 158.4S198.7 480 256 480s114.7-21.9 158.4-65.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160l45.7 0 0-44.8L414.4 97.6C370.6 53.9 313.3 32 256 32S141.3 53.9 97.6 97.6S32 198.7 32 256z", "M496 192c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128z"]]
}, uV = {
  prefix: "fad",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", ["M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z", ""]]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const cV = {
  prefix: "far",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"]
}, gV = {
  prefix: "far",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
}, fV = {
  prefix: "far",
  iconName: "calendar-days",
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"]
}, dV = {
  prefix: "far",
  iconName: "sort-down",
  icon: [320, 512, ["sort-desc"], "f0dd", "M160 425.4L70.6 336l178.7 0L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, CV = {
  prefix: "far",
  iconName: "right-from-bracket",
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
}, AV = {
  prefix: "far",
  iconName: "fingerprint",
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9zm-96-24c-13.3 0-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9c0-13.3-10.7-24-24-24z"]
}, IV = {
  prefix: "far",
  iconName: "hexagon-xmark",
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, pV = {
  prefix: "far",
  iconName: "address-book",
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"]
}, hV = {
  prefix: "far",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
}, mV = {
  prefix: "far",
  iconName: "cloud-xmark",
  icon: [640, 512, [], "e35f", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
}, vV = {
  prefix: "far",
  iconName: "box-archive",
  icon: [512, 512, ["archive"], "f187", "M48 80l0 48 416 0 0-48L48 80zM32 32l448 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM32 416l0-208 48 0 0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208 48 0 0 208c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64z"]
}, yV = vV, bV = {
  prefix: "far",
  iconName: "cloud",
  icon: [640, 512, [9729], "f0c2", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z"]
}, Qw = {
  prefix: "far",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z"]
}, wV = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, xV = {
  prefix: "far",
  iconName: "lock",
  icon: [448, 512, [128274], "f023", "M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z"]
}, SV = {
  prefix: "far",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"]
}, EV = SV, MV = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
}, TV = {
  prefix: "far",
  iconName: "calendar-circle-exclamation",
  icon: [576, 512, [], "e46e", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
}, LV = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
}, RV = {
  prefix: "far",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, OV = {
  prefix: "far",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"]
}, DV = {
  prefix: "far",
  iconName: "arrow-left-to-line",
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"]
}, kV = {
  prefix: "far",
  iconName: "arrow-up-from-bracket",
  icon: [448, 512, [], "e09a", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
}, jV = {
  prefix: "far",
  iconName: "folder",
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"]
}, zV = {
  prefix: "far",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"]
}, NV = {
  prefix: "far",
  iconName: "file-invoice-dollar",
  icon: [384, 512, [], "f571", "M336 448l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 215.6c11 0 20 9 20 20l0 10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8l0 10.1c0 11-9 20-20 20s-20-9-20-20l0-10.8c-10-1.9-19.3-4.8-27.5-7.3c0 0 0 0 0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2c0 0 0 0 0 0s0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3l0-10.3c0-11 9-20 20-20zM96 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, PV = {
  prefix: "far",
  iconName: "user-group",
  icon: [640, 512, [128101, "user-friends"], "f500", "M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6C95.3 319.4 135 304 178.3 304l45.7 0 45.7 0c43.3 0 83 15.4 113.9 41.1c33.6 28 56.8 68.1 62.8 113.6c1 7.7 1.5 15.6 1.5 23.6c0 16.4-13.3 29.7-29.7 29.7l-19.6 0L49.3 512l-19.6 0C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm208 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64c-8.6 14.4-14.4 30.7-16.8 48L98 464 350 464l48.8 0c-.4-2.7-.8-5.3-1.4-8c-2.9-14.3-8.2-27.8-15.5-40c-22.7-38.3-64.4-64-112.2-64l-91.4 0zm431 160l-136.9 0c4.9-8.8 7.6-18.9 7.6-29.7c0-65-29.5-123.2-75.9-161.8c4.3-.4 8.7-.5 13.2-.5l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
}, FV = {
  prefix: "far",
  iconName: "comment-plus",
  icon: [512, 512, [], "f4b2", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, BV = {
  prefix: "far",
  iconName: "circle-arrow-up",
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 207l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
}, HV = {
  prefix: "far",
  iconName: "folder-open",
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"]
}, UV = {
  prefix: "far",
  iconName: "file-arrow-up",
  icon: [384, 512, ["file-upload"], "f574", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 408l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L168 408c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
}, WV = {
  prefix: "far",
  iconName: "signature",
  icon: [640, 512, [], "f5b7", "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm-3.8 169l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42zm216.8 48L616 416c13.3 0 24-10.7 24-24s-10.7-24-24-24l-311.9 0c-7 16.3-14.8 32.4-23.3 48z"]
}, VV = {
  prefix: "far",
  iconName: "square-plus",
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, _V = {
  prefix: "far",
  iconName: "message-lines",
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
}, JV = {
  prefix: "far",
  iconName: "image",
  icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
}, KV = {
  prefix: "far",
  iconName: "microphone",
  icon: [384, 512, [], "f130", "M240 96l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"]
}, YV = {
  prefix: "far",
  iconName: "file-zip",
  icon: [512, 512, [], "e5ee", "M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z"]
}, Xw = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, QV = {
  prefix: "far",
  iconName: "circle-arrow-down",
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, XV = {
  prefix: "far",
  iconName: "box-open",
  icon: [640, 512, [], "f49e", "M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64l2.2 0s0 0 0 0l-2.2 0s0 0 0 0zM528 225.3l0 153.2-184 46L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240.5-184-46 0-153.2L64 211.6l0 167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-167-48 13.7z"]
}, GV = {
  prefix: "far",
  iconName: "pause",
  icon: [320, 512, [9208], "f04c", "M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"]
}, qV = {
  prefix: "far",
  iconName: "address-card",
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
}, ZV = {
  prefix: "far",
  iconName: "money-bills",
  icon: [640, 512, [], "e1f3", "M528 80c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
}, $V = {
  prefix: "far",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
}, Gw = {
  prefix: "far",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176 360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336l54.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-54.1 52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9z"]
}, e_ = {
  prefix: "far",
  iconName: "layer-group",
  icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
}, t_ = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
}, n_ = {
  prefix: "far",
  iconName: "sort",
  icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176l178.7 0L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336 70.6 336zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
}, r_ = {
  prefix: "far",
  iconName: "file-signature",
  icon: [576, 512, [], "f573", "M64 464l256 0c8.8 0 16-7.2 16-16l0-6.7 39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7l0 19.3c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 49.1-48 48 0-91.6-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-115l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L96 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 25.6 0 12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1 .3-2.1 .4-3.2 .5c-.8 .1-1.5 .2-2.3 .2L256 416c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zM549.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z"]
}, i_ = {
  prefix: "far",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
}, a_ = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"]
}, o_ = {
  prefix: "far",
  iconName: "wifi-slash",
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3 .3-21.4 .8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zM76.9 156.6L37.7 125.7c-10.2 7.6-20 15.6-29.5 23.9c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zM226.3 274.3L184 241c-23.4 12.1-44.9 27.2-64.1 44.8c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
}, s_ = {
  prefix: "far",
  iconName: "lock-open",
  icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72C560 57.3 502.7 0 432 0S304 57.3 304 128l0 64L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16z"]
}, l_ = {
  prefix: "far",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
}, u_ = {
  prefix: "far",
  iconName: "file-image",
  icon: [384, 512, [128443], "f1c5", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"]
}, c_ = {
  prefix: "far",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, g_ = {
  prefix: "far",
  iconName: "files",
  icon: [448, 512, [], "e178", "M160 368l224 0c8.8 0 16-7.2 16-16l0-224-48 0c-17.7 0-32-14.3-32-32l0-48L160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm224 48l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L325.5 0c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24z"]
}, qw = {
  prefix: "far",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
}, f_ = {
  prefix: "far",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"]
}, d_ = {
  prefix: "far",
  iconName: "sort-up",
  icon: [320, 512, ["sort-asc"], "f0de", "M160 86.6L70.6 176l178.7 0L160 86.6zM137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
}, C_ = {
  prefix: "far",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256C512 122.7 410.1 13.2 280 1.1C266.8-.1 256 10.7 256 24s10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6c-5.3 12.2-1.5 26.8 10 33.5z"]
}, A_ = {
  prefix: "far",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
}, I_ = {
  prefix: "far",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"]
}, p_ = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
}, h_ = {
  prefix: "far",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"]
}, m_ = {
  prefix: "far",
  iconName: "comment",
  icon: [512, 512, [128489, 61669], "f075", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"]
}, v_ = {
  prefix: "far",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"]
}, y_ = {
  prefix: "far",
  iconName: "paperclip",
  icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
}, b_ = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, w_ = b_, x_ = {
  prefix: "far",
  iconName: "camera",
  icon: [512, 512, [62258, "camera-alt"], "f030", "M199.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L137.4 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C358.4 47.4 337 32 312.9 32L199.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
}, S_ = {
  prefix: "far",
  iconName: "check-double",
  icon: [448, 512, [], "f560", "M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z"]
}, Zw = {
  prefix: "far",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
}, E_ = {
  prefix: "far",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
}, M_ = {
  prefix: "far",
  iconName: "sliders",
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
}, $w = {
  prefix: "far",
  iconName: "wand-sparkles",
  icon: [512, 512, [], "f72b", "M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3c2.7 0 4.9 2.2 4.9 4.9c0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4c-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4c0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0C446 0 433.4 4.9 423.6 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1L112 256c-8.8 0-16 7.2-16 16l0 31.3c0 4.5-1.9 8.8-5.3 11.9L20.2 379.1C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18c17.3 0 33.8-7.3 45.4-20.2L399.7 197.3c3-3.3 7.3-5.3 11.9-5.3l20.4 0c8.8 0 16-7.2 16-16l0-25.9c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9C512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0z"]
}, T_ = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
}, L_ = {
  prefix: "far",
  iconName: "download",
  icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, R_ = {
  prefix: "far",
  iconName: "mobile",
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, O_ = {
  prefix: "far",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-48 0 0-152c0-22.1-17.9-40-40-40l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32zm128 32l0-144 96 0 0 144-96 0z"]
}, D_ = {
  prefix: "far",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3L496 200c0 13.3-10.7 24-24 24l-116.7 0c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176l62.1 0 0-62.1z"]
}, k_ = {
  prefix: "far",
  iconName: "upload",
  icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95L280 360zm32-8l0-48 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80c0-35.3 28.7-64 64-64l136 0 0 48L64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-136 0zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
}, j_ = {
  prefix: "far",
  iconName: "file-arrow-down",
  icon: [384, 512, ["file-download"], "f56d", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232z"]
}, z_ = {
  prefix: "far",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"]
}, N_ = {
  prefix: "far",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
}, P_ = {
  prefix: "far",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
}, F_ = {
  prefix: "far",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
}, B_ = {
  prefix: "far",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
}, H_ = {
  prefix: "far",
  iconName: "inbox",
  icon: [512, 512, [], "f01c", "M48 336l81.2 0 20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1l140.2 0c15.1 0 29-8.6 35.8-22.1L382.8 336l81.2 0 0 80c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-80zm406.5-48l-76.6 0c-15.1 0-29 8.6-35.8 22.1L321.2 352l-130.3 0-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1l-76.6 0 49-195.9C108.2 85 114.6 80 122 80L390 80c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32L122 32C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
}, U_ = {
  prefix: "far",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
}, W_ = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
}, V_ = {
  prefix: "far",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"]
}, __ = {
  prefix: "far",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 72c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, J_ = __, K_ = {
  prefix: "far",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"]
}, Y_ = {
  prefix: "far",
  iconName: "share-from-square",
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
}, ex = {
  prefix: "far",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"]
}, Q_ = {
  prefix: "far",
  iconName: "cloud-check",
  icon: [640, 512, [], "e35c", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
}, X_ = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, tx = X_, G_ = {
  prefix: "far",
  iconName: "angle-up",
  icon: [448, 512, [8963], "f106", "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"]
}, q_ = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
}, Z_ = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
}, $_ = {
  prefix: "far",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304 168 304l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 115.5 0-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7L134.8 48c0 1.2 0 2.5-.1 3.7zM168 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48L56 48c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0L86.8 0 297.2 0 328 0c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3l-30.8 0 3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-136 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z"]
}, eJ = $_, tJ = {
  prefix: "far",
  iconName: "arrow-right-to-line",
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
}, nJ = {
  prefix: "far",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
}, rJ = {
  prefix: "far",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"]
}, iJ = {
  prefix: "far",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, aJ = {
  prefix: "far",
  iconName: "desktop",
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16zm64 208l0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 192zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48z"]
}, oJ = {
  prefix: "far",
  iconName: "comment-sms",
  icon: [512, 512, ["sms"], "f7cd", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 176 96 192.5 96 212.8zM372.8 176c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9z"]
}, sJ = oJ, lJ = {
  prefix: "far",
  iconName: "user-plus",
  icon: [640, 512, [], "f234", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, uJ = {
  prefix: "far",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
}, cJ = {
  prefix: "far",
  iconName: "angle-left",
  icon: [320, 512, [8249], "f104", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"]
}, gJ = {
  prefix: "far",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 120 0 136c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-144 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L48 304zm144-48l128 0 144 0 0-96c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0z"]
}, fJ = {
  prefix: "far",
  iconName: "paper-plane",
  icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
}, dJ = {
  prefix: "far",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
}, nx = {
  prefix: "far",
  iconName: "paperclip-vertical",
  icon: [384, 512, [], "e3c2", "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108l0 236c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236c0-33.1-26.9-60-60-60s-60 26.9-60 60l0 260c0 53 43 96 96 96s96-43 96-96l0-216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-260z"]
}, CJ = {
  prefix: "far",
  iconName: "print",
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z"]
}, AJ = {
  prefix: "far",
  iconName: "building-columns",
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const IJ = {
  prefix: "fas",
  iconName: "info",
  icon: [192, 512, [], "f129", "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"]
}, pJ = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, hJ = {
  prefix: "fas",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, mJ = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, vJ = {
  prefix: "fas",
  iconName: "folder",
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"]
}, yJ = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, rx = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, bJ = {
  prefix: "fas",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
}, wJ = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, xJ = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, SJ = {
  prefix: "fas",
  iconName: "user-shield",
  icon: [640, 512, [], "f505", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3l-91.4 0zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L591.4 312z"]
}, EJ = {
  prefix: "fas",
  iconName: "video-slash",
  icon: [640, 512, [], "f4e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9l0 17.1 0 128 0 5.8-32-25.1L416 128c0-35.3-28.7-64-64-64L113.9 64 38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5l0 256c0 35.3 28.7 64 64 64l256 0c23.4 0 43.9-12.6 55-31.3z"]
}, MJ = {
  prefix: "fas",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"]
}, TJ = MJ, LJ = {
  prefix: "fas",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"]
}, RJ = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, CM = {
  home: O_,
  inbox: H_,
  tasks: J_,
  task: Xw,
  emails: v_,
  accounts: gJ,
  files: g_,
  billing: ZV,
  entity: nJ,
  help: c_,
  sms: sJ,
  edoc: WV,
  bulkActions: e_,
  contacts: pV,
  contact: qV,
  notifications: P_,
  logout: CV,
  taxAutomation: $w,
  paperclip: y_,
  file: F_,
  fileLines: gV,
  fileImage: u_,
  camera: x_,
  microphone: KV,
  sparkles: RV,
  sparklesSolid: mJ,
  wandSparkles: $w,
  pause: GV,
  filePdf: h_,
  fileZip: YV,
  taxDoc: NV,
  signatureReq: r_,
  folder: jV,
  folderOpen: HV,
  folderSolid: vJ,
  download: L_,
  upload: k_,
  uploadFile: UV,
  downloadFile: j_,
  import: kV,
  show: qw,
  hide: MV,
  calendar: fV,
  calendarDay: rJ,
  calendarExclaim: TV,
  addUser: lJ,
  clear: tx,
  close: tx,
  createSms: FV,
  sort: n_,
  sortUp: d_,
  sortDown: dV,
  chevronLeft: q_,
  chevronRight: Z_,
  chevronUp: LV,
  chevronDown: W_,
  caretUp: yJ,
  caretDown: xJ,
  edit: EV,
  pencil: hV,
  copy: K_,
  archive: yV,
  unarchive: XV,
  ellipsis: N_,
  ellipsisVertical: T_,
  delete: I_,
  deleteSolid: wJ,
  info: IJ,
  infoCircle: w_,
  success: rx,
  warning: RJ,
  error: pJ,
  errorOutline: wV,
  retry: D_,
  attachFile: nx,
  attachment: nx,
  menu: Qw,
  arrowUp: V_,
  arrowRight: a_,
  arrowDown: B_,
  arrowLeft: p_,
  arrowLeftToLine: DV,
  arrowRightToLine: tJ,
  angleUp: G_,
  angleRight: OV,
  angleDown: z_,
  angleLeft: cJ,
  circle: l_,
  circleArrowUp: BV,
  circleArrowDown: QV,
  check: uJ,
  circleCheck: Xw,
  circleCheckSolid: rx,
  circleX: dJ,
  circlePlus: iJ,
  videoSlash: EJ,
  preview: qw,
  lock: xV,
  lockOpen: s_,
  danger: IV,
  image: JV,
  search: U_,
  checkbox: hJ,
  checkboxBlank: t_,
  sliders: M_,
  add: ex,
  plus: ex,
  plusSquare: VV,
  plusDuotone: uV,
  remove: Zw,
  minus: Zw,
  pushpin: eJ,
  pushpinFilled: TJ,
  phone: A_,
  comment: m_,
  fingerprint: AV,
  wifiSlash: o_,
  bank: AJ,
  recurringCharge: Gw,
  messageLines: _V,
  print: CJ,
  pen: bJ,
  penOutline: f_,
  reassignTask: S_,
  share: Y_,
  externalLink: i_,
  admin: SJ,
  send: fJ,
  user: zV,
  userGroup: PV,
  arrowsRotate: Gw,
  cloud: bV,
  cloudArrowUp: $V,
  cloudCheck: Q_,
  cloudX: mV,
  gripVertical: Qw,
  arrowRotateRightDuotone: lV,
  template: Yw,
  toc: Yw,
  apple: aV,
  linux: oV,
  microsoft: rV,
  android: sV,
  chrome: iV,
  desktop: aJ,
  mobile: R_,
  message: cV,
  clockRotateLeft: LJ,
  spinner: C_,
  gear: E_
}, OJ = (e) => e ? `fa-rotate-${e}` : "", DJ = (e) => e ? `fa-flip-${e}` : "", kJ = (e) => {
  switch (e) {
    case void 0:
      return "";
    case "spin-reverse":
      return "fa-spin fa-spin-reverse";
    case "pulse-reverse":
      return "fa-spin-pulse fa-spin-reverse";
    default:
      return `fa-${e}`;
  }
}, jJ = (e) => `${OJ(e == null ? void 0 : e.rotation)}${DJ(
  e == null ? void 0 : e.flip
)}${kJ(e == null ? void 0 : e.animate)}`, ee1 = {
  ...vm,
  ...CM
}, zJ = (e) => !!vm[e], Me = ka(
  ({
    icon: e,
    rotation: n,
    flip: i,
    animate: a,
    iconProps: s = {},
    ...g
  }, c) => {
    const I = `${g.className} ${jJ({
      rotation: n,
      flip: i,
      animate: a
    })}`;
    return /* @__PURE__ */ y.jsx(
      FA,
      {
        "data-testid": `${e}Icon`,
        ...g,
        fontSize: g.fontSize ?? "inherit",
        className: I,
        ref: c,
        children: zJ(e) ? /* @__PURE__ */ y.jsx(nV, { icon: e }) : /* @__PURE__ */ y.jsx(mm, { ...s, icon: CM[e] })
      }
    );
  }
);
Me.displayName = "Icon";
const ym = ka(
  ({
    icon: e,
    to: n,
    href: i,
    state: a = {},
    target: s,
    children: g,
    ...c
  }, I) => {
    const h = r6({ to: n, href: i, state: a, target: s }), m = V2(() => e ? /* @__PURE__ */ y.jsx(Me, { icon: e }) : g, [e, g]);
    return /* @__PURE__ */ y.jsx(OE, { ref: I, ...c, ...h, children: m });
  }
), te1 = ({
  ariaLabel: e = "",
  children: n
}) => /* @__PURE__ */ y.jsx(xj, { "aria-label": e, children: n });
function bm(e) {
  return /* @__PURE__ */ y.jsx(fl, { ...e });
}
function Lt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var n = Number(e);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function ee(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function ie(e) {
  ee(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || La(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function gA(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && i.setDate(i.getDate() + a), i);
}
function c6(e, n) {
  ee(2, arguments);
  var i = ie(e).getTime(), a = Lt(n);
  return new Date(i + a);
}
function NJ(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  return c6(e, i * 1e3);
}
var PJ = 6e4;
function FJ(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  return c6(e, i * PJ);
}
var BJ = 36e5;
function HJ(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  return c6(e, i * BJ);
}
function UJ(e, n) {
  ee(2, arguments);
  var i = Lt(n), a = i * 7;
  return gA(e, a);
}
function fA(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return i;
  var s = i.getDate(), g = new Date(i.getTime());
  g.setMonth(i.getMonth() + a + 1, 0);
  var c = g.getDate();
  return s >= c ? g : (i.setFullYear(g.getFullYear(), g.getMonth(), s), i);
}
function ix(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  return fA(e, i * 12);
}
function WJ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getFullYear() - a.getFullYear();
}
function ff(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n), s = i.getTime() - a.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function VJ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n), s = ff(i, a), g = Math.abs(WJ(i, a));
  i.setFullYear(1584), a.setFullYear(1584);
  var c = ff(i, a) === -s, I = s * (g - Number(c));
  return I === 0 ? 0 : I;
}
function _J(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n), s = i.getFullYear() - a.getFullYear(), g = i.getMonth() - a.getMonth();
  return s * 12 + g;
}
function yh(e) {
  ee(1, arguments);
  var n = ie(e);
  return n.setHours(23, 59, 59, 999), n;
}
function bh(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getMonth();
  return n.setFullYear(n.getFullYear(), i + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function JJ(e) {
  ee(1, arguments);
  var n = ie(e);
  return yh(n).getTime() === bh(n).getTime();
}
function AM(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n), s = ff(i, a), g = Math.abs(_J(i, a)), c;
  if (g < 1)
    c = 0;
  else {
    i.getMonth() === 1 && i.getDate() > 27 && i.setDate(30), i.setMonth(i.getMonth() - s * g);
    var I = ff(i, a) === -s;
    JJ(ie(e)) && g === 1 && ff(e, a) === 1 && (I = !1), c = s * (g - Number(I));
  }
  return c === 0 ? 0 : c;
}
var ax = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, KJ = "trunc";
function Ff(e) {
  return e ? ax[e] : ax[KJ];
}
function YJ(e, n, i) {
  ee(2, arguments);
  var a = AM(e, n) / 3;
  return Ff(void 0)(a);
}
function MA(e) {
  var n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), e.getTime() - n.getTime();
}
function jc(e) {
  ee(1, arguments);
  var n = ie(e);
  return n.setHours(0, 0, 0, 0), n;
}
var QJ = 864e5;
function XJ(e, n) {
  ee(2, arguments);
  var i = jc(e), a = jc(n), s = i.getTime() - MA(i), g = a.getTime() - MA(a);
  return Math.round((s - g) / QJ);
}
function ox(e, n) {
  var i = e.getFullYear() - n.getFullYear() || e.getMonth() - n.getMonth() || e.getDate() - n.getDate() || e.getHours() - n.getHours() || e.getMinutes() - n.getMinutes() || e.getSeconds() - n.getSeconds() || e.getMilliseconds() - n.getMilliseconds();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function IM(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n), s = ox(i, a), g = Math.abs(XJ(i, a));
  i.setDate(i.getDate() - s * g);
  var c = +(ox(i, a) === -s), I = s * (g - c);
  return I === 0 ? 0 : I;
}
function GJ(e, n, i) {
  ee(2, arguments);
  var a = IM(e, n) / 7;
  return Ff(void 0)(a);
}
var g6 = 6e4, f6 = 36e5, qJ = 1e3;
function d6(e, n) {
  return ee(2, arguments), ie(e).getTime() - ie(n).getTime();
}
function ZJ(e, n, i) {
  ee(2, arguments);
  var a = d6(e, n) / f6;
  return Ff(void 0)(a);
}
function $J(e, n, i) {
  ee(2, arguments);
  var a = d6(e, n) / g6;
  return Ff(void 0)(a);
}
function eK(e, n, i) {
  ee(2, arguments);
  var a = d6(e, n) / 1e3;
  return Ff(void 0)(a);
}
function tK(e, n) {
  var i;
  ee(1, arguments);
  var a = e || {}, s = ie(a.start), g = ie(a.end), c = g.getTime();
  if (!(s.getTime() <= c))
    throw new RangeError("Invalid interval");
  var I = [], h = s;
  h.setHours(0, 0, 0, 0);
  var m = Number((i = void 0) !== null && i !== void 0 ? i : 1);
  if (m < 1 || isNaN(m)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; h.getTime() <= c; )
    I.push(ie(h)), h.setDate(h.getDate() + m), h.setHours(0, 0, 0, 0);
  return I;
}
var nK = {};
function Ni() {
  return nK;
}
function c7(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = Ni(), S = Lt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var T = ie(e), D = T.getDay(), k = (D < S ? -7 : 0) + 6 - (D - S);
  return T.setDate(T.getDate() + k), T.setHours(23, 59, 59, 999), T;
}
function g7(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getFullYear();
  return n.setFullYear(i + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function rK(e) {
  return ee(1, arguments), e instanceof Date || La(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function pM(e) {
  if (ee(1, arguments), !rK(e) && typeof e != "number")
    return !1;
  var n = ie(e);
  return !isNaN(Number(n));
}
function hM(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  return c6(e, -i);
}
var iK = 864e5;
function aK(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var a = n.getTime(), s = i - a;
  return Math.floor(s / iK) + 1;
}
function zc(e) {
  ee(1, arguments);
  var n = 1, i = ie(e), a = i.getUTCDay(), s = (a < n ? 7 : 0) + a - n;
  return i.setUTCDate(i.getUTCDate() - s), i.setUTCHours(0, 0, 0, 0), i;
}
function mM(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(i + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = zc(a), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(i, 0, 4), g.setUTCHours(0, 0, 0, 0);
  var c = zc(g);
  return n.getTime() >= s.getTime() ? i + 1 : n.getTime() >= c.getTime() ? i : i - 1;
}
function oK(e) {
  ee(1, arguments);
  var n = mM(e), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = zc(i);
  return a;
}
var sK = 6048e5;
function vM(e) {
  ee(1, arguments);
  var n = ie(e), i = zc(n).getTime() - oK(n).getTime();
  return Math.round(i / sK) + 1;
}
function pl(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = Ni(), S = Lt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var T = ie(e), D = T.getUTCDay(), k = (D < S ? 7 : 0) + D - S;
  return T.setUTCDate(T.getUTCDate() - k), T.setUTCHours(0, 0, 0, 0), T;
}
function wm(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = ie(e), S = w.getUTCFullYear(), T = Ni(), D = Lt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : T.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = T.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = /* @__PURE__ */ new Date(0);
  k.setUTCFullYear(S + 1, 0, D), k.setUTCHours(0, 0, 0, 0);
  var z = pl(k, n), N = /* @__PURE__ */ new Date(0);
  N.setUTCFullYear(S, 0, D), N.setUTCHours(0, 0, 0, 0);
  var W = pl(N, n);
  return w.getTime() >= z.getTime() ? S + 1 : w.getTime() >= W.getTime() ? S : S - 1;
}
function lK(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = Ni(), S = Lt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1), T = wm(e, n), D = /* @__PURE__ */ new Date(0);
  D.setUTCFullYear(T, 0, S), D.setUTCHours(0, 0, 0, 0);
  var k = pl(D, n);
  return k;
}
var uK = 6048e5;
function yM(e, n) {
  ee(1, arguments);
  var i = ie(e), a = pl(i, n).getTime() - lK(i, n).getTime();
  return Math.round(a / uK) + 1;
}
function pt(e, n) {
  for (var i = e < 0 ? "-" : "", a = Math.abs(e).toString(); a.length < n; )
    a = "0" + a;
  return i + a;
}
var Wo = {
  // Year
  y: function(n, i) {
    var a = n.getUTCFullYear(), s = a > 0 ? a : 1 - a;
    return pt(i === "yy" ? s % 100 : s, i.length);
  },
  // Month
  M: function(n, i) {
    var a = n.getUTCMonth();
    return i === "M" ? String(a + 1) : pt(a + 1, 2);
  },
  // Day of the month
  d: function(n, i) {
    return pt(n.getUTCDate(), i.length);
  },
  // AM or PM
  a: function(n, i) {
    var a = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, i) {
    return pt(n.getUTCHours() % 12 || 12, i.length);
  },
  // Hour [0-23]
  H: function(n, i) {
    return pt(n.getUTCHours(), i.length);
  },
  // Minute
  m: function(n, i) {
    return pt(n.getUTCMinutes(), i.length);
  },
  // Second
  s: function(n, i) {
    return pt(n.getUTCSeconds(), i.length);
  },
  // Fraction of second
  S: function(n, i) {
    var a = i.length, s = n.getUTCMilliseconds(), g = Math.floor(s * Math.pow(10, a - 3));
    return pt(g, i.length);
  }
}, pc = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, cK = {
  // Era
  G: function(n, i, a) {
    var s = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (i) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, i, a) {
    if (i === "yo") {
      var s = n.getUTCFullYear(), g = s > 0 ? s : 1 - s;
      return a.ordinalNumber(g, {
        unit: "year"
      });
    }
    return Wo.y(n, i);
  },
  // Local week-numbering year
  Y: function(n, i, a, s) {
    var g = wm(n, s), c = g > 0 ? g : 1 - g;
    if (i === "YY") {
      var I = c % 100;
      return pt(I, 2);
    }
    return i === "Yo" ? a.ordinalNumber(c, {
      unit: "year"
    }) : pt(c, i.length);
  },
  // ISO week-numbering year
  R: function(n, i) {
    var a = mM(n);
    return pt(a, i.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, i) {
    var a = n.getUTCFullYear();
    return pt(a, i.length);
  },
  // Quarter
  Q: function(n, i, a) {
    var s = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (i) {
      case "Q":
        return String(s);
      case "QQ":
        return pt(s, 2);
      case "Qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, i, a) {
    var s = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (i) {
      case "q":
        return String(s);
      case "qq":
        return pt(s, 2);
      case "qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, i, a) {
    var s = n.getUTCMonth();
    switch (i) {
      case "M":
      case "MM":
        return Wo.M(n, i);
      case "Mo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, i, a) {
    var s = n.getUTCMonth();
    switch (i) {
      case "L":
        return String(s + 1);
      case "LL":
        return pt(s + 1, 2);
      case "Lo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, i, a, s) {
    var g = yM(n, s);
    return i === "wo" ? a.ordinalNumber(g, {
      unit: "week"
    }) : pt(g, i.length);
  },
  // ISO week of year
  I: function(n, i, a) {
    var s = vM(n);
    return i === "Io" ? a.ordinalNumber(s, {
      unit: "week"
    }) : pt(s, i.length);
  },
  // Day of the month
  d: function(n, i, a) {
    return i === "do" ? a.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : Wo.d(n, i);
  },
  // Day of year
  D: function(n, i, a) {
    var s = aK(n);
    return i === "Do" ? a.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : pt(s, i.length);
  },
  // Day of week
  E: function(n, i, a) {
    var s = n.getUTCDay();
    switch (i) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, i, a, s) {
    var g = n.getUTCDay(), c = (g - s.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "e":
        return String(c);
      case "ee":
        return pt(c, 2);
      case "eo":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "eee":
        return a.day(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(g, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(g, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, i, a, s) {
    var g = n.getUTCDay(), c = (g - s.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "c":
        return String(c);
      case "cc":
        return pt(c, i.length);
      case "co":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "ccc":
        return a.day(g, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(g, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(g, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(g, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, i, a) {
    var s = n.getUTCDay(), g = s === 0 ? 7 : s;
    switch (i) {
      case "i":
        return String(g);
      case "ii":
        return pt(g, i.length);
      case "io":
        return a.ordinalNumber(g, {
          unit: "day"
        });
      case "iii":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, i, a) {
    var s = n.getUTCHours(), g = s / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, i, a) {
    var s = n.getUTCHours(), g;
    switch (s === 12 ? g = pc.noon : s === 0 ? g = pc.midnight : g = s / 12 >= 1 ? "pm" : "am", i) {
      case "b":
      case "bb":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, i, a) {
    var s = n.getUTCHours(), g;
    switch (s >= 17 ? g = pc.evening : s >= 12 ? g = pc.afternoon : s >= 4 ? g = pc.morning : g = pc.night, i) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, i, a) {
    if (i === "ho") {
      var s = n.getUTCHours() % 12;
      return s === 0 && (s = 12), a.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return Wo.h(n, i);
  },
  // Hour [0-23]
  H: function(n, i, a) {
    return i === "Ho" ? a.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : Wo.H(n, i);
  },
  // Hour [0-11]
  K: function(n, i, a) {
    var s = n.getUTCHours() % 12;
    return i === "Ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : pt(s, i.length);
  },
  // Hour [1-24]
  k: function(n, i, a) {
    var s = n.getUTCHours();
    return s === 0 && (s = 24), i === "ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : pt(s, i.length);
  },
  // Minute
  m: function(n, i, a) {
    return i === "mo" ? a.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : Wo.m(n, i);
  },
  // Second
  s: function(n, i, a) {
    return i === "so" ? a.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : Wo.s(n, i);
  },
  // Fraction of second
  S: function(n, i) {
    return Wo.S(n, i);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    if (c === 0)
      return "Z";
    switch (i) {
      case "X":
        return lx(c);
      case "XXXX":
      case "XX":
        return sl(c);
      case "XXXXX":
      case "XXX":
      default:
        return sl(c, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "x":
        return lx(c);
      case "xxxx":
      case "xx":
        return sl(c);
      case "xxxxx":
      case "xxx":
      default:
        return sl(c, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + sx(c, ":");
      case "OOOO":
      default:
        return "GMT" + sl(c, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + sx(c, ":");
      case "zzzz":
      default:
        return "GMT" + sl(c, ":");
    }
  },
  // Seconds timestamp
  t: function(n, i, a, s) {
    var g = s._originalDate || n, c = Math.floor(g.getTime() / 1e3);
    return pt(c, i.length);
  },
  // Milliseconds timestamp
  T: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTime();
    return pt(c, i.length);
  }
};
function sx(e, n) {
  var i = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.floor(a / 60), g = a % 60;
  if (g === 0)
    return i + String(s);
  var c = n;
  return i + String(s) + c + pt(g, 2);
}
function lx(e, n) {
  if (e % 60 === 0) {
    var i = e > 0 ? "-" : "+";
    return i + pt(Math.abs(e) / 60, 2);
  }
  return sl(e, n);
}
function sl(e, n) {
  var i = n || "", a = e > 0 ? "-" : "+", s = Math.abs(e), g = pt(Math.floor(s / 60), 2), c = pt(s % 60, 2);
  return a + g + i + c;
}
var ux = function(n, i) {
  switch (n) {
    case "P":
      return i.date({
        width: "short"
      });
    case "PP":
      return i.date({
        width: "medium"
      });
    case "PPP":
      return i.date({
        width: "long"
      });
    case "PPPP":
    default:
      return i.date({
        width: "full"
      });
  }
}, bM = function(n, i) {
  switch (n) {
    case "p":
      return i.time({
        width: "short"
      });
    case "pp":
      return i.time({
        width: "medium"
      });
    case "ppp":
      return i.time({
        width: "long"
      });
    case "pppp":
    default:
      return i.time({
        width: "full"
      });
  }
}, gK = function(n, i) {
  var a = n.match(/(P+)(p+)?/) || [], s = a[1], g = a[2];
  if (!g)
    return ux(n, i);
  var c;
  switch (s) {
    case "P":
      c = i.dateTime({
        width: "short"
      });
      break;
    case "PP":
      c = i.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      c = i.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      c = i.dateTime({
        width: "full"
      });
      break;
  }
  return c.replace("{{date}}", ux(s, i)).replace("{{time}}", bM(g, i));
}, wh = {
  p: bM,
  P: gK
}, fK = ["D", "DD"], dK = ["YY", "YYYY"];
function wM(e) {
  return fK.indexOf(e) !== -1;
}
function xM(e) {
  return dK.indexOf(e) !== -1;
}
function TA(e, n, i) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var CK = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, AK = function(n, i, a) {
  var s, g = CK[n];
  return typeof g == "string" ? s = g : i === 1 ? s = g.one : s = g.other.replace("{{count}}", i.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + s : s + " ago" : s;
};
function f7(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = n.width ? String(n.width) : e.defaultWidth, a = e.formats[i] || e.formats[e.defaultWidth];
    return a;
  };
}
var IK = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, pK = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hK = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mK = {
  date: f7({
    formats: IK,
    defaultWidth: "full"
  }),
  time: f7({
    formats: pK,
    defaultWidth: "full"
  }),
  dateTime: f7({
    formats: hK,
    defaultWidth: "full"
  })
}, vK = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yK = function(n, i, a, s) {
  return vK[n];
};
function qg(e) {
  return function(n, i) {
    var a = i != null && i.context ? String(i.context) : "standalone", s;
    if (a === "formatting" && e.formattingValues) {
      var g = e.defaultFormattingWidth || e.defaultWidth, c = i != null && i.width ? String(i.width) : g;
      s = e.formattingValues[c] || e.formattingValues[g];
    } else {
      var I = e.defaultWidth, h = i != null && i.width ? String(i.width) : e.defaultWidth;
      s = e.values[h] || e.values[I];
    }
    var m = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[m];
  };
}
var bK = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, wK = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xK = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, SK = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, EK = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, MK = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, TK = function(n, i) {
  var a = Number(n), s = a % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, LK = {
  ordinalNumber: TK,
  era: qg({
    values: bK,
    defaultWidth: "wide"
  }),
  quarter: qg({
    values: wK,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: qg({
    values: xK,
    defaultWidth: "wide"
  }),
  day: qg({
    values: SK,
    defaultWidth: "wide"
  }),
  dayPeriod: qg({
    values: EK,
    defaultWidth: "wide",
    formattingValues: MK,
    defaultFormattingWidth: "wide"
  })
};
function Zg(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = i.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], g = n.match(s);
    if (!g)
      return null;
    var c = g[0], I = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], h = Array.isArray(I) ? OK(I, function(S) {
      return S.test(c);
    }) : RK(I, function(S) {
      return S.test(c);
    }), m;
    m = e.valueCallback ? e.valueCallback(h) : h, m = i.valueCallback ? i.valueCallback(m) : m;
    var w = n.slice(c.length);
    return {
      value: m,
      rest: w
    };
  };
}
function RK(e, n) {
  for (var i in e)
    if (e.hasOwnProperty(i) && n(e[i]))
      return i;
}
function OK(e, n) {
  for (var i = 0; i < e.length; i++)
    if (n(e[i]))
      return i;
}
function DK(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.match(e.matchPattern);
    if (!a) return null;
    var s = a[0], g = n.match(e.parsePattern);
    if (!g) return null;
    var c = e.valueCallback ? e.valueCallback(g[0]) : g[0];
    c = i.valueCallback ? i.valueCallback(c) : c;
    var I = n.slice(s.length);
    return {
      value: c,
      rest: I
    };
  };
}
var kK = /^(\d+)(th|st|nd|rd)?/i, jK = /\d+/i, zK = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, NK = {
  any: [/^b/i, /^(a|c)/i]
}, PK = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, FK = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, BK = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, HK = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, UK = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, WK = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, VK = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _K = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, JK = {
  ordinalNumber: DK({
    matchPattern: kK,
    parsePattern: jK,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: Zg({
    matchPatterns: zK,
    defaultMatchWidth: "wide",
    parsePatterns: NK,
    defaultParseWidth: "any"
  }),
  quarter: Zg({
    matchPatterns: PK,
    defaultMatchWidth: "wide",
    parsePatterns: FK,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Zg({
    matchPatterns: BK,
    defaultMatchWidth: "wide",
    parsePatterns: HK,
    defaultParseWidth: "any"
  }),
  day: Zg({
    matchPatterns: UK,
    defaultMatchWidth: "wide",
    parsePatterns: WK,
    defaultParseWidth: "any"
  }),
  dayPeriod: Zg({
    matchPatterns: VK,
    defaultMatchWidth: "any",
    parsePatterns: _K,
    defaultParseWidth: "any"
  })
}, xm = {
  code: "en-US",
  formatDistance: AK,
  formatLong: mK,
  formatRelative: yK,
  localize: LK,
  match: JK,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, KK = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, YK = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, QK = /^'([^]*?)'?$/, XK = /''/g, GK = /[a-zA-Z]/;
function qK(e, n, i) {
  var a, s, g, c, I, h, m, w, S, T, D, k, z, N, W, K, V, Y;
  ee(2, arguments);
  var H = String(n), Z = Ni(), Q = (a = (s = i == null ? void 0 : i.locale) !== null && s !== void 0 ? s : Z.locale) !== null && a !== void 0 ? a : xm, P1 = Lt((g = (c = (I = (h = i == null ? void 0 : i.firstWeekContainsDate) !== null && h !== void 0 ? h : i == null || (m = i.locale) === null || m === void 0 || (w = m.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && I !== void 0 ? I : Z.firstWeekContainsDate) !== null && c !== void 0 ? c : (S = Z.locale) === null || S === void 0 || (T = S.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && g !== void 0 ? g : 1);
  if (!(P1 >= 1 && P1 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Y1 = Lt((D = (k = (z = (N = i == null ? void 0 : i.weekStartsOn) !== null && N !== void 0 ? N : i == null || (W = i.locale) === null || W === void 0 || (K = W.options) === null || K === void 0 ? void 0 : K.weekStartsOn) !== null && z !== void 0 ? z : Z.weekStartsOn) !== null && k !== void 0 ? k : (V = Z.locale) === null || V === void 0 || (Y = V.options) === null || Y === void 0 ? void 0 : Y.weekStartsOn) !== null && D !== void 0 ? D : 0);
  if (!(Y1 >= 0 && Y1 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!Q.localize)
    throw new RangeError("locale must contain localize property");
  if (!Q.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var O1 = ie(e);
  if (!pM(O1))
    throw new RangeError("Invalid time value");
  var T1 = MA(O1), J1 = hM(O1, T1), s1 = {
    firstWeekContainsDate: P1,
    weekStartsOn: Y1,
    locale: Q,
    _originalDate: O1
  }, d1 = H.match(YK).map(function(h1) {
    var C1 = h1[0];
    if (C1 === "p" || C1 === "P") {
      var L1 = wh[C1];
      return L1(h1, Q.formatLong);
    }
    return h1;
  }).join("").match(KK).map(function(h1) {
    if (h1 === "''")
      return "'";
    var C1 = h1[0];
    if (C1 === "'")
      return ZK(h1);
    var L1 = cK[C1];
    if (L1)
      return !(i != null && i.useAdditionalWeekYearTokens) && xM(h1) && TA(h1, n, String(e)), !(i != null && i.useAdditionalDayOfYearTokens) && wM(h1) && TA(h1, n, String(e)), L1(J1, h1, Q.localize, s1);
    if (C1.match(GK))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + C1 + "`");
    return h1;
  }).join("");
  return d1;
}
function ZK(e) {
  var n = e.match(QK);
  return n ? n[1].replace(XK, "'") : e;
}
function $K(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getDate();
  return i;
}
function SM(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getFullYear(), a = n.getMonth(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(i, a + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function eY(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getHours();
  return i;
}
function tY(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getMinutes();
  return i;
}
function nY(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getMonth();
  return i;
}
function rY(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getSeconds();
  return i;
}
function iY(e) {
  ee(1, arguments);
  var n = ie(e), i = n.getMilliseconds();
  return i;
}
function gl(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = Ni(), S = Lt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var T = ie(e), D = T.getDay(), k = (D < S ? 7 : 0) + D - S;
  return T.setDate(T.getDate() - k), T.setHours(0, 0, 0, 0), T;
}
function aY(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = ie(e), S = w.getFullYear(), T = Ni(), D = Lt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : T.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = T.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = /* @__PURE__ */ new Date(0);
  k.setFullYear(S + 1, 0, D), k.setHours(0, 0, 0, 0);
  var z = gl(k, n), N = /* @__PURE__ */ new Date(0);
  N.setFullYear(S, 0, D), N.setHours(0, 0, 0, 0);
  var W = gl(N, n);
  return w.getTime() >= z.getTime() ? S + 1 : w.getTime() >= W.getTime() ? S : S - 1;
}
function oY(e, n) {
  var i, a, s, g, c, I, h, m;
  ee(1, arguments);
  var w = Ni(), S = Lt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1), T = aY(e, n), D = /* @__PURE__ */ new Date(0);
  D.setFullYear(T, 0, S), D.setHours(0, 0, 0, 0);
  var k = gl(D, n);
  return k;
}
var sY = 6048e5;
function lY(e, n) {
  ee(1, arguments);
  var i = ie(e), a = gl(i, n).getTime() - oY(i, n).getTime();
  return Math.round(a / sY) + 1;
}
function uY(e) {
  return ee(1, arguments), ie(e).getFullYear();
}
function d7(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getTime() > a.getTime();
}
function $g(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getTime() < a.getTime();
}
function cY(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getTime() === a.getTime();
}
function gY(e, n) {
  ee(2, arguments);
  var i = jc(e), a = jc(n);
  return i.getTime() === a.getTime();
}
function fY(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getFullYear() === a.getFullYear();
}
function dY(e, n) {
  ee(2, arguments);
  var i = ie(e), a = ie(n);
  return i.getFullYear() === a.getFullYear() && i.getMonth() === a.getMonth();
}
function cx(e) {
  ee(1, arguments);
  var n = ie(e);
  return n.setMinutes(0, 0, 0), n;
}
function CY(e, n) {
  ee(2, arguments);
  var i = cx(e), a = cx(n);
  return i.getTime() === a.getTime();
}
function gx(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, a = Array(n); i < n; i++) a[i] = e[i];
  return a;
}
function AY(e, n) {
  if (e) {
    if (typeof e == "string") return gx(e, n);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? gx(e, n) : void 0;
  }
}
function fx(e, n) {
  var i = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!i) {
    if (Array.isArray(e) || (i = AY(e)) || n) {
      i && (e = i);
      var a = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return a >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[a++]
          };
        },
        e: function(m) {
          throw m;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var g, c = !0, I = !1;
  return {
    s: function() {
      i = i.call(e);
    },
    n: function() {
      var m = i.next();
      return c = m.done, m;
    },
    e: function(m) {
      I = !0, g = m;
    },
    f: function() {
      try {
        c || i.return == null || i.return();
      } finally {
        if (I) throw g;
      }
    }
  };
}
function IY(e, n) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var i in n)
    Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  return e;
}
function Rt(e, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && Oc(e, n);
}
function pY(e, n) {
  if (n && (La(n) == "object" || typeof n == "function")) return n;
  if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return pe(e);
}
function Ot(e) {
  var n = im();
  return function() {
    var i, a = bf(e);
    if (n) {
      var s = bf(this).constructor;
      i = Reflect.construct(a, arguments, s);
    } else i = a.apply(this, arguments);
    return pY(this, i);
  };
}
function ht(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function hY(e, n) {
  for (var i = 0; i < n.length; i++) {
    var a = n[i];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, cE(a.key), a);
  }
}
function mt(e, n, i) {
  return n && hY(e.prototype, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ce(e, n, i) {
  return (n = cE(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
var mY = 10, EM = /* @__PURE__ */ function() {
  function e() {
    ht(this, e), Ce(this, "priority", void 0), Ce(this, "subPriority", 0);
  }
  return mt(e, [{
    key: "validate",
    value: function(i, a) {
      return !0;
    }
  }]), e;
}(), vY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i(a, s, g, c, I) {
    var h;
    return ht(this, i), h = n.call(this), h.value = a, h.validateValue = s, h.setValue = g, h.priority = c, I && (h.subPriority = I), h;
  }
  return mt(i, [{
    key: "validate",
    value: function(s, g) {
      return this.validateValue(s, this.value, g);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return this.setValue(s, g, this.value, c);
    }
  }]), i;
}(EM), yY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", mY), Ce(pe(a), "subPriority", -1), a;
  }
  return mt(i, [{
    key: "set",
    value: function(s, g) {
      if (g.timestampIsSet)
        return s;
      var c = /* @__PURE__ */ new Date(0);
      return c.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), c.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), c;
    }
  }]), i;
}(EM), Ht = /* @__PURE__ */ function() {
  function e() {
    ht(this, e), Ce(this, "incompatibleTokens", void 0), Ce(this, "priority", void 0), Ce(this, "subPriority", void 0);
  }
  return mt(e, [{
    key: "run",
    value: function(i, a, s, g) {
      var c = this.parse(i, a, s, g);
      return c ? {
        setter: new vY(c.value, this.validate, this.set, this.priority, this.subPriority),
        rest: c.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(i, a, s) {
      return !0;
    }
  }]), e;
}(), bY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 140), Ce(pe(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "G":
        case "GG":
        case "GGG":
          return c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return c.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return c.era(s, {
            width: "wide"
          }) || c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.era = c, s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), r2 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, xi = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function i2(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Nn(e, n) {
  var i = n.match(e);
  return i ? {
    value: parseInt(i[0], 10),
    rest: n.slice(i[0].length)
  } : null;
}
function Si(e, n) {
  var i = n.match(e);
  if (!i)
    return null;
  if (i[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var a = i[1] === "+" ? 1 : -1, s = i[2] ? parseInt(i[2], 10) : 0, g = i[3] ? parseInt(i[3], 10) : 0, c = i[5] ? parseInt(i[5], 10) : 0;
  return {
    value: a * (s * f6 + g * g6 + c * qJ),
    rest: n.slice(i[0].length)
  };
}
function MM(e) {
  return Nn(r2.anyDigitsSigned, e);
}
function Kn(e, n) {
  switch (e) {
    case 1:
      return Nn(r2.singleDigit, n);
    case 2:
      return Nn(r2.twoDigits, n);
    case 3:
      return Nn(r2.threeDigits, n);
    case 4:
      return Nn(r2.fourDigits, n);
    default:
      return Nn(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function LA(e, n) {
  switch (e) {
    case 1:
      return Nn(r2.singleDigitSigned, n);
    case 2:
      return Nn(r2.twoDigitsSigned, n);
    case 3:
      return Nn(r2.threeDigitsSigned, n);
    case 4:
      return Nn(r2.fourDigitsSigned, n);
    default:
      return Nn(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Sm(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function TM(e, n) {
  var i = n > 0, a = i ? n : 1 - n, s;
  if (a <= 50)
    s = e || 100;
  else {
    var g = a + 50, c = Math.floor(g / 100) * 100, I = e >= g % 100;
    s = e + c - (I ? 100 : 0);
  }
  return i ? s : 1 - s;
}
function LM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var wY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 130), Ce(pe(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return {
          year: m,
          isTwoDigitYear: g === "yy"
        };
      };
      switch (g) {
        case "y":
          return i2(Kn(4, s), I);
        case "yo":
          return i2(c.ordinalNumber(s, {
            unit: "year"
          }), I);
        default:
          return i2(Kn(g.length, s), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g.isTwoDigitYear || g.year > 0;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCFullYear();
      if (c.isTwoDigitYear) {
        var h = TM(c.year, I);
        return s.setUTCFullYear(h, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var m = !("era" in g) || g.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(m, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), xY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 130), Ce(pe(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return {
          year: m,
          isTwoDigitYear: g === "YY"
        };
      };
      switch (g) {
        case "Y":
          return i2(Kn(4, s), I);
        case "Yo":
          return i2(c.ordinalNumber(s, {
            unit: "year"
          }), I);
        default:
          return i2(Kn(g.length, s), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g.isTwoDigitYear || g.year > 0;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      var h = wm(s, I);
      if (c.isTwoDigitYear) {
        var m = TM(c.year, h);
        return s.setUTCFullYear(m, 0, I.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), pl(s, I);
      }
      var w = !("era" in g) || g.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(w, 0, I.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), pl(s, I);
    }
  }]), i;
}(Ht), SY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 130), Ce(pe(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g) {
      return LA(g === "R" ? 4 : g.length, s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = /* @__PURE__ */ new Date(0);
      return I.setUTCFullYear(c, 0, 4), I.setUTCHours(0, 0, 0, 0), zc(I);
    }
  }]), i;
}(Ht), EY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 130), Ce(pe(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g) {
      return LA(g === "u" ? 4 : g.length, s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), MY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 120), Ce(pe(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "Q":
        case "QQ":
          return Kn(g.length, s);
        case "Qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 4;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), TY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 120), Ce(pe(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "q":
        case "qq":
          return Kn(g.length, s);
        case "qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 4;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), LY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Ce(pe(a), "priority", 110), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m - 1;
      };
      switch (g) {
        case "M":
          return i2(Nn(r2.month, s), I);
        case "MM":
          return i2(Kn(2, s), I);
        case "Mo":
          return i2(c.ordinalNumber(s, {
            unit: "month"
          }), I);
        case "MMM":
          return c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return c.month(s, {
            width: "wide",
            context: "formatting"
          }) || c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), RY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 110), Ce(pe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m - 1;
      };
      switch (g) {
        case "L":
          return i2(Nn(r2.month, s), I);
        case "LL":
          return i2(Kn(2, s), I);
        case "Lo":
          return i2(c.ordinalNumber(s, {
            unit: "month"
          }), I);
        case "LLL":
          return c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return c.month(s, {
            width: "wide",
            context: "standalone"
          }) || c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht);
function OY(e, n, i) {
  ee(2, arguments);
  var a = ie(e), s = Lt(n), g = yM(a, i) - s;
  return a.setUTCDate(a.getUTCDate() - g * 7), a;
}
var DY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 100), Ce(pe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "w":
          return Nn(r2.week, s);
        case "wo":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 53;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return pl(OY(s, c, I), I);
    }
  }]), i;
}(Ht);
function kY(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n), s = vM(i) - a;
  return i.setUTCDate(i.getUTCDate() - s * 7), i;
}
var jY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 100), Ce(pe(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "I":
          return Nn(r2.week, s);
        case "Io":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 53;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return zc(kY(s, c));
    }
  }]), i;
}(Ht), zY = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], NY = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], PY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "subPriority", 1), Ce(pe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "d":
          return Nn(r2.date, s);
        case "do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      var c = s.getUTCFullYear(), I = LM(c), h = s.getUTCMonth();
      return I ? g >= 1 && g <= NY[h] : g >= 1 && g <= zY[h];
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCDate(c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), FY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "subpriority", 1), Ce(pe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "D":
        case "DD":
          return Nn(r2.dayOfYear, s);
        case "Do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      var c = s.getUTCFullYear(), I = LM(c);
      return I ? g >= 1 && g <= 366 : g >= 1 && g <= 365;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(0, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht);
function Em(e, n, i) {
  var a, s, g, c, I, h, m, w;
  ee(2, arguments);
  var S = Ni(), T = Lt((a = (s = (g = (c = i == null ? void 0 : i.weekStartsOn) !== null && c !== void 0 ? c : i == null || (I = i.locale) === null || I === void 0 || (h = I.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && g !== void 0 ? g : S.weekStartsOn) !== null && s !== void 0 ? s : (m = S.locale) === null || m === void 0 || (w = m.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var D = ie(e), k = Lt(n), z = D.getUTCDay(), N = k % 7, W = (N + 7) % 7, K = (W < T ? 7 : 0) + k - z;
  return D.setUTCDate(D.getUTCDate() + K), D;
}
var BY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "E":
        case "EE":
        case "EEE":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Em(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), HY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c, I) {
      var h = function(w) {
        var S = Math.floor((w - 1) / 7) * 7;
        return (w + I.weekStartsOn + 6) % 7 + S;
      };
      switch (g) {
        case "e":
        case "ee":
          return i2(Kn(g.length, s), h);
        case "eo":
          return i2(c.ordinalNumber(s, {
            unit: "day"
          }), h);
        case "eee":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Em(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), UY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c, I) {
      var h = function(w) {
        var S = Math.floor((w - 1) / 7) * 7;
        return (w + I.weekStartsOn + 6) % 7 + S;
      };
      switch (g) {
        case "c":
        case "cc":
          return i2(Kn(g.length, s), h);
        case "co":
          return i2(c.ordinalNumber(s, {
            unit: "day"
          }), h);
        case "ccc":
          return c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return c.day(s, {
            width: "wide",
            context: "standalone"
          }) || c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Em(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht);
function WY(e, n) {
  ee(2, arguments);
  var i = Lt(n);
  i % 7 === 0 && (i = i - 7);
  var a = 1, s = ie(e), g = s.getUTCDay(), c = i % 7, I = (c + 7) % 7, h = (I < a ? 7 : 0) + i - g;
  return s.setUTCDate(s.getUTCDate() + h), s;
}
var VY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 90), Ce(pe(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m === 0 ? 7 : m;
      };
      switch (g) {
        case "i":
        case "ii":
          return Kn(g.length, s);
        case "io":
          return c.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return i2(c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiiii":
          return i2(c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiiiii":
          return i2(c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiii":
        default:
          return i2(c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 7;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s = WY(s, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Ht), _Y = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 80), Ce(pe(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "a":
        case "aa":
        case "aaa":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Sm(c), 0, 0, 0), s;
    }
  }]), i;
}(Ht), JY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 80), Ce(pe(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "b":
        case "bb":
        case "bbb":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Sm(c), 0, 0, 0), s;
    }
  }]), i;
}(Ht), KY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 80), Ce(pe(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "B":
        case "BB":
        case "BBB":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Sm(c), 0, 0, 0), s;
    }
  }]), i;
}(Ht), YY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 70), Ce(pe(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "h":
          return Nn(r2.hour12h, s);
        case "ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 12;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCHours() >= 12;
      return I && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : !I && c === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Ht), QY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 70), Ce(pe(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "H":
          return Nn(r2.hour23h, s);
        case "Ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 23;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Ht), XY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 70), Ce(pe(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "K":
          return Nn(r2.hour11h, s);
        case "Ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCHours() >= 12;
      return I && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Ht), GY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 70), Ce(pe(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "k":
          return Nn(r2.hour24h, s);
        case "ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 24;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = c <= 24 ? c % 24 : c;
      return s.setUTCHours(I, 0, 0, 0), s;
    }
  }]), i;
}(Ht), qY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 60), Ce(pe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "m":
          return Nn(r2.minute, s);
        case "mo":
          return c.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 59;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMinutes(c, 0, 0), s;
    }
  }]), i;
}(Ht), ZY = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 50), Ce(pe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "s":
          return Nn(r2.second, s);
        case "so":
          return c.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return Kn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 59;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCSeconds(c, 0), s;
    }
  }]), i;
}(Ht), $Y = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 30), Ce(pe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g) {
      var c = function(h) {
        return Math.floor(h * Math.pow(10, -g.length + 3));
      };
      return i2(Kn(g.length, s), c);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMilliseconds(c), s;
    }
  }]), i;
}(Ht), eQ = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 10), Ce(pe(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g) {
      switch (g) {
        case "X":
          return Si(xi.basicOptionalMinutes, s);
        case "XX":
          return Si(xi.basic, s);
        case "XXXX":
          return Si(xi.basicOptionalSeconds, s);
        case "XXXXX":
          return Si(xi.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return Si(xi.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), i;
}(Ht), tQ = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 10), Ce(pe(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s, g) {
      switch (g) {
        case "x":
          return Si(xi.basicOptionalMinutes, s);
        case "xx":
          return Si(xi.basic, s);
        case "xxxx":
          return Si(xi.basicOptionalSeconds, s);
        case "xxxxx":
          return Si(xi.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return Si(xi.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), i;
}(Ht), nQ = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 40), Ce(pe(a), "incompatibleTokens", "*"), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s) {
      return MM(s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return [new Date(c * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), i;
}(Ht), rQ = /* @__PURE__ */ function(e) {
  Rt(i, e);
  var n = Ot(i);
  function i() {
    var a;
    ht(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), Ce(pe(a), "priority", 20), Ce(pe(a), "incompatibleTokens", "*"), a;
  }
  return mt(i, [{
    key: "parse",
    value: function(s) {
      return MM(s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return [new Date(c), {
        timestampIsSet: !0
      }];
    }
  }]), i;
}(Ht), iQ = {
  G: new bY(),
  y: new wY(),
  Y: new xY(),
  R: new SY(),
  u: new EY(),
  Q: new MY(),
  q: new TY(),
  M: new LY(),
  L: new RY(),
  w: new DY(),
  I: new jY(),
  d: new PY(),
  D: new FY(),
  E: new BY(),
  e: new HY(),
  c: new UY(),
  i: new VY(),
  a: new _Y(),
  b: new JY(),
  B: new KY(),
  h: new YY(),
  H: new QY(),
  K: new XY(),
  k: new GY(),
  m: new qY(),
  s: new ZY(),
  S: new $Y(),
  X: new eQ(),
  x: new tQ(),
  t: new nQ(),
  T: new rQ()
}, aQ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, oQ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, sQ = /^'([^]*?)'?$/, lQ = /''/g, uQ = /\S/, cQ = /[a-zA-Z]/;
function gQ(e, n, i, a) {
  var s, g, c, I, h, m, w, S, T, D, k, z, N, W, K, V, Y, H;
  ee(3, arguments);
  var Z = String(e), Q = String(n), P1 = Ni(), Y1 = (s = (g = a == null ? void 0 : a.locale) !== null && g !== void 0 ? g : P1.locale) !== null && s !== void 0 ? s : xm;
  if (!Y1.match)
    throw new RangeError("locale must contain match property");
  var O1 = Lt((c = (I = (h = (m = a == null ? void 0 : a.firstWeekContainsDate) !== null && m !== void 0 ? m : a == null || (w = a.locale) === null || w === void 0 || (S = w.options) === null || S === void 0 ? void 0 : S.firstWeekContainsDate) !== null && h !== void 0 ? h : P1.firstWeekContainsDate) !== null && I !== void 0 ? I : (T = P1.locale) === null || T === void 0 || (D = T.options) === null || D === void 0 ? void 0 : D.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
  if (!(O1 >= 1 && O1 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T1 = Lt((k = (z = (N = (W = a == null ? void 0 : a.weekStartsOn) !== null && W !== void 0 ? W : a == null || (K = a.locale) === null || K === void 0 || (V = K.options) === null || V === void 0 ? void 0 : V.weekStartsOn) !== null && N !== void 0 ? N : P1.weekStartsOn) !== null && z !== void 0 ? z : (Y = P1.locale) === null || Y === void 0 || (H = Y.options) === null || H === void 0 ? void 0 : H.weekStartsOn) !== null && k !== void 0 ? k : 0);
  if (!(T1 >= 0 && T1 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (Q === "")
    return Z === "" ? ie(i) : /* @__PURE__ */ new Date(NaN);
  var J1 = {
    firstWeekContainsDate: O1,
    weekStartsOn: T1,
    locale: Y1
  }, s1 = [new yY()], d1 = Q.match(oQ).map(function(V1) {
    var z1 = V1[0];
    if (z1 in wh) {
      var ae = wh[z1];
      return ae(V1, Y1.formatLong);
    }
    return V1;
  }).join("").match(aQ), h1 = [], C1 = fx(d1), L1;
  try {
    var f1 = function() {
      var z1 = L1.value;
      !(a != null && a.useAdditionalWeekYearTokens) && xM(z1) && TA(z1, Q, e), !(a != null && a.useAdditionalDayOfYearTokens) && wM(z1) && TA(z1, Q, e);
      var ae = z1[0], We = iQ[ae];
      if (We) {
        var D1 = We.incompatibleTokens;
        if (Array.isArray(D1)) {
          var ue = h1.find(function(Pe) {
            return D1.includes(Pe.token) || Pe.token === ae;
          });
          if (ue)
            throw new RangeError("The format string mustn't contain `".concat(ue.fullToken, "` and `").concat(z1, "` at the same time"));
        } else if (We.incompatibleTokens === "*" && h1.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(z1, "` and any other token at the same time"));
        h1.push({
          token: ae,
          fullToken: z1
        });
        var b1 = We.run(Z, z1, Y1.match, J1);
        if (!b1)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        s1.push(b1.setter), Z = b1.rest;
      } else {
        if (ae.match(cQ))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + ae + "`");
        if (z1 === "''" ? z1 = "'" : ae === "'" && (z1 = fQ(z1)), Z.indexOf(z1) === 0)
          Z = Z.slice(z1.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (C1.s(); !(L1 = C1.n()).done; ) {
      var B1 = f1();
      if (La(B1) === "object") return B1.v;
    }
  } catch (V1) {
    C1.e(V1);
  } finally {
    C1.f();
  }
  if (Z.length > 0 && uQ.test(Z))
    return /* @__PURE__ */ new Date(NaN);
  var t1 = s1.map(function(V1) {
    return V1.priority;
  }).sort(function(V1, z1) {
    return z1 - V1;
  }).filter(function(V1, z1, ae) {
    return ae.indexOf(V1) === z1;
  }).map(function(V1) {
    return s1.filter(function(z1) {
      return z1.priority === V1;
    }).sort(function(z1, ae) {
      return ae.subPriority - z1.subPriority;
    });
  }).map(function(V1) {
    return V1[0];
  }), y1 = ie(i);
  if (isNaN(y1.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var k1 = hM(y1, MA(y1)), se = {}, K1 = fx(t1), le;
  try {
    for (K1.s(); !(le = K1.n()).done; ) {
      var G1 = le.value;
      if (!G1.validate(k1, J1))
        return /* @__PURE__ */ new Date(NaN);
      var $1 = G1.set(k1, se, J1);
      Array.isArray($1) ? (k1 = $1[0], IY(se, $1[1])) : k1 = $1;
    }
  } catch (V1) {
    K1.e(V1);
  } finally {
    K1.f();
  }
  return k1;
}
function fQ(e) {
  return e.match(sQ)[1].replace(lQ, "'");
}
function dQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return i.setDate(a), i;
}
function CQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return i.setHours(a), i;
}
function AQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return i.setMinutes(a), i;
}
function IQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n), s = i.getFullYear(), g = i.getDate(), c = /* @__PURE__ */ new Date(0);
  c.setFullYear(s, a, 15), c.setHours(0, 0, 0, 0);
  var I = SM(c);
  return i.setMonth(a, Math.min(g, I)), i;
}
function pQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return i.setSeconds(a), i;
}
function hQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return i.setMilliseconds(a), i;
}
function mQ(e, n) {
  ee(2, arguments);
  var i = ie(e), a = Lt(n);
  return isNaN(i.getTime()) ? /* @__PURE__ */ new Date(NaN) : (i.setFullYear(a), i);
}
function dx(e) {
  ee(1, arguments);
  var n = ie(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function JC(e) {
  ee(1, arguments);
  var n = ie(e), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(n.getFullYear(), 0, 1), i.setHours(0, 0, 0, 0), i;
}
function vQ(e, n) {
  var i;
  ee(1, arguments);
  var a = Lt((i = void 0) !== null && i !== void 0 ? i : 2);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = xQ(e), g;
  if (s.date) {
    var c = SQ(s.date, a);
    g = EQ(c.restDateString, c.year);
  }
  if (!g || isNaN(g.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var I = g.getTime(), h = 0, m;
  if (s.time && (h = MQ(s.time), isNaN(h)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (m = TQ(s.timezone), isNaN(m))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var w = new Date(I + h), S = /* @__PURE__ */ new Date(0);
    return S.setFullYear(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate()), S.setHours(w.getUTCHours(), w.getUTCMinutes(), w.getUTCSeconds(), w.getUTCMilliseconds()), S;
  }
  return new Date(I + h + m);
}
var KC = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, yQ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, bQ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, wQ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function xQ(e) {
  var n = {}, i = e.split(KC.dateTimeDelimiter), a;
  if (i.length > 2)
    return n;
  if (/:/.test(i[0]) ? a = i[0] : (n.date = i[0], a = i[1], KC.timeZoneDelimiter.test(n.date) && (n.date = e.split(KC.timeZoneDelimiter)[0], a = e.substr(n.date.length, e.length))), a) {
    var s = KC.timezone.exec(a);
    s ? (n.time = a.replace(s[1], ""), n.timezone = s[1]) : n.time = a;
  }
  return n;
}
function SQ(e, n) {
  var i = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"), a = e.match(i);
  if (!a) return {
    year: NaN,
    restDateString: ""
  };
  var s = a[1] ? parseInt(a[1]) : null, g = a[2] ? parseInt(a[2]) : null;
  return {
    year: g === null ? s : g * 100,
    restDateString: e.slice((a[1] || a[2]).length)
  };
}
function EQ(e, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  var i = e.match(yQ);
  if (!i) return /* @__PURE__ */ new Date(NaN);
  var a = !!i[4], s = ef(i[1]), g = ef(i[2]) - 1, c = ef(i[3]), I = ef(i[4]), h = ef(i[5]) - 1;
  if (a)
    return kQ(n, I, h) ? LQ(n, I, h) : /* @__PURE__ */ new Date(NaN);
  var m = /* @__PURE__ */ new Date(0);
  return !OQ(n, g, c) || !DQ(n, s) ? /* @__PURE__ */ new Date(NaN) : (m.setUTCFullYear(n, g, Math.max(s, c)), m);
}
function ef(e) {
  return e ? parseInt(e) : 1;
}
function MQ(e) {
  var n = e.match(bQ);
  if (!n) return NaN;
  var i = C7(n[1]), a = C7(n[2]), s = C7(n[3]);
  return jQ(i, a, s) ? i * f6 + a * g6 + s * 1e3 : NaN;
}
function C7(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function TQ(e) {
  if (e === "Z") return 0;
  var n = e.match(wQ);
  if (!n) return 0;
  var i = n[1] === "+" ? -1 : 1, a = parseInt(n[2]), s = n[3] && parseInt(n[3]) || 0;
  return zQ(a, s) ? i * (a * f6 + s * g6) : NaN;
}
function LQ(e, n, i) {
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var s = a.getUTCDay() || 7, g = (n - 1) * 7 + i + 1 - s;
  return a.setUTCDate(a.getUTCDate() + g), a;
}
var RQ = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function RM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function OQ(e, n, i) {
  return n >= 0 && n <= 11 && i >= 1 && i <= (RQ[n] || (RM(e) ? 29 : 28));
}
function DQ(e, n) {
  return n >= 1 && n <= (RM(e) ? 366 : 365);
}
function kQ(e, n, i) {
  return n >= 1 && n <= 53 && i >= 0 && i <= 6;
}
function jQ(e, n, i) {
  return e === 24 ? n === 0 && i === 0 : i >= 0 && i < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function zQ(e, n) {
  return n >= 0 && n <= 59;
}
function NQ(e, n) {
  var i, a;
  ee(1, arguments);
  var s = ie(e);
  if (isNaN(s.getTime()))
    throw new RangeError("Invalid time value");
  var g = String((i = n == null ? void 0 : n.format) !== null && i !== void 0 ? i : "extended"), c = String((a = n == null ? void 0 : n.representation) !== null && a !== void 0 ? a : "complete");
  if (g !== "extended" && g !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (c !== "date" && c !== "time" && c !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var I = "", h = "", m = g === "extended" ? "-" : "", w = g === "extended" ? ":" : "";
  if (c !== "time") {
    var S = pt(s.getDate(), 2), T = pt(s.getMonth() + 1, 2), D = pt(s.getFullYear(), 4);
    I = "".concat(D).concat(m).concat(T).concat(m).concat(S);
  }
  if (c !== "date") {
    var k = s.getTimezoneOffset();
    if (k !== 0) {
      var z = Math.abs(k), N = pt(Math.floor(z / 60), 2), W = pt(z % 60, 2), K = k < 0 ? "+" : "-";
      h = "".concat(K).concat(N, ":").concat(W);
    } else
      h = "Z";
    var V = pt(s.getHours(), 2), Y = pt(s.getMinutes(), 2), H = pt(s.getSeconds(), 2), Z = I === "" ? "" : "T", Q = [V, Y, H].join(w);
    I = "".concat(I).concat(Z).concat(Q).concat(h);
  }
  return I;
}
function PQ(e, n) {
  ee(2, arguments);
  var i = ie(e).getTime(), a = ie(n.start).getTime(), s = ie(n.end).getTime();
  if (!(a <= s))
    throw new RangeError("Invalid interval");
  return i >= a && i <= s;
}
var xh = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = void 0;
  var i = function(h, m) {
    switch (h) {
      case "P":
        return m.date({
          width: "short"
        });
      case "PP":
        return m.date({
          width: "medium"
        });
      case "PPP":
        return m.date({
          width: "long"
        });
      case "PPPP":
      default:
        return m.date({
          width: "full"
        });
    }
  }, a = function(h, m) {
    switch (h) {
      case "p":
        return m.time({
          width: "short"
        });
      case "pp":
        return m.time({
          width: "medium"
        });
      case "ppp":
        return m.time({
          width: "long"
        });
      case "pppp":
      default:
        return m.time({
          width: "full"
        });
    }
  }, s = function(h, m) {
    var w = h.match(/(P+)(p+)?/) || [], S = w[1], T = w[2];
    if (!T)
      return i(h, m);
    var D;
    switch (S) {
      case "P":
        D = m.dateTime({
          width: "short"
        });
        break;
      case "PP":
        D = m.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        D = m.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        D = m.dateTime({
          width: "full"
        });
        break;
    }
    return D.replace("{{date}}", i(S, m)).replace("{{time}}", a(T, m));
  }, g = {
    p: a,
    P: s
  }, c = g;
  n.default = c, e.exports = n.default;
})(xh, xh.exports);
var FQ = xh.exports;
const BQ = /* @__PURE__ */ _h(FQ), HQ = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, UQ = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  monthAndYear: "LLLL yyyy",
  monthAndDate: "MMMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aa",
  fullDateTime24h: "PP HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class WQ {
  constructor(n) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = "date-fns", this.locale = void 0, this.formats = void 0, this.formatTokenMap = HQ, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (g) => typeof g > "u" ? /* @__PURE__ */ new Date() : g === null ? null : new Date(g), this.dateWithTimezone = (g) => this.date(g), this.getTimezone = () => "default", this.setTimezone = (g) => g, this.toJsDate = (g) => g, this.getCurrentLocaleCode = () => {
      var g;
      return ((g = this.locale) == null ? void 0 : g.code) || "en-US";
    }, this.is12HourCycleInCurrentLocale = () => this.locale ? /a/.test(this.locale.formatLong.time({
      width: "short"
    })) : !0, this.expandFormat = (g) => {
      const c = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return g.match(c).map((I) => {
        const h = I[0];
        if (h === "p" || h === "P") {
          const m = this.longFormatters[h];
          return m(I, this.locale.formatLong);
        }
        return I;
      }).join("");
    }, this.getFormatHelperText = (g) => this.expandFormat(g).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase(), this.isNull = (g) => g === null, this.formatNumber = (g) => g, this.getMeridiemText = (g) => g === "am" ? "AM" : "PM";
    const {
      locale: i,
      formats: a,
      longFormatters: s
    } = n;
    this.locale = i, this.formats = m1({}, UQ, a), this.longFormatters = s;
  }
}
class ne1 extends WQ {
  constructor({
    locale: n,
    formats: i
  } = {}) {
    if (typeof gA != "function")
      throw new Error(["MUI: The `date-fns` package v3.x is not compatible with this adapter.", "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."].join(`
`));
    super({
      locale: n ?? xm,
      formats: i,
      longFormatters: BQ
    }), this.parseISO = (a) => vQ(a), this.toISO = (a) => NQ(a, {
      format: "extended"
    }), this.parse = (a, s) => a === "" ? null : gQ(a, s, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (a) => pM(this.date(a)), this.format = (a, s) => this.formatByString(a, this.formats[s]), this.formatByString = (a, s) => qK(a, s, {
      locale: this.locale
    }), this.getDiff = (a, s, g) => {
      switch (g) {
        case "years":
          return VJ(a, this.date(s));
        case "quarters":
          return YJ(a, this.date(s));
        case "months":
          return AM(a, this.date(s));
        case "weeks":
          return GJ(a, this.date(s));
        case "days":
          return IM(a, this.date(s));
        case "hours":
          return ZJ(a, this.date(s));
        case "minutes":
          return $J(a, this.date(s));
        case "seconds":
          return eK(a, this.date(s));
        default:
          return d6(a, this.date(s));
      }
    }, this.isEqual = (a, s) => a === null && s === null ? !0 : cY(a, s), this.isSameYear = (a, s) => fY(a, s), this.isSameMonth = (a, s) => dY(a, s), this.isSameDay = (a, s) => gY(a, s), this.isSameHour = (a, s) => CY(a, s), this.isAfter = (a, s) => d7(a, s), this.isAfterYear = (a, s) => d7(a, g7(s)), this.isAfterDay = (a, s) => d7(a, yh(s)), this.isBefore = (a, s) => $g(a, s), this.isBeforeYear = (a, s) => $g(a, JC(s)), this.isBeforeDay = (a, s) => $g(a, jc(s)), this.isWithinRange = (a, [s, g]) => PQ(a, {
      start: s,
      end: g
    }), this.startOfYear = (a) => JC(a), this.startOfMonth = (a) => dx(a), this.startOfWeek = (a) => gl(a, {
      locale: this.locale
    }), this.startOfDay = (a) => jc(a), this.endOfYear = (a) => g7(a), this.endOfMonth = (a) => bh(a), this.endOfWeek = (a) => c7(a, {
      locale: this.locale
    }), this.endOfDay = (a) => yh(a), this.addYears = (a, s) => ix(a, s), this.addMonths = (a, s) => fA(a, s), this.addWeeks = (a, s) => UJ(a, s), this.addDays = (a, s) => gA(a, s), this.addHours = (a, s) => HJ(a, s), this.addMinutes = (a, s) => FJ(a, s), this.addSeconds = (a, s) => NJ(a, s), this.getYear = (a) => uY(a), this.getMonth = (a) => nY(a), this.getDate = (a) => $K(a), this.getHours = (a) => eY(a), this.getMinutes = (a) => tY(a), this.getSeconds = (a) => rY(a), this.getMilliseconds = (a) => iY(a), this.setYear = (a, s) => mQ(a, s), this.setMonth = (a, s) => IQ(a, s), this.setDate = (a, s) => dQ(a, s), this.setHours = (a, s) => CQ(a, s), this.setMinutes = (a, s) => AQ(a, s), this.setSeconds = (a, s) => pQ(a, s), this.setMilliseconds = (a, s) => hQ(a, s), this.getDaysInMonth = (a) => SM(a), this.getNextMonth = (a) => fA(a, 1), this.getPreviousMonth = (a) => fA(a, -1), this.getMonthArray = (a) => {
      const g = [JC(a)];
      for (; g.length < 12; ) {
        const c = g[g.length - 1];
        g.push(this.getNextMonth(c));
      }
      return g;
    }, this.mergeDateAndTime = (a, s) => this.setSeconds(this.setMinutes(this.setHours(a, this.getHours(s)), this.getMinutes(s)), this.getSeconds(s)), this.getWeekdays = () => {
      const a = /* @__PURE__ */ new Date();
      return tK({
        start: gl(a, {
          locale: this.locale
        }),
        end: c7(a, {
          locale: this.locale
        })
      }).map((s) => this.formatByString(s, "EEEEEE"));
    }, this.getWeekArray = (a) => {
      const s = gl(dx(a), {
        locale: this.locale
      }), g = c7(bh(a), {
        locale: this.locale
      });
      let c = 0, I = s;
      const h = [];
      for (; $g(I, g); ) {
        const m = Math.floor(c / 7);
        h[m] = h[m] || [], h[m].push(I), I = gA(I, 1), c += 1;
      }
      return h;
    }, this.getWeekNumber = (a) => lY(a, {
      locale: this.locale
    }), this.getYearRange = (a, s) => {
      const g = JC(a), c = g7(s), I = [];
      let h = g;
      for (; $g(h, c); )
        I.push(h), h = ix(h, 1);
      return I;
    };
  }
}
const VQ = "@media (max-height: 500px)", re1 = ({
  title: e,
  children: n,
  iconClose: i = !0,
  escClose: a = !1,
  bgClose: s = !1,
  onClose: g,
  onSubmit: c,
  submitLabel: I = "Submit",
  submitBtnProps: h = {},
  onCancel: m,
  cancelLabel: w = "Cancel",
  cancelBtnProps: S = {},
  actions: T,
  contentProps: D = {},
  actionsProps: k = {},
  type: z,
  options: N,
  layout: W,
  shortViewportFullScreen: K = !1,
  ...V
}) => {
  const Y = h2(
    (Z, Q) => {
      Q === "backdropClick" && s && g(), Q === "escapeKeyDown" && a && g();
    },
    [g, a, s]
  ), H = {
    info: /* @__PURE__ */ y.jsx(Me, { icon: "info", color: "info" }),
    warning: /* @__PURE__ */ y.jsx(Me, { icon: "warning", color: "warning" }),
    success: /* @__PURE__ */ y.jsx(Me, { icon: "success", color: "success" })
  };
  return /* @__PURE__ */ y.jsxs(
    hl,
    {
      maxWidth: "xs",
      sx: {
        [`.${Sj.root}`]: {
          padding: 2,
          ...W === "documentPreview" && {
            width: "calc(100% - 64px)",
            height: "calc(100% - 64px)",
            maxWidth: "none",
            maxHeight: "none",
            display: "flex",
            flexDirection: "column",
            ...K && {
              [VQ]: {
                margin: 0,
                padding: 0,
                marginLeft: "var(--safe-area-inset-left, env(safe-area-inset-left, 0px))",
                marginRight: "var(--safe-area-inset-right, env(safe-area-inset-right, 0px))",
                marginTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
                marginBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
                width: "calc(100% - var(--safe-area-inset-left, env(safe-area-inset-left, 0px)) - var(--safe-area-inset-right, env(safe-area-inset-right, 0px)))",
                height: "calc(100% - var(--safe-area-inset-top, env(safe-area-inset-top, 0px)) - var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))"
              }
            }
          }
        }
      },
      ...V,
      onClose: Y,
      children: [
        /* @__PURE__ */ y.jsx(
          BA,
          {
            sx: {
              [`&.${Ej.root}.${lS.root}`]: {
                padding: 1
              }
            },
            children: /* @__PURE__ */ y.jsxs(
              Ke,
              {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                sx: { minWidth: 0 },
                children: [
                  /* @__PURE__ */ y.jsxs(
                    Ke,
                    {
                      direction: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      spacing: 1,
                      sx: {
                        minWidth: 0,
                        flex: 1,
                        overflow: "hidden"
                      },
                      children: [
                        z && H[z],
                        /* @__PURE__ */ y.jsx(
                          ne,
                          {
                            component: "span",
                            variant: "h5",
                            sx: {
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            },
                            children: e
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ y.jsxs(
                    Ke,
                    {
                      direction: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 1,
                      sx: { flexShrink: 0 },
                      children: [
                        N,
                        i && /* @__PURE__ */ y.jsx(
                          xc,
                          {
                            "aria-label": "close",
                            onClick: g,
                            sx: { padding: 1, margin: -1 },
                            children: /* @__PURE__ */ y.jsx(Me, { icon: "close" })
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ y.jsx(
          Ei,
          {
            sx: {
              [`&.${Mj.root}`]: {
                padding: 1,
                paddingBottom: 2,
                ...W === "documentPreview" && {
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  flex: "1 1 auto",
                  minHeight: 0,
                  overflow: "hidden"
                }
              }
            },
            ...D,
            children: n
          }
        ),
        (T || m || c) && /* @__PURE__ */ y.jsxs(Nc, { ...k, children: [
          T,
          m && /* @__PURE__ */ y.jsx(
            k2,
            {
              variant: "outlined",
              color: "error",
              ...S,
              onClick: m,
              fullWidth: !0,
              children: w
            }
          ),
          c && /* @__PURE__ */ y.jsx(
            k2,
            {
              variant: "contained",
              color: "primary",
              ...h,
              onClick: c,
              fullWidth: !0,
              children: I
            }
          )
        ] })
      ]
    }
  );
}, OM = () => /* @__PURE__ */ y.jsx(F1, { display: "flex", flexDirection: "column", width: "100%", children: /* @__PURE__ */ y.jsx(
  F1,
  {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "52px",
    sx: { backgroundColor: (e) => {
      var n, i;
      return (i = (n = e.palette.common) == null ? void 0 : n.error) == null ? void 0 : i[50];
    } },
    px: 1,
    children: /* @__PURE__ */ y.jsx(F1, { children: /* @__PURE__ */ y.jsxs(ne, { display: "flex", alignItems: "center", gap: 1, children: [
      /* @__PURE__ */ y.jsx(Me, { icon: "danger" }),
      " Error Loading File"
    ] }) })
  }
) }), Mm = ka(
  (e, n) => /* @__PURE__ */ y.jsx(
    F1,
    {
      boxSizing: "border-box",
      position: "relative",
      width: "100%",
      p: 2,
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: (i) => {
        var a, s, g;
        return `1px dashed ${(g = (s = (a = i.palette) == null ? void 0 : a.common) == null ? void 0 : s.neutrals) == null ? void 0 : g[200]}`;
      },
      borderRadius: 1,
      ...e,
      ref: n
    }
  )
);
Mm.displayName = "DragAndDropBox";
const DM = ({ mimeType: e = "", ...n }) => {
  const i = V2(() => /^image\//.test(e) ? "fileImage" : e === "application/pdf" ? "filePdf" : "file", [e]);
  return /* @__PURE__ */ y.jsx(Me, { ...n, icon: i });
};
DM.displayName = "FileTypeIcon";
const _Q = (e) => /* @__PURE__ */ n1.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", strokeWidth: 1.5, ...e }, /* @__PURE__ */ n1.createElement("path", { d: "M7 3H5C3.89543 3 3 3.89543 3 5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M17 3H19C20.1046 3 21 3.89543 21 5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M16 8L16 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M8 8L8 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M9 16C9 16 10 17 12 17C14 17 15 16 15 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M12 8L12 13L11 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M7 21H5C3.89543 21 3 20.1046 3 19V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ n1.createElement("path", { d: "M17 21H19C20.1046 21 21 20.1046 21 19V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), ie1 = (e = {}) => /* @__PURE__ */ y.jsx(FA, { ...e, children: /* @__PURE__ */ y.jsx(_Q, {}) }), JQ = (e) => /* @__PURE__ */ n1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 186.69 190.5", ...e }, /* @__PURE__ */ n1.createElement("g", { transform: "translate(1184.583 765.171)" }, /* @__PURE__ */ n1.createElement("path", { clipPath: "none", mask: "none", d: "M-1089.333-687.239v36.888h51.262c-2.251 11.863-9.006 21.908-19.137 28.662l30.913 23.986c18.011-16.625 28.402-41.044 28.402-70.052 0-6.754-.606-13.249-1.732-19.483z", fill: "#4285f4" }), /* @__PURE__ */ n1.createElement("path", { clipPath: "none", mask: "none", d: "M-1142.714-651.791l-6.972 5.337-24.679 19.223h0c15.673 31.086 47.796 52.561 85.03 52.561 25.717 0 47.278-8.486 63.038-23.033l-30.913-23.986c-8.486 5.715-19.31 9.179-32.125 9.179-24.765 0-45.806-16.712-53.34-39.226z", fill: "#34a853" }), /* @__PURE__ */ n1.createElement("path", { clipPath: "none", mask: "none", d: "M-1174.365-712.61c-6.494 12.815-10.217 27.276-10.217 42.689s3.723 29.874 10.217 42.689c0 .086 31.693-24.592 31.693-24.592-1.905-5.715-3.031-11.776-3.031-18.098s1.126-12.383 3.031-18.098z", fill: "#fbbc05" }), /* @__PURE__ */ n1.createElement("path", { d: "M-1089.333-727.244c14.028 0 26.497 4.849 36.455 14.201l27.276-27.276c-16.539-15.413-38.013-24.852-63.731-24.852-37.234 0-69.359 21.388-85.032 52.561l31.692 24.592c7.533-22.514 28.575-39.226 53.34-39.226z", fill: "#ea4335", clipPath: "none", mask: "none" }))), ae1 = (e = {}) => /* @__PURE__ */ y.jsx(FA, { ...e, children: /* @__PURE__ */ y.jsx(JQ, {}) }), KQ = (e) => /* @__PURE__ */ n1.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ n1.createElement("rect", { y: 0.0625, width: 24, height: 24, fill: "url(#pattern0)" }), /* @__PURE__ */ n1.createElement("defs", null, /* @__PURE__ */ n1.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ n1.createElement("use", { xlinkHref: "#image0_578_25", transform: "scale(0.00195312)" })), /* @__PURE__ */ n1.createElement("image", { id: "image0_578_25", width: 512, height: 512, xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAABTC0lEQVR42u2dd7xjdZn/P9/k9pl775Q7MExhYAApYkHEwk9XUYqgiKJgwQKoICBYETuzNsBVwbXsyiIKDKKM1AEBHQuKuK6ia2Ot1ClMZ/otyXl+f8wt5yTnnJzkJjlJ7vv9WtZJbnJy8s1Jns/z+T7P9ysBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHk4hgBg6vCeLu2zy8s+Ky97qpnbz5z2cLK5ntQvqStv1mZSj3PabpI5uZ0ybXfO1jhza53To07uD13Z/P98bZceZ0QBEAAA0GAskdrWdba9JO/0EjN7Xt6zw8ypb+zvnu+xFvi3Be+ziX+b735n2pJx+mPW2c+cpx8syukXS6QcIw+AAACAOnOuNF1d2Td45l7pmb3QnPolybOJkG4Fgd9CRYBfCoze57vhFbyuSWrPanD//bVxv8V255FH6ZJ936tH+EQAEAAAUEPe1Zk9Pi+9zaTjPaknNLO3kOw+gRtgBZE+zA1QgZDo7pIOOVBbX/gCu/WZR+i6znb9zJ2qYT4pAAQAAEyS90rduc72d+Rk75LsAAsJxGFBPcoNiBYB0W6AxbzO2L/3XSS95CgbesG/aEU2o9tzGd3V8wbqBwAQAABQFudLnepqu9Dz9B5zmh0MvFbC1o8XAfEBvTI3YIyB2dJJJ5r+5UWSnB5y0h2etLxzpn7uTtAQnywAAgAAQlgiZTZ3t5/rmfcRz9xe0cHWSgbmsRueynUDkhUIKkYQzJ8rnfwq0xHPHf/zTifd75nusIxu7T5Nj/JpAyAAAEDSB7raXpxzuiJvekYgoFpU9m6a7JRAlJMQ5gZEn4ciz+PA/aW3n2naY27R231I0gqZ7ujM64fuDA1yBQAgAACmFB/q6lo8ZLnP55171e7vqxUHZ4sOtkmnBMyCEqBebkBnp3TCMaZXvkrKZEKHYJecfuFMK+S0vPNNepCrAgABANCyfFDqzXe3X2ymd3lSZyKbPwU3oJJ2wbD/3Xdv6YJ3mWbNLjk0D0la4aQVHSO6271N27haABAAAE3PEimzo6f97LzZJ83cQHzgrKUbUJ92Qf99Pd3S299iOvyIxMM1KOk+J61wphUdp+sBriAABABA03HhtM6XyeyLnmcHxwXKKBEQ5gaUcg4qcQNq1S5okpyTXnGs6bWnVDSED8vph05a0ZHRPe5N2spVBYAAAGjcrL+ra/Eu533Ok15jvshZKlsvtPlr4Qak0S5oko54pvTOs03ZtoqHNSfpV+a03Ewret6q3zpXZGgAIAAAoP58UOrNTOv8uHl2gYXO80tmFho4E7sBCURAqYCeVrvgIQdIF5xv6uqqynCvlfQDk5YPST+ceYae5AoEBAAA1JUbpezvuzvPyzvvE2ZudlSAnowbUHSsJm0X3HehdNGFVRMBY+Sd9L8m3eE5LccdAAQAANScj03rfJmZfd4z99Sw4BsZUM0S2+i1LxCsrxuw3z7She8zdXbW7GNZ56R7zXTHUJeWzzhNm7lSAQEAAFVhSW/HQSM59zk5nRgMgFYyqAft+PhA3artggfsI134flN7e80/qrxz+l9JK8x0R9fjut8tKTo9AAQAAMRz2YB6d+zq+qjJ3mumDqm4St8igm8pN6DUlEB93ID6tQse/jTpvPPq7tRvkNNPTFqhES2fdrbWcFUDAgAAojN+KeN6ut6Wd/YZSXMmAmZhMA+6Ackz+2CBYOnntEa74MknmF5xYmofqyfpd5JWZDJa0Tmie93ZGuFqBwQAAEiS/nVa53EmfUFyT7WCUBca6AL3lVP1r5ZqF0xSICgnvfN00xFHNMRHvVHSj01a4XK6s+ccreLqBwQAwBTks70dB+XymcvN6WVJgl0gqBZl4pW7Aa3eLtjdJX3yY6ZZsxrr8zfTgy6j5RlPKzpn6GfuVA3zrQAEAEALc0l//8xcbvjjkp0nqSN6LjuB7V1mgeBk3YBmbRfcf5H04QutkX/Bdkj6iTktd1nd1XOmHuebAggAgBZhiZTJ9vac4cy7VNJA0vY2ryD8xbkBlRYIJhcOzdsuePIrTCcc3yQXi+khy+gOmZZPG9TP3QUa4hsECACAJuTSvp7jzfO+ILmDPX+Ys2Rz4LVwA1q9XbDwPba3SR+7yDRvr6a7fHZKut853eEyurX77XqUbxQgAAAanMt6Ow/0lL3Emb06LKCZL2qX6wZYWEV+HdoFa10gWMt2wYMPkN53QdMv4veQpBWS7ujp1A/dGRrkmwYIAIAG4ZL+/plZb/ijMr0rct1+BSv5C92A6MVuShQIhrgBzdAuWBTsa9Qu+M7TpcMPb5mVfHfJ9AtzWmF53d57nv6Pbx8gAABSYInUNn369HNM3hKTzUqWvfqq4RO6AbQLVt4uOHuW9OmPm7LZlrwEH5LTCudpxY5O3T3nbdrGtxIQAAA15or+acfkTZfLs6eaiufjY7PuGDeg3GBHu2DpAsHXv1o66sUtv5/PoKT7JK1w0opp5+oBvqWAAACoZuDv7T3QU/4zknvNePCxmGw9LuNVYxQITtYNaPR2wVkzpE9fbMpkptSl+rBJP5S0Yjine2ZfoK18ewEBAFABX+vvnzns5T4spws0Os8fDHQTQTxsfjpuSmCyBYKl3ADaBaW3nCodeeSU3dU355x+ZdJyJ63oOYctjgEBAFCSJVLb7L7p55h0sUmzi6zsCBFQyg0Iq3ivhxuQPLNXS7ULzh1wuvgjbNw3ylpJPzDT8lxOP5z5Xj3JkAACAMDHV/qnHePkvmimQ70SmWZACJgVZcj1cgNoFwx+Rv7b7z/XtP/+XNcF5CX9r5nuyGS1HHcAEAAwtQN/b+9TMs77gsm9IixwR2a8sVMCky8QLAx2pdwA2gWDguc5z5TOeDOxrQTrnHSvme7ItWn5jHO1mSFBAAC0PF/r75+ZkXeRyd7rSR2FAcsfbJKIgDA3oGAJG9oFVb92wY4O6ZJPmLq6uNbLcQectMIz3dG7Wfe7JWIeBQEA0Dp8XWr3+vrOkbOLJc3yhw8vJHNtBDeAdsHK2gXfcLL0giNxASpkg6SfyLQi42n5tPdqDUOCAABoWq7sn3a0p8zlkg4NDwsWKQJM8YVtlRYIhgU02gUrdwP89z/tIOnst5HEVgFP0u+caYUyWjFtk37qlijHsCAAABqer/X2HpjJ6gsyvVxRWWbBvXFuQEFTXhluAO2CpdyAarYLdnVIl/2r16orA6bJRkk/ltOKbF539rxPqxgSBABAQ3FVX98sz9kHTe69JuuIepyVKQJq5QaU0y5YToFgKTegldsFzz3DdMjBTAPUmAedtFymFdN6dK87WyMMCQIAIBW+LrVrRt95kj4haaY/8lliEbD7Xi8kYEW5Aa3QLthMBYJJ2gWPOlJ69UlMA9SR7TL91Dktz3q6q+f9epwhQQAA1IUr+/uPlrMrJD3VIiK8xZr/5bkBtAs2drvg4kXSe85BAKTIQ066wzktn7ZFP3NLNMyQIAAAqpv1z+49yOXcF+R0QmRQTyACkroBtAs2lhsQJQK6OqVLl3j8wjUGWyX9yDndjTuAAACYNFf19c2yTOZiyc41qS16Rj/sjvKnBBrZDaBdMLxd8KJ3e9prLt+VBuRBk5Y56dt979ffGA4EAEAibpQ6npwx411O9nFJMxQSYGKDeo3cANoFG69d8I2vMT3ncAoBG5xfmvTVvu1axjQBAgAgkqtn9x/teXaFmXtqfOBO1w0op10wWKhHu2ApN6CcdsFjXmw6/lgEQJOwVtJ/ZUxf7r1Q6xgOBACAJOnrs2cflPVyX5B88/ymEoG7lm4A7YLN0C54xDNMbziVQsAmY4eTvuLldNmMD7NHAQIApizX9PbOzrVnPyHT6Dx/cRi0mAQvcdU/7YLFQbUF2gUXLzKd+3YEQJOy2UmX9vbrctYXqB0ZhgAajRuljqtm9X8g15b9p0wXSGpzEZrVuWgV6+RCNW7Rvc7/DFeGUnbKSMr4DugKvlz+13K+M3Kj5z7xPtz4e3Eh55IJHKf4vThNPNn/uEzE+874ju5ccByd78H+47uQsXNh5+Xc7vcTOL/C8w2+16K/hYypC/lkXdQ5SNq2je9SEzPTpMu2bNFvt/6bns9w4ADAFODq2f1Hy3NfMukQlczGg2li3GyvpVggWOwG0C5YDzegv9f0sQtxAFoAT07/scvporkXagfDgQCAFuO/Zs8+OOt5X5Ds+NLBNkIElBACjVAgKNEuWK92wWnd0sUfyvPlah3+4kmnzvqQ/shQVAemACBVruntnX31rFlfajPvj3I6vtBkdjHK1YU9wsU/p5pTAlFHyviOETclIL8Nr4IpgdE3ErS5XejrF/47I59J7sL+Fva84Dt1Ba9dPL0QPyVQZM1HTAlIUVMCxWPjXPHjQ8dx9L8R9q1rNQ7KSL968lK9g6GoDm0MAaTBv0udvTNnXuA5fczJ+sZ+vG3sl9zceC7nYrLu3Y8qeMRooAorEBwLMGFugPPf4zukG/1L9OsX35vZ/UR5kpwvex4LTp7v3TnfuTg3kfGOz+uPtgs63ysWHqvwXDLj2bCTOSs6B/+7d+P3u9HjTZxL4TCZm3g/Y+PoCpwJV5Ddj5+Xc3JmoU6KC32uKz62m/hcix8bdA9yOcXPC0Ez0i3pys2X6NAZQ3qvWyLmeHAAoJn45syZJ/bNnvlnOX1OUl9oZu2Ks/X4zD7k8am7AYp1AzJluAGVFgiOuwHOVVQgWMoNcAVnE5/ZK3GBoELcgKgCwTA3wEnBfkz+a6n/nOmCLR1a9vgX1c0vKgIAmoCrZ8065FuzZt3lnLtdpv1cqaBe+GuvpFMCgegZCKbFz0lQ9R8IOC6BEAk+sVAERFny/qMX295hgdOFBnQXKTaC0woqev2gxZ/xn1lYwC0SAS7xlICci6zedyUCe2gXhYoFEgVOLc/JvYO6a/1l6mUoKoPvCNSca3p7Z7v29k940nmSssG/xi3bU1iJHm4fRz6nCgWCRfeyu2BT7S742U9QCDAFuH9kRMftsUTbGQocAGgQbpQ6rpk1692uo/2f5nSBk7JRVnnJzN5JlRUIFrgBqoIbEMhJ416/tBtQnKUXHz18SsDFFgiGuQFu/HWCBYJJ3ABX4AYUZ/TJ1gzIKL5AsLQbEFIgGOFQMA0wZf47sr1Ntz68RF386iIAoAG4dmDgxMFZs/5PTleY1K+IwFcoAkpPCahIBJRVG+AqXzwo7EXLmxKQChcPCrPrw6xsN/qcuMWDXEW1ASqqDQgXAdGLBxV+LGFTApUsHhQlAlzBJxU1JQBTipfOaNd3bQkxrRzoAoCqcs2cOYc5z7tcZi/aPc9bYJSPlnsXF5hP3BNeWe97RLBdwH/Y6OcUPmK0mj2+s8AijhV8L3F9AuEdDGMFgibPNx6FFfz+d+d8lf8KVMIHq/zH7rWQDorCf++u+B+tsx89hv9vFvq84Dt1BcM09rFMHCv4AIsJ0DYqahTTKRC83wXerV+EjHdN0AUwdTC9cnNWn5X0IQYDBwDqyLd7eweWzp79Jed5v5b0omBO7WIy6Hq6AZUUCNbeDXAhbkBUgWCYGzA+JVCUgQePFXYucQWC0W5AcYFgmBvgCsYxWdW/AgWCcY5ElBsgRX+u0No46aLNn9IZjETi8QKonBuljqFZs86Rc5+Ur6UvqhAuetW96DX64pf4VVMVCMa9z2rvLlhOgeDY67fa7oKf/AhFgFOQXc7TkTOX6H8ZChwAqFXWPzBw4vDAwP/JuSsU0s8fpjddbAY9GTegQdoFVYkbMNXaBVW3dkEK5Kbkf93mdD1rBCAAoAZcNzDwrKUDA/d60u2SFjtXfjW8i4iKrkTIjg2oky0QVBV2Fyy4we6CYYsHubrtLghTlkOmb9WnGYZ4+I5AOYF/r4y0xKS3qaiffzdm5fXGW8yDJzclEHxkyecUPordBVPdXdAi/rfc3QWXfIit5KcwnsvoJTM/oXsZChwAqJAbpY7r58x5d0b6i6Szwvv5JzLPcjJeV7YbQLtgsRvQeu2ClRYIRv0NpmZ8M09fs6+rnaEIhzZAiOXbAwMn5uW+JNO+YYHLIkRAmBMQvakP7YK0C5bRLjgqApK0CxptgFOdQzau0TmS/p2hSJp8wJTn+oGBw53c5ZJeGPyBjTLmwylvSkCK6xSIe+V6LCUcF0wSj43FvM/Y87LIZW+lwimB4PHDOgXMgucdVfEfuZRwwimB3ccrHkcL+Vgs5HxKVv0XTW8EH//xDzIFANrcMaIDey/ReoaiwCJhCMDPDQMD827YY4+vO+d+JTcR/CfUYrG5Gmuvl1UgOJElh8nUuFdOvpRwafXbqLsLjhfhJSgQbOXdBYPDGF8gCCBp5nC7LmQYcAAgghsXLOjODw1dYNJHnXbvrmUxaWnt3QCLzaCr6QaUXSBY0g0or0CwEjfAK/hjnBtghRvoWPAzqbRAcLJugIVt4JOgQLCUG+C//2MX4gCAJGlHe1b79C3RBoYCBwB8fHdgzxPzQ8N/ltylTq43NBN1FWa8FbsBtAtK9W8XdDVqF1SIG1CPdkGAUaaNeHoXw4ADAGNZ/8DA4XmXucJJLyiZ8absBtAuSLtgqeOFuQEf/gAOAIyzabhNC+ct0U6GYjd0AUxBbhgYmOcymYs909tdgQs0UYtdXD0/fqu4UD5ZNXyBGxDVKWARObViOgUs5Cixry9/g0DUu446N98ruokV5yzCDQiTI4Fz9r1odJ9A9NhkRgfBk8ar/P2dAt744SfGcSwD9wsBN1aqX3BiY2eTUbDi3woyfhvtNJAU6BRQwWPN5x6MLQ3sQgbeAp0gLlSGuQIxMNFw4eTM2AwI/MzqGNZrJV3LUCAApl7Gv2BBtw3lLpDzPqqwef7QwB0MOy5GBChJsEsoAiTaBWkXnHy7IECAjM5EAPiHA1oek9yyOXNPseGRB+XsUsn1KmS996hgE1l7H/LkuNoARYiASS8exO6CPjeA3QUDtQGsi89//v88/cu6j+kAogICYErwvYG9nr1sjz1/bs5udNI+RaHclQjQim//C3sy7YK0CzZKuyBA4Rck6+mNDMNumAJoUW6cPXt+Jtv2CU/e2xU5z+8XAVY0fxz+nJgpAd+T4wz4uCkBSWXWBhRMOgTm0ydTG+AClYLJpgSCA+AU3i44MV1S4n0GSg3KqQ0InxIYO7uxi8GTf0pg99H9+sfMV+UfeCPBKQE3eqzCcZ2oGQhOK5iC9QT+9zAW1D1/nYIVzPU7+aYooqcEosYfprwj+nJJ/8pIIJRbjuXz5vUMjnjny+mjkkXO84ffbzGV9WH3R9xK2CUQ+zpWfjV88jUDSp1VdVcQjOsUSDw2CToF4u6N6hTwQs49bgXBsfdiIecSt0lPoOrflHDlweA7LVpBsOBYFrKC4AfePcyPAhR/KTwtmPM5rZ7qA8EUQOuoWrds7txTBvPeg3K6VFJv/E72EVZ5QU93/HNipgRc4XMSzH8XuAHl1waEn2zcKyefEnClz1kxtQGxz0nwPl3sO434PCfujZsSKK4N8D2zaEqgcNW94LhkQs7Fjb/OxAcStP7D6wQKqz2KpgSCl2zkmgEAhV8Ky+o4hoEpgJbgprlzj7jJ7HJn+n9SoKvN91ManWsWm/oar+Iu/RzaBePHhnbBVNsFmQKA8IzpxZK+iQCApuXG2QvmZ9pzl5jpTf5cLWQKW/EzzxFtdAU/0vHPoV0w/NxoF2yEdkGAgm/CEYwCTllTsnzevJ4RT+eb2cckTS+5lnzE5HhtagNiVgSs+wqCErsLTu3dBd9z/hA/GBD6BWgf1qyZV+hJHABojitWcrfMnfva4bz9m6RFwYw3JhN0hcHGJct4Q9LWsqvhS7gBFpuTN4MbYKUdjCiXpNBJr7Mb4EZfIcoN8MpwA/y2hhWcS9yUwLgb4OtECToFxe8h45sSKOUGYAJAVPKbb9OzJP14Kg8CRYBNwi1z5z7n5j33uk/mbnSB4B/8SY8uqlPoijPJFgIaEwEutqAt+JxyCgTDzahqFwhWsnhQ7Pt0xQNbUYFgycWDSrxPl/AaiHiF8goEfe8ibPEglVcgGHyd+AJB//mFLR4khawbABBB3unAqT4GOAANzk3z5y/I5PVZk/cmN1EpVl7GO0k3oCgHbYICQUUcyZVVIKhkxZMFbkDZBYIl3YDomonAeCqZGzC5AsGQ+XVXnQLBsX+FFQgWugET5xZeIDjuVOAAQLQgXoQAgIZk+bx5PTlPH1TePiipezyshyy4k7ga3hdsGqZAsOC9VFIgKJW/eJCFnGy4qEk4XVJxgWBwAOLHs/zFg6pZICgVLh4UNyWgshcPcr7R9kY/kKjFg4oLBCeudkf9HyTBtA8CABrsmpS7fe781+Y8+7ykvSMzQSdN1g2gXZB2wVZvF2QlQIgBAcA10DjcMnfBc26Td4Vkz4/PHst3A2ILBBvFDaBdUIXDSrvg5NoFcQIgJtuahQCA1Llp/vwF2bw+K9mbFLLHTnQmWBz5Xczj1VBugIUHTiV3A6o3JVDgBlRtP4Fy3YBK9hOovRtgoyLR/9n6bXwrGMdCN8D5bA0LLNhjCeb4o/cTiHYDgvsJAITiNA0BAKlxz557ThvMtl8ozy6SU9dut7SMYFc4JaCo7LUMN4B2wRq5AbQL1rFd8Ak53ZbJZ74l0y/5pYEIEABcA2k4T3J3zJ3/5sGMLpXZXsXxMyY4RmaCVXIDYqYEErsBBT/SKtMNaMbdBWPfZ4vuLhhfIFj33QUHzdw9ltF1tn3XbUuknCSdw88NRNODAIC6cuueC567PGtXyPS80AAZSJJc8oy3ygWCtAvSLtjo7YJylje5n8uzpR09gzdetEHbisS2sRgARNI+1YtEEAD1Cvzz5i3MWOYzkt4kG8+zw39oA5Xg5UwJ+EIX7YJVcQMap10weYFg67cL2l8zyix1nrv6op07d2/pujPabgMABEAq3DYw0Jtp7/qITO+R1GUl898wN6DM+W/aBStyAxq7XTB8SmDKtAuaHlNGN8iy131o+/Y/88sCgABoaJbPm3eilPmqTAujM94SmWCd3QDaBWkXbKB2wa2e7E6zzDUX7djxA1dJPo8DAIAAqCd37Ln3YmXz/ym5YxSaQUeGtxq5AbQLhokAiXbBtNsFQwoEh53TPXnPLe3cvv22C6QhSfpQpV9GBAAAAqBuwX/+3qfI7EopMyOQs0UErZIZb1XcANoF1cBugEWoq6nQLuh7+m9NWpr33PUXbtu+rlrfR+I/AAKg5tw2MNDb1tF9lcxOjc0EY92AuAmC5G4A7YLN1S4YdDamTrugk/uHpOudG7nugi1D/6zJFxMFAIAAqCXfX7hwP/N0q0yHRma8hW5AwimBWDeAdsGJW7QLqknaBTc70/ckd93527bd5wjRAAiAZuWuBQtebHl9T9LsZBlSOVMCJTJB2gUTuAG0CzZAu+CgTLebues7tm2762xpRJIuqMcXFHkBgACoBXfO3/sV5ulGSd2uLJs06ZRAXP4b5gbQLki7YMO0C3py+qVTZpnlbem7tm3bmMqXFAEAgACoNt9fsOg0mX1LbnQMzZWX8fpztiZ0A8prF6ygQFC0CzZlu6Dpz85paS6bu/68Tbse55cCAAHQUty1YNGrZfYt84+fGxMBkprWDahVu2AFBYJluwFTs10wvniyRgWCxW7ARkk3uYyuO3vztvsa6btqOAAACIBqcc+8vY/xzG6Q1BaaIdXFDaBdMHz0pKnWLphKgeDug+yS2R2W0XVPbN5215LRzXcAAAHQmsF/r70P95xuldQZG1DdhAhIlvGW6wbQLliOG0C7YNXcgLxzWuFJS3s6um55y9q1Oxr+S4sDAIAAmCx37rPPXBvxbnFyPYkqoX0/0pNyA2gXDLwR2gVTcQMelLlrrX3k2rM37Fyz+69bm+OLiwAAQABMht8cfnj7hic23Cy5hRMZb8K+6Em6AbQL0i6YUoHg4zJdr2x26VmbNrH5DgACYGqyac3GT8np+Ulz3vDq6dLBjnZB2gVTbhfcInO3y7llfZs3f/9UKd/s312KAAEQABXzgwX7vMhkH4ieL03YF123AsHGcgNoF2z4dsG8mf0kI3dde2fnTU0xrw8ACIBac9vAgb2mXddJLrv7h14R86VlLJVKu2CMG0C7YIjRUhU3wIoea//tKXN9Ppf7ztnbtm1o2S8xDgAAAqASurqHPinLLCyaL41xA5IXCIp2QdW3XdBiRnaKtAs+Jrkbctnc1Wdt2Pa3KfElRgAAIADK5e55i57lTOdH/dw6FzclUJ8CwdJuQDI7eKq0C1ZeINjU7YKbZPqunFt6xqZNv2TzHQBAAJQgk3H/Jikb93M7+jtfBTegfu2CpacEwp8t0S7YNO2CTkNO+qHMXTtt06bbTpWGJenMKfg9pggQAAFQFvfMX/wKyXtJwp/bhnADaBekXdDkHpC864aH89e39Lw+ACAAasESKZNx3mfjg3CEG2AJCudKuQG0CwaHgnbBUm7AX+QySy2fv/6MJzc/wje40AJgCAAQAAk5cuG+r5DZ05JlvMUpN+2ClbkBtAuWVSC4KSN9T2bXvXnz5l8wr48AAEAAVAEnXZg4qyvbDaBdkHbBitsFB01uhTO7dtemTbeeLY1I0lv4ygIAAmDyrFi4+AjJXmAh1X3VdgOmZLtgoikB2gV9z/Ek/dikpTmXufltGzZs41tapgGAAwCAAEj4a/H28cA9lspb0oyXdsHqTAnQLijpQefcslwu960znnzyEb6YAIAAqCH3L1jQvdPp1OIf+vLcANoFaRessEBwtZO+55y79rQNGx7gG1ktUc8QACAASrBTHSdLNiPyRzvEDShrSkC0C9IuWPQ+t8m5m53nLf3Hxo0/XrLb8gcEAAACoK5k7NVxQaCaUwK0C07pdsG8k34is+vaM5mbT12/fjtfPgBAAKTE9/ffv9MN548tnb1K9SgQpF2wFdsF3YOy/LXtmcw1p65f/wTfujoZADgAAAiAODqH8i+SXK8/OJbMBGvqBtAu2BLtgp4ekXS95C09bePGv/BNAwAEQIPh5F5sJX/e03EDaBdsunbBLc7sdi+bvfaN69f+iEV60rYAGAIABEA8Lyw74y3hBlik2KBdsAXbBfNm7ieZjK6b1tb2vRNXr94pSafxvQIABEDjcuNTn9qhbbueLRVutpIs2EW1C1Y8JSDaBZukXdAk/VJOS7ODHd89devKTfyc4AAAIACaiFlbdh6kjOvy//rHBbuSAZV2QYUk0S3TLihPjzrnvpOT943T1q//Oz8hAIAAaFKyLnOIhUS5oO0bzJBLBlTaBSPcgCZtF3TabOaWZcy77tQN69l8BwcAAAHQGr8P3iETYaA4aKlSN4B2wVTdgCq0Cw46p9tNWvrk2rV3j22+A8R/AARAi+Cc2zcyE4ycEmgUN4B2wSq3C3q2e15/WVtb29KTV63ayE8ECgAAAdC6EmCv2PDrmxKorxtgoRk07YJStdsFnen/zOnGjNO1r1m79iG+EwCAAJgazAsLv8ndgFq1CzZugWBpN6Ap2gU3SnaTWfa6U9avvo+vAQAgAKZa/i/NVEywK+0G0C4YLRwarl1wh8lukWWWeuvWrDhVyvMT0OIwBQCAAIihOzrjrdwNoF2wYQoEPUm/lHRtWz53w0kbNmzjkgcAQABIUld8xlnaDaBdsCHbBf/kpKstP/Kd12zYsIbLHAcAABAAhXSUlfFGBC2JdsEGcAPy5uxGZdzXTl7NvD4AAAIgBufkwgNnNaYEGsUNaPl2Qc+ZbnBZfeqk1Wv+ytcaMAAAEABJJMDoUrEWGrSkyRQI1tYNCPUkWrBd0CxOduh35rnzXr1u1S+5lgEFAJCcDEMwERzH4m9UsAve40b/f/iDXcQRQp9T+CjnSrx+ybOIeS9uvEiw5Pt0inmFuLHxvU8X9xxXdCvCpSk8qiQNOrP3/P6J1c8+meAPAIADMHk3wAqWiq2WG0C7YOj7DHFJpFLtgpkHnac3nLRu5R+4ZgEHAAAHoJpeQN3cgOjMvrXcgLAnunLdACc5p7uGhzqOJPgDAOAATDLcRyUK1XcDaBecnBvgpMt/u2bVB5bs7u0HwAEAQABURwhE7jPvTMk7BWgXrEW7oGd22UlPrP4QVyoAQHVgCqAgcEUZ4rWdEnAlXj9+SiD+OeFTApHvs+wpAVejAsHArc++iuAPAIADkJobQLtg8Jzr4wZ8+8Q1Kz/GVQmVYEwBAOAARAf7hBmvP0emXTDCDahuu6Ckn61Zs+fpjplcAAAcgFqJAIvI4aX6FAhKtAsWFAiuc1m98Ww9MMIVCpVbAAwBAA5ASRFQrhtAu2At3IDRJ5qTe8uJK1eu4soEAMABqF3k92UKjeAG0C6ob75izeP38PUEHAAAHID6CYG6uQExi91Mxg1wbvJugCvlBiR4ny7oBpR0MCbuWau2zAe4IAEAEAA1j/suIiLFiQDaBWvTLmhOS17x2GOb+WoCANQWpgB8QchCbsRtjEu7YNXbBf82d+4e39Cqx7kgoTowBQCAAJiMCCgV7KLmy8tbQVDh1QejDy578xzF1waUtYJg8SGKXJJEY+MmREDoOTtd8uwHqPoH4j8AAqD+YT8YUBuwQFBqgXbB8ALBtT3t2e9wPQIKAKA+UAMQCFPFgavwBu2CVWgXLCgQHPUQ/uOoRx4Z5CsJAIADUGcPIG6ZGtEuWON2QS9j3+ZKBBwAAByAVERAY7oBrd8u6JzuP3Hlyr9zFQIAIABSFQKRHeoRkZJ2wcm1C5rpNq48AID6whRATHCyyPXqFDolsPsm7YJhMiBuSsC5LKv+QW1gCgAAByAu2JfOeGOs8jLcgMgceUrvLujWH7fq4T/wVQQAwAFIJd13VqJwjnbBxG5AOe2CTt5v2O4XamYAcGUB4ACUVgBJ2uhoF6yeGzB+Cf6WaxAAAAGQvghwlU0JxO8n4OKDbZEbEP5HpzI6BVyYqGnEAkH7K9cfAED9mfJTAKGL6rr4KYHdj4opECy4EbcxbmSBoFTmUsIWfixX3wLB0KWEYwoEPZd5jK8h1AymAABwABLk/7VxA4rDevluQMlznjhKo7cLFtKR8dj5BwAAByB9EWAh6fuk3ADaBUNFwPgh8vktXH2AAwCAA9Ao+X8wx3W0C5ZyA6KdjfgCwU3O7eQaBADAAUgn/ltMi59/P17RLljtdsFTVq5kAyDAAQBAAKSkAALRK8ocl5q3QFDhUsOnbSqaEhiL4pMoEGQNACD+A6QDUwATC9KOb1Eb9tdg6ky7YOBYVSgQBAAAHIA6x/+CHDTEDSg2x5vZDWi0dkEALAAAHIC0fh9cYfafghtQHNbLdwPisvSCozROuyAAAOAApGMByOSL9xaVQpcolatBu6BFpDCt1C4IgAMAgAOQUvx3o5VoLtwNcKXcgNq1C5a/n0BztgsCAAAOQGouwO70fff8u/Pd1pg/ELitaDeAdsECZyN5uyAADgAADkB9g/94Kfzu/7XR/3Zn/wV/d64sNyDuFdldEAAAcABSi/+juepYdu+7Xa4bUHRrTARYqQVy1FRuQNiZll4ISKFrBgBgAAAgAFJ0ABRZABhbIDj+C0O74GQKBAFQAAD1hymAgAgILwCMLBCkXTD0VSspEAQAAByAOsd+V5wpVOIGhCwjLNEumMgNAMABAMABSDX7L3W7ZLtgeQWCtAsCAAACIFUHIKzK38Va/lZwW6G3w4KgC9xZOjg2134CLv5dAwBAg8AUwJgIsDGD3wpuK3ZKIGAWWEG0Y3dBJZkSAKgZXHAAOADRvw/xln+S2+W6AQpxA9hdEAAAcADqnP2PZb4urArOafIFggVuAO2CuAEAADgADSICSroBCdwB2gXDHxznBgAAAA5AWtE/8D+RbkAZ7gC7C4YMb4wbAFArWG8KAAegZPZfmO2X5QaoDDeA3QUTvCoAACAA6uEA+Fv/fO2AiTcFol0wUpqEPZhCQAAABEADiYBK3YDi3QTZXbASNwAAAOoJNQC7J7qDwSlkTQAbm0UPWzMgYjdBdhcMnpWVVhkA1YUaAAAEQHz2PxqIxwJ7RAFg+u2CVSoQLD6cUmsXBACAVGAKwB82Exb8pdcuWDAl0CrtggAAgANQ/9jvSmfu5bgBVW0XnEK7CwLUAi4yAByA6N+HkAJAVyM3QGW4AVNkd0EAAEAApGUBjAZxl7iqv+Iqf9oFE8oJAABAANQ+/hcH4Dg3IOY27YLjXkAZbgAAAKQBNQC+iGkW0ATxy/hGbCFMu6DfDSinXRCg+rAUMAACoIQFEAywsQFYLrrgr2HaBaVm2V0QAADSgSmACEvfFFEgKDVBu6D/WPVtF4x6FUe0BwDAAWg8BaBJ7uwn2gVj3pZfBFjUvAQAACAA6i8AwubYJyx/G53Ld0UrBhbcrrQ2oNRtmWz0vFxo7UC4EIiaEggP0PG1AdWZEtD41Apzs1AXuM4AEADR8d8lzszLcgMinl/aDQgpEExanxBSIFjkBowZHrEFgsVvomYFggAAkArUAIyFqtg5dke7YNGxVJV2QQAAwAFIL/hHpayl5vVLZv+0C5Z2AwBqCBccAAIgOv5H2+2lbjd/u2Cj7C4IAAD1hr0AEi/7qxZsF0xvd0EAAMABSNkBUIkK+7Hbk8jEaRdU1JQAAAAgANJTAGVV2NMuWM12QYBaQrspAAIgXgAUZNGJMnHaBavWLggAAPWHNsCQOfXk2/PSLljNdkEAAEAA1FcBxATQyL+70ret1DECgbaCAkGX7HYyMRMSuKtdIBgQAk5UAgAApAdTACX67yPn1GkXDBUO5bcLAtQQZpsAcACi439yO512QdWkXRAAAHAA0hMBk66wr0G7YEimXtt2wYQFgtVwAxABAAA4AClHf0XP44dnyZMqEIxzA0rdrtQNUFI3oLICwdJugCKOBQAAOAANmf1rkq16ol1Q8fsJAAAADkC6IiBhRX3hbdoFJ9cuCAAAOACpYP7QNIlMvHSFvSaxu+AkVxBs8N0FAQAAByCd7F/1rLCvpLagzHUHnEuc/Ve29kFR/q/C1X5wAwAAEACNrgBKB1DnaBcMFSeFob+SdkEAAEgDigDHA1G9NuRhd8EQzwAAAHAA6h37w63uxIVxjdAuWC03QGW4AVVsFwQAAByAdLL/mO16492AZFl0okw8tXbBmALBOrYLAgAADkD9BUBgnr7MLLrp2wVdw7QLAgAADkB9478/+099Qx5Nol1QE09sknZBAADAAUhTATRghX2FtQVN1i4IAAAIgBQFQJJgVu92wcKgHrzdMu2CAACQCkwBFE0BRBcE1rddUFVq1Yu5rUbYXRAAAHAAUsDKtL7LK4yLyaLZXRAAAHAA0rUAAkVtcW5AzO1wN0BV3tlPLdkuCAAAOAApxP+Cef2S2b9oFyynviFBuyAAAOAApOYCJMpg5ZK36jV0u2Dtdxccr29I6AYAAAAOQP0dgIIsuLkq7CvcXVCN0i4IAAA4AKll/2rCDXmiHIrgbRu97UrVM1Sr2yHODQirHQAAAARAuiIgPKDWPYAmbhdUlXf2ixc3NRUzAABQd5gCULKFfCbVLthsuwvWtV0QAABwAFKJ/9EtbbEtbuW0C1Z5d0EXlnk3a7sgAADgAKTqAoQVysUVxkVm/6Wz4sm2C1pLtQsCAAAOQFrBX2E7AZbhBljUMdSk7YLJ6xUmvbsgAADgAKQW/+WUZA698HbrtgsmWcinSu2CAACAA5AGJjeajFqBG+Crtp9MJt7s7YLVcgMi3QEAAEAApGQBWFiL3XgATlAgSLtg5WIGAABSgSmAcRGgCRs7EJ0SWOPVahecirsLAgAADkA6sd8FMlOLWrEuqRtg7C5YXrsgAADgAKSU/RdmphMZdGGxWnO1CzbH7oIAAIADkKoICGbbNha6CufbaResbrsgAADgAKQT+0Oy0kI3wDnaBUu1C1a8uyAAAOAApCkC/Nl8qBsg2gVr0e0AAAA4AClFf8VWtJd0A1zyrLqcCvtquQFK6gaUt5BP1TZHAgAABEB6AqAwaBYU/xWIANoFVbV2QQAASAemAJyC1rdUbIeH7NbXSu2Cqe4uCAAAOACpKYCiorSwrLX4vlZpF0x1d0EAAMABSNECCM/UA1lrXIEg7YKBcyg6Rly7IAAA4ACkgEW28pVyA2gXrEq7IAAA4ACk5QCYM7miVr64OgDaBavXLggAADgAqYoAX+YalcHSLqjqtwsCAAACIKXg7w98Flq8V3DfeNCkXXDSYgYAABAA6cT/4gBtzhd4o4KbkgmD6Pn0RtqQp8xM3pVe9je5mAEAAARAmiLAJXUDaBesfrsgAADUG4oA/VloSPGejRa9jYVQ2gWr3C4IAAA4AOkKgAiLfDTDpl2wVu2CAACAA5Ba/A9ZpEbhbkDTtguGZOqN0C4IAAA4AOk6ACWq+scz+GZtF3RqzHZBAABAAKQrAkoFbdoFVRTkg+dZWYEgAAAgAFKJ/U6l6wBEu2DN2gUBAAABkFb2Hxq0I4QB7YKqarsgAACkwpQvAhxdsd5XpDZxb+S69bQLVrddEAAAcADScACCWbMUbddHZc+0C1beLggAADgAqcT/sXS1IGsedwPGHlfoBtAuOLl2QdoAAQBwABrABfAX0lkZxXuh2TDtgqHuQNANoA0QAAAHIO3g758ft7GkttAN8M/jx7kBmkiL3airUDQHH+cGBJ8/4QaMViskcQNiMvNJuQGmoCtR5Ab43pfPWYmtTwAAAByA1OJ/YTZf2FYX1xUgiXbBsHFK2C4IAAAIgNQUQMwiPLEtbS3ZLqi6tgsCAEA6MAWgMMvaH8/iCgRbsV2wQAvVul0QAABwANIVAUndANoFy3YD4twBAADAAUgn9kcU3ylsAR3aBeMy+Um1CwIAAA5A3bP/sMy3xBw77YKqYrsgAADgAKQlAgqy6oAbEDbHTrtgSTeh2A0Ic1cAAAAHIJXYHz/HrtCsWrQLVtQu6CLGCQAAEAB1xiRZGcV7hUGbdkFp8gWCAACAAKi/BTCafavkHHt40HbhbkDSqv4IYWFOCd2AePESWH5XIUE/SedAqLiJWegnTki4sNcFAAAEQCoCwBfkEhbvtUy7oKtCu2AZ7YNG9g8A0BBQBOgUKLTbHSgLCvLiiu9oFyz5+EKtVdQuCAAAOACpKICQOXZLMMcedANoF6y4XRAAABAA6VgA4cHORgNvpVX9/uAeWVFfMmgnKRAsX1hMBHAXMw4R8/phm/ok3ASILgAAAARA44qARG4A7YJVaRcEAAAEQDqxP8ZKLygQpF2wRu2CAACAAEjNAUhihSsk6I4HaNoFK2sXBAAABEBawT+2JS7EDQgEbdoFC2+X1S4IAAAIgHTif2UZr8W5AWHCIEZYhLsByav6A8KkxFRGEmERWLQngSsyuQJBAABAAKQpAhJlvLQL1qZdEAAAEAD1j/5KUrxHu2CN2gUBAAABkAaBqvzQoB0T/GgXrLxdkOAPAIAASN8ACBEBSar6aReMCfpJNwUCAAAEQGoKQMW97BFZNe2CVW4XBAAABEDKNkAJN6BF2gXDXiPFdkEAAEAApBT7w4NnoCp/Ehlvw7ULukZrFwQAAARAWtl/jBVe7AYkyXhpF0xcIAgAAAiA1EVAhBUeqMqnXVDVbRcEAAAEQFrBvzB4hk4J0C5Ym3ZBAABAAKQW/11M0E5SIBgXtGkXZAoAAAAB0JgKwKmsjJd2wWq3CwIAAAIgNRsg2Tw+7YLVbhcEAAAEQGrBv4Qb4BztgrVqFwQAAARAevHfKd7+j3MDaBecXLsgAAAgANJSAEVZf1igC8uqg/fRLqgK2gUBAAABkAIWmvW7GHFAu2BV2wUBAAABkJYDYH4hUDLg0y5Y3XZBAABAAKQT/1Vkl8fVANAuqGq2CwIAAAIgPQXgC+xFbkBsgSDtgtVpFwQAAARAajaAC3cD4goEaRecfLsgAAAgANIL/tFuQGzWT7ug73wm0S4IAAAIgHTif3Rgjy8QlGgXnGy7IAAAIADSUgAJAjvtgqpRuyAAACAAUrUBSgd22gVr0C4IAAAIgPSCv8rI5GkXrG67IAAAIABSi/9lFPfRLqjqtgsCAAACIC0FUE5xH+2Cqmq7IAAAIADStQGSFveFuwG0C1baLggAAAiA1IJ/iYw9QWCnXXAy7YIAAIAASCX+l18DEBXYaRdUWe2CAACAAEhPAVRcAxB+DNoFy2gXBAAABEAalN/Sl1Qc0C6YvF0QAAAQACk4AJNq6aNdcDLtgsb1BwCAAEgr/mtSLX20C06mXXCIryAAAAIgPQVQrZY+2gXLbRfcxfUHAIAASNkGqEJLH+2CKqdd0Jk2c+0BACAAUgz+4cG3/Ja+5IGddkHJMm411x8AAAIgxfhfgx0A2V1QJdsFnVvJVxAAAAGQngKoyQ6A/qCX9NiaUu2CzuxBrj8AAARAyjZAjXcArGqBYIu0Czr3J649AAAEQIrBXxFZcImMvcrtgtZK7YKKFhZj73E4637F9QcAgABIMf7XOWOfCu2CrmS74D+O/eFXKAIEAEAApKgAar4DYNJjayq1C97FtQcAgABoABugnjsAJhcetdlPIC5o16ldMKvbuO4AABAAKQf/Ell1LVv6al582JDtgmv7Ng3+jGsPAAABkHL8TzNjTx7YJ198GOYGpNEu6K599gNXjvD1AwBAAKSrABoqYy997CZvF/Q8c1dx3QEAIABSpbEz9kkWHzZku6BuPfpHX/wbXz0AAARA6g5A42Ts5QmPJmwXNM8yl3LNAQAgABoh/jdOxl714kOpwdoFlx39oy/8mq8dAAACoDEUQKNk7K3dLjjoMvmPcr0BACAAGswGaISMPe12wYLHVbFdUHKfPOqey//BtQYAgABooODfDBl78sBe+VSGU43aBR/o2/jk57nWAAAQAA0W/5sxYy997AZpF9zuMnYaff8AAAiAxlMATb/AT5X3KggrEJQqaRc0OZ35krs/91euMwAABECD2gDNlLGXJzzKn8pwKrtdUCpyA5zs4pfefekyri8AAARAc7gBDZ+x17H4MGm7YEGBoJmuPuqeSz/NNQUAgABo4OxfybNq2gVVql3QSdfc9/yOd7gxzQEAAAiAxhUBrvh2M2bsqbcL2ld+9rz2M5csWeJxXQEANC5txH758tTAjdEAN3rb/H8bvX/3ovcymdx4Bjxx/+7HlzhG4P7iY4Qf28o6v5LHLvv8xh5mEzecy3mePnjM3Z+5XHfxxQIAQAA0gwIYD3T+zNkXCBMEdhvPgZMF9vD7w4Nv0bFLBPZyhEdJ8RJ37PHjZtY60xuPvnvJj7meAACaA6YAAkE+5L6AUBDtgoVTAhl3Vy7ffthL7yL4AwDgADQXud3j4M92C4NdlBvQ6Bl7eVMFZU5lrHRy73vpHRfT5gcAgAPQfJj0ZHSmX8INmJrtgjuUsU/lR3oOeumdBH8AAByAJsXJPSnZQFGAl02uQLDxMvaYYycoPpQbkfTN3LBb8rJ7Pr6Grw4AAAKg2dlUbPUrGBTH/1RGgaDv/vgCweLAXs5UQR2KD805d5Ny7qNHf/8jf+NyAQBAALQKf5L0nPAsv0puQJO2C5qXud85d9HRt3/oPi4TAAAEQEvh5H5rsjOLMv9qugHN1y74oMktOfaODzPHDwDQokz5IsC8028ntrFVcdAPu69l2wXtUTn31l88a+hpx95O8AcAwAFoYbrWPP7r4b0WrpPcHsEWwLHAaBEioKXaBTeZ9Ln2LUNfOuqnSwZ1G18MAAAcgBbnqJ8uyUljIc+/o52C2XGYG9D87YI7XcZd1uY69jv2tosuO+qnSwb5SgAA4ABMIbxlUuYdE3FxNLNO5AY0Zbug56SbRjTyweNv+fAjfP4AAAiAKcmWXP+P+9q2/9XJDizKvC2kGLCZ2wVNK1zW3n/0TRf+gU8eAGDqwl4Akk5ddmrenF1qYVZ/zQsEfffHFgi6ZMeInir4b3PZFx1z6weOIfgDAAAOwChzpueu37C14xPmtK8Ls/rr4QbUol3Q7EEnfeSYW95HaR8AAOAAFPLsK88ecVm7YHcodUrHDahqu+Aqc5mz2zdvfQbBHwAAkkSvKc3db7z6OzK9bmKALORRVlwPGPq4pI8de4wVP8Z3vys6noW9znZz9oVel7/syGXv28UnClOZv/w/Z4wCRHHQL2xKx0CmAAoVUbbtAsvljpK0x5gbUCwEkk4JjD3WCv4U0SlQorhvvJo/vEBwUM6+6rncZ1+27H2b+CQBAAAHoEzuet03j3BZ+6lMPcHBmowbYCF/spjHRLsBLvjanuRuMudddNyy8x/m0wPAAQAcAATAZETAG795ijP7jkLqJEKFgMUE/UqEQKzNP37fCiddeOyy8/6XTwwAAQAIAARAlbjnjVefY+a+IlkyEVAvN8D0KydddOyyc+/lUwJAAAACAAFQCxHwhm++Sk7fNrPuZCKgdm6Ayftbxuljx3z3nO858cMGgAAABEDl0AZYguNuOONWyb3Mya0q1Et1axeU1ph0Tue6dU899rvnLiP4AwAADkCd+OEpX+/Ptbd/zsmdFZbh16hdcLsz99Vc++BnT7j+gq18CgA4AIADgABIibvf8K3XyNlnZDowLJhXqUBwSOa+nrfsp09YduZ6Rh0AAQAIAARAA3DjKTdm+9p3niZPH5fz9q+aG2B60jn7utdmX3rZ0rPXMNIACABAACAAGhCTubvfcPX/cy5zmsxOkTS7Ajdg0Mn7kSfdNrQz+52Tbn/bNkYWAAEACAAEQDO5Aplth7qse66Znuuk/Uya42RzJPVIGpS0RdI2kx50nvcHc+6Pnfmhe49adt52RhAAAQAIAAQAtAx2+pKunTvWvjS/fccLbfvOZ2hoaG8bGp5rXr7bcvnusWkQG13vILDiwahbUvT/reBxo9MrxY8LHtEKXmvi/0+8VuBxUccIe62oY4S9VqC1M/hao0s7ysb/ZrLRczDT+N/GxmDscTb26LHH+l7Ls4n7x+4bu+35ztgbPQev4LzM/I/zxv/t+d6b53/dgmObb2w837s2879P3+v6jjV2Fp5vvGz8TMYHePy5E6+/+/ZJh1E7CwiAKNgLAKof9LUks+NVK1+nzVvesvW3v3yhciPTJhY2NJGSVTCmVsnnkMqHPxVeEgABABD4IT7lvd07d225aPuaX7/T/j64J7/MzRfaKnlFI+gDIABg6rLjpLedvf2ff/2Uhobn8OOcXmCzFn6feEcACABoIHa98bxFucee+I73j0efx2ikFUytguekEcDJ9QEQANAS7Hz12SfnHnzoGxoZmcFoTA2p0QzhG8kAkAz2AoCK2H7imR/K//2h7xL8WzuwWSrnWYnQIOwD4ABAzdnx8tM/4z302EcYicYP+tbAz5n88wn6ADgAUL/gf+IZH/UeWUnwR2g05WsCAAIAKmDna9/5eu/hlf/KSDReYEzHqgcABAC0PINvPGdx/p+Pfl1mWUaj1bN2ayihwfQAAAIA0gs0Lvfo2u9oeKSP0WjuoJ+sWM41adAHAAQAVJVdJ739fHty6xGMRJOKhiaJptYkbYYACACYGsHjzA/25h9bdTEj0VwBvFmydtr3ABAA0KDsfGLthzU8MouRqH8+3AzZcBqbFCEZABAAUOsf97POavfWrH8HI9GoIT+dDLp53AUAQABARexY671Jw8MDjARCI52dCakJAEAAQDps3vImBmHqhv1mad8j6AMgAKCa4eKsJT3asu35jETzZu3GeQJE41wOAQAQwq5N615muVw3I9FcQb9ZAnh91jMAiCHbNoQAAAjB27H9XxiFqZFBV/SaxF9odgMgk92JAAAIY/vOZzAICI3UhUbdXgmmnADIZgcRAABhP6GDQ3szCq0WwK0uz0njvQGULQDa2p9EAACEfTmGhvdkFFog6FuTnCdhH+r9G9fRsxIBAFD0Y7wkY16+h5FogM8ihZX2miVrRzLA5ARA56MIAIBCztw5TVawJRy0dGhLw11goR9INfi1dyAAuAygiGm7hhmE5gr51jTnSdCHBnEAeqb9EQEAUPjF+PKXh1gkoxlEQ5NsGNTCggia9DfOufxIT9vPEQAAYXS0b2YQWkcqIDQA/Nl/70MHfPlXWxEAAGFfkI6OJxiFVgjfrR1MCfpQCdlp/b9nFBAAEKmQu//CKDRvYGuWJX0J+pCKAOjp/QmjgACAqB/ZaT0PMApk+gRwaMH0xvO6p9/EOCAAIOpHelbfHYxCa4qGSbsLrE0AzZz99878/eKrfrWWkUAAQAS911z+Z9fTtZKRwCkgmEJLBb2+mT9gFBAAUAI3e+ZtjEJrBP367R2QxnkCJP1Rc9Y5Z+7VDAQCAErg7TnwH3L8vqYW9C3d59dP3HCJQX3I9g/cv+Cr9/2NkUAAQAl6r7n8z27WTKplW9wpmCruAkD77D3I/hEAkFgxz53zaX57GzuEWwu/N4Bq4Tq6No70L7yekUAAQEK6b/zaT9zAzHsYiUbL2ptkw6AmfE1o0ex/z4VfP+DLdw0xEggAKIO2RQvf7dqyOxmJ5s6fW3mhH4I+xGb/be1bra/3c4wEAgDKpOvaL/5Ne8//FCPRjKLB6vKcNAI4QR8SJzF77n31flc+sIWRQABABUxffvWlbvYspgJaNBsmmELrZv+dmzrnLPo0I4EAgEkwtHDPUzV9Gi00DRj0W1mcIFRgMrQvWLxkwVd/tJGRQADAJJh9/Ze3Zg9c/BLX3fUoozE1g2llywBb040NtAbZ6TP+tO/1D36FkUAAQBXoufbyVW1PWfgSN637YUZjaggN3hs0Z3TL5DoXHnCu49JAAED16Pr2fzxkBx74PNff91tGozWdgmZpMwSIon3evv++91X/83NGAgEAVab3us+vm3bs05+bmT/3SpYLbsCgb01ynogGqAHZ6TP+tPjgBRcxEggAqBFuyZLctB8sPdsdsv/xblrPI4xIFYNpC2+5y9r/UFPa2nd0LtjvDW7JT3MMBgIAasz0G//znmnPXXSQ23fhR9TRvpURqV84nSoZNJIBkmUlzroWHnj23t/4zZ8YDAQA1Ot79+UvD02/45uXuGccemBm/txvKONQ3y2VtTeHuEEoTG3aF+5/2T5L/8h6/wgASMUN+Na/PTH9B0vfnn3qwc9xA7N+xIjUIoA3x4ZBBHCoJ217LLhlvxv+9mFGAgEAKTPtO1/+Xe/Plh2dOXD/17ie7n8yImkEU5b0hSkS/Gft+eMn5+zxOkYCAQANRO8tX7+59zdHPMXtu/d71d6+mRFp7GDaLAV6iAYYIztzj3ttn8NOePaVD4wwGggAaDCclnj9d37rCh152H5u0fyvuUxmmFFpnMDWDFm7I+hDeOb/k64DFh/PNr+Vf68A6srWN737QHts1Rfy6zeeIJmTxtregvmnjfbCFf1/K3icTKP/V/C44BHH/j32Wv5AZhbyuKhjhL1W1DHCXmviAPJGHznxvkZv2+6/qfDf4883ef7bo//2Rl/PGz9vk9nE48Zea+y8PN/Z2eh7KHzs+Gv5PqOxY1jBeXk2MQKeJt6jzPe8sWeNnlfxe/Mdz6c4Ch838T6Kz3fs368+jKaUVqV9z72/vfjmR9/sNHGZAA4ANDh9S7/01/6ffe8V2WcefILr632QEWnNrL1Y0lV+ntbg7xPqmbY6a5+/32X73fzoaQR/BAA0Kf03fO3uGb9afmjmgEVnq7NjHSPSIkqjQU7T4W+2Xuxv69jaud+hp+134z8+xGggAKDZv9CSzbj9miu9w5+5f3af+Z9XNrOLUUk7a2+N82xDALRWsJo+4y+dBxz2vH2v+cMNjAYCAFqIOVd/btuMu799Yfthz3x6dq89bpZzU9bJnew6/vVaRjiV7YjL+XHLMBnQGllCZrhj/uJ/37po8dP3ueq//48BqWoCBtB4bD75rKO8lSuv8LZsf/pUKwL0Cv4WWgAXVlSn3UWA/kI+fxFg4BhWUBQ4fr5jhXdWXCxYUATo+d7b2HMKiwAnCv5s9BwKjx323ibGqbAI0D+Gnm9Qg+9t97+7O0zHPXUbX6ZmzlB7Z/6ha97+b9v76v/5DaOBAwBThJk3X/mTWf/z/Wdm99/nPHV2ToH6AJbKrfZoduAANG9g6uxe177vIe8/4O5NzyT4IwBgCuIkm3XntV+b86z5i7L7LPyU2tp2Tu2Qn85CPY0wPVDJ8bo7KBBvuu98W/vWjoX7f77vWS9YvN/SP3/R0dRR699YgOZgw1veO99Wrvo3b9Xq15lNiNdmnQII9tvb+GsVTgH4++29Iqu+9BRA0ZSCSk8B+M/fCqYDoqYACu37YM9/6SmA8b/5xtcLOd+xI8RNAZik/QZG9PSF1JQ2RSbaNW1ldmDe1erv/eJ+Vz6whRFBAACEC4HXn/fc/MOPXmGbn3xeqwqAwsVuyhUAnu/VkgqAsXOopwDwi4+kAiDwtxgBcOheQzpgLgvENW70cbls/8Cv2vaY/9V9vvm779LTjwAASC4EXvbG0/Nr1n3a27VrPgLAF1DLEADBYzSuAPAKXjuJAHj+4l2a28/y8A0Wcrxs74w/Z2fMvtX69rxqvyvve4wxQQAAVISdf37n+oe3Xug99MiF3kiur5kFgAWW8U0mACwsoNZYABQG5SQCYGxs6ukAnPC0bepsYwo59SDT1rkpO2P2fdnemXfnp/fdtP9/3s+iXwgAgOqx7vRz5+rRtZ/Or177VvO8tmYRAJ4vhCcVAIH1+eskAELX+C8hAMJa88oRABYzZRElALzRB/e0m449lBbAtLL8zLTev2d7Z9+XnTHzlkXfeOAu7H0EAEDNWf+6s56Ve2TVl7xNm1+AAAg/XmIBYCU2+amBAAhzR/yvFSYAikSEmfbqy+m5++3kC1GvQNLesSU7fdavs/0z7sz3zvw2WT4CACA9IfDyN79+ZOXqS70dOxchAJILgEBQbmABULijYKEAOHSvIe1PAWDts/wZc1Zk+mZ8b5+rfnMvLXsIAICGwc46q33tI9s+kFu56oMaHpnRbALAK7DhkwgAz4K1AkkEgBWcQ7kCIBCUEwqAqOy9WgLgpQfvUG9Xni9BdbP8J7PTZ/2GLB8BANA0rDnl/Dlu/apLRlaveYs8a29kAeBf4jepAPC/Vr0EQFhXQCkBkMS+jxMAVrhkcMQxejs8vfQQ5v/J8gEBADDKEyed/rT82nVfzK/fdHRjCQCfJZ5QABTuBVCuAPD8a/w3gQCwsP0QIo6xePYwCwBVIcvvmjVw/V5f/vl6RgUBANAyrH3V6a8aefixz3nbdxyQlgAIroJXHwHg+d5HUgEQvclPMgHgH5t6OQAv3H+HZk/PcaGT5QMCAKAYkzJrjnvdBbnHV3/choZnNYMACKzcl1AAWMhugKUEwFjQr1QAFE1XJBAAgfcyCQHQ0+np6IOx/+PItHduzvTNvj/bP+P2rhmzbiHLRwAATEk2nnZa3+Dqwc+OrFz1DuW9jkYTAP5zSCoACtfMr4cACPbwJxMAxYsGTV4AHDx3SAfMHeTCJssHBABAMla98swDvSdWfym/YdOxJnNpCoDxKvsyBMD48SoWAL5OgiYVABknHXPINnW2s+aMP8vv7J5z87wrf7qBbzkgAABieOLEN79kaOXqK7wtW59WTwEwbonXUQBYMPQnEgDBc6iPABgbg1JFgAtnjuiwRVNz8R/nXD4zfcaD2Rmz73HT++8kywcEAEAFmORWHfv6d4ysXPmvtmtobq0EQGDL3goEgBcmKGogAMaCd6UCwL8ZUFIBEFgwKIEAkDMd9ZTtmt49dXr/XVvnpmz/7F+S5QMCAKDKrDvl3OlD69dePLJy5bmWz/c0ggDwfK+VVAB4Bevl10MABIN6MgEQ5jz4XytuCmBu/4iO2HcHWT4AAgCgejxx4pv3HVq3/vLc+o2vNPNc/QXARIiumwDwrdyXVAD4tzSulwAwk5yTXnjANvX3tF727zq7n2jrG/hFprf3B+19c29a8NUfbeQbCQgAgDrz+IlvflHu8ccvzz+57bBaC4BgllsfATB2DuUIgPAe/toKgML9BBbNGtbT926Nuf/CLH/fq37zU755gAAAaBAePe6UN488tvpS27VrXjUFgHm+4FiBAAj8b0IBEFgwKKEAmDiHygSAP3tPKgAKNx4a+1vWmV56yDZ1tDVv5b/r7HmirW82WT4gAACawg045ZRub/3wJ4ZXrj7fcvlplQsAbyKA1kkA+DPqegmAsbEpRwBYyPkWCoBD9hrU4j2arO/fZYYzvTN/39Y/816yfEAAADQpD59y7lxb9fDn86vXvd4zL1sPAeDfDCipALCIgFpLATBxfrURADO68zryKdua4kfMn+W3DSz43sLL79nEtwcQAAAtwKOveuvhI489dkV+45MvKCUAvECvezIB4AUCbTIBMD7fXqEAKFxzIIkAmAj01RUAhVMAbc70woO2qaejQQv/yPIBAQAwxYTA8a9/7fBjj1+W375j8WQFwHhwrqMAGHMmyhEAwQWJyhcAXkFmn0QAPG3+Tu09MNRYP6ZdPWvaemffT5YPCACAKcpvDj+rfeb0NR/OrVrzfm8411eOAPAH1EoEgFewQU+jCgDPNyDlCoC5/cM6bJ8G6PnPZIcz02eQ5QMCAACCrDnljDk7V6+7ZHjV6rfI89prJQA8f9BNKAAm9gKoTAAEFyhKJgCKREQCAeDfC0Ay9XXn9bz9tymbSWf9G7J8QAAAQGIeetkbnp5b98QXchs2HR0mAMYDaBkCwB9Q6yUAAj38dRYAZlJ7m6cjn7JV3fXc7MeX5bf1zrhx7//69a+5ogEBAABl8c+Xv+7k3EOPXTayY8f+EwVwyQVAYVtdPQRAYUFgEgHgf1wlAsBCdgNsc6Yj9tumvp5cXbN8r7vru/td+cAWrl5AAADApDAp89BLXnXBrkdWftxGhmeVFgA2vhFOJQKgeNGhBAKgcI3/BAJgfI2BCgWA//iFAqDNmQ5fvF0zpo3UPsvvmfndva/+n99wpQICAABqwt+PP61P2zZ/dnDlynd4ea8jbQHgr8xvJAHgnOlZ++zQ7N7hmmT5rrfvtp4959089/M/2MFVCQgAAKgb/3jlm/YfWrXqSyPr1h9vnpx/7rwcATDej1+GAAjm/+ULAH9lf1IBEPhbCQGQzXh6xj47NHv65IO/y2aH3LQZf2jrn3lvdvqs7yy66lcPcPUBAgAAUudvJ7zhmF2PPPrF/JYthzayAAhuBpRMAESJiDgB0Nnm6bDF2zS9q/I5f3+W3z7Q+72Fl/9yF1caAAIAoOEwyT34ohPPH1q56mPe4NCcMAHg3wugEgHgb6tLKgBCF/EpIQACr1WmAOjtzOsZ+25VZ5nV/r4s/27XN/Dtfa/85V+4qgAQAABNw19eeWZvftPai3c+/vi5lhvpNitcLrc8AeAVLLmbRAAElvitowDYs39IBy/crqxL1udPlg+AAABoOf7w8tcszj+x8fMjT6w9yTPLlCMA/KsEJhUA3kTXYYUCIMJtiBEAY4/NONNT5u/QXjMHyfIBEAAAIEl/Oe7Uo7Y/9ugVI1u2PD1OAEysr18/ARBY3TChAJjY5Gj37RnThnXggu3qjtjYx3X1rGnrH/hxW/+sWzMzuu4kywdAAABMKX7/4le+dfCxxy7JDQ7uNW61+7bfrZcACBUhJQRAmIjIZkyL99ipeQM7I7N8zdzj+sX/8Yu/8ukDIAAApjSPn3JK99rHNn9yaPWad3q53PRKBMCEcEguAMI3A6pMADhnmjtzUIv22KH2tt1Hc53dq9v6B36c7Ztxa3bWtO+T5QMgAAAghN+9+FUzcoPbPzG4cs07vdxIdy0EQOndAMsTAM6ZZvUOa9+529XdpUE3fcYfyfIBEAAAUAG/Oe7kvbyNmz44uG7DW/PDQzP9AsC/F0C9BEDYdEMma5rTv0t7zdX6vrkzf9DWP+tWz/rv2PdbPx3kEwRAAADAJHj49NO7Nvx9zTsHN2x888iWLYd5Zq4SAWChj40XAOZbYsj/Wj1deW+PgczDex7Uf930/unXL/zGb//BJwWAAACAWrkCJ77moOH1m88a3rj5uJFt2w7yPMvECYDAroGJBUCY3W/W1a3B/v62P8+c2/df7oCubz77ygdG+EQAEAAAUGf++/iTF9jW7acMb93xwtz2Jw8b3jm4yMzc7g2ErCwBEFzi12Qma+vpeqKjt/+32b7eH7u+6be+YsWdDzHqAAgAAGgwfvXqt8we2bL5ObmdOw/L79p1cH54cC9vOLenNzw8Kzcy0iu5TD6X6zHznGtv22lyeWXczkxHxybX0bHedWSfaO/u/lumq/OBjhl73HfU8hs2MKoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA1+P+QZjYzIkqW6gAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0wMS0xMFQwNDo0Njo1MSswMDowMPZJ7CoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMDEtMTBUMDQ6NDY6NTErMDA6MDCHFFSWAAAAAElFTkSuQmCC" }))), oe1 = (e = {}) => /* @__PURE__ */ y.jsx(FA, { ...e, children: /* @__PURE__ */ y.jsx(KQ, {}) }), se1 = ({
  fontSize: e = "inherit",
  animate: n = "spin",
  ...i
}) => /* @__PURE__ */ y.jsxs(
  F1,
  {
    fontSize: e,
    lineHeight: 1,
    position: "relative",
    display: "inline-block",
    className: "outer-box",
    width: "1em",
    height: "1em",
    children: [
      /* @__PURE__ */ y.jsx(
        Me,
        {
          ...i,
          icon: "cloud",
          display: "block",
          sx: { fontSize: "inherit" }
        }
      ),
      /* @__PURE__ */ y.jsx(
        F1,
        {
          position: "absolute",
          top: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          height: "1em",
          width: "1em",
          alignItems: "center",
          children: /* @__PURE__ */ y.jsx(
            Me,
            {
              icon: "arrowsRotate",
              animate: n,
              sx: { fontSize: "0.4em", mt: "0.15em" }
            }
          )
        }
      )
    ]
  }
), Tm = (e) => /* @__PURE__ */ y.jsx(uS, { color: "secondary", variant: "determinate", ...e });
Tm.displayName = "ProgressBar";
const YQ = ({
  value: e = 0,
  label: n,
  labelProps: i = {},
  ...a
}) => {
  const s = n ?? `${Math.round(e)}%`;
  return /* @__PURE__ */ y.jsxs(F1, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ y.jsx(F1, { width: "100%", mr: 1, children: /* @__PURE__ */ y.jsx(Tm, { ...a, value: e }) }),
    /* @__PURE__ */ y.jsx(F1, { minWidth: 38, children: /* @__PURE__ */ y.jsx(ne, { variant: "subtitle2", textAlign: "right", ...i, children: s }) })
  ] });
};
YQ.displayName = "ProgressBarWithLabel";
const QQ = (e = 0) => dz(e), XQ = H1(Ke)(({ onClick: e, theme: n }) => ({
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
  // Add Custom Styles when interactive
  ...e ? {
    cursor: "pointer",
    transition: n.transitions.create("background-color"),
    "&:hover": {
      backgroundColor: n.palette.divider
    }
  } : {}
})), Lm = ({
  filename: e,
  mimeType: n,
  size: i,
  sizeFormat: a = QQ,
  progress: s,
  onClick: g,
  onCancel: c,
  onPreview: I,
  previewButtonTestId: h,
  onDelete: m,
  deleteDisabled: w,
  disabled: S,
  iconProps: T = {},
  filenameProps: D = {},
  sizeProps: k = {},
  cancelBtnProps: z = {},
  progressBarProps: N = {},
  uploadCancelled: W,
  ...K
}) => {
  const V = V2(() => a(i), [a, i]), Y = h2(
    (Q) => {
      rA(Q), c && c();
    },
    [c]
  ), H = h2(
    (Q) => {
      rA(Q), I == null || I();
    },
    [I]
  ), Z = h2(
    (Q) => {
      rA(Q), m == null || m();
    },
    [m]
  );
  return /* @__PURE__ */ y.jsxs(
    XQ,
    {
      minHeight: 42,
      bgcolor: (Q) => Q.palette.background.paper,
      border: 1,
      borderRadius: 1,
      borderColor: (Q) => Q.palette.divider,
      px: 1,
      position: "relative",
      overflow: "hidden",
      onClick: g,
      ...K,
      children: [
        /* @__PURE__ */ y.jsx(Ke, { direction: "row", flex: 1, minWidth: 0, children: /* @__PURE__ */ y.jsxs(
          Ke,
          {
            direction: "row",
            flex: 1,
            minWidth: 0,
            alignItems: "center",
            gap: 1,
            color: (Q) => Q.palette.common.neutrals[600],
            children: [
              /* @__PURE__ */ y.jsx(F1, { sx: { display: "inline-flex", flexShrink: 0 }, children: /* @__PURE__ */ y.jsx(DM, { ...T, mimeType: n }) }),
              /* @__PURE__ */ y.jsx(
                ne,
                {
                  flex: 1,
                  minWidth: 0,
                  noWrap: !0,
                  textAlign: "left",
                  color: (Q) => Q.palette.text.primary,
                  ...D,
                  children: e
                }
              ),
              /* @__PURE__ */ y.jsx(ne, { textAlign: "right", noWrap: !0, sx: { flexShrink: 0 }, ...k, children: V }),
              I && /* @__PURE__ */ y.jsx(
                k2,
                {
                  variant: "text",
                  size: "small",
                  startIcon: /* @__PURE__ */ y.jsx(Me, { icon: "preview" }),
                  "data-testid": h,
                  onClick: H,
                  "aria-label": "Preview",
                  sx: { flexShrink: 0 },
                  children: "Preview"
                }
              ),
              m && /* @__PURE__ */ y.jsx(
                k2,
                {
                  variant: "text",
                  color: "error",
                  size: "small",
                  disabled: w,
                  startIcon: /* @__PURE__ */ y.jsx(Me, { icon: "delete" }),
                  onClick: Z,
                  "aria-label": "Delete",
                  sx: { flexShrink: 0 },
                  children: "Delete"
                }
              ),
              c && !W && /* @__PURE__ */ y.jsx(
                ym,
                {
                  icon: "close",
                  disabled: S,
                  title: "Cancel",
                  sx: { flexShrink: 0 },
                  ...z,
                  onClick: Y
                }
              )
            ]
          }
        ) }),
        s !== void 0 && /* @__PURE__ */ y.jsx(Ke, { position: "absolute", left: 0, right: 0, bottom: 0, height: 4, children: /* @__PURE__ */ y.jsx(Tm, { ...N, value: s }) })
      ]
    }
  );
};
Lm.displayName = "FileAttachmentItem";
const GQ = H1(Tj)(({ theme: e }) => ({
  cursor: "pointer",
  "&.disabled": {
    pointerEvents: "none",
    cursor: "default",
    color: e.palette.text.disabled,
    textDecoration: "none"
  }
})), Cx = ({ to: e, state: n, disabled: i, ...a }) => {
  const s = e ? Wh : void 0;
  return /* @__PURE__ */ y.jsx(
    GQ,
    {
      underline: "hover",
      role: a.onClick ? "button" : void 0,
      component: s,
      className: i ? "disabled" : "",
      ...e ? { to: e, state: n } : {},
      ...a,
      onClick: i ? (g) => g.preventDefault() : a.onClick
    }
  );
}, qQ = Gt.forwardRef(
  ({
    attachments: e = [],
    onBrowse: n,
    onVaultClick: i,
    vaultDisabled: a,
    extraSource: s,
    children: g,
    hideFilesList: c,
    disabled: I,
    ...h
  }, m) => {
    const w = e.length > 0 && !c;
    return /* @__PURE__ */ y.jsxs(
      Mm,
      {
        ref: m,
        ...h,
        sx: {
          ...h.sx
        },
        children: [
          g,
          /* @__PURE__ */ y.jsxs(Ke, { width: "100%", children: [
            /* @__PURE__ */ y.jsxs(
              F1,
              {
                display: "flex",
                alignItems: "center",
                justifyContent: w ? "space-between" : "center",
                children: [
                  w && /* @__PURE__ */ y.jsx(ne, { variant: "body2", children: "Attachments" }),
                  /* @__PURE__ */ y.jsxs(F1, { display: "flex", justifyContent: "flex-end", alignItems: "center", children: [
                    /* @__PURE__ */ y.jsx(
                      Me,
                      {
                        icon: "upload",
                        sx: {
                          color: (S) => {
                            var T, D;
                            return (D = (T = S.palette.common) == null ? void 0 : T.neutrals) == null ? void 0 : D[300];
                          },
                          mr: 0.5
                        }
                      }
                    ),
                    " ",
                    "Drop files to attach",
                    i && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                      ", ",
                      a ? "Liscio Vault" : /* @__PURE__ */ y.jsx(Cx, { onClick: i, children: "Liscio Vault" })
                    ] }),
                    s ? /* @__PURE__ */ y.jsx(y.Fragment, { children: ", " }) : /* @__PURE__ */ y.jsx(y.Fragment, { children: " or " }),
                    I ? "Browse" : /* @__PURE__ */ y.jsx(Cx, { onClick: n, children: "Browse" }),
                    s && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                      " or ",
                      s
                    ] })
                  ] })
                ]
              }
            ),
            w && /* @__PURE__ */ y.jsx(Ke, { gap: 1, mt: 1, "data-testid": "dnd-attachments", children: e.map((S, T) => !S.filename && !S.mimeType ? /* @__PURE__ */ y.jsx(
              OM,
              {},
              `${T}-${S.filename}-error`
            ) : /* @__PURE__ */ mS(
              Lm,
              {
                ...S,
                key: `${T}-${S.filename}`
              }
            )) })
          ] })
        ]
      }
    );
  }
), ZQ = H1(Dr)(({ theme: e }) => {
  const n = e.palette.common.neutrals[300];
  return {
    margin: "0 auto",
    width: "100%",
    marginTop: e.spacing(2),
    color: n,
    border: `solid 1px ${n}`,
    "&:hover": {
      border: `solid 1px ${n}`
    }
  };
}), $Q = Gt.forwardRef(
  ({
    attachments: e = [],
    onBrowse: n,
    extraSource: i,
    children: a,
    hideFilesList: s,
    ...g
  }, c) => {
    const I = e.length > 0 && !s;
    return /* @__PURE__ */ y.jsxs(Mm, { ref: c, border: "none", ...g, children: [
      a,
      /* @__PURE__ */ y.jsxs(Ke, { width: "100%", children: [
        /* @__PURE__ */ y.jsx(
          F1,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: I ? "space-between" : "center"
          }
        ),
        I && /* @__PURE__ */ y.jsx(Ke, { gap: 2, mt: 1, "data-testid": "dnd-attachments", children: e.map((h, m) => !h.filename && !h.mimeType ? /* @__PURE__ */ y.jsx(OM, {}) : /* @__PURE__ */ y.jsx(
          Lm,
          {
            ...h
          },
          `${m}-${h.filename}`
        )) }),
        /* @__PURE__ */ y.jsx(
          ZQ,
          {
            startIcon: /* @__PURE__ */ y.jsx(Me, { icon: "paperclip" }),
            variant: "outlined",
            onClick: n,
            children: "Add files"
          }
        ),
        i && /* @__PURE__ */ y.jsxs(
          F1,
          {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.5,
              mt: 1
            },
            children: [
              "or ",
              i
            ]
          }
        )
      ] })
    ] });
  }
), le1 = Gt.forwardRef(
  (e, n) => {
    const { isMobile: i } = zH();
    return i ? /* @__PURE__ */ y.jsx($Q, { ...e, ref: n }) : /* @__PURE__ */ y.jsx(qQ, { ...e, ref: n });
  }
), kM = ({
  open: e,
  onClick: n
}) => /* @__PURE__ */ y.jsx(
  Lj,
  {
    sx: {
      color: (i) => i.palette.primary.dark,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      zIndex: (i) => i.zIndex.modal + 9999
    },
    open: e,
    onClick: n,
    children: /* @__PURE__ */ y.jsx(ji, { color: "inherit", "data-testid": "global-loader" })
  }
), eX = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, tX = [
  "color",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight"
], YC = {
  open: !1,
  anchorEl: null,
  textStyle: {},
  width: 0
}, nX = (e) => e.scrollWidth > e.clientWidth, rX = (e) => {
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
};
function iX(e, { enabled: n, triggerRef: i }) {
  const [a, s] = qt(YC);
  return vn(() => {
    const g = e.current, c = (i == null ? void 0 : i.current) ?? g;
    if (!n || !g || !c) {
      s(YC);
      return;
    }
    let I = !1, h = !1, m = !1;
    const w = (Y) => {
      Y.target instanceof Node && Y.target.contains(g) && z();
    }, S = (Y) => {
      Y !== m && (m = Y, Y ? document.addEventListener("scroll", w, !0) : document.removeEventListener("scroll", w, !0));
    };
    let T = null;
    const D = (Y) => {
      if (Y !== (T != null))
        if (Y) {
          if (typeof ResizeObserver > "u") return;
          T = new ResizeObserver(() => k()), T.observe(g);
        } else
          T == null || T.disconnect(), T = null;
    }, k = () => {
      if (D(I || h), (I || h) && nX(g)) {
        const Y = window.getComputedStyle(g), H = {};
        tX.forEach((Z) => {
          H[Z] = Y[Z];
        }), s({
          open: !0,
          anchorEl: g,
          textStyle: H,
          width: g.getBoundingClientRect().width
        }), S(!0);
      } else
        s(YC), S(!1);
    }, z = () => {
      I = !1, h = !1, k();
    }, N = () => {
      I = !0, k();
    }, W = () => {
      I = !1, k();
    }, K = () => {
      h = rX(c), k();
    }, V = () => {
      h = !1, k();
    };
    return c.addEventListener("pointerenter", N), c.addEventListener("pointerleave", W), c.addEventListener("focus", K), c.addEventListener("blur", V), c.addEventListener("dragstart", z), () => {
      c.removeEventListener("pointerenter", N), c.removeEventListener("pointerleave", W), c.removeEventListener("focus", K), c.removeEventListener("blur", V), c.removeEventListener("dragstart", z), S(!1), D(!1), s(YC);
    };
  }, [n, e, i]), a;
}
const aX = H1(ne)(eX), Ax = 0.5, jM = ka(({ revealOnHover: e = !1, revealTriggerRef: n, revealWithinWidth: i = !1, children: a, ...s }, g) => {
  const c = Da(), I = yn(null), h = Rj(g, I), m = iX(I, {
    enabled: e,
    triggerRef: n
  }), w = V2(
    () => oX(parseFloat(c.spacing(Ax))),
    [c]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(aX, { ref: h, ...s, children: a }),
    e && /* @__PURE__ */ y.jsx(
      cS,
      {
        open: m.open,
        anchorEl: m.anchorEl,
        placement: "bottom-start",
        modifiers: w,
        "aria-hidden": !0,
        "data-testid": "overflow-reveal",
        sx: { zIndex: "tooltip", pointerEvents: "none" },
        children: /* @__PURE__ */ y.jsx(
          F1,
          {
            sx: {
              ...m.textStyle,
              px: Ax,
              width: "max-content",
              maxWidth: `calc(100vw - ${c.spacing(2)})`,
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              bgcolor: "background.paper",
              borderRadius: 0.5,
              boxShadow: 2,
              // The text's own width, with the padding outside it.
              ...i && {
                boxSizing: "content-box",
                width: `${m.width}px`
              }
            },
            children: a
          }
        )
      }
    )
  ] });
});
jM.displayName = "OverflowTypography";
const oX = (e) => [
  {
    name: "offset",
    options: {
      offset: ({ reference: n }) => [
        -e,
        -n.height
      ]
    }
  },
  { name: "flip", enabled: !1 },
  { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
], sX = H1(F1)({
  width: "10px",
  height: "10px",
  borderRadius: "50%"
}), lX = ({ color: e }) => /* @__PURE__ */ y.jsx(
  sX,
  {
    "data-testid": e ? "unread-dot" : "",
    sx: { backgroundColor: e || "transparent" }
  }
), Sh = ({
  numberOfElements: e = 2,
  mt: n = 8
}) => /* @__PURE__ */ y.jsx(Ke, { gap: 2, alignItems: "center", mt: n, role: "progressbar", children: Array(e).fill("").map((i, a) => /* @__PURE__ */ y.jsx(Fh, { height: 60, width: "80%" }, a)) });
var uX = Object.defineProperty, cX = Object.defineProperties, gX = Object.getOwnPropertyDescriptors, RA = Object.getOwnPropertySymbols, zM = Object.prototype.hasOwnProperty, NM = Object.prototype.propertyIsEnumerable, Ix = (e, n, i) => n in e ? uX(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, _o = (e, n) => {
  for (var i in n || (n = {}))
    zM.call(n, i) && Ix(e, i, n[i]);
  if (RA)
    for (var i of RA(n))
      NM.call(n, i) && Ix(e, i, n[i]);
  return e;
}, fX = (e, n) => cX(e, gX(n)), PM = (e, n) => {
  var i = {};
  for (var a in e)
    zM.call(e, a) && n.indexOf(a) < 0 && (i[a] = e[a]);
  if (e != null && RA)
    for (var a of RA(e))
      n.indexOf(a) < 0 && NM.call(e, a) && (i[a] = e[a]);
  return i;
}, dX = Object.defineProperty, CX = Object.defineProperties, AX = Object.getOwnPropertyDescriptors, OA = Object.getOwnPropertySymbols, FM = Object.prototype.hasOwnProperty, BM = Object.prototype.propertyIsEnumerable, Eh = (e, n, i) => n in e ? dX(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, ir = (e, n) => {
  for (var i in n || (n = {}))
    FM.call(n, i) && Eh(e, i, n[i]);
  if (OA)
    for (var i of OA(n))
      BM.call(n, i) && Eh(e, i, n[i]);
  return e;
}, m3 = (e, n) => CX(e, AX(n)), HM = (e, n) => {
  var i = {};
  for (var a in e)
    FM.call(e, a) && n.indexOf(a) < 0 && (i[a] = e[a]);
  if (e != null && OA)
    for (var a of OA(e))
      n.indexOf(a) < 0 && BM.call(e, a) && (i[a] = e[a]);
  return i;
}, ct = (e, n, i) => Eh(e, typeof n != "symbol" ? n + "" : n, i), It = (e, n, i) => new Promise((a, s) => {
  var g = (h) => {
    try {
      I(i.next(h));
    } catch (m) {
      s(m);
    }
  }, c = (h) => {
    try {
      I(i.throw(h));
    } catch (m) {
      s(m);
    }
  }, I = (h) => h.done ? a(h.value) : Promise.resolve(h.value).then(g, c);
  I((i = i.apply(e, n)).next());
}), IX = class {
  requestAnimationFrame(e) {
    return requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    cancelAnimationFrame(e);
  }
}, pX = class {
  constructor() {
    ct(this, "_lastHandleId", 0), ct(this, "_lastImmediate", null);
  }
  requestAnimationFrame(e) {
    return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(() => {
      e(Date.now());
    }), this._lastHandleId;
  }
  cancelAnimationFrame(e) {
    this._lastImmediate && clearImmediate(this._lastImmediate);
  }
}, hX = class {
  constructor() {
    ct(this, "_strategy"), this._strategy = typeof requestAnimationFrame == "function" ? new IX() : new pX();
  }
  requestAnimationFrame(e) {
    return this._strategy.requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    this._strategy.cancelAnimationFrame(e);
  }
}, Or = typeof window < "u" && typeof window.document < "u", A7 = new Uint8Array([80, 75, 3, 4]), mX = ["v", "ip", "op", "layers", "fr", "w", "h"], UM = "0.35.0", WM = "@lottiefiles/dotlottie-web", vX = 0.75, yX = (() => {
  var e, n = typeof document < "u" ? (e = document.currentScript) == null ? void 0 : e.src : void 0;
  return function(i = {}) {
    var a, s = i, g, c, I = new Promise((L, R) => {
      g = L, c = R;
    }), h = Object.assign({}, s), m = "./this.program", w = "", S;
    typeof document < "u" && document.currentScript && (w = document.currentScript.src), n && (w = n), w.startsWith("blob:") ? w = "" : w = w.substr(0, w.replace(/[?#].*/, "").lastIndexOf("/") + 1), S = (L) => fetch(L, { credentials: "same-origin" }).then((R) => R.ok ? R.arrayBuffer() : Promise.reject(Error(R.status + " : " + R.url)));
    var T = s.print || console.log.bind(console), D = s.printErr || console.error.bind(console);
    Object.assign(s, h), h = null, s.thisProgram && (m = s.thisProgram);
    var k = s.wasmBinary, z, N = !1, W, K, V, Y, H, Z, Q, P1, Y1;
    function O1() {
      var L = z.buffer;
      s.HEAP8 = K = new Int8Array(L), s.HEAP16 = Y = new Int16Array(L), s.HEAPU8 = V = new Uint8Array(L), s.HEAPU16 = H = new Uint16Array(L), s.HEAP32 = Z = new Int32Array(L), s.HEAPU32 = Q = new Uint32Array(L), s.HEAPF32 = P1 = new Float32Array(L), s.HEAPF64 = Y1 = new Float64Array(L);
    }
    var T1 = [], J1 = [], s1 = [];
    function d1() {
      var L = s.preRun.shift();
      T1.unshift(L);
    }
    var h1 = 0, C1 = null;
    function L1(L) {
      var R;
      throw (R = s.onAbort) == null || R.call(s, L), L = "Aborted(" + L + ")", D(L), N = !0, L = new WebAssembly.RuntimeError(L + ". Build with -sASSERTIONS for more info."), c(L), L;
    }
    var f1 = (L) => L.startsWith("data:application/octet-stream;base64,"), B1;
    function t1(L) {
      if (L == B1 && k)
        return new Uint8Array(k);
      throw "both async and sync fetching of the wasm failed";
    }
    function y1(L) {
      return k ? Promise.resolve().then(() => t1(L)) : S(L).then((R) => new Uint8Array(R), () => t1(L));
    }
    function k1(L, R, B) {
      return y1(L).then((U) => WebAssembly.instantiate(U, R)).then(B, (U) => {
        D(`failed to asynchronously prepare wasm: ${U}`), L1(U);
      });
    }
    function se(L, R) {
      var B = B1;
      return k || typeof WebAssembly.instantiateStreaming != "function" || f1(B) || typeof fetch != "function" ? k1(B, L, R) : fetch(B, { credentials: "same-origin" }).then((U) => WebAssembly.instantiateStreaming(U, L).then(R, function(G) {
        return D(`wasm streaming compile failed: ${G}`), D("falling back to ArrayBuffer instantiation"), k1(B, L, R);
      }));
    }
    function K1(L) {
      this.name = "ExitStatus", this.message = `Program terminated with exit(${L})`, this.status = L;
    }
    var le = (L) => {
      for (; 0 < L.length; )
        L.shift()(s);
    }, G1 = s.noExitRuntime || !0, $1 = typeof TextDecoder < "u" ? new TextDecoder() : void 0, V1 = (L, R, B) => {
      var U = R + B;
      for (B = R; L[B] && !(B >= U); )
        ++B;
      if (16 < B - R && L.buffer && $1)
        return $1.decode(L.subarray(R, B));
      for (U = ""; R < B; ) {
        var G = L[R++];
        if (G & 128) {
          var u1 = L[R++] & 63;
          if ((G & 224) == 192)
            U += String.fromCharCode((G & 31) << 6 | u1);
          else {
            var M1 = L[R++] & 63;
            G = (G & 240) == 224 ? (G & 15) << 12 | u1 << 6 | M1 : (G & 7) << 18 | u1 << 12 | M1 << 6 | L[R++] & 63, 65536 > G ? U += String.fromCharCode(G) : (G -= 65536, U += String.fromCharCode(55296 | G >> 10, 56320 | G & 1023));
          }
        } else
          U += String.fromCharCode(G);
      }
      return U;
    };
    class z1 {
      constructor(R) {
        this.Ca = R - 24;
      }
    }
    var ae = 0, We = (L, R, B) => {
      var U = V;
      if (0 < B) {
        B = R + B - 1;
        for (var G = 0; G < L.length; ++G) {
          var u1 = L.charCodeAt(G);
          if (55296 <= u1 && 57343 >= u1) {
            var M1 = L.charCodeAt(++G);
            u1 = 65536 + ((u1 & 1023) << 10) | M1 & 1023;
          }
          if (127 >= u1) {
            if (R >= B)
              break;
            U[R++] = u1;
          } else {
            if (2047 >= u1) {
              if (R + 1 >= B)
                break;
              U[R++] = 192 | u1 >> 6;
            } else {
              if (65535 >= u1) {
                if (R + 2 >= B)
                  break;
                U[R++] = 224 | u1 >> 12;
              } else {
                if (R + 3 >= B)
                  break;
                U[R++] = 240 | u1 >> 18, U[R++] = 128 | u1 >> 12 & 63;
              }
              U[R++] = 128 | u1 >> 6 & 63;
            }
            U[R++] = 128 | u1 & 63;
          }
        }
        U[R] = 0;
      }
    }, D1 = {}, ue = (L) => {
      for (; L.length; ) {
        var R = L.pop();
        L.pop()(R);
      }
    };
    function b1(L) {
      return this.fromWireType(Q[L >> 2]);
    }
    var Pe = {}, $e = {}, W1 = {}, ke, Xe = (L, R, B) => {
      function U(p1) {
        if (p1 = B(p1), p1.length !== L.length)
          throw new ke("Mismatched type converter count");
        for (var te = 0; te < L.length; ++te)
          nt(L[te], p1[te]);
      }
      L.forEach((p1) => W1[p1] = R);
      var G = Array(R.length), u1 = [], M1 = 0;
      R.forEach((p1, te) => {
        $e.hasOwnProperty(p1) ? G[te] = $e[p1] : (u1.push(p1), Pe.hasOwnProperty(p1) || (Pe[p1] = []), Pe[p1].push(() => {
          G[te] = $e[p1], ++M1, M1 === u1.length && U(G);
        }));
      }), u1.length === 0 && U(G);
    }, St, tt = (L) => {
      for (var R = ""; V[L]; )
        R += St[V[L++]];
      return R;
    }, we;
    function An(L, R, B = {}) {
      var U = R.name;
      if (!L)
        throw new we(`type "${U}" must have a positive integer typeid pointer`);
      if ($e.hasOwnProperty(L)) {
        if (B.hb)
          return;
        throw new we(`Cannot register type '${U}' twice`);
      }
      $e[L] = R, delete W1[L], Pe.hasOwnProperty(L) && (R = Pe[L], delete Pe[L], R.forEach((G) => G()));
    }
    function nt(L, R, B = {}) {
      return An(L, R, B);
    }
    var In = (L) => {
      throw new we(L.Aa.Da.Ba.name + " instance already deleted");
    }, v2 = !1, tn = () => {
    }, s2 = (L, R, B) => R === B ? L : B.Ga === void 0 ? null : (L = s2(L, R, B.Ga), L === null ? null : B.$a(L)), Fe = {}, Pn = [], Q1 = () => {
      for (; Pn.length; ) {
        var L = Pn.pop();
        L.Aa.Ma = !1, L.delete();
      }
    }, he, Ye = {}, Et = (L, R) => {
      if (R === void 0)
        throw new we("ptr should not be undefined");
      for (; L.Ga; )
        R = L.Pa(R), L = L.Ga;
      return Ye[R];
    }, Ut = (L, R) => {
      if (!R.Da || !R.Ca)
        throw new ke("makeClassHandle requires ptr and ptrType");
      if (!!R.Ha != !!R.Ea)
        throw new ke("Both smartPtrType and smartPtr must be specified");
      return R.count = { value: 1 }, cn(Object.create(L, { Aa: { value: R, writable: !0 } }));
    }, cn = (L) => typeof FinalizationRegistry > "u" ? (cn = (R) => R, L) : (v2 = new FinalizationRegistry((R) => {
      R = R.Aa, --R.count.value, R.count.value === 0 && (R.Ea ? R.Ha.Ka(R.Ea) : R.Da.Ba.Ka(R.Ca));
    }), cn = (R) => {
      var B = R.Aa;
      return B.Ea && v2.register(R, { Aa: B }, R), R;
    }, tn = (R) => {
      v2.unregister(R);
    }, cn(L));
    function nn() {
    }
    var Fn = (L, R) => Object.defineProperty(R, "name", { value: L }), zt = (L, R, B) => {
      if (L[R].Fa === void 0) {
        var U = L[R];
        L[R] = function(...G) {
          if (!L[R].Fa.hasOwnProperty(G.length))
            throw new we(`Function '${B}' called with an invalid number of arguments (${G.length}) - expects one of (${L[R].Fa})!`);
          return L[R].Fa[G.length].apply(this, G);
        }, L[R].Fa = [], L[R].Fa[U.Qa] = U;
      }
    }, y2 = (L, R, B) => {
      if (s.hasOwnProperty(L)) {
        if (B === void 0 || s[L].Fa !== void 0 && s[L].Fa[B] !== void 0)
          throw new we(`Cannot register public name '${L}' twice`);
        if (zt(s, L, L), s.hasOwnProperty(B))
          throw new we(`Cannot register multiple overloads of a function with the same number of arguments (${B})!`);
        s[L].Fa[B] = R;
      } else
        s[L] = R, B !== void 0 && (s[L].qb = B);
    }, Nt = (L) => {
      if (L === void 0)
        return "_unknown";
      L = L.replace(/[^a-zA-Z0-9_]/g, "$");
      var R = L.charCodeAt(0);
      return 48 <= R && 57 >= R ? `_${L}` : L;
    };
    function Wt(L, R, B, U, G, u1, M1, p1) {
      this.name = L, this.constructor = R, this.Na = B, this.Ka = U, this.Ga = G, this.bb = u1, this.Pa = M1, this.$a = p1, this.jb = [];
    }
    var j3 = (L, R, B) => {
      for (; R !== B; ) {
        if (!R.Pa)
          throw new we(`Expected null or instance of ${B.name}, got an instance of ${R.name}`);
        L = R.Pa(L), R = R.Ga;
      }
      return L;
    };
    function l0(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new we(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!R.Aa)
        throw new we(`Cannot pass "${Zt(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new we(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return j3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba);
    }
    function W0(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new we(`null is not a valid ${this.name}`);
        if (this.Sa) {
          var B = this.Ua();
          return L !== null && L.push(this.Ka, B), B;
        }
        return 0;
      }
      if (!R || !R.Aa)
        throw new we(`Cannot pass "${Zt(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new we(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.Ra && R.Aa.Da.Ra)
        throw new we(`Cannot convert argument of type ${R.Aa.Ha ? R.Aa.Ha.name : R.Aa.Da.name} to parameter type ${this.name}`);
      if (B = j3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba), this.Sa) {
        if (R.Aa.Ea === void 0)
          throw new we("Passing raw pointer to smart pointer is illegal");
        switch (this.ob) {
          case 0:
            if (R.Aa.Ha === this)
              B = R.Aa.Ea;
            else
              throw new we(`Cannot convert argument of type ${R.Aa.Ha ? R.Aa.Ha.name : R.Aa.Da.name} to parameter type ${this.name}`);
            break;
          case 1:
            B = R.Aa.Ea;
            break;
          case 2:
            if (R.Aa.Ha === this)
              B = R.Aa.Ea;
            else {
              var U = R.clone();
              B = this.kb(B, je(() => U.delete())), L !== null && L.push(this.Ka, B);
            }
            break;
          default:
            throw new we("Unsupporting sharing policy");
        }
      }
      return B;
    }
    function Pi(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new we(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!R.Aa)
        throw new we(`Cannot pass "${Zt(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new we(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (R.Aa.Da.Ra)
        throw new we(`Cannot convert argument of type ${R.Aa.Da.name} to parameter type ${this.name}`);
      return j3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba);
    }
    function z3(L, R, B, U, G, u1, M1, p1, te, re, xe) {
      this.name = L, this.Ba = R, this.Ta = B, this.Ra = U, this.Sa = G, this.ib = u1, this.ob = M1, this.Ya = p1, this.Ua = te, this.kb = re, this.Ka = xe, G || R.Ga !== void 0 ? this.toWireType = W0 : (this.toWireType = U ? l0 : Pi, this.Ja = null);
    }
    var N3 = (L, R, B) => {
      if (!s.hasOwnProperty(L))
        throw new ke("Replacing nonexistent public symbol");
      s[L].Fa !== void 0 && B !== void 0 ? s[L].Fa[B] = R : (s[L] = R, s[L].Qa = B);
    }, Yn, u0 = (L, R, B = []) => (L.includes("j") ? (L = L.replace(/p/g, "i"), R = (0, s["dynCall_" + L])(R, ...B)) : R = Yn.get(R)(...B), R), V0 = (L, R) => (...B) => u0(L, R, B), rn = (L, R) => {
      L = tt(L);
      var B = L.includes("j") ? V0(L, R) : Yn.get(R);
      if (typeof B != "function")
        throw new we(`unknown function pointer with signature ${L}: ${R}`);
      return B;
    }, Qr, j2 = (L) => {
      L = rs(L);
      var R = tt(L);
      return ur(L), R;
    }, z2 = (L, R) => {
      function B(u1) {
        G[u1] || $e[u1] || (W1[u1] ? W1[u1].forEach(B) : (U.push(u1), G[u1] = !0));
      }
      var U = [], G = {};
      throw R.forEach(B), new Qr(`${L}: ` + U.map(j2).join([", "]));
    }, Xr = (L, R) => {
      for (var B = [], U = 0; U < L; U++)
        B.push(Q[R + 4 * U >> 2]);
      return B;
    };
    function c0(L) {
      for (var R = 1; R < L.length; ++R)
        if (L[R] !== null && L[R].Ja === void 0)
          return !0;
      return !1;
    }
    function J(L, R, B, U, G) {
      var u1 = R.length;
      if (2 > u1)
        throw new we("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var M1 = R[1] !== null && B !== null, p1 = c0(R), te = R[0].name !== "void", re = u1 - 2, xe = Array(re), st = [], gt = [];
      return Fn(L, function(...Xn) {
        if (gt.length = 0, st.length = M1 ? 2 : 1, st[0] = G, M1) {
          var $t = R[1].toWireType(gt, this);
          st[1] = $t;
        }
        for (var gn = 0; gn < re; ++gn)
          xe[gn] = R[gn + 2].toWireType(gt, Xn[gn]), st.push(xe[gn]);
        if (Xn = U(...st), p1)
          ue(gt);
        else
          for (gn = M1 ? 1 : 2; gn < R.length; gn++) {
            var u2 = gn === 1 ? $t : xe[gn - 2];
            R[gn].Ja !== null && R[gn].Ja(u2);
          }
        return $t = te ? R[0].fromWireType(Xn) : void 0, $t;
      });
    }
    var S1 = (L) => {
      L = L.trim();
      let R = L.indexOf("(");
      return R !== -1 ? L.substr(0, R) : L;
    }, X1 = [], Ae = [], ot = (L) => {
      9 < L && --Ae[L + 1] === 0 && (Ae[L] = void 0, X1.push(L));
    }, ut = (L) => {
      if (!L)
        throw new we("Cannot use deleted val. handle = " + L);
      return Ae[L];
    }, je = (L) => {
      switch (L) {
        case void 0:
          return 2;
        case null:
          return 4;
        case !0:
          return 6;
        case !1:
          return 8;
        default:
          let R = X1.pop() || Ae.length;
          return Ae[R] = L, Ae[R + 1] = 1, R;
      }
    }, et = { name: "emscripten::val", fromWireType: (L) => {
      var R = ut(L);
      return ot(L), R;
    }, toWireType: (L, R) => je(R), Ia: 8, readValueFromPointer: b1, Ja: null }, Bn = (L, R, B) => {
      switch (R) {
        case 1:
          return B ? function(U) {
            return this.fromWireType(K[U]);
          } : function(U) {
            return this.fromWireType(V[U]);
          };
        case 2:
          return B ? function(U) {
            return this.fromWireType(Y[U >> 1]);
          } : function(U) {
            return this.fromWireType(H[U >> 1]);
          };
        case 4:
          return B ? function(U) {
            return this.fromWireType(Z[U >> 2]);
          } : function(U) {
            return this.fromWireType(Q[U >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${R}): ${L}`);
      }
    }, Pt = (L, R) => {
      var B = $e[L];
      if (B === void 0)
        throw L = `${R} has unknown type ${j2(L)}`, new we(L);
      return B;
    }, Zt = (L) => {
      if (L === null)
        return "null";
      var R = typeof L;
      return R === "object" || R === "array" || R === "function" ? L.toString() : "" + L;
    }, N2 = (L, R) => {
      switch (R) {
        case 4:
          return function(B) {
            return this.fromWireType(P1[B >> 2]);
          };
        case 8:
          return function(B) {
            return this.fromWireType(Y1[B >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${R}): ${L}`);
      }
    }, P3 = (L, R, B) => {
      switch (R) {
        case 1:
          return B ? (U) => K[U] : (U) => V[U];
        case 2:
          return B ? (U) => Y[U >> 1] : (U) => H[U >> 1];
        case 4:
          return B ? (U) => Z[U >> 2] : (U) => Q[U >> 2];
        default:
          throw new TypeError(`invalid integer width (${R}): ${L}`);
      }
    }, vt = Object.assign({ optional: !0 }, et), Qn = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, _2 = (L, R) => {
      for (var B = L >> 1, U = B + R / 2; !(B >= U) && H[B]; )
        ++B;
      if (B <<= 1, 32 < B - L && Qn)
        return Qn.decode(V.subarray(L, B));
      for (B = "", U = 0; !(U >= R / 2); ++U) {
        var G = Y[L + 2 * U >> 1];
        if (G == 0)
          break;
        B += String.fromCharCode(G);
      }
      return B;
    }, rt = (L, R, B) => {
      if (B != null || (B = 2147483647), 2 > B)
        return 0;
      B -= 2;
      var U = R;
      B = B < 2 * L.length ? B / 2 : L.length;
      for (var G = 0; G < B; ++G)
        Y[R >> 1] = L.charCodeAt(G), R += 2;
      return Y[R >> 1] = 0, R - U;
    }, Gr = (L) => 2 * L.length, ml = (L, R) => {
      for (var B = 0, U = ""; !(B >= R / 4); ) {
        var G = Z[L + 4 * B >> 2];
        if (G == 0)
          break;
        ++B, 65536 <= G ? (G -= 65536, U += String.fromCharCode(55296 | G >> 10, 56320 | G & 1023)) : U += String.fromCharCode(G);
      }
      return U;
    }, ts = (L, R, B) => {
      if (B != null || (B = 2147483647), 4 > B)
        return 0;
      var U = R;
      B = U + B - 4;
      for (var G = 0; G < L.length; ++G) {
        var u1 = L.charCodeAt(G);
        if (55296 <= u1 && 57343 >= u1) {
          var M1 = L.charCodeAt(++G);
          u1 = 65536 + ((u1 & 1023) << 10) | M1 & 1023;
        }
        if (Z[R >> 2] = u1, R += 4, R + 4 > B)
          break;
      }
      return Z[R >> 2] = 0, R - U;
    }, Fi = (L) => {
      for (var R = 0, B = 0; B < L.length; ++B) {
        var U = L.charCodeAt(B);
        55296 <= U && 57343 >= U && ++B, R += 4;
      }
      return R;
    }, J2 = [], vl = (L) => {
      var R = J2.length;
      return J2.push(L), R;
    }, lr = (L, R) => {
      for (var B = Array(L), U = 0; U < L; ++U)
        B[U] = Pt(Q[R + 4 * U >> 2], "parameter " + U);
      return B;
    }, yl = Reflect.construct, _0 = {}, bl = (L) => {
      if (!(L instanceof K1 || L == "unwind"))
        throw L;
    }, J0 = 0, g0 = (L) => {
      var R;
      throw W = L, G1 || 0 < J0 || ((R = s.onExit) == null || R.call(s, L), N = !0), new K1(L);
    }, f0 = (L) => {
      if (!N)
        try {
          if (L(), !(G1 || 0 < J0))
            try {
              W = L = W, g0(L);
            } catch (R) {
              bl(R);
            }
        } catch (R) {
          bl(R);
        }
    }, K2 = {}, za = () => {
      if (!K0) {
        var L = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: m || "./this.program" }, R;
        for (R in K2)
          K2[R] === void 0 ? delete L[R] : L[R] = K2[R];
        var B = [];
        for (R in L)
          B.push(`${R}=${L[R]}`);
        K0 = B;
      }
      return K0;
    }, K0, ns = [null, [], []], Na = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
        return (L) => crypto.getRandomValues(L);
      L1("initRandomDevice");
    }, Pa = (L) => (Pa = Na())(L);
    ke = s.InternalError = class extends Error {
      constructor(L) {
        super(L), this.name = "InternalError";
      }
    };
    for (var F3 = Array(256), Fa = 0; 256 > Fa; ++Fa)
      F3[Fa] = String.fromCharCode(Fa);
    St = F3, we = s.BindingError = class extends Error {
      constructor(L) {
        super(L), this.name = "BindingError";
      }
    }, Object.assign(nn.prototype, { isAliasOf: function(L) {
      if (!(this instanceof nn && L instanceof nn))
        return !1;
      var R = this.Aa.Da.Ba, B = this.Aa.Ca;
      L.Aa = L.Aa;
      var U = L.Aa.Da.Ba;
      for (L = L.Aa.Ca; R.Ga; )
        B = R.Pa(B), R = R.Ga;
      for (; U.Ga; )
        L = U.Pa(L), U = U.Ga;
      return R === U && B === L;
    }, clone: function() {
      if (this.Aa.Ca || In(this), this.Aa.Oa)
        return this.Aa.count.value += 1, this;
      var L = cn, R = Object, B = R.create, U = Object.getPrototypeOf(this), G = this.Aa;
      return L = L(B.call(R, U, { Aa: { value: { count: G.count, Ma: G.Ma, Oa: G.Oa, Ca: G.Ca, Da: G.Da, Ea: G.Ea, Ha: G.Ha } } })), L.Aa.count.value += 1, L.Aa.Ma = !1, L;
    }, delete() {
      if (this.Aa.Ca || In(this), this.Aa.Ma && !this.Aa.Oa)
        throw new we("Object already scheduled for deletion");
      tn(this);
      var L = this.Aa;
      --L.count.value, L.count.value === 0 && (L.Ea ? L.Ha.Ka(L.Ea) : L.Da.Ba.Ka(L.Ca)), this.Aa.Oa || (this.Aa.Ea = void 0, this.Aa.Ca = void 0);
    }, isDeleted: function() {
      return !this.Aa.Ca;
    }, deleteLater: function() {
      if (this.Aa.Ca || In(this), this.Aa.Ma && !this.Aa.Oa)
        throw new we("Object already scheduled for deletion");
      return Pn.push(this), Pn.length === 1 && he && he(Q1), this.Aa.Ma = !0, this;
    } }), s.getInheritedInstanceCount = () => Object.keys(Ye).length, s.getLiveInheritedInstances = () => {
      var L = [], R;
      for (R in Ye)
        Ye.hasOwnProperty(R) && L.push(Ye[R]);
      return L;
    }, s.flushPendingDeletes = Q1, s.setDelayFunction = (L) => {
      he = L, Pn.length && he && he(Q1);
    }, Object.assign(z3.prototype, { cb(L) {
      return this.Ya && (L = this.Ya(L)), L;
    }, Wa(L) {
      var R;
      (R = this.Ka) == null || R.call(this, L);
    }, Ia: 8, readValueFromPointer: b1, fromWireType: function(L) {
      function R() {
        return this.Sa ? Ut(this.Ba.Na, { Da: this.ib, Ca: B, Ha: this, Ea: L }) : Ut(this.Ba.Na, { Da: this, Ca: L });
      }
      var B = this.cb(L);
      if (!B)
        return this.Wa(L), null;
      var U = Et(this.Ba, B);
      if (U !== void 0)
        return U.Aa.count.value === 0 ? (U.Aa.Ca = B, U.Aa.Ea = L, U.clone()) : (U = U.clone(), this.Wa(L), U);
      if (U = this.Ba.bb(B), U = Fe[U], !U)
        return R.call(this);
      U = this.Ra ? U.Za : U.pointerType;
      var G = s2(B, this.Ba, U.Ba);
      return G === null ? R.call(this) : this.Sa ? Ut(U.Ba.Na, { Da: U, Ca: G, Ha: this, Ea: L }) : Ut(U.Ba.Na, { Da: U, Ca: G });
    } }), Qr = s.UnboundTypeError = ((L, R) => {
      var B = Fn(R, function(U) {
        this.name = R, this.message = U, U = Error(U).stack, U !== void 0 && (this.stack = this.toString() + `
` + U.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return B.prototype = Object.create(L.prototype), B.prototype.constructor = B, B.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, B;
    })(Error, "UnboundTypeError"), Ae.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), s.count_emval_handles = () => Ae.length / 2 - 5 - X1.length;
    var Bi = { c: (L, R, B, U) => {
      L1(`Assertion failed: ${L ? V1(V, L) : ""}, at: ` + [R ? R ? V1(V, R) : "" : "unknown filename", B, U ? U ? V1(V, U) : "" : "unknown function"]);
    }, m: (L, R, B) => {
      var U = new z1(L);
      throw Q[U.Ca + 16 >> 2] = 0, Q[U.Ca + 4 >> 2] = R, Q[U.Ca + 8 >> 2] = B, ae = L, ae;
    }, C: function() {
      return 0;
    }, S: () => {
    }, P: () => {
    }, T: function() {
      return 0;
    }, Q: () => {
    }, B: function() {
    }, R: () => {
    }, U: () => {
      L1("");
    }, v: (L) => {
      var R = D1[L];
      delete D1[L];
      var B = R.Ua, U = R.Ka, G = R.Xa, u1 = G.map((M1) => M1.gb).concat(G.map((M1) => M1.mb));
      Xe([L], u1, (M1) => {
        var p1 = {};
        return G.forEach((te, re) => {
          var xe = M1[re], st = te.eb, gt = te.fb, Xn = M1[re + G.length], $t = te.lb, gn = te.nb;
          p1[te.ab] = { read: (u2) => xe.fromWireType(st(gt, u2)), write: (u2, y3) => {
            var P2 = [];
            $t(gn, u2, Xn.toWireType(P2, y3)), ue(P2);
          } };
        }), [{ name: R.name, fromWireType: (te) => {
          var re = {}, xe;
          for (xe in p1)
            re[xe] = p1[xe].read(te);
          return U(te), re;
        }, toWireType: (te, re) => {
          for (var xe in p1)
            if (!(xe in re))
              throw new TypeError(`Missing field: "${xe}"`);
          var st = B();
          for (xe in p1)
            p1[xe].write(st, re[xe]);
          return te !== null && te.push(U, st), st;
        }, Ia: 8, readValueFromPointer: b1, Ja: U }];
      });
    }, J: () => {
    }, _: (L, R, B, U) => {
      R = tt(R), nt(L, { name: R, fromWireType: function(G) {
        return !!G;
      }, toWireType: function(G, u1) {
        return u1 ? B : U;
      }, Ia: 8, readValueFromPointer: function(G) {
        return this.fromWireType(V[G]);
      }, Ja: null });
    }, r: (L, R, B, U, G, u1, M1, p1, te, re, xe, st, gt) => {
      xe = tt(xe), u1 = rn(G, u1), p1 && (p1 = rn(M1, p1)), re && (re = rn(te, re)), gt = rn(st, gt);
      var Xn = Nt(xe);
      y2(Xn, function() {
        z2(`Cannot construct ${xe} due to unbound types`, [U]);
      }), Xe([L, R, B], U ? [U] : [], ($t) => {
        if ($t = $t[0], U)
          var gn = $t.Ba, u2 = gn.Na;
        else
          u2 = nn.prototype;
        $t = Fn(xe, function(...qr) {
          if (Object.getPrototypeOf(this) !== y3)
            throw new we("Use 'new' to construct " + xe);
          if (P2.La === void 0)
            throw new we(xe + " has no accessible constructor");
          var Vi = P2.La[qr.length];
          if (Vi === void 0)
            throw new we(`Tried to invoke ctor of ${xe} with invalid number of parameters (${qr.length}) - expected (${Object.keys(P2.La).toString()}) parameters instead!`);
          return Vi.apply(this, qr);
        });
        var y3 = Object.create(u2, { constructor: { value: $t } });
        $t.prototype = y3;
        var P2 = new Wt(xe, $t, y3, gt, gn, u1, p1, re);
        if (P2.Ga) {
          var Gn;
          (Gn = P2.Ga).Va != null || (Gn.Va = []), P2.Ga.Va.push(P2);
        }
        return gn = new z3(xe, P2, !0, !1, !1), Gn = new z3(xe + "*", P2, !1, !1, !1), u2 = new z3(xe + " const*", P2, !1, !0, !1), Fe[L] = { pointerType: Gn, Za: u2 }, N3(Xn, $t), [gn, Gn, u2];
      });
    }, q: (L, R, B, U, G, u1) => {
      var M1 = Xr(R, B);
      G = rn(U, G), Xe([], [L], (p1) => {
        p1 = p1[0];
        var te = `constructor ${p1.name}`;
        if (p1.Ba.La === void 0 && (p1.Ba.La = []), p1.Ba.La[R - 1] !== void 0)
          throw new we(`Cannot register multiple constructors with identical number of parameters (${R - 1}) for class '${p1.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return p1.Ba.La[R - 1] = () => {
          z2(`Cannot construct ${p1.name} due to unbound types`, M1);
        }, Xe([], M1, (re) => (re.splice(1, 0, null), p1.Ba.La[R - 1] = J(te, re, null, G, u1), [])), [];
      });
    }, f: (L, R, B, U, G, u1, M1, p1) => {
      var te = Xr(B, U);
      R = tt(R), R = S1(R), u1 = rn(G, u1), Xe([], [L], (re) => {
        function xe() {
          z2(`Cannot call ${st} due to unbound types`, te);
        }
        re = re[0];
        var st = `${re.name}.${R}`;
        R.startsWith("@@") && (R = Symbol[R.substring(2)]), p1 && re.Ba.jb.push(R);
        var gt = re.Ba.Na, Xn = gt[R];
        return Xn === void 0 || Xn.Fa === void 0 && Xn.className !== re.name && Xn.Qa === B - 2 ? (xe.Qa = B - 2, xe.className = re.name, gt[R] = xe) : (zt(gt, R, st), gt[R].Fa[B - 2] = xe), Xe([], te, ($t) => ($t = J(st, $t, re, u1, M1), gt[R].Fa === void 0 ? ($t.Qa = B - 2, gt[R] = $t) : gt[R].Fa[B - 2] = $t, [])), [];
      });
    }, Z: (L) => nt(L, et), x: (L, R, B, U) => {
      function G() {
      }
      R = tt(R), G.values = {}, nt(L, { name: R, constructor: G, fromWireType: function(u1) {
        return this.constructor.values[u1];
      }, toWireType: (u1, M1) => M1.value, Ia: 8, readValueFromPointer: Bn(R, B, U), Ja: null }), y2(R, G);
    }, k: (L, R, B) => {
      var U = Pt(L, "enum");
      R = tt(R), L = U.constructor, U = Object.create(U.constructor.prototype, { value: { value: B }, constructor: { value: Fn(`${U.name}_${R}`, function() {
      }) } }), L.values[B] = U, L[R] = U;
    }, D: (L, R, B) => {
      R = tt(R), nt(L, { name: R, fromWireType: (U) => U, toWireType: (U, G) => G, Ia: 8, readValueFromPointer: N2(R, B), Ja: null });
    }, F: (L, R, B, U, G, u1) => {
      var M1 = Xr(R, B);
      L = tt(L), L = S1(L), G = rn(U, G), y2(L, function() {
        z2(`Cannot call ${L} due to unbound types`, M1);
      }, R - 1), Xe([], M1, (p1) => (N3(L, J(L, [p1[0], null].concat(p1.slice(1)), null, G, u1), R - 1), []));
    }, l: (L, R, B, U, G) => {
      if (R = tt(R), G === -1 && (G = 4294967295), G = (p1) => p1, U === 0) {
        var u1 = 32 - 8 * B;
        G = (p1) => p1 << u1 >>> u1;
      }
      var M1 = R.includes("unsigned") ? function(p1, te) {
        return te >>> 0;
      } : function(p1, te) {
        return te;
      };
      nt(L, { name: R, fromWireType: G, toWireType: M1, Ia: 8, readValueFromPointer: P3(R, B, U !== 0), Ja: null });
    }, h: (L, R, B) => {
      function U(u1) {
        return new G(K.buffer, Q[u1 + 4 >> 2], Q[u1 >> 2]);
      }
      var G = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][R];
      B = tt(B), nt(L, { name: B, fromWireType: U, Ia: 8, readValueFromPointer: U }, { hb: !0 });
    }, u: (L) => {
      nt(L, vt);
    }, ea: (L, R, B, U, G, u1, M1, p1, te, re, xe, st) => {
      B = tt(B), u1 = rn(G, u1), p1 = rn(M1, p1), re = rn(te, re), st = rn(xe, st), Xe([L], [R], (gt) => (gt = gt[0], [new z3(B, gt.Ba, !1, !1, !0, gt, U, u1, p1, re, st)]));
    }, E: (L, R) => {
      R = tt(R);
      var B = R === "std::string";
      nt(L, { name: R, fromWireType: function(U) {
        var G = Q[U >> 2], u1 = U + 4;
        if (B)
          for (var M1 = u1, p1 = 0; p1 <= G; ++p1) {
            var te = u1 + p1;
            if (p1 == G || V[te] == 0) {
              if (M1 = M1 ? V1(V, M1, te - M1) : "", re === void 0)
                var re = M1;
              else
                re += "\0", re += M1;
              M1 = te + 1;
            }
          }
        else {
          for (re = Array(G), p1 = 0; p1 < G; ++p1)
            re[p1] = String.fromCharCode(V[u1 + p1]);
          re = re.join("");
        }
        return ur(U), re;
      }, toWireType: function(U, G) {
        G instanceof ArrayBuffer && (G = new Uint8Array(G));
        var u1, M1 = typeof G == "string";
        if (!(M1 || G instanceof Uint8Array || G instanceof Uint8ClampedArray || G instanceof Int8Array))
          throw new we("Cannot pass non-string to std::string");
        if (B && M1)
          for (var p1 = u1 = 0; p1 < G.length; ++p1) {
            var te = G.charCodeAt(p1);
            127 >= te ? u1++ : 2047 >= te ? u1 += 2 : 55296 <= te && 57343 >= te ? (u1 += 4, ++p1) : u1 += 3;
          }
        else
          u1 = G.length;
        if (p1 = Hi(4 + u1 + 1), te = p1 + 4, Q[p1 >> 2] = u1, B && M1)
          We(G, te, u1 + 1);
        else if (M1)
          for (M1 = 0; M1 < u1; ++M1) {
            var re = G.charCodeAt(M1);
            if (255 < re)
              throw ur(te), new we("String has UTF-16 code units that do not fit in 8 bits");
            V[te + M1] = re;
          }
        else
          for (M1 = 0; M1 < u1; ++M1)
            V[te + M1] = G[M1];
        return U !== null && U.push(ur, p1), p1;
      }, Ia: 8, readValueFromPointer: b1, Ja(U) {
        ur(U);
      } });
    }, t: (L, R, B) => {
      if (B = tt(B), R === 2)
        var U = _2, G = rt, u1 = Gr, M1 = (p1) => H[p1 >> 1];
      else
        R === 4 && (U = ml, G = ts, u1 = Fi, M1 = (p1) => Q[p1 >> 2]);
      nt(L, { name: B, fromWireType: (p1) => {
        for (var te = Q[p1 >> 2], re, xe = p1 + 4, st = 0; st <= te; ++st) {
          var gt = p1 + 4 + st * R;
          (st == te || M1(gt) == 0) && (xe = U(xe, gt - xe), re === void 0 ? re = xe : (re += "\0", re += xe), xe = gt + R);
        }
        return ur(p1), re;
      }, toWireType: (p1, te) => {
        if (typeof te != "string")
          throw new we(`Cannot pass non-string to C++ string type ${B}`);
        var re = u1(te), xe = Hi(4 + re + R);
        return Q[xe >> 2] = re / R, G(te, xe + 4, re + R), p1 !== null && p1.push(ur, xe), xe;
      }, Ia: 8, readValueFromPointer: b1, Ja(p1) {
        ur(p1);
      } });
    }, w: (L, R, B, U, G, u1) => {
      D1[L] = { name: tt(R), Ua: rn(B, U), Ka: rn(G, u1), Xa: [] };
    }, j: (L, R, B, U, G, u1, M1, p1, te, re) => {
      D1[L].Xa.push({ ab: tt(R), gb: B, eb: rn(U, G), fb: u1, mb: M1, lb: rn(p1, te), nb: re });
    }, $: (L, R) => {
      R = tt(R), nt(L, { pb: !0, name: R, Ia: 0, fromWireType: () => {
      }, toWireType: () => {
      } });
    }, O: () => {
      G1 = !1, J0 = 0;
    }, K: () => {
      throw 1 / 0;
    }, ca: (L, R, B, U) => (L = J2[L], R = ut(R), L(null, R, B, U)), G: ot, ba: (L, R, B) => {
      var U = lr(L, R), G = U.shift();
      L--;
      var u1 = Array(L);
      return R = `methodCaller<(${U.map((M1) => M1.name).join(", ")}) => ${G.name}>`, vl(Fn(R, (M1, p1, te, re) => {
        for (var xe = 0, st = 0; st < L; ++st)
          u1[st] = U[st].readValueFromPointer(re + xe), xe += U[st].Ia;
        return p1 = B === 1 ? yl(p1, u1) : p1.apply(M1, u1), M1 = [], p1 = G.toWireType(M1, p1), M1.length && (Q[te >> 2] = je(M1)), p1;
      }));
    }, da: (L) => {
      9 < L && (Ae[L + 1] += 1);
    }, aa: (L) => {
      var R = ut(L);
      ue(R), ot(L);
    }, o: (L, R) => (L = Pt(L, "_emval_take_value"), L = L.readValueFromPointer(R), je(L)), L: (L, R) => {
      if (_0[L] && (clearTimeout(_0[L].id), delete _0[L]), !R)
        return 0;
      var B = setTimeout(() => {
        delete _0[L], f0(() => yt(L, performance.now()));
      }, R);
      return _0[L] = { id: B, rb: R }, 0;
    }, M: (L, R, B, U) => {
      var G = (/* @__PURE__ */ new Date()).getFullYear(), u1 = new Date(G, 0, 1).getTimezoneOffset();
      G = new Date(G, 6, 1).getTimezoneOffset(), Q[L >> 2] = 60 * Math.max(u1, G), Z[R >> 2] = +(u1 != G), R = (M1) => {
        var p1 = Math.abs(M1);
        return `UTC${0 <= M1 ? "-" : "+"}${String(Math.floor(p1 / 60)).padStart(2, "0")}${String(p1 % 60).padStart(2, "0")}`;
      }, L = R(u1), R = R(G), G < u1 ? (We(L, B, 17), We(R, U, 17)) : (We(L, U, 17), We(R, B, 17));
    }, fa: () => performance.now(), N: (L) => {
      var R = V.length;
      if (L >>>= 0, 2147483648 < L)
        return !1;
      for (var B = 1; 4 >= B; B *= 2) {
        var U = R * (1 + 0.2 / B);
        U = Math.min(U, L + 100663296);
        e: {
          U = (Math.min(2147483648, 65536 * Math.ceil(Math.max(L, U) / 65536)) - z.buffer.byteLength + 65535) / 65536;
          try {
            z.grow(U), O1();
            var G = 1;
            break e;
          } catch {
          }
          G = void 0;
        }
        if (G)
          return !0;
      }
      return !1;
    }, W: (L, R) => {
      var B = 0;
      return za().forEach((U, G) => {
        var u1 = R + B;
        for (G = Q[L + 4 * G >> 2] = u1, u1 = 0; u1 < U.length; ++u1)
          K[G++] = U.charCodeAt(u1);
        K[G] = 0, B += U.length + 1;
      }), 0;
    }, X: (L, R) => {
      var B = za();
      Q[L >> 2] = B.length;
      var U = 0;
      return B.forEach((G) => U += G.length + 1), Q[R >> 2] = U, 0;
    }, s: () => 52, A: () => 52, I: function() {
      return 70;
    }, z: (L, R, B, U) => {
      for (var G = 0, u1 = 0; u1 < B; u1++) {
        var M1 = Q[R >> 2], p1 = Q[R + 4 >> 2];
        R += 8;
        for (var te = 0; te < p1; te++) {
          var re = L, xe = V[M1 + te], st = ns[re];
          xe === 0 || xe === 10 ? ((re === 1 ? T : D)(V1(st, 0)), st.length = 0) : st.push(xe);
        }
        G += p1;
      }
      return Q[U >> 2] = G, 0;
    }, Y: (L, R) => (Pa(V.subarray(L, L + R)), 0), i: On, d: Ui, e: fr, p: Dt, y: l2, b: wn, a: gr, g: zr, n: Vc, H: B3, V: g0 }, Be = function() {
      var L;
      function R(U) {
        var G;
        return Be = U.exports, z = Be.ga, O1(), Yn = Be.ka, J1.unshift(Be.ha), h1--, (G = s.monitorRunDependencies) == null || G.call(s, h1), h1 == 0 && C1 && (U = C1, C1 = null, U()), Be;
      }
      var B = { a: Bi };
      if (h1++, (L = s.monitorRunDependencies) == null || L.call(s, h1), s.instantiateWasm)
        try {
          return s.instantiateWasm(B, R);
        } catch (U) {
          D(`Module.instantiateWasm callback failed with error: ${U}`), c(U);
        }
      return B1 != null || (B1 = f1("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : s.locateFile ? s.locateFile("DotLottiePlayer.wasm", w) : w + "DotLottiePlayer.wasm"), se(B, function(U) {
        R(U.instance);
      }).catch(c), {};
    }(), Hi = (L) => (Hi = Be.ia)(L), rs = (L) => (rs = Be.ja)(L), ur = (L) => (ur = Be.la)(L), yt = (L, R) => (yt = Be.ma)(L, R), cr = (L, R) => (cr = Be.na)(L, R), Y2 = (L) => (Y2 = Be.oa)(L), Oe = () => (Oe = Be.pa)();
    s.dynCall_iijj = (L, R, B, U, G, u1) => (s.dynCall_iijj = Be.qa)(L, R, B, U, G, u1), s.dynCall_vijj = (L, R, B, U, G, u1) => (s.dynCall_vijj = Be.ra)(L, R, B, U, G, u1), s.dynCall_jiii = (L, R, B, U) => (s.dynCall_jiii = Be.sa)(L, R, B, U), s.dynCall_jii = (L, R, B) => (s.dynCall_jii = Be.ta)(L, R, B);
    var Y0 = s.dynCall_vijjj = (L, R, B, U, G, u1, M1, p1) => (Y0 = s.dynCall_vijjj = Be.ua)(L, R, B, U, G, u1, M1, p1);
    s.dynCall_jiji = (L, R, B, U, G) => (s.dynCall_jiji = Be.va)(L, R, B, U, G), s.dynCall_viijii = (L, R, B, U, G, u1, M1) => (s.dynCall_viijii = Be.wa)(L, R, B, U, G, u1, M1), s.dynCall_iiiiij = (L, R, B, U, G, u1, M1) => (s.dynCall_iiiiij = Be.xa)(L, R, B, U, G, u1, M1), s.dynCall_iiiiijj = (L, R, B, U, G, u1, M1, p1, te) => (s.dynCall_iiiiijj = Be.ya)(L, R, B, U, G, u1, M1, p1, te), s.dynCall_iiiiiijj = (L, R, B, U, G, u1, M1, p1, te, re) => (s.dynCall_iiiiiijj = Be.za)(L, R, B, U, G, u1, M1, p1, te, re);
    function wn(L, R) {
      var B = Oe();
      try {
        Yn.get(L)(R);
      } catch (U) {
        if (Y2(B), U !== U + 0)
          throw U;
        cr(1, 0);
      }
    }
    function gr(L, R, B) {
      var U = Oe();
      try {
        Yn.get(L)(R, B);
      } catch (G) {
        if (Y2(U), G !== G + 0)
          throw G;
        cr(1, 0);
      }
    }
    function fr(L, R, B, U) {
      var G = Oe();
      try {
        return Yn.get(L)(R, B, U);
      } catch (u1) {
        if (Y2(G), u1 !== u1 + 0)
          throw u1;
        cr(1, 0);
      }
    }
    function Ui(L, R, B) {
      var U = Oe();
      try {
        return Yn.get(L)(R, B);
      } catch (G) {
        if (Y2(U), G !== G + 0)
          throw G;
        cr(1, 0);
      }
    }
    function On(L, R) {
      var B = Oe();
      try {
        return Yn.get(L)(R);
      } catch (U) {
        if (Y2(B), U !== U + 0)
          throw U;
        cr(1, 0);
      }
    }
    function Dt(L, R, B, U, G, u1) {
      var M1 = Oe();
      try {
        return Yn.get(L)(R, B, U, G, u1);
      } catch (p1) {
        if (Y2(M1), p1 !== p1 + 0)
          throw p1;
        cr(1, 0);
      }
    }
    function Vc(L, R, B, U, G) {
      var u1 = Oe();
      try {
        Yn.get(L)(R, B, U, G);
      } catch (M1) {
        if (Y2(u1), M1 !== M1 + 0)
          throw M1;
        cr(1, 0);
      }
    }
    function zr(L, R, B, U) {
      var G = Oe();
      try {
        Yn.get(L)(R, B, U);
      } catch (u1) {
        if (Y2(G), u1 !== u1 + 0)
          throw u1;
        cr(1, 0);
      }
    }
    function l2(L) {
      var R = Oe();
      try {
        Yn.get(L)();
      } catch (B) {
        if (Y2(R), B !== B + 0)
          throw B;
        cr(1, 0);
      }
    }
    function B3(L, R, B, U, G, u1, M1, p1) {
      var te = Oe();
      try {
        Y0(L, R, B, U, G, u1, M1, p1);
      } catch (re) {
        if (Y2(te), re !== re + 0)
          throw re;
        cr(1, 0);
      }
    }
    var Wi;
    C1 = function L() {
      Wi || d0(), Wi || (C1 = L);
    };
    function d0() {
      function L() {
        var R;
        if (!Wi && (Wi = !0, s.calledRun = !0, !N)) {
          if (le(J1), g(s), (R = s.onRuntimeInitialized) == null || R.call(s), s.postRun)
            for (typeof s.postRun == "function" && (s.postRun = [s.postRun]); s.postRun.length; ) {
              var B = s.postRun.shift();
              s1.unshift(B);
            }
          le(s1);
        }
      }
      if (!(0 < h1)) {
        if (s.preRun)
          for (typeof s.preRun == "function" && (s.preRun = [s.preRun]); s.preRun.length; )
            d1();
        le(T1), 0 < h1 || (s.setStatus ? (s.setStatus("Running..."), setTimeout(() => {
          setTimeout(() => s.setStatus(""), 1), L();
        }, 1)) : L());
      }
    }
    if (s.preInit)
      for (typeof s.preInit == "function" && (s.preInit = [s.preInit]); 0 < s.preInit.length; )
        s.preInit.pop()();
    return d0(), a = I, a;
  };
})(), bX = yX, DA = class {
  constructor() {
    throw new Error("RendererLoader is a static class and cannot be instantiated.");
  }
  static _tryLoad(e) {
    return It(this, null, function* () {
      return yield bX({ locateFile: () => e });
    });
  }
  static _loadWithBackup() {
    return It(this, null, function* () {
      return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch((e) => It(this, null, function* () {
        let n = `https://unpkg.com/${WM}@${UM}/dist/dotlottie-player.wasm`;
        console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${e.message}`), console.warn(`Attempting to load WASM from backup URL: ${n}`);
        try {
          return yield this._tryLoad(n);
        } catch (i) {
          throw console.error(`Primary WASM URL failed: ${e.message}`), console.error(`Backup WASM URL failed: ${i.message}`), new Error("WASM loading failed from all sources.");
        }
      }))), this._ModulePromise;
    });
  }
  static load() {
    return It(this, null, function* () {
      return this._loadWithBackup();
    });
  }
  static setWasmUrl(e) {
    this._wasmURL = e, this._ModulePromise = null;
  }
};
ct(DA, "_ModulePromise", null), ct(DA, "_wasmURL", `https://cdn.jsdelivr.net/npm/${WM}@${UM}/dist/dotlottie-player.wasm`);
var VM = class {
  constructor() {
    ct(this, "_eventListeners", /* @__PURE__ */ new Map());
  }
  addEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i || (i = /* @__PURE__ */ new Set(), this._eventListeners.set(e, i)), i.add(n);
  }
  removeEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i && (n ? (i.delete(n), i.size === 0 && this._eventListeners.delete(e)) : this._eventListeners.delete(e));
  }
  dispatch(e) {
    let n = this._eventListeners.get(e.type);
    n == null || n.forEach((i) => i(e));
  }
  removeAllEventListeners() {
    this._eventListeners.clear();
  }
}, Ri = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let a = this._observedCanvases.get(i.target);
        a && (i.isIntersecting ? a.unfreeze() : a.freeze());
      });
    };
    this._observer = new IntersectionObserver(e, { threshold: 0 });
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, n), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
ct(Ri, "_observer", null), ct(Ri, "_observedCanvases", /* @__PURE__ */ new Map());
var Oi = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let a = this._observedCanvases.get(i.target);
        if (!a)
          return;
        let [s, g] = a;
        clearTimeout(g);
        let c = setTimeout(() => {
          s.resize();
        }, 100);
        this._observedCanvases.set(i.target, [s, c]);
      });
    };
    this._observer = new ResizeObserver(e);
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, [n, 0]), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
ct(Oi, "_observer", null), ct(Oi, "_observedCanvases", /* @__PURE__ */ new Map());
function wX(e) {
  return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(e);
}
function xX(e) {
  if (!wX(e))
    return 0;
  let n = e.replace("#", "");
  return n = n.length === 6 ? `${n}ff` : n, parseInt(n, 16);
}
function px(e) {
  if (e.byteLength < 4)
    return !1;
  let n = new Uint8Array(e.slice(0, A7.byteLength));
  for (let i = 0; i < A7.length; i += 1)
    if (A7[i] !== n[i])
      return !1;
  return !0;
}
function hx(e) {
  return mX.every((n) => Object.prototype.hasOwnProperty.call(e, n));
}
function mx(e) {
  if (typeof e == "string")
    try {
      return hx(JSON.parse(e));
    } catch {
      return !1;
    }
  else
    return hx(e);
}
function df() {
  return 1 + ((Or ? window.devicePixelRatio : 1) - 1) * vX;
}
function _M(e) {
  let n = e.getBoundingClientRect();
  return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var I7 = (e, n) => e === "reverse" ? n.Mode.Reverse : e === "bounce" ? n.Mode.Bounce : e === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward, p7 = (e, n) => e === "contain" ? n.Fit.Contain : e === "cover" ? n.Fit.Cover : e === "fill" ? n.Fit.Fill : e === "fit-height" ? n.Fit.FitHeight : e === "fit-width" ? n.Fit.FitWidth : n.Fit.None, h7 = (e, n) => {
  let i = new n.VectorFloat();
  return i.push_back(e[0]), i.push_back(e[1]), i;
}, m7 = (e, n) => {
  let i = new n.VectorFloat();
  return e.length !== 2 || (i.push_back(e[0]), i.push_back(e[1])), i;
}, JM = class Ln {
  constructor(n) {
    ct(this, "_canvas"), ct(this, "_context", null), ct(this, "_eventManager"), ct(this, "_animationFrameId", null), ct(this, "_frameManager"), ct(this, "_dotLottieCore", null), ct(this, "_renderConfig", {}), ct(this, "_isFrozen", !1), ct(this, "_backgroundColor", null), ct(this, "_pointerUpMethod"), ct(this, "_pointerDownMethod"), ct(this, "_pointerMoveMethod"), ct(this, "_pointerEnterMethod"), ct(this, "_pointerExitMethod");
    var i, a, s;
    this._canvas = n.canvas, this._context = this._canvas.getContext("2d"), this._eventManager = new VM(), this._frameManager = new hX(), this._renderConfig = m3(ir({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || df(), freezeOnOffscreen: (s = (a = n.renderConfig) == null ? void 0 : a.freezeOnOffscreen) != null ? s : !0 }), DA.load().then((g) => {
      var c, I, h, m, w, S, T;
      Ln._wasmModule = g, this._dotLottieCore = new g.DotLottiePlayer({ autoplay: (c = n.autoplay) != null ? c : !1, backgroundColor: 0, loopAnimation: (I = n.loop) != null ? I : !1, mode: I7((h = n.mode) != null ? h : "forward", g), segment: m7((m = n.segment) != null ? m : [], g), speed: (w = n.speed) != null ? w : 1, useFrameInterpolation: (S = n.useFrameInterpolation) != null ? S : !0, marker: (T = n.marker) != null ? T : "", layout: n.layout ? { align: h7(n.layout.align, g), fit: p7(n.layout.fit, g) } : g.createDefaultLayout() }), this._eventManager.dispatch({ type: "ready" }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), n.backgroundColor && this.setBackgroundColor(n.backgroundColor);
    }).catch((g) => {
      this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to load wasm module: ${g}`) });
    }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _dispatchError(n) {
    console.error(n), this._eventManager.dispatch({ type: "loadError", error: new Error(n) });
  }
  _fetchData(n) {
    return It(this, null, function* () {
      let i = yield fetch(n);
      if (!i.ok)
        throw new Error(`Failed to fetch animation data from URL: ${n}. ${i.status}: ${i.statusText}`);
      let a = yield i.arrayBuffer();
      return px(a) ? a : new TextDecoder().decode(a);
    });
  }
  _loadFromData(n) {
    if (this._dotLottieCore === null)
      return;
    let i = this._canvas.width, a = this._canvas.height, s = !1;
    if (typeof n == "string") {
      if (!mx(n)) {
        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
        return;
      }
      s = this._dotLottieCore.loadAnimationData(n, i, a);
    } else if (n instanceof ArrayBuffer) {
      if (!px(n)) {
        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
        return;
      }
      s = this._dotLottieCore.loadDotLottieData(n, i, a);
    } else if (typeof n == "object") {
      if (!mx(n)) {
        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
        return;
      }
      s = this._dotLottieCore.loadAnimationData(JSON.stringify(n), i, a);
    } else {
      this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof n}`);
      return;
    }
    s ? (this._eventManager.dispatch({ type: "load" }), Or && this.resize(), this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), Or && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && Ri.observe(this._canvas, this), this._renderConfig.autoResize && Oi.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
  }
  _loadFromSrc(n) {
    this._fetchData(n).then((i) => this._loadFromData(i)).catch((i) => this._dispatchError(`Failed to load animation data from URL: ${n}. ${i}`));
  }
  get activeAnimationId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeAnimationId();
  }
  get activeThemeId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeThemeId();
  }
  get layout() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().layout;
    if (i)
      return { align: [i.align.get(0), i.align.get(1)], fit: (() => {
        var a, s, g, c, I, h;
        switch (i.fit) {
          case ((a = Ln._wasmModule) == null ? void 0 : a.Fit.Contain):
            return "contain";
          case ((s = Ln._wasmModule) == null ? void 0 : s.Fit.Cover):
            return "cover";
          case ((g = Ln._wasmModule) == null ? void 0 : g.Fit.Fill):
            return "fill";
          case ((c = Ln._wasmModule) == null ? void 0 : c.Fit.FitHeight):
            return "fit-height";
          case ((I = Ln._wasmModule) == null ? void 0 : I.Fit.FitWidth):
            return "fit-width";
          case ((h = Ln._wasmModule) == null ? void 0 : h.Fit.None):
            return "none";
          default:
            return "contain";
        }
      })() };
  }
  get marker() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.config().marker;
  }
  get manifest() {
    var n;
    try {
      let i = (n = this._dotLottieCore) == null ? void 0 : n.manifestString();
      if (this._dotLottieCore === null || !i)
        return null;
      let a = JSON.parse(i);
      return Object.keys(a).length === 0 ? null : a;
    } catch {
      return null;
    }
  }
  get renderConfig() {
    return this._renderConfig;
  }
  get segment() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().segment;
    if (i && i.size() === 2)
      return [i.get(0), i.get(1)];
  }
  get loop() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().loopAnimation) != null ? i : !1;
  }
  get mode() {
    var n, i, a, s;
    let g = (n = this._dotLottieCore) == null ? void 0 : n.config().mode;
    return g === ((i = Ln._wasmModule) == null ? void 0 : i.Mode.Reverse) ? "reverse" : g === ((a = Ln._wasmModule) == null ? void 0 : a.Mode.Bounce) ? "bounce" : g === ((s = Ln._wasmModule) == null ? void 0 : s.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
  }
  get isFrozen() {
    return this._isFrozen;
  }
  get backgroundColor() {
    var n;
    return (n = this._backgroundColor) != null ? n : "";
  }
  get autoplay() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().autoplay) != null ? i : !1;
  }
  get useFrameInterpolation() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().useFrameInterpolation) != null ? i : !1;
  }
  get speed() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().speed) != null ? i : 0;
  }
  get isReady() {
    return this._dotLottieCore !== null;
  }
  get isLoaded() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isLoaded()) != null ? i : !1;
  }
  get isPlaying() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPlaying()) != null ? i : !1;
  }
  get isPaused() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPaused()) != null ? i : !1;
  }
  get isStopped() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isStopped()) != null ? i : !1;
  }
  get currentFrame() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.currentFrame()) != null ? i : 0;
  }
  get loopCount() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.loopCount()) != null ? i : 0;
  }
  get totalFrames() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.totalFrames()) != null ? i : 0;
  }
  get duration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.duration()) != null ? i : 0;
  }
  get segmentDuration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.segmentDuration()) != null ? i : 0;
  }
  get canvas() {
    return this._canvas;
  }
  load(n) {
    var i, a, s, g, c, I, h, m;
    this._dotLottieCore === null || Ln._wasmModule === null || (this._dotLottieCore.setConfig({ autoplay: (i = n.autoplay) != null ? i : !1, backgroundColor: 0, loopAnimation: (a = n.loop) != null ? a : !1, mode: I7((s = n.mode) != null ? s : "forward", Ln._wasmModule), segment: m7((g = n.segment) != null ? g : [], Ln._wasmModule), speed: (c = n.speed) != null ? c : 1, useFrameInterpolation: (I = n.useFrameInterpolation) != null ? I : !0, marker: (h = n.marker) != null ? h : "", layout: n.layout ? { align: h7(n.layout.align, Ln._wasmModule), fit: p7(n.layout.fit, Ln._wasmModule) } : Ln._wasmModule.createDefaultLayout() }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor((m = n.backgroundColor) != null ? m : ""));
  }
  _render() {
    if (this._dotLottieCore === null || this._context === null)
      return !1;
    if (this._dotLottieCore.render()) {
      let n = this._dotLottieCore.buffer(), i = new Uint8ClampedArray(n, 0, this._canvas.width * this._canvas.height * 4), a = null;
      return typeof ImageData > "u" ? (a = this._context.createImageData(this._canvas.width, this._canvas.height), a.data.set(i)) : a = new ImageData(i, this._canvas.width, this._canvas.height), this._context.putImageData(a, 0, 0), this._eventManager.dispatch({ type: "render", currentFrame: this._dotLottieCore.currentFrame() }), !0;
    }
    return !1;
  }
  _draw() {
    if (this._dotLottieCore === null || this._context === null || !this._dotLottieCore.isPlaying())
      return;
    let n = this._dotLottieCore.requestFrame();
    this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render() && this._dotLottieCore.isComplete() && (this._dotLottieCore.config().loopAnimation ? this._eventManager.dispatch({ type: "loop", loopCount: this._dotLottieCore.loopCount() }) : this._eventManager.dispatch({ type: "complete" }))), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
  }
  play() {
    this._dotLottieCore !== null && ((this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = !1, this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), Or && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !_M(this._canvas) && this.freeze());
  }
  pause() {
    this._dotLottieCore !== null && (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({ type: "pause" });
  }
  stop() {
    this._dotLottieCore !== null && this._dotLottieCore.stop() && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._eventManager.dispatch({ type: "stop" }));
  }
  setFrame(n) {
    this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames() || this._dotLottieCore.seek(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render());
  }
  setSpeed(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { speed: n }));
  }
  setBackgroundColor(n) {
    this._dotLottieCore !== null && (Or && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { backgroundColor: xX(n) })), this._backgroundColor = n);
  }
  setLoop(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { loopAnimation: n }));
  }
  setUseFrameInterpolation(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { useFrameInterpolation: n }));
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  destroy() {
    var n;
    Or && this._canvas instanceof HTMLCanvasElement && (Ri.unobserve(this._canvas), Oi.unobserve(this._canvas)), (n = this._dotLottieCore) == null || n.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({ type: "destroy" }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
  }
  freeze() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = !0, this._eventManager.dispatch({ type: "freeze" }));
  }
  unfreeze() {
    this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = !1, this._eventManager.dispatch({ type: "unfreeze" }));
  }
  resize() {
    if (!(!this._dotLottieCore || !this.isLoaded)) {
      if (Or && this._canvas instanceof HTMLCanvasElement) {
        let n = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: i, width: a } = this._canvas.getBoundingClientRect();
        this._canvas.width = a * n, this._canvas.height = i * n;
      }
      this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
  }
  setSegment(n, i) {
    this._dotLottieCore === null || Ln._wasmModule === null || this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { segment: m7([n, i], Ln._wasmModule) }));
  }
  setMode(n) {
    this._dotLottieCore === null || Ln._wasmModule === null || this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { mode: I7(n, Ln._wasmModule) }));
  }
  setRenderConfig(n) {
    let i = n, { devicePixelRatio: a, freezeOnOffscreen: s } = i, g = HM(i, ["devicePixelRatio", "freezeOnOffscreen"]);
    this._renderConfig = m3(ir(ir({}, this._renderConfig), g), { devicePixelRatio: a || df(), freezeOnOffscreen: s ?? !0 }), Or && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? Oi.observe(this._canvas, this) : Oi.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? Ri.observe(this._canvas, this) : (Ri.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
  }
  loadAnimation(n) {
    this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n || (this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({ type: "load" }), this.resize()) : this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to animation :${n}`) }));
  }
  setMarker(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { marker: n }));
  }
  markers() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.markers();
    if (i) {
      let a = [];
      for (let s = 0; s < i.size(); s += 1) {
        let g = i.get(s);
        a.push({ name: g.name, time: g.time, duration: g.duration });
      }
      return a;
    }
    return [];
  }
  loadTheme(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.loadTheme(n);
    return this._render(), i;
  }
  loadThemeData(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.loadThemeData(n);
    return this._render(), i;
  }
  setLayout(n) {
    this._dotLottieCore === null || Ln._wasmModule === null || this._dotLottieCore.setConfig(m3(ir({}, this._dotLottieCore.config()), { layout: { align: h7(n.align, Ln._wasmModule), fit: p7(n.fit, Ln._wasmModule) } }));
  }
  setViewport(n, i, a, s) {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.setViewport(n, i, a, s);
  }
  static setWasmUrl(n) {
    DA.setWasmUrl(n);
  }
  loadStateMachine(n) {
    var i, a;
    return (a = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachine(n)) != null ? a : !1;
  }
  startStateMachine() {
    var n, i;
    let a = (i = (n = this._dotLottieCore) == null ? void 0 : n.startStateMachine()) != null ? i : !1;
    return a && this._setupStateMachineListeners(), a;
  }
  stopStateMachine() {
    var n, i;
    let a = (i = (n = this._dotLottieCore) == null ? void 0 : n.stopStateMachine()) != null ? i : !1;
    return a && this._cleanupStateMachineListeners(), a;
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), a = this._canvas.width / i.width, s = this._canvas.height / i.height, g = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, c = (n.clientX - i.left) * a / g, I = (n.clientY - i.top) * s / g;
    return { x: c, y: I };
  }
  _onPointerUp(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerUpEvent(i, a);
  }
  _onPointerDown(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerDownEvent(i, a);
  }
  _onPointerMove(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerMoveEvent(i, a);
  }
  _onPointerEnter(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerEnterEvent(i, a);
  }
  _onPointerLeave(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerExitEvent(i, a);
  }
  postPointerUpEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerUpEvent(n, i);
  }
  postPointerDownEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerDownEvent(n, i);
  }
  postPointerMoveEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerMoveEvent(n, i);
  }
  postPointerEnterEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerEnterEvent(n, i);
  }
  postPointerExitEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerExitEvent(n, i);
  }
  getStateMachineListeners() {
    if (!this._dotLottieCore)
      return [];
    let n = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
    for (let a = 0; a < n.size(); a += 1)
      i.push(n.get(a));
    return i;
  }
  _setupStateMachineListeners() {
    if (Or && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
      let n = this.getStateMachineListeners();
      n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    Or && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
  loadStateMachineData(n) {
    var i, a;
    return (a = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachineData(n)) != null ? a : !1;
  }
  animationSize() {
    var n, i, a, s;
    let g = (i = (n = this._dotLottieCore) == null ? void 0 : n.animationSize().get(0)) != null ? i : 0, c = (s = (a = this._dotLottieCore) == null ? void 0 : a.animationSize().get(1)) != null ? s : 0;
    return { width: g, height: c };
  }
  setStateMachineBooleanContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineBooleanContext(n, i)) != null ? s : !1;
  }
  setStateMachineNumericContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineNumericContext(n, i)) != null ? s : !1;
  }
  setStateMachineStringContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineStringContext(n, i)) != null ? s : !1;
  }
};
ct(JM, "_wasmModule", null);
var SX = JM, EX = class {
  constructor() {
    if (typeof Worker > "u")
      throw new Error("Worker is not supported in this environment.");
    let e = new Blob([new Uint8Array([34, 117, 115, 101, 32, 115, 116, 114, 105, 99, 116, 34, 59, 10, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 105, 101, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 68, 101, 115, 99, 114, 105, 112, 116, 111, 114, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 83, 121, 109, 98, 111, 108, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 112, 114, 111, 112, 101, 114, 116, 121, 73, 115, 69, 110, 117, 109, 101, 114, 97, 98, 108, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 107, 101, 121, 32, 105, 110, 32, 111, 98, 106, 32, 63, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 123, 32, 101, 110, 117, 109, 101, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 99, 111, 110, 102, 105, 103, 117, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 118, 97, 108, 117, 101, 32, 125, 41, 32, 58, 32, 111, 98, 106, 91, 107, 101, 121, 93, 32, 61, 32, 118, 97, 108, 117, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 98, 32, 124, 124, 32, 40, 98, 32, 61, 32, 123, 125, 41, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 98, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 40, 97, 44, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 40, 98, 41, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 32, 61, 32, 40, 115, 111, 117, 114, 99, 101, 44, 32, 101, 120, 99, 108, 117, 100, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 116, 97, 114, 103, 101, 116, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 115, 111, 117, 114, 99, 101, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 32, 38, 38, 32, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 111, 117, 114, 99, 101, 32, 33, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 115, 111, 117, 114, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 32, 38, 38, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 97, 114, 103, 101, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 116, 121, 112, 101, 111, 102, 32, 107, 101, 121, 32, 33, 61, 61, 32, 34, 115, 121, 109, 98, 111, 108, 34, 32, 63, 32, 107, 101, 121, 32, 43, 32, 34, 34, 32, 58, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 97, 115, 121, 110, 99, 32, 61, 32, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 44, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 114, 101, 115, 111, 108, 118, 101, 44, 32, 114, 101, 106, 101, 99, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 117, 108, 102, 105, 108, 108, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 110, 101, 120, 116, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 101, 106, 101, 99, 116, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 116, 104, 114, 111, 119, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 116, 101, 112, 32, 61, 32, 40, 120, 41, 32, 61, 62, 32, 120, 46, 100, 111, 110, 101, 32, 63, 32, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 46, 116, 104, 101, 110, 40, 102, 117, 108, 102, 105, 108, 108, 101, 100, 44, 32, 114, 101, 106, 101, 99, 116, 101, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 32, 61, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 97, 112, 112, 108, 121, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 41, 41, 46, 110, 101, 120, 116, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 97, 110, 105, 109, 97, 116, 105, 111, 110, 45, 102, 114, 97, 109, 101, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 34, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 62, 61, 32, 78, 117, 109, 98, 101, 114, 46, 77, 65, 88, 95, 83, 65, 70, 69, 95, 73, 78, 84, 69, 71, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 32, 61, 32, 115, 101, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 108, 108, 98, 97, 99, 107, 40, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 95, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 115, 116, 114, 97, 116, 101, 103, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 63, 32, 110, 101, 119, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 32, 58, 32, 110, 101, 119, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 110, 115, 116, 97, 110, 116, 115, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 46, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 59, 10, 32, 32, 118, 97, 114, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 91, 56, 48, 44, 32, 55, 53, 44, 32, 51, 44, 32, 52, 93, 41, 59, 10, 32, 32, 118, 97, 114, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 32, 61, 32, 91, 34, 118, 34, 44, 32, 34, 105, 112, 34, 44, 32, 34, 111, 112, 34, 44, 32, 34, 108, 97, 121, 101, 114, 115, 34, 44, 32, 34, 102, 114, 34, 44, 32, 34, 119, 34, 44, 32, 34, 104, 34, 93, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 32, 61, 32, 34, 48, 46, 51, 53, 46, 48, 34, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 32, 61, 32, 34, 64, 108, 111, 116, 116, 105, 101, 102, 105, 108, 101, 115, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 101, 98, 34, 59, 10, 32, 32, 118, 97, 114, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 32, 61, 32, 48, 46, 55, 53, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 106, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 32, 61, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 63, 32, 40, 95, 97, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 114, 99, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 109, 111, 100, 117, 108, 101, 65, 114, 103, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 109, 111, 100, 117, 108, 101, 65, 114, 103, 44, 32, 97, 97, 44, 32, 98, 97, 44, 32, 99, 97, 32, 61, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 44, 32, 100, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 125, 44, 32, 107, 41, 44, 32, 101, 97, 32, 61, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 44, 32, 112, 32, 61, 32, 34, 34, 44, 32, 102, 97, 59, 10, 32, 32, 32, 32, 32, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 38, 38, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 32, 38, 38, 32, 40, 112, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 38, 38, 32, 40, 112, 32, 61, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 112, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 98, 108, 111, 98, 58, 34, 41, 32, 63, 32, 112, 32, 61, 32, 34, 34, 32, 58, 32, 112, 32, 61, 32, 112, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 112, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 63, 35, 93, 46, 42, 47, 44, 32, 34, 34, 41, 46, 108, 97, 115, 116, 73, 110, 100, 101, 120, 79, 102, 40, 34, 47, 34, 41, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 102, 101, 116, 99, 104, 40, 97, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 98, 46, 111, 107, 32, 63, 32, 98, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 106, 101, 99, 116, 40, 69, 114, 114, 111, 114, 40, 98, 46, 115, 116, 97, 116, 117, 115, 32, 43, 32, 34, 32, 58, 32, 34, 32, 43, 32, 98, 46, 117, 114, 108, 41, 41, 10, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 106, 97, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 108, 111, 103, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 44, 32, 116, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 69, 114, 114, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 107, 44, 32, 100, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 100, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 32, 38, 38, 32, 40, 101, 97, 32, 61, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 97, 32, 61, 32, 107, 46, 119, 97, 115, 109, 66, 105, 110, 97, 114, 121, 44, 32, 108, 97, 44, 32, 109, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 110, 97, 44, 32, 117, 44, 32, 120, 44, 32, 121, 44, 32, 122, 44, 32, 67, 44, 32, 68, 44, 32, 111, 97, 44, 32, 112, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 56, 32, 61, 32, 117, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 49, 54, 32, 61, 32, 121, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 56, 32, 61, 32, 120, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 49, 54, 32, 61, 32, 122, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 51, 50, 32, 61, 32, 67, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 51, 50, 32, 61, 32, 68, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 51, 50, 32, 61, 32, 111, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 54, 52, 32, 61, 32, 112, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 97, 32, 61, 32, 91, 93, 44, 32, 115, 97, 32, 61, 32, 91, 93, 44, 32, 116, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 48, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 65, 98, 111, 114, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 34, 65, 98, 111, 114, 116, 101, 100, 40, 34, 32, 43, 32, 97, 32, 43, 32, 34, 41, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 110, 101, 119, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 40, 97, 32, 43, 32, 34, 46, 32, 66, 117, 105, 108, 100, 32, 119, 105, 116, 104, 32, 45, 115, 65, 83, 83, 69, 82, 84, 73, 79, 78, 83, 32, 102, 111, 114, 32, 109, 111, 114, 101, 32, 105, 110, 102, 111, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 97, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 100, 97, 116, 97, 58, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 111, 99, 116, 101, 116, 45, 115, 116, 114, 101, 97, 109, 59, 98, 97, 115, 101, 54, 52, 44, 34, 41, 44, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 32, 61, 61, 32, 121, 97, 32, 38, 38, 32, 107, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 107, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 34, 98, 111, 116, 104, 32, 97, 115, 121, 110, 99, 32, 97, 110, 100, 32, 115, 121, 110, 99, 32, 102, 101, 116, 99, 104, 105, 110, 103, 32, 111, 102, 32, 116, 104, 101, 32, 119, 97, 115, 109, 32, 102, 97, 105, 108, 101, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 63, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 41, 46, 116, 104, 101, 110, 40, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 41, 32, 58, 32, 102, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 40, 100, 44, 32, 98, 41, 41, 46, 116, 104, 101, 110, 40, 99, 44, 32, 40, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 102, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 115, 121, 110, 99, 104, 114, 111, 110, 111, 117, 115, 108, 121, 32, 112, 114, 101, 112, 97, 114, 101, 32, 119, 97, 115, 109, 58, 32, 36, 123, 100, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 67, 97, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 32, 124, 124, 32, 120, 97, 40, 99, 41, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 102, 101, 116, 99, 104, 32, 63, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 32, 58, 32, 102, 101, 116, 99, 104, 40, 99, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 40, 100, 44, 32, 97, 41, 46, 116, 104, 101, 110, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 119, 97, 115, 109, 32, 115, 116, 114, 101, 97, 109, 105, 110, 103, 32, 99, 111, 109, 112, 105, 108, 101, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 34, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 68, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 69, 120, 105, 116, 83, 116, 97, 116, 117, 115, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 96, 80, 114, 111, 103, 114, 97, 109, 32, 116, 101, 114, 109, 105, 110, 97, 116, 101, 100, 32, 119, 105, 116, 104, 32, 101, 120, 105, 116, 40, 36, 123, 97, 125, 41, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 116, 97, 116, 117, 115, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 48, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 97, 46, 115, 104, 105, 102, 116, 40, 41, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 97, 32, 61, 32, 107, 46, 110, 111, 69, 120, 105, 116, 82, 117, 110, 116, 105, 109, 101, 32, 124, 124, 32, 116, 114, 117, 101, 44, 32, 71, 97, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 72, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 99, 32, 61, 32, 98, 59, 32, 97, 91, 99, 93, 32, 38, 38, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 54, 32, 60, 32, 99, 32, 45, 32, 98, 32, 38, 38, 32, 97, 46, 98, 117, 102, 102, 101, 114, 32, 38, 38, 32, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 71, 97, 46, 100, 101, 99, 111, 100, 101, 40, 97, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 98, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 34, 34, 59, 32, 98, 32, 60, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 97, 91, 98, 43, 43, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 38, 32, 49, 50, 56, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 57, 50, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 50, 52, 41, 41, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 40, 101, 32, 38, 32, 51, 49, 41, 32, 60, 60, 32, 54, 32, 124, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 50, 50, 52, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 52, 48, 41, 32, 63, 32, 40, 101, 32, 38, 32, 49, 53, 41, 32, 60, 60, 32, 49, 50, 32, 124, 32, 102, 32, 60, 60, 32, 54, 32, 124, 32, 104, 32, 58, 32, 40, 101, 32, 38, 32, 55, 41, 32, 60, 60, 32, 49, 56, 32, 124, 32, 102, 32, 60, 60, 32, 49, 50, 32, 124, 32, 104, 32, 60, 60, 32, 54, 32, 124, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 62, 32, 101, 32, 63, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 32, 58, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 72, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 67, 97, 32, 61, 32, 97, 32, 45, 32, 50, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 73, 97, 32, 61, 32, 48, 44, 32, 74, 97, 32, 61, 32, 48, 44, 32, 73, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 120, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 60, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 32, 43, 32, 99, 32, 45, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 50, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 48, 52, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 49, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 57, 50, 32, 124, 32, 102, 32, 62, 62, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 54, 53, 53, 51, 53, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 50, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 50, 52, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 51, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 52, 48, 32, 124, 32, 102, 32, 62, 62, 32, 49, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 54, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 97, 32, 61, 32, 123, 125, 44, 32, 76, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 111, 112, 40, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 74, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 97, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 75, 32, 61, 32, 123, 125, 44, 32, 76, 32, 61, 32, 123, 125, 44, 32, 77, 97, 32, 61, 32, 123, 125, 44, 32, 77, 44, 32, 79, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 99, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 97, 46, 108, 101, 110, 103, 116, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 77, 105, 115, 109, 97, 116, 99, 104, 101, 100, 32, 116, 121, 112, 101, 32, 99, 111, 110, 118, 101, 114, 116, 101, 114, 32, 99, 111, 117, 110, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 108, 41, 32, 78, 40, 97, 91, 108, 93, 44, 32, 103, 91, 108, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 41, 32, 61, 62, 32, 77, 97, 91, 103, 93, 32, 61, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 114, 114, 97, 121, 40, 98, 46, 108, 101, 110, 103, 116, 104, 41, 44, 32, 102, 32, 61, 32, 91, 93, 44, 32, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 63, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 32, 58, 32, 40, 102, 46, 112, 117, 115, 104, 40, 103, 41, 44, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 124, 124, 32, 40, 75, 91, 103, 93, 32, 61, 32, 91, 93, 41, 44, 32, 75, 91, 103, 93, 46, 112, 117, 115, 104, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 97, 44, 32, 80, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 34, 34, 59, 32, 120, 91, 97, 93, 59, 32, 41, 32, 98, 32, 43, 61, 32, 78, 97, 91, 120, 91, 97, 43, 43, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 116, 121, 112, 101, 32, 34, 36, 123, 100, 125, 34, 32, 109, 117, 115, 116, 32, 104, 97, 118, 101, 32, 97, 32, 112, 111, 115, 105, 116, 105, 118, 101, 32, 105, 110, 116, 101, 103, 101, 114, 32, 116, 121, 112, 101, 105, 100, 32, 112, 111, 105, 110, 116, 101, 114, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 46, 104, 98, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 116, 121, 112, 101, 32, 39, 36, 123, 100, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 91, 97, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 77, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 75, 91, 97, 93, 44, 32, 100, 101, 108, 101, 116, 101, 32, 75, 91, 97, 93, 44, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 101, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 78, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 80, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 97, 46, 65, 97, 46, 68, 97, 46, 66, 97, 46, 110, 97, 109, 101, 32, 43, 32, 34, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 97, 108, 114, 101, 97, 100, 121, 32, 100, 101, 108, 101, 116, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 82, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 84, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 61, 61, 61, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 46, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 84, 97, 40, 97, 44, 32, 98, 44, 32, 99, 46, 71, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 32, 63, 32, 110, 117, 108, 108, 32, 58, 32, 99, 46, 36, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 97, 32, 61, 32, 123, 125, 44, 32, 82, 32, 61, 32, 91, 93, 44, 32, 86, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 82, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 82, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 77, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 97, 44, 32, 88, 97, 32, 61, 32, 123, 125, 44, 32, 89, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 112, 116, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 71, 97, 59, 32, 41, 32, 98, 32, 61, 32, 97, 46, 80, 97, 40, 98, 41, 44, 32, 97, 32, 61, 32, 97, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 36, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 68, 97, 32, 124, 124, 32, 33, 98, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 109, 97, 107, 101, 67, 108, 97, 115, 115, 72, 97, 110, 100, 108, 101, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 112, 116, 114, 32, 97, 110, 100, 32, 112, 116, 114, 84, 121, 112, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 33, 98, 46, 72, 97, 32, 33, 61, 61, 32, 33, 33, 98, 46, 69, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 66, 111, 116, 104, 32, 115, 109, 97, 114, 116, 80, 116, 114, 84, 121, 112, 101, 32, 97, 110, 100, 32, 115, 109, 97, 114, 116, 80, 116, 114, 32, 109, 117, 115, 116, 32, 98, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 99, 111, 117, 110, 116, 32, 61, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 49, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 40, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 44, 32, 123, 32, 65, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 32, 125, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 61, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 41, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 98, 44, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 32, 61, 32, 110, 101, 119, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 40, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 98, 46, 69, 97, 32, 63, 32, 98, 46, 72, 97, 46, 75, 97, 40, 98, 46, 69, 97, 41, 32, 58, 32, 98, 46, 68, 97, 46, 66, 97, 46, 75, 97, 40, 98, 46, 67, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 69, 97, 32, 38, 38, 32, 81, 97, 46, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 44, 32, 123, 32, 65, 97, 58, 32, 99, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 46, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 32, 125, 41, 44, 32, 99, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 70, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 91, 98, 93, 46, 70, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 101, 46, 108, 101, 110, 103, 116, 104, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 70, 117, 110, 99, 116, 105, 111, 110, 32, 39, 36, 123, 99, 125, 39, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 97, 110, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 101, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 115, 32, 111, 110, 101, 32, 111, 102, 32, 40, 36, 123, 97, 91, 98, 93, 46, 70, 97, 125, 41, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 91, 98, 93, 46, 70, 97, 91, 101, 46, 108, 101, 110, 103, 116, 104, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 70, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 70, 97, 91, 100, 46, 81, 97, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 100, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 112, 117, 98, 108, 105, 99, 32, 110, 97, 109, 101, 32, 39, 36, 123, 97, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 107, 44, 32, 97, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 99, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 111, 118, 101, 114, 108, 111, 97, 100, 115, 32, 111, 102, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 105, 116, 104, 32, 116, 104, 101, 32, 115, 97, 109, 101, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 99, 125, 41, 33, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 38, 38, 32, 40, 107, 91, 97, 93, 46, 113, 98, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 101, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 95, 117, 110, 107, 110, 111, 119, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 94, 97, 45, 122, 65, 45, 90, 48, 45, 57, 95, 93, 47, 103, 44, 32, 34, 36, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 56, 32, 60, 61, 32, 98, 32, 38, 38, 32, 53, 55, 32, 62, 61, 32, 98, 32, 63, 32, 96, 95, 36, 123, 97, 125, 96, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 102, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 78, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 75, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 71, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 98, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 80, 97, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 36, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 106, 98, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 98, 32, 33, 61, 61, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 117, 108, 108, 32, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 99, 46, 110, 97, 109, 101, 125, 44, 32, 103, 111, 116, 32, 97, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 98, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 80, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 85, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 75, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 32, 124, 124, 32, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 82, 97, 32, 38, 38, 32, 98, 46, 65, 97, 46, 68, 97, 46, 82, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 72, 97, 32, 63, 32, 98, 46, 65, 97, 46, 72, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 46, 65, 97, 46, 69, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 80, 97, 115, 115, 105, 110, 103, 32, 114, 97, 119, 32, 112, 111, 105, 110, 116, 101, 114, 32, 116, 111, 32, 115, 109, 97, 114, 116, 32, 112, 111, 105, 110, 116, 101, 114, 32, 105, 115, 32, 105, 108, 108, 101, 103, 97, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 116, 104, 105, 115, 46, 111, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 72, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 72, 97, 32, 63, 32, 98, 46, 65, 97, 46, 72, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 72, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 107, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 98, 40, 40, 41, 32, 61, 62, 32, 100, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 75, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 110, 115, 117, 112, 112, 111, 114, 116, 105, 110, 103, 32, 115, 104, 97, 114, 105, 110, 103, 32, 112, 111, 108, 105, 99, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 68, 97, 46, 82, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 66, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 84, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 82, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 83, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 105, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 111, 98, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 85, 97, 32, 61, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 107, 98, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 75, 97, 32, 61, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 98, 46, 71, 97, 32, 63, 32, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 106, 98, 32, 58, 32, 40, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 100, 32, 63, 32, 104, 98, 32, 58, 32, 108, 98, 44, 32, 116, 104, 105, 115, 46, 74, 97, 32, 61, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 82, 101, 112, 108, 97, 99, 105, 110, 103, 32, 110, 111, 110, 101, 120, 105, 115, 116, 101, 110, 116, 32, 112, 117, 98, 108, 105, 99, 32, 115, 121, 109, 98, 111, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 63, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 32, 61, 32, 98, 32, 58, 32, 40, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 81, 97, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 44, 32, 111, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 91, 93, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 40, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 112, 47, 103, 44, 32, 34, 105, 34, 41, 44, 32, 98, 32, 61, 32, 40, 48, 44, 32, 107, 91, 34, 100, 121, 110, 67, 97, 108, 108, 95, 34, 32, 43, 32, 97, 93, 41, 40, 98, 44, 32, 46, 46, 46, 99, 41, 41, 32, 58, 32, 98, 32, 61, 32, 83, 46, 103, 101, 116, 40, 98, 41, 40, 46, 46, 46, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 112, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 46, 46, 46, 99, 41, 32, 61, 62, 32, 111, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 84, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 112, 98, 40, 97, 44, 32, 98, 41, 32, 58, 32, 83, 46, 103, 101, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 111, 105, 110, 116, 101, 114, 32, 119, 105, 116, 104, 32, 115, 105, 103, 110, 97, 116, 117, 114, 101, 32, 36, 123, 97, 125, 58, 32, 36, 123, 98, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 113, 98, 44, 32, 115, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 114, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 102, 93, 32, 124, 124, 32, 76, 91, 102, 93, 32, 124, 124, 32, 40, 77, 97, 91, 102, 93, 32, 63, 32, 77, 97, 91, 102, 93, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 32, 58, 32, 40, 100, 46, 112, 117, 115, 104, 40, 102, 41, 44, 32, 101, 91, 102, 93, 32, 61, 32, 116, 114, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 44, 32, 101, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 113, 98, 40, 96, 36, 123, 97, 125, 58, 32, 96, 32, 43, 32, 100, 46, 109, 97, 112, 40, 115, 98, 41, 46, 106, 111, 105, 110, 40, 91, 34, 44, 32, 34, 93, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 117, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 100, 43, 43, 41, 32, 99, 46, 112, 117, 115, 104, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 49, 59, 32, 98, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 98, 41, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 91, 98, 93, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 74, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 102, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 97, 114, 103, 84, 121, 112, 101, 115, 32, 97, 114, 114, 97, 121, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 33, 32, 77, 117, 115, 116, 32, 97, 116, 32, 108, 101, 97, 115, 116, 32, 103, 101, 116, 32, 114, 101, 116, 117, 114, 110, 32, 118, 97, 108, 117, 101, 32, 97, 110, 100, 32, 39, 116, 104, 105, 115, 39, 32, 116, 121, 112, 101, 115, 33, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 49, 93, 32, 38, 38, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 44, 32, 103, 32, 61, 32, 118, 98, 40, 98, 41, 44, 32, 108, 32, 61, 32, 34, 118, 111, 105, 100, 34, 32, 33, 61, 61, 32, 98, 91, 48, 93, 46, 110, 97, 109, 101, 44, 32, 109, 32, 61, 32, 102, 32, 45, 32, 50, 44, 32, 110, 32, 61, 32, 65, 114, 114, 97, 121, 40, 109, 41, 44, 32, 113, 32, 61, 32, 91, 93, 44, 32, 114, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 98, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 65, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 104, 32, 63, 32, 50, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 48, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 98, 91, 49, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 49, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 119, 32, 61, 32, 48, 59, 32, 119, 32, 60, 32, 109, 59, 32, 43, 43, 119, 41, 32, 110, 91, 119, 93, 32, 61, 32, 98, 91, 119, 32, 43, 32, 50, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 65, 91, 119, 93, 41, 44, 32, 113, 46, 112, 117, 115, 104, 40, 110, 91, 119, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 32, 61, 32, 100, 40, 46, 46, 46, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 41, 32, 76, 97, 40, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 119, 32, 61, 32, 104, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 119, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 119, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 49, 32, 61, 61, 61, 32, 119, 32, 63, 32, 118, 32, 58, 32, 110, 91, 119, 32, 45, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 119, 93, 46, 74, 97, 32, 38, 38, 32, 98, 91, 119, 93, 46, 74, 97, 40, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 108, 32, 63, 32, 98, 91, 48, 93, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 65, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 114, 105, 109, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 97, 46, 105, 110, 100, 101, 120, 79, 102, 40, 34, 40, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 45, 49, 32, 33, 61, 61, 32, 98, 32, 63, 32, 97, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 98, 41, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 121, 98, 32, 61, 32, 91, 93, 44, 32, 86, 32, 61, 32, 91, 93, 44, 32, 122, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 48, 32, 61, 61, 61, 32, 45, 45, 86, 91, 97, 32, 43, 32, 49, 93, 32, 38, 38, 32, 40, 86, 91, 97, 93, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 121, 98, 46, 112, 117, 115, 104, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 66, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 117, 115, 101, 32, 100, 101, 108, 101, 116, 101, 100, 32, 118, 97, 108, 46, 32, 104, 97, 110, 100, 108, 101, 32, 61, 32, 34, 32, 43, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 107, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 118, 111, 105, 100, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 110, 117, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 116, 114, 117, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 102, 97, 108, 115, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 121, 98, 46, 112, 111, 112, 40, 41, 32, 124, 124, 32, 86, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 93, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 32, 43, 32, 49, 93, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 67, 98, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 34, 101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 58, 58, 118, 97, 108, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 66, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 107, 98, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 68, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 117, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 121, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 122, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 67, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 69, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 76, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 97, 32, 61, 32, 96, 36, 123, 98, 125, 32, 104, 97, 115, 32, 117, 110, 107, 110, 111, 119, 110, 32, 116, 121, 112, 101, 32, 36, 123, 115, 98, 40, 97, 41, 125, 96, 44, 32, 110, 101, 119, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 105, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 117, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 97, 114, 114, 97, 121, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 61, 32, 98, 32, 63, 32, 97, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 58, 32, 34, 34, 32, 43, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 111, 97, 91, 99, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 56, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 97, 91, 99, 32, 62, 62, 32, 51, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 102, 108, 111, 97, 116, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 71, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 117, 91, 100, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 120, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 121, 91, 100, 32, 62, 62, 32, 49, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 122, 91, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 67, 91, 100, 32, 62, 62, 32, 50, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 72, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 32, 111, 112, 116, 105, 111, 110, 97, 108, 58, 32, 116, 114, 117, 101, 32, 125, 44, 32, 67, 98, 41, 44, 32, 73, 98, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 34, 117, 116, 102, 45, 49, 54, 108, 101, 34, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 74, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 32, 62, 62, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 99, 32, 43, 32, 98, 32, 47, 32, 50, 59, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 32, 38, 38, 32, 122, 91, 99, 93, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 60, 60, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 51, 50, 32, 60, 32, 99, 32, 45, 32, 97, 32, 38, 38, 32, 73, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 73, 98, 46, 100, 101, 99, 111, 100, 101, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 48, 59, 32, 33, 40, 100, 32, 62, 61, 32, 98, 32, 47, 32, 50, 41, 59, 32, 43, 43, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 121, 91, 97, 32, 43, 32, 50, 32, 42, 32, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 45, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 99, 32, 60, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 32, 63, 32, 99, 32, 47, 32, 50, 32, 58, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 99, 59, 32, 43, 43, 101, 41, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 44, 32, 98, 32, 43, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 76, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 44, 32, 77, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 48, 44, 32, 100, 32, 61, 32, 34, 34, 59, 32, 33, 40, 99, 32, 62, 61, 32, 98, 32, 47, 32, 52, 41, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 67, 91, 97, 32, 43, 32, 52, 32, 42, 32, 99, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 60, 61, 32, 101, 32, 63, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 32, 58, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 52, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 100, 32, 43, 32, 99, 32, 45, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 52, 32, 62, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 79, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 48, 59, 32, 99, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 100, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 100, 32, 38, 38, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 80, 98, 32, 61, 32, 91, 93, 44, 32, 81, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 80, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 98, 46, 112, 117, 115, 104, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 43, 43, 100, 41, 32, 99, 91, 100, 93, 32, 61, 32, 69, 98, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 44, 32, 34, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 34, 32, 43, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 98, 32, 61, 32, 82, 101, 102, 108, 101, 99, 116, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 44, 32, 84, 98, 32, 61, 32, 123, 125, 44, 32, 85, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 68, 97, 32, 124, 124, 32, 34, 117, 110, 119, 105, 110, 100, 34, 32, 61, 61, 32, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 86, 98, 32, 61, 32, 48, 44, 32, 87, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 86, 98, 32, 124, 124, 32, 40, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 69, 120, 105, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 44, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 68, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 109, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 40, 41, 44, 32, 33, 40, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 86, 98, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 32, 61, 32, 110, 97, 44, 32, 87, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 98, 32, 61, 32, 123, 125, 44, 32, 36, 98, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 90, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 83, 69, 82, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 79, 71, 78, 65, 77, 69, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 65, 84, 72, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 87, 68, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 79, 77, 69, 58, 32, 34, 47, 104, 111, 109, 101, 47, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 65, 78, 71, 58, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 91, 48, 93, 32, 124, 124, 32, 34, 67, 34, 41, 46, 114, 101, 112, 108, 97, 99, 101, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 45, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 95, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 32, 43, 32, 34, 46, 85, 84, 70, 45, 56, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 101, 97, 32, 124, 124, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 89, 98, 41, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 89, 98, 91, 98, 93, 32, 63, 32, 100, 101, 108, 101, 116, 101, 32, 97, 91, 98, 93, 32, 58, 32, 97, 91, 98, 93, 32, 61, 32, 89, 98, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 97, 41, 32, 99, 46, 112, 117, 115, 104, 40, 96, 36, 123, 98, 125, 61, 36, 123, 97, 91, 98, 93, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 90, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 98, 44, 32, 97, 99, 32, 61, 32, 91, 110, 117, 108, 108, 44, 32, 91, 93, 44, 32, 91, 93, 93, 44, 32, 98, 99, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 97, 41, 32, 61, 62, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 105, 110, 105, 116, 82, 97, 110, 100, 111, 109, 68, 101, 118, 105, 99, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 99, 99, 32, 61, 32, 98, 99, 40, 41, 41, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 77, 32, 61, 32, 107, 46, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 50, 53, 54, 41, 44, 32, 101, 99, 32, 61, 32, 48, 59, 32, 50, 53, 54, 32, 62, 32, 101, 99, 59, 32, 43, 43, 101, 99, 41, 32, 100, 99, 91, 101, 99, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 78, 97, 32, 61, 32, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 81, 32, 61, 32, 107, 46, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 97, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 65, 108, 105, 97, 115, 79, 102, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 116, 104, 105, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 97, 98, 32, 38, 38, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 97, 98, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 32, 61, 32, 97, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 65, 97, 46, 68, 97, 46, 66, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 97, 32, 61, 32, 97, 46, 65, 97, 46, 67, 97, 59, 32, 98, 46, 71, 97, 59, 32, 41, 32, 99, 32, 61, 32, 98, 46, 80, 97, 40, 99, 41, 44, 32, 98, 32, 61, 32, 98, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 100, 46, 71, 97, 59, 32, 41, 32, 97, 32, 61, 32, 100, 46, 80, 97, 40, 97, 41, 44, 32, 100, 32, 61, 32, 100, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 61, 61, 61, 32, 100, 32, 38, 38, 32, 99, 32, 61, 61, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 111, 110, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 44, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 90, 97, 44, 32, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 44, 32, 99, 32, 61, 32, 98, 46, 99, 114, 101, 97, 116, 101, 44, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 44, 32, 101, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 99, 97, 108, 108, 40, 98, 44, 32, 100, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 99, 111, 117, 110, 116, 58, 32, 101, 46, 99, 111, 117, 110, 116, 44, 32, 77, 97, 58, 32, 101, 46, 77, 97, 44, 32, 79, 97, 58, 32, 101, 46, 79, 97, 44, 32, 67, 97, 58, 32, 101, 46, 67, 97, 44, 32, 68, 97, 58, 32, 101, 46, 68, 97, 44, 32, 69, 97, 58, 32, 101, 46, 69, 97, 44, 32, 72, 97, 58, 32, 101, 46, 72, 97, 32, 125, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 77, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 97, 46, 69, 97, 32, 63, 32, 97, 46, 72, 97, 46, 75, 97, 40, 97, 46, 69, 97, 41, 32, 58, 32, 97, 46, 68, 97, 46, 66, 97, 46, 75, 97, 40, 97, 46, 67, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 32, 124, 124, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 69, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 68, 101, 108, 101, 116, 101, 100, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 76, 97, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 32, 61, 61, 61, 32, 82, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 87, 97, 32, 38, 38, 32, 87, 97, 40, 86, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 103, 101, 116, 73, 110, 104, 101, 114, 105, 116, 101, 100, 73, 110, 115, 116, 97, 110, 99, 101, 67, 111, 117, 110, 116, 32, 61, 32, 40, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 88, 97, 41, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 103, 101, 116, 76, 105, 118, 101, 73, 110, 104, 101, 114, 105, 116, 101, 100, 73, 110, 115, 116, 97, 110, 99, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 91, 93, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 88, 97, 41, 32, 88, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 41, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 88, 97, 91, 98, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 102, 108, 117, 115, 104, 80, 101, 110, 100, 105, 110, 103, 68, 101, 108, 101, 116, 101, 115, 32, 61, 32, 86, 97, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 115, 101, 116, 68, 101, 108, 97, 121, 70, 117, 110, 99, 116, 105, 111, 110, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 87, 97, 32, 38, 38, 32, 87, 97, 40, 86, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 109, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 38, 38, 32, 40, 97, 32, 61, 32, 116, 104, 105, 115, 46, 89, 97, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 116, 104, 105, 115, 46, 75, 97, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 83, 97, 32, 63, 32, 36, 97, 40, 116, 104, 105, 115, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 116, 104, 105, 115, 46, 105, 98, 44, 32, 67, 97, 58, 32, 99, 44, 32, 72, 97, 58, 32, 116, 104, 105, 115, 44, 32, 69, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 36, 97, 40, 116, 104, 105, 115, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 116, 104, 105, 115, 44, 32, 67, 97, 58, 32, 97, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 99, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 87, 97, 40, 97, 41, 44, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 89, 97, 40, 116, 104, 105, 115, 46, 66, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 100, 46, 65, 97, 46, 67, 97, 32, 61, 32, 99, 44, 32, 100, 46, 65, 97, 46, 69, 97, 32, 61, 32, 97, 44, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 87, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 66, 97, 46, 98, 98, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 85, 97, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 82, 97, 32, 63, 32, 100, 46, 90, 97, 32, 58, 32, 100, 46, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 84, 97, 40, 99, 44, 32, 116, 104, 105, 115, 46, 66, 97, 44, 32, 100, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 101, 32, 63, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 32, 58, 32, 116, 104, 105, 115, 46, 83, 97, 32, 63, 32, 36, 97, 40, 100, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 100, 44, 32, 67, 97, 58, 32, 101, 44, 32, 72, 97, 58, 32, 116, 104, 105, 115, 44, 32, 69, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 36, 97, 40, 100, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 100, 44, 32, 67, 97, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 113, 98, 32, 61, 32, 107, 46, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 32, 61, 32, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 98, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 69, 114, 114, 111, 114, 40, 100, 41, 46, 115, 116, 97, 99, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 40, 116, 104, 105, 115, 46, 115, 116, 97, 99, 107, 32, 61, 32, 116, 104, 105, 115, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 43, 32, 34, 92, 110, 34, 32, 43, 32, 100, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 94, 69, 114, 114, 111, 114, 40, 58, 91, 94, 92, 110, 93, 42, 41, 63, 92, 110, 47, 44, 32, 34, 34, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 116, 111, 83, 116, 114, 105, 110, 103, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 63, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 58, 32, 96, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 58, 32, 36, 123, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 40, 69, 114, 114, 111, 114, 44, 32, 34, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 86, 46, 112, 117, 115, 104, 40, 48, 44, 32, 49, 44, 32, 118, 111, 105, 100, 32, 48, 44, 32, 49, 44, 32, 110, 117, 108, 108, 44, 32, 49, 44, 32, 116, 114, 117, 101, 44, 32, 49, 44, 32, 102, 97, 108, 115, 101, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 99, 111, 117, 110, 116, 95, 101, 109, 118, 97, 108, 95, 104, 97, 110, 100, 108, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 86, 46, 108, 101, 110, 103, 116, 104, 32, 47, 32, 50, 32, 45, 32, 53, 32, 45, 32, 121, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 99, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 65, 115, 115, 101, 114, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 97, 32, 63, 32, 72, 40, 120, 44, 32, 97, 41, 32, 58, 32, 34, 34, 125, 44, 32, 97, 116, 58, 32, 96, 32, 43, 32, 91, 98, 32, 63, 32, 98, 32, 63, 32, 72, 40, 120, 44, 32, 98, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 105, 108, 101, 110, 97, 109, 101, 34, 44, 32, 99, 44, 32, 100, 32, 63, 32, 100, 32, 63, 32, 72, 40, 120, 44, 32, 100, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 34, 93, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 110, 101, 119, 32, 72, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 56, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 85, 97, 44, 32, 100, 32, 61, 32, 98, 46, 75, 97, 44, 32, 101, 32, 61, 32, 98, 46, 88, 97, 44, 32, 102, 32, 61, 32, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 103, 98, 41, 46, 99, 111, 110, 99, 97, 116, 40, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 109, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 102, 44, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 104, 91, 109, 93, 44, 32, 113, 32, 61, 32, 108, 46, 101, 98, 44, 32, 114, 32, 61, 32, 108, 46, 102, 98, 44, 32, 65, 32, 61, 32, 104, 91, 109, 32, 43, 32, 101, 46, 108, 101, 110, 103, 116, 104, 93, 44, 32, 118, 32, 61, 32, 108, 46, 108, 98, 44, 32, 119, 32, 61, 32, 108, 46, 110, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 91, 108, 46, 97, 98, 93, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 58, 32, 40, 69, 41, 32, 61, 62, 32, 110, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 113, 40, 114, 44, 32, 69, 41, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 114, 105, 116, 101, 58, 32, 40, 69, 44, 32, 104, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 40, 119, 44, 32, 69, 44, 32, 65, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 44, 32, 104, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 123, 125, 44, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 109, 91, 110, 93, 32, 61, 32, 103, 91, 110, 93, 46, 114, 101, 97, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 105, 110, 32, 103, 41, 32, 105, 102, 32, 40, 33, 40, 110, 32, 105, 110, 32, 109, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 77, 105, 115, 115, 105, 110, 103, 32, 102, 105, 101, 108, 100, 58, 32, 34, 36, 123, 110, 125, 34, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 103, 91, 110, 93, 46, 119, 114, 105, 116, 101, 40, 113, 44, 32, 109, 91, 110, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 108, 32, 38, 38, 32, 108, 46, 112, 117, 115, 104, 40, 100, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 113, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 33, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 32, 63, 32, 99, 32, 58, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 101, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 44, 32, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 80, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 38, 38, 32, 40, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 84, 40, 113, 44, 32, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 65, 32, 61, 32, 101, 98, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 65, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 110, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 44, 32, 98, 44, 32, 99, 93, 44, 32, 100, 32, 63, 32, 91, 100, 93, 32, 58, 32, 91, 93, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 118, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 32, 61, 32, 118, 46, 66, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 119, 46, 78, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 69, 32, 61, 32, 97, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 98, 98, 40, 110, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 32, 33, 61, 61, 32, 104, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 115, 101, 32, 39, 110, 101, 119, 39, 32, 116, 111, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 34, 32, 43, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 66, 46, 76, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 110, 32, 43, 32, 34, 32, 104, 97, 115, 32, 110, 111, 32, 97, 99, 99, 101, 115, 115, 105, 98, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 65, 98, 32, 61, 32, 66, 46, 76, 97, 91, 83, 97, 46, 108, 101, 110, 103, 116, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 105, 110, 118, 111, 107, 101, 32, 99, 116, 111, 114, 32, 111, 102, 32, 36, 123, 110, 125, 32, 119, 105, 116, 104, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 83, 97, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 40, 36, 123, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 66, 46, 76, 97, 41, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 125, 41, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 105, 110, 115, 116, 101, 97, 100, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 98, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 83, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 69, 44, 32, 123, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 118, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 104, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 110, 101, 119, 32, 102, 98, 40, 110, 44, 32, 118, 44, 32, 104, 97, 44, 32, 114, 44, 32, 119, 44, 32, 102, 44, 32, 103, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 66, 46, 71, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 105, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 40, 105, 97, 32, 61, 32, 66, 46, 71, 97, 41, 46, 86, 97, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 105, 97, 46, 86, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 46, 71, 97, 46, 86, 97, 46, 112, 117, 115, 104, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 44, 32, 66, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 97, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 32, 43, 32, 34, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 32, 43, 32, 34, 32, 99, 111, 110, 115, 116, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 91, 97, 93, 32, 61, 32, 123, 32, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 58, 32, 105, 97, 44, 32, 90, 97, 58, 32, 69, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 98, 40, 65, 44, 32, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 119, 44, 32, 105, 97, 44, 32, 69, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 117, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 103, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 96, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 103, 46, 66, 97, 46, 76, 97, 32, 38, 38, 32, 40, 103, 46, 66, 97, 46, 76, 97, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 119, 105, 116, 104, 32, 105, 100, 101, 110, 116, 105, 99, 97, 108, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 98, 32, 45, 32, 49, 125, 41, 32, 102, 111, 114, 32, 99, 108, 97, 115, 115, 32, 39, 36, 123, 103, 46, 110, 97, 109, 101, 125, 39, 33, 32, 79, 118, 101, 114, 108, 111, 97, 100, 32, 114, 101, 115, 111, 108, 117, 116, 105, 111, 110, 32, 105, 115, 32, 99, 117, 114, 114, 101, 110, 116, 108, 121, 32, 111, 110, 108, 121, 32, 112, 101, 114, 102, 111, 114, 109, 101, 100, 32, 117, 115, 105, 110, 103, 32, 116, 104, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 99, 111, 117, 110, 116, 44, 32, 110, 111, 116, 32, 97, 99, 116, 117, 97, 108, 32, 116, 121, 112, 101, 32, 105, 110, 102, 111, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 46, 115, 112, 108, 105, 99, 101, 40, 49, 44, 32, 48, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 119, 98, 40, 108, 44, 32, 109, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 117, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 120, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 113, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 96, 36, 123, 109, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 109, 46, 66, 97, 46, 106, 98, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 109, 46, 66, 97, 46, 78, 97, 44, 32, 65, 32, 61, 32, 114, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 46, 70, 97, 32, 38, 38, 32, 65, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 33, 61, 61, 32, 109, 46, 110, 97, 109, 101, 32, 38, 38, 32, 65, 46, 81, 97, 32, 61, 61, 61, 32, 99, 32, 45, 32, 50, 32, 63, 32, 40, 110, 46, 81, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 110, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 61, 32, 109, 46, 110, 97, 109, 101, 44, 32, 114, 91, 98, 93, 32, 61, 32, 110, 41, 32, 58, 32, 40, 99, 98, 40, 114, 44, 32, 98, 44, 32, 113, 41, 44, 32, 114, 91, 98, 93, 46, 70, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 108, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 119, 98, 40, 113, 44, 32, 118, 44, 32, 109, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 114, 91, 98, 93, 46, 70, 97, 32, 63, 32, 40, 118, 46, 81, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 114, 91, 98, 93, 32, 61, 32, 118, 41, 32, 58, 32, 114, 91, 98, 93, 46, 70, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 58, 32, 40, 97, 41, 32, 61, 62, 32, 78, 40, 97, 44, 32, 67, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 118, 97, 108, 117, 101, 115, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 118, 97, 108, 117, 101, 115, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 102, 44, 32, 104, 41, 32, 61, 62, 32, 104, 46, 118, 97, 108, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 68, 98, 40, 98, 44, 32, 99, 44, 32, 100, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 98, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 69, 98, 40, 97, 44, 32, 34, 101, 110, 117, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 99, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 98, 40, 96, 36, 123, 100, 46, 110, 97, 109, 101, 125, 95, 36, 123, 98, 125, 96, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 118, 97, 108, 117, 101, 115, 91, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 41, 32, 61, 62, 32, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 70, 98, 40, 98, 44, 32, 99, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 117, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 120, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 97, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 45, 32, 49, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 98, 40, 97, 44, 32, 119, 98, 40, 97, 44, 32, 91, 103, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 103, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 44, 32, 98, 32, 45, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 49, 32, 61, 61, 61, 32, 101, 32, 38, 38, 32, 40, 101, 32, 61, 32, 52, 50, 57, 52, 57, 54, 55, 50, 57, 53, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 51, 50, 32, 45, 32, 56, 32, 42, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 32, 60, 60, 32, 102, 32, 62, 62, 62, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 117, 110, 115, 105, 103, 110, 101, 100, 34, 41, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 32, 62, 62, 62, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 101, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 104, 44, 32, 73, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 71, 98, 40, 98, 44, 32, 99, 44, 32, 48, 32, 33, 61, 61, 32, 100, 41, 44, 32, 74, 97, 58, 32, 110, 117, 108, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 101, 40, 117, 46, 98, 117, 102, 102, 101, 114, 44, 32, 68, 91, 102, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 44, 32, 68, 91, 102, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 91, 73, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 93, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 99, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 100, 44, 32, 73, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 100, 32, 125, 44, 32, 123, 32, 104, 98, 58, 32, 116, 114, 117, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 72, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 32, 61, 32, 84, 40, 110, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 91, 98, 93, 44, 32, 40, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 114, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 110, 101, 119, 32, 109, 98, 40, 99, 44, 32, 114, 46, 66, 97, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 114, 44, 32, 100, 44, 32, 102, 44, 32, 103, 44, 32, 109, 44, 32, 113, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 34, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 44, 32, 102, 32, 61, 32, 100, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 104, 32, 61, 32, 102, 44, 32, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 61, 32, 101, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 102, 32, 43, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 61, 61, 32, 101, 32, 124, 124, 32, 48, 32, 61, 61, 32, 120, 91, 108, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 104, 32, 63, 32, 72, 40, 120, 44, 32, 104, 44, 32, 108, 32, 45, 32, 104, 41, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 41, 32, 118, 97, 114, 32, 109, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 108, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 65, 114, 114, 97, 121, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 59, 32, 43, 43, 103, 41, 32, 109, 91, 103, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 120, 91, 102, 32, 43, 32, 103, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 46, 106, 111, 105, 110, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 38, 38, 32, 40, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 44, 32, 104, 32, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 104, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 103, 32, 61, 32, 102, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 50, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 43, 43, 32, 58, 32, 50, 48, 52, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 32, 43, 61, 32, 50, 32, 58, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 108, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 108, 32, 63, 32, 40, 102, 32, 43, 61, 32, 52, 44, 32, 43, 43, 103, 41, 32, 58, 32, 102, 32, 43, 61, 32, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 32, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 32, 61, 32, 103, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 32, 73, 40, 101, 44, 32, 108, 44, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 53, 53, 32, 60, 32, 109, 41, 32, 116, 104, 114, 111, 119, 32, 85, 40, 108, 41, 44, 32, 110, 101, 119, 32, 81, 40, 34, 83, 116, 114, 105, 110, 103, 32, 104, 97, 115, 32, 85, 84, 70, 45, 49, 54, 32, 99, 111, 100, 101, 32, 117, 110, 105, 116, 115, 32, 116, 104, 97, 116, 32, 100, 111, 32, 110, 111, 116, 32, 102, 105, 116, 32, 105, 110, 32, 56, 32, 98, 105, 116, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 101, 91, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 100, 46, 112, 117, 115, 104, 40, 85, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 74, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 75, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 76, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 122, 91, 103, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 52, 32, 61, 61, 61, 32, 98, 32, 38, 38, 32, 40, 100, 32, 61, 32, 77, 98, 44, 32, 101, 32, 61, 32, 78, 98, 44, 32, 102, 32, 61, 32, 79, 98, 44, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 44, 32, 109, 44, 32, 110, 32, 61, 32, 103, 32, 43, 32, 52, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 61, 32, 108, 59, 32, 43, 43, 113, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 103, 32, 43, 32, 52, 32, 43, 32, 113, 32, 42, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 113, 32, 61, 61, 32, 108, 32, 124, 124, 32, 48, 32, 61, 61, 32, 104, 40, 114, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 100, 40, 110, 44, 32, 114, 32, 45, 32, 110, 41, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 32, 63, 32, 109, 32, 61, 32, 110, 32, 58, 32, 40, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 110, 41, 44, 32, 110, 32, 61, 32, 114, 32, 43, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 115, 116, 114, 105, 110, 103, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 67, 43, 43, 32, 115, 116, 114, 105, 110, 103, 32, 116, 121, 112, 101, 32, 36, 123, 99, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 102, 40, 108, 41, 44, 32, 110, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 110, 32, 62, 62, 32, 50, 93, 32, 61, 32, 109, 32, 47, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 40, 108, 44, 32, 110, 32, 43, 32, 52, 44, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 103, 32, 38, 38, 32, 103, 46, 112, 117, 115, 104, 40, 85, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 32, 61, 32, 123, 32, 110, 97, 109, 101, 58, 32, 80, 40, 98, 41, 44, 32, 85, 97, 58, 32, 84, 40, 99, 44, 32, 100, 41, 44, 32, 75, 97, 58, 32, 84, 40, 101, 44, 32, 102, 41, 44, 32, 88, 97, 58, 32, 91, 93, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 46, 88, 97, 46, 112, 117, 115, 104, 40, 123, 32, 97, 98, 58, 32, 80, 40, 98, 41, 44, 32, 103, 98, 58, 32, 99, 44, 32, 101, 98, 58, 32, 84, 40, 100, 44, 32, 101, 41, 44, 32, 102, 98, 58, 32, 102, 44, 32, 109, 98, 58, 32, 104, 44, 32, 108, 98, 58, 32, 84, 40, 103, 44, 32, 108, 41, 44, 32, 110, 98, 58, 32, 109, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 112, 98, 58, 32, 116, 114, 117, 101, 44, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 73, 97, 58, 32, 48, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 98, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 110, 102, 105, 110, 105, 116, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 66, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 110, 117, 108, 108, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 58, 32, 122, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 82, 98, 40, 97, 44, 32, 98, 41, 44, 32, 101, 32, 61, 32, 100, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 96, 109, 101, 116, 104, 111, 100, 67, 97, 108, 108, 101, 114, 60, 40, 36, 123, 100, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 110, 97, 109, 101, 41, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 32, 61, 62, 32, 36, 123, 101, 46, 110, 97, 109, 101, 125, 62, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 98, 44, 32, 40, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 61, 32, 48, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 32, 97, 59, 32, 43, 43, 113, 41, 32, 102, 91, 113, 93, 32, 61, 32, 100, 91, 113, 93, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 109, 32, 43, 32, 110, 41, 44, 32, 110, 32, 43, 61, 32, 100, 91, 113, 93, 46, 73, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 49, 32, 61, 61, 61, 32, 99, 32, 63, 32, 83, 98, 40, 103, 44, 32, 102, 41, 32, 58, 32, 103, 46, 97, 112, 112, 108, 121, 40, 104, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 101, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 40, 68, 91, 108, 32, 62, 62, 32, 50, 93, 32, 61, 32, 107, 98, 40, 104, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 40, 86, 91, 97, 32, 43, 32, 49, 93, 32, 43, 61, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 66, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 69, 98, 40, 97, 44, 32, 34, 95, 101, 109, 118, 97, 108, 95, 116, 97, 107, 101, 95, 118, 97, 108, 117, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 91, 97, 93, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 84, 98, 91, 97, 93, 46, 105, 100, 41, 44, 32, 100, 101, 108, 101, 116, 101, 32, 84, 98, 91, 97, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 84, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 98, 40, 40, 41, 32, 61, 62, 32, 103, 99, 40, 97, 44, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 91, 97, 93, 32, 61, 32, 123, 32, 105, 100, 58, 32, 99, 44, 32, 114, 98, 58, 32, 98, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 40, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 41, 41, 46, 103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114, 40, 41, 44, 32, 102, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 48, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 54, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 54, 48, 32, 42, 32, 77, 97, 116, 104, 46, 109, 97, 120, 40, 102, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 78, 117, 109, 98, 101, 114, 40, 102, 32, 33, 61, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 77, 97, 116, 104, 46, 97, 98, 115, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 96, 85, 84, 67, 36, 123, 48, 32, 60, 61, 32, 104, 32, 63, 32, 34, 45, 34, 32, 58, 32, 34, 43, 34, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 77, 97, 116, 104, 46, 102, 108, 111, 111, 114, 40, 103, 32, 47, 32, 54, 48, 41, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 50, 44, 32, 34, 48, 34, 41, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 103, 32, 37, 32, 54, 48, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 48, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 60, 32, 102, 32, 63, 32, 40, 73, 40, 97, 44, 32, 99, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 100, 44, 32, 49, 55, 41, 41, 32, 58, 32, 40, 73, 40, 97, 44, 32, 100, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 99, 44, 32, 49, 55, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 97, 58, 32, 40, 41, 32, 61, 62, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 120, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 62, 62, 62, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 32, 60, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 49, 59, 32, 52, 32, 62, 61, 32, 99, 59, 32, 99, 32, 42, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 42, 32, 40, 49, 32, 43, 32, 48, 46, 50, 32, 47, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 77, 97, 116, 104, 46, 109, 105, 110, 40, 100, 44, 32, 97, 32, 43, 32, 49, 48, 48, 54, 54, 51, 50, 57, 54, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 40, 77, 97, 116, 104, 46, 109, 105, 110, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 44, 32, 54, 53, 53, 51, 54, 32, 42, 32, 77, 97, 116, 104, 46, 99, 101, 105, 108, 40, 77, 97, 116, 104, 46, 109, 97, 120, 40, 97, 44, 32, 100, 41, 32, 47, 32, 54, 53, 53, 51, 54, 41, 41, 32, 45, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 43, 32, 54, 53, 53, 51, 53, 41, 32, 47, 32, 54, 53, 53, 51, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 46, 103, 114, 111, 119, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 98, 40, 41, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 68, 91, 97, 32, 43, 32, 52, 32, 42, 32, 101, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 102, 41, 32, 117, 91, 101, 43, 43, 93, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 91, 101, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 36, 98, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 100, 32, 43, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 55, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 44, 32, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 99, 59, 32, 102, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 44, 32, 103, 32, 61, 32, 68, 91, 98, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 103, 59, 32, 108, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 97, 44, 32, 110, 32, 61, 32, 120, 91, 104, 32, 43, 32, 108, 93, 44, 32, 113, 32, 61, 32, 97, 99, 91, 109, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 110, 32, 124, 124, 32, 49, 48, 32, 61, 61, 61, 32, 110, 32, 63, 32, 40, 40, 49, 32, 61, 61, 61, 32, 109, 32, 63, 32, 106, 97, 32, 58, 32, 116, 41, 40, 72, 40, 113, 44, 32, 48, 41, 41, 44, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 41, 32, 58, 32, 113, 46, 112, 117, 115, 104, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 97, 32, 43, 32, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 58, 32, 104, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 58, 32, 105, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 58, 32, 106, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 58, 32, 107, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 58, 32, 108, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 58, 32, 109, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 110, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 58, 32, 111, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 58, 32, 112, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 58, 32, 113, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 58, 32, 87, 98, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 32, 61, 32, 99, 46, 101, 120, 112, 111, 114, 116, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 32, 61, 32, 87, 46, 103, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 32, 61, 32, 87, 46, 107, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 87, 46, 104, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 51, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 51, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 70, 32, 38, 38, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 118, 97, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 73, 110, 116, 101, 114, 118, 97, 108, 40, 118, 97, 41, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 41, 44, 32, 71, 32, 38, 38, 32, 40, 99, 32, 61, 32, 71, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 44, 32, 99, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 87, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 123, 32, 97, 58, 32, 114, 99, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 77, 111, 100, 117, 108, 101, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 32, 99, 97, 108, 108, 98, 97, 99, 107, 32, 102, 97, 105, 108, 101, 100, 32, 119, 105, 116, 104, 32, 101, 114, 114, 111, 114, 58, 32, 36, 123, 99, 125, 96, 41, 44, 32, 98, 97, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 97, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 121, 97, 32, 58, 32, 121, 97, 32, 61, 32, 120, 97, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 32, 63, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 32, 58, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 32, 63, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 44, 32, 112, 41, 32, 58, 32, 112, 32, 43, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 99, 46, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 98, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 40, 41, 44, 32, 102, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 102, 99, 32, 61, 32, 87, 46, 105, 97, 41, 40, 97, 41, 44, 32, 114, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 114, 98, 32, 61, 32, 87, 46, 106, 97, 41, 40, 97, 41, 44, 32, 85, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 85, 32, 61, 32, 87, 46, 108, 97, 41, 40, 97, 41, 44, 32, 103, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 103, 99, 32, 61, 32, 87, 46, 109, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 88, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 88, 32, 61, 32, 87, 46, 110, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 89, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 89, 32, 61, 32, 87, 46, 111, 97, 41, 40, 97, 41, 44, 32, 90, 32, 61, 32, 40, 41, 32, 61, 62, 32, 40, 90, 32, 61, 32, 87, 46, 112, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 87, 46, 113, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 87, 46, 114, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 87, 46, 115, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 87, 46, 116, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 115, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 32, 61, 32, 87, 46, 117, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 106, 105, 32, 61, 32, 87, 46, 118, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 87, 46, 119, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 87, 46, 120, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 121, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 122, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 111, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 33, 61, 61, 32, 99, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 116, 99, 59, 10, 32, 32, 32, 32, 32, 32, 71, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 99, 32, 124, 124, 32, 118, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 99, 32, 124, 124, 32, 40, 71, 32, 61, 32, 117, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 99, 32, 38, 38, 32, 40, 116, 99, 32, 61, 32, 116, 114, 117, 101, 44, 32, 107, 46, 99, 97, 108, 108, 101, 100, 82, 117, 110, 32, 61, 32, 116, 114, 117, 101, 44, 32, 33, 109, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 115, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 82, 117, 110, 116, 105, 109, 101, 73, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 111, 115, 116, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 48, 32, 60, 32, 70, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 41, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 114, 101, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 117, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 114, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 60, 32, 70, 32, 124, 124, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 32, 63, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 82, 117, 110, 110, 105, 110, 103, 46, 46, 46, 34, 41, 44, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 34, 41, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 49, 41, 41, 32, 58, 32, 97, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 61, 32, 91, 107, 46, 112, 114, 101, 73, 110, 105, 116, 93, 41, 59, 32, 48, 32, 60, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 112, 111, 112, 40, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 32, 61, 32, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 97, 115, 109, 45, 108, 111, 97, 100, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 82, 101, 110, 100, 101, 114, 101, 114, 76, 111, 97, 100, 101, 114, 32, 105, 115, 32, 97, 32, 115, 116, 97, 116, 105, 99, 32, 99, 108, 97, 115, 115, 32, 97, 110, 100, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 100, 46, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 116, 114, 121, 76, 111, 97, 100, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 117, 108, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 40, 123, 32, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 58, 32, 40, 41, 32, 61, 62, 32, 117, 114, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 84, 114, 105, 101, 115, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 109, 111, 100, 117, 108, 101, 32, 102, 114, 111, 109, 32, 116, 104, 101, 32, 112, 114, 105, 109, 97, 114, 121, 32, 85, 82, 76, 44, 32, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 97, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 105, 102, 32, 110, 101, 99, 101, 115, 115, 97, 114, 121, 46, 10, 32, 32, 32, 32, 32, 42, 32, 84, 104, 114, 111, 119, 115, 32, 97, 110, 32, 101, 114, 114, 111, 114, 32, 105, 102, 32, 98, 111, 116, 104, 32, 85, 82, 76, 115, 32, 102, 97, 105, 108, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 46, 99, 97, 116, 99, 104, 40, 40, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 41, 32, 61, 62, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 117, 112, 85, 114, 108, 32, 61, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 117, 110, 112, 107, 103, 46, 99, 111, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 108, 111, 97, 100, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 36, 123, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 125, 46, 32, 69, 114, 114, 111, 114, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 65, 116, 116, 101, 109, 112, 116, 105, 110, 103, 32, 116, 111, 32, 108, 111, 97, 100, 32, 87, 65, 83, 77, 32, 102, 114, 111, 109, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 85, 114, 108, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 121, 105, 101, 108, 100, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 98, 97, 99, 107, 117, 112, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 66, 97, 99, 107, 117, 112, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 87, 65, 83, 77, 32, 108, 111, 97, 100, 105, 110, 103, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 97, 108, 108, 32, 115, 111, 117, 114, 99, 101, 115, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 80, 117, 98, 108, 105, 99, 32, 109, 101, 116, 104, 111, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 85, 116, 105, 108, 105, 122, 101, 115, 32, 97, 32, 112, 114, 105, 109, 97, 114, 121, 32, 97, 110, 100, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 102, 111, 114, 32, 114, 111, 98, 117, 115, 116, 110, 101, 115, 115, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 108, 111, 97, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 83, 101, 116, 115, 32, 97, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 32, 97, 110, 100, 32, 105, 110, 118, 97, 108, 105, 100, 97, 116, 101, 115, 32, 116, 104, 101, 32, 99, 117, 114, 114, 101, 110, 116, 32, 109, 111, 100, 117, 108, 101, 32, 112, 114, 111, 109, 105, 115, 101, 46, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 115, 116, 114, 105, 110, 103, 32, 45, 32, 32, 84, 104, 101, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 32, 61, 32, 117, 114, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 47, 47, 32, 101, 115, 108, 105, 110, 116, 45, 100, 105, 115, 97, 98, 108, 101, 45, 110, 101, 120, 116, 45, 108, 105, 110, 101, 32, 64, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 45, 101, 115, 108, 105, 110, 116, 47, 110, 97, 109, 105, 110, 103, 45, 99, 111, 110, 118, 101, 110, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 47, 47, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 44, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 101, 100, 32, 117, 115, 105, 110, 103, 32, 112, 97, 99, 107, 97, 103, 101, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 119, 97, 115, 109, 85, 82, 76, 34, 44, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 99, 100, 110, 46, 106, 115, 100, 101, 108, 105, 118, 114, 46, 110, 101, 116, 47, 110, 112, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 101, 118, 101, 110, 116, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 83, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 101, 116, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 97, 100, 100, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 105, 115, 112, 97, 116, 99, 104, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 101, 118, 101, 110, 116, 46, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 61, 62, 32, 108, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 99, 108, 101, 97, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 111, 102, 102, 115, 99, 114, 101, 101, 110, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 110, 116, 114, 121, 46, 105, 115, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 110, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 40, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 101, 115, 104, 111, 108, 100, 58, 32, 48, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 114, 101, 115, 105, 122, 101, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 32, 61, 32, 49, 48, 48, 59, 10, 32, 32, 118, 97, 114, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 101, 108, 101, 109, 101, 110, 116, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 116, 105, 109, 101, 111, 117, 116, 93, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 48, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 117, 116, 105, 108, 115, 46, 116, 115, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 47, 94, 35, 40, 91, 92, 100, 97, 45, 102, 93, 123, 54, 125, 124, 91, 92, 100, 97, 45, 102, 93, 123, 56, 125, 41, 36, 47, 105, 117, 46, 116, 101, 115, 116, 40, 99, 111, 108, 111, 114, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 101, 116, 32, 104, 101, 120, 32, 61, 32, 99, 111, 108, 111, 114, 72, 101, 120, 46, 114, 101, 112, 108, 97, 99, 101, 40, 34, 35, 34, 44, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 104, 101, 120, 32, 61, 32, 104, 101, 120, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 54, 32, 63, 32, 96, 36, 123, 104, 101, 120, 125, 102, 102, 96, 32, 58, 32, 104, 101, 120, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 97, 114, 115, 101, 73, 110, 116, 40, 104, 101, 120, 44, 32, 49, 54, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 60, 32, 52, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 115, 108, 105, 99, 101, 40, 48, 44, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 41, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 108, 101, 110, 103, 116, 104, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 91, 105, 93, 32, 33, 61, 61, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 91, 105, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 106, 115, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 46, 101, 118, 101, 114, 121, 40, 40, 102, 105, 101, 108, 100, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 46, 99, 97, 108, 108, 40, 106, 115, 111, 110, 44, 32, 102, 105, 101, 108, 100, 41, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 102, 105, 108, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 63, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 49, 32, 43, 32, 40, 100, 112, 114, 32, 45, 32, 49, 41, 32, 42, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 99, 116, 46, 116, 111, 112, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 98, 111, 116, 116, 111, 109, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 72, 101, 105, 103, 104, 116, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 41, 32, 38, 38, 32, 114, 101, 99, 116, 46, 114, 105, 103, 104, 116, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 87, 105, 100, 116, 104, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 41, 59, 10, 32, 32, 125, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 32, 61, 32, 40, 109, 111, 100, 101, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 70, 111, 114, 119, 97, 114, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 32, 61, 32, 40, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 118, 101, 114, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 108, 108, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 108, 108, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 78, 111, 110, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 40, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 115, 101, 103, 109, 101, 110, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 50, 41, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 99, 108, 97, 115, 115, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 97, 110, 118, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 111, 110, 116, 101, 120, 116, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 34, 44, 32, 123, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 105, 115, 70, 114, 111, 122, 101, 110, 34, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 40, 34, 50, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 40, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 41, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 105, 115, 32, 116, 114, 117, 101, 32, 98, 121, 32, 100, 101, 102, 97, 117, 108, 116, 32, 116, 111, 32, 112, 114, 101, 118, 101, 110, 116, 32, 117, 110, 110, 101, 99, 101, 115, 115, 97, 114, 121, 32, 114, 101, 110, 100, 101, 114, 105, 110, 103, 32, 119, 104, 101, 110, 32, 116, 104, 101, 32, 99, 97, 110, 118, 97, 115, 32, 105, 115, 32, 111, 102, 102, 115, 99, 114, 101, 101, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 40, 95, 99, 32, 61, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 108, 111, 97, 100, 40, 41, 46, 116, 104, 101, 110, 40, 40, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 50, 44, 32, 95, 99, 50, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 97, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 98, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 99, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 50, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 91, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 109, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 97, 100, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 119, 97, 115, 109, 32, 109, 111, 100, 117, 108, 101, 58, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 102, 101, 116, 99, 104, 40, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 114, 101, 115, 112, 111, 110, 115, 101, 46, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 102, 101, 116, 99, 104, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 125, 58, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 84, 101, 120, 116, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 97, 116, 97, 32, 61, 32, 121, 105, 101, 108, 100, 32, 114, 101, 115, 112, 111, 110, 115, 101, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 46, 100, 101, 99, 111, 100, 101, 40, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 115, 116, 114, 105, 110, 103, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 115, 116, 114, 105, 110, 103, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 100, 97, 116, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 68, 111, 116, 76, 111, 116, 116, 105, 101, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 111, 98, 106, 101, 99, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 111, 98, 106, 101, 99, 116, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 74, 83, 79, 78, 46, 115, 116, 114, 105, 110, 103, 105, 102, 121, 40, 100, 97, 116, 97, 41, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 85, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 46, 32, 69, 120, 112, 101, 99, 116, 101, 100, 58, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 115, 116, 114, 105, 110, 103, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 40, 100, 111, 116, 76, 111, 116, 116, 105, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 111, 98, 106, 101, 99, 116, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 46, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 101, 99, 101, 105, 118, 101, 100, 58, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 115, 111, 109, 101, 116, 104, 105, 110, 103, 32, 119, 101, 110, 116, 32, 119, 114, 111, 110, 103, 44, 32, 116, 104, 101, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 119, 97, 115, 32, 115, 117, 112, 112, 111, 115, 101, 32, 116, 111, 32, 97, 117, 116, 111, 112, 108, 97, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 34, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 46, 116, 104, 101, 110, 40, 40, 100, 97, 116, 97, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 91, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 48, 41, 44, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 49, 41, 93, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 97, 50, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 118, 101, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 70, 105, 116, 46, 70, 105, 108, 108, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 102, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 102, 46, 70, 105, 116, 46, 78, 111, 110, 101, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 111, 110, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 114, 107, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 110, 105, 102, 101, 115, 116, 83, 116, 114, 105, 110, 103, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 109, 97, 110, 105, 102, 101, 115, 116, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 32, 61, 32, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 109, 97, 110, 105, 102, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 41, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 48, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 114, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 32, 38, 38, 32, 115, 101, 103, 109, 101, 110, 116, 46, 115, 105, 122, 101, 40, 41, 32, 61, 61, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 48, 41, 44, 32, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 49, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 111, 100, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 70, 114, 111, 122, 101, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 117, 116, 111, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 112, 101, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 82, 101, 97, 100, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 97, 110, 118, 97, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 99, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 91, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 114, 101, 110, 100, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 117, 102, 102, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 40, 98, 117, 102, 102, 101, 114, 44, 32, 48, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 42, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 42, 32, 52, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 99, 114, 101, 97, 116, 101, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 46, 100, 97, 116, 97, 46, 115, 101, 116, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 101, 119, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 112, 117, 116, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 105, 109, 97, 103, 101, 68, 97, 116, 97, 44, 32, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 114, 97, 119, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 120, 116, 70, 114, 97, 109, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 113, 117, 101, 115, 116, 70, 114, 97, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 112, 100, 97, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 110, 101, 120, 116, 70, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 112, 100, 97, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 67, 111, 109, 112, 108, 101, 116, 101, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 38, 38, 32, 33, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 97, 117, 115, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 115, 116, 111, 112, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 114, 97, 109, 101, 32, 60, 32, 48, 32, 124, 124, 32, 102, 114, 97, 109, 101, 32, 62, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 101, 107, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 115, 116, 121, 108, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 108, 111, 111, 112, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 108, 101, 116, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 58, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 58, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 105, 122, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 91, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 109, 111, 100, 101, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 44, 32, 123, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 44, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 125, 32, 61, 32, 95, 97, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 40, 95, 97, 44, 32, 91, 34, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 34, 44, 32, 34, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 34, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 105, 115, 32, 97, 32, 115, 112, 101, 99, 105, 97, 108, 32, 99, 97, 115, 101, 44, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 32, 115, 101, 116, 32, 116, 111, 32, 116, 104, 101, 32, 100, 101, 102, 97, 117, 108, 116, 32, 118, 97, 108, 117, 101, 32, 105, 102, 32, 105, 116, 39, 115, 32, 110, 111, 116, 32, 112, 114, 111, 118, 105, 100, 101, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 61, 61, 61, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 58, 36, 123, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 97, 114, 107, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 109, 97, 114, 107, 101, 114, 115, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 109, 97, 114, 107, 101, 114, 115, 46, 103, 101, 116, 40, 105, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 46, 112, 117, 115, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 105, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 116, 105, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 109, 97, 114, 107, 101, 114, 46, 100, 117, 114, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 115, 117, 108, 116, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 114, 116, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 97, 114, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 97, 114, 116, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 112, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 111, 112, 112, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 111, 112, 112, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 88, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 47, 32, 114, 101, 99, 116, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 89, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 47, 32, 114, 101, 99, 116, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 88, 32, 45, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 41, 32, 42, 32, 115, 99, 97, 108, 101, 88, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 89, 32, 45, 32, 114, 101, 99, 116, 46, 116, 111, 112, 41, 32, 42, 32, 115, 99, 97, 108, 101, 89, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 70, 114, 97, 109, 101, 119, 111, 114, 107, 83, 101, 116, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 112, 117, 115, 104, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 85, 112, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 48, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 40, 95, 100, 32, 61, 32, 40, 95, 99, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 49, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 44, 32, 34, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 119, 111, 114, 107, 101, 114, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 119, 111, 114, 107, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 32, 61, 32, 123, 10, 32, 32, 32, 32, 114, 101, 97, 100, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 97, 100, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 111, 109, 112, 108, 101, 116, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 67, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 83, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 97, 109, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 85, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 68, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 111, 109, 109, 97, 110, 100, 115, 32, 61, 32, 123, 10, 32, 32, 32, 32, 103, 101, 116, 68, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 83, 116, 97, 116, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 76, 111, 97, 100, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 76, 111, 97, 100, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 97, 117, 115, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 70, 114, 111, 122, 101, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 70, 114, 111, 122, 101, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 111, 100, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 112, 101, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 117, 116, 111, 112, 108, 97, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 97, 121, 111, 117, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 82, 101, 97, 100, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 82, 101, 97, 100, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 110, 105, 102, 101, 115, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 110, 105, 102, 101, 115, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 114, 101, 97, 116, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 104, 97, 115, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 97, 108, 114, 101, 97, 100, 121, 32, 101, 120, 105, 115, 116, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 110, 101, 119, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 115, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 32, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 118, 101, 110, 116, 115, 32, 61, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 115, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 97, 100, 121, 34, 10, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 44, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 91, 101, 118, 101, 110, 116, 93, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 100, 101, 108, 101, 116, 101, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 102, 114, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 44, 32, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 112, 101, 101, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 112, 101, 101, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 111, 111, 112, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 101, 116, 104, 111, 100, 32, 61, 32, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 46, 109, 101, 116, 104, 111, 100, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 77, 101, 116, 104, 111, 100, 32, 36, 123, 109, 101, 116, 104, 111, 100, 125, 32, 105, 115, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 115, 101, 108, 102, 46, 111, 110, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 101, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 100, 117, 109, 109, 121, 32, 61, 32, 34, 34, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 119, 111, 114, 107, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 100, 117, 109, 109, 121, 59, 10, 125, 41, 40, 41, 59, 10])], { type: "application/javascript" }), n = URL.createObjectURL(e), i = new Worker(n);
    return URL.revokeObjectURL(n), i;
  }
}, MX = EX, TX = class {
  constructor() {
    ct(this, "_workers", /* @__PURE__ */ new Map()), ct(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
  }
  getWorker(e) {
    return this._workers.has(e) || this._workers.set(e, new MX()), this._workers.get(e);
  }
  assignAnimationToWorker(e, n) {
    this._animationWorkerMap.set(e, n);
  }
  unassignAnimationFromWorker(e) {
    this._animationWorkerMap.delete(e);
  }
  sendMessage(e, n, i) {
    this.getWorker(e).postMessage(n, i || []);
  }
  terminateWorker(e) {
    let n = this._workers.get(e);
    n && (n.terminate(), this._workers.delete(e));
  }
};
function vx(e) {
  if (e instanceof OffscreenCanvas)
    return { width: e.width, height: e.height };
  let { height: n, width: i } = e.getBoundingClientRect();
  return { width: i * window.devicePixelRatio, height: n * window.devicePixelRatio };
}
function yx() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var bx = class ll {
  constructor(n) {
    ct(this, "_eventManager", new VM()), ct(this, "_id"), ct(this, "_worker"), ct(this, "_canvas"), ct(this, "_dotLottieInstanceState", { markers: [], autoplay: !1, backgroundColor: "", currentFrame: 0, duration: 0, loop: !1, mode: "forward", segment: [0, 0], segmentDuration: 0, speed: 1, totalFrames: 0, isLoaded: !1, isPlaying: !1, isPaused: !1, isStopped: !0, isFrozen: !1, useFrameInterpolation: !1, renderConfig: { devicePixelRatio: df() }, activeAnimationId: "", activeThemeId: "", layout: void 0, marker: void 0, isReady: !1, manifest: null }), ct(this, "_created", !1), ct(this, "_pointerUpMethod"), ct(this, "_pointerDownMethod"), ct(this, "_pointerMoveMethod"), ct(this, "_pointerEnterMethod"), ct(this, "_pointerExitMethod");
    var i, a, s;
    this._canvas = n.canvas, this._id = `dotlottie-${yx()}`;
    let g = n.workerId || "defaultWorker";
    this._worker = ll._workerManager.getWorker(g), ll._workerManager.assignAnimationToWorker(this._id, g), ll._wasmUrl && this._sendMessage("setWasmUrl", { url: ll._wasmUrl }), this._create(m3(ir({}, n), { renderConfig: m3(ir({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || df(), freezeOnOffscreen: (s = (a = n.renderConfig) == null ? void 0 : a.freezeOnOffscreen) != null ? s : !0 }) })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _handleWorkerEvent(n) {
    return It(this, null, function* () {
      let i = n.data;
      i.id || (i.method === "onLoad" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event), Or && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && Ri.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && Oi.observe(this._canvas, this))), i.method === "onComplete" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onUnfreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(i.result.event)), i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onFreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPause" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPlay" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStop" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoadError" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onReady" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)));
    });
  }
  _create(n) {
    return It(this, null, function* () {
      let i;
      this._canvas instanceof HTMLCanvasElement ? i = this._canvas.transferControlToOffscreen() : i = this._canvas;
      let { instanceId: a } = yield this._sendMessage("create", ir({ instanceId: this._id, config: m3(ir({}, n), { canvas: i }) }, vx(this._canvas)), [i]);
      if (a !== this._id)
        throw new Error("Instance ID mismatch");
      this._created = !0, yield this._updateDotLottieInstanceState();
    });
  }
  get isLoaded() {
    return this._dotLottieInstanceState.isLoaded;
  }
  get isPlaying() {
    return this._dotLottieInstanceState.isPlaying;
  }
  get isPaused() {
    return this._dotLottieInstanceState.isPaused;
  }
  get isStopped() {
    return this._dotLottieInstanceState.isStopped;
  }
  get currentFrame() {
    return this._dotLottieInstanceState.currentFrame;
  }
  get isFrozen() {
    return this._dotLottieInstanceState.isFrozen;
  }
  get segmentDuration() {
    return this._dotLottieInstanceState.segmentDuration;
  }
  get totalFrames() {
    return this._dotLottieInstanceState.totalFrames;
  }
  get segment() {
    return this._dotLottieInstanceState.segment;
  }
  get speed() {
    return this._dotLottieInstanceState.speed;
  }
  get duration() {
    return this._dotLottieInstanceState.duration;
  }
  get isReady() {
    return this._dotLottieInstanceState.isReady;
  }
  get mode() {
    return this._dotLottieInstanceState.mode;
  }
  get canvas() {
    return this._canvas;
  }
  get autoplay() {
    return this._dotLottieInstanceState.autoplay;
  }
  get backgroundColor() {
    return this._dotLottieInstanceState.backgroundColor;
  }
  get loop() {
    return this._dotLottieInstanceState.loop;
  }
  get useFrameInterpolation() {
    return this._dotLottieInstanceState.useFrameInterpolation;
  }
  get renderConfig() {
    return this._dotLottieInstanceState.renderConfig;
  }
  get manifest() {
    return this._dotLottieInstanceState.manifest;
  }
  get activeAnimationId() {
    return this._dotLottieInstanceState.activeAnimationId;
  }
  get marker() {
    return this._dotLottieInstanceState.marker;
  }
  get activeThemeId() {
    return this._dotLottieInstanceState.activeThemeId;
  }
  get layout() {
    return this._dotLottieInstanceState.layout;
  }
  play() {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("play", { instanceId: this._id }), yield this._updateDotLottieInstanceState(), Or && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !_M(this._canvas) && (yield this.freeze()));
    });
  }
  pause() {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("pause", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  stop() {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("stop", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSpeed(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setSpeed", { instanceId: this._id, speed: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setMode(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setMode", { instanceId: this._id, mode: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setFrame(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setFrame", { frame: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSegment(n, i) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setSegment", { instanceId: this._id, segment: [n, i] }), yield this._updateDotLottieInstanceState());
    });
  }
  setRenderConfig(n) {
    return It(this, null, function* () {
      if (!this._created)
        return;
      let i = n, { devicePixelRatio: a, freezeOnOffscreen: s } = i, g = HM(i, ["devicePixelRatio", "freezeOnOffscreen"]);
      yield this._sendMessage("setRenderConfig", { instanceId: this._id, renderConfig: m3(ir(ir({}, this._dotLottieInstanceState.renderConfig), g), { devicePixelRatio: a || df(), freezeOnOffscreen: s ?? !0 }) }), yield this._updateDotLottieInstanceState(), Or && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? Oi.observe(this._canvas, this) : Oi.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? Ri.observe(this._canvas, this) : (Ri.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && (yield this.unfreeze())));
    });
  }
  setUseFrameInterpolation(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setUseFrameInterpolation", { instanceId: this._id, useFrameInterpolation: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadTheme(n) {
    return It(this, null, function* () {
      if (!this._created)
        return !1;
      let i = this._sendMessage("loadTheme", { instanceId: this._id, themeId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  load(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("load", { config: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLoop(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setLoop", { instanceId: this._id, loop: n }), yield this._updateDotLottieInstanceState());
    });
  }
  resize() {
    return It(this, null, function* () {
      if (!this._created)
        return;
      let { height: n, width: i } = vx(this._canvas);
      yield this._sendMessage("resize", { height: n, instanceId: this._id, width: i }), yield this._updateDotLottieInstanceState();
    });
  }
  destroy() {
    return It(this, null, function* () {
      this._created && (this._created = !1, yield this._sendMessage("destroy", { instanceId: this._id }), this._cleanupStateMachineListeners(), ll._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), Or && this._canvas instanceof HTMLCanvasElement && (Ri.unobserve(this._canvas), Oi.unobserve(this._canvas)));
    });
  }
  freeze() {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("freeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  unfreeze() {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("unfreeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setBackgroundColor(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setBackgroundColor", { instanceId: this._id, backgroundColor: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadAnimation(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("loadAnimation", { animationId: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLayout(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setLayout", { instanceId: this._id, layout: n }), yield this._updateDotLottieInstanceState());
    });
  }
  _updateDotLottieInstanceState() {
    return It(this, null, function* () {
      if (!this._created)
        return;
      let n = yield this._sendMessage("getDotLottieInstanceState", { instanceId: this._id });
      this._dotLottieInstanceState = n.state;
    });
  }
  markers() {
    return this._dotLottieInstanceState.markers;
  }
  setMarker(n) {
    return It(this, null, function* () {
      this._created && (yield this._sendMessage("setMarker", { instanceId: this._id, marker: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadThemeData(n) {
    return It(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadThemeData", { instanceId: this._id, themeData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  setViewport(n, i, a, s) {
    return It(this, null, function* () {
      return this._created ? this._sendMessage("setViewport", { x: n, y: i, width: a, height: s, instanceId: this._id }) : !1;
    });
  }
  _sendMessage(n, i, a) {
    return It(this, null, function* () {
      let s = { id: `dotlottie-request-${yx()}`, method: n, params: i };
      return this._worker.postMessage(s, a || []), new Promise((g, c) => {
        let I = (h) => {
          let m = h.data;
          m.id === s.id && (this._worker.removeEventListener("message", I), m.error ? c(new Error(`Failed to execute method ${n}: ${m.error}`)) : g(m.result));
        };
        this._worker.addEventListener("message", I);
      });
    });
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  static setWasmUrl(n) {
    ll._wasmUrl = n;
  }
  loadStateMachine(n) {
    return It(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachine", { instanceId: this._id, stateMachineId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  loadStateMachineData(n) {
    return It(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachineData", { instanceId: this._id, stateMachineData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  startStateMachine() {
    return It(this, null, function* () {
      if (!this._created)
        return !1;
      this._setupStateMachineListeners();
      let n = yield this._sendMessage("startStateMachine", { instanceId: this._id });
      return yield this._updateDotLottieInstanceState(), n;
    });
  }
  stopStateMachine() {
    return It(this, null, function* () {
      return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", { instanceId: this._id })) : !1;
    });
  }
  getStateMachineListeners() {
    return It(this, null, function* () {
      return this._created ? this._sendMessage("getStateMachineListeners", { instanceId: this._id }) : [];
    });
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), a = this._canvas.width / i.width, s = this._canvas.height / i.height, g = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, c = (n.clientX - i.left) * a / g, I = (n.clientY - i.top) * s / g;
    return { x: c, y: I };
  }
  _onPointerUp(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerUpEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerDown(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerDownEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerMove(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerMoveEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerEnter(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerEnterEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerLeave(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerExitEvent", { instanceId: this._id, x: i, y: a });
  }
  _setupStateMachineListeners() {
    return It(this, null, function* () {
      if (Or && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
        let n = yield this._sendMessage("getStateMachineListeners", { instanceId: this._id });
        n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
      }
    });
  }
  _cleanupStateMachineListeners() {
    Or && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
};
ct(bx, "_workerManager", new TX()), ct(bx, "_wasmUrl", "");
function LX(e) {
  var n = e, {
    children: i,
    className: a = "",
    setCanvasRef: s,
    setContainerRef: g,
    style: c
  } = n, I = PM(n, [
    "children",
    "className",
    "setCanvasRef",
    "setContainerRef",
    "style"
  ]);
  const h = _o({
    width: "100%",
    height: "100%",
    lineHeight: 0
  }, c);
  return /* @__PURE__ */ Gt.createElement("div", _o({ ref: g, className: a }, !a && { style: h }), /* @__PURE__ */ Gt.createElement(
    "canvas",
    _o({
      ref: s,
      style: {
        width: "100%",
        height: "100%"
      }
    }, I),
    i
  ));
}
var RX = (e) => {
  const [n, i] = qt(null), a = yn(null), s = yn(e), g = yn(null), c = yn(null);
  a.current = n, s.current = e;
  const I = h2((S) => {
    var T, D;
    !((T = s.current) != null && T.playOnHover) || !((D = a.current) != null && D.isLoaded) || (S.type === "mouseenter" ? a.current.play() : S.type === "mouseleave" && a.current.pause());
  }, []), h = h2((S) => {
    g.current = S;
  }, []), m = h2((S) => {
    c.current = S;
  }, []), w = h2(
    (S) => /* @__PURE__ */ Gt.createElement(LX, _o({ setContainerRef: m, setCanvasRef: h }, S)),
    [h, m]
  );
  return vn(() => {
    const S = g.current;
    let T = null;
    return S && (T = new SX(fX(_o({}, s.current), {
      canvas: S
    })), S.addEventListener("mouseenter", I), S.addEventListener("mouseleave", I), i(T)), () => {
      T == null || T.destroy(), i(null), S == null || S.removeEventListener("mouseenter", I), S == null || S.removeEventListener("mouseleave", I);
    };
  }, [I]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.speed) == "number" && e.speed !== a.current.speed && a.current.setSpeed(e.speed);
  }, [e == null ? void 0 : e.speed]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.mode) == "string" && e.mode !== a.current.mode && a.current.setMode(e.mode);
  }, [e == null ? void 0 : e.mode]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.loop) == "boolean" && e.loop !== a.current.loop && a.current.setLoop(e.loop);
  }, [e == null ? void 0 : e.loop]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.useFrameInterpolation) == "boolean" && e.useFrameInterpolation !== a.current.useFrameInterpolation && a.current.setUseFrameInterpolation(e.useFrameInterpolation);
  }, [e == null ? void 0 : e.useFrameInterpolation]), vn(() => {
    var S, T;
    if (!a.current)
      return;
    const D = (S = e == null ? void 0 : e.segment) == null ? void 0 : S[0], k = (T = e == null ? void 0 : e.segment) == null ? void 0 : T[1];
    typeof D == "number" && typeof k == "number" && a.current.setSegment(D, k);
  }, [e == null ? void 0 : e.segment]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.backgroundColor) == "string" && e.backgroundColor !== a.current.backgroundColor && a.current.setBackgroundColor(e.backgroundColor);
  }, [e == null ? void 0 : e.backgroundColor]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.renderConfig) == "object" && a.current.setRenderConfig(e.renderConfig);
  }, [JSON.stringify(e == null ? void 0 : e.renderConfig)]), vn(() => {
    a.current && (typeof (e == null ? void 0 : e.data) == "string" || (e == null ? void 0 : e.data) instanceof ArrayBuffer) && a.current.load(_o({
      data: e.data
    }, s.current || {}));
  }, [e == null ? void 0 : e.data]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.src) == "string" && a.current.load(_o({
      src: e.src
    }, s.current || {}));
  }, [e == null ? void 0 : e.src]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.marker) == "string" && a.current.setMarker(e.marker);
  }, [e == null ? void 0 : e.marker]), vn(() => {
    a.current && a.current.isLoaded && e != null && e.animationId && a.current.activeAnimationId !== e.animationId && a.current.loadAnimation(e.animationId);
  }, [e == null ? void 0 : e.animationId]), vn(() => {
    a.current && a.current.isLoaded && a.current.activeThemeId !== (e == null ? void 0 : e.themeId) && a.current.loadTheme((e == null ? void 0 : e.themeId) || "");
  }, [e == null ? void 0 : e.themeId]), vn(() => {
    a.current && a.current.isLoaded && a.current.loadThemeData((e == null ? void 0 : e.themeData) || "");
  }, [e == null ? void 0 : e.themeData]), {
    dotLottie: n,
    setCanvasRef: h,
    setContainerRef: m,
    canvas: g.current,
    container: c.current,
    DotLottieComponent: w
  };
}, OX = typeof window < "u" ? If : vn;
function DX(e) {
  const n = yn(e);
  return OX(() => {
    n.current = e;
  }), h2((...i) => n.current(...i), [n]);
}
var Bf = (e) => {
  var n = e, {
    animationId: i,
    autoplay: a,
    backgroundColor: s,
    data: g,
    dotLottieRefCallback: c,
    loop: I,
    marker: h,
    mode: m,
    playOnHover: w,
    renderConfig: S,
    segment: T,
    speed: D,
    src: k,
    themeData: z,
    themeId: N,
    useFrameInterpolation: W
  } = n, K = PM(n, [
    "animationId",
    "autoplay",
    "backgroundColor",
    "data",
    "dotLottieRefCallback",
    "loop",
    "marker",
    "mode",
    "playOnHover",
    "renderConfig",
    "segment",
    "speed",
    "src",
    "themeData",
    "themeId",
    "useFrameInterpolation"
  ]);
  const { DotLottieComponent: V, dotLottie: Y } = RX({
    data: g,
    mode: m,
    speed: D,
    src: k,
    autoplay: a,
    loop: I,
    segment: T,
    renderConfig: S,
    backgroundColor: s,
    useFrameInterpolation: W,
    playOnHover: w,
    marker: h,
    themeId: N,
    animationId: i,
    themeData: z
  }), H = typeof c == "function" ? DX(c) : void 0;
  return Gt.useEffect(() => {
    typeof H == "function" && H(Y);
  }, [H, Y]), /* @__PURE__ */ Gt.createElement(V, _o({}, K));
};
const kX = "data:application/octet-stream;base64,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", ue1 = (e) => /* @__PURE__ */ y.jsx(Bf, { ...e, src: kX }), jX = "data:application/json;base64,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", zX = (e) => /* @__PURE__ */ y.jsx(Bf, { ...e, src: jX }), NX = "data:application/json;base64,eyJubSI6IlMiLCJoIjoxMDAsInciOjEwMCwibWV0YSI6eyJnIjoiQGxvdHRpZWZpbGVzL3Rvb2xraXQtanMgMC4zMy4yIn0sImxheWVycyI6W3sidHkiOjQsIm5tIjoicyIsInNyIjoxLCJzdCI6MCwib3AiOjYwLCJpcCI6MCwiaGFzTWFzayI6ZmFsc2UsImFvIjowLCJrcyI6eyJhIjp7ImEiOjAsImsiOlsxNjAsMjg0LDBdfSwicyI6eyJhIjowLCJrIjpbMTAwLDEwMCwxMDBdfSwic2siOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6WzUwLDUwLDBdfSwiciI6eyJhIjowLCJrIjowfSwic2EiOnsiYSI6MCwiayI6MH0sIm8iOnsiYSI6MCwiayI6MTAwfX0sImVmIjpbXSwic2hhcGVzIjpbeyJ0eSI6ImdyIiwibm0iOiJHIiwiaXQiOlt7InR5Ijoic2giLCJubSI6IlAiLCJkIjoxLCJrcyI6eyJhIjowLCJrIjp7ImMiOnRydWUsImkiOltbMCwxOS44ODJdLFsxOS44ODIsMF0sWzAsLTE5Ljg4Ml0sWy0xOS44ODIsMF1dLCJvIjpbWzAsLTE5Ljg4Ml0sWy0xOS44ODIsMF0sWzAsMTkuODgyXSxbMTkuODgyLDBdXSwidiI6W1szNiwwXSxbMCwtMzZdLFstMzYsMF0sWzAsMzZdXX19fSx7InR5IjoidG0iLCJubSI6IlQiLCJlIjp7ImEiOjEsImsiOlt7Im8iOnsieCI6MC4zMzMsInkiOjB9LCJpIjp7IngiOjAuODMzLCJ5IjowLjgzM30sInMiOlsxMDBdLCJ0IjoyMH0seyJzIjpbMV0sInQiOjYwfV19LCJvIjp7ImEiOjAsImsiOjB9LCJzIjp7ImEiOjEsImsiOlt7Im8iOnsieCI6MC4xNjcsInkiOjAuMTY3fSwiaSI6eyJ4IjowLjY2NywieSI6MX0sInMiOlsxMDBdLCJ0IjowfSx7Im8iOnsieCI6MC4xNjcsInkiOjB9LCJpIjp7IngiOjAuODMzLCJ5IjoxfSwicyI6WzBdLCJ0IjoyOX0seyJzIjpbMF0sInQiOjUxfV19LCJtIjoxfSx7InR5Ijoic3QiLCJubSI6IlMiLCJsYyI6MiwibGoiOjEsIm1sIjoxMCwibyI6eyJhIjowLCJrIjoxMDB9LCJ3Ijp7ImEiOjAsImsiOjEwfSwiYyI6eyJhIjowLCJrIjpbMC4wNzgsMC40NjMsMC43MjJdfX0seyJ0eSI6InRyIiwiYSI6eyJhIjowLCJrIjpbMCwwXX0sInMiOnsiYSI6MCwiayI6WzEwMCwxMDBdfSwic2siOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6WzE2MCwyODRdfSwiciI6eyJhIjoxLCJrIjpbeyJvIjp7IngiOjAuMTY3LCJ5IjowLjE2N30sImkiOnsieCI6MC42NjcsInkiOjF9LCJzIjpbLTkwXSwidCI6MH0seyJzIjpbMjcwXSwidCI6NTl9XX0sInNhIjp7ImEiOjAsImsiOjB9LCJvIjp7ImEiOjAsImsiOjEwMH19XX1dLCJpbmQiOjF9XSwidiI6IjUuMS44IiwiZnIiOjI5Ljk3LCJvcCI6NjAsImlwIjowLCJhc3NldHMiOltdfQ==", PX = (e) => /* @__PURE__ */ y.jsx(Bf, { ...e, src: NX }), FX = "data:application/json;base64,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", ce1 = (e) => /* @__PURE__ */ y.jsx(Bf, { ...e, src: FX }), BX = "data:application/json;base64,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", ge1 = (e) => /* @__PURE__ */ y.jsx(Bf, { ...e, src: BX }), KM = {
  position: "absolute",
  top: "0%"
}, HX = {
  ...KM,
  transform: "scale(1.3)",
  top: "2%",
  left: "1%"
}, UX = H1(Ke)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[200],
  width: "75px",
  height: "75px",
  transform: "translate(75px, -150px)"
})), WX = H1(Ke)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[200],
  borderRadius: "100%",
  width: "150px",
  height: "150px"
})), fe1 = ({
  delay: e = 3e3,
  finalDelay: n = 2e3,
  progressCaptions: i = [
    "Fetching data...",
    "Processing response...",
    "Wrapping up..."
  ],
  progressTitle: a = "We are preparing your data",
  isLoading: s,
  successTitle: g = "Your data is ready",
  successCaption: c = "All set and ready to go",
  onShouldVanish: I = () => {
  }
}) => {
  const [h, m] = qt(0), [w, S] = qt(!1);
  if (If(() => {
    const D = setInterval(() => {
      h < i.length - 1 && m((k) => k + 1);
    }, e);
    return () => {
      clearInterval(D);
    };
  }, [e, i, h]), If(() => {
    if (!s) {
      const D = setTimeout(() => {
        I(), S(!0);
      }, n);
      return () => clearTimeout(D);
    }
  }, [n, I, s]), w)
    return null;
  const T = s ? a : g;
  return /* @__PURE__ */ y.jsxs(
    Ke,
    {
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      role: "progressbar",
      "aria-valuetext": "title",
      "aria-valuemin": s ? 0 : 100,
      children: [
        /* @__PURE__ */ y.jsxs(F1, { position: "relative", height: "150px", children: [
          /* @__PURE__ */ y.jsx(WX, {}),
          /* @__PURE__ */ y.jsx(UX, {}),
          s ? /* @__PURE__ */ y.jsx(PX, { autoplay: !0, loop: !0, style: KM }) : /* @__PURE__ */ y.jsx(zX, { autoplay: !0, style: HX })
        ] }),
        /* @__PURE__ */ y.jsx(ne, { variant: "h5", p: 2, textAlign: "center", children: T }),
        /* @__PURE__ */ y.jsx(ne, { textAlign: "center", children: s ? i[h] : c })
      ]
    }
  );
}, VX = H1(uS)(({ theme: e }) => ({
  position: "fixed",
  top: 0,
  "html.native-android &": {
    top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))"
  },
  left: 0,
  right: 0,
  zIndex: e.zIndex.appBar + 1
}));
function de1({ open: e, ...n }) {
  return e ? /* @__PURE__ */ y.jsx(VX, { ...n }) : null;
}
const wx = H1(Oj)(({ theme: e }) => ({
  ...e.typography.body1,
  margin: "0px 10px",
  color: e.palette.primary.main,
  width: "32px",
  height: "32px",
  padding: 0,
  "&.Mui-disabled": {
    color: e.palette.common.neutrals[500]
  },
  "&.MuiPaginationItem-previousNext": {
    width: "32px",
    height: "32px",
    padding: 0
  },
  "&.Mui-selected": {
    "&:hover": {
      color: e.palette.primary.main[500]
    },
    backgroundColor: e.palette.primary.main,
    color: e.palette.common.neutrals[100]
  }
})), QC = H1(Ke)(() => ({
  borderRadius: "4px",
  width: "32px",
  height: "32px",
  justifyContent: "center",
  alignItems: "center"
}));
function _X({
  sx: e,
  page: n,
  count: i,
  onChange: a,
  ...s
}) {
  const [g, c] = Gt.useState(String(n || 1));
  Gt.useEffect(() => {
    c(String(n || 1));
  }, [n]);
  const I = (m) => {
    const w = typeof i == "number" && i > 0 ? i : 1;
    return Number.isNaN(m) ? n || 1 : Math.min(Math.max(m, 1), w);
  }, h = (m) => {
    const w = I(parseInt(m, 10));
    w && w !== n && typeof a == "function" && a(null, w);
  };
  return /* @__PURE__ */ y.jsxs(Ke, { direction: "row", alignItems: "center", justifyContent: "center", sx: e, children: [
    /* @__PURE__ */ y.jsx(
      mb,
      {
        sx: {
          "&:ul": {
            height: "32px",
            "&:li": {
              height: "32px"
            }
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        shape: "rounded",
        showFirstButton: !0,
        showLastButton: !0,
        siblingCount: 0,
        boundaryCount: 0,
        page: n,
        count: i,
        onChange: a,
        renderItem: (m) => m.type === "page" || m.type === "next" || m.type === "last" || m.type === "start-ellipsis" || m.type === "end-ellipsis" ? /* @__PURE__ */ y.jsx("span", {}) : /* @__PURE__ */ y.jsx(
          wx,
          {
            slots: {
              previous: () => /* @__PURE__ */ y.jsx(QC, { children: /* @__PURE__ */ y.jsx(Me, { icon: "chevronLeft" }) }),
              next: () => /* @__PURE__ */ y.jsx(QC, { children: /* @__PURE__ */ y.jsx(Me, { icon: "chevronRight" }) })
            },
            ...m
          }
        ),
        ...s
      }
    ),
    /* @__PURE__ */ y.jsxs(Ke, { direction: "row", alignItems: "center", ml: 2, gap: 1, children: [
      /* @__PURE__ */ y.jsx(ne, { color: (m) => m.palette.common.neutrals[500], children: "Page" }),
      /* @__PURE__ */ y.jsx(
        Ef,
        {
          value: g,
          onChange: (m) => {
            const w = m.target.value.replace(/[^0-9]/g, "");
            c(w);
          },
          onBlur: () => h(g),
          onKeyDown: (m) => {
            m.key === "Enter" && h(g);
          },
          inputProps: {
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: { textAlign: "center" }
          },
          sx: {
            width: 72,
            "& .MuiInputBase-root": { height: 52 }
          }
        }
      ),
      /* @__PURE__ */ y.jsx(ne, { color: (m) => m.palette.common.neutrals[500], children: `of ${i || 1}` })
    ] }),
    /* @__PURE__ */ y.jsx(
      mb,
      {
        sx: {
          "&:ul": {
            height: "32px",
            "&:li": {
              height: "32px"
            }
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        shape: "rounded",
        showFirstButton: !0,
        showLastButton: !0,
        siblingCount: 0,
        boundaryCount: 0,
        page: n,
        count: i,
        onChange: a,
        renderItem: (m) => m.type === "page" || m.type === "previous" || m.type === "first" || m.type === "start-ellipsis" || m.type === "end-ellipsis" ? /* @__PURE__ */ y.jsx("span", {}) : /* @__PURE__ */ y.jsx(
          wx,
          {
            slots: {
              previous: () => /* @__PURE__ */ y.jsx(QC, { children: /* @__PURE__ */ y.jsx(Me, { icon: "chevronLeft" }) }),
              next: () => /* @__PURE__ */ y.jsx(QC, { children: /* @__PURE__ */ y.jsx(Me, { icon: "chevronRight" }) })
            },
            ...m
          }
        )
      }
    )
  ] });
}
const JX = H1(HA)({
  pointerEvents: "none"
}), KX = H1(HA)({
  pointerEvents: "none",
  "& .MuiPopover-paper": {
    pointerEvents: "auto"
  }
}), xx = H1(F1)(({ theme: e }) => ({
  minWidth: 280,
  padding: e.spacing(2)
})), YX = ({
  children: e,
  variant: n = "default",
  ...i
}) => n === "entityPreview" ? /* @__PURE__ */ y.jsx(JX, { ...i, children: /* @__PURE__ */ y.jsx(xx, { children: e }) }) : n === "interactiveEntityPreview" ? /* @__PURE__ */ y.jsx(
  KX,
  {
    ...i,
    disableAutoFocus: !0,
    disableEnforceFocus: !0,
    disableScrollLock: !0,
    children: /* @__PURE__ */ y.jsx(xx, { children: e })
  }
) : /* @__PURE__ */ y.jsx(HA, { ...i, children: e }), Ce1 = ({
  SmallView: e = null,
  LargeView: n = null,
  ExtraLargeView: i = null,
  fallbackComponent: a = /* @__PURE__ */ y.jsx(kM, { open: !0 })
}) => {
  const s = t6(), g = Vb(s.breakpoints.up("md")), c = Vb(s.breakpoints.up("lg")), I = V2(() => g && !c ? n : c ? i || n : e, [g, c, n, i, e]);
  return /* @__PURE__ */ y.jsx(Gt.Suspense, { fallback: a, children: I });
};
function Ae1({
  sx: e,
  onChange: n = () => {
  },
  debounceTime: i = 500,
  ...a
}) {
  const s = Da(), g = V2(
    () => Dj(n, i),
    [n, i]
  );
  return /* @__PURE__ */ y.jsx(
    Ef,
    {
      placeholder: "Search",
      sx: {
        marginRight: "48px",
        ".MuiOutlinedInput-notchedOutline": {
          border: 0
        },
        ...e
      },
      InputProps: {
        sx: {
          background: s.palette.common.neutrals[100],
          borderRadius: "24px",
          paddingLeft: "12px"
        },
        endAdornment: /* @__PURE__ */ y.jsx(Bh, { position: "start", children: /* @__PURE__ */ y.jsx(
          Me,
          {
            icon: "search",
            sx: { color: s.palette.common.neutrals[300] }
          }
        ) })
      },
      onChange: g,
      ...a
    }
  );
}
const v7 = { marginRight: "10px" };
function Ie1({ isPdf: e, isImage: n }) {
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    e && /* @__PURE__ */ y.jsx(Me, { icon: "filePdf", sx: v7 }),
    n && /* @__PURE__ */ y.jsx(Me, { icon: "fileImage", sx: v7 }),
    !e && !n && /* @__PURE__ */ y.jsx(Me, { icon: "file", sx: v7 })
  ] });
}
function pe1({
  label: e,
  onClick: n,
  sortDirection: i,
  variant: a = "standalone"
}) {
  const s = a === "inherit", g = i === "asc" ? "sortDown" : i ? "sortUp" : null;
  return /* @__PURE__ */ y.jsx(
    Hh,
    {
      type: "button",
      disableRipple: !0,
      onClick: n,
      sx: {
        justifyContent: "flex-start",
        gap: s ? 0.5 : 0,
        maxWidth: "100%",
        borderRadius: 0.5,
        // A native button resets these; the label belongs to its header cell.
        font: "inherit",
        letterSpacing: "inherit",
        textTransform: "inherit",
        "&.Mui-focusVisible": {
          outline: (c) => `2px solid ${c.palette.primary.main}`,
          outlineOffset: 2
        },
        ...s ? {
          color: "inherit",
          "&:hover": { color: "text.primary" }
        } : {
          width: "100%",
          color: i ? "text.primary" : "text.secondary"
        }
      },
      children: s ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(
          F1,
          {
            component: "span",
            sx: {
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e
          }
        ),
        /* @__PURE__ */ y.jsx(
          F1,
          {
            component: "span",
            "aria-hidden": !0,
            sx: {
              color: "secondary.main",
              visibility: i ? "visible" : "hidden"
            },
            children: i === "asc" ? "↑" : "↓"
          }
        )
      ] }) : /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        /* @__PURE__ */ y.jsx(ne, { variant: "body2", children: e }),
        /* @__PURE__ */ y.jsx(Me, { icon: g ?? "sort" })
      ] })
    }
  );
}
const Rm = /* @__PURE__ */ n1.createContext();
process.env.NODE_ENV !== "production" && (Rm.displayName = "TableContext");
function QX(e) {
  return sr("MuiTable", e);
}
m2("MuiTable", ["root", "stickyHeader"]);
const XX = ["className", "component", "padding", "size", "stickyHeader"], GX = (e) => {
  const {
    classes: n,
    stickyHeader: i
  } = e;
  return Yr({
    root: ["root", i && "stickyHeader"]
  }, QX, n);
}, qX = Rn("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.stickyHeader && n.stickyHeader];
  }
})(({
  theme: e,
  ownerState: n
}) => m1({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": m1({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, n.stickyHeader && {
  borderCollapse: "separate"
})), Sx = "table", YM = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTable"
  }), {
    className: s,
    component: g = Sx,
    padding: c = "normal",
    size: I = "medium",
    stickyHeader: h = !1
  } = a, m = Tt(a, XX), w = m1({}, a, {
    component: g,
    padding: c,
    size: I,
    stickyHeader: h
  }), S = GX(w), T = n1.useMemo(() => ({
    padding: c,
    size: I,
    stickyHeader: h
  }), [c, I, h]);
  return /* @__PURE__ */ y.jsx(Rm.Provider, {
    value: T,
    children: /* @__PURE__ */ y.jsx(qX, m1({
      as: g,
      role: g === Sx ? null : "table",
      ref: i,
      className: Xt(S.root, s),
      ownerState: w
    }, m))
  });
});
process.env.NODE_ENV !== "production" && (YM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: E.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: E.oneOfType([E.oneOf(["medium", "small"]), E.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const Hf = /* @__PURE__ */ n1.createContext();
process.env.NODE_ENV !== "production" && (Hf.displayName = "Tablelvl2Context");
function ZX(e) {
  return sr("MuiTableBody", e);
}
m2("MuiTableBody", ["root"]);
const $X = ["className", "component"], eG = (e) => {
  const {
    classes: n
  } = e;
  return Yr({
    root: ["root"]
  }, ZX, n);
}, tG = Rn("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "table-row-group"
}), nG = {
  variant: "body"
}, Ex = "tbody", QM = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableBody"
  }), {
    className: s,
    component: g = Ex
  } = a, c = Tt(a, $X), I = m1({}, a, {
    component: g
  }), h = eG(I);
  return /* @__PURE__ */ y.jsx(Hf.Provider, {
    value: nG,
    children: /* @__PURE__ */ y.jsx(tG, m1({
      className: Xt(h.root, s),
      as: g,
      ref: i,
      role: g === Ex ? null : "rowgroup",
      ownerState: I
    }, c))
  });
});
process.env.NODE_ENV !== "production" && (QM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function rG() {
  return {
    accessor: (e, n) => typeof e == "function" ? {
      ...n,
      accessorFn: e
    } : {
      ...n,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Jo(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function O3(e, n) {
  return (i) => {
    n.setState((a) => ({
      ...a,
      [e]: Jo(i, a[e])
    }));
  };
}
function C6(e) {
  return e instanceof Function;
}
function iG(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function it(e, n, i) {
  let a = [], s;
  return (g) => {
    let c;
    i.key && i.debug && (c = Date.now());
    const I = e(g);
    if (!(I.length !== a.length || I.some((w, S) => a[S] !== w)))
      return s;
    a = I;
    let m;
    if (i.key && i.debug && (m = Date.now()), s = n(...I), i == null || i.onChange == null || i.onChange(s), i.key && i.debug && i != null && i.debug()) {
      const w = Math.round((Date.now() - c) * 100) / 100, S = Math.round((Date.now() - m) * 100) / 100, T = S / 16, D = (k, z) => {
        for (k = String(k); k.length < z; )
          k = " " + k;
        return k;
      };
      console.info(`%c⏱ ${D(S, 5)} /${D(w, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * T, 120))}deg 100% 31%);`, i == null ? void 0 : i.key);
    }
    return s;
  };
}
function at(e, n, i, a) {
  return {
    debug: () => {
      var s;
      return (s = e == null ? void 0 : e.debugAll) != null ? s : e[n];
    },
    key: process.env.NODE_ENV === "development" && i,
    onChange: a
  };
}
function aG(e, n, i, a) {
  var s, g;
  const I = {
    ...e._getDefaultColumnDef(),
    ...n
  }, h = I.accessorKey;
  let m = (s = (g = I.id) != null ? g : h ? typeof String.prototype.replaceAll == "function" ? h.replaceAll(".", "_") : h.replace(/\./g, "_") : void 0) != null ? s : typeof I.header == "string" ? I.header : void 0, w;
  if (I.accessorFn ? w = I.accessorFn : h && (h.includes(".") ? w = (T) => {
    let D = T;
    for (const z of h.split(".")) {
      var k;
      D = (k = D) == null ? void 0 : k[z], process.env.NODE_ENV !== "production" && D === void 0 && console.warn(`"${z}" in deeply nested key "${h}" returned undefined.`);
    }
    return D;
  } : w = (T) => T[I.accessorKey]), !m)
    throw process.env.NODE_ENV !== "production" ? new Error(I.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let S = {
    id: `${String(m)}`,
    accessorFn: w,
    parent: a,
    depth: i,
    columnDef: I,
    columns: [],
    getFlatColumns: it(() => [!0], () => {
      var T;
      return [S, ...(T = S.columns) == null ? void 0 : T.flatMap((D) => D.getFlatColumns())];
    }, at(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: it(() => [e._getOrderColumnsFn()], (T) => {
      var D;
      if ((D = S.columns) != null && D.length) {
        let k = S.columns.flatMap((z) => z.getLeafColumns());
        return T(k);
      }
      return [S];
    }, at(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const T of e._features)
    T.createColumn == null || T.createColumn(S, e);
  return S;
}
const Lr = "debugHeaders";
function Mx(e, n, i) {
  var a;
  let g = {
    id: (a = i.id) != null ? a : n.id,
    column: n,
    index: i.index,
    isPlaceholder: !!i.isPlaceholder,
    placeholderId: i.placeholderId,
    depth: i.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const c = [], I = (h) => {
        h.subHeaders && h.subHeaders.length && h.subHeaders.map(I), c.push(h);
      };
      return I(g), c;
    },
    getContext: () => ({
      table: e,
      header: g,
      column: n
    })
  };
  return e._features.forEach((c) => {
    c.createHeader == null || c.createHeader(g, e);
  }), g;
}
const oG = {
  createTable: (e) => {
    e.getHeaderGroups = it(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a, s) => {
      var g, c;
      const I = (g = a == null ? void 0 : a.map((S) => i.find((T) => T.id === S)).filter(Boolean)) != null ? g : [], h = (c = s == null ? void 0 : s.map((S) => i.find((T) => T.id === S)).filter(Boolean)) != null ? c : [], m = i.filter((S) => !(a != null && a.includes(S.id)) && !(s != null && s.includes(S.id)));
      return XC(n, [...I, ...m, ...h], e);
    }, at(e.options, Lr, "getHeaderGroups")), e.getCenterHeaderGroups = it(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a, s) => (i = i.filter((g) => !(a != null && a.includes(g.id)) && !(s != null && s.includes(g.id))), XC(n, i, e, "center")), at(e.options, Lr, "getCenterHeaderGroups")), e.getLeftHeaderGroups = it(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, i, a) => {
      var s;
      const g = (s = a == null ? void 0 : a.map((c) => i.find((I) => I.id === c)).filter(Boolean)) != null ? s : [];
      return XC(n, g, e, "left");
    }, at(e.options, Lr, "getLeftHeaderGroups")), e.getRightHeaderGroups = it(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, i, a) => {
      var s;
      const g = (s = a == null ? void 0 : a.map((c) => i.find((I) => I.id === c)).filter(Boolean)) != null ? s : [];
      return XC(n, g, e, "right");
    }, at(e.options, Lr, "getRightHeaderGroups")), e.getFooterGroups = it(() => [e.getHeaderGroups()], (n) => [...n].reverse(), at(e.options, Lr, "getFooterGroups")), e.getLeftFooterGroups = it(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), at(e.options, Lr, "getLeftFooterGroups")), e.getCenterFooterGroups = it(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), at(e.options, Lr, "getCenterFooterGroups")), e.getRightFooterGroups = it(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), at(e.options, Lr, "getRightFooterGroups")), e.getFlatHeaders = it(() => [e.getHeaderGroups()], (n) => n.map((i) => i.headers).flat(), at(e.options, Lr, "getFlatHeaders")), e.getLeftFlatHeaders = it(() => [e.getLeftHeaderGroups()], (n) => n.map((i) => i.headers).flat(), at(e.options, Lr, "getLeftFlatHeaders")), e.getCenterFlatHeaders = it(() => [e.getCenterHeaderGroups()], (n) => n.map((i) => i.headers).flat(), at(e.options, Lr, "getCenterFlatHeaders")), e.getRightFlatHeaders = it(() => [e.getRightHeaderGroups()], (n) => n.map((i) => i.headers).flat(), at(e.options, Lr, "getRightFlatHeaders")), e.getCenterLeafHeaders = it(() => [e.getCenterFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), at(e.options, Lr, "getCenterLeafHeaders")), e.getLeftLeafHeaders = it(() => [e.getLeftFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), at(e.options, Lr, "getLeftLeafHeaders")), e.getRightLeafHeaders = it(() => [e.getRightFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), at(e.options, Lr, "getRightLeafHeaders")), e.getLeafHeaders = it(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, i, a) => {
      var s, g, c, I, h, m;
      return [...(s = (g = n[0]) == null ? void 0 : g.headers) != null ? s : [], ...(c = (I = i[0]) == null ? void 0 : I.headers) != null ? c : [], ...(h = (m = a[0]) == null ? void 0 : m.headers) != null ? h : []].map((w) => w.getLeafHeaders()).flat();
    }, at(e.options, Lr, "getLeafHeaders"));
  }
};
function XC(e, n, i, a) {
  var s, g;
  let c = 0;
  const I = function(T, D) {
    D === void 0 && (D = 1), c = Math.max(c, D), T.filter((k) => k.getIsVisible()).forEach((k) => {
      var z;
      (z = k.columns) != null && z.length && I(k.columns, D + 1);
    }, 0);
  };
  I(e);
  let h = [];
  const m = (T, D) => {
    const k = {
      depth: D,
      id: [a, `${D}`].filter(Boolean).join("_"),
      headers: []
    }, z = [];
    T.forEach((N) => {
      const W = [...z].reverse()[0], K = N.column.depth === k.depth;
      let V, Y = !1;
      if (K && N.column.parent ? V = N.column.parent : (V = N.column, Y = !0), W && (W == null ? void 0 : W.column) === V)
        W.subHeaders.push(N);
      else {
        const H = Mx(i, V, {
          id: [a, D, V.id, N == null ? void 0 : N.id].filter(Boolean).join("_"),
          isPlaceholder: Y,
          placeholderId: Y ? `${z.filter((Z) => Z.column === V).length}` : void 0,
          depth: D,
          index: z.length
        });
        H.subHeaders.push(N), z.push(H);
      }
      k.headers.push(N), N.headerGroup = k;
    }), h.push(k), D > 0 && m(z, D - 1);
  }, w = n.map((T, D) => Mx(i, T, {
    depth: c,
    index: D
  }));
  m(w, c - 1), h.reverse();
  const S = (T) => T.filter((k) => k.column.getIsVisible()).map((k) => {
    let z = 0, N = 0, W = [0];
    k.subHeaders && k.subHeaders.length ? (W = [], S(k.subHeaders).forEach((V) => {
      let {
        colSpan: Y,
        rowSpan: H
      } = V;
      z += Y, W.push(H);
    })) : z = 1;
    const K = Math.min(...W);
    return N = N + K, k.colSpan = z, k.rowSpan = N, {
      colSpan: z,
      rowSpan: N
    };
  });
  return S((s = (g = h[0]) == null ? void 0 : g.headers) != null ? s : []), h;
}
const sG = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, XM = (e, n, i) => {
  var a, s;
  const g = i == null || (a = i.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((s = e.getValue(n)) == null || (s = s.toString()) == null || (s = s.toLowerCase()) == null) && s.includes(g));
};
XM.autoRemove = (e) => H0(e);
const GM = (e, n, i) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(i));
};
GM.autoRemove = (e) => H0(e);
const qM = (e, n, i) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (i == null ? void 0 : i.toLowerCase());
};
qM.autoRemove = (e) => H0(e);
const ZM = (e, n, i) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(i);
};
ZM.autoRemove = (e) => H0(e) || !(e != null && e.length);
const $M = (e, n, i) => !i.some((a) => {
  var s;
  return !((s = e.getValue(n)) != null && s.includes(a));
});
$M.autoRemove = (e) => H0(e) || !(e != null && e.length);
const eT = (e, n, i) => i.some((a) => {
  var s;
  return (s = e.getValue(n)) == null ? void 0 : s.includes(a);
});
eT.autoRemove = (e) => H0(e) || !(e != null && e.length);
const tT = (e, n, i) => e.getValue(n) === i;
tT.autoRemove = (e) => H0(e);
const nT = (e, n, i) => e.getValue(n) == i;
nT.autoRemove = (e) => H0(e);
const Om = (e, n, i) => {
  let [a, s] = i;
  const g = e.getValue(n);
  return g >= a && g <= s;
};
Om.resolveFilterValue = (e) => {
  let [n, i] = e, a = typeof n != "number" ? parseFloat(n) : n, s = typeof i != "number" ? parseFloat(i) : i, g = n === null || Number.isNaN(a) ? -1 / 0 : a, c = i === null || Number.isNaN(s) ? 1 / 0 : s;
  if (g > c) {
    const I = g;
    g = c, c = I;
  }
  return [g, c];
};
Om.autoRemove = (e) => H0(e) || H0(e[0]) && H0(e[1]);
const Ea = {
  includesString: XM,
  includesStringSensitive: GM,
  equalsString: qM,
  arrIncludes: ZM,
  arrIncludesAll: $M,
  arrIncludesSome: eT,
  equals: tT,
  weakEquals: nT,
  inNumberRange: Om
};
function H0(e) {
  return e == null || e === "";
}
const lG = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: O3("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const i = n.getCoreRowModel().flatRows[0], a = i == null ? void 0 : i.getValue(e.id);
      return typeof a == "string" ? Ea.includesString : typeof a == "number" ? Ea.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? Ea.equals : Array.isArray(a) ? Ea.arrIncludes : Ea.weakEquals;
    }, e.getFilterFn = () => {
      var i, a;
      return C6(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (i = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? i : Ea[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var i, a, s;
      return ((i = e.columnDef.enableColumnFilter) != null ? i : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((s = n.options.enableFilters) != null ? s : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var i;
      return (i = n.getState().columnFilters) == null || (i = i.find((a) => a.id === e.id)) == null ? void 0 : i.value;
    }, e.getFilterIndex = () => {
      var i, a;
      return (i = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((s) => s.id === e.id)) != null ? i : -1;
    }, e.setFilterValue = (i) => {
      n.setColumnFilters((a) => {
        const s = e.getFilterFn(), g = a == null ? void 0 : a.find((w) => w.id === e.id), c = Jo(i, g ? g.value : void 0);
        if (Tx(s, c, e)) {
          var I;
          return (I = a == null ? void 0 : a.filter((w) => w.id !== e.id)) != null ? I : [];
        }
        const h = {
          id: e.id,
          value: c
        };
        if (g) {
          var m;
          return (m = a == null ? void 0 : a.map((w) => w.id === e.id ? h : w)) != null ? m : [];
        }
        return a != null && a.length ? [...a, h] : [h];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const i = e.getAllLeafColumns(), a = (s) => {
        var g;
        return (g = Jo(n, s)) == null ? void 0 : g.filter((c) => {
          const I = i.find((h) => h.id === c.id);
          if (I) {
            const h = I.getFilterFn();
            if (Tx(h, c.value, I))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var i, a;
      e.setColumnFilters(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? i : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Tx(e, n, i) {
  return (e && e.autoRemove ? e.autoRemove(n, i) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const uG = (e, n, i) => i.reduce((a, s) => {
  const g = s.getValue(e);
  return a + (typeof g == "number" ? g : 0);
}, 0), cG = (e, n, i) => {
  let a;
  return i.forEach((s) => {
    const g = s.getValue(e);
    g != null && (a > g || a === void 0 && g >= g) && (a = g);
  }), a;
}, gG = (e, n, i) => {
  let a;
  return i.forEach((s) => {
    const g = s.getValue(e);
    g != null && (a < g || a === void 0 && g >= g) && (a = g);
  }), a;
}, fG = (e, n, i) => {
  let a, s;
  return i.forEach((g) => {
    const c = g.getValue(e);
    c != null && (a === void 0 ? c >= c && (a = s = c) : (a > c && (a = c), s < c && (s = c)));
  }), [a, s];
}, dG = (e, n) => {
  let i = 0, a = 0;
  if (n.forEach((s) => {
    let g = s.getValue(e);
    g != null && (g = +g) >= g && (++i, a += g);
  }), i) return a / i;
}, CG = (e, n) => {
  if (!n.length)
    return;
  const i = n.map((g) => g.getValue(e));
  if (!iG(i))
    return;
  if (i.length === 1)
    return i[0];
  const a = Math.floor(i.length / 2), s = i.sort((g, c) => g - c);
  return i.length % 2 !== 0 ? s[a] : (s[a - 1] + s[a]) / 2;
}, AG = (e, n) => Array.from(new Set(n.map((i) => i.getValue(e))).values()), IG = (e, n) => new Set(n.map((i) => i.getValue(e))).size, pG = (e, n) => n.length, y7 = {
  sum: uG,
  min: cG,
  max: gG,
  extent: fG,
  mean: dG,
  median: CG,
  unique: AG,
  uniqueCount: IG,
  count: pG
}, hG = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, i;
      return (n = (i = e.getValue()) == null || i.toString == null ? void 0 : i.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: O3("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((i) => i != null && i.includes(e.id) ? i.filter((a) => a !== e.id) : [...i ?? [], e.id]);
    }, e.getCanGroup = () => {
      var i, a;
      return ((i = e.columnDef.enableGrouping) != null ? i : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var i;
      return (i = n.getState().grouping) == null ? void 0 : i.includes(e.id);
    }, e.getGroupedIndex = () => {
      var i;
      return (i = n.getState().grouping) == null ? void 0 : i.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const i = e.getCanGroup();
      return () => {
        i && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const i = n.getCoreRowModel().flatRows[0], a = i == null ? void 0 : i.getValue(e.id);
      if (typeof a == "number")
        return y7.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return y7.extent;
    }, e.getAggregationFn = () => {
      var i, a;
      if (!e)
        throw new Error();
      return C6(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (i = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? i : y7[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var i, a;
      e.setGrouping(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.grouping) != null ? i : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (i) => {
      if (e._groupingValuesCache.hasOwnProperty(i))
        return e._groupingValuesCache[i];
      const a = n.getColumn(i);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[i] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[i]) : e.getValue(i);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, i, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === i.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var s;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((s = i.subRows) != null && s.length);
    };
  }
};
function mG(e, n, i) {
  if (!(n != null && n.length) || !i)
    return e;
  const a = e.filter((g) => !n.includes(g.id));
  return i === "remove" ? a : [...n.map((g) => e.find((c) => c.id === g)).filter(Boolean), ...a];
}
const vG = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: O3("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = it((i) => [Cf(n, i)], (i) => i.findIndex((a) => a.id === e.id), at(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (i) => {
      var a;
      return ((a = Cf(n, i)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (i) => {
      var a;
      const s = Cf(n, i);
      return ((a = s[s.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var i;
      e.setColumnOrder(n ? [] : (i = e.initialState.columnOrder) != null ? i : []);
    }, e._getOrderColumnsFn = it(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, i, a) => (s) => {
      let g = [];
      if (!(n != null && n.length))
        g = s;
      else {
        const c = [...n], I = [...s];
        for (; I.length && c.length; ) {
          const h = c.shift(), m = I.findIndex((w) => w.id === h);
          m > -1 && g.push(I.splice(m, 1)[0]);
        }
        g = [...g, ...I];
      }
      return mG(g, i, a);
    }, at(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, b7 = () => ({
  left: [],
  right: []
}), yG = {
  getInitialState: (e) => ({
    columnPinning: b7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: O3("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (i) => {
      const a = e.getLeafColumns().map((s) => s.id).filter(Boolean);
      n.setColumnPinning((s) => {
        var g, c;
        if (i === "right") {
          var I, h;
          return {
            left: ((I = s == null ? void 0 : s.left) != null ? I : []).filter((S) => !(a != null && a.includes(S))),
            right: [...((h = s == null ? void 0 : s.right) != null ? h : []).filter((S) => !(a != null && a.includes(S))), ...a]
          };
        }
        if (i === "left") {
          var m, w;
          return {
            left: [...((m = s == null ? void 0 : s.left) != null ? m : []).filter((S) => !(a != null && a.includes(S))), ...a],
            right: ((w = s == null ? void 0 : s.right) != null ? w : []).filter((S) => !(a != null && a.includes(S)))
          };
        }
        return {
          left: ((g = s == null ? void 0 : s.left) != null ? g : []).filter((S) => !(a != null && a.includes(S))),
          right: ((c = s == null ? void 0 : s.right) != null ? c : []).filter((S) => !(a != null && a.includes(S)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var s, g, c;
      return ((s = a.columnDef.enablePinning) != null ? s : !0) && ((g = (c = n.options.enableColumnPinning) != null ? c : n.options.enablePinning) != null ? g : !0);
    }), e.getIsPinned = () => {
      const i = e.getLeafColumns().map((I) => I.id), {
        left: a,
        right: s
      } = n.getState().columnPinning, g = i.some((I) => a == null ? void 0 : a.includes(I)), c = i.some((I) => s == null ? void 0 : s.includes(I));
      return g ? "left" : c ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var i, a;
      const s = e.getIsPinned();
      return s ? (i = (a = n.getState().columnPinning) == null || (a = a[s]) == null ? void 0 : a.indexOf(e.id)) != null ? i : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = it(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (i, a, s) => {
      const g = [...a ?? [], ...s ?? []];
      return i.filter((c) => !g.includes(c.column.id));
    }, at(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = it(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (i, a) => (a ?? []).map((g) => i.find((c) => c.column.id === g)).filter(Boolean).map((g) => ({
      ...g,
      position: "left"
    })), at(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = it(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (i, a) => (a ?? []).map((g) => i.find((c) => c.column.id === g)).filter(Boolean).map((g) => ({
      ...g,
      position: "right"
    })), at(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var i, a;
      return e.setColumnPinning(n ? b7() : (i = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? i : b7());
    }, e.getIsSomeColumnsPinned = (n) => {
      var i;
      const a = e.getState().columnPinning;
      if (!n) {
        var s, g;
        return !!((s = a.left) != null && s.length || (g = a.right) != null && g.length);
      }
      return !!((i = a[n]) != null && i.length);
    }, e.getLeftLeafColumns = it(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, i) => (i ?? []).map((a) => n.find((s) => s.id === a)).filter(Boolean), at(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = it(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, i) => (i ?? []).map((a) => n.find((s) => s.id === a)).filter(Boolean), at(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = it(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a) => {
      const s = [...i ?? [], ...a ?? []];
      return n.filter((g) => !s.includes(g.id));
    }, at(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, GC = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, w7 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), bG = {
  getDefaultColumnDef: () => GC,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: w7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: O3("columnSizing", e),
    onColumnSizingInfoChange: O3("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var i, a, s;
      const g = n.getState().columnSizing[e.id];
      return Math.min(Math.max((i = e.columnDef.minSize) != null ? i : GC.minSize, (a = g ?? e.columnDef.size) != null ? a : GC.size), (s = e.columnDef.maxSize) != null ? s : GC.maxSize);
    }, e.getStart = it((i) => [i, Cf(n, i), n.getState().columnSizing], (i, a) => a.slice(0, e.getIndex(i)).reduce((s, g) => s + g.getSize(), 0), at(n.options, "debugColumns", "getStart")), e.getAfter = it((i) => [i, Cf(n, i), n.getState().columnSizing], (i, a) => a.slice(e.getIndex(i) + 1).reduce((s, g) => s + g.getSize(), 0), at(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((i) => {
        let {
          [e.id]: a,
          ...s
        } = i;
        return s;
      });
    }, e.getCanResize = () => {
      var i, a;
      return ((i = e.columnDef.enableResizing) != null ? i : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let i = 0;
      const a = (s) => {
        if (s.subHeaders.length)
          s.subHeaders.forEach(a);
        else {
          var g;
          i += (g = s.column.getSize()) != null ? g : 0;
        }
      };
      return a(e), i;
    }, e.getStart = () => {
      if (e.index > 0) {
        const i = e.headerGroup.headers[e.index - 1];
        return i.getStart() + i.getSize();
      }
      return 0;
    }, e.getResizeHandler = (i) => {
      const a = n.getColumn(e.column.id), s = a == null ? void 0 : a.getCanResize();
      return (g) => {
        if (!a || !s || (g.persist == null || g.persist(), x7(g) && g.touches && g.touches.length > 1))
          return;
        const c = e.getSize(), I = e ? e.getLeafHeaders().map((W) => [W.column.id, W.column.getSize()]) : [[a.id, a.getSize()]], h = x7(g) ? Math.round(g.touches[0].clientX) : g.clientX, m = {}, w = (W, K) => {
          typeof K == "number" && (n.setColumnSizingInfo((V) => {
            var Y, H;
            const Z = n.options.columnResizeDirection === "rtl" ? -1 : 1, Q = (K - ((Y = V == null ? void 0 : V.startOffset) != null ? Y : 0)) * Z, P1 = Math.max(Q / ((H = V == null ? void 0 : V.startSize) != null ? H : 0), -0.999999);
            return V.columnSizingStart.forEach((Y1) => {
              let [O1, T1] = Y1;
              m[O1] = Math.round(Math.max(T1 + T1 * P1, 0) * 100) / 100;
            }), {
              ...V,
              deltaOffset: Q,
              deltaPercentage: P1
            };
          }), (n.options.columnResizeMode === "onChange" || W === "end") && n.setColumnSizing((V) => ({
            ...V,
            ...m
          })));
        }, S = (W) => w("move", W), T = (W) => {
          w("end", W), n.setColumnSizingInfo((K) => ({
            ...K,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, D = i || typeof document < "u" ? document : null, k = {
          moveHandler: (W) => S(W.clientX),
          upHandler: (W) => {
            D == null || D.removeEventListener("mousemove", k.moveHandler), D == null || D.removeEventListener("mouseup", k.upHandler), T(W.clientX);
          }
        }, z = {
          moveHandler: (W) => (W.cancelable && (W.preventDefault(), W.stopPropagation()), S(W.touches[0].clientX), !1),
          upHandler: (W) => {
            var K;
            D == null || D.removeEventListener("touchmove", z.moveHandler), D == null || D.removeEventListener("touchend", z.upHandler), W.cancelable && (W.preventDefault(), W.stopPropagation()), T((K = W.touches[0]) == null ? void 0 : K.clientX);
          }
        }, N = wG() ? {
          passive: !1
        } : !1;
        x7(g) ? (D == null || D.addEventListener("touchmove", z.moveHandler, N), D == null || D.addEventListener("touchend", z.upHandler, N)) : (D == null || D.addEventListener("mousemove", k.moveHandler, N), D == null || D.addEventListener("mouseup", k.upHandler, N)), n.setColumnSizingInfo((W) => ({
          ...W,
          startOffset: h,
          startSize: c,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: I,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var i;
      e.setColumnSizing(n ? {} : (i = e.initialState.columnSizing) != null ? i : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var i;
      e.setColumnSizingInfo(n ? w7() : (i = e.initialState.columnSizingInfo) != null ? i : w7());
    }, e.getTotalSize = () => {
      var n, i;
      return (n = (i = e.getHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, i;
      return (n = (i = e.getLeftHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, i;
      return (n = (i = e.getCenterHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, i;
      return (n = (i = e.getRightHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    };
  }
};
let qC = null;
function wG() {
  if (typeof qC == "boolean") return qC;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, i = () => {
    };
    window.addEventListener("test", i, n), window.removeEventListener("test", i);
  } catch {
    e = !1;
  }
  return qC = e, qC;
}
function x7(e) {
  return e.type === "touchstart";
}
const xG = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: O3("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (i) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: i ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var i, a;
      const s = e.columns;
      return (i = s.length ? s.some((g) => g.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? i : !0;
    }, e.getCanHide = () => {
      var i, a;
      return ((i = e.columnDef.enableHiding) != null ? i : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (i) => {
      e.toggleVisibility == null || e.toggleVisibility(i.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = it(() => [e.getAllCells(), n.getState().columnVisibility], (i) => i.filter((a) => a.column.getIsVisible()), at(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = it(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (i, a, s) => [...i, ...a, ...s], at(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (i, a) => it(() => [a(), a().filter((s) => s.getIsVisible()).map((s) => s.id).join("_")], (s) => s.filter((g) => g.getIsVisible == null ? void 0 : g.getIsVisible()), at(e.options, "debugColumns", i));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (i) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(i), e.resetColumnVisibility = (i) => {
      var a;
      e.setColumnVisibility(i ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (i) => {
      var a;
      i = (a = i) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((s, g) => ({
        ...s,
        [g.id]: i || !(g.getCanHide != null && g.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((i) => !(i.getIsVisible != null && i.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (i) => {
      var a;
      e.toggleAllColumnsVisible((a = i.target) == null ? void 0 : a.checked);
    };
  }
};
function Cf(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const SG = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, EG = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: O3("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var i;
      const a = (i = e.getCoreRowModel().flatRows[0]) == null || (i = i._getAllCellsByColumnId()[n.id]) == null ? void 0 : i.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var i, a, s, g;
      return ((i = e.columnDef.enableGlobalFilter) != null ? i : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((s = n.options.enableFilters) != null ? s : !0) && ((g = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? g : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Ea.includesString, e.getGlobalFilterFn = () => {
      var n, i;
      const {
        globalFilterFn: a
      } = e.options;
      return C6(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (i = e.options.filterFns) == null ? void 0 : i[a]) != null ? n : Ea[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, MG = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: O3("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, i = !1;
    e._autoResetExpanded = () => {
      var a, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (s = e.options.autoResetAll) != null ? s : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (i) return;
        i = !0, e._queue(() => {
          e.resetExpanded(), i = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var s, g;
      e.setExpanded(a ? {} : (s = (g = e.initialState) == null ? void 0 : g.expanded) != null ? s : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((s) => !s.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((g) => {
        const c = g.split(".");
        a = Math.max(a, c.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (i) => {
      n.setExpanded((a) => {
        var s;
        const g = a === !0 ? !0 : !!(a != null && a[e.id]);
        let c = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((I) => {
          c[I] = !0;
        }) : c = a, i = (s = i) != null ? s : !g, !g && i)
          return {
            ...c,
            [e.id]: !0
          };
        if (g && !i) {
          const {
            [e.id]: I,
            ...h
          } = c;
          return h;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var i;
      const a = n.getState().expanded;
      return !!((i = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? i : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var i, a, s;
      return (i = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? i : ((a = n.options.enableExpanding) != null ? a : !0) && !!((s = e.subRows) != null && s.length);
    }, e.getIsAllParentsExpanded = () => {
      let i = !0, a = e;
      for (; i && a.parentId; )
        a = n.getRow(a.parentId, !0), i = a.getIsExpanded();
      return i;
    }, e.getToggleExpandedHandler = () => {
      const i = e.getCanExpand();
      return () => {
        i && e.toggleExpanded();
      };
    };
  }
}, Mh = 0, Th = 10, S7 = () => ({
  pageIndex: Mh,
  pageSize: Th
}), TG = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...S7(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: O3("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, i = !1;
    e._autoResetPageIndex = () => {
      var a, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (s = e.options.autoResetAll) != null ? s : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (i) return;
        i = !0, e._queue(() => {
          e.resetPageIndex(), i = !1;
        });
      }
    }, e.setPagination = (a) => {
      const s = (g) => Jo(a, g);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(s);
    }, e.resetPagination = (a) => {
      var s;
      e.setPagination(a ? S7() : (s = e.initialState.pagination) != null ? s : S7());
    }, e.setPageIndex = (a) => {
      e.setPagination((s) => {
        let g = Jo(a, s.pageIndex);
        const c = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return g = Math.max(0, Math.min(g, c)), {
          ...s,
          pageIndex: g
        };
      });
    }, e.resetPageIndex = (a) => {
      var s, g;
      e.setPageIndex(a ? Mh : (s = (g = e.initialState) == null || (g = g.pagination) == null ? void 0 : g.pageIndex) != null ? s : Mh);
    }, e.resetPageSize = (a) => {
      var s, g;
      e.setPageSize(a ? Th : (s = (g = e.initialState) == null || (g = g.pagination) == null ? void 0 : g.pageSize) != null ? s : Th);
    }, e.setPageSize = (a) => {
      e.setPagination((s) => {
        const g = Math.max(1, Jo(a, s.pageSize)), c = s.pageSize * s.pageIndex, I = Math.floor(c / g);
        return {
          ...s,
          pageIndex: I,
          pageSize: g
        };
      });
    }, e.setPageCount = (a) => e.setPagination((s) => {
      var g;
      let c = Jo(a, (g = e.options.pageCount) != null ? g : -1);
      return typeof c == "number" && (c = Math.max(-1, c)), {
        ...s,
        pageCount: c
      };
    }), e.getPageOptions = it(() => [e.getPageCount()], (a) => {
      let s = [];
      return a && a > 0 && (s = [...new Array(a)].fill(null).map((g, c) => c)), s;
    }, at(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, s = e.getPageCount();
      return s === -1 ? !0 : s === 0 ? !1 : a < s - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, E7 = () => ({
  top: [],
  bottom: []
}), LG = {
  getInitialState: (e) => ({
    rowPinning: E7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: O3("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (i, a, s) => {
      const g = a ? e.getLeafRows().map((h) => {
        let {
          id: m
        } = h;
        return m;
      }) : [], c = s ? e.getParentRows().map((h) => {
        let {
          id: m
        } = h;
        return m;
      }) : [], I = /* @__PURE__ */ new Set([...c, e.id, ...g]);
      n.setRowPinning((h) => {
        var m, w;
        if (i === "bottom") {
          var S, T;
          return {
            top: ((S = h == null ? void 0 : h.top) != null ? S : []).filter((z) => !(I != null && I.has(z))),
            bottom: [...((T = h == null ? void 0 : h.bottom) != null ? T : []).filter((z) => !(I != null && I.has(z))), ...Array.from(I)]
          };
        }
        if (i === "top") {
          var D, k;
          return {
            top: [...((D = h == null ? void 0 : h.top) != null ? D : []).filter((z) => !(I != null && I.has(z))), ...Array.from(I)],
            bottom: ((k = h == null ? void 0 : h.bottom) != null ? k : []).filter((z) => !(I != null && I.has(z)))
          };
        }
        return {
          top: ((m = h == null ? void 0 : h.top) != null ? m : []).filter((z) => !(I != null && I.has(z))),
          bottom: ((w = h == null ? void 0 : h.bottom) != null ? w : []).filter((z) => !(I != null && I.has(z)))
        };
      });
    }, e.getCanPin = () => {
      var i;
      const {
        enableRowPinning: a,
        enablePinning: s
      } = n.options;
      return typeof a == "function" ? a(e) : (i = a ?? s) != null ? i : !0;
    }, e.getIsPinned = () => {
      const i = [e.id], {
        top: a,
        bottom: s
      } = n.getState().rowPinning, g = i.some((I) => a == null ? void 0 : a.includes(I)), c = i.some((I) => s == null ? void 0 : s.includes(I));
      return g ? "top" : c ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var i, a;
      const s = e.getIsPinned();
      if (!s) return -1;
      const g = (i = s === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : i.map((c) => {
        let {
          id: I
        } = c;
        return I;
      });
      return (a = g == null ? void 0 : g.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var i, a;
      return e.setRowPinning(n ? E7() : (i = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? i : E7());
    }, e.getIsSomeRowsPinned = (n) => {
      var i;
      const a = e.getState().rowPinning;
      if (!n) {
        var s, g;
        return !!((s = a.top) != null && s.length || (g = a.bottom) != null && g.length);
      }
      return !!((i = a[n]) != null && i.length);
    }, e._getPinnedRows = (n, i, a) => {
      var s;
      return ((s = e.options.keepPinnedRows) == null || s ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (i ?? []).map((c) => {
          const I = e.getRow(c, !0);
          return I.getIsAllParentsExpanded() ? I : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (i ?? []).map((c) => n.find((I) => I.id === c))
      )).filter(Boolean).map((c) => ({
        ...c,
        position: a
      }));
    }, e.getTopRows = it(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, i) => e._getPinnedRows(n, i, "top"), at(e.options, "debugRows", "getTopRows")), e.getBottomRows = it(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, i) => e._getPinnedRows(n, i, "bottom"), at(e.options, "debugRows", "getBottomRows")), e.getCenterRows = it(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, i, a) => {
      const s = /* @__PURE__ */ new Set([...i ?? [], ...a ?? []]);
      return n.filter((g) => !s.has(g.id));
    }, at(e.options, "debugRows", "getCenterRows"));
  }
}, RG = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: O3("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var i;
      return e.setRowSelection(n ? {} : (i = e.initialState.rowSelection) != null ? i : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((i) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...i
        }, s = e.getPreGroupedRowModel().flatRows;
        return n ? s.forEach((g) => {
          g.getCanSelect() && (a[g.id] = !0);
        }) : s.forEach((g) => {
          delete a[g.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((i) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), s = {
        ...i
      };
      return e.getRowModel().rows.forEach((g) => {
        Lh(s, g.id, a, !0, e);
      }), s;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = it(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, i) => Object.keys(n).length ? M7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = it(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, i) => Object.keys(n).length ? M7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = it(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, i) => Object.keys(n).length ? M7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: i
      } = e.getState();
      let a = !!(n.length && Object.keys(i).length);
      return a && n.some((s) => s.getCanSelect() && !i[s.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((s) => s.getCanSelect()), {
        rowSelection: i
      } = e.getState();
      let a = !!n.length;
      return a && n.some((s) => !i[s.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const i = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return i > 0 && i < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((i) => i.getCanSelect()).some((i) => i.getIsSelected() || i.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (i, a) => {
      const s = e.getIsSelected();
      n.setRowSelection((g) => {
        var c;
        if (i = typeof i < "u" ? i : !s, e.getCanSelect() && s === i)
          return g;
        const I = {
          ...g
        };
        return Lh(I, e.id, i, (c = a == null ? void 0 : a.selectChildren) != null ? c : !0, n), I;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return Dm(e, i);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return Rh(e, i) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return Rh(e, i) === "all";
    }, e.getCanSelect = () => {
      var i;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (i = n.options.enableRowSelection) != null ? i : !0;
    }, e.getCanSelectSubRows = () => {
      var i;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (i = n.options.enableSubRowSelection) != null ? i : !0;
    }, e.getCanMultiSelect = () => {
      var i;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (i = n.options.enableMultiRowSelection) != null ? i : !0;
    }, e.getToggleSelectedHandler = () => {
      const i = e.getCanSelect();
      return (a) => {
        var s;
        i && e.toggleSelected((s = a.target) == null ? void 0 : s.checked);
      };
    };
  }
}, Lh = (e, n, i, a, s) => {
  var g;
  const c = s.getRow(n, !0);
  i ? (c.getCanMultiSelect() || Object.keys(e).forEach((I) => delete e[I]), c.getCanSelect() && (e[n] = !0)) : delete e[n], a && (g = c.subRows) != null && g.length && c.getCanSelectSubRows() && c.subRows.forEach((I) => Lh(e, I.id, i, a, s));
};
function M7(e, n) {
  const i = e.getState().rowSelection, a = [], s = {}, g = function(c, I) {
    return c.map((h) => {
      var m;
      const w = Dm(h, i);
      if (w && (a.push(h), s[h.id] = h), (m = h.subRows) != null && m.length && (h = {
        ...h,
        subRows: g(h.subRows)
      }), w)
        return h;
    }).filter(Boolean);
  };
  return {
    rows: g(n.rows),
    flatRows: a,
    rowsById: s
  };
}
function Dm(e, n) {
  var i;
  return (i = n[e.id]) != null ? i : !1;
}
function Rh(e, n, i) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let s = !0, g = !1;
  return e.subRows.forEach((c) => {
    if (!(g && !s) && (c.getCanSelect() && (Dm(c, n) ? g = !0 : s = !1), c.subRows && c.subRows.length)) {
      const I = Rh(c, n);
      I === "all" ? g = !0 : (I === "some" && (g = !0), s = !1);
    }
  }), s ? "all" : g ? "some" : !1;
}
const Oh = /([0-9]+)/gm, OG = (e, n, i) => rT(Xo(e.getValue(i)).toLowerCase(), Xo(n.getValue(i)).toLowerCase()), DG = (e, n, i) => rT(Xo(e.getValue(i)), Xo(n.getValue(i))), kG = (e, n, i) => km(Xo(e.getValue(i)).toLowerCase(), Xo(n.getValue(i)).toLowerCase()), jG = (e, n, i) => km(Xo(e.getValue(i)), Xo(n.getValue(i))), zG = (e, n, i) => {
  const a = e.getValue(i), s = n.getValue(i);
  return a > s ? 1 : a < s ? -1 : 0;
}, NG = (e, n, i) => km(e.getValue(i), n.getValue(i));
function km(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Xo(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function rT(e, n) {
  const i = e.split(Oh).filter(Boolean), a = n.split(Oh).filter(Boolean);
  for (; i.length && a.length; ) {
    const s = i.shift(), g = a.shift(), c = parseInt(s, 10), I = parseInt(g, 10), h = [c, I].sort();
    if (isNaN(h[0])) {
      if (s > g)
        return 1;
      if (g > s)
        return -1;
      continue;
    }
    if (isNaN(h[1]))
      return isNaN(c) ? -1 : 1;
    if (c > I)
      return 1;
    if (I > c)
      return -1;
  }
  return i.length - a.length;
}
const tf = {
  alphanumeric: OG,
  alphanumericCaseSensitive: DG,
  text: kG,
  textCaseSensitive: jG,
  datetime: zG,
  basic: NG
}, PG = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: O3("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const i = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const s of i) {
        const g = s == null ? void 0 : s.getValue(e.id);
        if (Object.prototype.toString.call(g) === "[object Date]")
          return tf.datetime;
        if (typeof g == "string" && (a = !0, g.split(Oh).length > 1))
          return tf.alphanumeric;
      }
      return a ? tf.text : tf.basic;
    }, e.getAutoSortDir = () => {
      const i = n.getFilteredRowModel().flatRows[0];
      return typeof (i == null ? void 0 : i.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var i, a;
      if (!e)
        throw new Error();
      return C6(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (i = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? i : tf[e.columnDef.sortingFn];
    }, e.toggleSorting = (i, a) => {
      const s = e.getNextSortingOrder(), g = typeof i < "u" && i !== null;
      n.setSorting((c) => {
        const I = c == null ? void 0 : c.find((D) => D.id === e.id), h = c == null ? void 0 : c.findIndex((D) => D.id === e.id);
        let m = [], w, S = g ? i : s === "desc";
        if (c != null && c.length && e.getCanMultiSort() && a ? I ? w = "toggle" : w = "add" : c != null && c.length && h !== c.length - 1 ? w = "replace" : I ? w = "toggle" : w = "replace", w === "toggle" && (g || s || (w = "remove")), w === "add") {
          var T;
          m = [...c, {
            id: e.id,
            desc: S
          }], m.splice(0, m.length - ((T = n.options.maxMultiSortColCount) != null ? T : Number.MAX_SAFE_INTEGER));
        } else w === "toggle" ? m = c.map((D) => D.id === e.id ? {
          ...D,
          desc: S
        } : D) : w === "remove" ? m = c.filter((D) => D.id !== e.id) : m = [{
          id: e.id,
          desc: S
        }];
        return m;
      });
    }, e.getFirstSortDir = () => {
      var i, a;
      return ((i = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? i : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (i) => {
      var a, s;
      const g = e.getFirstSortDir(), c = e.getIsSorted();
      return c ? c !== g && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(i && (s = n.options.enableMultiRemove) != null) || s) ? !1 : c === "desc" ? "asc" : "desc" : g;
    }, e.getCanSort = () => {
      var i, a;
      return ((i = e.columnDef.enableSorting) != null ? i : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var i, a;
      return (i = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? i : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var i;
      const a = (i = n.getState().sorting) == null ? void 0 : i.find((s) => s.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var i, a;
      return (i = (a = n.getState().sorting) == null ? void 0 : a.findIndex((s) => s.id === e.id)) != null ? i : -1;
    }, e.clearSorting = () => {
      n.setSorting((i) => i != null && i.length ? i.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const i = e.getCanSort();
      return (a) => {
        i && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var i, a;
      e.setSorting(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.sorting) != null ? i : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, FG = [
  oG,
  xG,
  vG,
  yG,
  sG,
  lG,
  SG,
  //depends on ColumnFaceting
  EG,
  //depends on ColumnFiltering
  PG,
  hG,
  //depends on RowSorting
  MG,
  TG,
  LG,
  RG,
  bG
];
function BG(e) {
  var n, i;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...FG, ...(n = e._features) != null ? n : []];
  let s = {
    _features: a
  };
  const g = s._features.reduce((T, D) => Object.assign(T, D.getDefaultOptions == null ? void 0 : D.getDefaultOptions(s)), {}), c = (T) => s.options.mergeOptions ? s.options.mergeOptions(g, T) : {
    ...g,
    ...T
  };
  let h = {
    ...{},
    ...(i = e.initialState) != null ? i : {}
  };
  s._features.forEach((T) => {
    var D;
    h = (D = T.getInitialState == null ? void 0 : T.getInitialState(h)) != null ? D : h;
  });
  const m = [];
  let w = !1;
  const S = {
    _features: a,
    options: {
      ...g,
      ...e
    },
    initialState: h,
    _queue: (T) => {
      m.push(T), w || (w = !0, Promise.resolve().then(() => {
        for (; m.length; )
          m.shift()();
        w = !1;
      }).catch((D) => setTimeout(() => {
        throw D;
      })));
    },
    reset: () => {
      s.setState(s.initialState);
    },
    setOptions: (T) => {
      const D = Jo(T, s.options);
      s.options = c(D);
    },
    getState: () => s.options.state,
    setState: (T) => {
      s.options.onStateChange == null || s.options.onStateChange(T);
    },
    _getRowId: (T, D, k) => {
      var z;
      return (z = s.options.getRowId == null ? void 0 : s.options.getRowId(T, D, k)) != null ? z : `${k ? [k.id, D].join(".") : D}`;
    },
    getCoreRowModel: () => (s._getCoreRowModel || (s._getCoreRowModel = s.options.getCoreRowModel(s)), s._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => s.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (T, D) => {
      let k = (D ? s.getPrePaginationRowModel() : s.getRowModel()).rowsById[T];
      if (!k && (k = s.getCoreRowModel().rowsById[T], !k))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${T}`) : new Error();
      return k;
    },
    _getDefaultColumnDef: it(() => [s.options.defaultColumn], (T) => {
      var D;
      return T = (D = T) != null ? D : {}, {
        header: (k) => {
          const z = k.header.column.columnDef;
          return z.accessorKey ? z.accessorKey : z.accessorFn ? z.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (k) => {
          var z, N;
          return (z = (N = k.renderValue()) == null || N.toString == null ? void 0 : N.toString()) != null ? z : null;
        },
        ...s._features.reduce((k, z) => Object.assign(k, z.getDefaultColumnDef == null ? void 0 : z.getDefaultColumnDef()), {}),
        ...T
      };
    }, at(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => s.options.columns,
    getAllColumns: it(() => [s._getColumnDefs()], (T) => {
      const D = function(k, z, N) {
        return N === void 0 && (N = 0), k.map((W) => {
          const K = aG(s, W, N, z), V = W;
          return K.columns = V.columns ? D(V.columns, K, N + 1) : [], K;
        });
      };
      return D(T);
    }, at(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: it(() => [s.getAllColumns()], (T) => T.flatMap((D) => D.getFlatColumns()), at(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: it(() => [s.getAllFlatColumns()], (T) => T.reduce((D, k) => (D[k.id] = k, D), {}), at(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: it(() => [s.getAllColumns(), s._getOrderColumnsFn()], (T, D) => {
      let k = T.flatMap((z) => z.getLeafColumns());
      return D(k);
    }, at(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (T) => {
      const D = s._getAllFlatColumnsById()[T];
      return process.env.NODE_ENV !== "production" && !D && console.error(`[Table] Column with id '${T}' does not exist.`), D;
    }
  };
  Object.assign(s, S);
  for (let T = 0; T < s._features.length; T++) {
    const D = s._features[T];
    D == null || D.createTable == null || D.createTable(s);
  }
  return s;
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function iT(e, n) {
  return e ? HG(e) ? /* @__PURE__ */ n1.createElement(e, n) : e : null;
}
function HG(e) {
  return UG(e) || typeof e == "function" || WG(e);
}
function UG(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function WG(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function VG(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [i] = n1.useState(() => ({
    current: BG(n)
  })), [a, s] = n1.useState(() => i.current.initialState);
  return i.current.setOptions((g) => ({
    ...g,
    ...e,
    state: {
      ...a,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (c) => {
      s(c), e.onStateChange == null || e.onStateChange(c);
    }
  })), i.current;
}
function _G(e) {
  return sr("MuiTableRow", e);
}
const Lx = m2("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), JG = ["className", "component", "hover", "selected"], KG = (e) => {
  const {
    classes: n,
    selected: i,
    hover: a,
    head: s,
    footer: g
  } = e;
  return Yr({
    root: ["root", i && "selected", a && "hover", s && "head", g && "footer"]
  }, _G, n);
}, YG = Rn("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.head && n.head, i.footer && n.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Lx.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Lx.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : i0(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : i0(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), Rx = "tr", jm = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableRow"
  }), {
    className: s,
    component: g = Rx,
    hover: c = !1,
    selected: I = !1
  } = a, h = Tt(a, JG), m = n1.useContext(Hf), w = m1({}, a, {
    component: g,
    hover: c,
    selected: I,
    head: m && m.variant === "head",
    footer: m && m.variant === "footer"
  }), S = KG(w);
  return /* @__PURE__ */ y.jsx(YG, m1({
    as: g,
    ref: i,
    className: Xt(S.root, s),
    role: g === Rx ? null : "row",
    ownerState: w
  }, h));
});
process.env.NODE_ENV !== "production" && (jm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: E.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
function QG(e) {
  return sr("MuiTableCell", e);
}
const XG = m2("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), GG = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], qG = (e) => {
  const {
    classes: n,
    variant: i,
    align: a,
    padding: s,
    size: g,
    stickyHeader: c
  } = e, I = {
    root: ["root", i, c && "stickyHeader", a !== "inherit" && `align${or(a)}`, s !== "normal" && `padding${or(s)}`, `size${or(g)}`]
  };
  return Yr(I, QG, n);
}, ZG = Rn("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, n[i.variant], n[`size${or(i.size)}`], i.padding !== "normal" && n[`padding${or(i.padding)}`], i.align !== "inherit" && n[`align${or(i.align)}`], i.stickyHeader && n.stickyHeader];
  }
})(({
  theme: e,
  ownerState: n
}) => m1({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? AE(i0(e.palette.divider, 1), 0.88) : CE(i0(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, n.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, n.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, n.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, n.size === "small" && {
  padding: "6px 16px",
  [`&.${XG.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, n.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, n.padding === "none" && {
  padding: 0
}, n.align === "left" && {
  textAlign: "left"
}, n.align === "center" && {
  textAlign: "center"
}, n.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, n.align === "justify" && {
  textAlign: "justify"
}, n.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), aT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableCell"
  }), {
    align: s = "inherit",
    className: g,
    component: c,
    padding: I,
    scope: h,
    size: m,
    sortDirection: w,
    variant: S
  } = a, T = Tt(a, GG), D = n1.useContext(Rm), k = n1.useContext(Hf), z = k && k.variant === "head";
  let N;
  c ? N = c : N = z ? "th" : "td";
  let W = h;
  N === "td" ? W = void 0 : !W && z && (W = "col");
  const K = S || k && k.variant, V = m1({}, a, {
    align: s,
    component: N,
    padding: I || (D && D.padding ? D.padding : "normal"),
    size: m || (D && D.size ? D.size : "medium"),
    sortDirection: w,
    stickyHeader: K === "head" && D && D.stickyHeader,
    variant: K
  }), Y = qG(V);
  let H = null;
  return w && (H = w === "asc" ? "ascending" : "descending"), /* @__PURE__ */ y.jsx(ZG, m1({
    as: N,
    ref: i,
    className: Xt(Y.root, g),
    "aria-sort": H,
    scope: W,
    ownerState: V
  }, T));
});
process.env.NODE_ENV !== "production" && (aT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: E.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: E.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: E.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: E.oneOfType([E.oneOf(["medium", "small"]), E.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: E.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: E.oneOfType([E.oneOf(["body", "footer", "head"]), E.string])
});
function oT({ sx: e, ...n }) {
  return /* @__PURE__ */ y.jsx(
    aT,
    {
      padding: "none",
      sx: { padding: "16px 0px 16px 0px", ...e },
      ...n
    }
  );
}
const $G = H1(ne)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});
function eq({
  row: e,
  navigateTo: n,
  onClick: i,
  checkIsUnread: a,
  filterRows: s,
  dataTestRowPrefix: g = "table_row"
}) {
  const c = Da(), I = e.original, h = typeof a == "function" ? a(I) : !1;
  if (!(typeof s == "function" ? s(I) : !0))
    return null;
  const w = typeof n == "function" ? n(I) : n;
  return /* @__PURE__ */ mS(
    jm,
    {
      component: w ? Wh : void 0,
      ...w ? { to: w } : {},
      sx: {
        borderBottom: `solid 1px ${c.palette.common.neutrals[200]}`,
        alignItems: "center",
        padding: "16px 0px 16px 0px",
        transition: ".2s ease-in-out",
        "&:hover": {
          cursor: typeof i == "function" ? "pointer" : "initial",
          borderTop: `solid 1px ${c.palette.common.neutrals[500]}`,
          boxShadow: "12.5px 12.5px 10px rgba(0, 0, 0, 0.035)"
        },
        textDecoration: "none"
      },
      key: e.id,
      "data-testid": `${g}_${e.id}`
    },
    e.getVisibleCells().map((S) => {
      const T = S.column.columnDef.cell, D = iT(T, S.getContext()), k = typeof T == "function" ? typeof T(S.getContext()) : "string", z = k === "string" || k === "number", N = String(S.id).includes(lT);
      return /* @__PURE__ */ y.jsx(
        oT,
        {
          sx: {
            width: `${S.column.getSize()}%`
          },
          onClick: typeof i == "function" && !N ? () => i(I) : () => {
          },
          children: z ? /* @__PURE__ */ y.jsx(
            $G,
            {
              sx: {
                fontWeight: h ? 600 : 400
              },
              children: D
            }
          ) : D
        },
        S.id
      );
    })
  );
}
function tq(e) {
  return sr("MuiTableHead", e);
}
m2("MuiTableHead", ["root"]);
const nq = ["className", "component"], rq = (e) => {
  const {
    classes: n
  } = e;
  return Yr({
    root: ["root"]
  }, tq, n);
}, iq = Rn("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "table-header-group"
}), aq = {
  variant: "head"
}, Ox = "thead", sT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableHead"
  }), {
    className: s,
    component: g = Ox
  } = a, c = Tt(a, nq), I = m1({}, a, {
    component: g
  }), h = rq(I);
  return /* @__PURE__ */ y.jsx(Hf.Provider, {
    value: aq,
    children: /* @__PURE__ */ y.jsx(iq, m1({
      as: g,
      className: Xt(h.root, s),
      ref: i,
      role: g === Ox ? null : "rowgroup",
      ownerState: I
    }, c))
  });
});
process.env.NODE_ENV !== "production" && (sT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const oq = H1(sT)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[50],
  color: e.palette.common.neutrals[500]
})), sq = H1(ne)(({ theme: e }) => ({
  fontWeight: 600,
  color: e.palette.text.secondary
}));
function lq({ headerGroup: e }) {
  return /* @__PURE__ */ y.jsx(oq, { children: /* @__PURE__ */ y.jsx(jm, { children: e.headers.map((n) => /* @__PURE__ */ y.jsx(
    oT,
    {
      sx: {
        width: `${n.getSize()}%`
      },
      children: /* @__PURE__ */ y.jsx(sq, { variant: "body2", children: iT(n.column.columnDef.header, n.getContext()) }, n.id)
    },
    n.id
  )) }) }, e.id);
}
const lT = "__row_checkbox", uq = H1(QM)(({ theme: e }) => ({
  borderTop: `solid 1px ${e.palette.common.neutrals[200]}`
}));
function he1({
  onRowClick: e,
  onRowSelect: n,
  selectedRows: i,
  checkIsUnread: a,
  filterRows: s,
  onPageChange: g,
  pageCount: c,
  enableRowSelect: I,
  isLoading: h,
  pageSize: m = 10,
  sx: w = {},
  page: S,
  navigateTo: T,
  data: D = [],
  dataTestRowPrefix: k,
  ...z
}) {
  var s1;
  const [N, W] = qt({}), [{ pageIndex: K, pageSize: V }, Y] = qt({
    pageIndex: S && !Number.isNaN(S) && S - 1 || 0,
    pageSize: m
  }), H = V2(
    () => ({
      pageIndex: K,
      pageSize: V
    }),
    [K, V]
  ), Z = V2(
    () => N,
    [N]
  );
  function Q() {
    typeof g == "function" && g(K + 1);
  }
  function P1() {
    const d1 = Object.keys(N);
    I && typeof n == "function" ? n(d1) : I && console.error(
      "In StaticTable, onRowSelect is required if enableRowSelect is true."
    );
  }
  vn(Q, [H.pageIndex]), vn(P1, [N]), vn(() => {
    typeof S == "number" && !Number.isNaN(S) && S !== K + 1 && T1.setPageIndex(S - 1);
  }, [S]);
  let Y1 = { ...z };
  const O1 = h2(
    (d1) => ({
      ...z,
      enableMultiRowSelection: !0,
      onRowSelectionChange: W,
      state: {
        rowSelection: Z
      },
      columns: [
        d1.display({
          id: lT,
          header: (h1) => /* @__PURE__ */ y.jsx(
            AA,
            {
              onChange: () => h1.table.toggleAllPageRowsSelected(),
              checked: h1.table.getIsAllPageRowsSelected()
            }
          ),
          cell: (h1) => /* @__PURE__ */ y.jsx(
            AA,
            {
              onChange: () => h1.row.toggleSelected(),
              checked: h1.row.getIsSelected()
            }
          ),
          minSize: 4,
          size: 4
        }),
        ...z.columns
      ]
    }),
    [z, Z]
  );
  if (I) {
    const d1 = rG();
    Y1 = O1(d1);
  }
  const T1 = VG({
    getRowId: (d1) => String(d1.id),
    manualPagination: !0,
    manualSorting: !0,
    pageCount: c,
    ...Y1,
    state: {
      ...Y1.state,
      pagination: H
    },
    onPaginationChange: Y,
    defaultColumn: {
      minSize: 0
    },
    data: D
  }), J1 = ((s1 = T1 == null ? void 0 : T1.getRowModel()) == null ? void 0 : s1.rows) || [];
  return /* @__PURE__ */ y.jsxs(Ke, { children: [
    h ? /* @__PURE__ */ y.jsx(Sh, {}) : /* @__PURE__ */ y.jsxs(
      YM,
      {
        sx: {
          ...w,
          tableLayout: "fixed"
        },
        children: [
          T1.getHeaderGroups().map((d1) => /* @__PURE__ */ y.jsx(lq, { headerGroup: d1 }, d1.id)),
          /* @__PURE__ */ y.jsx(uq, { children: J1.map((d1) => /* @__PURE__ */ y.jsx(
            eq,
            {
              row: d1,
              navigateTo: T,
              onClick: e,
              checkIsUnread: a,
              filterRows: s,
              dataTestRowPrefix: k
            },
            d1.id
          )) })
        ]
      }
    ),
    !!(c && c > 1 && m) && /* @__PURE__ */ y.jsx(Ke, { p: "20px", children: /* @__PURE__ */ y.jsx(
      _X,
      {
        onChange: (d1, h1) => T1.setPageIndex(h1 - 1),
        page: Number.isNaN(H.pageIndex) ? 1 : H.pageIndex + 1,
        count: c
      }
    ) })
  ] });
}
const cq = H1(F1)(({ theme: e }) => ({
  overflowX: "auto",
  width: "100%",
  padding: "20px",
  [e.breakpoints.down("md")]: {
    padding: "10px"
  }
})), gq = H1(kj)(({ theme: e }) => ({
  [`& .${Kg.root}`]: {
    fontSize: "2.1rem",
    cursor: "pointer",
    color: e.palette.common.white,
    border: `2px solid ${e.palette.common.neutrals[400]}`,
    borderRadius: "50%",
    [`&.${Kg.active}`]: {
      border: `2px solid ${e.palette.common.primary[400]}`,
      fill: "none",
      [`& .${Kg.text}`]: {
        fill: e.palette.common.black
      }
    }
  },
  [`& .${jj.root}`]: {
    minWidth: "60px",
    cursor: "pointer"
  },
  [`& .${Up.root}`]: {
    top: "1rem",
    [`& .${Up.line}`]: {
      borderColor: e.palette.common.neutrals[400]
    }
  },
  [`& .${Wp.completed}`]: {
    svg: {
      border: `2px solid ${e.palette.common.primary[400]}`,
      fill: e.palette.common.primary[50],
      text: {
        fill: e.palette.common.primary[400]
      }
    }
  },
  [`& .${Up.line}`]: {
    borderTopWidth: "2px"
  },
  [`& .${Kg.text}`]: {
    fill: e.palette.common.black
  },
  [`& .${Wp.label}`]: {
    marginTop: "8px",
    cursor: "pointer",
    color: e.palette.common.black,
    fontWeight: "normal",
    [`&.${Kg.active}`]: {
      color: e.palette.common.primary[500]
    },
    [`&.${Wp.alternativeLabel}`]: {
      textTransform: "none",
      fontSize: "1rem",
      color: e.palette.common.black,
      marginTop: "8px"
    }
  },
  [`& .${zj.root}`]: {
    padding: "0",
    margin: "0"
  }
}));
function me1({ activeStep: e, steps: n, onClick: i }) {
  const a = Da(), s = (g) => {
    n[g].disabled || i(g);
  };
  return /* @__PURE__ */ y.jsx(cq, { children: /* @__PURE__ */ y.jsx(gq, { activeStep: e, alternativeLabel: !0, children: n.map((g, c) => /* @__PURE__ */ y.jsx(
    Nj,
    {
      disabled: g.disabled,
      "data-tour-id": g.tourTargetId,
      children: /* @__PURE__ */ y.jsx(
        Pj,
        {
          disabled: g.disabled,
          onClick: () => s(c),
          children: /* @__PURE__ */ y.jsx(
            Fj,
            {
              icon: g.error ? /* @__PURE__ */ y.jsx(
                Me,
                {
                  icon: "close",
                  sx: {
                    fontSize: "2.1rem",
                    background: a.palette.common.error[100],
                    borderRadius: "50%",
                    path: {
                      transform: "scale(0.7) translate(5px, 5px)"
                    },
                    border: `2px solid ${a.palette.common.error[400]}`,
                    fill: `${a.palette.common.error[400]}`
                  }
                }
              ) : c + 1,
              error: g.error,
              StepIconProps: {
                completed: !1,
                error: !1
              },
              children: g.label
            }
          )
        }
      )
    },
    g.label
  )) }) });
}
const ve1 = ({
  isUnread: e,
  color: n
}) => {
  const i = Da(), a = n || i.palette.common.accent[500], s = e ? a : null;
  return /* @__PURE__ */ y.jsx(lX, { color: s });
}, fq = H1(Bj)({ ml: 0 }), dq = H1(Hj)(({ theme: e }) => ({
  marginBottom: 4,
  color: e.palette.text.primary
})), zm = ({
  children: e,
  label: n,
  error: i,
  labelProps: a = {},
  stacked: s = !1,
  ...g
}) => /* @__PURE__ */ y.jsxs(Uj, { ...g, error: !!i, children: [
  s ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(dq, { children: n }),
    e
  ] }) : /* @__PURE__ */ y.jsx(
    Uh,
    {
      labelPlacement: "top",
      ...a,
      control: e,
      label: n
    }
  ),
  i && i !== !0 && /* @__PURE__ */ y.jsx(fq, { "data-testid": "field-error", children: i })
] }), Uf = Gt.forwardRef(
  ({ name: e, label: n, error: i, fullWidth: a = !0, ...s }, g) => /* @__PURE__ */ y.jsx(
    zm,
    {
      name: e,
      label: n,
      error: i,
      fullWidth: a,
      children: /* @__PURE__ */ y.jsx(
        Ef,
        {
          ...s,
          ref: g,
          name: e,
          fullWidth: !0,
          error: !!i
        }
      )
    }
  )
), Cq = ({
  name: e,
  label: n,
  error: i,
  placeholder: a,
  options: s = [],
  renderInputProps: g,
  ...c
}) => {
  const I = Object.prototype.hasOwnProperty.call(
    g ?? {},
    "startAdornment"
  ), h = Object.prototype.hasOwnProperty.call(
    g ?? {},
    "endAdornment"
  );
  return /* @__PURE__ */ y.jsx(
    Wj,
    {
      ...c,
      options: s,
      renderInput: (m) => /* @__PURE__ */ y.jsx(
        Uf,
        {
          ...m,
          name: e,
          placeholder: a,
          label: n,
          error: i,
          onKeyDown: g == null ? void 0 : g.onKeyDown,
          InputProps: {
            ...m.InputProps,
            ...I ? { startAdornment: g == null ? void 0 : g.startAdornment } : {},
            ...h ? { endAdornment: g == null ? void 0 : g.endAdornment } : {}
          }
        }
      )
    }
  );
}, ye1 = ({
  name: e,
  control: n,
  required: i,
  validate: a,
  ...s
}) => {
  const {
    field: g,
    fieldState: { error: c }
  } = Vh({
    name: e || "",
    control: n,
    rules: { required: i, validate: a }
  });
  return /* @__PURE__ */ y.jsx(Cq, { ...g, error: c == null ? void 0 : c.type, ...s });
}, Aq = Gt.forwardRef(({ name: e, label: n, error: i, labelPlacement: a = "end", ...s }, g) => /* @__PURE__ */ y.jsx(
  zm,
  {
    name: e,
    label: n,
    error: i,
    labelProps: {
      labelPlacement: a,
      sx: { alignItems: "center" }
    },
    sx: { flexDirection: "row" },
    children: /* @__PURE__ */ y.jsx(AA, { ref: g, ...s })
  }
)), Iq = ({
  name: e,
  ...n
}) => {
  var g;
  const { field: i, fieldState: a } = Vh({ name: e }), s = (g = a.error) == null ? void 0 : g.message;
  return /* @__PURE__ */ y.jsx(
    Aq,
    {
      error: s,
      ...n,
      checked: !!i.value,
      onChange: (c, I) => i.onChange(I)
    }
  );
}, be1 = ({
  label: e,
  items: n = [],
  disabled: i,
  direction: a = "row"
}) => /* @__PURE__ */ y.jsx(
  Uh,
  {
    labelPlacement: "top",
    label: e,
    disabled: i,
    control: /* @__PURE__ */ y.jsx(Ke, { direction: a, gap: 2, flexWrap: "wrap", children: n.map(({ name: s, label: g }) => /* @__PURE__ */ y.jsx(
      Iq,
      {
        name: s,
        label: g,
        labelPlacement: "end",
        disabled: i
      },
      s
    )) })
  }
), we1 = ({ name: e, ...n }) => {
  var g, c;
  const { register: i, formState: a } = Tf(), s = (c = (g = a.errors) == null ? void 0 : g[e]) == null ? void 0 : c.message;
  return /* @__PURE__ */ y.jsx(
    Uf,
    {
      disabled: a.isSubmitting,
      ...n,
      ...i(e),
      error: s
    }
  );
}, pq = Gt.forwardRef(
  ({
    visible: e,
    onVisible: n,
    visibleIcon: i = /* @__PURE__ */ y.jsx(Me, { icon: "hide" }),
    hiddenIcon: a = /* @__PURE__ */ y.jsx(Me, { icon: "show" }),
    adornmentProps: s,
    ...g
  }, c) => {
    const [I, h] = qt(e || !1), m = e ?? I, w = h2(() => {
      n ? n(m) : h(!m);
    }, [m, n, h]);
    return /* @__PURE__ */ y.jsx(
      Uf,
      {
        ref: c,
        ...g,
        type: m ? "text" : "password",
        autoComplete: "off",
        InputProps: {
          endAdornment: /* @__PURE__ */ y.jsx(
            Bh,
            {
              style: {
                color: "inherit"
              },
              ...s || {},
              position: (s == null ? void 0 : s.position) || "end",
              children: /* @__PURE__ */ y.jsx(
                xc,
                {
                  "aria-label": "toggle password visibility",
                  onClick: w,
                  edge: "end",
                  color: "inherit",
                  title: m ? "Hide password" : "Show password",
                  children: m ? i : a
                }
              )
            }
          )
        }
      }
    );
  }
), xe1 = ({
  name: e,
  inputRef: n,
  ...i
}) => {
  var c, I;
  const { register: a, formState: s } = Tf(), g = (I = (c = s.errors) == null ? void 0 : c[e]) == null ? void 0 : I.message;
  return /* @__PURE__ */ y.jsx(
    pq,
    {
      disabled: s.isSubmitting,
      error: g,
      inputRef: n,
      ...i,
      ...a(e)
    }
  );
};
var Dh = function() {
  return Dh = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, Dh.apply(this, arguments);
}, uT = {
  onActivate: E1.func,
  onAddUndo: E1.func,
  onBeforeAddUndo: E1.func,
  onBeforeExecCommand: E1.func,
  onBeforeGetContent: E1.func,
  onBeforeRenderUI: E1.func,
  onBeforeSetContent: E1.func,
  onBeforePaste: E1.func,
  onBlur: E1.func,
  onChange: E1.func,
  onClearUndos: E1.func,
  onClick: E1.func,
  onContextMenu: E1.func,
  onCommentChange: E1.func,
  onCopy: E1.func,
  onCut: E1.func,
  onDblclick: E1.func,
  onDeactivate: E1.func,
  onDirty: E1.func,
  onDrag: E1.func,
  onDragDrop: E1.func,
  onDragEnd: E1.func,
  onDragGesture: E1.func,
  onDragOver: E1.func,
  onDrop: E1.func,
  onExecCommand: E1.func,
  onFocus: E1.func,
  onFocusIn: E1.func,
  onFocusOut: E1.func,
  onGetContent: E1.func,
  onHide: E1.func,
  onInit: E1.func,
  onKeyDown: E1.func,
  onKeyPress: E1.func,
  onKeyUp: E1.func,
  onLoadContent: E1.func,
  onMouseDown: E1.func,
  onMouseEnter: E1.func,
  onMouseLeave: E1.func,
  onMouseMove: E1.func,
  onMouseOut: E1.func,
  onMouseOver: E1.func,
  onMouseUp: E1.func,
  onNodeChange: E1.func,
  onObjectResizeStart: E1.func,
  onObjectResized: E1.func,
  onObjectSelected: E1.func,
  onPaste: E1.func,
  onPostProcess: E1.func,
  onPostRender: E1.func,
  onPreProcess: E1.func,
  onProgressState: E1.func,
  onRedo: E1.func,
  onRemove: E1.func,
  onReset: E1.func,
  onSaveContent: E1.func,
  onSelectionChange: E1.func,
  onSetAttrib: E1.func,
  onSetContent: E1.func,
  onShow: E1.func,
  onSubmit: E1.func,
  onUndo: E1.func,
  onVisualAid: E1.func,
  onSkinLoadError: E1.func,
  onThemeLoadError: E1.func,
  onModelLoadError: E1.func,
  onPluginLoadError: E1.func,
  onIconsLoadError: E1.func,
  onLanguageLoadError: E1.func,
  onScriptsLoad: E1.func,
  onScriptsLoadError: E1.func
}, hq = Dh({ apiKey: E1.string, id: E1.string, inline: E1.bool, init: E1.object, initialValue: E1.string, onEditorChange: E1.func, value: E1.string, tagName: E1.string, cloudChannel: E1.string, plugins: E1.oneOfType([E1.string, E1.array]), toolbar: E1.oneOfType([E1.string, E1.array]), disabled: E1.bool, textareaName: E1.string, tinymceScriptSrc: E1.oneOfType([
  E1.string,
  E1.arrayOf(E1.string),
  E1.arrayOf(E1.shape({
    src: E1.string,
    async: E1.bool,
    defer: E1.bool
  }))
]), rollback: E1.oneOfType([E1.number, E1.oneOf([!1])]), scriptLoading: E1.shape({
  async: E1.bool,
  defer: E1.bool,
  delay: E1.number
}) }, uT), T7 = function(e) {
  return typeof e == "function";
}, Dx = function(e) {
  return e in uT;
}, kx = function(e) {
  return e.substr(2);
}, mq = function(e, n, i, a, s, g, c) {
  var I = Object.keys(s).filter(Dx), h = Object.keys(g).filter(Dx), m = I.filter(function(S) {
    return g[S] === void 0;
  }), w = h.filter(function(S) {
    return s[S] === void 0;
  });
  m.forEach(function(S) {
    var T = kx(S), D = c[T];
    i(T, D), delete c[T];
  }), w.forEach(function(S) {
    var T = a(e, S), D = kx(S);
    c[D] = T, n(D, T);
  });
}, vq = function(e, n, i, a, s) {
  return mq(
    s,
    e.on.bind(e),
    e.off.bind(e),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    function(g, c) {
      return function(I) {
        var h;
        return (h = g(c)) === null || h === void 0 ? void 0 : h(I, e);
      };
    },
    n,
    i,
    a
  );
}, jx = 0, cT = function(e) {
  var n = Date.now(), i = Math.floor(Math.random() * 1e9);
  return jx++, e + "_" + i + jx + String(n);
}, zx = function(e) {
  return e !== null && (e.tagName.toLowerCase() === "textarea" || e.tagName.toLowerCase() === "input");
}, Nx = function(e) {
  return typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" ");
}, yq = function(e, n) {
  return Nx(e).concat(Nx(n));
}, bq = function() {
  return window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}, wq = function(e) {
  if (!("isConnected" in Node.prototype)) {
    for (var n = e, i = e.parentNode; i != null; )
      n = i, i = n.parentNode;
    return n === e.ownerDocument;
  }
  return e.isConnected;
}, Px = function(e, n) {
  e !== void 0 && (e.mode != null && typeof e.mode == "object" && typeof e.mode.set == "function" ? e.mode.set(n) : e.setMode(n));
}, kh = function() {
  return kh = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, kh.apply(this, arguments);
}, xq = function(e, n, i) {
  var a, s, g = e.createElement("script");
  g.referrerPolicy = "origin", g.type = "application/javascript", g.id = n.id, g.src = n.src, g.async = (a = n.async) !== null && a !== void 0 ? a : !1, g.defer = (s = n.defer) !== null && s !== void 0 ? s : !1;
  var c = function() {
    g.removeEventListener("load", c), g.removeEventListener("error", I), i(n.src);
  }, I = function(h) {
    g.removeEventListener("load", c), g.removeEventListener("error", I), i(n.src, h);
  };
  g.addEventListener("load", c), g.addEventListener("error", I), e.head && e.head.appendChild(g);
}, Sq = function(e) {
  var n = {}, i = function(c, I) {
    var h = n[c];
    h.done = !0, h.error = I;
    for (var m = 0, w = h.handlers; m < w.length; m++) {
      var S = w[m];
      S(c, I);
    }
    h.handlers = [];
  }, a = function(c, I, h) {
    var m = function(K) {
      return h !== void 0 ? h(K) : console.error(K);
    };
    if (c.length === 0) {
      m(new Error("At least one script must be provided"));
      return;
    }
    for (var w = 0, S = !1, T = function(K, V) {
      S || (V ? (S = !0, m(V)) : ++w === c.length && I());
    }, D = 0, k = c; D < k.length; D++) {
      var z = k[D], N = n[z.src];
      if (N)
        N.done ? T(z.src, N.error) : N.handlers.push(T);
      else {
        var W = cT("tiny-");
        n[z.src] = {
          id: W,
          src: z.src,
          done: !1,
          error: null,
          handlers: [T]
        }, xq(e, kh({ id: W }, z), i);
      }
    }
  }, s = function() {
    for (var c, I = 0, h = Object.values(n); I < h.length; I++) {
      var m = h[I], w = e.getElementById(m.id);
      w != null && w.tagName === "SCRIPT" && ((c = w.parentNode) === null || c === void 0 || c.removeChild(w));
    }
    n = {};
  }, g = function() {
    return e;
  };
  return {
    loadScripts: a,
    deleteScripts: s,
    getDocument: g
  };
}, Eq = function() {
  var e = [], n = function(s) {
    var g = e.find(function(c) {
      return c.getDocument() === s;
    });
    return g === void 0 && (g = Sq(s), e.push(g)), g;
  }, i = function(s, g, c, I, h) {
    var m = function() {
      return n(s).loadScripts(g, I, h);
    };
    c > 0 ? setTimeout(m, c) : m();
  }, a = function() {
    for (var s = e.pop(); s != null; s = e.pop())
      s.deleteScripts();
  };
  return {
    loadList: i,
    reinitialize: a
  };
}, Mq = Eq(), L7 = function(e) {
  var n = e;
  return n && n.tinymce ? n.tinymce : null;
}, Tq = /* @__PURE__ */ function() {
  var e = function(n, i) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, s) {
      a.__proto__ = s;
    } || function(a, s) {
      for (var g in s) Object.prototype.hasOwnProperty.call(s, g) && (a[g] = s[g]);
    }, e(n, i);
  };
  return function(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    e(n, i);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  };
}(), kA = function() {
  return kA = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, kA.apply(this, arguments);
}, Lq = (
  /** @class */
  function(e) {
    Tq(n, e);
    function n(i) {
      var a, s, g, c = e.call(this, i) || this;
      return c.rollbackTimer = void 0, c.valueCursor = void 0, c.rollbackChange = function() {
        var I = c.editor, h = c.props.value;
        I && h && h !== c.currentContent && I.undoManager.ignore(function() {
          if (I.setContent(h), c.valueCursor && (!c.inline || I.hasFocus()))
            try {
              I.selection.moveToBookmark(c.valueCursor);
            } catch {
            }
        }), c.rollbackTimer = void 0;
      }, c.handleBeforeInput = function(I) {
        if (c.props.value !== void 0 && c.props.value === c.currentContent && c.editor && (!c.inline || c.editor.hasFocus()))
          try {
            c.valueCursor = c.editor.selection.getBookmark(3);
          } catch {
          }
      }, c.handleBeforeInputSpecial = function(I) {
        (I.key === "Enter" || I.key === "Backspace" || I.key === "Delete") && c.handleBeforeInput(I);
      }, c.handleEditorChange = function(I) {
        var h = c.editor;
        if (h && h.initialized) {
          var m = h.getContent();
          c.props.value !== void 0 && c.props.value !== m && c.props.rollback !== !1 && (c.rollbackTimer || (c.rollbackTimer = window.setTimeout(c.rollbackChange, typeof c.props.rollback == "number" ? c.props.rollback : 200))), m !== c.currentContent && (c.currentContent = m, T7(c.props.onEditorChange) && c.props.onEditorChange(m, h));
        }
      }, c.handleEditorChangeSpecial = function(I) {
        (I.key === "Backspace" || I.key === "Delete") && c.handleEditorChange(I);
      }, c.initialise = function(I) {
        var h, m, w;
        I === void 0 && (I = 0);
        var S = c.elementRef.current;
        if (S) {
          if (!wq(S)) {
            if (I === 0)
              setTimeout(function() {
                return c.initialise(1);
              }, 1);
            else if (I < 100)
              setTimeout(function() {
                return c.initialise(I + 1);
              }, 100);
            else
              throw new Error("tinymce can only be initialised when in a document");
            return;
          }
          var T = L7(c.view);
          if (!T)
            throw new Error("tinymce should have been loaded into global scope");
          var D = kA(kA({}, c.props.init), { selector: void 0, target: S, readonly: c.props.disabled, inline: c.inline, plugins: yq((h = c.props.init) === null || h === void 0 ? void 0 : h.plugins, c.props.plugins), toolbar: (m = c.props.toolbar) !== null && m !== void 0 ? m : (w = c.props.init) === null || w === void 0 ? void 0 : w.toolbar, setup: function(k) {
            c.editor = k, c.bindHandlers({}), c.inline && !zx(S) && k.once("PostRender", function(z) {
              k.setContent(c.getInitialValue(), { no_events: !0 });
            }), c.props.init && T7(c.props.init.setup) && c.props.init.setup(k);
          }, init_instance_callback: function(k) {
            var z, N, W = c.getInitialValue();
            c.currentContent = (z = c.currentContent) !== null && z !== void 0 ? z : k.getContent(), c.currentContent !== W && (c.currentContent = W, k.setContent(W), k.undoManager.clear(), k.undoManager.add(), k.setDirty(!1));
            var K = (N = c.props.disabled) !== null && N !== void 0 ? N : !1;
            Px(c.editor, K ? "readonly" : "design"), c.props.init && T7(c.props.init.init_instance_callback) && c.props.init.init_instance_callback(k);
          } });
          c.inline || (S.style.visibility = ""), zx(S) && (S.value = c.getInitialValue()), T.init(D);
        }
      }, c.id = c.props.id || cT("tiny-react"), c.elementRef = n1.createRef(), c.inline = (g = (a = c.props.inline) !== null && a !== void 0 ? a : (s = c.props.init) === null || s === void 0 ? void 0 : s.inline) !== null && g !== void 0 ? g : !1, c.boundHandlers = {}, c;
    }
    return Object.defineProperty(n.prototype, "view", {
      get: function() {
        var i, a;
        return (a = (i = this.elementRef.current) === null || i === void 0 ? void 0 : i.ownerDocument.defaultView) !== null && a !== void 0 ? a : window;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidUpdate = function(i) {
      var a = this, s, g;
      if (this.rollbackTimer && (clearTimeout(this.rollbackTimer), this.rollbackTimer = void 0), this.editor && (this.bindHandlers(i), this.editor.initialized)) {
        if (this.currentContent = (s = this.currentContent) !== null && s !== void 0 ? s : this.editor.getContent(), typeof this.props.initialValue == "string" && this.props.initialValue !== i.initialValue)
          this.editor.setContent(this.props.initialValue), this.editor.undoManager.clear(), this.editor.undoManager.add(), this.editor.setDirty(!1);
        else if (typeof this.props.value == "string" && this.props.value !== this.currentContent) {
          var c = this.editor;
          c.undoManager.transact(function() {
            var h;
            if (!a.inline || c.hasFocus())
              try {
                h = c.selection.getBookmark(3);
              } catch {
              }
            var m = a.valueCursor;
            if (c.setContent(a.props.value), !a.inline || c.hasFocus())
              for (var w = 0, S = [h, m]; w < S.length; w++) {
                var T = S[w];
                if (T)
                  try {
                    c.selection.moveToBookmark(T), a.valueCursor = T;
                    break;
                  } catch {
                  }
              }
          });
        }
        if (this.props.disabled !== i.disabled) {
          var I = (g = this.props.disabled) !== null && g !== void 0 ? g : !1;
          Px(this.editor, I ? "readonly" : "design");
        }
      }
    }, n.prototype.componentDidMount = function() {
      var i = this, a, s, g, c, I;
      if (L7(this.view) !== null)
        this.initialise();
      else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0)
        (s = (a = this.props).onScriptsLoadError) === null || s === void 0 || s.call(a, new Error("No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array."));
      else if (!((g = this.elementRef.current) === null || g === void 0) && g.ownerDocument) {
        var h = function() {
          var w, S;
          (S = (w = i.props).onScriptsLoad) === null || S === void 0 || S.call(w), i.initialise();
        }, m = function(w) {
          var S, T;
          (T = (S = i.props).onScriptsLoadError) === null || T === void 0 || T.call(S, w);
        };
        Mq.loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (I = (c = this.props.scriptLoading) === null || c === void 0 ? void 0 : c.delay) !== null && I !== void 0 ? I : 0, h, m);
      }
    }, n.prototype.componentWillUnmount = function() {
      var i = this, a = this.editor;
      a && (a.off(this.changeEvents(), this.handleEditorChange), a.off(this.beforeInputEvent(), this.handleBeforeInput), a.off("keypress", this.handleEditorChangeSpecial), a.off("keydown", this.handleBeforeInputSpecial), a.off("NewBlock", this.handleEditorChange), Object.keys(this.boundHandlers).forEach(function(s) {
        a.off(s, i.boundHandlers[s]);
      }), this.boundHandlers = {}, a.remove(), this.editor = void 0);
    }, n.prototype.render = function() {
      return this.inline ? this.renderInline() : this.renderIframe();
    }, n.prototype.changeEvents = function() {
      var i, a, s, g = (s = (a = (i = L7(this.view)) === null || i === void 0 ? void 0 : i.Env) === null || a === void 0 ? void 0 : a.browser) === null || s === void 0 ? void 0 : s.isIE();
      return g ? "change keyup compositionend setcontent CommentChange" : "change input compositionend setcontent CommentChange";
    }, n.prototype.beforeInputEvent = function() {
      return bq() ? "beforeinput SelectionChange" : "SelectionChange";
    }, n.prototype.renderInline = function() {
      var i = this.props.tagName, a = i === void 0 ? "div" : i;
      return n1.createElement(a, {
        ref: this.elementRef,
        id: this.id
      });
    }, n.prototype.renderIframe = function() {
      return n1.createElement("textarea", {
        ref: this.elementRef,
        style: { visibility: "hidden" },
        name: this.props.textareaName,
        id: this.id
      });
    }, n.prototype.getScriptSources = function() {
      var i, a, s = (i = this.props.scriptLoading) === null || i === void 0 ? void 0 : i.async, g = (a = this.props.scriptLoading) === null || a === void 0 ? void 0 : a.defer;
      if (this.props.tinymceScriptSrc !== void 0)
        return typeof this.props.tinymceScriptSrc == "string" ? [{ src: this.props.tinymceScriptSrc, async: s, defer: g }] : this.props.tinymceScriptSrc.map(function(m) {
          return typeof m == "string" ? { src: m, async: s, defer: g } : m;
        });
      var c = this.props.cloudChannel, I = this.props.apiKey ? this.props.apiKey : "no-api-key", h = "https://cdn.tiny.cloud/1/".concat(I, "/tinymce/").concat(c, "/tinymce.min.js");
      return [{ src: h, async: s, defer: g }];
    }, n.prototype.getInitialValue = function() {
      return typeof this.props.initialValue == "string" ? this.props.initialValue : typeof this.props.value == "string" ? this.props.value : "";
    }, n.prototype.bindHandlers = function(i) {
      var a = this;
      if (this.editor !== void 0) {
        vq(this.editor, i, this.props, this.boundHandlers, function(I) {
          return a.props[I];
        });
        var s = function(I) {
          return I.onEditorChange !== void 0 || I.value !== void 0;
        }, g = s(i), c = s(this.props);
        !g && c ? (this.editor.on(this.changeEvents(), this.handleEditorChange), this.editor.on(this.beforeInputEvent(), this.handleBeforeInput), this.editor.on("keydown", this.handleBeforeInputSpecial), this.editor.on("keyup", this.handleEditorChangeSpecial), this.editor.on("NewBlock", this.handleEditorChange)) : g && !c && (this.editor.off(this.changeEvents(), this.handleEditorChange), this.editor.off(this.beforeInputEvent(), this.handleBeforeInput), this.editor.off("keydown", this.handleBeforeInputSpecial), this.editor.off("keyup", this.handleEditorChangeSpecial), this.editor.off("NewBlock", this.handleEditorChange));
      }
    }, n.propTypes = hq, n.defaultProps = {
      cloudChannel: "6"
    }, n;
  }(n1.Component)
);
const Rq = {
  "Heading 1": "H1: Heading 1",
  "Heading 2": "H2: Heading 2",
  "Heading 3": "H3: Heading 3"
}, Oq = ["aria-label", "aria-placeholder"];
function Dq(e) {
  e.editorManager.addI18n("en", Rq);
}
function kq(e) {
  const n = () => {
    const i = e.getBody();
    Oq.forEach((a) => i == null ? void 0 : i.removeAttribute(a));
  };
  n(), e.on("PlaceholderToggle", n);
}
const Fx = 512 * 1024, jq = {
  left: "JustifyLeft",
  center: "JustifyCenter",
  right: "JustifyRight",
  justify: "JustifyFull"
}, zq = [
  "JustifyLeft",
  "JustifyCenter",
  "JustifyRight",
  "JustifyFull"
];
function Nq(e) {
  return typeof e != "string" ? "" : e.replace(/[<>]/g, "").trim().toLowerCase();
}
function Bx(e, n) {
  if (e !== "mceToggleFormat" && e !== "FormatBlock") return !1;
  const i = Nq(n);
  return i === "h1" || i === "h2" || i === "h3";
}
function Pq(e) {
  for (const n of zq)
    if (e.queryCommandState(n))
      return n;
  return null;
}
const Fq = H1(F1)(({ theme: e }) => ({
  "& .tox-tinymce": {
    fontFamily: "inherit !important",
    border: `solid 1px ${e.palette.common.neutrals[200]}`
  },
  "& .tox-tinymce:hover": {
    border: `solid 1px ${e.palette.common.neutrals[500]}`
  },
  "& .tox:not(.tox-tinymce-inline) .tox-editor-header": {
    padding: "0px !important"
  },
  "& .tox .tox-statusbar": {
    display: "none"
  }
})), Bq = ({
  initialValue: e,
  value: n,
  onChange: i = (T) => console.log("RTE:", { html: T }),
  onBlur: a,
  disabled: s,
  height: g = "300px",
  inlineImages: c = !0,
  hideToolbar: I,
  placeholder: h = "",
  defaultTextAlign: m,
  defaultBold: w = !1,
  ...S
}) => {
  const T = Da(), D = V2(() => {
    const k = [], z = [
      "h1",
      "h2",
      "h3",
      "bold",
      "italic",
      "underline",
      "forecolor",
      "backcolor",
      "bullist",
      "numlist",
      "alignleft",
      "aligncenter",
      "alignright",
      "alignjustify",
      "lineheight",
      "link"
    ], N = ["quickimage"];
    return I || (k.push(...z), c && k.push(...N)), k.join(" ");
  }, [I, c]);
  return /* @__PURE__ */ y.jsx(Fq, { ...S, tabIndex: 0, children: /* @__PURE__ */ y.jsx(
    Lq,
    {
      disabled: s,
      tinymceScriptSrc: "https://turmericp.liscio.me/tinymce/js/tinymce/tinymce.min.js",
      initialValue: e,
      value: n,
      onBlur: a,
      init: {
        placeholder: h,
        images_replace_blob_uris: !1,
        convert_urls: !1,
        paste_data_images: c,
        height: g,
        menubar: !1,
        paste_retain_style_properties: "all",
        paste_webkit_styles: "all",
        paste_convert_word_fake_lists: !1,
        // open embedded link in new tab
        link_target_list: [{ title: "New window", value: "_blank" }],
        contextmenu: !1,
        paste_postprocess(k, z) {
          z.node.querySelectorAll("a").forEach((N) => {
            N.innerHTML || N.remove();
          });
        },
        plugins: [
          "link",
          "autolink",
          "lists",
          "media",
          "advlist",
          ...c ? ["image", "quickbars"] : []
        ],
        browser_spellcheck: !0,
        toolbar: D,
        content_style: `@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700');
            body {
              font-family:Source Sans Pro, sans-serif;
              font-size:0.94rem;
              color: rgb(33, 43, 54);
              margin:0;
              padding: 0.5rem;
            }
    
            p {
              color: rgb(33, 43, 54);
              margin: 0px;
            }

            a, a:visited {
              color: ${T.palette.info.light};
            }
    
            #tinymce * {
              text-indent: 0 !important;
            }
    
            .mce-item-table, .mce-item-table td, .mce-item-table tr {
              border: inherit !important;
              outline: inherit !important;
            }
    
            .mce-content-body {
              min-height:210px;
            }

            .mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {
              left: 12px;
            }
            `,
        quickbars_selection_toolbar: !1,
        link_assume_external_targets: !0,
        toolbar_location: "bottom",
        quickbars_insert_toolbar: !1,
        quickbars_image_toolbar: !1,
        elementpath: !1,
        branding: !1,
        resize: !1,
        autoresize: !0,
        images_file_types: "jpg,png,jpeg",
        image_description: !1,
        image_dimensions: !1,
        image_title: !1,
        a11y_advanced_options: !0,
        // NOTE: This is currently only being used by Email editor.
        // Omitting until it is necessary
        // images_upload_handler: imageUploadHandler || undefined,
        object_resizing: !0,
        forced_root_block: "div",
        init_instance_callback: (k) => {
          kq(k);
          let z = null, N = !1;
          const W = k.getContent({ format: "text" }).trim().length > 0, K = k.getBody(), V = !!(K != null && K.querySelector(
            "img,table,iframe,embed,video,audio,object,svg,canvas"
          )), Y = Array.from((K == null ? void 0 : K.children) ?? []).some(
            (Z) => !(Z instanceof HTMLElement) || Z.tagName.toLowerCase() === "br" ? !1 : (Z.textContent || "").replace(/\u00a0/g, "").trim().length > 0 ? !0 : !!Z.querySelector(
              "img,table,iframe,embed,video,audio,object,svg,canvas,li,blockquote,pre,code,hr"
            )
          );
          if (!W && !V && !Y) {
            if (m) {
              const Z = jq[m];
              Z && k.execCommand(Z);
            }
            w && k.execCommand("Bold");
          }
          k.on("BeforeExecCommand", (Z) => {
            N || Bx(Z.command, Z.value) && (z = Pq(k));
          }), k.on("ExecCommand", (Z) => {
            if (N || !Bx(Z.command, Z.value)) return;
            const Q = z;
            if (z = null, !!Q && !k.queryCommandState(Q)) {
              N = !0;
              try {
                k.execCommand(Q);
              } finally {
                N = !1;
              }
            }
          }), k.on("GetContent", (Z) => {
            if (Z.content.includes("a")) {
              const P1 = Z.content.replace(
                /<a/g,
                '<a style="text-decoration: underline"'
              );
              Z.content = P1;
            }
          }), k.on("ObjectResized", (Z) => {
            Z.target.dataset.mceStyle = 'style="max-width: none; max-height: none"';
          }), k.on("focus", function() {
            const Z = k.getContainer();
            Z && (Z.style.border = `1px solid ${T.palette.common.primary[500]}`);
          }), k.on("blur", function() {
            const Z = k.getContainer();
            Z && (Z.style.border = `1px solid ${T.palette.common.neutrals[300]}`);
          }), c && k.on("paste", (Z) => {
            const { clipboardData: Q } = Z;
            if (Q && Q.items) {
              let P1 = !1;
              Array.from(Q.items).forEach((Y1) => {
                if (Y1.type.indexOf("image") !== -1) {
                  const O1 = Y1.getAsFile();
                  O1 && O1.size > Fx && (Z.preventDefault(), P1 = !0);
                }
              }), P1 && k.notificationManager.open({
                text: "Image size exceeds the maximum allowed size of 0.5MB",
                type: "error",
                timeout: 3e3
              });
            }
          });
        },
        setup(k) {
          Dq(k), k.ui.registry.addContextMenu("useBrowserSpellcheck", {
            update() {
              return k.selection.isCollapsed() ? ["useBrowserSpellcheck"] : [];
            }
          });
        },
        ...c ? {
          images_upload_handler: (k) => {
            if (k.blob().size > Fx) {
              const z = new Error(
                "Image size exceeds the maximum allowed size of 0.5MB"
              );
              return z.remove = !0, Promise.reject(z);
            }
            return new Promise((z, N) => {
              if (!k || !k.blob())
                return N(new Error("Invalid image data"));
              const W = new FileReader();
              W.onload = () => {
                try {
                  if (!W.result)
                    throw new Error("Empty result from file reader");
                  if (typeof W.result == "string")
                    z(W.result);
                  else
                    throw new Error(
                      "reader.result is an ArrayBuffer, which is not expected with readAsDataURL"
                    );
                } catch (K) {
                  N(
                    K instanceof Error ? K : new Error("Unknown error processing image")
                  );
                }
              }, W.onerror = () => {
                var K;
                return N(
                  new Error(
                    `Failed to read image: ${((K = W.error) == null ? void 0 : K.message) || "unknown error"}`
                  )
                );
              }, W.onabort = () => N(new Error("Image reading was aborted")), W.readAsDataURL(k.blob());
            });
          }
        } : {}
      },
      onEditorChange: i
    }
  ) });
}, Se1 = ({
  name: e,
  label: n,
  error: i,
  ...a
}) => {
  var I;
  const { control: s, formState: g } = Tf(), c = i || ((I = g.errors[e]) == null ? void 0 : I.message);
  return /* @__PURE__ */ y.jsx(
    zm,
    {
      name: e,
      label: n,
      error: c,
      sx: { width: "100%" },
      children: /* @__PURE__ */ y.jsx(
        Cz,
        {
          name: e,
          control: s,
          render: ({ field: h }) => /* @__PURE__ */ y.jsx(
            Bq,
            {
              width: "100%",
              ...a,
              value: h.value,
              onChange: h.onChange,
              onBlur: h.onBlur
            }
          )
        }
      )
    }
  );
}, Hq = Gt.forwardRef(
  ({ rows: e = 3, ...n }, i) => /* @__PURE__ */ y.jsx(Uf, { rows: e, multiline: !0, ...n, ref: i })
), Ee1 = ({
  name: e,
  ...n
}) => {
  var g, c;
  const { register: i, formState: a } = Tf(), s = (c = (g = a.errors) == null ? void 0 : g[e]) == null ? void 0 : c.message;
  return /* @__PURE__ */ y.jsx(
    Hq,
    {
      disabled: a.isSubmitting,
      ...n,
      ...i(e),
      error: s
    }
  );
}, Uq = ({ children: e, ...n }) => /* @__PURE__ */ y.jsx(k2, { type: "submit", variant: "contained", color: "primary", ...n, children: e || "Submit" }), Me1 = ({
  submittingProps: e = {},
  ...n
}) => {
  const {
    formState: { isSubmitting: i }
  } = Tf(), a = V2(
    () => ({
      ...n,
      ...i ? e : {}
    }),
    [n, e, i]
  );
  return /* @__PURE__ */ y.jsx(Uq, { disabled: i, ...a });
}, Wq = {
  medium: { label: "body2", value: "body1", gap: 1 },
  small: { label: "caption", value: "caption", gap: 1.25 }
}, Vq = H1(ne, {
  shouldForwardProp: (e) => e !== "compact"
})(({ theme: e, compact: n }) => ({
  color: e.palette.common.neutrals[300],
  ...n && { flexShrink: 0 }
})), _q = H1(ne, {
  shouldForwardProp: (e) => e !== "compact"
})(({ compact: e }) => ({
  ...e && { minWidth: 0, overflowWrap: "anywhere" }
})), Te1 = ({
  label: e,
  value: n,
  labelWidth: i = "160px",
  emptyValuePlaceholder: a = "-",
  alignItems: s,
  size: g = "medium"
}) => {
  const c = Wq[g], I = g === "small";
  return /* @__PURE__ */ y.jsxs(Ke, { direction: "row", gap: c.gap, alignItems: s, children: [
    /* @__PURE__ */ y.jsx(
      Vq,
      {
        sx: { width: i },
        variant: c.label,
        compact: I,
        children: e
      }
    ),
    typeof n == "string" || n === null ? /* @__PURE__ */ y.jsx(_q, { variant: c.value, compact: I, children: n || a }) : n
  ] });
}, Hx = (e) => typeof e == "string" ? !1 : "collapsed" in e && "expanded" in e, Le1 = ({
  children: e,
  summary: n,
  expanded: i,
  defaultExpanded: a = !1,
  expandIcon: s = /* @__PURE__ */ y.jsx(Me, { icon: "chevronDown" }),
  onChange: g,
  summaryProps: c = {},
  detailsProps: I = {},
  ...h
}) => {
  const [m, w] = qt(a), S = i ?? m, T = h2(
    (z, N) => {
      g && g(z, N), w(N);
    },
    [g, w, S]
  ), D = V2(() => s && Hx(s) ? S ? s.expanded : s.collapsed : s, [s, S]), k = V2(() => n && Hx(n) ? S ? n == null ? void 0 : n.expanded : n == null ? void 0 : n.collapsed : n, [S, n]);
  return /* @__PURE__ */ y.jsxs(
    Vj,
    {
      disableGutters: !0,
      square: !0,
      elevation: 0,
      expanded: S,
      onChange: T,
      ...h,
      children: [
        /* @__PURE__ */ y.jsx(_j, { ...c, expandIcon: D, children: typeof k == "string" ? /* @__PURE__ */ y.jsx(ne, { children: k }) : k }),
        /* @__PURE__ */ y.jsx(Jj, { ...I, children: e })
      ]
    }
  );
}, Re1 = H1(F1)({
  display: "none",
  width: "750px",
  "@media print": {
    display: "block"
  },
  "@page": {
    margin: "10mm"
  }
}), Oe1 = ({
  variant: e = "logoExpanded",
  ...n
}) => {
  const i = Da(), a = V2(() => {
    var s, g, c;
    switch (e) {
      case "logoExpanded":
        return (s = i.assets) == null ? void 0 : s.logoExpanded;
      case "logoSplash":
        return (g = i.assets) == null ? void 0 : g.logoSplash;
      case "logo":
      default:
        return (c = i.assets) == null ? void 0 : c.logo;
    }
  }, [e]);
  return /* @__PURE__ */ y.jsx(
    F1,
    {
      "data-testid": "logo",
      component: "img",
      src: a,
      width: "100%",
      ...n
    }
  );
}, gT = ({
  type: e = "default",
  icon: n,
  variant: i = "body2",
  children: a,
  ...s
}) => /* @__PURE__ */ y.jsxs(
  ne,
  {
    gap: 1,
    display: "flex",
    alignItems: "center",
    variant: i,
    color: (g) => e === "default" ? g.palette.text.primary : g.palette[e].main,
    ...s,
    children: [
      e !== "default" && /* @__PURE__ */ y.jsx(Me, { icon: n || e }),
      a
    ]
  }
);
gT.displayName = "AlertHeading";
const jA = /* @__PURE__ */ n1.createContext({});
process.env.NODE_ENV !== "production" && (jA.displayName = "ListContext");
function Jq(e) {
  return sr("MuiList", e);
}
m2("MuiList", ["root", "padding", "dense", "subheader"]);
const Kq = ["children", "className", "component", "dense", "disablePadding", "subheader"], Yq = (e) => {
  const {
    classes: n,
    disablePadding: i,
    dense: a,
    subheader: s
  } = e;
  return Yr({
    root: ["root", !i && "padding", a && "dense", s && "subheader"]
  }, Jq, n);
}, Qq = Rn("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, !i.disablePadding && n.padding, i.dense && n.dense, i.subheader && n.subheader];
  }
})(({
  ownerState: e
}) => m1({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), fT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiList"
  }), {
    children: s,
    className: g,
    component: c = "ul",
    dense: I = !1,
    disablePadding: h = !1,
    subheader: m
  } = a, w = Tt(a, Kq), S = n1.useMemo(() => ({
    dense: I
  }), [I]), T = m1({}, a, {
    component: c,
    dense: I,
    disablePadding: h
  }), D = Yq(T);
  return /* @__PURE__ */ y.jsx(jA.Provider, {
    value: S,
    children: /* @__PURE__ */ y.jsxs(Qq, m1({
      as: c,
      className: Xt(D.root, g),
      ref: i,
      ownerState: T
    }, w, {
      children: [m, s]
    }))
  });
});
process.env.NODE_ENV !== "production" && (fT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: E.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: E.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: E.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const Xq = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function R7(e, n, i) {
  return e === n ? e.firstChild : n && n.nextElementSibling ? n.nextElementSibling : i ? null : e.firstChild;
}
function Ux(e, n, i) {
  return e === n ? i ? e.firstChild : e.lastChild : n && n.previousElementSibling ? n.previousElementSibling : i ? null : e.lastChild;
}
function dT(e, n) {
  if (n === void 0)
    return !0;
  let i = e.innerText;
  return i === void 0 && (i = e.textContent), i = i.trim().toLowerCase(), i.length === 0 ? !1 : n.repeating ? i[0] === n.keys[0] : i.indexOf(n.keys.join("")) === 0;
}
function nf(e, n, i, a, s, g) {
  let c = !1, I = s(e, n, n ? i : !1);
  for (; I; ) {
    if (I === e.firstChild) {
      if (c)
        return !1;
      c = !0;
    }
    const h = a ? !1 : I.disabled || I.getAttribute("aria-disabled") === "true";
    if (!I.hasAttribute("tabindex") || !dT(I, g) || h)
      I = s(e, I, i);
    else
      return I.focus(), !0;
  }
  return !1;
}
const CT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: a,
    autoFocus: s = !1,
    autoFocusItem: g = !1,
    children: c,
    className: I,
    disabledItemsFocusable: h = !1,
    disableListWrap: m = !1,
    onKeyDown: w,
    variant: S = "selectedMenu"
  } = n, T = Tt(n, Xq), D = n1.useRef(null), k = n1.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Lc(() => {
    s && D.current.focus();
  }, [s]), n1.useImperativeHandle(a, () => ({
    adjustStyleForScrollbar: (V, {
      direction: Y
    }) => {
      const H = !D.current.style.width;
      if (V.clientHeight < D.current.clientHeight && H) {
        const Z = `${iE(a0(V))}px`;
        D.current.style[Y === "rtl" ? "paddingLeft" : "paddingRight"] = Z, D.current.style.width = `calc(100% + ${Z})`;
      }
      return D.current;
    }
  }), []);
  const z = (V) => {
    const Y = D.current, H = V.key, Z = a0(Y).activeElement;
    if (H === "ArrowDown")
      V.preventDefault(), nf(Y, Z, m, h, R7);
    else if (H === "ArrowUp")
      V.preventDefault(), nf(Y, Z, m, h, Ux);
    else if (H === "Home")
      V.preventDefault(), nf(Y, null, m, h, R7);
    else if (H === "End")
      V.preventDefault(), nf(Y, null, m, h, Ux);
    else if (H.length === 1) {
      const Q = k.current, P1 = H.toLowerCase(), Y1 = performance.now();
      Q.keys.length > 0 && (Y1 - Q.lastTime > 500 ? (Q.keys = [], Q.repeating = !0, Q.previousKeyMatched = !0) : Q.repeating && P1 !== Q.keys[0] && (Q.repeating = !1)), Q.lastTime = Y1, Q.keys.push(P1);
      const O1 = Z && !Q.repeating && dT(Z, Q);
      Q.previousKeyMatched && (O1 || nf(Y, Z, !1, h, R7, Q)) ? V.preventDefault() : Q.previousKeyMatched = !1;
    }
    w && w(V);
  }, N = U0(D, i);
  let W = -1;
  n1.Children.forEach(c, (V, Y) => {
    if (!/* @__PURE__ */ n1.isValidElement(V)) {
      W === Y && (W += 1, W >= c.length && (W = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && mA.isFragment(V) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), V.props.disabled || (S === "selectedMenu" && V.props.selected || W === -1) && (W = Y), W === Y && (V.props.disabled || V.props.muiSkipListHighlight || V.type.muiSkipListHighlight) && (W += 1, W >= c.length && (W = -1));
  });
  const K = n1.Children.map(c, (V, Y) => {
    if (Y === W) {
      const H = {};
      return g && (H.autoFocus = !0), V.props.tabIndex === void 0 && S === "selectedMenu" && (H.tabIndex = 0), /* @__PURE__ */ n1.cloneElement(V, H);
    }
    return V;
  });
  return /* @__PURE__ */ y.jsx(fT, m1({
    role: "menu",
    ref: N,
    className: I,
    onKeyDown: z,
    tabIndex: s ? 0 : -1
  }, T, {
    children: K
  }));
});
process.env.NODE_ENV !== "production" && (CT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: E.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: E.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: E.node,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: E.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: E.bool,
  /**
   * @ignore
   */
  onKeyDown: E.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: E.oneOf(["menu", "selectedMenu"])
});
const AT = (e) => e.scrollTop;
function zA(e, n) {
  var i, a;
  const {
    timeout: s,
    easing: g,
    style: c = {}
  } = e;
  return {
    duration: (i = c.transitionDuration) != null ? i : typeof s == "number" ? s : s[n.mode] || 0,
    easing: (a = c.transitionTimingFunction) != null ? a : typeof g == "object" ? g[n.mode] : g,
    delay: c.transitionDelay
  };
}
const Gq = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function jh(e) {
  return `scale(${e}, ${e ** 2})`;
}
const qq = {
  entering: {
    opacity: 1,
    transform: jh(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, O7 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Nm = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const {
    addEndListener: a,
    appear: s = !0,
    children: g,
    easing: c,
    in: I,
    onEnter: h,
    onEntered: m,
    onEntering: w,
    onExit: S,
    onExited: T,
    onExiting: D,
    style: k,
    timeout: z = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: N = zi
  } = n, W = Tt(n, Gq), K = rE(), V = n1.useRef(), Y = t6(), H = n1.useRef(null), Z = U0(H, g.ref, i), Q = (h1) => (C1) => {
    if (h1) {
      const L1 = H.current;
      C1 === void 0 ? h1(L1) : h1(L1, C1);
    }
  }, P1 = Q(w), Y1 = Q((h1, C1) => {
    AT(h1);
    const {
      duration: L1,
      delay: f1,
      easing: B1
    } = zA({
      style: k,
      timeout: z,
      easing: c
    }, {
      mode: "enter"
    });
    let t1;
    z === "auto" ? (t1 = Y.transitions.getAutoHeightDuration(h1.clientHeight), V.current = t1) : t1 = L1, h1.style.transition = [Y.transitions.create("opacity", {
      duration: t1,
      delay: f1
    }), Y.transitions.create("transform", {
      duration: O7 ? t1 : t1 * 0.666,
      delay: f1,
      easing: B1
    })].join(","), h && h(h1, C1);
  }), O1 = Q(m), T1 = Q(D), J1 = Q((h1) => {
    const {
      duration: C1,
      delay: L1,
      easing: f1
    } = zA({
      style: k,
      timeout: z,
      easing: c
    }, {
      mode: "exit"
    });
    let B1;
    z === "auto" ? (B1 = Y.transitions.getAutoHeightDuration(h1.clientHeight), V.current = B1) : B1 = C1, h1.style.transition = [Y.transitions.create("opacity", {
      duration: B1,
      delay: L1
    }), Y.transitions.create("transform", {
      duration: O7 ? B1 : B1 * 0.666,
      delay: O7 ? L1 : L1 || B1 * 0.333,
      easing: f1
    })].join(","), h1.style.opacity = 0, h1.style.transform = jh(0.75), S && S(h1);
  }), s1 = Q(T), d1 = (h1) => {
    z === "auto" && K.start(V.current || 0, h1), a && a(H.current, h1);
  };
  return /* @__PURE__ */ y.jsx(N, m1({
    appear: s,
    in: I,
    nodeRef: H,
    onEnter: Y1,
    onEntered: O1,
    onEntering: P1,
    onExit: J1,
    onExited: s1,
    onExiting: T1,
    addEndListener: d1,
    timeout: z === "auto" ? null : z
  }, W, {
    children: (h1, C1) => /* @__PURE__ */ n1.cloneElement(g, m1({
      style: m1({
        opacity: 0,
        transform: jh(0.75),
        visibility: h1 === "exited" && !I ? "hidden" : void 0
      }, qq[h1], k, g.props.style),
      ref: Z
    }, C1))
  }));
});
process.env.NODE_ENV !== "production" && (Nm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: E.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: E.bool,
  /**
   * A single child content element.
   */
  children: jf.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: E.oneOfType([E.shape({
    enter: E.string,
    exit: E.string
  }), E.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: E.bool,
  /**
   * @ignore
   */
  onEnter: E.func,
  /**
   * @ignore
   */
  onEntered: E.func,
  /**
   * @ignore
   */
  onEntering: E.func,
  /**
   * @ignore
   */
  onExit: E.func,
  /**
   * @ignore
   */
  onExited: E.func,
  /**
   * @ignore
   */
  onExiting: E.func,
  /**
   * @ignore
   */
  style: E.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
Nm.muiSupportAuto = !0;
function Zq(e) {
  const n = a0(e);
  return n.body === e ? vf(e).innerWidth > n.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Af(e, n) {
  n ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Wx(e) {
  return parseInt(vf(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function $q(e) {
  const i = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, a = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return i || a;
}
function Vx(e, n, i, a, s) {
  const g = [n, i, ...a];
  [].forEach.call(e.children, (c) => {
    const I = g.indexOf(c) === -1, h = !$q(c);
    I && h && Af(c, s);
  });
}
function D7(e, n) {
  let i = -1;
  return e.some((a, s) => n(a) ? (i = s, !0) : !1), i;
}
function eZ(e, n) {
  const i = [], a = e.container;
  if (!n.disableScrollLock) {
    if (Zq(a)) {
      const c = iE(a0(a));
      i.push({
        value: a.style.paddingRight,
        property: "padding-right",
        el: a
      }), a.style.paddingRight = `${Wx(a) + c}px`;
      const I = a0(a).querySelectorAll(".mui-fixed");
      [].forEach.call(I, (h) => {
        i.push({
          value: h.style.paddingRight,
          property: "padding-right",
          el: h
        }), h.style.paddingRight = `${Wx(h) + c}px`;
      });
    }
    let g;
    if (a.parentNode instanceof DocumentFragment)
      g = a0(a).body;
    else {
      const c = a.parentElement, I = vf(a);
      g = (c == null ? void 0 : c.nodeName) === "HTML" && I.getComputedStyle(c).overflowY === "scroll" ? c : a;
    }
    i.push({
      value: g.style.overflow,
      property: "overflow",
      el: g
    }, {
      value: g.style.overflowX,
      property: "overflow-x",
      el: g
    }, {
      value: g.style.overflowY,
      property: "overflow-y",
      el: g
    }), g.style.overflow = "hidden";
  }
  return () => {
    i.forEach(({
      value: g,
      el: c,
      property: I
    }) => {
      g ? c.style.setProperty(I, g) : c.style.removeProperty(I);
    });
  };
}
function tZ(e) {
  const n = [];
  return [].forEach.call(e.children, (i) => {
    i.getAttribute("aria-hidden") === "true" && n.push(i);
  }), n;
}
class nZ {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(n, i) {
    let a = this.modals.indexOf(n);
    if (a !== -1)
      return a;
    a = this.modals.length, this.modals.push(n), n.modalRef && Af(n.modalRef, !1);
    const s = tZ(i);
    Vx(i, n.mount, n.modalRef, s, !0);
    const g = D7(this.containers, (c) => c.container === i);
    return g !== -1 ? (this.containers[g].modals.push(n), a) : (this.containers.push({
      modals: [n],
      container: i,
      restore: null,
      hiddenSiblings: s
    }), a);
  }
  mount(n, i) {
    const a = D7(this.containers, (g) => g.modals.indexOf(n) !== -1), s = this.containers[a];
    s.restore || (s.restore = eZ(s, i));
  }
  remove(n, i = !0) {
    const a = this.modals.indexOf(n);
    if (a === -1)
      return a;
    const s = D7(this.containers, (c) => c.modals.indexOf(n) !== -1), g = this.containers[s];
    if (g.modals.splice(g.modals.indexOf(n), 1), this.modals.splice(a, 1), g.modals.length === 0)
      g.restore && g.restore(), n.modalRef && Af(n.modalRef, i), Vx(g.container, n.mount, n.modalRef, g.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const c = g.modals[g.modals.length - 1];
      c.modalRef && Af(c.modalRef, !1);
    }
    return a;
  }
  isTopModal(n) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === n;
  }
}
const rZ = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function iZ(e) {
  const n = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(n) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : n;
}
function aZ(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const n = (a) => e.ownerDocument.querySelector(`input[type="radio"]${a}`);
  let i = n(`[name="${e.name}"]:checked`);
  return i || (i = n(`[name="${e.name}"]`)), i !== e;
}
function oZ(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || aZ(e));
}
function sZ(e) {
  const n = [], i = [];
  return Array.from(e.querySelectorAll(rZ)).forEach((a, s) => {
    const g = iZ(a);
    g === -1 || !oZ(a) || (g === 0 ? n.push(a) : i.push({
      documentOrder: s,
      tabIndex: g,
      node: a
    }));
  }), i.sort((a, s) => a.tabIndex === s.tabIndex ? a.documentOrder - s.documentOrder : a.tabIndex - s.tabIndex).map((a) => a.node).concat(n);
}
function lZ() {
  return !0;
}
function NA(e) {
  const {
    children: n,
    disableAutoFocus: i = !1,
    disableEnforceFocus: a = !1,
    disableRestoreFocus: s = !1,
    getTabbable: g = sZ,
    isEnabled: c = lZ,
    open: I
  } = e, h = n1.useRef(!1), m = n1.useRef(null), w = n1.useRef(null), S = n1.useRef(null), T = n1.useRef(null), D = n1.useRef(!1), k = n1.useRef(null), z = U0(n.ref, k), N = n1.useRef(null);
  n1.useEffect(() => {
    !I || !k.current || (D.current = !i);
  }, [i, I]), n1.useEffect(() => {
    if (!I || !k.current)
      return;
    const V = a0(k.current);
    return k.current.contains(V.activeElement) || (k.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), k.current.setAttribute("tabIndex", "-1")), D.current && k.current.focus()), () => {
      s || (S.current && S.current.focus && (h.current = !0, S.current.focus()), S.current = null);
    };
  }, [I]), n1.useEffect(() => {
    if (!I || !k.current)
      return;
    const V = a0(k.current), Y = (Q) => {
      N.current = Q, !(a || !c() || Q.key !== "Tab") && V.activeElement === k.current && Q.shiftKey && (h.current = !0, w.current && w.current.focus());
    }, H = () => {
      const Q = k.current;
      if (Q === null)
        return;
      if (!V.hasFocus() || !c() || h.current) {
        h.current = !1;
        return;
      }
      if (Q.contains(V.activeElement) || a && V.activeElement !== m.current && V.activeElement !== w.current)
        return;
      if (V.activeElement !== T.current)
        T.current = null;
      else if (T.current !== null)
        return;
      if (!D.current)
        return;
      let P1 = [];
      if ((V.activeElement === m.current || V.activeElement === w.current) && (P1 = g(k.current)), P1.length > 0) {
        var Y1, O1;
        const T1 = !!((Y1 = N.current) != null && Y1.shiftKey && ((O1 = N.current) == null ? void 0 : O1.key) === "Tab"), J1 = P1[0], s1 = P1[P1.length - 1];
        typeof J1 != "string" && typeof s1 != "string" && (T1 ? s1.focus() : J1.focus());
      } else
        Q.focus();
    };
    V.addEventListener("focusin", H), V.addEventListener("keydown", Y, !0);
    const Z = setInterval(() => {
      V.activeElement && V.activeElement.tagName === "BODY" && H();
    }, 50);
    return () => {
      clearInterval(Z), V.removeEventListener("focusin", H), V.removeEventListener("keydown", Y, !0);
    };
  }, [i, a, s, c, I, g]);
  const W = (V) => {
    S.current === null && (S.current = V.relatedTarget), D.current = !0, T.current = V.target;
    const Y = n.props.onFocus;
    Y && Y(V);
  }, K = (V) => {
    S.current === null && (S.current = V.relatedTarget), D.current = !0;
  };
  return /* @__PURE__ */ y.jsxs(n1.Fragment, {
    children: [/* @__PURE__ */ y.jsx("div", {
      tabIndex: I ? 0 : -1,
      onFocus: K,
      ref: m,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ n1.cloneElement(n, {
      ref: z,
      onFocus: W
    }), /* @__PURE__ */ y.jsx("div", {
      tabIndex: I ? 0 : -1,
      onFocus: K,
      ref: w,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (NA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: jf,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: E.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: E.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: E.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: E.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: E.func,
  /**
   * If `true`, focus is locked.
   */
  open: E.bool.isRequired
});
process.env.NODE_ENV !== "production" && (NA.propTypes = tE(NA.propTypes));
function uZ(e) {
  return typeof e == "function" ? e() : e;
}
const PA = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const {
    children: a,
    container: s,
    disablePortal: g = !1
  } = n, [c, I] = n1.useState(null), h = U0(/* @__PURE__ */ n1.isValidElement(a) ? a.ref : null, i);
  if (Lc(() => {
    g || I(uZ(s) || document.body);
  }, [s, g]), Lc(() => {
    if (c && !g)
      return J7(i, c), () => {
        J7(i, null);
      };
  }, [i, c, g]), g) {
    if (/* @__PURE__ */ n1.isValidElement(a)) {
      const m = {
        ref: h
      };
      return /* @__PURE__ */ n1.cloneElement(a, m);
    }
    return /* @__PURE__ */ y.jsx(n1.Fragment, {
      children: a
    });
  }
  return /* @__PURE__ */ y.jsx(n1.Fragment, {
    children: c && /* @__PURE__ */ TE.createPortal(a, c)
  });
});
process.env.NODE_ENV !== "production" && (PA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: E.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([mf, E.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: E.bool
});
process.env.NODE_ENV !== "production" && (PA.propTypes = tE(PA.propTypes));
const cZ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], gZ = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, IT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = t6(), s = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    addEndListener: g,
    appear: c = !0,
    children: I,
    easing: h,
    in: m,
    onEnter: w,
    onEntered: S,
    onEntering: T,
    onExit: D,
    onExited: k,
    onExiting: z,
    style: N,
    timeout: W = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: K = zi
  } = n, V = Tt(n, cZ), Y = n1.useRef(null), H = U0(Y, I.ref, i), Z = (d1) => (h1) => {
    if (d1) {
      const C1 = Y.current;
      h1 === void 0 ? d1(C1) : d1(C1, h1);
    }
  }, Q = Z(T), P1 = Z((d1, h1) => {
    AT(d1);
    const C1 = zA({
      style: N,
      timeout: W,
      easing: h
    }, {
      mode: "enter"
    });
    d1.style.webkitTransition = a.transitions.create("opacity", C1), d1.style.transition = a.transitions.create("opacity", C1), w && w(d1, h1);
  }), Y1 = Z(S), O1 = Z(z), T1 = Z((d1) => {
    const h1 = zA({
      style: N,
      timeout: W,
      easing: h
    }, {
      mode: "exit"
    });
    d1.style.webkitTransition = a.transitions.create("opacity", h1), d1.style.transition = a.transitions.create("opacity", h1), D && D(d1);
  }), J1 = Z(k), s1 = (d1) => {
    g && g(Y.current, d1);
  };
  return /* @__PURE__ */ y.jsx(K, m1({
    appear: c,
    in: m,
    nodeRef: Y,
    onEnter: P1,
    onEntered: Y1,
    onEntering: Q,
    onExit: T1,
    onExited: J1,
    onExiting: O1,
    addEndListener: s1,
    timeout: W
  }, V, {
    children: (d1, h1) => /* @__PURE__ */ n1.cloneElement(I, m1({
      style: m1({
        opacity: 0,
        visibility: d1 === "exited" && !m ? "hidden" : void 0
      }, gZ[d1], N, I.props.style),
      ref: H
    }, h1))
  }));
});
process.env.NODE_ENV !== "production" && (IT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: E.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: E.bool,
  /**
   * A single child content element.
   */
  children: jf.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: E.oneOfType([E.shape({
    enter: E.string,
    exit: E.string
  }), E.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: E.bool,
  /**
   * @ignore
   */
  onEnter: E.func,
  /**
   * @ignore
   */
  onEntered: E.func,
  /**
   * @ignore
   */
  onEntering: E.func,
  /**
   * @ignore
   */
  onExit: E.func,
  /**
   * @ignore
   */
  onExited: E.func,
  /**
   * @ignore
   */
  onExiting: E.func,
  /**
   * @ignore
   */
  style: E.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: E.oneOfType([E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
function fZ(e) {
  return sr("MuiBackdrop", e);
}
m2("MuiBackdrop", ["root", "invisible"]);
const dZ = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], CZ = (e) => {
  const {
    classes: n,
    invisible: i
  } = e;
  return Yr({
    root: ["root", i && "invisible"]
  }, fZ, n);
}, AZ = Rn("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.invisible && n.invisible];
  }
})(({
  ownerState: e
}) => m1({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), pT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  var a, s, g;
  const c = jr({
    props: n,
    name: "MuiBackdrop"
  }), {
    children: I,
    className: h,
    component: m = "div",
    components: w = {},
    componentsProps: S = {},
    invisible: T = !1,
    open: D,
    slotProps: k = {},
    slots: z = {},
    TransitionComponent: N = IT,
    transitionDuration: W
  } = c, K = Tt(c, dZ), V = m1({}, c, {
    component: m,
    invisible: T
  }), Y = CZ(V), H = (a = k.root) != null ? a : S.root;
  return /* @__PURE__ */ y.jsx(N, m1({
    in: D,
    timeout: W
  }, K, {
    children: /* @__PURE__ */ y.jsx(AZ, m1({
      "aria-hidden": !0
    }, H, {
      as: (s = (g = z.root) != null ? g : w.Root) != null ? s : m,
      className: Xt(Y.root, h, H == null ? void 0 : H.className),
      ownerState: m1({}, V, H == null ? void 0 : H.ownerState),
      classes: Y,
      ref: i,
      children: I
    }))
  }));
});
process.env.NODE_ENV !== "production" && (pT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: E.shape({
    Root: E.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: E.shape({
    root: E.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: E.bool,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: E.shape({
    root: E.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: E.shape({
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: E.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: E.oneOfType([E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
function IZ(e) {
  return typeof e == "function" ? e() : e;
}
function pZ(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const hZ = new nZ();
function mZ(e) {
  const {
    container: n,
    disableEscapeKeyDown: i = !1,
    disableScrollLock: a = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = hZ,
    closeAfterTransition: g = !1,
    onTransitionEnter: c,
    onTransitionExited: I,
    children: h,
    onClose: m,
    open: w,
    rootRef: S
  } = e, T = n1.useRef({}), D = n1.useRef(null), k = n1.useRef(null), z = U0(k, S), [N, W] = n1.useState(!w), K = pZ(h);
  let V = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (V = !1);
  const Y = () => a0(D.current), H = () => (T.current.modalRef = k.current, T.current.mount = D.current, T.current), Z = () => {
    s.mount(H(), {
      disableScrollLock: a
    }), k.current && (k.current.scrollTop = 0);
  }, Q = vc(() => {
    const C1 = IZ(n) || Y().body;
    s.add(H(), C1), k.current && Z();
  }), P1 = n1.useCallback(() => s.isTopModal(H()), [s]), Y1 = vc((C1) => {
    D.current = C1, C1 && (w && P1() ? Z() : k.current && Af(k.current, V));
  }), O1 = n1.useCallback(() => {
    s.remove(H(), V);
  }, [V, s]);
  n1.useEffect(() => () => {
    O1();
  }, [O1]), n1.useEffect(() => {
    w ? Q() : (!K || !g) && O1();
  }, [w, O1, K, g, Q]);
  const T1 = (C1) => (L1) => {
    var f1;
    (f1 = C1.onKeyDown) == null || f1.call(C1, L1), !(L1.key !== "Escape" || L1.which === 229 || // Wait until IME is settled.
    !P1()) && (i || (L1.stopPropagation(), m && m(L1, "escapeKeyDown")));
  }, J1 = (C1) => (L1) => {
    var f1;
    (f1 = C1.onClick) == null || f1.call(C1, L1), L1.target === L1.currentTarget && m && m(L1, "backdropClick");
  };
  return {
    getRootProps: (C1 = {}) => {
      const L1 = uE(e);
      delete L1.onTransitionEnter, delete L1.onTransitionExited;
      const f1 = m1({}, L1, C1);
      return m1({
        role: "presentation"
      }, f1, {
        onKeyDown: T1(f1),
        ref: z
      });
    },
    getBackdropProps: (C1 = {}) => {
      const L1 = C1;
      return m1({
        "aria-hidden": !0
      }, L1, {
        onClick: J1(L1),
        open: w
      });
    },
    getTransitionProps: () => {
      const C1 = () => {
        W(!1), c && c();
      }, L1 = () => {
        W(!0), I && I(), g && O1();
      };
      return {
        onEnter: _b(C1, h == null ? void 0 : h.props.onEnter),
        onExited: _b(L1, h == null ? void 0 : h.props.onExited)
      };
    },
    rootRef: z,
    portalRef: Y1,
    isTopModal: P1,
    exited: N,
    hasTransition: K
  };
}
function vZ(e) {
  return sr("MuiModal", e);
}
m2("MuiModal", ["root", "hidden", "backdrop"]);
const yZ = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], bZ = (e) => {
  const {
    open: n,
    exited: i,
    classes: a
  } = e;
  return Yr({
    root: ["root", !n && i && "hidden"],
    backdrop: ["backdrop"]
  }, vZ, a);
}, wZ = Rn("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, !i.open && i.exited && n.hidden];
  }
})(({
  theme: e,
  ownerState: n
}) => m1({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !n.open && n.exited && {
  visibility: "hidden"
})), xZ = Rn(pT, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, n) => n.backdrop
})({
  zIndex: -1
}), hT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  var a, s, g, c, I, h;
  const m = jr({
    name: "MuiModal",
    props: n
  }), {
    BackdropComponent: w = xZ,
    BackdropProps: S,
    className: T,
    closeAfterTransition: D = !1,
    children: k,
    container: z,
    component: N,
    components: W = {},
    componentsProps: K = {},
    disableAutoFocus: V = !1,
    disableEnforceFocus: Y = !1,
    disableEscapeKeyDown: H = !1,
    disablePortal: Z = !1,
    disableRestoreFocus: Q = !1,
    disableScrollLock: P1 = !1,
    hideBackdrop: Y1 = !1,
    keepMounted: O1 = !1,
    onBackdropClick: T1,
    open: J1,
    slotProps: s1,
    slots: d1
    // eslint-disable-next-line react/prop-types
  } = m, h1 = Tt(m, yZ), C1 = m1({}, m, {
    closeAfterTransition: D,
    disableAutoFocus: V,
    disableEnforceFocus: Y,
    disableEscapeKeyDown: H,
    disablePortal: Z,
    disableRestoreFocus: Q,
    disableScrollLock: P1,
    hideBackdrop: Y1,
    keepMounted: O1
  }), {
    getRootProps: L1,
    getBackdropProps: f1,
    getTransitionProps: B1,
    portalRef: t1,
    isTopModal: y1,
    exited: k1,
    hasTransition: se
  } = mZ(m1({}, C1, {
    rootRef: i
  })), K1 = m1({}, C1, {
    exited: k1
  }), le = bZ(K1), G1 = {};
  if (k.props.tabIndex === void 0 && (G1.tabIndex = "-1"), se) {
    const {
      onEnter: ue,
      onExited: b1
    } = B1();
    G1.onEnter = ue, G1.onExited = b1;
  }
  const $1 = (a = (s = d1 == null ? void 0 : d1.root) != null ? s : W.Root) != null ? a : wZ, V1 = (g = (c = d1 == null ? void 0 : d1.backdrop) != null ? c : W.Backdrop) != null ? g : w, z1 = (I = s1 == null ? void 0 : s1.root) != null ? I : K.root, ae = (h = s1 == null ? void 0 : s1.backdrop) != null ? h : K.backdrop, We = Rc({
    elementType: $1,
    externalSlotProps: z1,
    externalForwardedProps: h1,
    getSlotProps: L1,
    additionalProps: {
      ref: i,
      as: N
    },
    ownerState: K1,
    className: Xt(T, z1 == null ? void 0 : z1.className, le == null ? void 0 : le.root, !K1.open && K1.exited && (le == null ? void 0 : le.hidden))
  }), D1 = Rc({
    elementType: V1,
    externalSlotProps: ae,
    additionalProps: S,
    getSlotProps: (ue) => f1(m1({}, ue, {
      onClick: (b1) => {
        T1 && T1(b1), ue != null && ue.onClick && ue.onClick(b1);
      }
    })),
    className: Xt(ae == null ? void 0 : ae.className, S == null ? void 0 : S.className, le == null ? void 0 : le.backdrop),
    ownerState: K1
  });
  return !O1 && !J1 && (!se || k1) ? null : /* @__PURE__ */ y.jsx(PA, {
    ref: t1,
    container: z,
    disablePortal: Z,
    children: /* @__PURE__ */ y.jsxs($1, m1({}, We, {
      children: [!Y1 && w ? /* @__PURE__ */ y.jsx(V1, m1({}, D1)) : null, /* @__PURE__ */ y.jsx(NA, {
        disableEnforceFocus: Y,
        disableAutoFocus: V,
        disableRestoreFocus: Q,
        isEnabled: y1,
        open: J1,
        children: /* @__PURE__ */ n1.cloneElement(k, G1)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (hT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: E.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: E.object,
  /**
   * A single child content element.
   */
  children: jf.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: E.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: E.shape({
    Backdrop: E.elementType,
    Root: E.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: E.shape({
    backdrop: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([mf, E.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: E.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: E.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: E.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: E.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: E.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: E.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: E.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: E.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: E.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: E.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: E.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: E.shape({
    backdrop: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: E.shape({
    backdrop: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
function SZ(e) {
  return sr("MuiPaper", e);
}
m2("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const EZ = ["className", "component", "elevation", "square", "variant"], MZ = (e) => {
  const {
    square: n,
    elevation: i,
    variant: a,
    classes: s
  } = e, g = {
    root: ["root", a, !n && "rounded", a === "elevation" && `elevation${i}`]
  };
  return Yr(g, SZ, s);
}, TZ = Rn("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, n[i.variant], !i.square && n.rounded, i.variant === "elevation" && n[`elevation${i.elevation}`]];
  }
})(({
  theme: e,
  ownerState: n
}) => {
  var i;
  return m1({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !n.square && {
    borderRadius: e.shape.borderRadius
  }, n.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, n.variant === "elevation" && m1({
    boxShadow: (e.vars || e).shadows[n.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${i0("#fff", iw(n.elevation))}, ${i0("#fff", iw(n.elevation))})`
  }, e.vars && {
    backgroundImage: (i = e.vars.overlays) == null ? void 0 : i[n.elevation]
  }));
}), mT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiPaper"
  }), {
    className: s,
    component: g = "div",
    elevation: c = 1,
    square: I = !1,
    variant: h = "elevation"
  } = a, m = Tt(a, EZ), w = m1({}, a, {
    component: g,
    elevation: c,
    square: I,
    variant: h
  }), S = MZ(w);
  return process.env.NODE_ENV !== "production" && t6().shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ y.jsx(TZ, m1({
    as: g,
    ownerState: w,
    className: Xt(S.root, s),
    ref: i
  }, m));
});
process.env.NODE_ENV !== "production" && (mT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Fc(sE, (e) => {
    const {
      elevation: n,
      variant: i
    } = e;
    return n > 0 && i === "outlined" ? new Error(`MUI: Combining \`elevation={${n}}\` with \`variant="${i}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: E.oneOfType([E.oneOf(["elevation", "outlined"]), E.string])
});
function LZ(e) {
  return sr("MuiPopover", e);
}
m2("MuiPopover", ["root", "paper"]);
const RZ = ["onEntering"], OZ = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], DZ = ["slotProps"];
function _x(e, n) {
  let i = 0;
  return typeof n == "number" ? i = n : n === "center" ? i = e.height / 2 : n === "bottom" && (i = e.height), i;
}
function Jx(e, n) {
  let i = 0;
  return typeof n == "number" ? i = n : n === "center" ? i = e.width / 2 : n === "right" && (i = e.width), i;
}
function Kx(e) {
  return [e.horizontal, e.vertical].map((n) => typeof n == "number" ? `${n}px` : n).join(" ");
}
function dA(e) {
  return typeof e == "function" ? e() : e;
}
const kZ = (e) => {
  const {
    classes: n
  } = e;
  return Yr({
    root: ["root"],
    paper: ["paper"]
  }, LZ, n);
}, jZ = Rn(hT, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({}), vT = Rn(mT, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, n) => n.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), yT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  var a, s, g;
  const c = jr({
    props: n,
    name: "MuiPopover"
  }), {
    action: I,
    anchorEl: h,
    anchorOrigin: m = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: w,
    anchorReference: S = "anchorEl",
    children: T,
    className: D,
    container: k,
    elevation: z = 8,
    marginThreshold: N = 16,
    open: W,
    PaperProps: K = {},
    slots: V,
    slotProps: Y,
    transformOrigin: H = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: Z = Nm,
    transitionDuration: Q = "auto",
    TransitionProps: {
      onEntering: P1
    } = {},
    disableScrollLock: Y1 = !1
  } = c, O1 = Tt(c.TransitionProps, RZ), T1 = Tt(c, OZ), J1 = (a = Y == null ? void 0 : Y.paper) != null ? a : K, s1 = n1.useRef(), d1 = U0(s1, J1.ref), h1 = m1({}, c, {
    anchorOrigin: m,
    anchorReference: S,
    elevation: z,
    marginThreshold: N,
    externalPaperSlotProps: J1,
    transformOrigin: H,
    TransitionComponent: Z,
    transitionDuration: Q,
    TransitionProps: O1
  }), C1 = kZ(h1), L1 = n1.useCallback(() => {
    if (S === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (w || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), w;
    const ue = dA(h), b1 = ue && ue.nodeType === 1 ? ue : a0(s1.current).body, Pe = b1.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const $e = b1.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && $e.top === 0 && $e.left === 0 && $e.right === 0 && $e.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Pe.top + _x(Pe, m.vertical),
      left: Pe.left + Jx(Pe, m.horizontal)
    };
  }, [h, m.horizontal, m.vertical, w, S]), f1 = n1.useCallback((ue) => ({
    vertical: _x(ue, H.vertical),
    horizontal: Jx(ue, H.horizontal)
  }), [H.horizontal, H.vertical]), B1 = n1.useCallback((ue) => {
    const b1 = {
      width: ue.offsetWidth,
      height: ue.offsetHeight
    }, Pe = f1(b1);
    if (S === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Kx(Pe)
      };
    const $e = L1();
    let W1 = $e.top - Pe.vertical, ke = $e.left - Pe.horizontal;
    const Xe = W1 + b1.height, St = ke + b1.width, tt = vf(dA(h)), we = tt.innerHeight - N, An = tt.innerWidth - N;
    if (N !== null && W1 < N) {
      const nt = W1 - N;
      W1 -= nt, Pe.vertical += nt;
    } else if (N !== null && Xe > we) {
      const nt = Xe - we;
      W1 -= nt, Pe.vertical += nt;
    }
    if (process.env.NODE_ENV !== "production" && b1.height > we && b1.height && we && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${b1.height - we}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), N !== null && ke < N) {
      const nt = ke - N;
      ke -= nt, Pe.horizontal += nt;
    } else if (St > An) {
      const nt = St - An;
      ke -= nt, Pe.horizontal += nt;
    }
    return {
      top: `${Math.round(W1)}px`,
      left: `${Math.round(ke)}px`,
      transformOrigin: Kx(Pe)
    };
  }, [h, S, L1, f1, N]), [t1, y1] = n1.useState(W), k1 = n1.useCallback(() => {
    const ue = s1.current;
    if (!ue)
      return;
    const b1 = B1(ue);
    b1.top !== null && (ue.style.top = b1.top), b1.left !== null && (ue.style.left = b1.left), ue.style.transformOrigin = b1.transformOrigin, y1(!0);
  }, [B1]);
  n1.useEffect(() => (Y1 && window.addEventListener("scroll", k1), () => window.removeEventListener("scroll", k1)), [h, Y1, k1]);
  const se = (ue, b1) => {
    P1 && P1(ue, b1), k1();
  }, K1 = () => {
    y1(!1);
  };
  n1.useEffect(() => {
    W && k1();
  }), n1.useImperativeHandle(I, () => W ? {
    updatePosition: () => {
      k1();
    }
  } : null, [W, k1]), n1.useEffect(() => {
    if (!W)
      return;
    const ue = RP(() => {
      k1();
    }), b1 = vf(h);
    return b1.addEventListener("resize", ue), () => {
      ue.clear(), b1.removeEventListener("resize", ue);
    };
  }, [h, W, k1]);
  let le = Q;
  Q === "auto" && !Z.muiSupportAuto && (le = void 0);
  const G1 = k || (h ? a0(dA(h)).body : void 0), $1 = (s = V == null ? void 0 : V.root) != null ? s : jZ, V1 = (g = V == null ? void 0 : V.paper) != null ? g : vT, z1 = Rc({
    elementType: V1,
    externalSlotProps: m1({}, J1, {
      style: t1 ? J1.style : m1({}, J1.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: z,
      ref: d1
    },
    ownerState: h1,
    className: Xt(C1.paper, J1 == null ? void 0 : J1.className)
  }), ae = Rc({
    elementType: $1,
    externalSlotProps: (Y == null ? void 0 : Y.root) || {},
    externalForwardedProps: T1,
    additionalProps: {
      ref: i,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: G1,
      open: W
    },
    ownerState: h1,
    className: Xt(C1.root, D)
  }), {
    slotProps: We
  } = ae, D1 = Tt(ae, DZ);
  return /* @__PURE__ */ y.jsx($1, m1({}, D1, !lE($1) && {
    slotProps: We,
    disableScrollLock: Y1
  }, {
    children: /* @__PURE__ */ y.jsx(Z, m1({
      appear: !0,
      in: W,
      onEntering: se,
      onExited: K1,
      timeout: le
    }, O1, {
      children: /* @__PURE__ */ y.jsx(V1, m1({}, z1, {
        children: T
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (yT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: nE,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Fc(E.oneOfType([mf, E.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const n = dA(e.anchorEl);
      if (n && n.nodeType === 1) {
        const i = n.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && i.top === 0 && i.left === 0 && i.right === 0 && i.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${n}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: E.shape({
    horizontal: E.oneOfType([E.oneOf(["center", "left", "right"]), E.number]).isRequired,
    vertical: E.oneOfType([E.oneOf(["bottom", "center", "top"]), E.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: E.shape({
    left: E.number.isRequired,
    top: E.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: E.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([mf, E.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: E.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: sE,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: E.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: E.shape({
    component: eE
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: E.shape({
    paper: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: E.shape({
    paper: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: E.shape({
    horizontal: E.oneOfType([E.oneOf(["center", "left", "right"]), E.number]).isRequired,
    vertical: E.oneOfType([E.oneOf(["bottom", "center", "top"]), E.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: E.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: E.object
});
function zZ(e) {
  return sr("MuiMenu", e);
}
m2("MuiMenu", ["root", "paper", "list"]);
const NZ = ["onEntering"], PZ = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], FZ = {
  vertical: "top",
  horizontal: "right"
}, BZ = {
  vertical: "top",
  horizontal: "left"
}, HZ = (e) => {
  const {
    classes: n
  } = e;
  return Yr({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, zZ, n);
}, UZ = Rn(yT, {
  shouldForwardProp: (e) => nm(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({}), WZ = Rn(vT, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, n) => n.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), VZ = Rn(CT, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, n) => n.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), bT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  var a, s;
  const g = jr({
    props: n,
    name: "MuiMenu"
  }), {
    autoFocus: c = !0,
    children: I,
    className: h,
    disableAutoFocusItem: m = !1,
    MenuListProps: w = {},
    onClose: S,
    open: T,
    PaperProps: D = {},
    PopoverClasses: k,
    transitionDuration: z = "auto",
    TransitionProps: {
      onEntering: N
    } = {},
    variant: W = "selectedMenu",
    slots: K = {},
    slotProps: V = {}
  } = g, Y = Tt(g.TransitionProps, NZ), H = Tt(g, PZ), Z = GP(), Q = m1({}, g, {
    autoFocus: c,
    disableAutoFocusItem: m,
    MenuListProps: w,
    onEntering: N,
    PaperProps: D,
    transitionDuration: z,
    TransitionProps: Y,
    variant: W
  }), P1 = HZ(Q), Y1 = c && !m && T, O1 = n1.useRef(null), T1 = (f1, B1) => {
    O1.current && O1.current.adjustStyleForScrollbar(f1, {
      direction: Z ? "rtl" : "ltr"
    }), N && N(f1, B1);
  }, J1 = (f1) => {
    f1.key === "Tab" && (f1.preventDefault(), S && S(f1, "tabKeyDown"));
  };
  let s1 = -1;
  n1.Children.map(I, (f1, B1) => {
    /* @__PURE__ */ n1.isValidElement(f1) && (process.env.NODE_ENV !== "production" && mA.isFragment(f1) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), f1.props.disabled || (W === "selectedMenu" && f1.props.selected || s1 === -1) && (s1 = B1));
  });
  const d1 = (a = K.paper) != null ? a : WZ, h1 = (s = V.paper) != null ? s : D, C1 = Rc({
    elementType: K.root,
    externalSlotProps: V.root,
    ownerState: Q,
    className: [P1.root, h]
  }), L1 = Rc({
    elementType: d1,
    externalSlotProps: h1,
    ownerState: Q,
    className: P1.paper
  });
  return /* @__PURE__ */ y.jsx(UZ, m1({
    onClose: S,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: Z ? "right" : "left"
    },
    transformOrigin: Z ? FZ : BZ,
    slots: {
      paper: d1,
      root: K.root
    },
    slotProps: {
      root: C1,
      paper: L1
    },
    open: T,
    ref: i,
    transitionDuration: z,
    TransitionProps: m1({
      onEntering: T1
    }, Y),
    ownerState: Q
  }, H, {
    classes: k,
    children: /* @__PURE__ */ y.jsx(VZ, m1({
      onKeyDown: J1,
      actions: O1,
      autoFocus: c && (s1 === -1 || m),
      autoFocusItem: Y1,
      variant: W
    }, w, {
      className: Xt(P1.list, w.className),
      children: I
    }))
  }));
});
process.env.NODE_ENV !== "production" && (bT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: E.oneOfType([mf, E.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: E.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: E.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: E.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: E.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: E.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: E.shape({
    paper: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: E.shape({
    paper: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: E.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: E.oneOf(["menu", "selectedMenu"])
});
const Yx = m2("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Qx = m2("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function _Z(e) {
  return sr("MuiTypography", e);
}
m2("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const JZ = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], KZ = (e) => {
  const {
    align: n,
    gutterBottom: i,
    noWrap: a,
    paragraph: s,
    variant: g,
    classes: c
  } = e, I = {
    root: ["root", g, e.align !== "inherit" && `align${or(n)}`, i && "gutterBottom", a && "noWrap", s && "paragraph"]
  };
  return Yr(I, _Z, c);
}, YZ = Rn("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.variant && n[i.variant], i.align !== "inherit" && n[`align${or(i.align)}`], i.noWrap && n.noWrap, i.gutterBottom && n.gutterBottom, i.paragraph && n.paragraph];
  }
})(({
  theme: e,
  ownerState: n
}) => m1({
  margin: 0
}, n.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, n.variant !== "inherit" && e.typography[n.variant], n.align !== "inherit" && {
  textAlign: n.align
}, n.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, n.gutterBottom && {
  marginBottom: "0.35em"
}, n.paragraph && {
  marginBottom: 16
})), Xx = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, QZ = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, XZ = (e) => QZ[e] || e, wT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTypography"
  }), s = XZ(a.color), g = Zh(m1({}, a, {
    color: s
  })), {
    align: c = "inherit",
    className: I,
    component: h,
    gutterBottom: m = !1,
    noWrap: w = !1,
    paragraph: S = !1,
    variant: T = "body1",
    variantMapping: D = Xx
  } = g, k = Tt(g, JZ), z = m1({}, g, {
    align: c,
    color: s,
    className: I,
    component: h,
    gutterBottom: m,
    noWrap: w,
    paragraph: S,
    variant: T,
    variantMapping: D
  }), N = h || (S ? "p" : D[T] || Xx[T]) || "span", W = KZ(z);
  return /* @__PURE__ */ y.jsx(YZ, m1({
    as: N,
    ref: i,
    ownerState: z,
    className: Xt(W.root, I)
  }, k));
});
process.env.NODE_ENV !== "production" && (wT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: E.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: E.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: E.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: E.oneOfType([E.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), E.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: E.object
});
const Gx = m2("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function GZ(e) {
  return sr("MuiMenuItem", e);
}
const rf = m2("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), qZ = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], ZZ = (e, n) => {
  const {
    ownerState: i
  } = e;
  return [n.root, i.dense && n.dense, i.divider && n.divider, !i.disableGutters && n.gutters];
}, $Z = (e) => {
  const {
    disabled: n,
    dense: i,
    divider: a,
    disableGutters: s,
    selected: g,
    classes: c
  } = e, h = Yr({
    root: ["root", i && "dense", n && "disabled", !s && "gutters", a && "divider", g && "selected"]
  }, GZ, c);
  return m1({}, c, h);
}, e$ = Rn(sm, {
  shouldForwardProp: (e) => nm(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: ZZ
})(({
  theme: e,
  ownerState: n
}) => m1({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !n.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, n.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${rf.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : i0(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${rf.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : i0(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${rf.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : i0(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : i0(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${rf.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${rf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${Yx.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${Yx.inset}`]: {
    marginLeft: 52
  },
  [`& .${Gx.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Gx.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Qx.root}`]: {
    minWidth: 36
  }
}, !n.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, n.dense && m1({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${Qx.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), xT = /* @__PURE__ */ n1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: g = "li",
    dense: c = !1,
    divider: I = !1,
    disableGutters: h = !1,
    focusVisibleClassName: m,
    role: w = "menuitem",
    tabIndex: S,
    className: T
  } = a, D = Tt(a, qZ), k = n1.useContext(jA), z = n1.useMemo(() => ({
    dense: c || k.dense || !1,
    disableGutters: h
  }), [k.dense, c, h]), N = n1.useRef(null);
  Lc(() => {
    s && (N.current ? N.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const W = m1({}, a, {
    dense: z.dense,
    divider: I,
    disableGutters: h
  }), K = $Z(a), V = U0(N, i);
  let Y;
  return a.disabled || (Y = S !== void 0 ? S : -1), /* @__PURE__ */ y.jsx(jA.Provider, {
    value: z,
    children: /* @__PURE__ */ y.jsx(e$, m1({
      ref: V,
      role: w,
      tabIndex: Y,
      component: g,
      focusVisibleClassName: Xt(K.focusVisible, m),
      className: Xt(K.root, T)
    }, D, {
      ownerState: W,
      classes: K
    }))
  });
});
process.env.NODE_ENV !== "production" && (xT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: E.bool,
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: E.bool,
  /**
   * @ignore
   */
  disabled: E.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: E.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: E.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: E.string,
  /**
   * @ignore
   */
  role: E.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * @default 0
   */
  tabIndex: E.number
});
const t$ = Rn(xT)({
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: "4px",
  paddingRight: "4px"
}), n$ = Rn(wT)({
  paddingLeft: "8px",
  paddingRight: "8px",
  textAlign: "left"
}), r$ = Rn(YS)({
  display: "flex"
}), i$ = ka(
  function({
    MenuItemProps: n,
    className: i,
    label: a,
    leftIcon: s,
    renderLabel: g,
    rightIcon: c,
    ...I
  }, h) {
    return /* @__PURE__ */ y.jsxs(
      t$,
      {
        ...n,
        ref: h,
        className: i,
        ...I,
        children: [
          /* @__PURE__ */ y.jsxs(r$, { children: [
            s,
            g ? g() : /* @__PURE__ */ y.jsx(n$, { children: a })
          ] }),
          c
        ]
      }
    );
  }
), a$ = ka(
  function(n, i) {
    const {
      parentMenuOpen: a,
      label: s,
      renderLabel: g,
      rightIcon: c = /* @__PURE__ */ y.jsx(Me, { icon: "chevronRight" }),
      leftIcon: I = null,
      children: h,
      className: m,
      tabIndex: w,
      ContainerProps: S = {},
      slotProps: T,
      MenuProps: D,
      ...k
    } = n, { ref: z, ...N } = S, W = yn(null);
    vb(i, () => W.current);
    const K = yn(null);
    vb(
      z,
      () => K.current
    );
    const V = yn(null), [Y, H] = qt(!1), Z = (s1) => {
      H(!0), N.onMouseEnter && N.onMouseEnter(s1);
    }, Q = (s1) => {
      H(!1), N.onMouseLeave && N.onMouseLeave(s1);
    }, P1 = () => {
      var d1;
      const s1 = ((d1 = K.current) == null ? void 0 : d1.ownerDocument.activeElement) ?? null;
      if (V.current == null)
        return !1;
      for (const h1 of V.current.children)
        if (h1 === s1)
          return !0;
      return !1;
    }, Y1 = (s1) => {
      s1.target === K.current && H(!0), N.onFocus && N.onFocus(s1);
    }, O1 = (s1) => {
      var h1, C1, L1;
      if (s1.key === "Escape")
        return;
      P1() && s1.stopPropagation();
      const d1 = (h1 = K.current) == null ? void 0 : h1.ownerDocument.activeElement;
      if (s1.key === "ArrowLeft" && P1() && ((C1 = K.current) == null || C1.focus()), s1.key === "ArrowRight" && s1.target === K.current && s1.target === d1) {
        const f1 = (L1 = V.current) == null ? void 0 : L1.children[0];
        f1 == null || f1.focus();
      }
    }, T1 = Y && a;
    let J1;
    return n.disabled || (J1 = w !== void 0 ? w : -1), /* @__PURE__ */ y.jsxs(
      "div",
      {
        ...N,
        ref: K,
        onFocus: Y1,
        tabIndex: J1,
        onMouseEnter: Z,
        onMouseLeave: Q,
        onKeyDown: O1,
        children: [
          /* @__PURE__ */ y.jsx(
            i$,
            {
              MenuItemProps: k,
              className: m,
              ref: W,
              leftIcon: I,
              rightIcon: c,
              label: s,
              renderLabel: g
            }
          ),
          /* @__PURE__ */ y.jsx(
            bT,
            {
              style: { pointerEvents: "none" },
              anchorEl: W.current,
              anchorOrigin: {
                horizontal: "right",
                vertical: "top"
              },
              transformOrigin: {
                horizontal: "left",
                vertical: "top"
              },
              open: T1,
              autoFocus: !1,
              disableAutoFocus: !0,
              disableEnforceFocus: !0,
              onClose: () => {
                H(!1);
              },
              slotProps: T,
              ...D,
              children: /* @__PURE__ */ y.jsx("div", { ref: V, style: { pointerEvents: "auto" }, children: h })
            }
          )
        ]
      }
    );
  }
);
a$.displayName = "NestedMenuItem";
const o$ = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  state: s,
  ...g
}) => {
  const c = r6({
    to: e,
    selected: n,
    href: i,
    target: a,
    state: s
  });
  return /* @__PURE__ */ y.jsx(Kj, { ...g, ...c });
}, De1 = H1(gS)(({ theme: e }) => ({
  padding: "16px 0px 16px 0px",
  borderBottom: `solid 1px ${e.palette.common.neutrals[200]}`,
  alignItems: "center"
})), s$ = H1(F1)({
  position: "absolute",
  width: "100%",
  height: "70%",
  display: "flex",
  alignItems: "center",
  alignSelf: "center",
  justifyContent: "center"
}), ke1 = ({
  label: e
}) => /* @__PURE__ */ y.jsx(s$, { children: /* @__PURE__ */ y.jsx(ne, { children: e }) }), qx = H1(Yj)({
  color: "inherit"
}), je1 = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  children: s,
  color: g = "inherit",
  label: c,
  iconBefore: I,
  iconAfter: h,
  state: m,
  ...w
}) => {
  const S = r6({
    to: e,
    selected: n,
    href: i,
    target: a,
    state: m
  });
  return /* @__PURE__ */ y.jsx(Ma, { ...w, ...S, children: c || I || h ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    I && /* @__PURE__ */ y.jsx(qx, { sx: { color: g }, children: I }),
    c && /* @__PURE__ */ y.jsx(fS, { sx: { color: g }, children: c }),
    h && /* @__PURE__ */ y.jsx(qx, { sx: { color: g }, children: h })
  ] }) : s });
}, l$ = () => {
  const [e, n] = qt(null);
  return {
    anchorEl: e,
    open: !!e,
    onOpen: (g) => {
      n(g.currentTarget);
    },
    onClose: () => n(null)
  };
};
function ze1({
  id: e,
  menuId: n,
  label: i = "Actions",
  disabled: a,
  sx: s,
  children: g
}) {
  const { anchorEl: c, open: I, onOpen: h, onClose: m } = l$();
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      k2,
      {
        id: e,
        variant: "outlined",
        color: "inherit",
        disabled: a,
        "aria-haspopup": "menu",
        "aria-controls": I ? n : void 0,
        "aria-expanded": I,
        endIcon: /* @__PURE__ */ y.jsx(Me, { icon: "chevronDown", fontSize: "small" }),
        onClick: h,
        sx: [
          {
            px: 2,
            flexShrink: 0,
            whiteSpace: "nowrap",
            textTransform: "none",
            color: "text.primary",
            borderColor: "divider",
            bgcolor: I ? "action.selected" : void 0,
            "&:hover": {
              borderColor: "divider",
              bgcolor: I ? "action.selected" : "action.hover"
            },
            "&.Mui-focusVisible": {
              outline: 2,
              outlineColor: "primary.main",
              outlineOffset: 2
            },
            "& .MuiButton-endIcon": {
              transition: (w) => w.transitions.create("transform", {
                duration: w.transitions.duration.shorter
              }),
              transform: I ? "rotate(180deg)" : "none"
            }
          },
          ...Array.isArray(s) ? s : [s]
        ],
        children: i
      }
    ),
    /* @__PURE__ */ y.jsx(
      P7,
      {
        anchorEl: c,
        open: I,
        onClose: m,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "right" },
        MenuListProps: { id: n, "aria-labelledby": e, onClick: m },
        slotProps: {
          paper: {
            sx: {
              mt: 0.5,
              minWidth: 200,
              "& .MuiMenuItem-root": { minHeight: 44, px: 2, gap: 1.5 }
            }
          }
        },
        children: g
      }
    )
  ] });
}
const u$ = H1(dS)(({ theme: e }) => {
  var n, i;
  return {
    borderColor: (i = (n = e.palette) == null ? void 0 : n.primary) == null ? void 0 : i.main,
    borderWidth: "2px",
    borderStyle: "solid"
  };
}), c$ = H1("span")({
  minWidth: "20px"
}), g$ = (e, n) => n ? /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
  /* @__PURE__ */ y.jsx("span", { children: "|" }),
  e == null && /* @__PURE__ */ y.jsx(Fh, { width: 20 }),
  e != null && /* @__PURE__ */ y.jsx(c$, { children: e })
] }) : "", f$ = H1(CS)({
  flexDirection: "row",
  columnGap: "8px"
}), d$ = ({
  label: e,
  isCountVisible: n,
  count: i,
  ...a
}) => {
  const s = yn(i);
  vn(() => {
    i != null && (s.current = i);
  }, [i]);
  const g = i ?? s.current, c = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx("span", { children: e }),
    " ",
    g$(g, n)
  ] });
  return /* @__PURE__ */ y.jsx(f$, { label: c, ...a });
}, Ne1 = ({
  options: e,
  selectedOptionValue: n,
  onNavigationClick: i,
  sx: a,
  singleTabSx: s,
  variant: g = "scrollable",
  ariaLabel: c = "tabs"
}) => {
  const I = (h, m) => {
    i && i(m);
  };
  return /* @__PURE__ */ y.jsx(
    AS,
    {
      value: n || !1,
      onChange: I,
      "aria-label": c,
      variant: g,
      allowScrollButtonsMobile: !0,
      scrollButtons: "auto",
      sx: a,
      children: e.map(({ label: h, value: m, count: w, isCountVisible: S, dataTestId: T }) => /* @__PURE__ */ y.jsx(
        d$,
        {
          label: h,
          count: w,
          isCountVisible: S,
          value: m,
          sx: s,
          "data-testid": T
        },
        m
      ))
    }
  );
}, Go = (e, n) => SE(e).typography[n], Pm = (e) => Mf(e.palette.common.black, e.palette.action.hoverOpacity), ST = (e) => `${e / 16}rem`, k7 = 48, Wf = 32, C$ = 320, ET = 34, Pe1 = H1("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: e.spacing(2),
  flexWrap: "wrap",
  padding: e.spacing(0, 2.5),
  borderBottom: `1px solid ${e.palette.divider}`
})), Fe1 = H1("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: e.spacing(1),
  flexWrap: "wrap",
  padding: e.spacing(1.5, 2.5),
  borderBottom: `1px solid ${e.palette.common.neutrals[200]}`
})), MT = H1(Hh)(({ theme: e }) => ({
  height: Wf,
  // Centres the 32px pill on the 34px search box while the toolbar stays top-aligned.
  marginTop: 1,
  padding: e.spacing(0, 1.5),
  gap: e.spacing(0.75),
  flexShrink: 0,
  whiteSpace: "nowrap",
  borderRadius: e.shape.borderRadius * 10,
  border: `1px solid ${e.palette.common.neutrals[200]}`,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  lineHeight: 1.5,
  color: e.palette.text.primary,
  "&:hover": { backgroundColor: Pm(e) },
  "&.Mui-focusVisible": {
    outline: `2px solid ${e.palette.primary.main}`,
    outlineOffset: 2
  }
})), A$ = H1(MT)(({ theme: e }) => ({
  gap: e.spacing(0.5),
  borderStyle: "dashed",
  borderColor: e.palette.common.neutrals[300],
  color: e.palette.secondary.main,
  fontWeight: 600,
  "&:hover": { backgroundColor: Mf(e.palette.secondary.main, 0.1) }
})), Be1 = H1(MT)(({ theme: e }) => ({
  width: Wf,
  padding: 0,
  borderRadius: e.shape.borderRadius,
  color: e.palette.secondary.main,
  "&:hover": { backgroundColor: Mf(e.palette.secondary.main, 0.1) },
  '&[aria-pressed="true"]': {
    color: e.palette.common.white,
    backgroundColor: e.palette.secondary.main,
    borderColor: e.palette.secondary.main
  }
})), He1 = H1(Hh)(({ theme: e }) => ({
  height: Wf,
  padding: e.spacing(0, 1),
  flexShrink: 0,
  whiteSpace: "nowrap",
  borderRadius: e.shape.borderRadius * 10,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: 1.5,
  color: e.palette.secondary.main,
  "&:hover": { backgroundColor: Mf(e.palette.secondary.main, 0.1) },
  "&.Mui-focusVisible": {
    outline: `2px solid ${e.palette.primary.main}`,
    outlineOffset: 2
  }
})), Ue1 = H1(Dr)(({ theme: e }) => ({
  height: Wf,
  paddingLeft: e.spacing(1.75),
  paddingRight: e.spacing(1.75),
  gap: e.spacing(0.75),
  flexShrink: 0,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: 1.5
})), I$ = H1(fl)(({ theme: e }) => ({
  ...Go(e, "body2"),
  height: Wf,
  borderRadius: e.shape.borderRadius * 10,
  padding: e.spacing(0, 0.5),
  color: e.palette.text.primary,
  backgroundColor: e.brandColors.secondaryContainer,
  border: `1px solid ${e.palette.secondary.main}`,
  "& .MuiChip-icon": {
    color: e.palette.secondary.main,
    fontSize: "inherit"
  },
  "& .MuiChip-deleteIcon": {
    color: e.palette.text.secondary,
    "&:hover": { color: e.palette.text.primary }
  }
})), p$ = H1(AS)(({ theme: e }) => ({
  // Doubled class: the theme's Tabs overrides (72px from `sm` up) apply after these styles.
  "&&": { minHeight: k7, height: k7 },
  "& .MuiTabs-flexContainer": { gap: e.spacing(3) },
  "& .MuiTabs-indicator": {
    height: 2,
    backgroundColor: e.palette.primary.main
  },
  "& .MuiTab-root": {
    minHeight: k7,
    minWidth: 0,
    padding: 0,
    flexDirection: "row",
    gap: e.spacing(1),
    // MUI buttons default to the theme's base (Roboto) family; the header uses the body font.
    fontFamily: e.typography.body1.fontFamily,
    fontSize: ST(16),
    fontWeight: 600,
    lineHeight: 1.5,
    // The ui theme's button case and spacing and its text colours (text.secondary, text.primary):
    // the legacy app's theme replaces them with uppercase, unspaced buttons and darker text.
    textTransform: "none",
    letterSpacing: "0.02857em",
    // Link tabs: an app's global link styles (the legacy app underlines links on hover).
    textDecoration: "none",
    color: e.palette.common.neutrals[500],
    "&.Mui-selected": { color: e.palette.common.neutrals[800] }
  }
})), h$ = H1("span")(({ theme: e }) => ({
  padding: e.spacing(0, 0.875),
  borderRadius: e.shape.borderRadius * 10,
  fontSize: ST(12),
  lineHeight: 1.5,
  fontVariantNumeric: "tabular-nums",
  color: e.palette.common.neutrals[700],
  backgroundColor: e.palette.common.neutrals[100],
  ".Mui-selected > &": {
    color: e.palette.primary.main,
    backgroundColor: Mf(e.palette.primary.main, 0.1)
  }
})), Zx = (e) => {
  const { button: n, metaKey: i, ctrlKey: a, shiftKey: s, altKey: g } = e;
  return n > 0 || i || a || s || g;
}, We1 = ({
  options: e,
  value: n,
  onChange: i,
  "aria-label": a
}) => /* @__PURE__ */ y.jsx(
  p$,
  {
    value: n,
    onChange: (s, g) => {
      const c = e.find((I) => I.value === g);
      c != null && c.href && Zx(s) || i(g);
    },
    "aria-label": a,
    variant: "scrollable",
    children: e.map(({ value: s, label: g, count: c, id: I, href: h, ...m }) => /* @__PURE__ */ y.jsx(
      CS,
      {
        value: s,
        id: I,
        "aria-controls": m["aria-controls"],
        ...h ? {
          href: h,
          onClick: (w) => {
            Zx(w) || w.preventDefault();
          },
          // Space selects a tab button, but on a link it scrolls the page instead (MUI only
          // clicks non-native buttons on Space): select it on key up, as a button does.
          onKeyDown: (w) => {
            w.key === " " && w.preventDefault();
          },
          onKeyUp: (w) => {
            w.key === " " && w.currentTarget.click();
          }
        } : {},
        label: /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          g,
          c != null && /* @__PURE__ */ y.jsx(h$, { children: c })
        ] })
      },
      s
    ))
  }
), TT = 34, m$ = 36, v$ = H1("div")(({ theme: e }) => ({
  position: "relative",
  flex: `0 1 ${C$}px`,
  minWidth: 0,
  height: ET,
  backgroundColor: e.palette.background.paper,
  border: `1px solid ${e.palette.common.neutrals[200]}`,
  borderRadius: e.shape.borderRadius,
  "&:focus-within": { borderColor: e.palette.primary.main }
})), y$ = H1("div")(({ theme: e }) => ({
  position: "absolute",
  left: 10,
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex",
  color: e.palette.common.neutrals[700]
})), b$ = H1("div")({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  paddingLeft: TT,
  fontSize: 14,
  whiteSpace: "pre",
  overflow: "hidden",
  pointerEvents: "none"
}), w$ = H1("input", {
  shouldForwardProp: (e) => e !== "hasEndAdornment"
})(({ theme: e, hasEndAdornment: n }) => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  paddingLeft: TT,
  paddingRight: n ? m$ : e.spacing(1.25),
  border: 0,
  outline: 0,
  backgroundColor: "transparent",
  fontSize: 14,
  fontFamily: "inherit",
  color: e.palette.text.primary,
  "&::placeholder": { color: e.palette.text.secondary, opacity: 1 }
})), x$ = H1("div")({
  position: "absolute",
  right: 2,
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex"
}), Ve1 = ka(function({ overlay: n, endAdornment: i, sx: a, ...s }, g) {
  return /* @__PURE__ */ y.jsxs(v$, { sx: a, children: [
    /* @__PURE__ */ y.jsx(y$, { children: /* @__PURE__ */ y.jsx(Me, { icon: "search", sx: { fontSize: 16 } }) }),
    n != null && /* @__PURE__ */ y.jsx(b$, { "aria-hidden": !0, children: n }),
    /* @__PURE__ */ y.jsx(
      w$,
      {
        ref: g,
        hasEndAdornment: i != null,
        ...s
      }
    ),
    i != null && /* @__PURE__ */ y.jsx(x$, { children: i })
  ] });
}), _e1 = ({
  children: e,
  action: n,
  component: i = "div",
  singleRow: a = !1,
  "aria-label": s,
  sx: g = []
}) => /* @__PURE__ */ y.jsxs(
  F1,
  {
    component: i,
    "aria-label": s,
    sx: [
      {
        display: "flex",
        flex: "1 1 0",
        minWidth: 240,
        minHeight: ET,
        flexWrap: "wrap",
        alignItems: "center",
        // Rows pack from the top, the first one centred on the search box: its 32px chips sit
        // 1px into the 34px box height, level with the Filter pill.
        alignContent: "flex-start",
        gap: 1,
        m: 0,
        px: 0,
        py: "1px",
        listStyle: "none",
        // Chip groups render a wrapper span; lay their chips out as items of this row.
        "& > span": { display: "contents" }
      },
      a && {
        flex: "0 1 auto",
        minWidth: 0,
        flexWrap: "nowrap",
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" }
      },
      ...Array.isArray(g) ? g : [g]
    ],
    children: [
      e,
      n
    ]
  }
), Je1 = ({
  labelKey: e,
  labelValue: n,
  onDelete: i
}) => /* @__PURE__ */ y.jsx(
  I$,
  {
    label: `${e}: ${n}`,
    onDelete: i,
    deleteIcon: /* @__PURE__ */ y.jsx(Me, { icon: "close", titleAccess: `Remove ${e}: ${n}` })
  }
), $x = H1("span")(({ theme: e }) => ({
  ...Go(e, "caption"),
  minWidth: 20,
  padding: e.spacing(0, 0.75),
  borderRadius: e.shape.borderRadius * 10,
  textAlign: "center",
  fontVariantNumeric: "tabular-nums",
  color: e.palette.info.contrastText,
  backgroundColor: e.palette.info.main
})), S$ = H1("label")(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1.25),
  padding: e.spacing(1.25, 2),
  cursor: "pointer",
  '&:hover:not([data-disabled="true"])': {
    backgroundColor: Pm(e)
  },
  '&[data-disabled="true"]': {
    cursor: "default",
    color: e.palette.text.disabled
  }
})), E$ = H1("span")(({ theme: e }) => ({
  width: 28,
  height: 28,
  flexShrink: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: e.palette.action.selected,
  color: e.palette.text.secondary,
  ...Go(e, "caption")
})), eS = H1("div")(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.75),
  padding: e.spacing(1.25, 2, 0.5),
  ...Go(e, "caption"),
  textTransform: "uppercase",
  color: e.palette.text.secondary
})), CA = 1, M$ = H1(F1)(({ theme: e }) => ({
  position: "sticky",
  top: e.spacing(-CA),
  zIndex: 1,
  marginTop: e.spacing(-CA),
  backgroundColor: e.palette.background.paper,
  padding: e.spacing(0.5 + CA, 2, 1)
})), zh = {
  "& .MuiOutlinedInput-root": {
    height: 32,
    pl: 1.25,
    borderRadius: 1,
    fontSize: (e) => e.typography.pxToRem(14)
  },
  // Outranks the theme's `.MuiInputBase-input.MuiOutlinedInput-input` padding.
  "& .MuiInputBase-input.MuiOutlinedInput-input": { p: 0 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "common.neutrals.200"
  },
  "& input::placeholder": { color: "text.secondary", opacity: 1 }
}, tS = 16, A6 = H1("span")(({ theme: e }) => ({
  width: tS,
  height: tS,
  boxSizing: "border-box",
  display: "grid",
  placeItems: "center",
  ".Mui-disabled &": { opacity: 0.5 },
  color: e.palette.common.white
})), T$ = H1(A6)(({ theme: e }) => ({
  borderRadius: e.shape.borderRadius,
  border: `1.5px solid ${e.palette.common.neutrals[600]}`
})), L$ = H1(A6)(({ theme: e }) => ({
  borderRadius: e.shape.borderRadius,
  backgroundColor: e.palette.secondary.main,
  fontSize: 10
})), R$ = H1(A6)(({ theme: e }) => ({
  borderRadius: "50%",
  border: `1.5px solid ${e.palette.common.neutrals[600]}`
})), O$ = H1(A6)(({ theme: e }) => ({
  borderRadius: "50%",
  border: `2px solid ${e.palette.secondary.main}`,
  "&::after": {
    content: '""',
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: e.palette.secondary.main
  }
})), D$ = H1("div")(({ theme: e }) => ({
  padding: e.spacing(1.5, 2),
  ...Go(e, "body1"),
  color: e.palette.text.secondary
}));
function k$({
  control: e,
  name: n,
  label: i,
  checked: a,
  onChange: s,
  disabled: g = !1,
  secondary: c,
  initials: I,
  title: h,
  describedBy: m
}) {
  const w = e === "radio" ? Qj : AA;
  return /* @__PURE__ */ y.jsxs(S$, { "data-disabled": g, title: h, children: [
    I && /* @__PURE__ */ y.jsx(E$, { "aria-hidden": !0, children: I }),
    /* @__PURE__ */ y.jsxs(F1, { sx: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }, children: [
      /* @__PURE__ */ y.jsx(
        ne,
        {
          variant: "body1",
          noWrap: !0,
          color: "inherit",
          sx: (S) => ({ ...Go(S, "body1"), fontWeight: 600 }),
          children: i
        }
      ),
      c && /* @__PURE__ */ y.jsx(
        ne,
        {
          variant: "caption",
          noWrap: !0,
          color: "text.secondary",
          sx: (S) => Go(S, "caption"),
          children: c
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx(
      w,
      {
        icon: e === "radio" ? /* @__PURE__ */ y.jsx(R$, {}) : /* @__PURE__ */ y.jsx(T$, {}),
        checkedIcon: e === "radio" ? /* @__PURE__ */ y.jsx(O$, {}) : /* @__PURE__ */ y.jsx(L$, { children: /* @__PURE__ */ y.jsx(Me, { icon: "check", fontSize: "inherit" }) }),
        sx: { p: 0 },
        name: n,
        checked: a,
        disabled: g,
        onChange: s,
        disableRipple: !0,
        inputProps: m ? { "aria-describedby": m } : void 0
      }
    )
  ] });
}
function j$({
  value: e,
  onChange: n,
  placeholder: i,
  label: a,
  onFocus: s,
  onClick: g
}) {
  return /* @__PURE__ */ y.jsx(M$, { children: /* @__PURE__ */ y.jsx(
    Uf,
    {
      size: "small",
      fullWidth: !0,
      sx: zh,
      value: e,
      onChange: (c) => n(c.target.value),
      onFocus: s,
      onClick: g,
      placeholder: i,
      inputProps: { "aria-label": a },
      InputProps: {
        startAdornment: /* @__PURE__ */ y.jsx(Bh, { position: "start", sx: { mr: 1 }, children: /* @__PURE__ */ y.jsx(
          Me,
          {
            icon: "search",
            sx: { fontSize: 14, color: "common.neutrals.700" }
          }
        ) })
      }
    }
  ) });
}
function Ke1({
  noun: e,
  searchLabel: n,
  options: i,
  selected: a,
  onToggle: s,
  header: g
}) {
  const [c, I] = qt(""), h = c.trim().toLowerCase(), m = i.filter(
    (w) => !h || w.label.toLowerCase().includes(h)
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      j$,
      {
        value: c,
        onChange: I,
        placeholder: `Search ${e}…`,
        label: n
      }
    ),
    g,
    m.map((w) => /* @__PURE__ */ y.jsx(
      k$,
      {
        control: "checkbox",
        label: w.label,
        checked: a.includes(w.value),
        onChange: () => s(w.value)
      },
      w.value
    )),
    m.length === 0 && /* @__PURE__ */ y.jsx(D$, { children: `No matches for '${c.trim()}'` })
  ] });
}
const nS = (e) => {
  switch (e) {
    case "maxDate":
      return 'Please select a date that is before the "to" date';
    case "minDate":
      return 'Please select a date that is after the "from" date';
    case "invalidDate":
      return "Please select a valid date";
    default:
      return "";
  }
};
function Ye1({
  from: e,
  to: n,
  onFromChange: i,
  onToChange: a,
  disableFuture: s,
  disabled: g
}) {
  const [c, I] = qt(null), [h, m] = qt(null), w = (S) => ({
    field: { clearable: !0 },
    textField: { helperText: S }
  });
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(eS, { children: "From" }),
    /* @__PURE__ */ y.jsx(F1, { sx: { px: 2, pb: 1 }, children: /* @__PURE__ */ y.jsx(
      yb,
      {
        disableFuture: s,
        disabled: g,
        maxDate: n ?? void 0,
        value: e,
        onChange: i,
        onError: I,
        sx: [zh, { width: "100%" }],
        slotProps: w(nS(c))
      }
    ) }),
    /* @__PURE__ */ y.jsx(eS, { children: "To" }),
    /* @__PURE__ */ y.jsx(F1, { sx: { px: 2, pb: 1 }, children: /* @__PURE__ */ y.jsx(
      yb,
      {
        disableFuture: s,
        disabled: g,
        minDate: e ?? void 0,
        value: n,
        onChange: a,
        onError: m,
        sx: [zh, { width: "100%" }],
        slotProps: w(nS(h))
      }
    ) })
  ] });
}
function Qe1({
  dialogLabel: e,
  categories: n,
  renderCategory: i,
  count: a = 0,
  footer: s,
  onOpenChange: g
}) {
  var D;
  const [c, I] = qt(null), [h, m] = qt(n[0].id), w = c != null, S = (k) => {
    I(k.currentTarget), g == null || g(!0);
  }, T = () => {
    I(null), g == null || g(!1);
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs(
      A$,
      {
        onClick: S,
        "aria-haspopup": "dialog",
        "aria-expanded": w,
        "aria-label": a > 0 ? `Filter, ${a} active` : "Filter",
        children: [
          "+ Filter",
          a > 0 && /* @__PURE__ */ y.jsx($x, { "aria-hidden": !0, sx: { ml: 0.5 }, children: a })
        ]
      }
    ),
    /* @__PURE__ */ y.jsxs(
      YX,
      {
        role: "dialog",
        "aria-label": e,
        open: w,
        anchorEl: c,
        onClose: T,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: -4, horizontal: "left" },
        elevation: 8,
        slotProps: {
          paper: {
            sx: {
              overflow: "hidden",
              width: 536,
              height: 400,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column"
            }
          }
        },
        children: [
          /* @__PURE__ */ y.jsxs(Ke, { direction: "row", sx: { flex: 1, minHeight: 0 }, children: [
            /* @__PURE__ */ y.jsx(
              F1,
              {
                sx: {
                  width: 190,
                  flexShrink: 0,
                  borderRight: 1,
                  borderColor: "divider"
                },
                children: /* @__PURE__ */ y.jsx(Xj, { "aria-label": "Filter categories", sx: { py: 0 }, children: n.map(({ id: k, label: z, count: N = 0 }) => {
                  const W = k === h;
                  return /* @__PURE__ */ y.jsx(gS, { disableGutters: !0, disablePadding: !0, children: /* @__PURE__ */ y.jsxs(
                    o$,
                    {
                      selected: W,
                      "aria-current": W ? "true" : void 0,
                      onClick: () => m(k),
                      disableRipple: !0,
                      sx: {
                        gap: 1,
                        py: 1.25,
                        px: 2,
                        color: W ? "text.primary" : "common.neutrals.700",
                        "&:hover": { bgcolor: Pm },
                        "&.Mui-selected, &.Mui-selected:hover": {
                          bgcolor: "common.neutrals.100"
                        }
                      },
                      children: [
                        /* @__PURE__ */ y.jsx(
                          fS,
                          {
                            primary: z,
                            sx: { my: 0 },
                            primaryTypographyProps: {
                              variant: "body1",
                              sx: (K) => ({
                                ...Go(K, "body1"),
                                fontWeight: W ? 600 : 400
                              })
                            }
                          }
                        ),
                        N > 0 && /* @__PURE__ */ y.jsx($x, { "aria-label": `${N} selected`, children: N })
                      ]
                    }
                  ) }, k);
                }) })
              }
            ),
            /* @__PURE__ */ y.jsx(
              F1,
              {
                role: "tabpanel",
                "aria-label": (D = n.find(({ id: k }) => k === h)) == null ? void 0 : D.label,
                sx: {
                  flex: 1,
                  minWidth: 0,
                  overflowY: "auto",
                  py: CA
                },
                children: i(h)
              }
            )
          ] }),
          /* @__PURE__ */ y.jsxs(
            Ke,
            {
              direction: "row",
              sx: {
                alignItems: "center",
                px: 2,
                py: 1.25,
                borderTop: 1,
                borderColor: "divider"
              },
              children: [
                s,
                /* @__PURE__ */ y.jsx(
                  k2,
                  {
                    variant: "contained",
                    onClick: T,
                    sx: {
                      ml: "auto",
                      px: 2.25,
                      borderRadius: 1,
                      py: 1,
                      lineHeight: 1.5,
                      fontFamily: (k) => k.typography.body1.fontFamily,
                      fontSize: (k) => k.typography.pxToRem(15),
                      fontWeight: 600
                    },
                    children: "Done"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}
const Xe1 = (e) => /* @__PURE__ */ y.jsx(Gj, { ...e, children: e.children }), Ge1 = H1(qj)(() => ({})), qe1 = H1(Zj)({
  maxHeight: 400
}), Ze1 = H1($j)(({ theme: e }) => ({
  "&:hover": {
    backgroundColor: e.palette.action.hover
  },
  "&.Mui-selected": {
    backgroundColor: e.palette.action.selected
  }
})), z$ = H1("div")(({ theme: e }) => ({
  width: 30,
  height: 6,
  backgroundColor: e.palette.common.neutrals[500],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)"
})), N$ = H1(F1)(({ theme: e }) => ({
  backgroundColor: e.palette.background.paper,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  visibility: "visible",
  right: 0,
  left: 0
})), LT = ({
  children: e,
  swipeable: n,
  ...i
}) => /* @__PURE__ */ y.jsxs(N$, { ...i, children: [
  n && /* @__PURE__ */ y.jsx(z$, {}),
  e
] }), RT = ({
  children: e,
  open: n,
  containerProps: i = {},
  ...a
}) => /* @__PURE__ */ y.jsx(
  ez,
  {
    PaperProps: { sx: { backgroundColor: "transparent" } },
    ...a,
    anchor: "bottom",
    open: n,
    children: /* @__PURE__ */ y.jsx(LT, { ...i, children: e })
  }
);
RT.displayName = "MobileBottomDrawer";
const P$ = ({
  children: e,
  open: n,
  onClose: i = () => {
  },
  containerProps: a = {},
  ...s
}) => /* @__PURE__ */ y.jsx(
  tz,
  {
    PaperProps: { sx: { backgroundColor: "transparent" } },
    ...s,
    anchor: "bottom",
    open: n,
    onClose: i,
    onOpen: () => {
    },
    disableSwipeToOpen: !0,
    disableDiscovery: !0,
    children: /* @__PURE__ */ y.jsx(LT, { ...a, swipeable: !0, children: e })
  }
);
P$.displayName = "SwipeableMobileBottomDrawer";
const F$ = ({
  open: e,
  cancelLabel: n = "Cancel",
  onCancel: i,
  confirmLabel: a = "Confirm",
  onConfirm: s,
  title: g,
  type: c = "default",
  children: I,
  titleProps: h = {},
  contentProps: m = {},
  stackProps: w = {},
  cancelBtnProps: S = {},
  confirmBtnProps: T = {}
}) => /* @__PURE__ */ y.jsx(
  RT,
  {
    open: e,
    sx: (D) => ({ zIndex: D.zIndex.modal + 1 }),
    children: /* @__PURE__ */ y.jsxs(Ke, { p: 2, gap: 2, alignItems: "center", ...w, children: [
      g && /* @__PURE__ */ y.jsx(gT, { ...h, type: c, children: g }),
      typeof I == "string" ? /* @__PURE__ */ y.jsx(
        ne,
        {
          variant: "body1",
          color: (D) => D.palette.text.primary,
          ...m,
          children: I
        }
      ) : I,
      i && /* @__PURE__ */ y.jsx(
        k2,
        {
          variant: "outlined",
          fullWidth: !0,
          ...S,
          onClick: i,
          children: n
        }
      ),
      s && /* @__PURE__ */ y.jsx(
        k2,
        {
          variant: "contained",
          fullWidth: !0,
          color: c !== "default" ? c : void 0,
          ...T,
          onClick: s,
          children: a
        }
      )
    ] })
  }
);
F$.displayName = "MobileConfirmationDrawer";
const Nh = "slidingViewsTransitionType", $e1 = (e) => ({ [Nh]: e }), OT = () => {
  const e = yS();
  return V2(() => {
    var i;
    switch ((i = e.state) == null ? void 0 : i[Nh]) {
      case "slide-in":
      case "slide-out":
        return e.state[Nh];
      default:
        return;
    }
  }, [e.state]);
}, et1 = ({ children: e }) => {
  const n = OT();
  return /* @__PURE__ */ y.jsx(Az, { initial: !1, custom: n, children: e });
}, tt1 = ({ children: e, ...n }) => {
  const i = Da(), a = OT();
  return /* @__PURE__ */ y.jsx(
    Iz.div,
    {
      style: {
        backgroundColor: i.palette.background.default,
        boxShadow: i.shadows[10],
        ...n.style || {},
        flex: 1,
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      },
      transition: { duration: 0.3 },
      ...n,
      custom: a,
      variants: {
        initial: (s) => ({
          x: s === "slide-out" ? "-50%" : "100%",
          zIndex: s === "slide-out" ? i.zIndex.slidingViews - 1 : i.zIndex.slidingViews + 1,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }),
        target: (s) => ({
          x: "0%",
          zIndex: s === "slide-out" ? i.zIndex.slidingViews - 1 : i.zIndex.slidingViews + 1,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          transitionEnd: {
            position: "relative",
            zIndex: i.zIndex.slidingViews
          }
        }),
        exit: (s) => ({
          x: s === "slide-out" ? "100%" : "-50%"
        })
      },
      initial: "initial",
      animate: "target",
      exit: "exit",
      children: e
    }
  );
}, B$ = ({
  targetId: e,
  children: n,
  fullWidth: i = !1,
  showHighlight: a = !0
}) => /* @__PURE__ */ y.jsx(
  F1,
  {
    "data-guided-file-rename-target": e,
    tabIndex: -1,
    sx: {
      flex: i ? 1 : void 0,
      minWidth: 0,
      borderRadius: 1,
      outline: a ? "2px solid transparent" : "none",
      outlineOffset: 3,
      transition: "outline-color 180ms ease",
      ...a && {
        '&:focus, &[data-guided-highlight="true"]': {
          outlineColor: "primary.main"
        }
      }
    },
    children: n
  }
), nt1 = ({
  targetId: e,
  label: n,
  showHighlight: i = !0,
  fullWidth: a = !0,
  revealOnHover: s = !1,
  revealTriggerRef: g,
  revealWithinWidth: c
}) => /* @__PURE__ */ y.jsx(
  B$,
  {
    targetId: e,
    fullWidth: a,
    showHighlight: i,
    children: /* @__PURE__ */ y.jsx(
      jM,
      {
        variant: "body2",
        revealOnHover: s,
        revealTriggerRef: g,
        revealWithinWidth: c,
        sx: { flex: 1, minWidth: 0, fontWeight: 400 },
        children: n
      }
    )
  }
), rt1 = ka(
  ({
    open: e,
    originalName: n,
    suggestedName: i,
    foundInDocumentLabels: a,
    onDismiss: s,
    onComplete: g,
    showBackdrop: c = !0,
    completeLabel: I = "Show me where to accept"
  }, h) => /* @__PURE__ */ y.jsxs(
    hl,
    {
      open: e,
      onClose: s,
      maxWidth: !1,
      "aria-labelledby": "guided-file-rename-title",
      "aria-describedby": "guided-file-rename-description",
      BackdropProps: {
        sx: {
          opacity: c ? 1 : 0,
          backgroundColor: "rgba(33, 43, 54, 0.55)",
          transition: "opacity 0.25s ease"
        }
      },
      PaperProps: {
        sx: {
          width: "min(780px, calc(100vw - 32px))",
          maxWidth: "none",
          borderRadius: 2.5,
          overflow: "visible",
          boxShadow: "0 24px 48px rgba(33, 43, 54, 0.18)"
        }
      },
      children: [
        /* @__PURE__ */ y.jsxs(Ei, { sx: { px: 4, pt: 4.5, pb: 3 }, children: [
          /* @__PURE__ */ y.jsxs(Ke, { alignItems: "center", spacing: 2, textAlign: "center", sx: { mb: 4 }, children: [
            /* @__PURE__ */ y.jsx(
              F1,
              {
                sx: {
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "linear-gradient(135deg, #eef6ff 0%, #f5efff 100%)",
                  border: "1px solid #d8e7fa",
                  boxShadow: "0 4px 16px rgba(25, 118, 210, 0.1)"
                },
                children: /* @__PURE__ */ y.jsx(Me, { icon: "sparkles", color: "primary", sx: { fontSize: 40 } })
              }
            ),
            /* @__PURE__ */ y.jsx(
              ne,
              {
                id: "guided-file-rename-title",
                variant: "h5",
                component: "h2",
                fontWeight: 700,
                children: "Liscio found a better file name"
              }
            ),
            /* @__PURE__ */ y.jsx(
              ne,
              {
                id: "guided-file-rename-description",
                variant: "body1",
                color: "text.secondary",
                sx: { maxWidth: 520, lineHeight: 1.55 },
                children: "We read the document and suggested a clearer name so your files stay organized."
              }
            )
          ] }),
          /* @__PURE__ */ y.jsx(
            F1,
            {
              sx: {
                p: 2.5,
                borderRadius: 2,
                bgcolor: "common.neutrals.100",
                border: 1,
                borderColor: "divider"
              },
              children: /* @__PURE__ */ y.jsxs(Ke, { direction: "row", alignItems: "stretch", spacing: 1.5, sx: { minHeight: 88 }, children: [
                /* @__PURE__ */ y.jsxs(
                  F1,
                  {
                    sx: {
                      flex: 1,
                      minWidth: 0,
                      px: 2,
                      py: 2,
                      borderRadius: 1.5,
                      border: 1,
                      borderColor: "divider",
                      bgcolor: "common.white"
                    },
                    children: [
                      /* @__PURE__ */ y.jsx(ne, { variant: "overline", color: "text.disabled", display: "block", children: "Original file name" }),
                      /* @__PURE__ */ y.jsx(ne, { variant: "body1", color: "text.secondary", sx: { wordBreak: "break-word" }, children: n })
                    ]
                  }
                ),
                /* @__PURE__ */ y.jsx(Ke, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ y.jsx(Me, { icon: "arrowRight", color: "primary" }) }),
                /* @__PURE__ */ y.jsxs(
                  F1,
                  {
                    ref: h,
                    sx: {
                      flex: 1.15,
                      minWidth: 0,
                      px: 2.5,
                      py: 2.25,
                      borderRadius: 1.5,
                      border: 2,
                      borderColor: "primary.main",
                      bgcolor: "primary.lighter",
                      boxShadow: "0 2px 12px rgba(25, 118, 210, 0.12)"
                    },
                    children: [
                      /* @__PURE__ */ y.jsx(ne, { variant: "overline", color: "primary", display: "block", children: "Suggested file name" }),
                      /* @__PURE__ */ y.jsx(ne, { variant: "h6", component: "p", fontWeight: 700, sx: { wordBreak: "break-word" }, children: i })
                    ]
                  }
                )
              ] })
            }
          ),
          a.length > 0 && /* @__PURE__ */ y.jsxs(F1, { sx: { mt: 3.5, pt: 2.5, borderTop: 1, borderColor: "divider" }, children: [
            /* @__PURE__ */ y.jsx(ne, { variant: "subtitle2", fontWeight: 600, sx: { mb: 1.75 }, children: "Liscio found in this document" }),
            /* @__PURE__ */ y.jsx(Ke, { direction: "row", flexWrap: "wrap", gap: 1.25, children: a.map((m) => /* @__PURE__ */ y.jsx(
              F1,
              {
                component: "span",
                sx: {
                  px: 1.75,
                  py: 0.875,
                  borderRadius: 999,
                  fontSize: "0.9375rem",
                  border: 1,
                  borderColor: "divider",
                  bgcolor: "common.white"
                },
                children: m
              },
              m
            )) })
          ] })
        ] }),
        /* @__PURE__ */ y.jsxs(Nc, { sx: { px: 4, pb: 4, justifyContent: "space-between" }, children: [
          /* @__PURE__ */ y.jsx(Dr, { color: "inherit", onClick: s, children: "Maybe later" }),
          /* @__PURE__ */ y.jsx(Dr, { variant: "contained", size: "large", onClick: g, children: I })
        ] })
      ]
    }
  )
), it1 = ({
  label: e,
  top: n,
  left: i,
  width: a,
  height: s,
  opacity: g,
  transition: c
}) => /* @__PURE__ */ y.jsx(
  F1,
  {
    "aria-hidden": !0,
    sx: {
      position: "fixed",
      zIndex: 1400,
      top: n,
      left: i,
      width: a,
      height: s,
      opacity: g,
      transition: c,
      pointerEvents: "none",
      px: 2.5,
      py: 2,
      borderRadius: 1.5,
      border: 2,
      borderColor: "primary.main",
      bgcolor: "primary.lighter",
      boxShadow: "0 8px 24px rgba(25, 118, 210, 0.2)",
      display: "flex",
      alignItems: "center",
      overflow: "hidden"
    },
    children: /* @__PURE__ */ y.jsx(F1, { component: "span", sx: { fontWeight: 700, fontSize: "1.0625rem", wordBreak: "break-word" }, children: e })
  }
), at1 = ({
  accept: e,
  disabled: n = !1,
  onFileSelected: i
}) => {
  const a = yn(null), [s, g] = qt(!1), c = (w) => {
    w && !n && i(w);
  }, I = (w) => {
    var S;
    c((S = w.target.files) == null ? void 0 : S[0]), w.target.value = "";
  }, h = (w) => {
    var S;
    w.preventDefault(), g(!1), c((S = w.dataTransfer.files) == null ? void 0 : S[0]);
  }, m = (w) => {
    var S;
    w.key !== "Enter" && w.key !== " " || (w.preventDefault(), (S = a.current) == null || S.click());
  };
  return /* @__PURE__ */ y.jsxs(
    F1,
    {
      component: "label",
      role: "button",
      tabIndex: n ? -1 : 0,
      "aria-disabled": n,
      onKeyDown: m,
      onDragEnter: (w) => {
        w.preventDefault(), n || g(!0);
      },
      onDragOver: (w) => w.preventDefault(),
      onDragLeave: (w) => {
        w.currentTarget.contains(w.relatedTarget) || g(!1);
      },
      onDrop: h,
      sx: {
        display: "grid",
        placeItems: "center",
        minHeight: 118,
        px: 2,
        py: 3,
        mb: 2.25,
        border: "1.5px dashed",
        borderColor: s ? "primary.main" : "grey.300",
        borderRadius: 1.5,
        bgcolor: s ? "primary.50" : "grey.50",
        cursor: n ? "default" : "pointer",
        textAlign: "center",
        transition: "border-color 120ms ease, background-color 120ms ease",
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: 2
        }
      },
      children: [
        /* @__PURE__ */ y.jsx(
          "input",
          {
            ref: a,
            type: "file",
            accept: e,
            "aria-label": "Upload a file",
            disabled: n,
            hidden: !0,
            onChange: I
          }
        ),
        /* @__PURE__ */ y.jsxs(Ke, { alignItems: "center", gap: 0.75, children: [
          /* @__PURE__ */ y.jsx(Me, { icon: "upload", sx: { fontSize: 26, color: "primary.main" } }),
          /* @__PURE__ */ y.jsxs(ne, { variant: "body2", fontWeight: 600, color: "primary.dark", children: [
            "Drag & drop a file, or",
            " ",
            /* @__PURE__ */ y.jsx(F1, { component: "span", sx: { textDecoration: "underline" }, children: "browse" })
          ] })
        ] })
      ]
    }
  );
}, ZC = ({
  label: e,
  onClick: n
}) => /* @__PURE__ */ y.jsx(
  Dr,
  {
    color: "inherit",
    fullWidth: !0,
    onClick: n,
    endIcon: /* @__PURE__ */ y.jsx(Me, { icon: "chevronRight" }),
    sx: {
      justifyContent: "space-between",
      px: 0.25,
      py: 1.5,
      borderBottom: 1,
      borderColor: "divider",
      borderRadius: 0,
      fontSize: 15,
      fontWeight: 400,
      textTransform: "none",
      "&:last-of-type": { borderBottom: 0 }
    },
    children: e
  }
), ot1 = ({
  open: e,
  state: n,
  uploadContent: i,
  samples: a,
  activeSampleId: s,
  samplesDisabled: g = !1,
  uploadError: c,
  result: I,
  onClose: h,
  onSample: m,
  onTryAnother: w,
  onOpenFolder: S,
  onOpenTemplate: T,
  onSend: D
}) => /* @__PURE__ */ y.jsxs(
  hl,
  {
    open: e,
    onClose: h,
    maxWidth: !1,
    PaperProps: {
      "aria-label": "File Intelligence",
      sx: {
        width: n === "result" ? "min(720px, calc(100% - 32px))" : "min(520px, calc(100% - 32px))",
        maxHeight: "86vh",
        borderRadius: 1.5,
        boxShadow: 24
      }
    },
    children: [
      /* @__PURE__ */ y.jsx(
        F1,
        {
          component: "header",
          sx: { px: 2.75, py: 2.5, borderBottom: 1, borderColor: "divider" },
          children: /* @__PURE__ */ y.jsxs(Ke, { direction: "row", alignItems: "center", gap: 1.5, children: [
            /* @__PURE__ */ y.jsxs(
              F1,
              {
                sx: {
                  position: "relative",
                  display: "grid",
                  placeItems: "center",
                  width: 36,
                  height: 36,
                  flexShrink: 0,
                  borderRadius: 1.25,
                  bgcolor: "primary.50",
                  color: "primary.main"
                },
                children: [
                  /* @__PURE__ */ y.jsx(Me, { icon: "fileLines", sx: { fontSize: 19 } }),
                  /* @__PURE__ */ y.jsx(
                    Me,
                    {
                      icon: "check",
                      sx: {
                        position: "absolute",
                        right: 4,
                        bottom: 4,
                        fontSize: 10,
                        strokeWidth: 2
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ y.jsxs(F1, { sx: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ y.jsx(
                ne,
                {
                  variant: "h6",
                  component: "h2",
                  fontWeight: 600,
                  sx: { fontSize: 17, lineHeight: 1.35 },
                  children: "File Intelligence"
                }
              ),
              /* @__PURE__ */ y.jsx(
                ne,
                {
                  variant: "caption",
                  color: "text.secondary",
                  sx: { display: "block" },
                  children: "Reads, classifies, and renames accounting documents in seconds."
                }
              )
            ] }),
            /* @__PURE__ */ y.jsx(xc, { size: "small", onClick: h, "aria-label": "Close", children: /* @__PURE__ */ y.jsx(Me, { icon: "close" }) })
          ] })
        }
      ),
      n === "upload" && /* @__PURE__ */ y.jsxs(Ei, { sx: { p: 2.75 }, children: [
        c && /* @__PURE__ */ y.jsx(dl, { severity: "error", sx: { mb: 2 }, children: c }),
        i,
        a.length > 0 && /* @__PURE__ */ y.jsx(
          ne,
          {
            variant: "caption",
            color: "text.secondary",
            fontWeight: 600,
            sx: { display: "block", mb: 1 },
            children: "Or try a sample:"
          }
        ),
        /* @__PURE__ */ y.jsx(Ke, { gap: 1, children: a.map((k) => /* @__PURE__ */ y.jsxs(
          Dr,
          {
            variant: "outlined",
            onClick: () => m(k.id),
            disabled: g || !!s,
            "aria-label": `${k.title}, ${k.detectedType}`,
            sx: {
              minHeight: 42,
              justifyContent: "space-between",
              px: 1.5,
              py: 1.25,
              borderRadius: 1,
              borderColor: "divider",
              bgcolor: "common.white",
              textAlign: "left",
              textTransform: "none"
            },
            children: [
              /* @__PURE__ */ y.jsx(ne, { variant: "body2", color: "text.primary", fontWeight: 400, children: k.title }),
              s === k.id ? /* @__PURE__ */ y.jsx(ji, { size: 18 }) : /* @__PURE__ */ y.jsx(ne, { variant: "caption", color: "text.secondary", children: k.detectedType })
            ]
          },
          k.id
        )) })
      ] }),
      (n === "uploading" || n === "processing") && /* @__PURE__ */ y.jsx(
        Ei,
        {
          sx: { display: "grid", placeItems: "center", minHeight: 300 },
          children: /* @__PURE__ */ y.jsxs(Ke, { alignItems: "center", gap: 2.5, children: [
            /* @__PURE__ */ y.jsx(ji, { size: 52, thickness: 3 }),
            /* @__PURE__ */ y.jsx(ne, { color: "text.secondary", fontSize: 18, children: "Reading your document…" })
          ] })
        }
      ),
      (n === "no-name" || n === "failed") && /* @__PURE__ */ y.jsx(Ei, { children: /* @__PURE__ */ y.jsxs(dl, { severity: n === "no-name" ? "warning" : "error", children: [
        /* @__PURE__ */ y.jsx(ne, { fontWeight: 600, children: n === "no-name" ? "No file name to suggest" : "Processing failed" }),
        /* @__PURE__ */ y.jsx(ne, { variant: "body2", sx: { mt: 1 }, children: n === "no-name" ? "Your file does not look like a supported document for naming. Try another file to continue." : "Your file could not be analyzed. Try another file to continue." }),
        /* @__PURE__ */ y.jsx(
          Dr,
          {
            variant: "outlined",
            color: "inherit",
            size: "small",
            onClick: w,
            sx: { mt: 2 },
            children: "Try another file"
          }
        )
      ] }) }),
      n === "result" && I && /* @__PURE__ */ y.jsxs(Ei, { sx: { px: 3.5, py: 3 }, children: [
        /* @__PURE__ */ y.jsxs(
          Ke,
          {
            direction: "row",
            alignItems: "center",
            gap: 1,
            sx: { mb: 2.5, color: "success.main" },
            children: [
              /* @__PURE__ */ y.jsx(Me, { icon: "check", sx: { fontSize: 18 } }),
              /* @__PURE__ */ y.jsx(
                ne,
                {
                  variant: "caption",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: "text.secondary",
                  children: "RENAMED AND FILED"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(
          ne,
          {
            component: "p",
            fontFamily: "monospace",
            fontSize: 22,
            fontWeight: 700,
            sx: { mb: 2 },
            children: I.suggestedName
          }
        ),
        /* @__PURE__ */ y.jsxs(Ke, { gap: 1, sx: { mb: 2.5 }, children: [
          /* @__PURE__ */ y.jsxs(Ke, { direction: "row", gap: 2, children: [
            /* @__PURE__ */ y.jsx(ne, { color: "text.secondary", sx: { width: 72 }, children: "Original" }),
            /* @__PURE__ */ y.jsx(ne, { color: "text.secondary", children: I.originalName })
          ] }),
          /* @__PURE__ */ y.jsxs(Ke, { direction: "row", gap: 2, children: [
            /* @__PURE__ */ y.jsx(ne, { color: "text.secondary", sx: { width: 72 }, children: "Filed to" }),
            /* @__PURE__ */ y.jsx(ne, { color: "text.secondary", children: I.filedLocation })
          ] })
        ] }),
        /* @__PURE__ */ y.jsxs(Ke, { sx: { borderTop: 1, borderColor: "divider" }, children: [
          /* @__PURE__ */ y.jsx(ZC, { label: "Open the folder", onClick: S }),
          /* @__PURE__ */ y.jsx(
            ZC,
            {
              label: "Change the naming template",
              onClick: T
            }
          ),
          D && /* @__PURE__ */ y.jsx(ZC, { label: "Send to a client or teammate", onClick: D }),
          /* @__PURE__ */ y.jsx(ZC, { label: "Name another file", onClick: w })
        ] })
      ] })
    ]
  }
), H$ = ({
  open: e,
  title: n,
  content: i,
  confirmLabel: a = "OK",
  cancelLabel: s = "Cancel",
  disabled: g,
  onConfirm: c,
  onCancel: I,
  isLoading: h,
  confirmColor: m,
  confirmBtnProps: w = {},
  cancelBtnProps: S = {}
}) => /* @__PURE__ */ y.jsxs(
  hl,
  {
    onClick: rA,
    open: e,
    onClose: I,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [
      /* @__PURE__ */ y.jsx(BA, { id: "alert-dialog-title", children: n }),
      /* @__PURE__ */ y.jsx(Ei, { children: /* @__PURE__ */ y.jsx(IS, { id: "alert-dialog-description", children: i }) }),
      /* @__PURE__ */ y.jsxs(Nc, { children: [
        I && /* @__PURE__ */ y.jsx(k2, { ...S, onClick: I, disabled: g, children: s }),
        /* @__PURE__ */ y.jsx(
          k2,
          {
            autoFocus: !0,
            color: m,
            disabled: g,
            "data-testid": "dialog-confirm",
            variant: "contained",
            ...w,
            onClick: c,
            children: a
          }
        )
      ] }),
      /* @__PURE__ */ y.jsx(kM, { open: !!h })
    ]
  }
), rS = [
  { value: " ", label: "Space", display: " " },
  { value: "-", label: "Dash", display: "–" },
  { value: "_", label: "Underscore", display: "_" },
  { value: ".", label: "Period", display: "." }
], j7 = "application/x-liscio-naming-token", st1 = ({
  open: e,
  loading: n = !1,
  saving: i = !1,
  dirty: a,
  canRetrySave: s = !1,
  tokens: g,
  options: c,
  separators: I,
  detectedFields: h,
  originalName: m,
  previewName: w,
  error: S,
  onClose: T,
  onReset: D,
  onAdd: k,
  onRemove: z,
  onReorder: N,
  onFormatChange: W,
  onSeparatorChange: K,
  onSave: V
}) => {
  const [Y, H] = qt(null), [Z, Q] = qt(null), [P1, Y1] = qt(!1), O1 = () => {
    if (!i) {
      if (a) {
        Y1(!0);
        return;
      }
      T();
    }
  }, T1 = (s1, d1, h1) => {
    H({
      anchor: s1.currentTarget,
      options: d1.formatOptions,
      tokenIndex: h1
    });
  }, J1 = (s1, d1) => {
    if (!d1.formatOptions.length) {
      k(d1.value);
      return;
    }
    H({
      anchor: s1.currentTarget,
      options: d1.formatOptions,
      variable: d1.value
    });
  };
  return /* @__PURE__ */ y.jsxs(
    hl,
    {
      open: e,
      onClose: O1,
      maxWidth: "md",
      fullWidth: !0,
      sx: { "& .MuiDialog-container": { alignItems: "flex-start", pt: "8vh" } },
      PaperProps: {
        "aria-label": "File naming pattern",
        sx: { borderRadius: 1, overflow: "hidden", maxHeight: "84vh" }
      },
      children: [
        /* @__PURE__ */ y.jsx(
          F1,
          {
            sx: {
              bgcolor: "#f4f6fa",
              px: 3,
              py: 1.5,
              borderBottom: "1px solid #e4e9f0"
            },
            children: /* @__PURE__ */ y.jsxs(Ke, { direction: "row", alignItems: "center", gap: 1.5, children: [
              /* @__PURE__ */ y.jsx(
                F1,
                {
                  sx: {
                    display: "grid",
                    placeItems: "center",
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    borderRadius: 1,
                    bgcolor: "#e7eefc",
                    color: "#3366cc"
                  },
                  children: /* @__PURE__ */ y.jsx(Me, { icon: "sparkles", sx: { fontSize: 22 } })
                }
              ),
              /* @__PURE__ */ y.jsxs(
                Ke,
                {
                  direction: "row",
                  alignItems: "center",
                  gap: 1.5,
                  flexWrap: "wrap",
                  sx: { flex: 1, minWidth: 0 },
                  children: [
                    /* @__PURE__ */ y.jsx(
                      ne,
                      {
                        component: "h2",
                        variant: "h6",
                        fontWeight: 600,
                        fontSize: 18,
                        children: "File naming pattern"
                      }
                    ),
                    /* @__PURE__ */ y.jsxs(
                      Ke,
                      {
                        direction: "row",
                        alignItems: "center",
                        gap: 0.5,
                        sx: {
                          px: 1,
                          py: 0.25,
                          border: "1px solid #dbe2f2",
                          borderRadius: 0.75,
                          bgcolor: "#eef2fb",
                          color: "#4759a8"
                        },
                        children: [
                          /* @__PURE__ */ y.jsx(Me, { icon: "userGroup", sx: { fontSize: 14 } }),
                          /* @__PURE__ */ y.jsx(ne, { fontSize: 12, fontWeight: 600, children: "Firm-wide setting" })
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ y.jsx(
                xc,
                {
                  "aria-label": "Close",
                  onClick: O1,
                  disabled: i,
                  children: /* @__PURE__ */ y.jsx(Me, { icon: "close" })
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ y.jsx(Ei, { sx: { px: 3, py: 3.5 }, children: n ? /* @__PURE__ */ y.jsx(Ke, { alignItems: "center", py: 6, children: /* @__PURE__ */ y.jsx(ji, { size: 28 }) }) : /* @__PURE__ */ y.jsxs(Ke, { gap: 3, children: [
          S && /* @__PURE__ */ y.jsx(dl, { severity: "error", children: S }),
          /* @__PURE__ */ y.jsxs(F1, { children: [
            /* @__PURE__ */ y.jsx(ne, { fontWeight: 600, children: "Naming pattern" }),
            /* @__PURE__ */ y.jsx(
              ne,
              {
                variant: "body2",
                color: "text.secondary",
                sx: { mt: 0.5, mb: 1.75 },
                children: "Arrange the fields once. Liscio will use this structure for future file name suggestions."
              }
            ),
            /* @__PURE__ */ y.jsxs(
              F1,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minHeight: 44,
                  px: 1.5,
                  py: 1.25,
                  border: `1px solid ${a ? "#90caf9" : "#dfe3ea"}`,
                  borderRadius: 1,
                  bgcolor: a ? "#fafcff" : "#fafbfc"
                },
                children: [
                  /* @__PURE__ */ y.jsx(
                    F1,
                    {
                      sx: {
                        display: "flex",
                        flex: 1,
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 0.75
                      },
                      children: g.length ? g.map((s1, d1) => {
                        var h1;
                        return /* @__PURE__ */ y.jsxs(oz, { children: [
                          /* @__PURE__ */ y.jsxs(
                            F1,
                            {
                              draggable: !i,
                              onDragStart: (C1) => C1.dataTransfer.setData(
                                j7,
                                String(d1)
                              ),
                              onDragOver: (C1) => {
                                C1.preventDefault(), (i || !C1.dataTransfer.types.includes(j7)) && (C1.dataTransfer.dropEffect = "none");
                              },
                              onDrop: (C1) => {
                                C1.preventDefault();
                                const L1 = C1.dataTransfer.getData(j7);
                                i || !/^\d+$/.test(L1) || N(Number(L1), d1);
                              },
                              sx: {
                                position: "relative",
                                "&:hover .remove-field, &:focus-within .remove-field": { opacity: 1 },
                                "@media (hover: none)": {
                                  "& .remove-field": { opacity: 1 }
                                }
                              },
                              children: [
                                /* @__PURE__ */ y.jsx(
                                  fl,
                                  {
                                    label: `${s1.label}${s1.formatOptions.length ? " ▾" : ""}`,
                                    variant: "outlined",
                                    disabled: i,
                                    onClick: s1.formatOptions.length ? (C1) => T1(C1, s1, d1) : void 0,
                                    sx: {
                                      height: 30,
                                      borderRadius: 0.75,
                                      bgcolor: "common.white",
                                      cursor: "grab"
                                    }
                                  }
                                ),
                                /* @__PURE__ */ y.jsx(
                                  xc,
                                  {
                                    className: "remove-field",
                                    "aria-label": `Remove ${s1.label}`,
                                    disabled: i,
                                    onClick: () => z(d1),
                                    sx: {
                                      position: "absolute",
                                      top: -7,
                                      right: -7,
                                      width: 18,
                                      height: 18,
                                      p: 0,
                                      opacity: 0,
                                      bgcolor: "grey.500",
                                      color: "common.white",
                                      "&:hover": { bgcolor: "grey.700" }
                                    },
                                    children: /* @__PURE__ */ y.jsx(Me, { icon: "close", sx: { fontSize: 10 } })
                                  }
                                )
                              ]
                            }
                          ),
                          d1 < g.length - 1 && /* @__PURE__ */ y.jsx(
                            F1,
                            {
                              component: "button",
                              type: "button",
                              "aria-label": `Separator after ${s1.label}`,
                              disabled: i,
                              onClick: (C1) => Q({
                                anchor: C1.currentTarget,
                                index: d1
                              }),
                              sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 20,
                                height: 24,
                                px: 0.5,
                                border: "1px dashed #c4c9d0",
                                borderRadius: 0.5,
                                bgcolor: "transparent",
                                color: "text.secondary",
                                fontFamily: "monospace",
                                cursor: "pointer"
                              },
                              children: ((h1 = rS.find(
                                (C1) => C1.value === (I[d1] ?? " ")
                              )) == null ? void 0 : h1.display) ?? I[d1]
                            }
                          )
                        ] }, s1.id);
                      }) : /* @__PURE__ */ y.jsx(ne, { variant: "body2", color: "text.secondary", children: "Click a field below to start building your template" })
                    }
                  ),
                  a && /* @__PURE__ */ y.jsx(
                    xc,
                    {
                      "aria-label": "Reset template",
                      onClick: D,
                      disabled: i,
                      children: /* @__PURE__ */ y.jsx(Me, { icon: "arrowRotateRightDuotone" })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ y.jsxs(F1, { sx: { mt: 2 }, children: [
              /* @__PURE__ */ y.jsx(
                ne,
                {
                  variant: "body2",
                  color: "text.secondary",
                  fontWeight: 600,
                  sx: { mb: 1 },
                  children: "Available fields"
                }
              ),
              /* @__PURE__ */ y.jsx(F1, { sx: { display: "flex", flexWrap: "wrap", gap: 0.75 }, children: c.map((s1) => /* @__PURE__ */ y.jsx(
                fl,
                {
                  label: `+ ${s1.label}${s1.formatOptions.length ? " ▾" : ""}`,
                  variant: "outlined",
                  disabled: i,
                  onClick: (d1) => J1(d1, s1),
                  sx: {
                    height: 30,
                    borderRadius: 0.75,
                    bgcolor: "#fafbfc"
                  }
                },
                s1.value
              )) })
            ] })
          ] }),
          /* @__PURE__ */ y.jsx(IA, {}),
          /* @__PURE__ */ y.jsxs(F1, { children: [
            /* @__PURE__ */ y.jsx(ne, { fontWeight: 600, sx: { mb: 1.75 }, children: "File name preview" }),
            /* @__PURE__ */ y.jsxs(
              F1,
              {
                sx: {
                  p: 2.25,
                  border: "1px solid #cddaea",
                  borderRadius: 1,
                  bgcolor: "#eef4fb"
                },
                children: [
                  /* @__PURE__ */ y.jsxs(
                    Ke,
                    {
                      direction: { xs: "column", sm: "row" },
                      alignItems: "stretch",
                      gap: 1.75,
                      children: [
                        /* @__PURE__ */ y.jsxs(
                          F1,
                          {
                            sx: {
                              flex: 1,
                              minWidth: 0,
                              p: 1.75,
                              border: "1px solid #d8dee8",
                              borderRadius: 1,
                              bgcolor: "common.white"
                            },
                            children: [
                              /* @__PURE__ */ y.jsx(
                                ne,
                                {
                                  variant: "caption",
                                  fontWeight: 700,
                                  color: "text.secondary",
                                  children: "ORIGINAL FILE NAME"
                                }
                              ),
                              /* @__PURE__ */ y.jsx(ne, { sx: { mt: 0.75, wordBreak: "break-word" }, children: m })
                            ]
                          }
                        ),
                        /* @__PURE__ */ y.jsx(
                          F1,
                          {
                            sx: {
                              display: "grid",
                              placeItems: "center",
                              color: "#3366cc"
                            },
                            children: /* @__PURE__ */ y.jsx(Me, { icon: "arrowRight", sx: { fontSize: 22 } })
                          }
                        ),
                        /* @__PURE__ */ y.jsxs(
                          F1,
                          {
                            sx: {
                              flex: 1.05,
                              minWidth: 0,
                              p: 1.75,
                              border: "2px solid #7eb3ea",
                              borderRadius: 1,
                              bgcolor: "#e3f0ff"
                            },
                            children: [
                              /* @__PURE__ */ y.jsx(
                                ne,
                                {
                                  variant: "caption",
                                  fontWeight: 700,
                                  color: "#3366cc",
                                  children: "NEW FILE NAME"
                                }
                              ),
                              /* @__PURE__ */ y.jsx(
                                ne,
                                {
                                  fontWeight: 600,
                                  sx: { mt: 0.75, wordBreak: "break-word" },
                                  children: w || "File name preview"
                                }
                              )
                            ]
                          }
                        )
                      ]
                    }
                  ),
                  h.length > 0 && /* @__PURE__ */ y.jsxs(F1, { sx: { mt: 2.25, pt: 2, borderTop: "1px solid #d8dee8" }, children: [
                    /* @__PURE__ */ y.jsx(
                      ne,
                      {
                        variant: "body2",
                        color: "text.secondary",
                        fontWeight: 600,
                        sx: { mb: 1.25 },
                        children: "Fields Liscio found"
                      }
                    ),
                    /* @__PURE__ */ y.jsx(Ke, { direction: "row", flexWrap: "wrap", gap: 1, children: h.map((s1) => /* @__PURE__ */ y.jsxs(
                      F1,
                      {
                        sx: {
                          minWidth: 76,
                          px: 1.5,
                          py: 1,
                          border: "1px solid #d8dee8",
                          borderRadius: 1,
                          bgcolor: "common.white",
                          textAlign: "center"
                        },
                        children: [
                          /* @__PURE__ */ y.jsx(ne, { variant: "body2", fontWeight: 600, children: s1.value }),
                          /* @__PURE__ */ y.jsx(ne, { variant: "caption", color: "text.secondary", children: s1.label })
                        ]
                      },
                      s1.label
                    )) })
                  ] })
                ]
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ y.jsx(
          Nc,
          {
            sx: {
              justifyContent: "flex-end",
              px: 3,
              py: 2.25,
              borderTop: "1px solid #eef0f2"
            },
            children: /* @__PURE__ */ y.jsxs(Ke, { direction: "row", gap: 1, children: [
              /* @__PURE__ */ y.jsx(Dr, { color: "inherit", onClick: O1, disabled: i, children: "Cancel" }),
              /* @__PURE__ */ y.jsx(
                Dr,
                {
                  variant: "contained",
                  onClick: V,
                  disabled: !a && !s || i || g.length === 0,
                  children: i ? "Saving..." : "Save pattern"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ y.jsx(
          P7,
          {
            anchorEl: Y == null ? void 0 : Y.anchor,
            open: !!Y,
            onClose: () => H(null),
            children: Y == null ? void 0 : Y.options.map((s1) => /* @__PURE__ */ y.jsxs(
              Ma,
              {
                onClick: () => {
                  Y.tokenIndex != null && W(Y.tokenIndex, s1.value), Y.variable && k(Y.variable, s1.value), H(null);
                },
                sx: { display: "flex", justifyContent: "space-between", gap: 3 },
                children: [
                  /* @__PURE__ */ y.jsx(ne, { variant: "body2", children: s1.label }),
                  s1.example && /* @__PURE__ */ y.jsx(
                    ne,
                    {
                      variant: "caption",
                      color: "text.secondary",
                      fontFamily: "monospace",
                      children: s1.example
                    }
                  )
                ]
              },
              s1.value
            ))
          }
        ),
        /* @__PURE__ */ y.jsx(
          P7,
          {
            anchorEl: Z == null ? void 0 : Z.anchor,
            open: !!Z,
            onClose: () => Q(null),
            children: rS.map((s1) => /* @__PURE__ */ y.jsxs(
              Ma,
              {
                onClick: () => {
                  Z && K(Z.index, s1.value), Q(null);
                },
                sx: { display: "flex", justifyContent: "space-between", gap: 3 },
                children: [
                  /* @__PURE__ */ y.jsx(ne, { variant: "body2", children: s1.label }),
                  /* @__PURE__ */ y.jsx(
                    ne,
                    {
                      variant: "body2",
                      color: "text.secondary",
                      fontFamily: "monospace",
                      children: s1.display
                    }
                  )
                ]
              },
              s1.value
            ))
          }
        ),
        /* @__PURE__ */ y.jsx(
          H$,
          {
            open: P1,
            title: "Discard unsaved changes?",
            content: "Your changes to the naming pattern have not been saved.",
            confirmLabel: "Discard",
            cancelLabel: "Keep editing",
            onConfirm: () => {
              Y1(!1), T();
            },
            onCancel: () => Y1(!1)
          }
        )
      ]
    }
  );
}, lt1 = ({
  open: e,
  title: n,
  options: i,
  isLoading: a = !1,
  loadErrorText: s,
  onRetryLoad: g,
  isSaving: c = !1,
  disabled: I = !1,
  errorText: h,
  onClose: m,
  onSelect: w
}) => /* @__PURE__ */ y.jsxs(
  hl,
  {
    open: e,
    onClose: c ? void 0 : m,
    maxWidth: "xs",
    fullWidth: !0,
    "aria-labelledby": "folder-picker-dialog-title",
    children: [
      /* @__PURE__ */ y.jsx(BA, { id: "folder-picker-dialog-title", children: n }),
      /* @__PURE__ */ y.jsxs(Ei, { sx: { pt: 0 }, children: [
        h && /* @__PURE__ */ y.jsx(dl, { severity: "error", sx: { mb: 1 }, children: h }),
        a ? /* @__PURE__ */ y.jsx(F1, { sx: { display: "flex", justifyContent: "center", py: 3 }, children: /* @__PURE__ */ y.jsx(ji, { size: 22 }) }) : s ? /* @__PURE__ */ y.jsx(
          dl,
          {
            severity: "error",
            action: g && /* @__PURE__ */ y.jsx(Dr, { color: "inherit", size: "small", onClick: g, children: "Try again" }),
            children: s
          }
        ) : (
          // MenuList owns focus: it moves focus into the list on open and gives
          // the menu items arrow-key navigation, so destinations stay reachable
          // without a pointer.
          /* @__PURE__ */ y.jsx(pS, { autoFocusItem: !0, disablePadding: !0, children: i.map((S) => /* @__PURE__ */ y.jsxs(
            Ma,
            {
              disabled: S.disabled || c || I,
              onClick: () => w(S.id),
              sx: { pl: 2 + S.depth * 2.5, borderRadius: 1 },
              children: [
                /* @__PURE__ */ y.jsx(
                  Me,
                  {
                    icon: S.id == null ? "folderOpen" : "folder",
                    sx: { mr: 1, fontSize: 16, color: "text.secondary" }
                  }
                ),
                S.label
              ]
            },
            S.id ?? "root"
          )) })
        )
      ] }),
      /* @__PURE__ */ y.jsx(Nc, { children: /* @__PURE__ */ y.jsx(Dr, { color: "inherit", onClick: m, disabled: c, children: "Cancel" }) })
    ]
  }
), ut1 = ka(
  function({
    label: n,
    value: i,
    emptyText: a = "—",
    extraCount: s = 0,
    saving: g = !1,
    disabled: c = !1,
    readOnly: I = !1,
    wide: h = !1,
    shrinkable: m = !1,
    expanded: w,
    error: S = !1,
    title: T,
    onClick: D
  }, k) {
    const z = !!i, N = /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      /* @__PURE__ */ y.jsx(_$, { error: S, children: n }),
      /* @__PURE__ */ y.jsx(
        J$,
        {
          wide: h,
          capped: !I,
          hasValue: z,
          error: S,
          children: z ? i : a
        }
      ),
      s > 0 && /* @__PURE__ */ y.jsxs(K$, { children: [
        "+",
        s
      ] })
    ] });
    return I ? /* @__PURE__ */ y.jsx(V$, { title: T ?? i, children: N }) : /* @__PURE__ */ y.jsx(
      W$,
      {
        ref: k,
        size: "small",
        variant: "outlined",
        color: "inherit",
        onClick: D,
        disabled: c,
        "aria-haspopup": "listbox",
        "aria-expanded": w,
        title: T,
        wide: h,
        shrinkable: m,
        hasValue: z,
        error: S,
        endIcon: g ? /* @__PURE__ */ y.jsx(ji, { size: 10, color: "inherit" }) : /* @__PURE__ */ y.jsx(Me, { icon: "chevronDown" }),
        children: N
      }
    );
  }
), U$ = 180, DT = (e) => ({
  borderRadius: 999,
  minHeight: 24,
  fontFamily: e.typography.button.fontFamily,
  fontSize: 12,
  fontWeight: e.typography.fontWeightRegular,
  letterSpacing: e.typography.button.letterSpacing,
  lineHeight: 1.9,
  color: e.palette.text.primary,
  whiteSpace: "nowrap",
  minWidth: 0
}), W$ = H1(Dr, {
  shouldForwardProp: (e) => e !== "wide" && e !== "shrinkable" && e !== "hasValue" && e !== "error"
})(
  ({ theme: e, wide: n, shrinkable: i, hasValue: a, error: s }) => ({
    ...DT(e),
    // Non-wide chips hug their content so a squeezed row ellipsizes the wide
    // chip instead of short values like "Year 2024".
    ...!n && !i && { flexShrink: 0 },
    textTransform: "none",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: e.spacing(1.25),
    paddingRight: e.spacing(1.25),
    borderColor: e.palette.divider,
    "& .MuiButton-endIcon": {
      marginLeft: e.spacing(0.5),
      "& svg": { fontSize: 10 }
    },
    // The chevron inherits `color`. Hover restates the colors so the outlined
    // variant's neutral hover doesn't wash out the error state.
    ...s && {
      borderColor: e.palette.common.error[600],
      color: e.palette.common.error[600],
      backgroundColor: e.palette.common.error[50],
      "&:hover": {
        borderColor: e.palette.common.error[600],
        backgroundColor: e.palette.common.error[100]
      }
    },
    // Grow-but-shrinkable up to 290px when a value is set: flex-shrink plus
    // minWidth 0 keep the min-content near zero so a long label can never push
    // the surrounding row's min width around. Unset hugs content.
    ...n && {
      flex: a ? "1 1 auto" : "0 1 auto",
      maxWidth: 290,
      justifyContent: "flex-start"
    }
  })
), V$ = H1("span")(({ theme: e }) => ({
  ...DT(e),
  display: "inline-flex",
  alignItems: "center",
  border: `1px solid ${e.palette.divider}`,
  paddingLeft: e.spacing(1.25),
  paddingRight: e.spacing(1.25),
  maxWidth: "100%",
  flex: "0 1 auto"
})), _$ = H1("span", {
  shouldForwardProp: (e) => e !== "error"
})(({ theme: e, error: n }) => ({
  color: n ? e.palette.common.error[600] : e.palette.common.fieldChipMutedText ?? e.palette.text.secondary,
  marginRight: e.spacing(0.5),
  flexShrink: 0
})), J$ = H1("span", {
  shouldForwardProp: (e) => e !== "wide" && e !== "capped" && e !== "hasValue" && e !== "error"
})(
  ({ theme: e, wide: n, capped: i, hasValue: a, error: s }) => ({
    fontWeight: 600,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    ...!a && {
      color: e.palette.common.fieldChipMutedText ?? e.palette.text.secondary
    },
    ...s && { color: e.palette.common.error[600] },
    ...n ? { flex: 1 } : i && { maxWidth: U$ }
  })
), K$ = H1("span")(({ theme: e }) => ({
  flexShrink: 0,
  marginLeft: e.spacing(0.5),
  fontWeight: 600
})), Y$ = 48, kT = 300, af = { kind: "clear" }, z7 = (e, n) => e.kind === "clear" ? n.kind === "clear" : n.kind === "option" && e.id === n.id;
function ct1({
  open: e,
  anchorEl: n,
  onClose: i,
  onDone: a,
  label: s,
  searchLabel: g,
  searchPlaceholder: c,
  query: I,
  onQueryChange: h,
  options: m,
  selectionMode: w = "single",
  selectedIds: S,
  onSelect: T,
  defaultActiveId: D,
  emptyText: k,
  isLoading: z = !1,
  errorText: N,
  onRetry: W,
  onClear: K,
  clearLabel: V = "Clear",
  clearAriaLabel: Y,
  onEndReached: H,
  isLoadingMore: Z = !1,
  loadMoreErrorText: Q,
  onRetryLoadMore: P1,
  disabled: Y1 = !1
}) {
  const O1 = vS(), T1 = yn(null), J1 = yn(null), s1 = yn(null), d1 = yn(null), [h1, C1] = qt(null), L1 = hc("(pointer: coarse), (hover: none)"), { viewport: f1, compact: B1, veryShort: t1, anchorPosition: y1 } = PH(
    e,
    L1,
    n,
    kT
  ), k1 = !z && !N, se = k1 ? m : [], K1 = se.filter((W1) => !W1.disabled).map(({ id: W1 }) => ({ kind: "option", id: W1 })), le = K && K1.length > 0 ? [...K1, af] : K1, G1 = h1 ?? (D === void 0 ? null : { kind: "option", id: D }), $1 = G1 === null ? null : le.find((W1) => z7(W1, G1)) ?? null, V1 = (W1) => $1 !== null && z7($1, W1), z1 = (W1) => W1.kind === "clear" ? `${O1}-clear` : `${O1}-option-${se.findIndex(
    (ke) => ke.id === W1.id
  )}`, ae = (W1) => {
    var ke, Xe, St;
    if (!Y1) {
      if (W1.kind === "clear") {
        L1 ? (Xe = s1.current ?? ((ke = T1.current) == null ? void 0 : ke.querySelector(
          '[role="option"]:not([aria-disabled="true"]):not([id$="-clear"])'
        )) ?? d1.current) == null || Xe.focus() : (St = J1.current) == null || St.focus(), K == null || K();
        return;
      }
      se.some((tt) => tt.id === W1.id && !tt.disabled) && T(W1.id);
    }
  }, We = (W1) => {
    var tt, we, An;
    if (le.length === 0) {
      C1(null);
      return;
    }
    const ke = $1 === null ? -1 : le.findIndex((nt) => z7(nt, $1)), Xe = W1 === 1 ? Math.min(ke + 1, le.length - 1) : Math.max(ke - 1, 0), St = le[Xe];
    C1(St), (An = (we = (tt = T1.current) == null ? void 0 : tt.ownerDocument.getElementById(z1(St))) == null ? void 0 : we.scrollIntoView) == null || An.call(we, { block: "nearest" });
  }, D1 = (W1) => {
    W1.key === "ArrowDown" || W1.key === "ArrowUp" ? (W1.preventDefault(), We(W1.key === "ArrowDown" ? 1 : -1)) : W1.key === "Enter" && $1 !== null && (W1.preventDefault(), ae($1));
  }, ue = (W1) => {
    var ke;
    L1 || (W1.preventDefault(), (ke = J1.current) == null || ke.focus());
  }, b1 = (W1) => {
    if (!H) return;
    const { clientHeight: ke, scrollHeight: Xe, scrollTop: St } = W1.currentTarget;
    Xe - St - ke <= Y$ && H();
  }, Pe = se.reduce((W1, ke, Xe) => {
    const St = W1[W1.length - 1];
    return St && St.group === ke.group ? St.options.push(ke) : W1.push({ group: ke.group, start: Xe, options: [ke] }), W1;
  }, []), $e = (W1) => {
    const ke = S.includes(W1.id), Xe = { kind: "option", id: W1.id };
    return /* @__PURE__ */ y.jsxs(
      e11,
      {
        dense: !0,
        id: z1(Xe),
        role: "option",
        tabIndex: -1,
        "aria-selected": ke,
        selected: ke,
        disabled: Y1 || W1.disabled,
        active: V1(Xe),
        onMouseDown: ue,
        onClick: () => ae(Xe),
        onMouseEnter: () => C1(Xe),
        children: [
          /* @__PURE__ */ y.jsx(iS, { children: ke && /* @__PURE__ */ y.jsx(Me, { icon: "check" }) }),
          /* @__PURE__ */ y.jsxs(r11, { children: [
            /* @__PURE__ */ y.jsx(i11, { emphasized: W1.emphasized, children: W1.label }),
            W1.description && /* @__PURE__ */ y.jsx(a11, { children: W1.description })
          ] })
        ]
      },
      `option-${String(W1.id)}`
    );
  };
  return /* @__PURE__ */ y.jsxs(
    Q$,
    {
      open: e,
      anchorEl: n,
      anchorReference: L1 && B1 ? "anchorPosition" : "anchorEl",
      anchorPosition: L1 && B1 ? y1 : void 0,
      onClose: i,
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      transformOrigin: L1 && B1 ? { vertical: "bottom", horizontal: "left" } : { vertical: -4, horizontal: "left" },
      slotProps: L1 ? { paper: { ref: d1, tabIndex: -1, sx: {
        maxHeight: Math.max(0, f1.height - 16),
        maxWidth: Math.max(0, f1.width - 16),
        overflow: "hidden"
      } } } : void 0,
      TransitionProps: {
        onEnter: () => C1(null),
        onEntered: (W1) => {
          var ke, Xe;
          if (L1) {
            W1.contains(document.activeElement) || (ke = d1.current) == null || ke.focus();
            return;
          }
          !L1 && (W1 === document.activeElement || !W1.contains(document.activeElement)) && ((Xe = J1.current) == null || Xe.focus());
        }
      },
      onKeyDown: (W1) => {
        W1.key === "Escape" && (W1.stopPropagation(), i());
      },
      children: [
        /* @__PURE__ */ y.jsxs(X$, { sx: L1 ? { flexShrink: 0, ...t1 && { p: 0.5 } } : void 0, children: [
          /* @__PURE__ */ y.jsx(G$, { icon: "search" }),
          /* @__PURE__ */ y.jsx(
            q$,
            {
              autoFocus: !L1,
              fullWidth: !0,
              size: "small",
              inputRef: J1,
              value: I,
              disabled: Y1,
              placeholder: c,
              onChange: (W1) => {
                h(W1.target.value), C1(null);
              },
              onKeyDown: D1,
              inputProps: {
                "aria-label": g,
                role: "combobox",
                "aria-autocomplete": "list",
                "aria-expanded": !0,
                "aria-controls": O1,
                "aria-activedescendant": $1 === null ? void 0 : z1($1)
              }
            }
          )
        ] }),
        /* @__PURE__ */ y.jsxs(
          Z$,
          {
            ref: T1,
            id: O1,
            role: "listbox",
            "aria-label": s,
            "aria-multiselectable": w === "multiple" || void 0,
            onMouseLeave: () => C1(null),
            sx: L1 ? {
              flex: "1 1 auto",
              minHeight: t1 && a ? 32 : 64,
              overflow: "hidden"
            } : void 0,
            children: [
              /* @__PURE__ */ y.jsxs(
                $$,
                {
                  role: "presentation",
                  onScroll: b1,
                  sx: L1 ? {
                    flex: "1 1 auto",
                    minHeight: 0,
                    maxHeight: "none"
                  } : void 0,
                  children: [
                    z && /* @__PURE__ */ y.jsx(of, { children: /* @__PURE__ */ y.jsx(ji, { size: 18 }) }),
                    !z && N && /* @__PURE__ */ y.jsxs(of, { children: [
                      /* @__PURE__ */ y.jsx(ne, { variant: "caption", color: "error", children: N }),
                      W && /* @__PURE__ */ y.jsx(Dr, { size: "small", onClick: W, children: "Retry" })
                    ] }),
                    k1 && m.length === 0 && /* @__PURE__ */ y.jsx(of, { children: /* @__PURE__ */ y.jsx(
                      ne,
                      {
                        role: "status",
                        variant: "caption",
                        color: "text.secondary",
                        children: k
                      }
                    ) }),
                    Pe.map((W1) => {
                      const ke = W1.options.map($e);
                      if (W1.group === void 0) return ke;
                      const Xe = `${O1}-group-${W1.start}`;
                      return /* @__PURE__ */ y.jsxs(
                        F1,
                        {
                          role: "group",
                          "aria-labelledby": Xe,
                          children: [
                            /* @__PURE__ */ y.jsx(
                              t11,
                              {
                                id: Xe,
                                component: "div",
                                role: "presentation",
                                disableSticky: !0,
                                children: W1.group
                              }
                            ),
                            ke
                          ]
                        },
                        `group-${W1.start}`
                      );
                    }),
                    k1 && Z && /* @__PURE__ */ y.jsx(of, { children: /* @__PURE__ */ y.jsx(ji, { size: 18 }) }),
                    k1 && Q && /* @__PURE__ */ y.jsxs(of, { children: [
                      /* @__PURE__ */ y.jsx(ne, { variant: "caption", color: "error", children: Q }),
                      P1 && /* @__PURE__ */ y.jsx(Dr, { size: "small", onClick: P1, children: "Retry" })
                    ] })
                  ]
                }
              ),
              K && /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
                /* @__PURE__ */ y.jsx(IA, { role: "presentation" }),
                /* @__PURE__ */ y.jsxs(
                  n11,
                  {
                    dense: !0,
                    id: z1(af),
                    role: "option",
                    tabIndex: 0,
                    "aria-selected": !1,
                    "aria-label": Y,
                    disabled: Y1,
                    active: V1(af),
                    onMouseDown: ue,
                    onClick: () => ae(af),
                    onMouseEnter: () => C1(af),
                    children: [
                      /* @__PURE__ */ y.jsx(iS, {}),
                      V
                    ]
                  }
                )
              ] })
            ]
          }
        ),
        a && /* @__PURE__ */ y.jsx(F1, { sx: { display: "flex", justifyContent: "flex-end", p: t1 && L1 ? 0.5 : 1, borderTop: 1, borderColor: "divider", flexShrink: 0 }, children: /* @__PURE__ */ y.jsx(Dr, { ref: s1, size: "small", variant: "contained", onClick: a, children: "Done" }) })
      ]
    }
  );
}
const Q$ = H1(HA)({
  "& .MuiPopover-paper": {
    width: kT,
    display: "flex",
    flexDirection: "column"
  }
}), X$ = H1(F1)(({ theme: e }) => ({
  position: "relative",
  padding: e.spacing(1),
  borderBottom: `1px solid ${e.palette.divider}`
})), G$ = H1(Me)(({ theme: e }) => ({
  position: "absolute",
  left: e.spacing(2.5),
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 14,
  color: e.palette.text.secondary,
  pointerEvents: "none",
  zIndex: 1
})), q$ = H1(Ef)(({ theme: e }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: e.palette.background.default,
    borderRadius: 6,
    "& fieldset": { borderColor: e.palette.divider }
  },
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    padding: e.spacing(1.25, 1, 1.25, 4),
    fontSize: 13,
    "&::placeholder": { fontSize: 13 }
  }
})), Z$ = H1(F1)({
  display: "flex",
  flexDirection: "column",
  minHeight: 0
}), $$ = H1(F1)(({ theme: e }) => ({
  overflow: "auto",
  maxHeight: 336,
  padding: e.spacing(0.5, 0)
})), of = H1(F1)(({ theme: e }) => ({
  minHeight: 64,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: e.spacing(1),
  padding: e.spacing(2)
})), e11 = H1(Ma, {
  shouldForwardProp: (e) => e !== "active"
})(({ theme: e, active: n }) => ({
  "&&": {
    minHeight: 32,
    padding: e.spacing(0.5, 2, 0.5, 1.25),
    fontSize: 13,
    fontWeight: e.typography.fontWeightRegular,
    lineHeight: 1.4,
    borderRadius: 0
  },
  ...n && { backgroundColor: e.palette.action.hover },
  "&&.Mui-selected": { fontWeight: 600 }
})), t11 = H1(nz)(({ theme: e }) => ({
  ...e.typography.caption,
  padding: e.spacing(1.25, 2, 0.5),
  // Line the heading up with option labels, past the row inset and check gutter.
  paddingLeft: `calc(${e.spacing(1.25)} + 14px)`,
  textTransform: "uppercase",
  color: e.palette.text.secondary,
  backgroundColor: "transparent"
})), n11 = H1(Ma, {
  shouldForwardProp: (e) => e !== "active"
})(({ theme: e, active: n }) => ({
  flexShrink: 0,
  color: e.palette.text.secondary,
  "&&": {
    minHeight: 36,
    padding: e.spacing(0, 2, 0, 1.25),
    fontSize: 13,
    fontWeight: e.typography.fontWeightRegular,
    lineHeight: 1.4,
    borderRadius: 0
  },
  ...n && { backgroundColor: e.palette.action.hover }
})), iS = H1("span")({
  width: 14,
  display: "inline-flex",
  flexShrink: 0,
  alignItems: "center",
  fontSize: 10
}), r11 = H1("span")({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0
}), i11 = H1("span", {
  shouldForwardProp: (e) => e !== "emphasized"
})(({ theme: e, emphasized: n }) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  ...n && { fontWeight: e.typography.fontWeightBold }
})), a11 = H1("span")(({ theme: e }) => ({
  fontSize: 12,
  color: e.palette.text.secondary
})), gt1 = ({ text: e }) => /* @__PURE__ */ y.jsxs(F1, { display: "flex", alignItems: "center", width: "100%", children: [
  /* @__PURE__ */ y.jsx(IA, { sx: { flexGrow: 1 } }),
  /* @__PURE__ */ y.jsx(ne, { mx: 3, children: e }),
  /* @__PURE__ */ y.jsx(IA, { sx: { flexGrow: 1 } })
] }), o11 = H1(F1)(({ theme: e }) => {
  var n, i;
  return {
    display: "flex",
    flexDirection: "column",
    backgroundColor: (i = (n = e.palette.common) == null ? void 0 : n.neutrals) == null ? void 0 : i[50],
    minHeight: "100vh",
    "@supports (height: -webkit-fill-available)": {
      minHeight: "-webkit-fill-available"
    },
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    [e.breakpoints.down("md")]: {
      "html.native-android &": {
        top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
        bottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
        minHeight: "var(--liscio-app-viewport-height, 100vh)"
      }
    },
    // Change position to fit mobile views in desktop layout
    [e.breakpoints.up("md")]: {
      position: "relative",
      minHeight: "calc(100vh - 50px)"
      // The desktop view has a footer that is 50 pixels high
    }
  };
}), ft1 = ({
  children: e,
  dataTestId: n = "ScreenWrapper",
  ...i
}) => /* @__PURE__ */ y.jsx(o11, { ...i, "data-testid": n, children: e }), s11 = H1(F1)(({ theme: e }) => ({
  alignItems: "stretch",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: e.spacing(3),
  padding: e.spacing(4)
})), dt1 = ({ children: e, ...n }) => /* @__PURE__ */ y.jsx(s11, { ...n, children: e });
H1(F1)({
  position: "relative"
});
H1(hS)(({ theme: e }) => ({
  position: "absolute",
  left: "calc(50% - 20px)",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: e.zIndex.modal + 10
}));
const l11 = H1(F1)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}), u11 = 5, c11 = ({
  touchDiff: e,
  reloadThreshold: n
}) => /* @__PURE__ */ y.jsx(l11, { sx: { height: e }, children: e > n - u11 && /* @__PURE__ */ y.jsx(ji, { variant: "indeterminate", disableShrink: !0, size: 30 }) }), N7 = 100, g11 = 20, f11 = ({
  bodyNodeRef: e,
  reloadFunction: n
}) => {
  const [i, a] = qt(0), s = yn(i), g = (S) => {
    a(S), s.current = S;
  }, c = yn(0), I = yn(0), h = h2(
    (S) => {
      var T;
      c.current = S.touches[0].clientY, I.current = ((T = e == null ? void 0 : e.current) == null ? void 0 : T.scrollTop) || 0;
    },
    [e]
  ), m = h2(
    (S) => {
      var z;
      const T = ((z = e == null ? void 0 : e.current) == null ? void 0 : z.scrollTop) || 0, k = S.touches[0].clientY - c.current - I.current;
      k > 0 && T === 0 && k < N7 + g11 && g(Math.floor(k)), S.stopPropagation();
    },
    [e]
  ), w = h2(() => {
    s.current >= N7 && n(), g(0), c.current = 0, I.current = 0;
  }, [n]);
  return vn(() => {
    const S = e.current;
    return S && (S.addEventListener("touchstart", h), S.addEventListener("touchmove", m), S.addEventListener("touchend", w)), () => {
      S && (S.removeEventListener("touchstart", h), S.removeEventListener("touchmove", m), S.removeEventListener("touchend", w));
    };
  }, [e, w, m, h]), /* @__PURE__ */ y.jsx(c11, { touchDiff: i, reloadThreshold: N7 });
}, d11 = H1(F1)(({ theme: e }) => ({
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
  paddingBottom: "8px",
  position: "relative",
  overscrollBehavior: "none",
  [e.breakpoints.up("md")]: {
    overflow: "visible"
  }
})), Ct1 = ({
  children: e,
  reloadFunction: n,
  id: i = "body-wrapper",
  ...a
}) => {
  const s = yn();
  return /* @__PURE__ */ y.jsxs(d11, { ref: s, id: i, ...a, children: [
    n && /* @__PURE__ */ y.jsx(
      f11,
      {
        bodyNodeRef: s,
        reloadFunction: n
      }
    ),
    e
  ] });
}, At1 = H1(F1)(({ theme: e }) => ({
  borderTop: `solid 1px ${e.palette.common.blueGray[200]}`,
  padding: "16px 8px 32px 8px",
  textAlign: "center"
})), It1 = H1(F1)(() => ({
  padding: "16px 8px 32px 8px",
  textAlign: "center"
}));
function pt1({ tags: e, getLabel: n = (i) => i }) {
  return !e || e.length < 1 ? null : /* @__PURE__ */ y.jsx(y.Fragment, { children: e == null ? void 0 : e.map((i) => /* @__PURE__ */ y.jsx(bm, { label: n(i) }, i)) });
}
const C11 = ({
  error: e,
  parseError: n = wS,
  errorContent: i,
  title: a = "Submission Error",
  onClose: s = () => {
  },
  closeLabel: g = "Close",
  secondaryAction: c,
  secondaryLabel: I,
  defaultMessage: h = F7
}) => {
  const [m, w] = qt(!1), S = h2(async () => {
    await s(), w(!1);
  }, [s, w]), T = V2(
    () => n(e, h),
    [n, e, h]
  );
  return vn(() => {
    (i || T) && w(!0);
  }, [i, T, w]), /* @__PURE__ */ y.jsxs(
    hl,
    {
      open: m,
      onClose: S,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description",
      children: [
        /* @__PURE__ */ y.jsx(BA, { id: "alert-dialog-title", children: a }),
        /* @__PURE__ */ y.jsx(Ei, { children: i || /* @__PURE__ */ y.jsx(IS, { id: "alert-dialog-description", children: T }) }),
        /* @__PURE__ */ y.jsxs(Nc, { children: [
          c && I && /* @__PURE__ */ y.jsx(k2, { onClick: c, children: I }),
          /* @__PURE__ */ y.jsx(k2, { onClick: S, children: g })
        ] })
      ]
    }
  );
}, ht1 = ({
  hasError: e
}) => /* @__PURE__ */ y.jsx(
  C11,
  {
    title: "Network problem",
    error: e,
    defaultMessage: "Please check your internet connection",
    onClose: () => window.location.reload(),
    closeLabel: "Reload"
  }
), mt1 = ({
  error: e,
  parseError: n = wS,
  defaultMessage: i = F7
}) => {
  const a = V2(
    () => n(e, i),
    [n, e, i]
  );
  return e ? /* @__PURE__ */ y.jsx(dl, { severity: "error", children: a || F7 }) : null;
};
function vt1({
  title: e,
  description: n,
  ctaLabel: i,
  activateLabel: a,
  removeLabel: s,
  icon: g,
  disabled: c,
  onActivate: I,
  onRemove: h
}) {
  return /* @__PURE__ */ y.jsxs(
    F1,
    {
      component: "article",
      sx: {
        position: "relative",
        display: "flex",
        minWidth: 0,
        minHeight: 220,
        flexDirection: "column",
        gap: 1.5,
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: "0 2px 8px rgba(28, 31, 54, 0.08)",
        p: 2.25
      },
      children: [
        /* @__PURE__ */ y.jsx(
          ym,
          {
            icon: "close",
            size: "small",
            "aria-label": s,
            disabled: c,
            onClick: h,
            sx: {
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary"
            }
          }
        ),
        /* @__PURE__ */ y.jsx(
          F1,
          {
            sx: {
              display: "grid",
              width: 40,
              height: 40,
              placeItems: "center",
              borderRadius: 2,
              bgcolor: "common.primary.50",
              color: "common.primary.500"
            },
            children: /* @__PURE__ */ y.jsx(Me, { icon: g, fontSize: "small" })
          }
        ),
        /* @__PURE__ */ y.jsx(
          ne,
          {
            component: "h3",
            variant: "subtitle1",
            sx: { pr: 2, fontWeight: 600 },
            children: e
          }
        ),
        /* @__PURE__ */ y.jsx(
          ne,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { fontWeight: 400, lineHeight: 1.5 },
            children: n
          }
        ),
        /* @__PURE__ */ y.jsx(
          k2,
          {
            variant: "contained",
            size: "small",
            "aria-label": a,
            onClick: I,
            endIcon: /* @__PURE__ */ y.jsx(Me, { icon: "arrowRight", fontSize: "small" }),
            sx: { alignSelf: "flex-start", mt: "auto" },
            children: i
          }
        )
      ]
    }
  );
}
function yt1({
  title: e,
  description: n,
  icon: i,
  statusLabel: a,
  ctaLabel: s,
  activateAriaLabel: g,
  actionLabel: c,
  actionAriaLabel: I,
  dismissAriaLabel: h,
  visible: m,
  disabled: w,
  onActivate: S,
  onAction: T
}) {
  return /* @__PURE__ */ y.jsxs(
    F1,
    {
      component: "article",
      sx: {
        position: "relative",
        display: "flex",
        minWidth: 0,
        minHeight: 206,
        flexDirection: "column",
        gap: 1.5,
        border: 1,
        borderColor: "divider",
        borderRadius: "8px",
        bgcolor: "background.paper",
        boxShadow: "0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.12)",
        px: 2.25,
        pt: 2.25,
        pb: 2,
        ...m && {
          "&::after": {
            position: "absolute",
            inset: -1,
            border: 2,
            borderStyle: "dashed",
            borderColor: "common.accent.400",
            borderRadius: "8px",
            content: '""',
            pointerEvents: "none"
          }
        }
      },
      children: [
        m ? /* @__PURE__ */ y.jsx(
          ym,
          {
            icon: "close",
            size: "small",
            "aria-label": h,
            disabled: w,
            onClick: T,
            sx: {
              position: "absolute",
              zIndex: 1,
              top: 8,
              right: 8,
              color: "text.secondary"
            }
          }
        ) : /* @__PURE__ */ y.jsx(
          bm,
          {
            size: "small",
            label: a,
            sx: { position: "absolute", top: 12, right: 12, fontWeight: 600 }
          }
        ),
        /* @__PURE__ */ y.jsx(
          F1,
          {
            sx: {
              display: "grid",
              width: 38,
              height: 38,
              placeItems: "center",
              borderRadius: "9px",
              bgcolor: "common.primary.50",
              color: "common.primary.500"
            },
            children: /* @__PURE__ */ y.jsx(Me, { icon: i, fontSize: "small" })
          }
        ),
        /* @__PURE__ */ y.jsx(
          ne,
          {
            component: "h4",
            variant: "subtitle1",
            sx: { pr: 2.5, fontSize: 15.5, fontWeight: 600 },
            children: e
          }
        ),
        /* @__PURE__ */ y.jsx(
          ne,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { fontSize: 12.5, fontWeight: 400, lineHeight: 1.5 },
            children: n
          }
        ),
        m && /* @__PURE__ */ y.jsx(
          k2,
          {
            variant: "contained",
            size: "small",
            disabled: w,
            "aria-label": g,
            onClick: S,
            endIcon: /* @__PURE__ */ y.jsx(Me, { icon: "arrowRight", fontSize: "small" }),
            sx: { zIndex: 1, alignSelf: "flex-start", mt: "auto" },
            children: s
          }
        ),
        /* @__PURE__ */ y.jsx(
          k2,
          {
            variant: m ? "text" : "contained",
            size: "small",
            disabled: w,
            "aria-label": I,
            onClick: T,
            startIcon: /* @__PURE__ */ y.jsx(Me, { icon: m ? "close" : "add", fontSize: "small" }),
            sx: {
              zIndex: 1,
              alignSelf: "flex-start",
              mt: m ? 0 : "auto",
              ...m && {
                px: 0,
                color: "common.accent.600",
                "&:hover": { bgcolor: "transparent", color: "common.accent.700" }
              }
            },
            children: c
          }
        )
      ]
    }
  );
}
const aS = {
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    md: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))"
  },
  gap: 2
}, A11 = {
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    md: "repeat(4, minmax(0, 1fr))"
  },
  gap: 2
};
function bt1({
  heading: e,
  description: n,
  headerAction: i,
  errorMessage: a,
  onClearError: s,
  isLoading: g,
  loadingRegionLabel: c,
  loadingItems: I,
  settingsContent: h,
  isEmpty: m,
  emptyMessage: w,
  emptyActionLabel: S,
  emptyActionIcon: T,
  onEmptyAction: D,
  children: k
}) {
  const z = vS();
  return /* @__PURE__ */ y.jsxs(F1, { component: "section", "aria-labelledby": z, children: [
    h ? /* @__PURE__ */ y.jsxs(
      Ke,
      {
        direction: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 2,
        sx: {
          mb: 2,
          border: 1,
          borderColor: "common.primary.100",
          borderRadius: "10px",
          bgcolor: "common.primary.50",
          px: 2.25,
          py: 1.75
        },
        children: [
          /* @__PURE__ */ y.jsx(
            Me,
            {
              icon: "sliders",
              sx: { color: "common.primary.500", fontSize: 20 }
            }
          ),
          /* @__PURE__ */ y.jsxs(F1, { sx: { minWidth: 0, flex: 1 }, children: [
            /* @__PURE__ */ y.jsx(
              ne,
              {
                id: z,
                component: "h2",
                variant: "body2",
                sx: { color: "common.primary.700", fontWeight: 600 },
                children: h.heading
              }
            ),
            /* @__PURE__ */ y.jsx(
              ne,
              {
                variant: "body2",
                color: "text.secondary",
                sx: { fontSize: 13, fontWeight: 400 },
                children: h.description
              }
            )
          ] }),
          i
        ]
      }
    ) : /* @__PURE__ */ y.jsxs(
      Ke,
      {
        direction: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        sx: { mb: 2 },
        children: [
          /* @__PURE__ */ y.jsxs(F1, { children: [
            /* @__PURE__ */ y.jsx(
              ne,
              {
                id: z,
                component: "h2",
                variant: "h5",
                sx: { fontWeight: 700 },
                children: e
              }
            ),
            /* @__PURE__ */ y.jsx(ne, { variant: "body2", color: "text.secondary", sx: { mt: 0.5 }, children: n })
          ] }),
          i
        ]
      }
    ),
    a && /* @__PURE__ */ y.jsx(dl, { severity: "error", onClose: s, sx: { mb: 2 }, children: a }),
    g ? /* @__PURE__ */ y.jsx(F1, { role: "status", "aria-label": c, sx: aS, children: I.map((N) => /* @__PURE__ */ y.jsx(
      Fh,
      {
        variant: "rounded",
        height: 220,
        "aria-label": N.label
      },
      N.key
    )) }) : h ? /* @__PURE__ */ y.jsxs(F1, { children: [
      /* @__PURE__ */ y.jsx(
        ne,
        {
          component: "h3",
          variant: "body2",
          color: "text.secondary",
          sx: { mb: 1, fontWeight: 600 },
          children: h.label
        }
      ),
      /* @__PURE__ */ y.jsx(F1, { sx: A11, children: h.children })
    ] }) : m ? /* @__PURE__ */ y.jsxs(
      F1,
      {
        sx: {
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
          bgcolor: "background.paper",
          p: 3,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ y.jsx(ne, { variant: "body2", color: "text.secondary", children: w }),
          /* @__PURE__ */ y.jsx(
            k2,
            {
              variant: "text",
              startIcon: /* @__PURE__ */ y.jsx(Me, { icon: T }),
              onClick: D,
              sx: { mt: 1 },
              children: S
            }
          )
        ]
      }
    ) : /* @__PURE__ */ y.jsx(F1, { sx: aS, children: k })
  ] });
}
const I11 = H1(Uh)({
  display: "flex"
}), p11 = ({
  label: e,
  labelStyles: n,
  ...i
}) => /* @__PURE__ */ y.jsx(
  I11,
  {
    control: /* @__PURE__ */ y.jsx(rz, { ...i }),
    label: e,
    sx: {
      ...n,
      // Gross, yes, but the padding on switches is weird and I expect our design system
      // will want toggles to hug the left side of their container flush.
      // Manipulating the padding directly in the MUI switch uglifies the component in other ways.
      position: "relative",
      right: "8px"
    }
  }
), wt1 = ({
  control: e,
  name: n,
  ...i
}) => {
  const { field: a } = Vh({ name: n, control: e });
  return /* @__PURE__ */ y.jsx(
    p11,
    {
      ...i,
      value: a.value || !1,
      checked: a.value || !1,
      onChange: a.onChange
    }
  );
}, h11 = H1(F1)({
  display: "flex",
  alignItems: "center"
}), m11 = H1(ne)(({ theme: e }) => ({
  color: e.palette.grey[500]
})), xt1 = ({
  initials: e,
  name: n,
  avatar: i,
  accountName: a
}) => /* @__PURE__ */ y.jsxs(h11, { children: [
  /* @__PURE__ */ y.jsx(u$, { src: i, sx: { width: 24, height: 24, fontSize: "12px" }, children: i ? null : e }),
  /* @__PURE__ */ y.jsxs(F1, { sx: { paddingLeft: "15px" }, children: [
    /* @__PURE__ */ y.jsx(ne, { children: n }),
    a && /* @__PURE__ */ y.jsx(m11, { children: a })
  ] })
] }), St1 = ({
  userName: e,
  accountName: n,
  onRemoveClick: i
}) => {
  const a = n ? `${e} • ${n}` : e;
  return /* @__PURE__ */ y.jsx(fl, { sx: { width: "auto" }, label: a, onDelete: i });
}, Et1 = H1(bm)(({ theme: e }) => ({
  ...e.typography.body2,
  padding: 0,
  textTransform: "uppercase",
  letterSpacing: "1px"
}));
var v11 = Object.defineProperty, y11 = (e, n, i) => n in e ? v11(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, $C = (e, n, i) => y11(e, typeof n != "symbol" ? n + "" : n, i), Ph = /* @__PURE__ */ new Map(), eA = /* @__PURE__ */ new WeakMap(), oS = 0, b11 = void 0;
function w11(e) {
  return e ? (eA.has(e) || (oS += 1, eA.set(e, oS.toString())), eA.get(e)) : "0";
}
function x11(e) {
  return Object.keys(e).sort().filter(
    (n) => e[n] !== void 0
  ).map((n) => `${n}_${n === "root" ? w11(e.root) : e[n]}`).toString();
}
function S11(e) {
  const n = x11(e);
  let i = Ph.get(n);
  if (!i) {
    const a = /* @__PURE__ */ new Map();
    let s;
    const g = new IntersectionObserver((c) => {
      c.forEach((I) => {
        var h;
        const m = I.isIntersecting && s.some((w) => I.intersectionRatio >= w);
        e.trackVisibility && typeof I.isVisible > "u" && (I.isVisible = m), (h = a.get(I.target)) == null || h.forEach((w) => {
          w(m, I);
        });
      });
    }, e);
    s = g.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), i = {
      id: n,
      observer: g,
      elements: a
    }, Ph.set(n, i);
  }
  return i;
}
function E11(e, n, i = {}, a = b11) {
  if (typeof window.IntersectionObserver > "u" && a !== void 0) {
    const h = e.getBoundingClientRect();
    return n(a, {
      isIntersecting: a,
      target: e,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: h,
      intersectionRect: h,
      rootBounds: h
    }), () => {
    };
  }
  const { id: s, observer: g, elements: c } = S11(i), I = c.get(e) || [];
  return c.has(e) || c.set(e, I), I.push(n), g.observe(e), function() {
    I.splice(I.indexOf(n), 1), I.length === 0 && (c.delete(e), g.unobserve(e)), c.size === 0 && (g.disconnect(), Ph.delete(s));
  };
}
function M11(e) {
  return typeof e.children != "function";
}
var T11 = class extends n1.Component {
  constructor(e) {
    super(e), $C(this, "node", null), $C(this, "_unobserveCb", null), $C(this, "handleNode", (n) => {
      this.node && (this.unobserve(), !n && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = n || null, this.observeNode();
    }), $C(this, "handleChange", (n, i) => {
      n && this.props.triggerOnce && this.unobserve(), M11(this.props) || this.setState({ inView: n, entry: i }), this.props.onChange && this.props.onChange(n, i);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: e,
      root: n,
      rootMargin: i,
      trackVisibility: a,
      delay: s,
      fallbackInView: g
    } = this.props;
    this._unobserveCb = E11(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: n,
        rootMargin: i,
        // @ts-ignore
        trackVisibility: a,
        // @ts-ignore
        delay: s
      },
      g
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: D, entry: k } = this.state;
      return e({ inView: D, entry: k, ref: this.handleNode });
    }
    const {
      as: n,
      triggerOnce: i,
      threshold: a,
      root: s,
      rootMargin: g,
      onChange: c,
      skip: I,
      trackVisibility: h,
      delay: m,
      initialInView: w,
      fallbackInView: S,
      ...T
    } = this.props;
    return n1.createElement(
      n || "div",
      { ref: this.handleNode, ...T },
      e
    );
  }
};
const Mt1 = ({
  isFetchingNextPage: e,
  fetchNextPage: n,
  isLoading: i,
  hasNextPage: a,
  root: s,
  children: g
}) => {
  const c = i;
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    c && /* @__PURE__ */ y.jsx(Sh, {}),
    !c && g,
    e && /* @__PURE__ */ y.jsx(Sh, { numberOfElements: 1, mt: 1 }),
    !i && !e && (a ?? !0) && /* @__PURE__ */ y.jsx(T11, { root: s, onChange: (I) => I && n() })
  ] });
};
function Tt1({
  chips: e,
  disabled: n,
  onRemoveChip: i,
  onRemoveAccount: a,
  onAssignAccount: s,
  onRefreshAccountOptions: g,
  renderChip: c,
  accountAssignmentDisplay: I = "hover"
}) {
  return /* @__PURE__ */ y.jsx(y.Fragment, { children: L11(e).map(
    ({ accountId: h, accountName: m, chips: w }) => {
      if (h > 0 && m) {
        const S = w.every(
          (T) => T.canRemove !== !1
        );
        return /* @__PURE__ */ y.jsxs(
          F1,
          {
            component: "span",
            role: "group",
            "aria-label": `${m} recipients`,
            "data-testid": `recipient-account-group-${h}`,
            sx: {
              display: "inline-flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 0.5,
              maxWidth: "100%",
              p: 0.5,
              border: 1,
              borderColor: "primary.light",
              borderRadius: "21px",
              bgcolor: (T) => SP(T.palette.primary.main, 0.08)
            },
            children: [
              /* @__PURE__ */ y.jsx(
                fl,
                {
                  label: m,
                  size: "small",
                  "data-recipient-chip-variant": "account",
                  onDelete: n || !a || !S ? void 0 : (T) => {
                    T.stopPropagation(), a(h);
                  },
                  deleteIcon: /* @__PURE__ */ y.jsx(Me, { icon: "close", fontSize: "small" }),
                  sx: {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    height: 32,
                    borderRadius: "999px",
                    fontWeight: 700,
                    "& .MuiChip-deleteIcon": {
                      color: "primary.contrastText",
                      opacity: 0.8
                    }
                  }
                }
              ),
              w.map(
                (T) => sS(
                  T,
                  n,
                  i,
                  s,
                  g,
                  c,
                  I
                )
              )
            ]
          },
          h
        );
      }
      return w.map(
        (S) => sS(
          S,
          n,
          i,
          s,
          g,
          c,
          I
        )
      );
    }
  ) });
}
function L11(e) {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((i) => {
    const a = i.key.accountId, s = n.get(a) || {
      accountId: a,
      accountName: i.accountName,
      chips: []
    };
    s.chips.push(i), n.set(a, s);
  }), [...n.values()];
}
function sS(e, n, i, a, s, g, c) {
  var S;
  const I = e.canRemove !== !1 && !n, h = e.key.accountId <= 0, m = e.canAssignAccount === !0 || !!((S = e.accountOptions) != null && S.length) || e.canAssignAccount == null && !!s, w = /* @__PURE__ */ y.jsx(
    fl,
    {
      "data-recipient-chip-variant": h ? "accountless" : "contact",
      avatar: e.initials || e.avatar ? /* @__PURE__ */ y.jsx(
        dS,
        {
          src: e.avatar ?? void 0,
          sx: {
            width: 24,
            height: 24,
            bgcolor: "secondary.main",
            color: "common.white",
            fontSize: "0.65rem",
            fontWeight: 600
          },
          children: e.initials
        }
      ) : void 0,
      label: /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
        e.label,
        e.isFirmEmployee ? /* @__PURE__ */ y.jsx(
          F1,
          {
            component: "span",
            "data-testid": "firm-recipient-badge",
            sx: {
              ml: 0.75,
              px: 0.5,
              py: 0.125,
              borderRadius: "4px",
              bgcolor: "primary.main",
              color: "primary.contrastText",
              fontSize: "0.625rem",
              fontWeight: 700,
              lineHeight: 1.4
            },
            children: "FIRM"
          }
        ) : null
      ] }),
      size: "small",
      onDelete: I ? (T) => {
        T.stopPropagation(), i(e.key);
      } : void 0,
      deleteIcon: /* @__PURE__ */ y.jsx(Me, { icon: "close", fontSize: "small" }),
      onClick: (T) => T.stopPropagation(),
      sx: {
        bgcolor: h ? "action.hover" : "background.paper",
        border: 1,
        borderColor: h ? "secondary.light" : "primary.light",
        borderStyle: h ? "dashed" : "solid",
        borderRadius: "999px",
        height: 32,
        maxWidth: "100%",
        fontWeight: 600,
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        "& .MuiChip-avatar": {
          color: "common.white"
        }
      }
    },
    `${e.key.accountId}:${e.key.contactId}`
  );
  return !h || e.canRemove === !1 || !a || !m ? g ? g(e, w) : w : /* @__PURE__ */ y.jsx(
    R11,
    {
      chip: e,
      chipElement: g ? g(e, w) : w,
      disabled: n,
      onAssignAccount: a,
      onRefreshAccountOptions: s,
      accountAssignmentDisplay: c
    },
    `${e.key.accountId}:${e.key.contactId}`
  );
}
function R11({
  chip: e,
  chipElement: n,
  disabled: i,
  onAssignAccount: a,
  onRefreshAccountOptions: s,
  accountAssignmentDisplay: g
}) {
  const [c, I] = qt(!1), [h, m] = qt(!1), [w, S] = qt(!1), [T, D] = qt(!1), k = yn(null), z = g === "visible", N = z || c || h || w || T, W = z ? T : N;
  return vn(() => {
    if (!W) return;
    const K = (V) => {
      var H;
      const Y = V.target;
      !((H = k.current) != null && H.contains(Y)) && !Y.closest(
        ".MuiPopover-root, .MuiAutocomplete-popper, .contact-card-popper, .recipient-account-options"
      ) && (S(!1), I(!1), D(!1));
    };
    return document.addEventListener("pointerdown", K), () => document.removeEventListener("pointerdown", K);
  }, [W]), /* @__PURE__ */ y.jsxs(
    F1,
    {
      ref: k,
      component: "span",
      "data-testid": "accountless-recipient-container",
      "data-account-assignment-display": g,
      onPointerEnter: z ? void 0 : () => I(!0),
      onPointerLeave: z ? void 0 : () => I(!1),
      onFocusCapture: z ? void 0 : () => m(!0),
      onBlurCapture: z ? void 0 : (K) => {
        K.currentTarget.contains(K.relatedTarget) || m(!1);
      },
      onPointerDownCapture: z ? void 0 : (K) => {
        K.target.closest('button, [role="combobox"]') || K.pointerType === "touch" && S((Y) => !Y);
      },
      sx: {
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        p: 0.25,
        border: 1,
        borderColor: "secondary.light",
        borderStyle: "dashed",
        borderRadius: "18px",
        bgcolor: "action.hover",
        '& [data-recipient-chip-variant="accountless"]': {
          border: 0,
          bgcolor: "transparent"
        }
      },
      children: [
        n,
        N ? /* @__PURE__ */ y.jsx(
          O11,
          {
            chip: e,
            disabled: i,
            open: T,
            onAssignAccount: (K, V) => {
              a(K, V), D(!1), S(!1);
            },
            onRefreshAccountOptions: s,
            onOpenChange: D,
            accountAssignmentDisplay: g
          }
        ) : null
      ]
    }
  );
}
function O11({
  chip: e,
  disabled: n,
  onAssignAccount: i,
  onRefreshAccountOptions: a,
  open: s,
  onOpenChange: g,
  accountAssignmentDisplay: c
}) {
  var V, Y;
  const I = c === "visible", [h, m] = qt(!1), [w, S] = qt(""), T = yn(null), D = yn(e.key);
  D.current = e.key;
  const { accountId: k, contactId: z } = e.key, N = yn(0), W = yn(null), K = yn(null);
  return vn(() => {
    if (!s) {
      S(""), T.current = null;
      return;
    }
    if (!a) return;
    const H = setTimeout(
      async () => {
        const Z = w.trim();
        if (T.current === Z) return;
        T.current = Z;
        const Q = ++N.current;
        m(!0);
        try {
          await a(D.current, Z);
        } catch {
        } finally {
          N.current === Q && m(!1);
        }
      },
      w ? 250 : 0
    );
    return () => clearTimeout(H);
  }, [k, z, w, a, s]), /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      Ef,
      {
        inputRef: W,
        disabled: n,
        value: w,
        placeholder: s ? "Search accounts" : I ? "Which account?" : "+ Account",
        inputProps: {
          "aria-label": I ? `Which account for ${e.label}?` : `Add account for ${e.label}`,
          role: "combobox",
          "aria-expanded": s
        },
        InputProps: {
          endAdornment: h ? /* @__PURE__ */ y.jsx(ji, { size: 14 }) : I ? /* @__PURE__ */ y.jsx(
            Me,
            {
              icon: "chevronDown",
              fontSize: "small",
              sx: { pointerEvents: "none", color: "error.dark" }
            }
          ) : null
        },
        onFocus: () => {
          g(!0);
        },
        onChange: (H) => S(H.target.value),
        onClick: (H) => {
          H.stopPropagation(), I && !s && !n && g(!0);
        },
        onKeyDown: (H) => {
          var Z, Q;
          H.key === "Escape" ? (S(""), g(!1)) : H.key === "ArrowDown" && (H.preventDefault(), (Q = (Z = K.current) == null ? void 0 : Z.querySelector('[role="option"]')) == null || Q.focus());
        },
        sx: {
          // Leave slack for font metrics: Firefox clipped "Which account?" at 150.
          width: s ? 180 : I ? 168 : 104,
          maxWidth: I ? "100%" : void 0,
          "& .MuiInputBase-root": {
            height: 32,
            paddingRight: I ? 1 : void 0,
            borderRadius: "999px",
            bgcolor: "background.paper",
            color: I ? "error.dark" : "primary.main",
            fontSize: "0.875rem",
            fontWeight: 600,
            cursor: I ? "pointer" : void 0
          },
          "& .MuiInputBase-input::placeholder": I ? { color: "error.dark", opacity: 1 } : void 0,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: I ? "error.main" : "primary.main",
            borderStyle: I ? "solid" : "dashed"
          }
        }
      }
    ),
    /* @__PURE__ */ y.jsx(
      cS,
      {
        open: s,
        anchorEl: W.current,
        placement: "bottom-start",
        className: "recipient-account-options",
        sx: { zIndex: "modal" },
        children: /* @__PURE__ */ y.jsx(hS, { sx: { minWidth: 180, maxHeight: 240, overflowY: "auto" }, children: /* @__PURE__ */ y.jsxs(
          pS,
          {
            ref: K,
            role: "listbox",
            onKeyDown: (H) => {
              var Z;
              H.key === "Escape" && (H.preventDefault(), S(""), g(!1), (Z = W.current) == null || Z.focus());
            },
            children: [
              (V = e.accountOptions) == null ? void 0 : V.map((H) => /* @__PURE__ */ y.jsx(
                Ma,
                {
                  role: "option",
                  onClick: (Z) => {
                    Z.stopPropagation(), i(e.key, H), S(""), g(!1);
                  },
                  children: H.name
                },
                H.id
              )),
              h ? null : e.accountOptionsError ? /* @__PURE__ */ y.jsx(Ma, { disabled: !0, children: "Couldn't load accounts" }) : ((Y = e.accountOptions) == null ? void 0 : Y.length) === 0 ? /* @__PURE__ */ y.jsx(Ma, { disabled: !0, children: "No accounts found" }) : null
            ]
          }
        ) })
      }
    )
  ] });
}
const Lt1 = ({
  children: e,
  innerProps: n = {},
  ...i
}) => /* @__PURE__ */ y.jsx(iz, { ...i, style: { height: "100vh", overflow: "auto" }, children: /* @__PURE__ */ y.jsx(
  F1,
  {
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...n,
    children: e
  }
) }), D11 = H1(F1)({
  flex: 1,
  overflow: "auto",
  width: "100%",
  display: "flex",
  flexDirection: "column"
}), Rt1 = ({
  header: e = null,
  children: n,
  footer: i = null
}) => /* @__PURE__ */ y.jsxs(Ke, { direction: "column", flex: 1, height: "100%", width: "100%", children: [
  e,
  /* @__PURE__ */ y.jsx(D11, { children: n }),
  i
] }), k11 = {
  baseline: "baseline",
  center: "center",
  end: "flex-end",
  start: "flex-start"
}, j11 = {
  between: "space-between",
  center: "center",
  end: "flex-end",
  start: "flex-start"
}, z11 = H1("div", {
  shouldForwardProp: (e) => !["align", "justify", "spacing", "wrap"].includes(String(e))
})(
  ({ align: e = "center", justify: n = "start", spacing: i = 0, theme: a, wrap: s }) => ({
    alignItems: k11[e],
    display: "flex",
    flexWrap: s ? "wrap" : "nowrap",
    gap: a.spacing(i),
    justifyContent: j11[n]
  })
), Ot1 = (e) => /* @__PURE__ */ y.jsx(z11, { ...e });
export {
  Le1 as Accordion,
  ze1 as ActionsMenuButton,
  ne1 as AdapterDateFns,
  jt1 as Alert,
  gT as AlertHeading,
  zt1 as AlertTitle,
  Te1 as Attribute,
  Cq as AutocompleteField,
  u$ as Avatar,
  q11 as BackButton,
  Nt1 as BaseSelect,
  zX as BlueInfoCheckAnimation,
  Ct1 as BodyWrapper,
  Pt1 as Box,
  te1 as Breadcrumbs,
  k2 as Button,
  Ft1 as Card,
  Bt1 as CardActionArea,
  Ht1 as CardActions,
  Ut1 as CardContent,
  Wt1 as CardHeader,
  Vt1 as CardMedia,
  Lt1 as CenteredLayout,
  _t1 as Checkbox,
  Aq as CheckboxField,
  be1 as CheckboxGroup,
  ge1 as CheckmarkAnimation,
  bm as Chip,
  Jt1 as CircularProgress,
  se1 as CloudSaveIcon,
  H$ as ConfirmationDialog,
  Kt1 as Container,
  On1 as DataGrid,
  Pn1 as DatePicker,
  re1 as Dialog,
  Yt1 as Divider,
  Z11 as DotBadge,
  le1 as DragAndDrop,
  Mm as DragAndDropBox,
  Qt1 as Drawer,
  ke1 as EmptyListPlaceholder,
  mt1 as ErrorAlert,
  C11 as ErrorDialog,
  vt1 as ExperienceCard,
  yt1 as ExperienceCardSettingsTile,
  bt1 as ExperienceCardsSection,
  ie1 as FaceIDIcon,
  ut1 as FieldChip,
  zm as FieldWrapper,
  Lm as FileAttachmentItem,
  Ie1 as FileIcon,
  ot1 as FileIntelligenceDialog,
  at1 as FileIntelligenceUploadPicker,
  st1 as FileNamingPatternDialog,
  DM as FileTypeIcon,
  Ke1 as FilterChecklistPanel,
  Ye1 as FilterDateRangePanel,
  eS as FilterGroupLabel,
  k$ as FilterOptionRow,
  D$ as FilterPanelMessage,
  j$ as FilterSearchField,
  lt1 as FolderPickerDialog,
  At1 as FooterWrapper,
  ye1 as FormAutocompleteField,
  Iq as FormCheckboxField,
  xe1 as FormPasswordField,
  Se1 as FormRichTextEditor,
  Me1 as FormSubmitButton,
  we1 as FormTextField,
  Ee1 as FormTextareaField,
  kM as GlobalLoader,
  ae1 as GoogleGIcon,
  ce1 as GreenInfoCheckAnimation,
  Xt1 as Grid,
  Tt1 as GroupedRecipientChips,
  rt1 as GuidedFileRenameDialog,
  it1 as GuidedFileRenameGhost,
  B$ as GuidedFileRenameTarget,
  nt1 as GuidedFileRenameTextTarget,
  Me as Icon,
  ym as IconButton,
  lX as Indicator,
  Mt1 as Infinite,
  Ot1 as Inline,
  Gt1 as InputAdornment,
  qt1 as InputLabel,
  Ze1 as InteractiveTableRow,
  Je1 as KeyValuePillChip,
  It1 as LightFooterWrapper,
  Cx as Link,
  Zt1 as List,
  $t1 as ListItem,
  en1 as ListItemAvatar,
  o$ as ListItemButton,
  tn1 as ListItemIcon,
  nn1 as ListItemSecondaryAction,
  rn1 as ListItemText,
  Sh as Loading,
  Fn1 as LocalizationProvider,
  in1 as MUIStepper,
  an1 as Menu,
  je1 as MenuItem,
  on1 as MenuList,
  oe1 as MicrosoftIcon,
  RT as MobileBottomDrawer,
  LT as MobileBottomDrawerContentContainer,
  z$ as MobileBottomDrawerPuller,
  F$ as MobileConfirmationDrawer,
  a$ as NestedMenuItem,
  ht1 as NetworkErrorDialog,
  jM as OverflowTypography,
  k7 as PAGE_TAB_HEIGHT,
  We1 as PageTabs,
  Pe1 as PageTabsBar,
  Fe1 as PageToolbar,
  _X as Pagination,
  sn1 as Paper,
  pq as PasswordField,
  I$ as PillChip,
  YX as Popover,
  Re1 as PrintContainer,
  Tm as ProgressBar,
  YQ as ProgressBarWithLabel,
  wt1 as RHFSwitch,
  Ce1 as ResponsiveView,
  Bq as RichTextEditor,
  VQ as SHORT_DOCUMENT_PREVIEW_VIEWPORT,
  Nh as SLIDING_VIEWS_STATE_KEY,
  dt1 as ScreenContent,
  ft1 as ScreenWrapper,
  qe1 as ScrollableTableContainer,
  Ae1 as SearchInput,
  ct1 as SearchablePicker,
  ln1 as Skeleton,
  un1 as Slider,
  tt1 as SlidingView,
  et1 as SlidingViews,
  pe1 as SortableTableHeader,
  PX as SpinnerAnimation,
  cn1 as Stack,
  he1 as StaticTable,
  gn1 as Step,
  fn1 as StepConnector,
  dn1 as StepLabel,
  me1 as Stepper,
  N$ as StyledContentArea,
  De1 as StyledListItem,
  Uq as SubmitButton,
  ue1 as SuccessCheckAnimation,
  Cn1 as SwipeableDrawer,
  P$ as SwipeableMobileBottomDrawer,
  p11 as Switch,
  Wf as TOOLBAR_PILL_HEIGHT,
  ET as TOOLBAR_SEARCH_HEIGHT_PX,
  C$ as TOOLBAR_SEARCH_WIDTH_PX,
  An1 as Table,
  In1 as TableBody,
  Ge1 as TableCell,
  pn1 as TableContainer,
  hn1 as TableHead,
  mn1 as TableRow,
  Ne1 as Tabs,
  Et1 as Tag,
  pt1 as TagList,
  Uf as TextField,
  gt1 as TextWithLines,
  Hq as TextareaField,
  vn1 as ThemeProvider,
  Oe1 as ThemedLogo,
  Ue1 as ToolbarButton,
  _e1 as ToolbarChips,
  Qe1 as ToolbarFilterButton,
  A$ as ToolbarFilterPill,
  Be1 as ToolbarIconToggle,
  He1 as ToolbarLinkButton,
  MT as ToolbarPill,
  Ve1 as ToolbarSearchField,
  Xe1 as Tooltip,
  de1 as TopLoader,
  yn1 as Typography,
  ve1 as UnreadIndicator,
  St1 as UserChip,
  xt1 as UserInfo,
  fe1 as VerboseLoading,
  Rt1 as VerticalLayout,
  Pm as baseHoverBackground,
  ST as basePxToRem,
  Go as baseText,
  G11 as createTheme,
  Dn1 as gridClasses,
  kJ as iconAnimateClass,
  jJ as iconClasses,
  DJ as iconFlipClass,
  OJ as iconRotationClass,
  ee1 as icons,
  Hx as isCompoundExpandProp,
  zJ as isCustomSVGIcon,
  Q11 as liscioLogo,
  X11 as liscioLogoExpanded,
  pz as liscioLogoSplash,
  bb as liscioLogoVector,
  $e1 as slidingViewsState,
  bn1 as stepButtonClasses,
  wn1 as stepClasses,
  xn1 as stepConnectorClasses,
  Sn1 as stepIconClasses,
  En1 as stepLabelClasses,
  Mn1 as stepperClasses,
  Tn1 as styled,
  kn1 as useGridApiContext,
  jn1 as useGridApiEventHandler,
  zn1 as useGridApiRef,
  l$ as useMenuAnchor,
  r6 as useRouterLinkComponent,
  Ln1 as useTheme,
  PH as useTouchPickerViewport,
  $11 as useUrlState,
  zH as useViewportSize
};
